import styled, { keyframes as keyframes$1, css, createGlobalStyle, ThemeProvider as ThemeProvider$1 } from 'styled-components';
import React, { isValidElement, useMemo, useEffect, createContext, useState, useContext, useRef, useCallback, forwardRef, Fragment as Fragment$2, Children, cloneElement, createElement, createRef } from 'react';
import { jsxs, jsx, Fragment as Fragment$1 } from 'react/jsx-runtime';
import Sprite from './sprite.svg';
import MobileDetect from 'mobile-detect';
import ReactDOM from 'react-dom';

var Avatar = styled.img.withConfig({
  displayName: "Avatar",
  componentId: "b96c8a-0"
})(["border-radius:50%;object-fit:cover;max-width:100%;max-height:100%;"]);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var _extends_1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
    return _extends.apply(this, arguments);
  }

  module.exports = _extends;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _extends$2 = unwrapExports(_extends_1);

var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  module.exports = _objectWithoutPropertiesLoose;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
var _objectWithoutPropertiesLoose$2 = unwrapExports(objectWithoutPropertiesLoose);

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$1(subClass, superClass);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf$1(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf$1(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf$1(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */

var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found and no default was provided.\n\n",
  "75": "important requires a valid style object, got a %s instead.\n\n",
  "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
  "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
  "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};
/**
 * super basic version of sprintf
 * @private
 */

function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */


var PolishedError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(PolishedError, _Error);

  function PolishedError(code) {
    var _this;

    if (process.env.NODE_ENV === 'production') {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      _this = _Error.call(this, format.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }

    return _assertThisInitialized$1(_this);
  }

  return PolishedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Check if a string ends with something
 * @private
 */


function endsWith(string, suffix) {
  return string.substr(-suffix.length) === suffix;
}

var cssRegex$1 = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value minus its unit of measure.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */

function stripUnit(value) {
  if (typeof value !== 'string') return value;
  var matchedValue = value.match(cssRegex$1);
  return matchedValue ? parseFloat(value) : value;
}
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */


var pxtoFactory = function pxtoFactory(to) {
  return function (pxval, base) {
    if (base === void 0) {
      base = '16px';
    }

    var newPxval = pxval;
    var newBase = base;

    if (typeof pxval === 'string') {
      if (!endsWith(pxval, 'px')) {
        throw new PolishedError(69, to, pxval);
      }

      newPxval = stripUnit(pxval);
    }

    if (typeof base === 'string') {
      if (!endsWith(base, 'px')) {
        throw new PolishedError(70, to, base);
      }

      newBase = stripUnit(base);
    }

    if (typeof newPxval === 'string') {
      throw new PolishedError(71, pxval, to);
    }

    if (typeof newBase === 'string') {
      throw new PolishedError(72, base, to);
    }

    return "" + newPxval / newBase + to;
  };
};
var cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0],
 *   '--unit': getValueAndUnit('100px')[1],
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]};
 *   --unit: ${getValueAndUnit('100px')[1]};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100,
 *   '--unit': 'px',
 * }
 */

function getValueAndUnit(value) {
  if (typeof value !== 'string') return [value, ''];
  var matchedValue = value.match(cssRegex);
  if (matchedValue) return [parseFloat(value), matchedValue[2]];
  return [value, undefined];
}
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */


var rem = /*#__PURE__*/pxtoFactory('rem');

function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  } // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV


  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */

function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new PolishedError(3);
  }

  var normalizedColor = nameToHex(color);

  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }

  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }

  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }

  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));

    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }

  var rgbMatched = rgbRegex.exec(normalizedColor);

  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }

  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));

  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4])
    };
  }

  var hslMatched = hslRegex.exec(normalizedColor);

  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);

    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }

    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }

  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));

  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);

    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;

    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;

    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";

    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);

    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }

    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4])
    };
  }

  throw new PolishedError(5);
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */


var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }

  return value;
};

function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */


function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new PolishedError(6);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */


function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }

  throw new PolishedError(7);
}

var textCssFactory = function textCssFactory(variant) {
  return "\n  " + buildTextStyleWithMediaQuery('desktop', variant) + "\n  " + buildTextStyleWithMediaQuery('tablet', variant) + "\n  " + buildTextStyleWithMediaQuery('mobile', variant) + "\n  " + ('textTransform' in variant ? "text-transform: " + variant.textTransform + ";" : '') + "\n";
};

var buildTextStyleWithMediaQuery = function buildTextStyleWithMediaQuery(media, variant) {
  return "\n    @media (" + mediaQueries[media] + ") {\n      font-size: " + getPropertyValueByMedia(media, 'fontSize', variant) + ";\n      font-weight: " + getPropertyValueByMedia(media, 'fontWeight', variant) + ";\n      line-height: " + getPropertyValueByMedia(media, 'lineHeight', variant) + ";\n      letter-spacing: " + getPropertyValueByMedia(media, 'letterSpacing', variant) + ";\n      font-family: " + getPropertyValueByMedia(media, 'fontFamily', variant) + ";\n    }\n  ";
};

var mediaQueries = {
  desktop: 'min-width: 1025px',
  tablet: 'max-width: 1024px',
  mobile: 'max-width: 768px'
};

var getPropertyValueByMedia = function getPropertyValueByMedia(media, property, variant) {
  var propertyObject = variant[property];

  if (typeof propertyObject === 'string') {
    return propertyObject;
  }

  return propertyObject[media];
};

var textVariants = {
  title1: {
    tag: 'h1',
    fontFamily: 'Unbounded',
    cmsName: 'Big Title - H1',
    fontSize: {
      desktop: '56px',
      tablet: '48px',
      mobile: '36px'
    },
    fontWeight: '700',
    lineHeight: {
      desktop: '64px',
      tablet: '56px',
      mobile: '42px'
    },
    letterSpacing: {
      desktop: '-0.2px',
      tablet: '-0.1px',
      mobile: '0px'
    }
  },
  title1XXL: {
    tag: 'h1',
    fontFamily: 'Unbounded',
    cmsName: 'Basic Title - H1',
    fontSize: {
      desktop: '40px',
      tablet: '36px',
      mobile: '30px'
    },
    fontWeight: '700',
    lineHeight: {
      desktop: '48px',
      tablet: '44px',
      mobile: '40px'
    },
    letterSpacing: {
      desktop: '-0.1px',
      tablet: '0px',
      mobile: '0px'
    }
  },
  title1XL: {
    tag: 'h1',
    fontFamily: 'Unbounded',
    cmsName: 'Small Title - H1',
    fontSize: {
      desktop: '32px',
      tablet: '30px',
      mobile: '28px'
    },
    fontWeight: '700',
    lineHeight: {
      desktop: '40px',
      tablet: '40px',
      mobile: '32px'
    },
    letterSpacing: {
      desktop: '-0.1px',
      tablet: '0px',
      mobile: '0px'
    }
  },
  title2: {
    fontFamily: 'Unbounded',
    tag: 'h2',
    cmsName: 'Basic Title - H2',
    fontSize: {
      desktop: '40px',
      tablet: '36px',
      mobile: '30px'
    },
    fontWeight: '700',
    lineHeight: {
      desktop: '48px',
      tablet: '44px',
      mobile: '40px'
    },
    letterSpacing: {
      desktop: '-0.1px',
      tablet: '0px',
      mobile: '0px'
    }
  },
  title2XXL: {
    tag: 'h2',
    fontFamily: 'Unbounded',
    cmsName: 'Basic Title - H2',
    fontSize: {
      desktop: '40px',
      tablet: '36px',
      mobile: '30px'
    },
    fontWeight: '700',
    lineHeight: {
      desktop: '48px',
      tablet: '44px',
      mobile: '40px'
    },
    letterSpacing: {
      desktop: '-0.1px',
      tablet: '0px',
      mobile: '0px'
    }
  },
  title2XL: {
    tag: 'h2',
    fontFamily: 'Unbounded',
    cmsName: 'Small Title - H2',
    fontSize: {
      desktop: '32px',
      tablet: '30px',
      mobile: '28px'
    },
    lineHeight: {
      desktop: '40px',
      tablet: '40px',
      mobile: '32px'
    },
    fontWeight: '700',
    letterSpacing: {
      desktop: '-0.1px',
      tablet: '0px',
      mobile: '0px'
    }
  },
  title2L: {
    tag: 'h2',
    fontFamily: 'Unbounded',
    cmsName: '',
    fontSize: {
      desktop: '24px',
      tablet: '19px',
      mobile: '18px'
    },
    fontWeight: '700',
    lineHeight: {
      desktop: '32px',
      tablet: '32px',
      mobile: '24px'
    },
    letterSpacing: '0px'
  },
  title2ldm: {
    tag: 'h2',
    fontFamily: 'DM',
    cmsName: '',
    fontSize: {
      desktop: '24px',
      tablet: '19px',
      mobile: '18px'
    },
    fontWeight: '700',
    lineHeight: {
      desktop: '32px',
      tablet: '32px',
      mobile: '24px'
    },
    letterSpacing: '0px'
  },
  title3: {
    tag: 'h3',
    fontFamily: 'Unbounded',
    cmsName: '',
    fontSize: {
      desktop: '32px',
      tablet: '30px',
      mobile: '28px'
    },
    fontWeight: '700',
    lineHeight: {
      desktop: '40px',
      tablet: '40px',
      mobile: '32px'
    },
    letterSpacing: '0px'
  },
  title3M: {
    tag: 'h3',
    fontFamily: 'Unbounded',
    cmsName: '',
    fontSize: {
      desktop: '18px',
      tablet: '16px',
      mobile: '15px'
    },
    fontWeight: '700',
    lineHeight: {
      desktop: '18px',
      tablet: '15px',
      mobile: '13px'
    },
    letterSpacing: '0px'
  },
  title3L: {
    tag: 'h3',
    fontFamily: 'Unbounded',
    cmsName: '',
    fontSize: {
      desktop: '24px',
      tablet: '16px',
      mobile: '15px'
    },
    fontWeight: '700',
    lineHeight: {
      desktop: '24px',
      tablet: '18px',
      mobile: '16px'
    },
    letterSpacing: '0px'
  },
  title4: {
    tag: 'h4',
    fontFamily: 'Unbounded',
    cmsName: '',
    fontSize: '24px',
    fontWeight: '700',
    lineHeight: '32px',
    letterSpacing: '0.2px'
  },
  title5: {
    tag: 'h5',
    fontFamily: 'Unbounded',
    cmsName: '',
    fontSize: '18px',
    fontWeight: '700',
    lineHeight: '24px',
    letterSpacing: '0.1px'
  },
  title6: {
    tag: 'h6',
    fontFamily: 'Unbounded',
    cmsName: '',
    fontSize: '15px',
    fontWeight: '700',
    lineHeight: '20px',
    letterSpacing: '0.2px'
  },
  title6Small: {
    tag: 'h6',
    fontFamily: 'Unbounded',
    cmsName: '',
    fontSize: '12px',
    fontWeight: '700',
    lineHeight: '16px',
    letterSpacing: '0.2px'
  },
  paragraphXXL: {
    tag: 'p',
    fontFamily: 'DM',
    cmsName: '',
    fontSize: {
      desktop: '48px',
      tablet: '40px',
      mobile: '32px'
    },
    fontWeight: '400',
    lineHeight: {
      desktop: '56px',
      tablet: '48px',
      mobile: '40px'
    },
    letterSpacing: {
      desktop: '-0.1px',
      tablet: '0px',
      mobile: '0px'
    }
  },
  paragraphXXLBold: {
    tag: 'p',
    fontFamily: 'DM',
    cmsName: 'Basic Title - P',
    fontSize: {
      desktop: '40px',
      tablet: '36px',
      mobile: '30px'
    },
    fontWeight: '700',
    lineHeight: {
      desktop: '48px',
      tablet: '44px',
      mobile: '40px'
    },
    letterSpacing: {
      desktop: '-0.1px',
      tablet: '0px',
      mobile: '0px'
    }
  },
  paragraphXL: {
    tag: 'p',
    cmsName: 'Small Title - P',
    fontFamily: 'DM',
    fontSize: {
      desktop: '32px',
      tablet: '30px',
      mobile: '28px'
    },
    lineHeight: {
      desktop: '40px',
      tablet: '40px',
      mobile: '32px'
    },
    fontWeight: '400',
    letterSpacing: '0.2px'
  },
  paragraphXLBold: {
    tag: 'p',
    fontFamily: 'DM',
    cmsName: 'Small Title - P',
    fontSize: {
      desktop: '32px',
      tablet: '30px',
      mobile: '28px'
    },
    lineHeight: {
      desktop: '40px',
      tablet: '40px',
      mobile: '32px'
    },
    fontWeight: '700',
    letterSpacing: '0.2px'
  },
  paragraphL: {
    tag: 'p',
    cmsName: 'Bigger Paragraph - P',
    fontFamily: 'DM',
    fontSize: {
      desktop: '24px',
      tablet: '24px',
      mobile: '24px'
    },
    fontWeight: '400',
    lineHeight: {
      desktop: '32px',
      tablet: '32px',
      mobile: '32px'
    },
    letterSpacing: {
      desktop: '0.2px',
      tablet: '0.2px',
      mobile: '0.2px'
    }
  },
  paragraphLBold: {
    tag: 'p',
    cmsName: 'Bigger Subtitle - P',
    fontFamily: 'DM',
    fontSize: {
      desktop: '24px',
      tablet: '24px',
      mobile: '24px'
    },
    fontWeight: '700',
    lineHeight: {
      desktop: '32px',
      tablet: '32px',
      mobile: '32px'
    },
    letterSpacing: '0.2px'
  },
  paragraphM: {
    tag: 'p',
    cmsName: 'Big Paragraph - P',
    fontFamily: 'DM',
    fontSize: {
      desktop: '18px',
      tablet: '18px',
      mobile: '18px'
    },
    fontWeight: '400',
    lineHeight: {
      desktop: '24px',
      tablet: '24px',
      mobile: '24px'
    },
    letterSpacing: '0.2px'
  },
  paragraphMBold: {
    tag: 'p',
    fontFamily: 'DM',
    cmsName: 'Big Subtitle - P',
    fontSize: {
      desktop: '18px',
      tablet: '18px',
      mobile: '18px'
    },
    fontWeight: '700',
    lineHeight: {
      desktop: '24px',
      tablet: '24px',
      mobile: '24px'
    },
    letterSpacing: '0.2px'
  },
  paragraphS: {
    tag: 'p',
    fontFamily: 'DM',
    cmsName: 'Basic Paragraph - P',
    fontSize: {
      desktop: '15px',
      tablet: '15px',
      mobile: '15px'
    },
    fontWeight: '400',
    lineHeight: {
      desktop: '20px',
      tablet: '20px',
      mobile: '20px'
    },
    letterSpacing: '0.2px'
  },
  paragraphSBold: {
    tag: 'p',
    fontFamily: 'DM',
    cmsName: 'Basic Subtitle - P',
    fontSize: {
      desktop: '15px',
      tablet: '15px',
      mobile: '15px'
    },
    fontWeight: '700',
    lineHeight: {
      desktop: '20px',
      tablet: '20px',
      mobile: '20px'
    },
    letterSpacing: '0.2px'
  },
  paragraphXS: {
    tag: 'p',
    fontFamily: 'DM',
    cmsName: 'Small Paragraph - P',
    fontSize: {
      desktop: '12px',
      tablet: '12px',
      mobile: '12px'
    },
    fontWeight: '400',
    lineHeight: {
      desktop: '16px',
      tablet: '16px',
      mobile: '16px'
    },
    letterSpacing: '0.2px'
  },
  paragraphXSBold: {
    tag: 'p',
    fontFamily: 'DM',
    cmsName: 'Small Subtitle - P',
    fontSize: {
      desktop: '12px',
      tablet: '12px',
      mobile: '12px'
    },
    fontWeight: '700',
    lineHeight: {
      desktop: '16px',
      tablet: '16px',
      mobile: '16px'
    },
    letterSpacing: '0.2px'
  },
  bigButton: {
    tag: 'p',
    fontFamily: 'DM',
    cmsName: 'Big Button P',
    fontSize: {
      desktop: '18px',
      tablet: '18px',
      mobile: '18px'
    },
    fontWeight: '500',
    lineHeight: {
      desktop: '24px',
      tablet: '24px',
      mobile: '24px'
    },
    letterSpacing: '0.2px'
  },
  mediumButton: {
    tag: 'p',
    fontFamily: 'DM',
    cmsName: 'Medium Button - P',
    fontSize: {
      desktop: '15px',
      tablet: '15px',
      mobile: '15px'
    },
    fontWeight: '500',
    lineHeight: {
      desktop: '20px',
      tablet: '20px',
      mobile: '20px'
    },
    letterSpacing: '0.5px'
  },
  smallButton: {
    tag: 'p',
    fontFamily: 'DM',
    cmsName: 'Small Button - P',
    fontSize: {
      desktop: '12px',
      tablet: '12px',
      mobile: '12px'
    },
    fontWeight: '500',
    lineHeight: {
      desktop: '16px',
      tablet: '16px',
      mobile: '16px'
    },
    letterSpacing: '0.25px'
  },
  div: {
    tag: 'div',
    cmsName: 'Basic Paragraph - Div',
    fontFamily: 'DM',
    fontSize: {
      desktop: '15px',
      tablet: '15px',
      mobile: '15px'
    },
    fontWeight: '400',
    lineHeight: {
      desktop: '20px',
      tablet: '20px',
      mobile: '20px'
    },
    letterSpacing: '0.2px'
  },
  divM: {
    tag: 'div',
    cmsName: 'Big Paragraph - Div',
    fontFamily: 'DM',
    fontSize: {
      desktop: '18px',
      tablet: '18px',
      mobile: '18px'
    },
    fontWeight: '400',
    lineHeight: {
      desktop: '24px',
      tablet: '24px',
      mobile: '24px'
    },
    letterSpacing: '0.1px'
  },
  divMBold: {
    tag: 'div',
    cmsName: 'Big Subtitle - Div',
    fontFamily: 'DM',
    fontSize: {
      desktop: '18px',
      tablet: '18px',
      mobile: '18px'
    },
    fontWeight: '700',
    lineHeight: {
      desktop: '24px',
      tablet: '24px',
      mobile: '24px'
    },
    letterSpacing: '0.1px'
  },
  span: {
    tag: 'span',
    cmsName: 'Basic Paragraph - Span',
    fontFamily: 'DM',
    fontSize: {
      desktop: '15px',
      tablet: '15px',
      mobile: '15px'
    },
    fontWeight: '400',
    lineHeight: {
      desktop: '20px',
      tablet: '20px',
      mobile: '20px'
    },
    letterSpacing: '0.2px'
  },
  spanM: {
    tag: 'span',
    cmsName: 'Big Paragraph - Span',
    fontFamily: 'DM',
    fontSize: {
      desktop: '18px',
      tablet: '18px',
      mobile: '18px'
    },
    fontWeight: '400',
    lineHeight: {
      desktop: '24px',
      tablet: '20px',
      mobile: '20px'
    },
    letterSpacing: '0.1px'
  },
  spanMBold: {
    tag: 'span',
    cmsName: 'Big Subtitle - Span',
    fontFamily: 'DM',
    fontSize: {
      desktop: '18px',
      tablet: '18px',
      mobile: '18px'
    },
    fontWeight: '700',
    lineHeight: {
      desktop: '24px',
      tablet: '20px',
      mobile: '20px'
    },
    letterSpacing: '0.1px'
  }
};

var NONE = {};
var FADE_IN = keyframes$1(["from{opacity:0;}to{opacity:1;}"]);
var FADE_IN_DOWN = keyframes$1(["from{opacity:0;transform:translateY(", ");}to{opacity:1;transform:translateY(", ");}"], rem(-20), rem(0));
var FADE_IN_UP = keyframes$1(["from{opacity:0;transform:translateY(", ");}to{opacity:1;transform:translateY(", ");}"], rem(40), rem(0));
var FADE_IN_LEFT = keyframes$1(["from{opacity:0;transform:translateX(", ");}to{opacity:1;transform:translateX(", ");}"], rem(50), rem(0));
var FADE_IN_RIGHT = keyframes$1(["from{opacity:0;transform:translateX(", ");}to{opacity:1;transform:translateX(", ");}"], rem(-50), rem(0));
var FADE_IN_TOP_LEFT = keyframes$1(["from{opacity:0;transform:translateX(", ") translateY(", ");}to{opacity:1;transform:translateX(", ") translateY(", ");}"], rem(50), rem(50), rem(0), rem(0));
var FADE_IN_TOP_RIGHT = keyframes$1(["from{opacity:0;transform:translateX(", ") translateY(", ");}to{opacity:1;transform:translateX(", ") translateY(", ");}"], rem(-50), rem(50), rem(0), rem(0));
var FADE_IN_BOTTOM_LEFT = keyframes$1(["from{opacity:0;transform:translateX(", ") translateY(", ");}to{opacity:1;transform:translateX(", ") translateY(", ");}"], rem(50), rem(-50), rem(0), rem(0));
var FADE_IN_BOTTOM_RIGHT = keyframes$1(["from{opacity:0;transform:translateX(", ") translateY(", ");}to{opacity:1;transform:translateX(", ") translateY(", ");}"], rem(-50), rem(-50), rem(0), rem(0));
var FADE_OUT = keyframes$1(["from{opacity:0;}to{opacity:1;}"]);
var FADE_OUT_DOWN = keyframes$1(["from{opacity:0;transform:translateY(", ");}to{opacity:1;transform:translateY(", ");}"], rem(-50), rem(0));
var FADE_OUT_UP = keyframes$1(["from{opacity:0;transform:translateY(", ");}to{opacity:1;transform:translateY(", ");}"], rem(50), rem(0));
var FADE_OUT_LEFT = keyframes$1(["from{opacity:0;transform:translateX(", ");}to{opacity:1;transform:translateX(", ");}"], rem(50), rem(0));
var FADE_OUT_RIGHT = keyframes$1(["from{opacity:0;transform:translateX(", ");}to{opacity:1;transform:translateX(", ");}"], rem(-50), rem(0));
var FADE_OUT_TOP_LEFT = keyframes$1(["from{opacity:0;transform:translateX(", ") translateY(", ");}to{opacity:1;transform:translateX(", ") translateY(", ");}"], rem(50), rem(50), rem(0), rem(0));
var FADE_OUT_TOP_RIGHT = keyframes$1(["from{opacity:0;transform:translateX(", ") translateY(", ");}to{opacity:1;transform:translateX(", ") translateY(", ");}"], rem(-50), rem(50), rem(0), rem(0));
var FADE_OUT_BOTTOM_LEFT = keyframes$1(["from{opacity:0;transform:translateX(", ") translateY(", ");}to{opacity:1;transform:translateX(", ") translateY(", ");}"], rem(50), rem(-50), rem(0), rem(0));
var FADE_OUT_BOTTOM_RIGHT = keyframes$1(["from{opacity:0;transform:translateX(", ") translateY(", ");}to{opacity:1;transform:translateX(", ") translateY(", ");}"], rem(-50), rem(-50), rem(0), rem(0));
var ZOOM_IN = keyframes$1(["from{opacity:0;transform:scale(.7);}to{opacity:1;transform:scale(1);}"]);
var ZOOM_IN_DOWN = keyframes$1(["from{opacity:0;transform:translateY(", ") scale(.7);}to{opacity:1;transform:translateY(", ") scale(1);}"], rem(-100), rem(0));
var ZOOM_IN_UP = keyframes$1(["from{opacity:0;transform:translateY(", ") scale(.7);}to{opacity:1;transform:translateY(", ") scale(1);}"], rem(100), rem(0));
var ZOOM_IN_LEFT = keyframes$1(["from{opacity:0;transform:translateX(", ") scale(.7);}to{opacity:1;transform:translateX(", ") scale(1);}"], rem(100), rem(0));
var ZOOM_IN_RIGHT = keyframes$1(["from{opacity:0;transform:translateX(", ") scale(.7);}to{opacity:1;transform:translateX(", ") scale(1);}"], rem(-100), rem(0));
var ZOOM_OUT = keyframes$1(["from{opacity:0;transform:scale(.7);}to{opacity:1;transform:scale(1);}"]);
var ZOOM_OUT_DOWN = keyframes$1(["from{opacity:0;transform:translateY(", ") scale(.7);}to{opacity:1;transform:translateY(", ") scale(1);}"], rem(-100), rem(0));
var ZOOM_OUT_UP = keyframes$1(["from{opacity:0;transform:translateY(", ") scale(.7);}to{opacity:1;transform:translateY(", ") scale(1);}"], rem(100), rem(0));
var ZOOM_OUT_LEFT = keyframes$1(["from{opacity:0;transform:translateX(", ") scale(.7);}to{opacity:1;transform:translateX(", ") scale(1);}"], rem(100), rem(0));
var ZOOM_OUT_RIGHT = keyframes$1(["from{opacity:0;transform:translateX(", ") scale(.7);}to{opacity:1;transform:translateX(", ") scale(1);}"], rem(-100), rem(0));
var SLIDE_IN_DOWN = keyframes$1(["from{transform:translateY(", ");}to{transform:translateY(", ");}"], rem(-50), rem(0));
var SLIDE_IN_UP = keyframes$1(["from{transform:translateY(", ");}to{transform:translateY(", ");}"], rem(50), rem(0));
var SLIDE_IN_LEFT = keyframes$1(["from{transform:translateX(", ");}to{transform:translateX(", ");}"], rem(50), rem(0));
var SLIDE_IN_RIGHT = keyframes$1(["from{transform:translateX(", ");}to{transform:translateX(", ");}"], rem(-50), rem(0));
var SLIDE_OUT_DOWN = keyframes$1(["from{transform:translateY(", ");}to{transform:translateY(", ");}"], rem(-50), rem(0));
var SLIDE_OUT_UP = keyframes$1(["from{transform:translateY(", ");}to{transform:translateY(", ");}"], rem(50), rem(0));
var SLIDE_OUT_LEFT = keyframes$1(["from{transform:translateX(", ");}to{transform:translateX(", ");}"], rem(50), rem(0));
var SLIDE_OUT_RIGHT = keyframes$1(["from{transform:translateX(", ");}to{transform:translateX(", ");}"], rem(-50), rem(0));

var animations$4 = {
  none: NONE,
  fadeIn: FADE_IN,
  fadeInDown: FADE_IN_DOWN,
  fadeInUp: FADE_IN_UP,
  fadeInLeft: FADE_IN_LEFT,
  fadeInRight: FADE_IN_RIGHT,
  fadeInTopLeft: FADE_IN_TOP_LEFT,
  fadeInTopRight: FADE_IN_TOP_RIGHT,
  fadeInBottomLeft: FADE_IN_BOTTOM_LEFT,
  fadeInBottomRight: FADE_IN_BOTTOM_RIGHT,
  fadeOut: FADE_OUT,
  fadeOutDown: FADE_OUT_DOWN,
  fadeOutUp: FADE_OUT_UP,
  fadeOutLeft: FADE_OUT_LEFT,
  fadeOutRight: FADE_OUT_RIGHT,
  fadeOutTopLeft: FADE_OUT_TOP_LEFT,
  fadeOutTopRight: FADE_OUT_TOP_RIGHT,
  fadeOutBottomLeft: FADE_OUT_BOTTOM_LEFT,
  fadeOutBottomRight: FADE_OUT_BOTTOM_RIGHT,
  zoomIn: ZOOM_IN,
  zoomInDown: ZOOM_IN_DOWN,
  zoomInUp: ZOOM_IN_UP,
  zoomInLeft: ZOOM_IN_LEFT,
  zoomInRight: ZOOM_IN_RIGHT,
  zoomOut: ZOOM_OUT,
  zoomOutDown: ZOOM_OUT_DOWN,
  zoomOutUp: ZOOM_OUT_UP,
  zoomOutLeft: ZOOM_OUT_LEFT,
  zoomOutRight: ZOOM_OUT_RIGHT,
  slideInDown: SLIDE_IN_DOWN,
  slideInUp: SLIDE_IN_UP,
  slideInLeft: SLIDE_IN_LEFT,
  slideInRight: SLIDE_IN_RIGHT,
  slideOutDown: SLIDE_OUT_DOWN,
  slideOutUp: SLIDE_OUT_UP,
  slideOutLeft: SLIDE_OUT_LEFT,
  slideOutRight: SLIDE_OUT_RIGHT
};

// Base
var WHITE = '#FFFFFF';
var SNOW = '#F2F4FC';
var CLOUD = '#E0E2EB';
var SMOKE = '#C0C2CC';
var CEMENT = '#A3A5AE';
var COAL = '#696B74';
var BLACK = '#121212';
var BLACK_15 = 'rgba(0,15,51,0.15)';
var BLACK_20 = 'rgba(0,15,51,0.2)';
var BLACK_30 = 'rgba(0,15,51,0.3)';
var BLACK_50 = 'rgba(0,15,51,0.5)';
var BLACK_80 = 'rgba(0,15,51,0.8)';
var BLACK_90 = 'rgba(0,15,51,0.9)';
var WHITE_15 = 'rgba(255,255,255,0.15)'; // Brand

var PRIMARY = '#525FFF';
var PRIMARY_10 = 'rgba(82, 95, 255, 0.1)';
var PRIMARY_HOVER = '#221AB2';
var PRIMARY_DISABLED = '#A6ACFC';
var SECONDARY = '#F4D34A';
var SECONDARY_HOVER = '#F9B224';
var ACADEMY = '#F969D7';
var ACADEMY_HOVER = '#FF9EE8';
var CALM_MILKSHAKE = '#EFD8EF';
var PRIMARY_SOFT_HELP_CENTER = '#6B67F3'; // Complementary

var DANGER = '#D83F55';
var DANGER_HOVER = '#A52235';
var DANGER_DISABLED = '#EDB8B8';
var WARNING = '#F9B224'; // Plans

var STUDENT_GRAD = 'linear-gradient(180deg, #F9B224 0%, #F2C038 100%)';
var EDU_GRAD = 'linear-gradient(180deg, #72D081 0%, #DAD130 100%)';
var PRO_GRAD = 'linear-gradient(180deg, #8140F0 0%, #BE56E8 100%);';
var MASTER_GRAD = 'linear-gradient(180deg, #6C87E8 0%, #27DBF0 100%)';
var TEAM_GRAD = 'linear-gradient(180deg, #221AB2 0%, #3E5EE5 100%)';
var STUDENT = '#F9B224';
var EDU = '#25A782';
var PRO = '#8441EF';
var MASTER = '#3FBCED';
var TEAM = '#352DCA';
var PRIMARY_SOFT = '#677CF9';
var SECONDARY_SOFT = '#F4C84D';
var TERTIARY_SOFT = '#F788E4'; // Rebranding

var RBLACK = '#121212';
var RBLACK_15 = 'rgba(18,18,18,0.15)';
var RBLACK_20 = 'rgba(18,18,18,0.2)';
var RBLACK_30 = 'rgba(18,18,18,0.3)';
var RBLACK_50 = 'rgba(18,18,18,0.5)';
var RBLACK_80 = 'rgba(18,18,18,0.8)';
var RBLACK_90 = 'rgba(18,18,18,0.9)';
var RWHITE = '#FFFFFF';
var RWHITE_15 = 'rgba(255,255,255,0.15)';
var RGHOST = '#F9F8FC';
var RSILVER = '#E8E6F0';
var RLAVENDER = '#C7C3D3';
var RONYX = '#393645';
var RGRANITE = '#625E6E';
var RICY_LIFE = '#5FFFE4';
var RGRADIENT_BLACK_FRIDAY = 'linear-gradient(91deg, #30DFE6 1.72%, #5FFFE4 98.02%)';
var RMUNCH_ON_MELON = '#F73C69';
var RBLUE_MARENGO = '#C8DBEF';
var RFLAT_YELLOW = '#FEF007';
var RPREMIUM = '#EFC44B';
var RPREMIUM_HOVER = '#EBA313';
var RAKIHABARA = '#6C29FF';
var RAKIHABARA15 = 'rgba(108,41,255,0.15)';
var RAKIHABARA_DARK = '#3C17C1';
var RAKIHABARA_LIGHT = '#C7B6ED';
var RAKIHABARA10 = 'rgba(108, 41, 255, 0.1)';
var RCORNFLOW_BLUE = '#6084EE';
var RPEARL = '#DEF041';
var RAVOCADO = '#BECD39';
var RDARKTURQUOISE = '#30DFE6';
var TRANSPARENT = '';

var colors = {
  transparent: TRANSPARENT,
  academy: ACADEMY,
  academyHover: ACADEMY_HOVER,
  black15: BLACK_15,
  black20: BLACK_20,
  black30: BLACK_30,
  black50: BLACK_50,
  black80: BLACK_80,
  black90: BLACK_90,
  black: BLACK,
  rBlack: RBLACK,
  rBlack15: RBLACK_15,
  rBlack20: RBLACK_20,
  rBlack30: RBLACK_30,
  rBlack50: RBLACK_50,
  rBlack80: RBLACK_80,
  rBlack90: RBLACK_90,
  rCornflowBlue: RCORNFLOW_BLUE,
  rWhite: RWHITE,
  rWhite15: RWHITE_15,
  rGhost: RGHOST,
  rSilver: RSILVER,
  rLavender: RLAVENDER,
  rOnyx: RONYX,
  rGranite: RGRANITE,
  rIcyLife: RICY_LIFE,
  rGradientBlackFriday: RGRADIENT_BLACK_FRIDAY,
  rMunchOnMelon: RMUNCH_ON_MELON,
  rBlueMarengo: RBLUE_MARENGO,
  rFlatYellow: RFLAT_YELLOW,
  rPremium: RPREMIUM,
  rPremiumHover: RPREMIUM_HOVER,
  rAkihabara: RAKIHABARA,
  rAkihabara10: RAKIHABARA10,
  rAkihabaraDark: RAKIHABARA_DARK,
  rAkihabaraLight: RAKIHABARA_LIGHT,
  rPearl: RPEARL,
  rAvocado: RAVOCADO,
  rDarkTurquoise: RDARKTURQUOISE,
  calmMilkshake: CALM_MILKSHAKE,
  cement: CEMENT,
  cloud: CLOUD,
  coal: COAL,
  danger: DANGER,
  dangerDisabled: DANGER_DISABLED,
  dangerHover: DANGER_HOVER,
  edu: EDU,
  eduGrad: EDU_GRAD,
  master: MASTER,
  masterGrad: MASTER_GRAD,
  primary: PRIMARY,
  primary10: PRIMARY_10,
  primaryDisabled: PRIMARY_DISABLED,
  primaryHover: PRIMARY_HOVER,
  primarySoft: PRIMARY_SOFT,
  primarySoftHelpCenter: PRIMARY_SOFT_HELP_CENTER,
  pro: PRO,
  proGrad: PRO_GRAD,
  secondary: SECONDARY,
  secondaryHover: SECONDARY_HOVER,
  smoke: SMOKE,
  snow: SNOW,
  secondarySoft: SECONDARY_SOFT,
  student: STUDENT,
  studentGrad: STUDENT_GRAD,
  team: TEAM,
  teamGrad: TEAM_GRAD,
  tertiarySoft: TERTIARY_SOFT,
  warning: WARNING,
  white15: WHITE_15,
  white: WHITE
};

var size = {
  mobile: '0',
  tablet: '768px',
  laptop: '1024px',
  desktop: '1440px'
};
var device = {
  mobile: "(min-width: " + size.mobile + ")",
  tablet: "(min-width: " + size.tablet + ")",
  laptop: "(min-width: " + size.laptop + ")",
  desktop: "(min-width: " + size.desktop + ")"
};

var gridBaseSize = 8; // px

var Sizes$1;

(function (Sizes) {
  Sizes[Sizes["xtiny"] = gridBaseSize / 4] = "xtiny";
  Sizes[Sizes["tiny"] = gridBaseSize / 2] = "tiny";
  Sizes[Sizes["xmini"] = gridBaseSize] = "xmini";
  Sizes[Sizes["mini"] = gridBaseSize * 1.5] = "mini";
  Sizes[Sizes["small"] = gridBaseSize * 2] = "small";
  Sizes[Sizes["base"] = gridBaseSize * 2.5] = "base";
  Sizes[Sizes["medium"] = gridBaseSize * 3] = "medium";
  Sizes[Sizes["large"] = gridBaseSize * 4] = "large";
  Sizes[Sizes["xlarge"] = gridBaseSize * 5] = "xlarge";
  Sizes[Sizes["huge"] = gridBaseSize * 6] = "huge";
  Sizes[Sizes["xhuge"] = gridBaseSize * 7] = "xhuge";
  Sizes[Sizes["xxhuge"] = gridBaseSize * 8] = "xxhuge";
})(Sizes$1 || (Sizes$1 = {}));

var sizes$1 = {
  xtiny: Sizes$1.xtiny,
  tiny: Sizes$1.tiny,
  xmini: Sizes$1.xmini,
  mini: Sizes$1.mini,
  small: Sizes$1.small,
  base: Sizes$1.base,
  medium: Sizes$1.medium,
  large: Sizes$1.large,
  xlarge: Sizes$1.xlarge,
  huge: Sizes$1.huge,
  xhuge: Sizes$1.xhuge,
  xxhuge: Sizes$1.xxhuge,
  scale: function scale(factor) {
    return factor * gridBaseSize;
  }
};
var topbarSize = '64px';

var marginsCss = css(["", ";", ";", ";", ";", ";"], function (p) {
  return p.margin && applyMarginSize('margin', p.margin);
}, function (p) {
  return p.marginTop && applyMarginSize('margin-top', p.marginTop);
}, function (p) {
  return p.marginRight && applyMarginSize('margin-right', p.marginRight);
}, function (p) {
  return p.marginBottom && applyMarginSize('margin-bottom', p.marginBottom);
}, function (p) {
  return p.marginLeft && applyMarginSize('margin-left', p.marginLeft);
});

var applyMarginSize = function applyMarginSize(style, size) {
  if (typeof size === 'object') {
    return "\n    " + (size.mobile !== undefined ? "\n      " + style + ": " + getRemSize(size.mobile) + ";\n      " : '') + "\n\n      " + (size.tablet !== undefined ? "\n        @media " + theme.device.tablet + " {\n          " + style + ": " + getRemSize(size.tablet) + ";\n        }\n      " : '') + "\n      " + (size.laptop !== undefined ? "\n        @media " + theme.device.laptop + " {\n          " + style + ": " + getRemSize(size.laptop) + ";\n        }\n      " : '') + "\n      " + (size.desktop !== undefined ? "\n        @media " + theme.device.desktop + " {\n          " + style + ": " + getRemSize(size.desktop) + ";\n        }\n      " : '') + "\n    ";
  } else {
    return "\n      " + style + ": " + getRemSize(size) + ";\n    ";
  }
};

var getRemSize = function getRemSize(size) {
  if (typeof size === 'number') {
    return rem(size);
  } else if (size in sizes$1) {
    return rem(sizes$1[size]);
  } else {
    return size;
  }
};

var maxWidth = {
  laptop: '1224px',
  desktop: '1416px'
};

var PLANS_SHADOW_VALUES = "0 " + rem(12) + " " + rem(32);
var MODAL = "0 " + rem(12) + " " + rem(32) + " " + RAKIHABARA15;
var PLANS_EDUPRO = PLANS_SHADOW_VALUES + " " + rgba(EDU, 0.6);
var PLANS_MASTER = PLANS_SHADOW_VALUES + " " + rgba(MASTER, 0.4);
var PLANS_PRO = PLANS_SHADOW_VALUES + " " + rgba(PRO, 0.6);
var PLANS_STUDENT = PLANS_SHADOW_VALUES + " " + rgba(STUDENT, 0.5);
var PLANS_TEAM = PLANS_SHADOW_VALUES + " " + rgba(TEAM, 0.4);
var SHORT = "0 " + rem(1) + " " + rem(4) + " " + BLACK_20;
var SHORT_DARKER = "0 " + rem(1) + " " + rem(4) + " " + BLACK_50;
var SHORT_HOVER = "0 " + rem(1) + " " + rem(8) + " " + BLACK_30;
var TEMPLATE = "0 " + rem(-1) + " " + rem(1) + " " + BLACK_15;

var shadows = {
  modal: MODAL,
  plansEdupro: PLANS_EDUPRO,
  plansMaster: PLANS_MASTER,
  plansPro: PLANS_PRO,
  plansStudent: PLANS_STUDENT,
  plansTeam: PLANS_TEAM,
  "short": SHORT,
  shortDarker: SHORT_DARKER,
  shortHover: SHORT_HOVER,
  template: TEMPLATE
};

var unit = 8;
var spaces = {
  none: '0px',
  xxxxs: unit / 4 + "px",
  xxxs: unit / 2 + "px",
  xxs: unit + "px",
  xs: unit * 1.5 + "px",
  s: unit * 2 + "px",
  m: unit * 2.5 + "px",
  l: unit * 3 + "px",
  xl: unit * 4 + "px",
  xxl: unit * 5 + "px",
  xxxl: unit * 6 + "px",
  xxxxl: unit * 7 + "px" // 56px

};

var transitions = {
  easeInOut: 'cubic-bezier(0.4, 0, 0.4, 1)',
  easeOut: 'cubic-bezier(0, 0.4, 0.4, 1)'
};

var grid = {
  contentMaxWidth: 1416 + 72 * 2,
  horizontalMargin: {
    "default": 24,
    tablet: 64,
    laptop: 72,
    desktop: 72
  },
  verticalMargin: {
    "default": 40,
    tablet: 56,
    laptop: 80,
    desktop: 112
  }
};

var visuallyHidden = css(["position:absolute;width:1px;height:1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;clip-path:inset(50%);border:0;"]);

var theme = {
  animations: animations$4,
  colors: colors,
  device: device,
  deviceSize: size,
  maxWidth: maxWidth,
  marginsCss: marginsCss,
  shadows: shadows,
  sizes: sizes$1,
  spaces: spaces,
  transitions: transitions,
  topbarSize: topbarSize,
  grid: grid,
  visuallyHidden: visuallyHidden
};

var taggedTemplateLiteralLoose = createCommonjsModule(function (module) {
  function _taggedTemplateLiteralLoose(strings, raw) {
    if (!raw) {
      raw = strings.slice(0);
    }

    strings.raw = raw;
    return strings;
  }

  module.exports = _taggedTemplateLiteralLoose;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
var _taggedTemplateLiteralLoose = unwrapExports(taggedTemplateLiteralLoose);

var _templateObject;
var normalize = css(["*,*::before,*::after{box-sizing:border-box;}html{box-sizing:border-box;overflow-x:clip;}*,*:before,*:after{box-sizing:inherit;}*{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}body,h1,h2,h3,h4,p,figure,blockquote,dl,dd{margin:0;}ul[role='list'],ol[role='list']{list-style:none;}html:focus-within{scroll-behavior:smooth;}body{min-height:100vh;text-rendering:optimizeSpeed;line-height:1.5;overflow-x:clip;}a:not([class]){text-decoration-skip-ink:auto;text-decoration:none;}img,picture{max-width:100%;display:block;}input,button,textarea,select{font:inherit;}@media (prefers-reduced-motion:reduce){html:focus-within{scroll-behavior:auto;}*,*::before,*::after{animation-duration:0.01ms !important;animation-iteration-count:1 !important;transition-duration:0.01ms !important;scroll-behavior:auto !important;}}"]);
var scrollbar = css(["::-webkit-scrollbar{width:", ";}::-webkit-scrollbar-track{margin:", " 0;box-shadow:none;}::-webkit-scrollbar-thumb{background:", ";border-radius:", ";}::-webkit-scrollbar-thumb:hover{background:", ";}"], rem(6), rem(theme.sizes.xmini), theme.colors.smoke, rem(10), theme.colors.coal);
var GlobalStyle = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", ";\n  \n  * {\n    ", ";\n  }\n\n  html, body {\n    margin: 0;\n    padding: 0;\n\n    font-family: 'DM', sans-serif;\n    color: ", ";\n  }\n\n  h1 {\n    font-family: 'Unbounded';\n  }\n\n  p, h1, h2, h3, h4, h5, h6 {\n    margin: 0;\n  }\n\n  p, h1, h2, h3, h4, h5, h6, div, span {\n    font-weight: normal;\n  }\n\n  ul, li {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  img {\n    max-width: 100%; \n    height: auto;\n  }\n\n  main {\n    padding-top: ", ";\n  }\n"])), normalize, scrollbar, theme.colors.rBlack, rem(63));

var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/jsxs(ThemeProvider$1, {
    theme: theme,
    children: [/*#__PURE__*/jsx(GlobalStyle, {}), children]
  });
};

var sizes = {
  big: "\n    " + textCssFactory(textVariants.bigButton) + ";\n    padding: " + rem(theme.sizes.mini) + " " + rem(theme.sizes.medium) + ";\n    border-radius: " + rem(8) + ";\n  ",
  "default": "\n    " + textCssFactory(textVariants.mediumButton) + ";\n    padding: " + rem(theme.sizes.xmini) + " " + rem(theme.sizes.small) + ";\n  ",
  small: "\n    " + textCssFactory(textVariants.smallButton) + ";\n    padding: " + rem(theme.sizes.tiny) + " " + rem(theme.sizes.small) + ";\n  "
};
var allowedSizesPerVariant = {
  primary: ['small', 'default', 'big'],
  secondary: ['small', 'default', 'big'],
  tertiary: ['small', 'default', 'big'],
  stroke: ['default', 'big'],
  strokeWhite: ['default', 'big'],
  danger: ['default'],
  academy: ['default', 'big']
};
function getSizeStyles(variant, size) {
  if (!size || !allowedSizesPerVariant[variant].includes(size)) {
    return sizes["default"];
  }

  return sizes[size];
}

var _excluded$w = ["name"];
var Icon = function Icon(_ref) {
  var name = _ref.name,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$w);

  var size = '16px';

  switch (rest.iconSize) {
    case 'medium':
      {
        size = '67px';
        break;
      }

    case 'big':
      {
        size = '104px';
        break;
      }

    default:
      {
        size = '16px';
        break;
      }
  }

  return /*#__PURE__*/jsx("svg", {
    role: "img",
    width: size,
    height: size,
    style: {
      color: rest.color
    },
    className: rest.className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    children: /*#__PURE__*/jsx("use", {
      xlinkHref: Sprite + "#" + name
    })
  });
};

var IconContainer$1 = styled.div.withConfig({
  displayName: "WithIcon__IconContainer",
  componentId: "lp6fye-0"
})(["align-items:center;display:flex;flex-direction:row;justify-content:center;"]);
var StyledIcon = styled(Icon).withConfig({
  displayName: "WithIcon__StyledIcon",
  componentId: "lp6fye-1"
})(["margin-right:9px;"]);
var WithIcon = function WithIcon(_ref) {
  var children = _ref.children,
      icon = _ref.icon;
  return icon ? /*#__PURE__*/jsxs(IconContainer$1, {
    children: [/*#__PURE__*/jsx(StyledIcon, _extends$2({}, icon)), children]
  }) : children;
};

var stylis$1 = createCommonjsModule(function (module, exports) {
  /*
   *          __        ___
   *    _____/ /___  __/ (_)____
   *   / ___/ __/ / / / / / ___/
   *  (__  ) /_/ /_/ / / (__  )
   * /____/\__/\__, /_/_/____/
   *          /____/
   *
   * light - weight css preprocessor @licence MIT
   */
  (function (factory) {
    /* eslint-disable */
    module['exports'] = factory(null) ;
  })(
  /** @param {*=} options */
  function factory(options) {
    /**
     * Notes
     *
     * The ['<method name>'] pattern is used to support closure compiler
     * the jsdoc signatures are also used to the same effect
     *
     * ----
     *
     * int + int + int === n4 [faster]
     *
     * vs
     *
     * int === n1 && int === n2 && int === n3
     *
     * ----
     *
     * switch (int) { case ints...} [faster]
     *
     * vs
     *
     * if (int == 1 && int === 2 ...)
     *
     * ----
     *
     * The (first*n1 + second*n2 + third*n3) format used in the property parser
     * is a simple way to hash the sequence of characters
     * taking into account the index they occur in
     * since any number of 3 character sequences could produce duplicates.
     *
     * On the other hand sequences that are directly tied to the index of the character
     * resolve a far more accurate measure, it's also faster
     * to evaluate one condition in a switch statement
     * than three in an if statement regardless of the added math.
     *
     * This allows the vendor prefixer to be both small and fast.
     */

    var nullptn = /^\0+/g;
    /* matches leading null characters */

    var formatptn = /[\0\r\f]/g;
    /* matches new line, null and formfeed characters */

    var colonptn = /: */g;
    /* splits animation rules */

    var cursorptn = /zoo|gra/;
    /* assert cursor varient */

    var transformptn = /([,: ])(transform)/g;
    /* vendor prefix transform, older webkit */

    var animationptn = /,+\s*(?![^(]*[)])/g;
    /* splits multiple shorthand notation animations */

    var propertiesptn = / +\s*(?![^(]*[)])/g;
    /* animation properties */

    var elementptn = / *[\0] */g;
    /* selector elements */

    var selectorptn = /,\r+?/g;
    /* splits selectors */

    var andptn = /([\t\r\n ])*\f?&/g;
    /* match & */

    var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g;
    /* matches :global(.*) */

    var invalidptn = /\W+/g;
    /* removes invalid characters from keyframes */

    var keyframeptn = /@(k\w+)\s*(\S*)\s*/;
    /* matches @keyframes $1 */

    var plcholdrptn = /::(place)/g;
    /* match ::placeholder varient */

    var readonlyptn = /:(read-only)/g;
    /* match :read-only varient */

    var beforeptn = /\s+(?=[{\];=:>])/g;
    /* matches \s before ] ; = : */

    var afterptn = /([[}=:>])\s+/g;
    /* matches \s after characters [ } = : */

    var tailptn = /(\{[^{]+?);(?=\})/g;
    /* matches tail semi-colons ;} */

    var whiteptn = /\s{2,}/g;
    /* matches repeating whitespace */

    var pseudoptn = /([^\(])(:+) */g;
    /* pseudo element */

    var writingptn = /[svh]\w+-[tblr]{2}/;
    /* match *gradient property */

    var supportsptn = /\(\s*(.*)\s*\)/g;
    /* match supports (groups) */

    var propertyptn = /([\s\S]*?);/g;
    /* match properties leading semicolon */

    var selfptn = /-self|flex-/g;
    /* match flex- and -self in align-self: flex-*; */

    var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/;
    /* match tail whitspace */

    var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/;
    /* match max/min/fit-content, fill-available */

    var imgsrcptn = /([^-])(image-set\()/;
    /* vendors */

    var webkit = '-webkit-';
    var moz = '-moz-';
    var ms = '-ms-';
    /* character codes */

    var SEMICOLON = 59;
    /* ; */

    var CLOSEBRACES = 125;
    /* } */

    var OPENBRACES = 123;
    /* { */

    var OPENPARENTHESES = 40;
    /* ( */

    var CLOSEPARENTHESES = 41;
    /* ) */

    var OPENBRACKET = 91;
    /* [ */

    var CLOSEBRACKET = 93;
    /* ] */

    var NEWLINE = 10;
    /* \n */

    var CARRIAGE = 13;
    /* \r */

    var TAB = 9;
    /* \t */

    var AT = 64;
    /* @ */

    var SPACE = 32;
    /*   */

    var AND = 38;
    /* & */

    var DASH = 45;
    /* - */

    var UNDERSCORE = 95;
    /* _ */

    var STAR = 42;
    /* * */

    var COMMA = 44;
    /* , */

    var COLON = 58;
    /* : */

    var SINGLEQUOTE = 39;
    /* ' */

    var DOUBLEQUOTE = 34;
    /* " */

    var FOWARDSLASH = 47;
    /* / */

    var GREATERTHAN = 62;
    /* > */

    var PLUS = 43;
    /* + */

    var TILDE = 126;
    /* ~ */

    var NULL = 0;
    /* \0 */

    var FORMFEED = 12;
    /* \f */

    var VERTICALTAB = 11;
    /* \v */

    /* special identifiers */

    var KEYFRAME = 107;
    /* k */

    var MEDIA = 109;
    /* m */

    var SUPPORTS = 115;
    /* s */

    var PLACEHOLDER = 112;
    /* p */

    var READONLY = 111;
    /* o */

    var IMPORT = 105;
    /* <at>i */

    var CHARSET = 99;
    /* <at>c */

    var DOCUMENT = 100;
    /* <at>d */

    var PAGE = 112;
    /* <at>p */

    var column = 1;
    /* current column */

    var line = 1;
    /* current line numebr */

    var pattern = 0;
    /* :pattern */

    var cascade = 1;
    /* #id h1 h2 vs h1#id h2#id  */

    var prefix = 1;
    /* vendor prefix */

    var escape = 1;
    /* escape :global() pattern */

    var compress = 0;
    /* compress output */

    var semicolon = 0;
    /* no/semicolon option */

    var preserve = 0;
    /* preserve empty selectors */

    /* empty reference */

    var array = [];
    /* plugins */

    var plugins = [];
    var plugged = 0;
    var should = null;
    /* plugin context */

    var POSTS = -2;
    var PREPS = -1;
    var UNKWN = 0;
    var PROPS = 1;
    var BLCKS = 2;
    var ATRUL = 3;
    /* plugin newline context */

    var unkwn = 0;
    /* keyframe animation */

    var keyed = 1;
    var key = '';
    /* selector namespace */

    var nscopealt = '';
    var nscope = '';
    /**
     * Compile
     *
     * @param {Array<string>} parent
     * @param {Array<string>} current
     * @param {string} body
     * @param {number} id
     * @param {number} depth
     * @return {string}
     */

    function compile(parent, current, body, id, depth) {
      var bracket = 0;
      /* brackets [] */

      var comment = 0;
      /* comments /* // or /* */

      var parentheses = 0;
      /* functions () */

      var quote = 0;
      /* quotes '', "" */

      var first = 0;
      /* first character code */

      var second = 0;
      /* second character code */

      var code = 0;
      /* current character code */

      var tail = 0;
      /* previous character code */

      var trail = 0;
      /* character before previous code */

      var peak = 0;
      /* previous non-whitespace code */

      var counter = 0;
      /* count sequence termination */

      var context = 0;
      /* track current context */

      var atrule = 0;
      /* track @at-rule context */

      var pseudo = 0;
      /* track pseudo token index */

      var caret = 0;
      /* current character index */

      var format = 0;
      /* control character formating context */

      var insert = 0;
      /* auto semicolon insertion */

      var invert = 0;
      /* inverted selector pattern */

      var length = 0;
      /* generic length address */

      var eof = body.length;
      /* end of file(length) */

      var eol = eof - 1;
      /* end of file(characters) */

      var _char = '';
      /* current character */

      var chars = '';
      /* current buffer of characters */

      var child = '';
      /* next buffer of characters */

      var out = '';
      /* compiled body */

      var children = '';
      /* compiled children */

      var flat = '';
      /* compiled leafs */

      var selector;
      /* generic selector address */

      var result;
      /* generic address */
      // ...build body

      while (caret < eof) {
        code = body.charCodeAt(caret); // eof varient

        if (caret === eol) {
          // last character + noop context, add synthetic padding for noop context to terminate
          if (comment + quote + parentheses + bracket !== 0) {
            if (comment !== 0) {
              code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH;
            }

            quote = parentheses = bracket = 0;
            eof++;
            eol++;
          }
        }

        if (comment + quote + parentheses + bracket === 0) {
          // eof varient
          if (caret === eol) {
            if (format > 0) {
              chars = chars.replace(formatptn, '');
            }

            if (chars.trim().length > 0) {
              switch (code) {
                case SPACE:
                case TAB:
                case SEMICOLON:
                case CARRIAGE:
                case NEWLINE:
                  {
                    break;
                  }

                default:
                  {
                    chars += body.charAt(caret);
                  }
              }

              code = SEMICOLON;
            }
          } // auto semicolon insertion


          if (insert === 1) {
            switch (code) {
              // false flags
              case OPENBRACES:
              case CLOSEBRACES:
              case SEMICOLON:
              case DOUBLEQUOTE:
              case SINGLEQUOTE:
              case OPENPARENTHESES:
              case CLOSEPARENTHESES:
              case COMMA:
                {
                  insert = 0;
                }
              // ignore

              case TAB:
              case CARRIAGE:
              case NEWLINE:
              case SPACE:
                {
                  break;
                }
              // valid

              default:
                {
                  insert = 0;
                  length = caret;
                  first = code;
                  caret--;
                  code = SEMICOLON;

                  while (length < eof) {
                    switch (body.charCodeAt(length++)) {
                      case NEWLINE:
                      case CARRIAGE:
                      case SEMICOLON:
                        {
                          ++caret;
                          code = first;
                          length = eof;
                          break;
                        }

                      case COLON:
                        {
                          if (format > 0) {
                            ++caret;
                            code = first;
                          }
                        }

                      case OPENBRACES:
                        {
                          length = eof;
                        }
                    }
                  }
                }
            }
          } // token varient


          switch (code) {
            case OPENBRACES:
              {
                chars = chars.trim();
                first = chars.charCodeAt(0);
                counter = 1;
                length = ++caret;

                while (caret < eof) {
                  switch (code = body.charCodeAt(caret)) {
                    case OPENBRACES:
                      {
                        counter++;
                        break;
                      }

                    case CLOSEBRACES:
                      {
                        counter--;
                        break;
                      }

                    case FOWARDSLASH:
                      {
                        switch (second = body.charCodeAt(caret + 1)) {
                          // /*, //
                          case STAR:
                          case FOWARDSLASH:
                            {
                              caret = delimited(second, caret, eol, body);
                            }
                        }

                        break;
                      }
                    // given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93

                    case OPENBRACKET:
                      {
                        code++;
                      }
                    // given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41

                    case OPENPARENTHESES:
                      {
                        code++;
                      }
                    // quote tail delimiter is identical to the head delimiter hence noop,
                    // fallthrough clauses have been shifted to the correct tail delimiter

                    case DOUBLEQUOTE:
                    case SINGLEQUOTE:
                      {
                        while (caret++ < eol) {
                          if (body.charCodeAt(caret) === code) {
                            break;
                          }
                        }
                      }
                  }

                  if (counter === 0) {
                    break;
                  }

                  caret++;
                }

                child = body.substring(length, caret);

                if (first === NULL) {
                  first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0);
                }

                switch (first) {
                  // @at-rule
                  case AT:
                    {
                      if (format > 0) {
                        chars = chars.replace(formatptn, '');
                      }

                      second = chars.charCodeAt(1);

                      switch (second) {
                        case DOCUMENT:
                        case MEDIA:
                        case SUPPORTS:
                        case DASH:
                          {
                            selector = current;
                            break;
                          }

                        default:
                          {
                            selector = array;
                          }
                      }

                      child = compile(current, selector, child, second, depth + 1);
                      length = child.length; // preserve empty @at-rule

                      if (preserve > 0 && length === 0) {
                        length = chars.length;
                      } // execute plugins, @at-rule context


                      if (plugged > 0) {
                        selector = select(array, chars, invert);
                        result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id);
                        chars = selector.join('');

                        if (result !== void 0) {
                          if ((length = (child = result.trim()).length) === 0) {
                            second = 0;
                            child = '';
                          }
                        }
                      }

                      if (length > 0) {
                        switch (second) {
                          case SUPPORTS:
                            {
                              chars = chars.replace(supportsptn, supports);
                            }

                          case DOCUMENT:
                          case MEDIA:
                          case DASH:
                            {
                              child = chars + '{' + child + '}';
                              break;
                            }

                          case KEYFRAME:
                            {
                              chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''));
                              child = chars + '{' + child + '}';

                              if (prefix === 1 || prefix === 2 && vendor('@' + child, 3)) {
                                child = '@' + webkit + child + '@' + child;
                              } else {
                                child = '@' + child;
                              }

                              break;
                            }

                          default:
                            {
                              child = chars + child;

                              if (id === PAGE) {
                                child = (out += child, '');
                              }
                            }
                        }
                      } else {
                        child = '';
                      }

                      break;
                    }
                  // selector

                  default:
                    {
                      child = compile(current, select(current, chars, invert), child, id, depth + 1);
                    }
                }

                children += child; // reset

                context = 0;
                insert = 0;
                pseudo = 0;
                format = 0;
                invert = 0;
                atrule = 0;
                chars = '';
                child = '';
                code = body.charCodeAt(++caret);
                break;
              }

            case CLOSEBRACES:
            case SEMICOLON:
              {
                chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim();

                if ((length = chars.length) > 1) {
                  // monkey-patch missing colon
                  if (pseudo === 0) {
                    first = chars.charCodeAt(0); // first character is a letter or dash, buffer has a space character

                    if (first === DASH || first > 96 && first < 123) {
                      length = (chars = chars.replace(' ', ':')).length;
                    }
                  } // execute plugins, property context


                  if (plugged > 0) {
                    if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
                      if ((length = (chars = result.trim()).length) === 0) {
                        chars = '\0\0';
                      }
                    }
                  }

                  first = chars.charCodeAt(0);
                  second = chars.charCodeAt(1);

                  switch (first) {
                    case NULL:
                      {
                        break;
                      }

                    case AT:
                      {
                        if (second === IMPORT || second === CHARSET) {
                          flat += chars + body.charAt(caret);
                          break;
                        }
                      }

                    default:
                      {
                        if (chars.charCodeAt(length - 1) === COLON) {
                          break;
                        }

                        out += property(chars, first, second, chars.charCodeAt(2));
                      }
                  }
                } // reset


                context = 0;
                insert = 0;
                pseudo = 0;
                format = 0;
                invert = 0;
                chars = '';
                code = body.charCodeAt(++caret);
                break;
              }
          }
        } // parse characters


        switch (code) {
          case CARRIAGE:
          case NEWLINE:
            {
              // auto insert semicolon
              if (comment + quote + parentheses + bracket + semicolon === 0) {
                // valid non-whitespace characters that
                // may precede a newline
                switch (peak) {
                  case CLOSEPARENTHESES:
                  case SINGLEQUOTE:
                  case DOUBLEQUOTE:
                  case AT:
                  case TILDE:
                  case GREATERTHAN:
                  case STAR:
                  case PLUS:
                  case FOWARDSLASH:
                  case DASH:
                  case COLON:
                  case COMMA:
                  case SEMICOLON:
                  case OPENBRACES:
                  case CLOSEBRACES:
                    {
                      break;
                    }

                  default:
                    {
                      // current buffer has a colon
                      if (pseudo > 0) {
                        insert = 1;
                      }
                    }
                }
              } // terminate line comment


              if (comment === FOWARDSLASH) {
                comment = 0;
              } else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
                format = 1;
                chars += '\0';
              } // execute plugins, newline context


              if (plugged * unkwn > 0) {
                proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id);
              } // next line, reset column position


              column = 1;
              line++;
              break;
            }

          case SEMICOLON:
          case CLOSEBRACES:
            {
              if (comment + quote + parentheses + bracket === 0) {
                column++;
                break;
              }
            }

          default:
            {
              // increment column position
              column++; // current character

              _char = body.charAt(caret); // remove comments, escape functions, strings, attributes and prepare selectors

              switch (code) {
                case TAB:
                case SPACE:
                  {
                    if (quote + bracket + comment === 0) {
                      switch (tail) {
                        case COMMA:
                        case COLON:
                        case TAB:
                        case SPACE:
                          {
                            _char = '';
                            break;
                          }

                        default:
                          {
                            if (code !== SPACE) {
                              _char = ' ';
                            }
                          }
                      }
                    }

                    break;
                  }
                // escape breaking control characters

                case NULL:
                  {
                    _char = '\\0';
                    break;
                  }

                case FORMFEED:
                  {
                    _char = '\\f';
                    break;
                  }

                case VERTICALTAB:
                  {
                    _char = '\\v';
                    break;
                  }
                // &

                case AND:
                  {
                    // inverted selector pattern i.e html &
                    if (quote + comment + bracket === 0 && cascade > 0) {
                      invert = 1;
                      format = 1;
                      _char = '\f' + _char;
                    }

                    break;
                  }
                // ::p<l>aceholder, l
                // :read-on<l>y, l

                case 108:
                  {
                    if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
                      switch (caret - pseudo) {
                        // ::placeholder
                        case 2:
                          {
                            if (tail === PLACEHOLDER && body.charCodeAt(caret - 3) === COLON) {
                              pattern = tail;
                            }
                          }
                        // :read-only

                        case 8:
                          {
                            if (trail === READONLY) {
                              pattern = trail;
                            }
                          }
                      }
                    }

                    break;
                  }
                // :<pattern>

                case COLON:
                  {
                    if (quote + comment + bracket === 0) {
                      pseudo = caret;
                    }

                    break;
                  }
                // selectors

                case COMMA:
                  {
                    if (comment + parentheses + quote + bracket === 0) {
                      format = 1;
                      _char += '\r';
                    }

                    break;
                  }
                // quotes

                case DOUBLEQUOTE:
                case SINGLEQUOTE:
                  {
                    if (comment === 0) {
                      quote = quote === code ? 0 : quote === 0 ? code : quote;
                    }

                    break;
                  }
                // attributes

                case OPENBRACKET:
                  {
                    if (quote + comment + parentheses === 0) {
                      bracket++;
                    }

                    break;
                  }

                case CLOSEBRACKET:
                  {
                    if (quote + comment + parentheses === 0) {
                      bracket--;
                    }

                    break;
                  }
                // functions

                case CLOSEPARENTHESES:
                  {
                    if (quote + comment + bracket === 0) {
                      parentheses--;
                    }

                    break;
                  }

                case OPENPARENTHESES:
                  {
                    if (quote + comment + bracket === 0) {
                      if (context === 0) {
                        switch (tail * 2 + trail * 3) {
                          // :matches
                          case 533:
                            {
                              break;
                            }
                          // :global, :not, :nth-child etc...

                          default:
                            {
                              counter = 0;
                              context = 1;
                            }
                        }
                      }

                      parentheses++;
                    }

                    break;
                  }

                case AT:
                  {
                    if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
                      atrule = 1;
                    }

                    break;
                  }
                // block/line comments

                case STAR:
                case FOWARDSLASH:
                  {
                    if (quote + bracket + parentheses > 0) {
                      break;
                    }

                    switch (comment) {
                      // initialize line/block comment context
                      case 0:
                        {
                          switch (code * 2 + body.charCodeAt(caret + 1) * 3) {
                            // //
                            case 235:
                              {
                                comment = FOWARDSLASH;
                                break;
                              }
                            // /*

                            case 220:
                              {
                                length = caret;
                                comment = STAR;
                                break;
                              }
                          }

                          break;
                        }
                      // end block comment context

                      case STAR:
                        {
                          if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
                            // /*<!> ... */, !
                            if (body.charCodeAt(length + 2) === 33) {
                              out += body.substring(length, caret + 1);
                            }

                            _char = '';
                            comment = 0;
                          }
                        }
                    }
                  }
              } // ignore comment blocks


              if (comment === 0) {
                // aggressive isolation mode, divide each individual selector
                // including selectors in :not function but excluding selectors in :global function
                if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
                  switch (code) {
                    case COMMA:
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case CLOSEPARENTHESES:
                    case OPENPARENTHESES:
                      {
                        if (context === 0) {
                          // outside of an isolated context i.e nth-child(<...>)
                          switch (tail) {
                            case TAB:
                            case SPACE:
                            case NEWLINE:
                            case CARRIAGE:
                              {
                                _char = _char + '\0';
                                break;
                              }

                            default:
                              {
                                _char = '\0' + _char + (code === COMMA ? '' : '\0');
                              }
                          }

                          format = 1;
                        } else {
                          // within an isolated context, sleep untill it's terminated
                          switch (code) {
                            case OPENPARENTHESES:
                              {
                                // :globa<l>(
                                if (pseudo + 7 === caret && tail === 108) {
                                  pseudo = 0;
                                }

                                context = ++counter;
                                break;
                              }

                            case CLOSEPARENTHESES:
                              {
                                if ((context = --counter) === 0) {
                                  format = 1;
                                  _char += '\0';
                                }

                                break;
                              }
                          }
                        }

                        break;
                      }

                    case TAB:
                    case SPACE:
                      {
                        switch (tail) {
                          case NULL:
                          case OPENBRACES:
                          case CLOSEBRACES:
                          case SEMICOLON:
                          case COMMA:
                          case FORMFEED:
                          case TAB:
                          case SPACE:
                          case NEWLINE:
                          case CARRIAGE:
                            {
                              break;
                            }

                          default:
                            {
                              // ignore in isolated contexts
                              if (context === 0) {
                                format = 1;
                                _char += '\0';
                              }
                            }
                        }
                      }
                  }
                } // concat buffer of characters


                chars += _char; // previous non-whitespace character code

                if (code !== SPACE && code !== TAB) {
                  peak = code;
                }
              }
            }
        } // tail character codes


        trail = tail;
        tail = code; // visit every character

        caret++;
      }

      length = out.length; // preserve empty selector

      if (preserve > 0) {
        if (length === 0 && children.length === 0 && current[0].length === 0 === false) {
          if (id !== MEDIA || current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0]) {
            length = current.join(',').length + 2;
          }
        }
      }

      if (length > 0) {
        // cascade isolation mode?
        selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current; // execute plugins, block context

        if (plugged > 0) {
          result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id);

          if (result !== void 0 && (out = result).length === 0) {
            return flat + out + children;
          }
        }

        out = selector.join(',') + '{' + out + '}';

        if (prefix * pattern !== 0) {
          if (prefix === 2 && !vendor(out, 2)) pattern = 0;

          switch (pattern) {
            // ::read-only
            case READONLY:
              {
                out = out.replace(readonlyptn, ':' + moz + '$1') + out;
                break;
              }
            // ::placeholder

            case PLACEHOLDER:
              {
                out = out.replace(plcholdrptn, '::' + webkit + 'input-$1') + out.replace(plcholdrptn, '::' + moz + '$1') + out.replace(plcholdrptn, ':' + ms + 'input-$1') + out;
                break;
              }
          }

          pattern = 0;
        }
      }

      return flat + out + children;
    }
    /**
     * Select
     *
     * @param {Array<string>} parent
     * @param {string} current
     * @param {number} invert
     * @return {Array<string>}
     */


    function select(parent, current, invert) {
      var selectors = current.trim().split(selectorptn);
      var out = selectors;
      var length = selectors.length;
      var l = parent.length;

      switch (l) {
        // 0-1 parent selectors
        case 0:
        case 1:
          {
            for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
              out[i] = scope(selector, out[i], invert, l).trim();
            }

            break;
          }
        // >2 parent selectors, nested

        default:
          {
            for (var i = 0, j = 0, out = []; i < length; ++i) {
              for (var k = 0; k < l; ++k) {
                out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim();
              }
            }
          }
      }

      return out;
    }
    /**
     * Scope
     *
     * @param {string} parent
     * @param {string} current
     * @param {number} invert
     * @param {number} level
     * @return {string}
     */


    function scope(parent, current, invert, level) {
      var selector = current;
      var code = selector.charCodeAt(0); // trim leading whitespace

      if (code < 33) {
        code = (selector = selector.trim()).charCodeAt(0);
      }

      switch (code) {
        // &
        case AND:
          {
            switch (cascade + level) {
              case 0:
              case 1:
                {
                  if (parent.trim().length === 0) {
                    break;
                  }
                }

              default:
                {
                  return selector.replace(andptn, '$1' + parent.trim());
                }
            }

            break;
          }
        // :

        case COLON:
          {
            switch (selector.charCodeAt(1)) {
              // g in :global
              case 103:
                {
                  if (escape > 0 && cascade > 0) {
                    return selector.replace(escapeptn, '$1').replace(andptn, '$1' + nscope);
                  }

                  break;
                }

              default:
                {
                  // :hover
                  return parent.trim() + selector.replace(andptn, '$1' + parent.trim());
                }
            }
          }

        default:
          {
            // html &
            if (invert * cascade > 0 && selector.indexOf('\f') > 0) {
              return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1') + parent.trim());
            }
          }
      }

      return parent + selector;
    }
    /**
     * Property
     *
     * @param {string} input
     * @param {number} first
     * @param {number} second
     * @param {number} third
     * @return {string}
     */


    function property(input, first, second, third) {
      var index = 0;
      var out = input + ';';
      var hash = first * 2 + second * 3 + third * 4;
      var cache; // animation: a, n, i characters

      if (hash === 944) {
        return animation(out);
      } else if (prefix === 0 || prefix === 2 && !vendor(out, 1)) {
        return out;
      } // vendor prefix


      switch (hash) {
        // text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
        case 1015:
          {
            // text-shadow/text-align/text-transform, a
            return out.charCodeAt(10) === 97 ? webkit + out + out : out;
          }
        // filter/fill f, i, l

        case 951:
          {
            // filter, t
            return out.charCodeAt(3) === 116 ? webkit + out + out : out;
          }
        // color/column, c, o, l

        case 963:
          {
            // column, n
            return out.charCodeAt(5) === 110 ? webkit + out + out : out;
          }
        // box-decoration-break, b, o, x

        case 1009:
          {
            if (out.charCodeAt(4) !== 100) {
              break;
            }
          }
        // mask, m, a, s
        // clip-path, c, l, i

        case 969:
        case 942:
          {
            return webkit + out + out;
          }
        // appearance: a, p, p

        case 978:
          {
            return webkit + out + moz + out + out;
          }
        // hyphens: h, y, p
        // user-select: u, s, e

        case 1019:
        case 983:
          {
            return webkit + out + moz + out + ms + out + out;
          }
        // background/backface-visibility, b, a, c

        case 883:
          {
            // backface-visibility, -
            if (out.charCodeAt(8) === DASH) {
              return webkit + out + out;
            } // image-set(...)


            if (out.indexOf('image-set(', 11) > 0) {
              return out.replace(imgsrcptn, '$1' + webkit + '$2') + out;
            }

            return out;
          }
        // flex: f, l, e

        case 932:
          {
            if (out.charCodeAt(4) === DASH) {
              switch (out.charCodeAt(5)) {
                // flex-grow, g
                case 103:
                  {
                    return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out;
                  }
                // flex-shrink, s

                case 115:
                  {
                    return webkit + out + ms + out.replace('shrink', 'negative') + out;
                  }
                // flex-basis, b

                case 98:
                  {
                    return webkit + out + ms + out.replace('basis', 'preferred-size') + out;
                  }
              }
            }

            return webkit + out + ms + out + out;
          }
        // order: o, r, d

        case 964:
          {
            return webkit + out + ms + 'flex' + '-' + out + out;
          }
        // justify-items/justify-content, j, u, s

        case 1023:
          {
            // justify-content, c
            if (out.charCodeAt(8) !== 99) {
              break;
            }

            cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
            return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out;
          }
        // cursor, c, u, r

        case 1005:
          {
            return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out;
          }
        // writing-mode, w, r, i

        case 1000:
          {
            cache = out.substring(13).trim();
            index = cache.indexOf('-') + 1;

            switch (cache.charCodeAt(0) + cache.charCodeAt(index)) {
              // vertical-lr
              case 226:
                {
                  cache = out.replace(writingptn, 'tb');
                  break;
                }
              // vertical-rl

              case 232:
                {
                  cache = out.replace(writingptn, 'tb-rl');
                  break;
                }
              // horizontal-tb

              case 220:
                {
                  cache = out.replace(writingptn, 'lr');
                  break;
                }

              default:
                {
                  return out;
                }
            }

            return webkit + out + ms + cache + out;
          }
        // position: sticky

        case 1017:
          {
            if (out.indexOf('sticky', 9) === -1) {
              return out;
            }
          }
        // display(flex/inline-flex/inline-box): d, i, s

        case 975:
          {
            index = (out = input).length - 10;
            cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim();

            switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7) | 0)) {
              // inline-
              case 203:
                {
                  // inline-box
                  if (cache.charCodeAt(8) < 111) {
                    break;
                  }
                }
              // inline-box/sticky

              case 115:
                {
                  out = out.replace(cache, webkit + cache) + ';' + out;
                  break;
                }
              // inline-flex
              // flex

              case 207:
              case 102:
                {
                  out = out.replace(cache, webkit + (hash > 102 ? 'inline-' : '') + 'box') + ';' + out.replace(cache, webkit + cache) + ';' + out.replace(cache, ms + cache + 'box') + ';' + out;
                }
            }

            return out + ';';
          }
        // align-items, align-center, align-self: a, l, i, -

        case 938:
          {
            if (out.charCodeAt(5) === DASH) {
              switch (out.charCodeAt(6)) {
                // align-items, i
                case 105:
                  {
                    cache = out.replace('-items', '');
                    return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out;
                  }
                // align-self, s

                case 115:
                  {
                    return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out;
                  }
                // align-content

                default:
                  {
                    return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out;
                  }
              }
            }

            break;
          }
        // min/max

        case 973:
        case 989:
          {
            // min-/max- height/width/block-size/inline-size
            if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
              break;
            }
          }
        // height/width: min-content / width: max-content

        case 931:
        case 953:
          {
            if (dimensionptn.test(input) === true) {
              // stretch
              if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115) return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch');else return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out;
            }

            break;
          }
        // transform, transition: t, r, a

        case 962:
          {
            out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out; // transitions

            if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
              return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out;
            }

            break;
          }
      }

      return out;
    }
    /**
     * Vendor
     *
     * @param {string} content
     * @param {number} context
     * @return {boolean}
     */


    function vendor(content, context) {
      var index = content.indexOf(context === 1 ? ':' : '{');
      var key = content.substring(0, context !== 3 ? index : 10);
      var value = content.substring(index + 1, content.length - 1);
      return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context);
    }
    /**
     * Supports
     *
     * @param {string} match
     * @param {string} group
     * @return {string}
     */


    function supports(match, group) {
      var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2));
      return out !== group + ';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '(' + group + ')';
    }
    /**
     * Animation
     *
     * @param {string} input
     * @return {string}
     */


    function animation(input) {
      var length = input.length;
      var index = input.indexOf(':', 9) + 1;
      var declare = input.substring(0, index).trim();
      var out = input.substring(index, length - 1).trim();

      switch (input.charCodeAt(9) * keyed) {
        case 0:
          {
            break;
          }
        // animation-*, -

        case DASH:
          {
            // animation-name, n
            if (input.charCodeAt(10) !== 110) {
              break;
            }
          }
        // animation/animation-name

        default:
          {
            // split in case of multiple animations
            var list = out.split((out = '', animationptn));

            for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
              var value = list[i];
              var items = value.split(propertiesptn);

              while (value = items[index]) {
                var peak = value.charCodeAt(0);

                if (keyed === 1 && ( // letters
                peak > AT && peak < 90 || peak > 96 && peak < 123 || peak === UNDERSCORE || // dash but not in sequence i.e --
                peak === DASH && value.charCodeAt(1) !== DASH)) {
                  // not a number/function
                  switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
                    case 1:
                      {
                        switch (value) {
                          // not a valid reserved keyword
                          case 'infinite':
                          case 'alternate':
                          case 'backwards':
                          case 'running':
                          case 'normal':
                          case 'forwards':
                          case 'both':
                          case 'none':
                          case 'linear':
                          case 'ease':
                          case 'ease-in':
                          case 'ease-out':
                          case 'ease-in-out':
                          case 'paused':
                          case 'reverse':
                          case 'alternate-reverse':
                          case 'inherit':
                          case 'initial':
                          case 'unset':
                          case 'step-start':
                          case 'step-end':
                            {
                              break;
                            }

                          default:
                            {
                              value += key;
                            }
                        }
                      }
                  }
                }

                items[index++] = value;
              }

              out += (i === 0 ? '' : ',') + items.join(' ');
            }
          }
      }

      out = declare + out + ';';
      if (prefix === 1 || prefix === 2 && vendor(out, 1)) return webkit + out + out;
      return out;
    }
    /**
     * Isolate
     *
     * @param {Array<string>} current
     */


    function isolate(current) {
      for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
        // split individual elements in a selector i.e h1 h2 === [h1, h2]
        var elements = current[i].split(elementptn);
        var out = '';

        for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
          // empty element
          if ((size = (element = elements[j]).length) === 0 && l > 1) {
            continue;
          }

          tail = out.charCodeAt(out.length - 1);
          code = element.charCodeAt(0);
          padding = '';

          if (j !== 0) {
            // determine if we need padding
            switch (tail) {
              case STAR:
              case TILDE:
              case GREATERTHAN:
              case PLUS:
              case SPACE:
              case OPENPARENTHESES:
                {
                  break;
                }

              default:
                {
                  padding = ' ';
                }
            }
          }

          switch (code) {
            case AND:
              {
                element = padding + nscopealt;
              }

            case TILDE:
            case GREATERTHAN:
            case PLUS:
            case SPACE:
            case CLOSEPARENTHESES:
            case OPENPARENTHESES:
              {
                break;
              }

            case OPENBRACKET:
              {
                element = padding + element + nscopealt;
                break;
              }

            case COLON:
              {
                switch (element.charCodeAt(1) * 2 + element.charCodeAt(2) * 3) {
                  // :global
                  case 530:
                    {
                      if (escape > 0) {
                        element = padding + element.substring(8, size - 1);
                        break;
                      }
                    }
                  // :hover, :nth-child(), ...

                  default:
                    {
                      if (j < 1 || elements[j - 1].length < 1) {
                        element = padding + nscopealt + element;
                      }
                    }
                }

                break;
              }

            case COMMA:
              {
                padding = '';
              }

            default:
              {
                if (size > 1 && element.indexOf(':') > 0) {
                  element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2');
                } else {
                  element = padding + element + nscopealt;
                }
              }
          }

          out += element;
        }

        selector[i] = out.replace(formatptn, '').trim();
      }

      return selector;
    }
    /**
     * Proxy
     *
     * @param {number} context
     * @param {string} content
     * @param {Array<string>} selectors
     * @param {Array<string>} parents
     * @param {number} line
     * @param {number} column
     * @param {number} length
     * @param {number} id
     * @param {number} depth
     * @param {number} at
     * @return {(string|void|*)}
     */


    function proxy(context, content, selectors, parents, line, column, length, id, depth, at) {
      for (var i = 0, out = content, next; i < plugged; ++i) {
        switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
          case void 0:
          case false:
          case true:
          case null:
            {
              break;
            }

          default:
            {
              out = next;
            }
        }
      }

      if (out !== content) {
        return out;
      }
    }
    /**
     * @param {number} code
     * @param {number} index
     * @param {number} length
     * @param {string} body
     * @return {number}
     */


    function delimited(code, index, length, body) {
      for (var i = index + 1; i < length; ++i) {
        switch (body.charCodeAt(i)) {
          // /*
          case FOWARDSLASH:
            {
              if (code === STAR) {
                if (body.charCodeAt(i - 1) === STAR && index + 2 !== i) {
                  return i + 1;
                }
              }

              break;
            }
          // //

          case NEWLINE:
            {
              if (code === FOWARDSLASH) {
                return i + 1;
              }
            }
        }
      }

      return i;
    }
    /**
     * Minify
     *
     * @param {(string|*)} output
     * @return {string}
     */


    function minify(output) {
      return output.replace(formatptn, '').replace(beforeptn, '').replace(afterptn, '$1').replace(tailptn, '$1').replace(whiteptn, ' ');
    }
    /**
     * Use
     *
     * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
     */


    function use(plugin) {
      switch (plugin) {
        case void 0:
        case null:
          {
            plugged = plugins.length = 0;
            break;
          }

        default:
          {
            if (typeof plugin === 'function') {
              plugins[plugged++] = plugin;
            } else if (typeof plugin === 'object') {
              for (var i = 0, length = plugin.length; i < length; ++i) {
                use(plugin[i]);
              }
            } else {
              unkwn = !!plugin | 0;
            }
          }
      }

      return use;
    }
    /**
     * Set
     *
     * @param {*} options
     */


    function set(options) {
      for (var name in options) {
        var value = options[name];

        switch (name) {
          case 'keyframe':
            keyed = value | 0;
            break;

          case 'global':
            escape = value | 0;
            break;

          case 'cascade':
            cascade = value | 0;
            break;

          case 'compress':
            compress = value | 0;
            break;

          case 'semicolon':
            semicolon = value | 0;
            break;

          case 'preserve':
            preserve = value | 0;
            break;

          case 'prefix':
            should = null;

            if (!value) {
              prefix = 0;
            } else if (typeof value !== 'function') {
              prefix = 1;
            } else {
              prefix = 2;
              should = value;
            }

        }
      }

      return set;
    }
    /**
     * Stylis
     *
     * @param {string} selector
     * @param {string} input
     * @return {*}
     */


    function stylis(selector, input) {
      if (this !== void 0 && this.constructor === stylis) {
        return factory(selector);
      } // setup


      var ns = selector;
      var code = ns.charCodeAt(0); // trim leading whitespace

      if (code < 33) {
        code = (ns = ns.trim()).charCodeAt(0);
      } // keyframe/animation namespace


      if (keyed > 0) {
        key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-');
      } // reset, used to assert if a plugin is moneky-patching the return value


      code = 1; // cascade/isolate

      if (cascade === 1) {
        nscope = ns;
      } else {
        nscopealt = ns;
      }

      var selectors = [nscope];
      var result; // execute plugins, pre-process context

      if (plugged > 0) {
        result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0);

        if (result !== void 0 && typeof result === 'string') {
          input = result;
        }
      } // build


      var output = compile(array, selectors, input, 0, 0); // execute plugins, post-process context

      if (plugged > 0) {
        result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0); // bypass minification

        if (result !== void 0 && typeof (output = result) !== 'string') {
          code = 0;
        }
      } // reset


      key = '';
      nscope = '';
      nscopealt = '';
      pattern = 0;
      line = 1;
      column = 1;
      return compress * code === 0 ? output : minify(output);
    }

    stylis['use'] = use;
    stylis['set'] = set;

    if (options !== void 0) {
      set(options);
    }

    return stylis;
  });
});

/*! @preserve react-md-spinner v1.0.0 - tsuyoshiwada | MIT license. */

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var STYLE_DATA_NAME = "react-md-spinner";
var KEYFRAME_PREFIX = "__react-md-spinner-animation__";
var stylis = new stylis$1({
  global: false,
  cascade: true,
  keyframe: true,
  prefix: true,
  compress: false
});
var Keyframe = {
  ROOT_ROTATE: "".concat(KEYFRAME_PREFIX, "root-rotate"),
  FILL_UNFILL_ROTATE: "".concat(KEYFRAME_PREFIX, "fill-unfill-rotate"),
  LAYER_1_FADE_IN_OUT: "".concat(KEYFRAME_PREFIX, "layer-1-fade-in-out"),
  LAYER_2_FADE_IN_OUT: "".concat(KEYFRAME_PREFIX, "layer-2-fade-in-out"),
  LAYER_3_FADE_IN_OUT: "".concat(KEYFRAME_PREFIX, "layer-3-fade-in-out"),
  LAYER_4_FADE_IN_OUT: "".concat(KEYFRAME_PREFIX, "layer-4-fade-in-out"),
  LEFT_SPIN: "".concat(KEYFRAME_PREFIX, "left-spin"),
  RIGHT_SPIN: "".concat(KEYFRAME_PREFIX, "right-spin")
};
var keyframes = stylis("", "\n@keyframes ".concat(Keyframe.ROOT_ROTATE, " {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes ").concat(Keyframe.FILL_UNFILL_ROTATE, " {\n  12.5% { transform: rotate(135deg) }\n  25% { transform: rotate(270deg) }\n  37.5% { transform: rotate(405deg) }\n  50% { transform: rotate(540deg) }\n  62.5% { transform: rotate(675deg) }\n  75% { transform: rotate(810deg) }\n  87.5% { transform: rotate(945deg) }\n  100% { transform: rotate(1080deg) }\n}\n\n@keyframes ").concat(Keyframe.LAYER_1_FADE_IN_OUT, " {\n  0% { opacity: 1 }\n  25% { opacity: 1 }\n  26% { opacity: 0 }\n  89% { opacity: 0 }\n  90% { opacity: 1 }\n  100% { opacity: 1 }\n}\n\n@keyframes ").concat(Keyframe.LAYER_2_FADE_IN_OUT, " {\n  0% { opacity: 0 }\n  15% { opacity: 0 }\n  25% { opacity: 1 }\n  50% { opacity: 1 }\n  51% { opacity: 0 }\n  100% { opacity: 0 }\n}\n\n@keyframes ").concat(Keyframe.LAYER_3_FADE_IN_OUT, " {\n  0% { opacity: 0 }\n  40% { opacity: 0 }\n  50% { opacity: 1 }\n  75% { opacity: 1 }\n  76% { opacity: 0 }\n  100% { opacity: 0 }\n}\n\n@keyframes ").concat(Keyframe.LAYER_4_FADE_IN_OUT, " {\n  0% { opacity: 0 }\n  65% { opacity: 0 }\n  75% { opacity: 1 }\n  90% { opacity: 1 }\n  100% { opacity: 0 }\n}\n\n@keyframes ").concat(Keyframe.LEFT_SPIN, " {\n  0% { transform: rotate(130deg) }\n  50% { transform: rotate(-5deg) }\n  100% { transform: rotate(130deg) }\n}\n\n@keyframes ").concat(Keyframe.RIGHT_SPIN, " {\n  0% { transform: rotate(-130deg) }\n  50% { transform: rotate(5deg) }\n  100% { transform: rotate(-130deg) }\n}\n"));

var getColors = function getColors(props) {
  var singleColor = props.singleColor,
      color1 = props.color1,
      color2 = props.color2,
      color3 = props.color3,
      color4 = props.color4;
  return singleColor ? [singleColor, singleColor, singleColor, singleColor] : [color1, color2, color3, color4];
};

var getStyles = function getStyles(props) {
  var size = props.size;
  var duration = props.duration;
  var borderSize = props.borderSize;
  var borderWidth = borderSize || Math.max(1, Math.round(size * 0.107142));
  var colors = getColors(props);
  var arcSize = 270;
  var arcStartRotate = 216;
  var rootDuration = 360 * duration / (arcStartRotate + (360 - arcSize));
  var rootStyle = {
    display: "inline-block",
    position: "relative",
    width: size,
    height: size,
    verticalAlign: "middle",
    fontSize: "0",
    animation: "".concat(Keyframe.ROOT_ROTATE, " ").concat(rootDuration, "ms linear infinite"),
    WebkitAnimation: "".concat(Keyframe.ROOT_ROTATE, " ").concat(rootDuration, "ms linear infinite")
  };
  var layerStyles = colors.map(function (color, i) {
    return {
      boxSizing: "border-box",
      display: "block",
      position: "absolute",
      width: "100%",
      height: "100%",
      borderColor: color,
      whiteSpace: "nowrap",
      opacity: 1,
      animationName: "".concat(Keyframe.FILL_UNFILL_ROTATE, ", ").concat(Keyframe["LAYER_".concat(i + 1, "_FADE_IN_OUT")]),
      WebkitAnimationName: "".concat(Keyframe.FILL_UNFILL_ROTATE, ", ").concat(Keyframe["LAYER_".concat(i + 1, "_FADE_IN_OUT")]),
      animationDuration: "".concat(duration * colors.length, "ms"),
      WebkitAnimationDuration: "".concat(duration * colors.length, "ms"),
      animationTimingFunction: "cubic-bezier(.4, 0, .2, 1)",
      WebkitAnimationTimingFunction: "cubic-bezier(.4, 0, .2, 1)",
      animationIterationCount: "infinite",
      WebkitAnimationIterationCount: "infinite"
    };
  });
  var clipStyle = {
    display: "inline-block",
    boxSizing: "border-box",
    position: "relative",
    width: "50%",
    height: "100%",
    overflow: "hidden",
    borderColor: "inherit"
  };
  var layerClipAfterStyle = {
    display: "inline-block",
    boxSizing: "border-box",
    position: "absolute",
    top: 0,
    borderRadius: "50%"
  };

  var layerAfterStyle = _objectSpread({}, layerClipAfterStyle, {
    left: "45%",
    width: "10%",
    borderWidth: borderWidth,
    borderColor: "inherit",
    borderTopStyle: "solid"
  });

  var clipAfterStyle = _objectSpread({}, layerClipAfterStyle, {
    bottom: 0,
    width: "200%",
    borderWidth: borderWidth,
    borderStyle: "solid",
    animationDuration: "".concat(duration, "ms"),
    WebkitAnimationDuration: "".concat(duration, "ms"),
    animationTimingFunction: "cubic-bezier(.4, 0, .2, 1)",
    WebkitAnimationTimingFunction: "cubic-bezier(.4, 0, .2, 1)",
    animationIterationCount: "infinite",
    WebkitAnimationIterationCount: "infinite"
  });

  var clip1AfterStyle = _objectSpread({}, clipAfterStyle, {
    left: 0,
    transform: "rotate(129deg)",
    WebkitTransform: "rotate(129deg)",
    animationName: Keyframe.LEFT_SPIN,
    WebkitAnimationName: Keyframe.LEFT_SPIN
  });

  var clip1AfterStyles = colors.map(function (color) {
    return _objectSpread({}, clip1AfterStyle, {
      borderColor: "".concat(color, " transparent transparent ").concat(color)
    });
  });

  var clip2AfterStyle = _objectSpread({}, clipAfterStyle, {
    left: "-100%",
    transform: "rotate(-129deg)",
    WebkitTransform: "rotate(-129deg)",
    animationName: Keyframe.RIGHT_SPIN,
    WebkitAnimationName: Keyframe.RIGHT_SPIN
  });

  var clip2AfterStyles = colors.map(function (color) {
    return _objectSpread({}, clip2AfterStyle, {
      borderColor: "".concat(color, " ").concat(color, " transparent transparent")
    });
  });
  return {
    rootStyle: rootStyle,
    layerStyles: layerStyles,
    layerAfterStyle: layerAfterStyle,
    clipStyle: clipStyle,
    clip1AfterStyles: clip1AfterStyles,
    clip2AfterStyles: clip2AfterStyles
  };
};

var injectStyles = function injectStyles(name, rules) {
  var el = document.createElement("style");
  el.type = "text/css";
  el.setAttribute("data-".concat(name), "");
  el.innerHTML = rules;
  document.head.appendChild(el);
};

var uninjectStyles = function uninjectStyles(name) {
  var el = document.querySelector("[data-".concat(name, "]"));

  if (el != null && el.parentNode != null) {
    el.parentNode.removeChild(el);
  }
};

var MDSpinner = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MDSpinner, _React$PureComponent);

  function MDSpinner() {
    _classCallCheck(this, MDSpinner);

    return _possibleConstructorReturn(this, _getPrototypeOf(MDSpinner).apply(this, arguments));
  }

  _createClass(MDSpinner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (MDSpinner.mountedInstanceCount < 1) {
        injectStyles(STYLE_DATA_NAME, keyframes);
      }

      MDSpinner.mountedInstanceCount++;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      MDSpinner.mountedInstanceCount = Math.max(0, MDSpinner.mountedInstanceCount - 1);

      if (MDSpinner.mountedInstanceCount < 1) {
        uninjectStyles(STYLE_DATA_NAME);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props;
          _this$props.singleColor;
          _this$props.size;
          _this$props.borderSize;
          _this$props.duration;
          _this$props.color1;
          _this$props.color2;
          _this$props.color3;
          _this$props.color4;
          var rest = _objectWithoutProperties(_this$props, ["singleColor", "size", "borderSize", "duration", "color1", "color2", "color3", "color4"]);

      var _getStyles = getStyles(this.props),
          rootStyle = _getStyles.rootStyle,
          layerStyles = _getStyles.layerStyles,
          layerAfterStyle = _getStyles.layerAfterStyle,
          clipStyle = _getStyles.clipStyle,
          clip1AfterStyles = _getStyles.clip1AfterStyles,
          clip2AfterStyles = _getStyles.clip2AfterStyles;

      var layers = [];

      for (var i = 0; i < 4; i++) {
        layers.push( /*#__PURE__*/React.createElement("span", {
          key: i,
          style: layerStyles[i]
        }, /*#__PURE__*/React.createElement("span", {
          style: clipStyle
        }, /*#__PURE__*/React.createElement("span", {
          style: clip1AfterStyles[i]
        })), /*#__PURE__*/React.createElement("span", {
          style: clipStyle
        }, /*#__PURE__*/React.createElement("span", {
          style: clip2AfterStyles[i]
        })), /*#__PURE__*/React.createElement("span", {
          style: layerAfterStyle
        })));
      }

      return /*#__PURE__*/React.createElement("span", _extends$1({}, rest, {
        style: _objectSpread({}, rootStyle, rest.style != null ? rest.style : {})
      }), layers);
    }
  }]);

  return MDSpinner;
}(React.PureComponent);

_defineProperty(MDSpinner, "defaultProps", {
  size: 28,
  duration: 1333,
  color1: "rgb(66, 165, 245)",
  color2: "rgb(239, 83, 80)",
  color3: "rgb(253, 216, 53)",
  color4: "rgb(76, 175, 80)"
});

_defineProperty(MDSpinner, "mountedInstanceCount", 0);

var Loading = function Loading(_ref) {
  var size = _ref.size,
      color = _ref.color;
  return /*#__PURE__*/jsx(MDSpinner, {
    size: size,
    singleColor: color
  });
};

var _StyledDiv$b = styled("div").withConfig({
  displayName: "WithLoading___StyledDiv",
  componentId: "sc-1izgeq2-0"
})(["position:absolute;"]);

var _StyledDiv2$5 = styled("div").withConfig({
  displayName: "WithLoading___StyledDiv2",
  componentId: "sc-1izgeq2-1"
})(["opacity:0;"]);

var WithLoading = function WithLoading(_ref) {
  var children = _ref.children,
      color = _ref.color,
      loading = _ref.loading;
  if (!loading) return children;
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(_StyledDiv$b, {
      children: /*#__PURE__*/jsx(Loading, {
        size: 16,
        color: color
      })
    }), /*#__PURE__*/jsx(_StyledDiv2$5, {
      children: children
    })]
  });
};

var Primary = styled.button.attrs(function (_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      $loading = _ref.$loading;
  return {
    children: /*#__PURE__*/jsx(WithLoading, {
      color: theme.colors.white,
      loading: $loading,
      children: /*#__PURE__*/jsx(WithIcon, {
        icon: icon,
        children: children
      })
    })
  };
}).withConfig({
  displayName: "Buttonvariants__Primary",
  componentId: "sc-1c2gn5e-0"
})(["", ";background-color:", ";border-radius:", ";color:", ";", ";", ""], function (_ref2) {
  var styles = _ref2.styles;
  return styles;
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? theme.colors.primaryDisabled : theme.colors.rBlack;
}, rem(theme.sizes.large), theme.colors.rGhost, function (_ref4) {
  var icon = _ref4.icon;
  return icon && "padding: " + rem(theme.sizes.xmini) + " " + rem(theme.sizes.small) + " " + rem(theme.sizes.xmini) + " " + rem(theme.sizes.xmini) + ";";
}, function (_ref5) {
  var disabled = _ref5.disabled,
      $loading = _ref5.$loading;
  return !disabled && !$loading && "\n      &:hover {\n        color: " + theme.colors.rWhite + ";\n        background-color: " + theme.colors.rOnyx + ";\n      }\n    ";
});
var Secondary = styled.button.attrs(function (_ref6) {
  var children = _ref6.children,
      icon = _ref6.icon,
      $loading = _ref6.$loading;
  return {
    children: /*#__PURE__*/jsx(WithLoading, {
      color: theme.colors.coal,
      loading: $loading,
      children: /*#__PURE__*/jsx(WithIcon, {
        icon: icon,
        children: children
      })
    })
  };
}).withConfig({
  displayName: "Buttonvariants__Secondary",
  componentId: "sc-1c2gn5e-1"
})(["", ";background-color:", ";border-radius:", ";color:", ";", ""], function (_ref7) {
  var styles = _ref7.styles;
  return styles;
}, function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled ? theme.colors.primaryDisabled : theme.colors.rAkihabara;
}, rem(theme.sizes.large), function (_ref9) {
  var disabled = _ref9.disabled;
  return disabled ? theme.colors.rWhite15 : theme.colors.rGhost;
}, function (_ref10) {
  var disabled = _ref10.disabled,
      $loading = _ref10.$loading;
  return !disabled && !$loading && "\n      &:hover {\n        color: " + theme.colors.rWhite + ";\n        background-color: " + theme.colors.rAkihabaraDark + ";\n      }\n    ";
});
var Tertiary = styled.button.attrs(function (_ref11) {
  var children = _ref11.children,
      $loading = _ref11.$loading;
  return {
    children: /*#__PURE__*/jsx(WithLoading, {
      color: theme.colors.coal,
      loading: $loading,
      children: children
    })
  };
}).withConfig({
  displayName: "Buttonvariants__Tertiary",
  componentId: "sc-1c2gn5e-2"
})(["", ";background-color:", ";border-radius:", ";color:", ";", ""], function (_ref12) {
  var styles = _ref12.styles;
  return styles;
}, theme.colors.rWhite, rem(theme.sizes.large), function (_ref13) {
  var disabled = _ref13.disabled;
  return disabled ? theme.colors.smoke : theme.colors.rBlack;
}, function (_ref14) {
  var disabled = _ref14.disabled,
      $loading = _ref14.$loading;
  return !disabled && !$loading && "\n      &:hover {\n        background-color: " + theme.colors.rLavender + ";\n      }\n    ";
});
var Stroke = styled.button.attrs(function (_ref15) {
  var children = _ref15.children,
      $loading = _ref15.$loading;
  return {
    children: /*#__PURE__*/jsx(WithLoading, {
      color: theme.colors.black,
      loading: $loading,
      children: children
    })
  };
}).withConfig({
  displayName: "Buttonvariants__Stroke",
  componentId: "sc-1c2gn5e-3"
})(["", ";background-color:transparent;border-radius:", ";border:", ";color:", ";", ""], function (_ref16) {
  var styles = _ref16.styles;
  return styles;
}, rem(theme.sizes.large), function (_ref17) {
  var disabled = _ref17.disabled;
  return disabled ? 'none' : "1px solid " + theme.colors.black;
}, function (_ref18) {
  var disabled = _ref18.disabled;
  return disabled ? theme.colors.smoke : theme.colors.rBlack;
}, function (_ref19) {
  var disabled = _ref19.disabled,
      $loading = _ref19.$loading;
  return !disabled && !$loading && "\n      &:hover {\n        border-color: " + theme.colors.rLavender + ";\n        color: " + theme.colors.rOnyx + ";\n      }\n    ";
});
var StrokeWhite = styled.button.attrs(function (_ref20) {
  var children = _ref20.children,
      $loading = _ref20.$loading;
  return {
    children: /*#__PURE__*/jsx(WithLoading, {
      color: theme.colors.white,
      loading: $loading,
      children: children
    })
  };
}).withConfig({
  displayName: "Buttonvariants__StrokeWhite",
  componentId: "sc-1c2gn5e-4"
})(["", ";background-color:transparent;border-radius:", ";border:", " solid ", ";color:", ";", ""], function (_ref21) {
  var styles = _ref21.styles;
  return styles;
}, rem(theme.sizes.large), rem(1), function (_ref22) {
  var disabled = _ref22.disabled;
  return disabled ? theme.colors.rBlack15 : theme.colors.rWhite;
}, function (_ref23) {
  var disabled = _ref23.disabled;
  return disabled ? theme.colors.rBlack15 : theme.colors.rGhost;
}, function (_ref24) {
  var disabled = _ref24.disabled,
      $loading = _ref24.$loading;
  return !disabled && !$loading && "\n      &:hover {\n        border-color: " + theme.colors.rLavender + ";\n        color: " + theme.colors.rSilver + ";\n      }\n    ";
});
var Danger = styled.button.attrs(function (_ref25) {
  var children = _ref25.children,
      $loading = _ref25.$loading;
  return {
    children: /*#__PURE__*/jsx(WithLoading, {
      color: theme.colors.white,
      loading: $loading,
      children: children
    })
  };
}).withConfig({
  displayName: "Buttonvariants__Danger",
  componentId: "sc-1c2gn5e-5"
})(["", ";border-radius:", ";background-color:", ";color:", ";", ""], function (_ref26) {
  var styles = _ref26.styles;
  return styles;
}, rem(theme.sizes.large), function (_ref27) {
  var disabled = _ref27.disabled;
  return disabled ? theme.colors.dangerDisabled : theme.colors.danger;
}, function (_ref28) {
  var disabled = _ref28.disabled;
  return disabled ? theme.colors.cloud : theme.colors.rGhost;
}, function (_ref29) {
  var disabled = _ref29.disabled,
      $loading = _ref29.$loading;
  return !disabled && !$loading && "\n      &:hover {\n        background-color: " + theme.colors.dangerHover + ";\n      }\n    ";
});
var Academy = styled.button.attrs(function (_ref30) {
  var children = _ref30.children,
      icon = _ref30.icon,
      $loading = _ref30.$loading;
  return {
    children: /*#__PURE__*/jsx(WithLoading, {
      color: theme.colors.white,
      loading: $loading,
      children: /*#__PURE__*/jsx(WithIcon, {
        icon: icon,
        children: children
      })
    })
  };
}).withConfig({
  displayName: "Buttonvariants__Academy",
  componentId: "sc-1c2gn5e-6"
})(["", ";background-color:", ";color:", ";border-radius:", ";", ""], function (_ref31) {
  var styles = _ref31.styles;
  return styles;
}, theme.colors.academy, theme.colors.white, rem(theme.sizes.large), function (_ref32) {
  var disabled = _ref32.disabled,
      $loading = _ref32.$loading;
  return !disabled && !$loading && "\n      &:hover {\n        background-color: " + theme.colors.academyHover + ";\n      }\n    ";
});
var buttonVariants = {
  primary: Primary,
  secondary: Secondary,
  tertiary: Tertiary,
  stroke: Stroke,
  strokeWhite: StrokeWhite,
  danger: Danger,
  academy: Academy
};

var _excluded$v = ["children", "loading", "onClick"];
var ButtonBaseStyles = css(["width:100%;outline:none;border-radius:", ";border:none;text-decoration:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:89vw;@media ", "{max-width:unset;}cursor:pointer;transition:background 0.15s ", ",transform 0.1s ", ";@media ", "{width:", ";}", " ", " ", " ", " ", ""], rem(4), theme.device.tablet, theme.transitions.easeInOut, theme.transitions.easeInOut, theme.device.tablet, function (_ref) {
  var fullwidth = _ref.fullwidth;
  return fullwidth ? '100%' : 'auto';
}, function (_ref2) {
  var $loading = _ref2.$loading;
  return $loading && "\n    cursor: progress;\n  ";
}, function (_ref3) {
  var uppercase = _ref3.uppercase;
  return uppercase && "\n    text-transform: uppercase;\n  ";
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled && "\n    cursor: not-allowed;\n  ";
}, function (_ref5) {
  var disabled = _ref5.disabled,
      $loading = _ref5.$loading;
  return !disabled && !$loading && "\n      &:active {\n        transform: scale(0.95);\n      }\n    ";
}, function (_ref6) {
  var variant = _ref6.variant,
      size = _ref6.size;
  return getSizeStyles(variant, size);
});
var Button = function Button(_ref7) {
  var children = _ref7.children,
      loading = _ref7.loading,
      onClick = _ref7.onClick,
      rest = _objectWithoutPropertiesLoose$2(_ref7, _excluded$v);

  return /*#__PURE__*/React.createElement(buttonVariants[rest.variant], _extends$2({}, rest, {
    styles: ButtonBaseStyles,
    $loading: loading,
    onClick: loading ? function () {
      return undefined;
    } : onClick
  }), children);
};

var Flex = styled.div.withConfig({
  displayName: "Flex",
  componentId: "sc-29vjs2-0"
})(["", ";display:flex;", " ", ";", ";", ";@media ", "{", ";", ";", ";}@media ", "{", ";", ";", ";}@media ", "{", ";", ";", ";}"], theme.marginsCss, function (_ref) {
  var fullwidth = _ref.fullwidth;
  return fullwidth && "\n    width: 100%;\n  ";
}, function (_ref2) {
  var justifyContent = _ref2.justifyContent;
  return typeof justifyContent === 'string' ? "justify-content: " + justifyContent + ";" : (justifyContent === null || justifyContent === void 0 ? void 0 : justifyContent.mobile) && "justify-content: " + justifyContent.mobile + ";";
}, function (_ref3) {
  var alignItems = _ref3.alignItems;
  return typeof alignItems === 'string' ? "align-items: " + alignItems + ";" : (alignItems === null || alignItems === void 0 ? void 0 : alignItems.mobile) && "align-items: " + alignItems.mobile + ";";
}, function (_ref4) {
  var flexDirection = _ref4.flexDirection;
  return typeof flexDirection === 'string' ? "flex-direction: " + flexDirection + ";" : (flexDirection === null || flexDirection === void 0 ? void 0 : flexDirection.mobile) && "flex-direction: " + flexDirection.mobile + ";";
}, theme.device.tablet, function (_ref5) {
  var flexDirection = _ref5.flexDirection;
  return typeof flexDirection !== 'string' && (flexDirection === null || flexDirection === void 0 ? void 0 : flexDirection.tablet) && "flex-direction: " + flexDirection.tablet + ";";
}, function (_ref6) {
  var justifyContent = _ref6.justifyContent;
  return typeof justifyContent !== 'string' && (justifyContent === null || justifyContent === void 0 ? void 0 : justifyContent.tablet) && "justify-content: " + justifyContent.tablet + ";";
}, function (_ref7) {
  var alignItems = _ref7.alignItems;
  return typeof alignItems !== 'string' && (alignItems === null || alignItems === void 0 ? void 0 : alignItems.tablet) && "align-items: " + alignItems.tablet + ";";
}, theme.device.laptop, function (_ref8) {
  var flexDirection = _ref8.flexDirection;
  return typeof flexDirection !== 'string' && (flexDirection === null || flexDirection === void 0 ? void 0 : flexDirection.laptop) && "flex-direction: " + flexDirection.laptop + ";";
}, function (_ref9) {
  var justifyContent = _ref9.justifyContent;
  return typeof justifyContent !== 'string' && (justifyContent === null || justifyContent === void 0 ? void 0 : justifyContent.laptop) && "justify-content: " + justifyContent.laptop + ";";
}, function (_ref10) {
  var alignItems = _ref10.alignItems;
  return typeof alignItems !== 'string' && (alignItems === null || alignItems === void 0 ? void 0 : alignItems.laptop) && "align-items: " + alignItems.laptop + ";";
}, theme.device.desktop, function (_ref11) {
  var flexDirection = _ref11.flexDirection;
  return typeof flexDirection !== 'string' && (flexDirection === null || flexDirection === void 0 ? void 0 : flexDirection.desktop) && "flex-direction: " + flexDirection.desktop + ";";
}, function (_ref12) {
  var justifyContent = _ref12.justifyContent;
  return typeof justifyContent !== 'string' && (justifyContent === null || justifyContent === void 0 ? void 0 : justifyContent.desktop) && "justify-content: " + justifyContent.desktop + ";";
}, function (_ref13) {
  var alignItems = _ref13.alignItems;
  return typeof alignItems !== 'string' && (alignItems === null || alignItems === void 0 ? void 0 : alignItems.desktop) && "align-items: " + alignItems.desktop + ";";
});

var variants$2 = {
  primary: {
    bgColor: theme.colors.primary,
    bgColorHover: theme.colors.primaryHover
  },
  secondary: {
    bgColor: theme.colors.rAkihabara,
    bgColorHover: theme.colors.rAkihabaraDark
  },
  academy: {
    bgColor: theme.colors.academy,
    bgColorHover: theme.colors.academyHover
  }
};

var _StyledButton$1 = styled("button").withConfig({
  displayName: "AuthButton___StyledButton",
  componentId: "sc-15a2zbo-0"
})(["display:flex;align-items:center;min-width:", ";width:100%;cursor:pointer;background:", ";border:", ";padding:", " ", " ", " ", ";border-radius:", ";box-sizing:border-box;height:", ";color:", ";&:hover{border:", ";color:", ";background:", ";}"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
}, function (p) {
  return p._css5;
}, function (p) {
  return p._css6;
}, function (p) {
  return p._css7;
}, function (p) {
  return p._css8;
}, function (p) {
  return p._css9;
}, function (p) {
  return p._css10;
}, function (p) {
  return p._css11;
}, function (p) {
  return p._css12;
}, function (p) {
  return p._css13;
});

var _StyledFlex$u = styled(Flex).withConfig({
  displayName: "AuthButton___StyledFlex",
  componentId: "sc-15a2zbo-1"
})(["width:100%;"]);

var AuthButton = function AuthButton(props) {
  var _icon$isInColor;

  var icon = props.icon,
      variant = props.variant,
      children = props.children;
  var selectedVariant = variant ? variants$2[variant] : null;
  return /*#__PURE__*/jsxs(_StyledButton$1, _extends$2({}, props, {
    _css: rem(272),
    _css2: selectedVariant ? selectedVariant.bgColor : 'none',
    _css3: selectedVariant ? 'none' : rem(1) + " solid " + theme.colors.rBlack,
    _css4: rem(14),
    _css5: rem(24),
    _css6: rem(14),
    _css7: rem(16),
    _css8: rem(theme.sizes.large),
    _css9: rem(48),
    _css10: selectedVariant ? theme.colors.white : theme.colors.coal,
    _css11: selectedVariant ? 'none' : rem(1) + " solid " + theme.colors.black,
    _css12: selectedVariant ? theme.colors.white : theme.colors.black,
    _css13: selectedVariant ? selectedVariant.bgColorHover : 'none',
    children: [icon && /*#__PURE__*/jsx(Icon, {
      name: icon.name,
      color: (icon === null || icon === void 0 ? void 0 : icon.color) && theme.colors[icon.color],
      isInColor: (_icon$isInColor = icon === null || icon === void 0 ? void 0 : icon.isInColor) != null ? _icon$isInColor : true
    }), /*#__PURE__*/jsx(_StyledFlex$u, {
      justifyContent: "center",
      children: children
    })]
  }));
};

var Text = styled.p.attrs(function (props) {
  return {
    as: props.as || textVariants[props.variant].tag
  };
}).withConfig({
  displayName: "Text",
  componentId: "sc-9m646a-0"
})(["", ";", ";", ";", ";", ";", ";"], function (_ref) {
  var variant = _ref.variant;
  return textCssFactory(textVariants[variant]);
}, function (_ref2) {
  var center = _ref2.center;
  return center && "text-align: center;";
}, function (_ref3) {
  var family = _ref3.family;
  return family && "font-family: " + (family ? family + ' !important' : 'DM');
}, function (_ref4) {
  var $color = _ref4.$color;
  return $color && "color: " + theme.colors[$color];
}, function (_ref5) {
  var uppercase = _ref5.uppercase;
  return uppercase && "text-transform: uppercase;";
}, theme.marginsCss);

var variants$1 = {
  danger: {
    color: theme.colors.danger,
    colorHover: theme.colors.dangerHover
  }
};
var Label$1 = styled(Flex).withConfig({
  displayName: "CheckBox__Label",
  componentId: "sc-12pr7yf-0"
})(["align-items:baseline;cursor:pointer;&:not(:last-child){margin-bottom:", ";}"], rem(16));
var ClickArea$1 = styled(Flex).withConfig({
  displayName: "CheckBox__ClickArea",
  componentId: "sc-12pr7yf-1"
})(["z-index:0;position:relative;"]);
var Box = styled(Flex).withConfig({
  displayName: "CheckBox__Box",
  componentId: "sc-12pr7yf-2"
})(["width:", ";height:", ";border:", ";border-radius:", ";background:", ";padding:", ";&:hover{border:", ";}"], rem(16), rem(16), function (_ref) {
  var variant = _ref.variant;
  return rem(2) + " solid " + (variant ? variants$1[variant].color : theme.colors.coal);
}, rem(2), theme.colors.white, rem(2), function (_ref2) {
  var variant = _ref2.variant;
  return rem(2) + " solid " + (variant ? variants$1[variant].colorHover : undefined);
});
var Background$1 = styled.div.withConfig({
  displayName: "CheckBox__Background",
  componentId: "sc-12pr7yf-3"
})(["position:absolute;top:", ";left:", ";height:", ";width:", ";z-index:-1;border-radius:50%;background:", ";transform:scale(0);transition:transform 0.15s ", ",opacity 0.15s ", ";", ":hover &{transform:scale(1);}", ":active &{transform:scale(0.5);transition:transform 0.1s ", ",opacity 0.1s ", ";}", ""], rem(-8), rem(-8), rem(32), rem(32), theme.colors.rAkihabara10, theme.transitions.easeInOut, theme.transitions.easeInOut,
/*sc-selector*/
ClickArea$1,
/*sc-selector*/
ClickArea$1, theme.transitions.easeInOut, theme.transitions.easeInOut, function (_ref3) {
  var $activeAnimation = _ref3.$activeAnimation;
  return $activeAnimation && 'transform: scale(1)';
});
var CheckMark = styled.div.withConfig({
  displayName: "CheckBox__CheckMark",
  componentId: "sc-12pr7yf-4"
})(["", ""], function (_ref4) {
  var checked = _ref4.checked;
  return checked ? "            \n            width: 100%;\n            height: 100%;\n            transform: scale(1);\n            opacity: 1;\n            background: " + theme.colors.rAkihabara + ";\n            transition: transform .2s " + theme.transitions.easeInOut + ",\n            opacity .2s " + theme.transitions.easeInOut + ",\n            background .15s " + theme.transitions.easeInOut + ";\n            " + ClickArea$1 + ":hover & {\n                background: " + theme.colors.rAkihabara + ";\n            }\n        " : "\n            width: " + rem(8) + ";\n            height: " + rem(8) + ";\n            background: " + theme.colors.rAkihabara + ";\n            transform: scale(0);\n            opacity: 0;\n            transition: transform .2s " + theme.transitions.easeInOut + ",\n                        opacity .2s " + theme.transitions.easeInOut + ";   \n      ";
});

var _StyledInput$1 = styled("input").withConfig({
  displayName: "CheckBox___StyledInput",
  componentId: "sc-12pr7yf-5"
})(["position:absolute;cursor:pointer;opacity:0;height:0;width:0;margin:0;"]);

var CheckBox = function CheckBox(props) {
  var checked = props.checked,
      variant = props.variant,
      handleChange = props.handleChange,
      label = props.label,
      activeAnimation = props.activeAnimation;
  return /*#__PURE__*/jsxs(Label$1, {
    onClick: function onClick() {
      return handleChange(!checked);
    },
    children: [/*#__PURE__*/jsxs(ClickArea$1, {
      children: [/*#__PURE__*/jsx(_StyledInput$1, _extends$2({
        type: "checkbox",
        value: label
      }, props, {
        checked: checked,
        onChange: function onChange() {
          return handleChange(!checked);
        }
      })), /*#__PURE__*/jsxs(Box, {
        variant: variant,
        children: [/*#__PURE__*/jsx(Background$1, {
          $activeAnimation: activeAnimation
        }), /*#__PURE__*/jsx(CheckMark, {
          checked: checked
        })]
      })]
    }), /*#__PURE__*/isValidElement(label) ? label : /*#__PURE__*/jsx(Text, {
      marginLeft: "xmini",
      variant: "paragraphS",
      $color: "coal",
      dangerouslySetInnerHTML: {
        __html: label
      }
    })]
  });
};

var HTMLDOMPropertyConfig = {
  Properties: {
    autoFocus: 4,
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: 4,
    allowTransparency: 0,
    alt: 0,
    as: 0,
    async: 4,
    autoComplete: 0,
    autoPlay: 4,
    capture: 4,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: 5,
    cite: 0,
    classID: 0,
    className: 0,
    cols: 24,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: 4,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0,
    dateTime: 0,
    "default": 4,
    defer: 4,
    dir: 0,
    disabled: 4,
    download: 32,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: 4,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: 4,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: 4,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    multiple: 5,
    muted: 5,
    name: 0,
    nonce: 0,
    noValidate: 4,
    open: 4,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: 4,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: 4,
    referrerPolicy: 0,
    rel: 0,
    required: 4,
    reversed: 4,
    role: 0,
    rows: 24,
    rowSpan: 8,
    sandbox: 0,
    scope: 0,
    scoped: 4,
    scrolling: 0,
    seamless: 4,
    selected: 5,
    shape: 0,
    size: 24,
    sizes: 0,
    span: 24,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: 8,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    property: 0,
    resource: 0,
    "typeof": 0,
    vocab: 0,
    autoCapitalize: 0,
    autoCorrect: 0,
    autoSave: 0,
    color: 0,
    itemProp: 0,
    itemScope: 4,
    itemType: 0,
    itemID: 0,
    itemRef: 0,
    results: 0,
    security: 0,
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  }
};
HTMLDOMPropertyConfig.Properties;
HTMLDOMPropertyConfig.DOMAttributeNames;

var SVGDOMPropertyConfig = {
  Properties: {
    accentHeight: 0,
    accumulate: 0,
    additive: 0,
    alignmentBaseline: 0,
    allowReorder: 0,
    alphabetic: 0,
    amplitude: 0,
    arabicForm: 0,
    ascent: 0,
    attributeName: 0,
    attributeType: 0,
    autoReverse: 0,
    azimuth: 0,
    baseFrequency: 0,
    baseProfile: 0,
    baselineShift: 0,
    bbox: 0,
    begin: 0,
    bias: 0,
    by: 0,
    calcMode: 0,
    capHeight: 0,
    clip: 0,
    clipPath: 0,
    clipRule: 0,
    clipPathUnits: 0,
    colorInterpolation: 0,
    colorInterpolationFilters: 0,
    colorProfile: 0,
    colorRendering: 0,
    contentScriptType: 0,
    contentStyleType: 0,
    cursor: 0,
    cx: 0,
    cy: 0,
    d: 0,
    decelerate: 0,
    descent: 0,
    diffuseConstant: 0,
    direction: 0,
    display: 0,
    divisor: 0,
    dominantBaseline: 0,
    dur: 0,
    dx: 0,
    dy: 0,
    edgeMode: 0,
    elevation: 0,
    enableBackground: 0,
    end: 0,
    exponent: 0,
    externalResourcesRequired: 0,
    fill: 0,
    fillOpacity: 0,
    fillRule: 0,
    filter: 0,
    filterRes: 0,
    filterUnits: 0,
    floodColor: 0,
    floodOpacity: 0,
    focusable: 0,
    fontFamily: 0,
    fontSize: 0,
    fontSizeAdjust: 0,
    fontStretch: 0,
    fontStyle: 0,
    fontVariant: 0,
    fontWeight: 0,
    format: 0,
    from: 0,
    fx: 0,
    fy: 0,
    g1: 0,
    g2: 0,
    glyphName: 0,
    glyphOrientationHorizontal: 0,
    glyphOrientationVertical: 0,
    glyphRef: 0,
    gradientTransform: 0,
    gradientUnits: 0,
    hanging: 0,
    horizAdvX: 0,
    horizOriginX: 0,
    ideographic: 0,
    imageRendering: 0,
    "in": 0,
    in2: 0,
    intercept: 0,
    k: 0,
    k1: 0,
    k2: 0,
    k3: 0,
    k4: 0,
    kernelMatrix: 0,
    kernelUnitLength: 0,
    kerning: 0,
    keyPoints: 0,
    keySplines: 0,
    keyTimes: 0,
    lengthAdjust: 0,
    letterSpacing: 0,
    lightingColor: 0,
    limitingConeAngle: 0,
    local: 0,
    markerEnd: 0,
    markerMid: 0,
    markerStart: 0,
    markerHeight: 0,
    markerUnits: 0,
    markerWidth: 0,
    mask: 0,
    maskContentUnits: 0,
    maskUnits: 0,
    mathematical: 0,
    mode: 0,
    numOctaves: 0,
    offset: 0,
    opacity: 0,
    operator: 0,
    order: 0,
    orient: 0,
    orientation: 0,
    origin: 0,
    overflow: 0,
    overlinePosition: 0,
    overlineThickness: 0,
    paintOrder: 0,
    panose1: 0,
    pathLength: 0,
    patternContentUnits: 0,
    patternTransform: 0,
    patternUnits: 0,
    pointerEvents: 0,
    points: 0,
    pointsAtX: 0,
    pointsAtY: 0,
    pointsAtZ: 0,
    preserveAlpha: 0,
    preserveAspectRatio: 0,
    primitiveUnits: 0,
    r: 0,
    radius: 0,
    refX: 0,
    refY: 0,
    renderingIntent: 0,
    repeatCount: 0,
    repeatDur: 0,
    requiredExtensions: 0,
    requiredFeatures: 0,
    restart: 0,
    result: 0,
    rotate: 0,
    rx: 0,
    ry: 0,
    scale: 0,
    seed: 0,
    shapeRendering: 0,
    slope: 0,
    spacing: 0,
    specularConstant: 0,
    specularExponent: 0,
    speed: 0,
    spreadMethod: 0,
    startOffset: 0,
    stdDeviation: 0,
    stemh: 0,
    stemv: 0,
    stitchTiles: 0,
    stopColor: 0,
    stopOpacity: 0,
    strikethroughPosition: 0,
    strikethroughThickness: 0,
    string: 0,
    stroke: 0,
    strokeDasharray: 0,
    strokeDashoffset: 0,
    strokeLinecap: 0,
    strokeLinejoin: 0,
    strokeMiterlimit: 0,
    strokeOpacity: 0,
    strokeWidth: 0,
    surfaceScale: 0,
    systemLanguage: 0,
    tableValues: 0,
    targetX: 0,
    targetY: 0,
    textAnchor: 0,
    textDecoration: 0,
    textRendering: 0,
    textLength: 0,
    to: 0,
    transform: 0,
    u1: 0,
    u2: 0,
    underlinePosition: 0,
    underlineThickness: 0,
    unicode: 0,
    unicodeBidi: 0,
    unicodeRange: 0,
    unitsPerEm: 0,
    vAlphabetic: 0,
    vHanging: 0,
    vIdeographic: 0,
    vMathematical: 0,
    values: 0,
    vectorEffect: 0,
    version: 0,
    vertAdvY: 0,
    vertOriginX: 0,
    vertOriginY: 0,
    viewBox: 0,
    viewTarget: 0,
    visibility: 0,
    widths: 0,
    wordSpacing: 0,
    writingMode: 0,
    x: 0,
    xHeight: 0,
    x1: 0,
    x2: 0,
    xChannelSelector: 0,
    xlinkActuate: 0,
    xlinkArcrole: 0,
    xlinkHref: 0,
    xlinkRole: 0,
    xlinkShow: 0,
    xlinkTitle: 0,
    xlinkType: 0,
    xmlBase: 0,
    xmlns: 0,
    xmlnsXlink: 0,
    xmlLang: 0,
    xmlSpace: 0,
    y: 0,
    y1: 0,
    y2: 0,
    yChannelSelector: 0,
    z: 0,
    zoomAndPan: 0
  },
  DOMAttributeNames: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDasharray: 'stroke-dasharray',
    strokeDashoffset: 'stroke-dashoffset',
    strokeLinecap: 'stroke-linecap',
    strokeLinejoin: 'stroke-linejoin',
    strokeMiterlimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    xlinkActuate: 'xlink:actuate',
    xlinkArcrole: 'xlink:arcrole',
    xlinkHref: 'xlink:href',
    xlinkRole: 'xlink:role',
    xlinkShow: 'xlink:show',
    xlinkTitle: 'xlink:title',
    xlinkType: 'xlink:type',
    xmlBase: 'xml:base',
    xmlnsXlink: 'xmlns:xlink',
    xmlLang: 'xml:lang',
    xmlSpace: 'xml:space'
  }
};
SVGDOMPropertyConfig.Properties;
SVGDOMPropertyConfig.DOMAttributeNames;

var injection = {
  MUST_USE_PROPERTY: 1,
  HAS_BOOLEAN_VALUE: 4,
  HAS_NUMERIC_VALUE: 8,
  HAS_POSITIVE_NUMERIC_VALUE: 24,
  HAS_OVERLOADED_BOOLEAN_VALUE: 32
};

var MUST_USE_PROPERTY = injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = injection.HAS_OVERLOADED_BOOLEAN_VALUE;
/**
 * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/DOMProperty.js#L14-L16
 *
 * @param  {Number}  value
 * @param  {Number}  bitmask
 * @return {Boolean}
 */

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}
/**
 * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/DOMProperty.js#L57
 *
 * @param {Object}  domPropertyConfig - HTMLDOMPropertyConfig or SVGDOMPropertyConfig
 * @param {Object}  config            - The object to be mutated
 * @param {Boolean} isSVG             - Whether the injected config is HTML or SVG (it assumes the default is HTML)
 */


function injectDOMPropertyConfig(domPropertyConfig, config, isSVG) {
  var Properties = domPropertyConfig.Properties;
  var DOMAttributeNames = domPropertyConfig.DOMAttributeNames;
  var attributeName;
  var propertyName;
  var propConfig;

  for (propertyName in Properties) {
    attributeName = DOMAttributeNames[propertyName] || (isSVG ? propertyName : propertyName.toLowerCase());
    propConfig = Properties[propertyName];
    config[attributeName] = {
      attributeName: attributeName,
      propertyName: propertyName,
      mustUseProperty: checkMask(propConfig, MUST_USE_PROPERTY),
      hasBooleanValue: checkMask(propConfig, HAS_BOOLEAN_VALUE),
      hasNumericValue: checkMask(propConfig, HAS_NUMERIC_VALUE),
      hasPositiveNumericValue: checkMask(propConfig, HAS_POSITIVE_NUMERIC_VALUE),
      hasOverloadedBooleanValue: checkMask(propConfig, HAS_OVERLOADED_BOOLEAN_VALUE)
    };
  }
}
/**
 * HTML properties config.
 *
 * @type {Object}
 */


var html = {};
injectDOMPropertyConfig(HTMLDOMPropertyConfig, html);
/**
 * SVG properties config.
 *
 * @type {Object}
 */

var svg = {};
injectDOMPropertyConfig(SVGDOMPropertyConfig, svg, true);
/**
 * HTML and SVG properties config.
 *
 * @type {Object}
 */

var properties = {};
injectDOMPropertyConfig(HTMLDOMPropertyConfig, properties);
injectDOMPropertyConfig(SVGDOMPropertyConfig, properties, true);
var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
var reactProperty = {
  html: html,
  svg: svg,
  properties: properties,

  /**
   * Checks whether a property name is a custom attribute.
   *
   * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25
   *
   * @param {String}
   * @return {Boolean}
   */
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'))
};

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/; // declaration

var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/; // https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill

var TRIM_REGEX = /^\s+|\s+$/g; // strings

var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = ''; // types

var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */

var inlineStyleParser = function inlineStyleParser(style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!style) return [];
  options = options || {};
  /**
   * Positional.
   */

  var lineno = 1;
  var column = 1;
  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */

  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }
  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */


  function position() {
    var start = {
      line: lineno,
      column: column
    };
    return function (node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }
  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */


  function Position(start) {
    this.start = start;
    this.end = {
      line: lineno,
      column: column
    };
    this.source = options.source;
  }
  /**
   * Non-enumerable source string.
   */


  Position.prototype.content = style;
  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */

  function error(msg) {
    var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;

    if (options.silent) ; else {
      throw err;
    }
  }
  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */


  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }
  /**
   * Parse whitespace.
   */


  function whitespace() {
    match(WHITESPACE_REGEX);
  }
  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */


  function comments(rules) {
    var c;
    rules = rules || [];

    while (c = comment()) {
      if (c !== false) {
        rules.push(c);
      }
    }

    return rules;
  }
  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */


  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;
    var i = 2;

    while (EMPTY_STRING != style.charAt(i) && (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))) {
      ++i;
    }

    i += 2;

    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }

    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;
    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }
  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */


  function declaration() {
    var pos = position(); // prop

    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment(); // :

    if (!match(COLON_REGEX)) return error("property missing ':'"); // val

    var val = match(VALUE_REGEX);
    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING)) : EMPTY_STRING
    }); // ;

    match(SEMICOLON_REGEX);
    return ret;
  }
  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */


  function declarations() {
    var decls = [];
    comments(decls); // declarations

    var decl;

    while (decl = declaration()) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    return decls;
  }

  whitespace();
  return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */


function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}

/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */

function StyleToObject(style, iterator) {
  var output = null;

  if (!style || typeof style !== 'string') {
    return output;
  }

  var declaration;
  var declarations = inlineStyleParser(style);
  var hasIterator = typeof iterator === 'function';
  var property;
  var value;

  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;

    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }

  return output;
}

var styleToObject = StyleToObject;

var utilities$2 = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;
  exports.camelCase = void 0;
  var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;
  var HYPHEN_REGEX = /-([a-z])/g;
  var NO_HYPHEN_REGEX = /^[^-]+$/;
  var VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;

  var skipCamelCase = function skipCamelCase(property) {
    return !property || NO_HYPHEN_REGEX.test(property) || CUSTOM_PROPERTY_REGEX.test(property);
  };

  var capitalize = function capitalize(match, character) {
    return character.toUpperCase();
  };

  var trimHyphen = function trimHyphen(match, prefix) {
    return prefix + "-";
  };

  var camelCase = function camelCase(property, options) {
    if (options === void 0) {
      options = {};
    }

    if (skipCamelCase(property)) {
      return property;
    }

    property = property.toLowerCase();

    if (!options.reactCompat) {
      property = property.replace(VENDOR_PREFIX_REGEX, trimHyphen);
    }

    return property.replace(HYPHEN_REGEX, capitalize);
  };

  exports.camelCase = camelCase;
});
unwrapExports(utilities$2);
utilities$2.camelCase;

var cjs = createCommonjsModule(function (module, exports) {

  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  exports.__esModule = true;

  var style_to_object_1 = __importDefault(styleToObject);

  function StyleToJS(style, options) {
    var output = {};

    if (!style || typeof style !== 'string') {
      return output;
    }

    style_to_object_1["default"](style, function (property, value) {
      if (property && value) {
        output[utilities$2.camelCase(property, options)] = value;
      }
    });
    return output;
  }

  exports["default"] = StyleToJS;
});
unwrapExports(cjs);

var styleToJS = cjs["default"];
/**
 * Swap key with value in an object.
 *
 * @param  {Object}   obj        - The object.
 * @param  {Function} [override] - The override method.
 * @return {Object}              - The inverted object.
 */

function invertObject(obj, override) {
  if (!obj || typeof obj !== 'object') {
    throw new TypeError('First argument must be an object');
  }

  var key;
  var value;
  var isOverridePresent = typeof override === 'function';
  var overrides = {};
  var result = {};

  for (key in obj) {
    value = obj[key];

    if (isOverridePresent) {
      overrides = override(key, value);

      if (overrides && overrides.length === 2) {
        result[overrides[0]] = overrides[1];
        continue;
      }
    }

    if (typeof value === 'string') {
      result[value] = key;
    }
  }

  return result;
}
/**
 * Check if a given tag is a custom component.
 *
 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
 *
 * @param {string} tagName - The name of the html tag.
 * @param {Object} props   - The props being passed to the element.
 * @return {boolean}
 */


function isCustomComponent(tagName, props) {
  if (tagName.indexOf('-') === -1) {
    return props && typeof props.is === 'string';
  }

  switch (tagName) {
    // These are reserved SVG and MathML elements.
    // We don't mind this whitelist too much because we expect it to never grow.
    // The alternative is to track the namespace in a few places which is convoluted.
    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
    case 'annotation-xml':
    case 'color-profile':
    case 'font-face':
    case 'font-face-src':
    case 'font-face-uri':
    case 'font-face-format':
    case 'font-face-name':
    case 'missing-glyph':
      return false;

    default:
      return true;
  }
}

var styleToJSOptions = {
  reactCompat: true
};
/**
 * Sets style prop.
 *
 * @param {null|undefined|string} style
 * @param {object} props
 */

function setStyleProp$2(style, props) {
  if (style === null || style === undefined) {
    return;
  }

  props.style = styleToJS(style, styleToJSOptions);
}
/**
 * @constant {boolean}
 * @see {@link https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html}
 */


var PRESERVE_CUSTOM_ATTRIBUTES = React.version.split('.')[0] >= 16;
var utilities$1 = {
  PRESERVE_CUSTOM_ATTRIBUTES: PRESERVE_CUSTOM_ATTRIBUTES,
  invertObject: invertObject,
  isCustomComponent: isCustomComponent,
  setStyleProp: setStyleProp$2
};

var setStyleProp$1 = utilities$1.setStyleProp;
var htmlProperties = reactProperty.html;
var svgProperties = reactProperty.svg;
var isCustomAttribute = reactProperty.isCustomAttribute;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
/**
 * Converts HTML/SVG DOM attributes to React props.
 *
 * @param  {object} [attributes={}] - HTML/SVG DOM attributes.
 * @return {object}                 - React props.
 */

function attributesToProps$1(attributes) {
  attributes = attributes || {};
  var attributeName;
  var attributeNameLowerCased;
  var attributeValue;
  var property;
  var props = {};

  for (attributeName in attributes) {
    attributeValue = attributes[attributeName]; // ARIA (aria-*) or custom data (data-*) attribute

    if (isCustomAttribute(attributeName)) {
      props[attributeName] = attributeValue;
      continue;
    } // convert HTML attribute to React prop


    attributeNameLowerCased = attributeName.toLowerCase();

    if (hasOwnProperty$1.call(htmlProperties, attributeNameLowerCased)) {
      property = htmlProperties[attributeNameLowerCased];
      props[property.propertyName] = property.hasBooleanValue || property.hasOverloadedBooleanValue && !attributeValue ? true : attributeValue;
      continue;
    } // convert SVG attribute to React prop


    if (hasOwnProperty$1.call(svgProperties, attributeName)) {
      property = svgProperties[attributeName];
      props[property.propertyName] = attributeValue;
      continue;
    } // preserve custom attribute if React >=16


    if (utilities$1.PRESERVE_CUSTOM_ATTRIBUTES) {
      props[attributeName] = attributeValue;
    }
  } // transform inline style to object


  setStyleProp$1(attributes.style, props);
  return props;
}

var attributesToProps_1 = attributesToProps$1;

var setStyleProp = utilities$1.setStyleProp;
/**
 * Converts DOM nodes to JSX element(s).
 *
 * @param  {DomElement[]} nodes             - DOM nodes.
 * @param  {object}       [options={}]      - Options.
 * @param  {Function}     [options.replace] - Replacer.
 * @param  {object}       [options.library] - Library (React/Preact/etc.).
 * @return {string|JSX.Element|JSX.Element[]}
 */

function domToReact$1(nodes, options) {
  options = options || {};
  var library = options.library || React;
  var cloneElement = library.cloneElement;
  var createElement = library.createElement;
  var isValidElement = library.isValidElement;
  var result = [];
  var node;
  var hasReplace = typeof options.replace === 'function';
  var replaceElement;
  var props;
  var children;
  var data;
  var trim = options.trim;

  for (var i = 0, len = nodes.length; i < len; i++) {
    node = nodes[i]; // replace with custom React element (if present)

    if (hasReplace) {
      replaceElement = options.replace(node);

      if (isValidElement(replaceElement)) {
        // set "key" prop for sibling elements
        // https://fb.me/react-warning-keys
        if (len > 1) {
          replaceElement = cloneElement(replaceElement, {
            key: replaceElement.key || i
          });
        }

        result.push(replaceElement);
        continue;
      }
    }

    if (node.type === 'text') {
      // if trim option is enabled, skip whitespace text nodes
      if (trim) {
        data = node.data.trim();

        if (data) {
          result.push(node.data);
        }
      } else {
        result.push(node.data);
      }

      continue;
    }

    props = node.attribs;

    if (skipAttributesToProps(node)) {
      setStyleProp(props.style, props);
    } else if (props) {
      props = attributesToProps_1(props);
    }

    children = null;

    switch (node.type) {
      case 'script':
      case 'style':
        // prevent text in <script> or <style> from being escaped
        // https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
        if (node.children[0]) {
          props.dangerouslySetInnerHTML = {
            __html: node.children[0].data
          };
        }

        break;

      case 'tag':
        // setting textarea value in children is an antipattern in React
        // https://reactjs.org/docs/forms.html#the-textarea-tag
        if (node.name === 'textarea' && node.children[0]) {
          props.defaultValue = node.children[0].data;
        } else if (node.children && node.children.length) {
          // continue recursion of creating React elements (if applicable)
          children = domToReact$1(node.children, options);
        }

        break;
      // skip all other cases (e.g., comment)

      default:
        continue;
    } // set "key" prop for sibling elements
    // https://fb.me/react-warning-keys


    if (len > 1) {
      props.key = i;
    }

    result.push(createElement(node.name, props, children));
  }

  return result.length === 1 ? result[0] : result;
}
/**
 * Determines whether DOM element attributes should be transformed to props.
 * Web Components should not have their attributes transformed except for `style`.
 *
 * @param  {DomElement} node
 * @return {boolean}
 */


function skipAttributesToProps(node) {
  return utilities$1.PRESERVE_CUSTOM_ATTRIBUTES && node.type === 'tag' && utilities$1.isCustomComponent(node.name, node.attribs);
}

var domToReact_1 = domToReact$1;

var decode = {
	"0": 65533,
	"128": 8364,
	"130": 8218,
	"131": 402,
	"132": 8222,
	"133": 8230,
	"134": 8224,
	"135": 8225,
	"136": 710,
	"137": 8240,
	"138": 352,
	"139": 8249,
	"140": 338,
	"142": 381,
	"145": 8216,
	"146": 8217,
	"147": 8220,
	"148": 8221,
	"149": 8226,
	"150": 8211,
	"151": 8212,
	"152": 732,
	"153": 8482,
	"154": 353,
	"155": 8250,
	"156": 339,
	"158": 382,
	"159": 376
};

var decode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': decode
});

var require$$0 = getCjsExportFromNamespace(decode$1);

var decode_codepoint = createCommonjsModule(function (module, exports) {

  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var decode_json_1 = __importDefault(require$$0); // Adapted from https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119


  var fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.fromCodePoint || function (codePoint) {
    var output = "";

    if (codePoint > 0xffff) {
      codePoint -= 0x10000;
      output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
      codePoint = 0xdc00 | codePoint & 0x3ff;
    }

    output += String.fromCharCode(codePoint);
    return output;
  };

  function decodeCodePoint(codePoint) {
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) {
      return "\uFFFD";
    }

    if (codePoint in decode_json_1["default"]) {
      codePoint = decode_json_1["default"][codePoint];
    }

    return fromCodePoint(codePoint);
  }

  exports["default"] = decodeCodePoint;
});
unwrapExports(decode_codepoint);

var Aacute$1 = "Á";
var aacute$1 = "á";
var Abreve = "Ă";
var abreve = "ă";
var ac = "∾";
var acd = "∿";
var acE = "∾̳";
var Acirc$1 = "Â";
var acirc$1 = "â";
var acute$1 = "´";
var Acy = "А";
var acy = "а";
var AElig$1 = "Æ";
var aelig$1 = "æ";
var af = "⁡";
var Afr = "𝔄";
var afr = "𝔞";
var Agrave$1 = "À";
var agrave$1 = "à";
var alefsym = "ℵ";
var aleph = "ℵ";
var Alpha = "Α";
var alpha = "α";
var Amacr = "Ā";
var amacr = "ā";
var amalg = "⨿";
var amp$2 = "&";
var AMP$1 = "&";
var andand = "⩕";
var And = "⩓";
var and = "∧";
var andd = "⩜";
var andslope = "⩘";
var andv = "⩚";
var ang = "∠";
var ange = "⦤";
var angle = "∠";
var angmsdaa = "⦨";
var angmsdab = "⦩";
var angmsdac = "⦪";
var angmsdad = "⦫";
var angmsdae = "⦬";
var angmsdaf = "⦭";
var angmsdag = "⦮";
var angmsdah = "⦯";
var angmsd = "∡";
var angrt = "∟";
var angrtvb = "⊾";
var angrtvbd = "⦝";
var angsph = "∢";
var angst = "Å";
var angzarr = "⍼";
var Aogon = "Ą";
var aogon = "ą";
var Aopf = "𝔸";
var aopf = "𝕒";
var apacir = "⩯";
var ap = "≈";
var apE = "⩰";
var ape = "≊";
var apid = "≋";
var apos$1 = "'";
var ApplyFunction = "⁡";
var approx = "≈";
var approxeq = "≊";
var Aring$1 = "Å";
var aring$1 = "å";
var Ascr = "𝒜";
var ascr = "𝒶";
var Assign = "≔";
var ast = "*";
var asymp = "≈";
var asympeq = "≍";
var Atilde$1 = "Ã";
var atilde$1 = "ã";
var Auml$1 = "Ä";
var auml$1 = "ä";
var awconint = "∳";
var awint = "⨑";
var backcong = "≌";
var backepsilon = "϶";
var backprime = "‵";
var backsim = "∽";
var backsimeq = "⋍";
var Backslash = "∖";
var Barv = "⫧";
var barvee = "⊽";
var barwed = "⌅";
var Barwed = "⌆";
var barwedge = "⌅";
var bbrk = "⎵";
var bbrktbrk = "⎶";
var bcong = "≌";
var Bcy = "Б";
var bcy = "б";
var bdquo = "„";
var becaus = "∵";
var because = "∵";
var Because = "∵";
var bemptyv = "⦰";
var bepsi = "϶";
var bernou = "ℬ";
var Bernoullis = "ℬ";
var Beta = "Β";
var beta = "β";
var beth = "ℶ";
var between = "≬";
var Bfr = "𝔅";
var bfr = "𝔟";
var bigcap = "⋂";
var bigcirc = "◯";
var bigcup = "⋃";
var bigodot = "⨀";
var bigoplus = "⨁";
var bigotimes = "⨂";
var bigsqcup = "⨆";
var bigstar = "★";
var bigtriangledown = "▽";
var bigtriangleup = "△";
var biguplus = "⨄";
var bigvee = "⋁";
var bigwedge = "⋀";
var bkarow = "⤍";
var blacklozenge = "⧫";
var blacksquare = "▪";
var blacktriangle = "▴";
var blacktriangledown = "▾";
var blacktriangleleft = "◂";
var blacktriangleright = "▸";
var blank = "␣";
var blk12 = "▒";
var blk14 = "░";
var blk34 = "▓";
var block = "█";
var bne = "=⃥";
var bnequiv = "≡⃥";
var bNot = "⫭";
var bnot = "⌐";
var Bopf = "𝔹";
var bopf = "𝕓";
var bot = "⊥";
var bottom = "⊥";
var bowtie = "⋈";
var boxbox = "⧉";
var boxdl = "┐";
var boxdL = "╕";
var boxDl = "╖";
var boxDL = "╗";
var boxdr = "┌";
var boxdR = "╒";
var boxDr = "╓";
var boxDR = "╔";
var boxh = "─";
var boxH = "═";
var boxhd = "┬";
var boxHd = "╤";
var boxhD = "╥";
var boxHD = "╦";
var boxhu = "┴";
var boxHu = "╧";
var boxhU = "╨";
var boxHU = "╩";
var boxminus = "⊟";
var boxplus = "⊞";
var boxtimes = "⊠";
var boxul = "┘";
var boxuL = "╛";
var boxUl = "╜";
var boxUL = "╝";
var boxur = "└";
var boxuR = "╘";
var boxUr = "╙";
var boxUR = "╚";
var boxv = "│";
var boxV = "║";
var boxvh = "┼";
var boxvH = "╪";
var boxVh = "╫";
var boxVH = "╬";
var boxvl = "┤";
var boxvL = "╡";
var boxVl = "╢";
var boxVL = "╣";
var boxvr = "├";
var boxvR = "╞";
var boxVr = "╟";
var boxVR = "╠";
var bprime = "‵";
var breve = "˘";
var Breve = "˘";
var brvbar$1 = "¦";
var bscr = "𝒷";
var Bscr = "ℬ";
var bsemi = "⁏";
var bsim = "∽";
var bsime = "⋍";
var bsolb = "⧅";
var bsol = "\\";
var bsolhsub = "⟈";
var bull = "•";
var bullet = "•";
var bump = "≎";
var bumpE = "⪮";
var bumpe = "≏";
var Bumpeq = "≎";
var bumpeq = "≏";
var Cacute = "Ć";
var cacute = "ć";
var capand = "⩄";
var capbrcup = "⩉";
var capcap = "⩋";
var cap = "∩";
var Cap = "⋒";
var capcup = "⩇";
var capdot = "⩀";
var CapitalDifferentialD = "ⅅ";
var caps = "∩︀";
var caret = "⁁";
var caron = "ˇ";
var Cayleys = "ℭ";
var ccaps = "⩍";
var Ccaron = "Č";
var ccaron = "č";
var Ccedil$1 = "Ç";
var ccedil$1 = "ç";
var Ccirc = "Ĉ";
var ccirc = "ĉ";
var Cconint = "∰";
var ccups = "⩌";
var ccupssm = "⩐";
var Cdot = "Ċ";
var cdot = "ċ";
var cedil$1 = "¸";
var Cedilla = "¸";
var cemptyv = "⦲";
var cent$1 = "¢";
var centerdot = "·";
var CenterDot = "·";
var cfr = "𝔠";
var Cfr = "ℭ";
var CHcy = "Ч";
var chcy = "ч";
var check = "✓";
var checkmark = "✓";
var Chi = "Χ";
var chi = "χ";
var circ = "ˆ";
var circeq = "≗";
var circlearrowleft = "↺";
var circlearrowright = "↻";
var circledast = "⊛";
var circledcirc = "⊚";
var circleddash = "⊝";
var CircleDot = "⊙";
var circledR = "®";
var circledS = "Ⓢ";
var CircleMinus = "⊖";
var CirclePlus = "⊕";
var CircleTimes = "⊗";
var cir = "○";
var cirE = "⧃";
var cire = "≗";
var cirfnint = "⨐";
var cirmid = "⫯";
var cirscir = "⧂";
var ClockwiseContourIntegral = "∲";
var CloseCurlyDoubleQuote = "”";
var CloseCurlyQuote = "’";
var clubs = "♣";
var clubsuit = "♣";
var colon = ":";
var Colon = "∷";
var Colone = "⩴";
var colone = "≔";
var coloneq = "≔";
var comma = ",";
var commat = "@";
var comp = "∁";
var compfn = "∘";
var complement = "∁";
var complexes = "ℂ";
var cong = "≅";
var congdot = "⩭";
var Congruent = "≡";
var conint = "∮";
var Conint = "∯";
var ContourIntegral = "∮";
var copf = "𝕔";
var Copf = "ℂ";
var coprod = "∐";
var Coproduct = "∐";
var copy$1 = "©";
var COPY$1 = "©";
var copysr = "℗";
var CounterClockwiseContourIntegral = "∳";
var crarr = "↵";
var cross = "✗";
var Cross = "⨯";
var Cscr = "𝒞";
var cscr = "𝒸";
var csub = "⫏";
var csube = "⫑";
var csup = "⫐";
var csupe = "⫒";
var ctdot = "⋯";
var cudarrl = "⤸";
var cudarrr = "⤵";
var cuepr = "⋞";
var cuesc = "⋟";
var cularr = "↶";
var cularrp = "⤽";
var cupbrcap = "⩈";
var cupcap = "⩆";
var CupCap = "≍";
var cup = "∪";
var Cup = "⋓";
var cupcup = "⩊";
var cupdot = "⊍";
var cupor = "⩅";
var cups = "∪︀";
var curarr = "↷";
var curarrm = "⤼";
var curlyeqprec = "⋞";
var curlyeqsucc = "⋟";
var curlyvee = "⋎";
var curlywedge = "⋏";
var curren$1 = "¤";
var curvearrowleft = "↶";
var curvearrowright = "↷";
var cuvee = "⋎";
var cuwed = "⋏";
var cwconint = "∲";
var cwint = "∱";
var cylcty = "⌭";
var dagger = "†";
var Dagger = "‡";
var daleth = "ℸ";
var darr = "↓";
var Darr = "↡";
var dArr = "⇓";
var dash = "‐";
var Dashv = "⫤";
var dashv = "⊣";
var dbkarow = "⤏";
var dblac = "˝";
var Dcaron = "Ď";
var dcaron = "ď";
var Dcy = "Д";
var dcy = "д";
var ddagger = "‡";
var ddarr = "⇊";
var DD = "ⅅ";
var dd = "ⅆ";
var DDotrahd = "⤑";
var ddotseq = "⩷";
var deg$1 = "°";
var Del = "∇";
var Delta = "Δ";
var delta = "δ";
var demptyv = "⦱";
var dfisht = "⥿";
var Dfr = "𝔇";
var dfr = "𝔡";
var dHar = "⥥";
var dharl = "⇃";
var dharr = "⇂";
var DiacriticalAcute = "´";
var DiacriticalDot = "˙";
var DiacriticalDoubleAcute = "˝";
var DiacriticalGrave = "`";
var DiacriticalTilde = "˜";
var diam = "⋄";
var diamond = "⋄";
var Diamond = "⋄";
var diamondsuit = "♦";
var diams = "♦";
var die = "¨";
var DifferentialD = "ⅆ";
var digamma = "ϝ";
var disin = "⋲";
var div = "÷";
var divide$1 = "÷";
var divideontimes = "⋇";
var divonx = "⋇";
var DJcy = "Ђ";
var djcy = "ђ";
var dlcorn = "⌞";
var dlcrop = "⌍";
var dollar = "$";
var Dopf = "𝔻";
var dopf = "𝕕";
var Dot$1 = "¨";
var dot = "˙";
var DotDot = "⃜";
var doteq = "≐";
var doteqdot = "≑";
var DotEqual = "≐";
var dotminus = "∸";
var dotplus = "∔";
var dotsquare = "⊡";
var doublebarwedge = "⌆";
var DoubleContourIntegral = "∯";
var DoubleDot = "¨";
var DoubleDownArrow = "⇓";
var DoubleLeftArrow = "⇐";
var DoubleLeftRightArrow = "⇔";
var DoubleLeftTee = "⫤";
var DoubleLongLeftArrow = "⟸";
var DoubleLongLeftRightArrow = "⟺";
var DoubleLongRightArrow = "⟹";
var DoubleRightArrow = "⇒";
var DoubleRightTee = "⊨";
var DoubleUpArrow = "⇑";
var DoubleUpDownArrow = "⇕";
var DoubleVerticalBar = "∥";
var DownArrowBar = "⤓";
var downarrow = "↓";
var DownArrow = "↓";
var Downarrow = "⇓";
var DownArrowUpArrow = "⇵";
var DownBreve = "̑";
var downdownarrows = "⇊";
var downharpoonleft = "⇃";
var downharpoonright = "⇂";
var DownLeftRightVector = "⥐";
var DownLeftTeeVector = "⥞";
var DownLeftVectorBar = "⥖";
var DownLeftVector = "↽";
var DownRightTeeVector = "⥟";
var DownRightVectorBar = "⥗";
var DownRightVector = "⇁";
var DownTeeArrow = "↧";
var DownTee = "⊤";
var drbkarow = "⤐";
var drcorn = "⌟";
var drcrop = "⌌";
var Dscr = "𝒟";
var dscr = "𝒹";
var DScy = "Ѕ";
var dscy = "ѕ";
var dsol = "⧶";
var Dstrok = "Đ";
var dstrok = "đ";
var dtdot = "⋱";
var dtri = "▿";
var dtrif = "▾";
var duarr = "⇵";
var duhar = "⥯";
var dwangle = "⦦";
var DZcy = "Џ";
var dzcy = "џ";
var dzigrarr = "⟿";
var Eacute$1 = "É";
var eacute$1 = "é";
var easter = "⩮";
var Ecaron = "Ě";
var ecaron = "ě";
var Ecirc$1 = "Ê";
var ecirc$1 = "ê";
var ecir = "≖";
var ecolon = "≕";
var Ecy = "Э";
var ecy = "э";
var eDDot = "⩷";
var Edot = "Ė";
var edot = "ė";
var eDot = "≑";
var ee = "ⅇ";
var efDot = "≒";
var Efr = "𝔈";
var efr = "𝔢";
var eg = "⪚";
var Egrave$1 = "È";
var egrave$1 = "è";
var egs = "⪖";
var egsdot = "⪘";
var el = "⪙";
var Element$2 = "∈";
var elinters = "⏧";
var ell = "ℓ";
var els = "⪕";
var elsdot = "⪗";
var Emacr = "Ē";
var emacr = "ē";
var empty = "∅";
var emptyset = "∅";
var EmptySmallSquare = "◻";
var emptyv = "∅";
var EmptyVerySmallSquare = "▫";
var emsp13 = " ";
var emsp14 = " ";
var emsp = " ";
var ENG = "Ŋ";
var eng = "ŋ";
var ensp = " ";
var Eogon = "Ę";
var eogon = "ę";
var Eopf = "𝔼";
var eopf = "𝕖";
var epar = "⋕";
var eparsl = "⧣";
var eplus = "⩱";
var epsi = "ε";
var Epsilon = "Ε";
var epsilon = "ε";
var epsiv = "ϵ";
var eqcirc = "≖";
var eqcolon = "≕";
var eqsim = "≂";
var eqslantgtr = "⪖";
var eqslantless = "⪕";
var Equal = "⩵";
var equals = "=";
var EqualTilde = "≂";
var equest = "≟";
var Equilibrium = "⇌";
var equiv = "≡";
var equivDD = "⩸";
var eqvparsl = "⧥";
var erarr = "⥱";
var erDot = "≓";
var escr = "ℯ";
var Escr = "ℰ";
var esdot = "≐";
var Esim = "⩳";
var esim = "≂";
var Eta = "Η";
var eta = "η";
var ETH$1 = "Ð";
var eth$1 = "ð";
var Euml$1 = "Ë";
var euml$1 = "ë";
var euro = "€";
var excl = "!";
var exist$1 = "∃";
var Exists = "∃";
var expectation = "ℰ";
var exponentiale = "ⅇ";
var ExponentialE = "ⅇ";
var fallingdotseq = "≒";
var Fcy = "Ф";
var fcy = "ф";
var female = "♀";
var ffilig = "ﬃ";
var fflig = "ﬀ";
var ffllig = "ﬄ";
var Ffr = "𝔉";
var ffr = "𝔣";
var filig = "ﬁ";
var FilledSmallSquare = "◼";
var FilledVerySmallSquare = "▪";
var fjlig = "fj";
var flat = "♭";
var fllig = "ﬂ";
var fltns = "▱";
var fnof = "ƒ";
var Fopf = "𝔽";
var fopf = "𝕗";
var forall = "∀";
var ForAll = "∀";
var fork = "⋔";
var forkv = "⫙";
var Fouriertrf = "ℱ";
var fpartint = "⨍";
var frac12$1 = "½";
var frac13 = "⅓";
var frac14$1 = "¼";
var frac15 = "⅕";
var frac16 = "⅙";
var frac18 = "⅛";
var frac23 = "⅔";
var frac25 = "⅖";
var frac34$1 = "¾";
var frac35 = "⅗";
var frac38 = "⅜";
var frac45 = "⅘";
var frac56 = "⅚";
var frac58 = "⅝";
var frac78 = "⅞";
var frasl = "⁄";
var frown = "⌢";
var fscr = "𝒻";
var Fscr = "ℱ";
var gacute = "ǵ";
var Gamma = "Γ";
var gamma = "γ";
var Gammad = "Ϝ";
var gammad = "ϝ";
var gap = "⪆";
var Gbreve = "Ğ";
var gbreve = "ğ";
var Gcedil = "Ģ";
var Gcirc = "Ĝ";
var gcirc = "ĝ";
var Gcy = "Г";
var gcy = "г";
var Gdot = "Ġ";
var gdot = "ġ";
var ge = "≥";
var gE = "≧";
var gEl = "⪌";
var gel = "⋛";
var geq = "≥";
var geqq = "≧";
var geqslant = "⩾";
var gescc = "⪩";
var ges = "⩾";
var gesdot = "⪀";
var gesdoto = "⪂";
var gesdotol = "⪄";
var gesl = "⋛︀";
var gesles = "⪔";
var Gfr = "𝔊";
var gfr = "𝔤";
var gg = "≫";
var Gg = "⋙";
var ggg = "⋙";
var gimel = "ℷ";
var GJcy = "Ѓ";
var gjcy = "ѓ";
var gla = "⪥";
var gl = "≷";
var glE = "⪒";
var glj = "⪤";
var gnap = "⪊";
var gnapprox = "⪊";
var gne = "⪈";
var gnE = "≩";
var gneq = "⪈";
var gneqq = "≩";
var gnsim = "⋧";
var Gopf = "𝔾";
var gopf = "𝕘";
var grave = "`";
var GreaterEqual = "≥";
var GreaterEqualLess = "⋛";
var GreaterFullEqual = "≧";
var GreaterGreater = "⪢";
var GreaterLess = "≷";
var GreaterSlantEqual = "⩾";
var GreaterTilde = "≳";
var Gscr = "𝒢";
var gscr = "ℊ";
var gsim = "≳";
var gsime = "⪎";
var gsiml = "⪐";
var gtcc = "⪧";
var gtcir = "⩺";
var gt$2 = ">";
var GT$1 = ">";
var Gt = "≫";
var gtdot = "⋗";
var gtlPar = "⦕";
var gtquest = "⩼";
var gtrapprox = "⪆";
var gtrarr = "⥸";
var gtrdot = "⋗";
var gtreqless = "⋛";
var gtreqqless = "⪌";
var gtrless = "≷";
var gtrsim = "≳";
var gvertneqq = "≩︀";
var gvnE = "≩︀";
var Hacek = "ˇ";
var hairsp = " ";
var half = "½";
var hamilt = "ℋ";
var HARDcy = "Ъ";
var hardcy = "ъ";
var harrcir = "⥈";
var harr = "↔";
var hArr = "⇔";
var harrw = "↭";
var Hat = "^";
var hbar = "ℏ";
var Hcirc = "Ĥ";
var hcirc = "ĥ";
var hearts = "♥";
var heartsuit = "♥";
var hellip = "…";
var hercon = "⊹";
var hfr = "𝔥";
var Hfr = "ℌ";
var HilbertSpace = "ℋ";
var hksearow = "⤥";
var hkswarow = "⤦";
var hoarr = "⇿";
var homtht = "∻";
var hookleftarrow = "↩";
var hookrightarrow = "↪";
var hopf = "𝕙";
var Hopf = "ℍ";
var horbar = "―";
var HorizontalLine = "─";
var hscr = "𝒽";
var Hscr = "ℋ";
var hslash = "ℏ";
var Hstrok = "Ħ";
var hstrok = "ħ";
var HumpDownHump = "≎";
var HumpEqual = "≏";
var hybull = "⁃";
var hyphen = "‐";
var Iacute$1 = "Í";
var iacute$1 = "í";
var ic = "⁣";
var Icirc$1 = "Î";
var icirc$1 = "î";
var Icy = "И";
var icy = "и";
var Idot = "İ";
var IEcy = "Е";
var iecy = "е";
var iexcl$1 = "¡";
var iff = "⇔";
var ifr = "𝔦";
var Ifr = "ℑ";
var Igrave$1 = "Ì";
var igrave$1 = "ì";
var ii = "ⅈ";
var iiiint = "⨌";
var iiint = "∭";
var iinfin = "⧜";
var iiota = "℩";
var IJlig = "Ĳ";
var ijlig = "ĳ";
var Imacr = "Ī";
var imacr = "ī";
var image = "ℑ";
var ImaginaryI = "ⅈ";
var imagline = "ℐ";
var imagpart = "ℑ";
var imath = "ı";
var Im = "ℑ";
var imof = "⊷";
var imped = "Ƶ";
var Implies = "⇒";
var incare = "℅";
var infin = "∞";
var infintie = "⧝";
var inodot = "ı";
var intcal = "⊺";
var int = "∫";
var Int = "∬";
var integers = "ℤ";
var Integral = "∫";
var intercal = "⊺";
var Intersection = "⋂";
var intlarhk = "⨗";
var intprod = "⨼";
var InvisibleComma = "⁣";
var InvisibleTimes = "⁢";
var IOcy = "Ё";
var iocy = "ё";
var Iogon = "Į";
var iogon = "į";
var Iopf = "𝕀";
var iopf = "𝕚";
var Iota = "Ι";
var iota = "ι";
var iprod = "⨼";
var iquest$1 = "¿";
var iscr = "𝒾";
var Iscr = "ℐ";
var isin = "∈";
var isindot = "⋵";
var isinE = "⋹";
var isins = "⋴";
var isinsv = "⋳";
var isinv = "∈";
var it = "⁢";
var Itilde = "Ĩ";
var itilde = "ĩ";
var Iukcy = "І";
var iukcy = "і";
var Iuml$1 = "Ï";
var iuml$1 = "ï";
var Jcirc = "Ĵ";
var jcirc = "ĵ";
var Jcy = "Й";
var jcy = "й";
var Jfr = "𝔍";
var jfr = "𝔧";
var jmath = "ȷ";
var Jopf = "𝕁";
var jopf = "𝕛";
var Jscr = "𝒥";
var jscr = "𝒿";
var Jsercy = "Ј";
var jsercy = "ј";
var Jukcy = "Є";
var jukcy = "є";
var Kappa = "Κ";
var kappa = "κ";
var kappav = "ϰ";
var Kcedil = "Ķ";
var kcedil = "ķ";
var Kcy = "К";
var kcy = "к";
var Kfr = "𝔎";
var kfr = "𝔨";
var kgreen = "ĸ";
var KHcy = "Х";
var khcy = "х";
var KJcy = "Ќ";
var kjcy = "ќ";
var Kopf = "𝕂";
var kopf = "𝕜";
var Kscr = "𝒦";
var kscr = "𝓀";
var lAarr = "⇚";
var Lacute = "Ĺ";
var lacute = "ĺ";
var laemptyv = "⦴";
var lagran = "ℒ";
var Lambda = "Λ";
var lambda = "λ";
var lang = "⟨";
var Lang = "⟪";
var langd = "⦑";
var langle = "⟨";
var lap = "⪅";
var Laplacetrf = "ℒ";
var laquo$1 = "«";
var larrb = "⇤";
var larrbfs = "⤟";
var larr = "←";
var Larr = "↞";
var lArr = "⇐";
var larrfs = "⤝";
var larrhk = "↩";
var larrlp = "↫";
var larrpl = "⤹";
var larrsim = "⥳";
var larrtl = "↢";
var latail = "⤙";
var lAtail = "⤛";
var lat = "⪫";
var late = "⪭";
var lates = "⪭︀";
var lbarr = "⤌";
var lBarr = "⤎";
var lbbrk = "❲";
var lbrace = "{";
var lbrack = "[";
var lbrke = "⦋";
var lbrksld = "⦏";
var lbrkslu = "⦍";
var Lcaron = "Ľ";
var lcaron = "ľ";
var Lcedil = "Ļ";
var lcedil = "ļ";
var lceil = "⌈";
var lcub = "{";
var Lcy = "Л";
var lcy = "л";
var ldca = "⤶";
var ldquo = "“";
var ldquor = "„";
var ldrdhar = "⥧";
var ldrushar = "⥋";
var ldsh = "↲";
var le = "≤";
var lE = "≦";
var LeftAngleBracket = "⟨";
var LeftArrowBar = "⇤";
var leftarrow = "←";
var LeftArrow = "←";
var Leftarrow = "⇐";
var LeftArrowRightArrow = "⇆";
var leftarrowtail = "↢";
var LeftCeiling = "⌈";
var LeftDoubleBracket = "⟦";
var LeftDownTeeVector = "⥡";
var LeftDownVectorBar = "⥙";
var LeftDownVector = "⇃";
var LeftFloor = "⌊";
var leftharpoondown = "↽";
var leftharpoonup = "↼";
var leftleftarrows = "⇇";
var leftrightarrow = "↔";
var LeftRightArrow = "↔";
var Leftrightarrow = "⇔";
var leftrightarrows = "⇆";
var leftrightharpoons = "⇋";
var leftrightsquigarrow = "↭";
var LeftRightVector = "⥎";
var LeftTeeArrow = "↤";
var LeftTee = "⊣";
var LeftTeeVector = "⥚";
var leftthreetimes = "⋋";
var LeftTriangleBar = "⧏";
var LeftTriangle = "⊲";
var LeftTriangleEqual = "⊴";
var LeftUpDownVector = "⥑";
var LeftUpTeeVector = "⥠";
var LeftUpVectorBar = "⥘";
var LeftUpVector = "↿";
var LeftVectorBar = "⥒";
var LeftVector = "↼";
var lEg = "⪋";
var leg = "⋚";
var leq = "≤";
var leqq = "≦";
var leqslant = "⩽";
var lescc = "⪨";
var les = "⩽";
var lesdot = "⩿";
var lesdoto = "⪁";
var lesdotor = "⪃";
var lesg = "⋚︀";
var lesges = "⪓";
var lessapprox = "⪅";
var lessdot = "⋖";
var lesseqgtr = "⋚";
var lesseqqgtr = "⪋";
var LessEqualGreater = "⋚";
var LessFullEqual = "≦";
var LessGreater = "≶";
var lessgtr = "≶";
var LessLess = "⪡";
var lesssim = "≲";
var LessSlantEqual = "⩽";
var LessTilde = "≲";
var lfisht = "⥼";
var lfloor = "⌊";
var Lfr = "𝔏";
var lfr = "𝔩";
var lg = "≶";
var lgE = "⪑";
var lHar = "⥢";
var lhard = "↽";
var lharu = "↼";
var lharul = "⥪";
var lhblk = "▄";
var LJcy = "Љ";
var ljcy = "љ";
var llarr = "⇇";
var ll = "≪";
var Ll = "⋘";
var llcorner = "⌞";
var Lleftarrow = "⇚";
var llhard = "⥫";
var lltri = "◺";
var Lmidot = "Ŀ";
var lmidot = "ŀ";
var lmoustache = "⎰";
var lmoust = "⎰";
var lnap = "⪉";
var lnapprox = "⪉";
var lne = "⪇";
var lnE = "≨";
var lneq = "⪇";
var lneqq = "≨";
var lnsim = "⋦";
var loang = "⟬";
var loarr = "⇽";
var lobrk = "⟦";
var longleftarrow = "⟵";
var LongLeftArrow = "⟵";
var Longleftarrow = "⟸";
var longleftrightarrow = "⟷";
var LongLeftRightArrow = "⟷";
var Longleftrightarrow = "⟺";
var longmapsto = "⟼";
var longrightarrow = "⟶";
var LongRightArrow = "⟶";
var Longrightarrow = "⟹";
var looparrowleft = "↫";
var looparrowright = "↬";
var lopar = "⦅";
var Lopf = "𝕃";
var lopf = "𝕝";
var loplus = "⨭";
var lotimes = "⨴";
var lowast = "∗";
var lowbar = "_";
var LowerLeftArrow = "↙";
var LowerRightArrow = "↘";
var loz = "◊";
var lozenge = "◊";
var lozf = "⧫";
var lpar = "(";
var lparlt = "⦓";
var lrarr = "⇆";
var lrcorner = "⌟";
var lrhar = "⇋";
var lrhard = "⥭";
var lrm = "‎";
var lrtri = "⊿";
var lsaquo = "‹";
var lscr = "𝓁";
var Lscr = "ℒ";
var lsh = "↰";
var Lsh = "↰";
var lsim = "≲";
var lsime = "⪍";
var lsimg = "⪏";
var lsqb = "[";
var lsquo = "‘";
var lsquor = "‚";
var Lstrok = "Ł";
var lstrok = "ł";
var ltcc = "⪦";
var ltcir = "⩹";
var lt$2 = "<";
var LT$1 = "<";
var Lt = "≪";
var ltdot = "⋖";
var lthree = "⋋";
var ltimes = "⋉";
var ltlarr = "⥶";
var ltquest = "⩻";
var ltri = "◃";
var ltrie = "⊴";
var ltrif = "◂";
var ltrPar = "⦖";
var lurdshar = "⥊";
var luruhar = "⥦";
var lvertneqq = "≨︀";
var lvnE = "≨︀";
var macr$1 = "¯";
var male = "♂";
var malt = "✠";
var maltese = "✠";
var map = "↦";
var mapsto = "↦";
var mapstodown = "↧";
var mapstoleft = "↤";
var mapstoup = "↥";
var marker = "▮";
var mcomma = "⨩";
var Mcy = "М";
var mcy = "м";
var mdash = "—";
var mDDot = "∺";
var measuredangle = "∡";
var MediumSpace = " ";
var Mellintrf = "ℳ";
var Mfr = "𝔐";
var mfr = "𝔪";
var mho = "℧";
var micro$1 = "µ";
var midast = "*";
var midcir = "⫰";
var mid = "∣";
var middot$1 = "·";
var minusb = "⊟";
var minus = "−";
var minusd = "∸";
var minusdu = "⨪";
var MinusPlus = "∓";
var mlcp = "⫛";
var mldr = "…";
var mnplus = "∓";
var models = "⊧";
var Mopf = "𝕄";
var mopf = "𝕞";
var mp = "∓";
var mscr = "𝓂";
var Mscr = "ℳ";
var mstpos = "∾";
var Mu = "Μ";
var mu = "μ";
var multimap = "⊸";
var mumap = "⊸";
var nabla = "∇";
var Nacute = "Ń";
var nacute = "ń";
var nang = "∠⃒";
var nap = "≉";
var napE = "⩰̸";
var napid = "≋̸";
var napos = "ŉ";
var napprox = "≉";
var natural = "♮";
var naturals = "ℕ";
var natur = "♮";
var nbsp$1 = " ";
var nbump = "≎̸";
var nbumpe = "≏̸";
var ncap = "⩃";
var Ncaron = "Ň";
var ncaron = "ň";
var Ncedil = "Ņ";
var ncedil = "ņ";
var ncong = "≇";
var ncongdot = "⩭̸";
var ncup = "⩂";
var Ncy = "Н";
var ncy = "н";
var ndash = "–";
var nearhk = "⤤";
var nearr = "↗";
var neArr = "⇗";
var nearrow = "↗";
var ne = "≠";
var nedot = "≐̸";
var NegativeMediumSpace = "​";
var NegativeThickSpace = "​";
var NegativeThinSpace = "​";
var NegativeVeryThinSpace = "​";
var nequiv = "≢";
var nesear = "⤨";
var nesim = "≂̸";
var NestedGreaterGreater = "≫";
var NestedLessLess = "≪";
var NewLine = "\n";
var nexist = "∄";
var nexists = "∄";
var Nfr = "𝔑";
var nfr = "𝔫";
var ngE = "≧̸";
var nge = "≱";
var ngeq = "≱";
var ngeqq = "≧̸";
var ngeqslant = "⩾̸";
var nges = "⩾̸";
var nGg = "⋙̸";
var ngsim = "≵";
var nGt = "≫⃒";
var ngt = "≯";
var ngtr = "≯";
var nGtv = "≫̸";
var nharr = "↮";
var nhArr = "⇎";
var nhpar = "⫲";
var ni = "∋";
var nis = "⋼";
var nisd = "⋺";
var niv = "∋";
var NJcy = "Њ";
var njcy = "њ";
var nlarr = "↚";
var nlArr = "⇍";
var nldr = "‥";
var nlE = "≦̸";
var nle = "≰";
var nleftarrow = "↚";
var nLeftarrow = "⇍";
var nleftrightarrow = "↮";
var nLeftrightarrow = "⇎";
var nleq = "≰";
var nleqq = "≦̸";
var nleqslant = "⩽̸";
var nles = "⩽̸";
var nless = "≮";
var nLl = "⋘̸";
var nlsim = "≴";
var nLt = "≪⃒";
var nlt = "≮";
var nltri = "⋪";
var nltrie = "⋬";
var nLtv = "≪̸";
var nmid = "∤";
var NoBreak = "⁠";
var NonBreakingSpace = " ";
var nopf = "𝕟";
var Nopf = "ℕ";
var Not = "⫬";
var not$1 = "¬";
var NotCongruent = "≢";
var NotCupCap = "≭";
var NotDoubleVerticalBar = "∦";
var NotElement = "∉";
var NotEqual = "≠";
var NotEqualTilde = "≂̸";
var NotExists = "∄";
var NotGreater = "≯";
var NotGreaterEqual = "≱";
var NotGreaterFullEqual = "≧̸";
var NotGreaterGreater = "≫̸";
var NotGreaterLess = "≹";
var NotGreaterSlantEqual = "⩾̸";
var NotGreaterTilde = "≵";
var NotHumpDownHump = "≎̸";
var NotHumpEqual = "≏̸";
var notin = "∉";
var notindot = "⋵̸";
var notinE = "⋹̸";
var notinva = "∉";
var notinvb = "⋷";
var notinvc = "⋶";
var NotLeftTriangleBar = "⧏̸";
var NotLeftTriangle = "⋪";
var NotLeftTriangleEqual = "⋬";
var NotLess = "≮";
var NotLessEqual = "≰";
var NotLessGreater = "≸";
var NotLessLess = "≪̸";
var NotLessSlantEqual = "⩽̸";
var NotLessTilde = "≴";
var NotNestedGreaterGreater = "⪢̸";
var NotNestedLessLess = "⪡̸";
var notni = "∌";
var notniva = "∌";
var notnivb = "⋾";
var notnivc = "⋽";
var NotPrecedes = "⊀";
var NotPrecedesEqual = "⪯̸";
var NotPrecedesSlantEqual = "⋠";
var NotReverseElement = "∌";
var NotRightTriangleBar = "⧐̸";
var NotRightTriangle = "⋫";
var NotRightTriangleEqual = "⋭";
var NotSquareSubset = "⊏̸";
var NotSquareSubsetEqual = "⋢";
var NotSquareSuperset = "⊐̸";
var NotSquareSupersetEqual = "⋣";
var NotSubset = "⊂⃒";
var NotSubsetEqual = "⊈";
var NotSucceeds = "⊁";
var NotSucceedsEqual = "⪰̸";
var NotSucceedsSlantEqual = "⋡";
var NotSucceedsTilde = "≿̸";
var NotSuperset = "⊃⃒";
var NotSupersetEqual = "⊉";
var NotTilde = "≁";
var NotTildeEqual = "≄";
var NotTildeFullEqual = "≇";
var NotTildeTilde = "≉";
var NotVerticalBar = "∤";
var nparallel = "∦";
var npar = "∦";
var nparsl = "⫽⃥";
var npart = "∂̸";
var npolint = "⨔";
var npr = "⊀";
var nprcue = "⋠";
var nprec = "⊀";
var npreceq = "⪯̸";
var npre = "⪯̸";
var nrarrc = "⤳̸";
var nrarr = "↛";
var nrArr = "⇏";
var nrarrw = "↝̸";
var nrightarrow = "↛";
var nRightarrow = "⇏";
var nrtri = "⋫";
var nrtrie = "⋭";
var nsc = "⊁";
var nsccue = "⋡";
var nsce = "⪰̸";
var Nscr = "𝒩";
var nscr = "𝓃";
var nshortmid = "∤";
var nshortparallel = "∦";
var nsim = "≁";
var nsime = "≄";
var nsimeq = "≄";
var nsmid = "∤";
var nspar = "∦";
var nsqsube = "⋢";
var nsqsupe = "⋣";
var nsub = "⊄";
var nsubE = "⫅̸";
var nsube = "⊈";
var nsubset = "⊂⃒";
var nsubseteq = "⊈";
var nsubseteqq = "⫅̸";
var nsucc = "⊁";
var nsucceq = "⪰̸";
var nsup = "⊅";
var nsupE = "⫆̸";
var nsupe = "⊉";
var nsupset = "⊃⃒";
var nsupseteq = "⊉";
var nsupseteqq = "⫆̸";
var ntgl = "≹";
var Ntilde$1 = "Ñ";
var ntilde$1 = "ñ";
var ntlg = "≸";
var ntriangleleft = "⋪";
var ntrianglelefteq = "⋬";
var ntriangleright = "⋫";
var ntrianglerighteq = "⋭";
var Nu = "Ν";
var nu = "ν";
var num = "#";
var numero = "№";
var numsp = " ";
var nvap = "≍⃒";
var nvdash = "⊬";
var nvDash = "⊭";
var nVdash = "⊮";
var nVDash = "⊯";
var nvge = "≥⃒";
var nvgt = ">⃒";
var nvHarr = "⤄";
var nvinfin = "⧞";
var nvlArr = "⤂";
var nvle = "≤⃒";
var nvlt = "<⃒";
var nvltrie = "⊴⃒";
var nvrArr = "⤃";
var nvrtrie = "⊵⃒";
var nvsim = "∼⃒";
var nwarhk = "⤣";
var nwarr = "↖";
var nwArr = "⇖";
var nwarrow = "↖";
var nwnear = "⤧";
var Oacute$1 = "Ó";
var oacute$1 = "ó";
var oast = "⊛";
var Ocirc$1 = "Ô";
var ocirc$1 = "ô";
var ocir = "⊚";
var Ocy = "О";
var ocy = "о";
var odash = "⊝";
var Odblac = "Ő";
var odblac = "ő";
var odiv = "⨸";
var odot = "⊙";
var odsold = "⦼";
var OElig = "Œ";
var oelig = "œ";
var ofcir = "⦿";
var Ofr = "𝔒";
var ofr = "𝔬";
var ogon = "˛";
var Ograve$1 = "Ò";
var ograve$1 = "ò";
var ogt = "⧁";
var ohbar = "⦵";
var ohm = "Ω";
var oint = "∮";
var olarr = "↺";
var olcir = "⦾";
var olcross = "⦻";
var oline = "‾";
var olt = "⧀";
var Omacr = "Ō";
var omacr = "ō";
var Omega = "Ω";
var omega = "ω";
var Omicron = "Ο";
var omicron = "ο";
var omid = "⦶";
var ominus = "⊖";
var Oopf = "𝕆";
var oopf = "𝕠";
var opar = "⦷";
var OpenCurlyDoubleQuote = "“";
var OpenCurlyQuote = "‘";
var operp = "⦹";
var oplus = "⊕";
var orarr = "↻";
var Or = "⩔";
var or = "∨";
var ord = "⩝";
var order = "ℴ";
var orderof = "ℴ";
var ordf$1 = "ª";
var ordm$1 = "º";
var origof = "⊶";
var oror = "⩖";
var orslope = "⩗";
var orv = "⩛";
var oS = "Ⓢ";
var Oscr = "𝒪";
var oscr = "ℴ";
var Oslash$1 = "Ø";
var oslash$1 = "ø";
var osol = "⊘";
var Otilde$1 = "Õ";
var otilde$1 = "õ";
var otimesas = "⨶";
var Otimes = "⨷";
var otimes = "⊗";
var Ouml$1 = "Ö";
var ouml$1 = "ö";
var ovbar = "⌽";
var OverBar = "‾";
var OverBrace = "⏞";
var OverBracket = "⎴";
var OverParenthesis = "⏜";
var para$1 = "¶";
var parallel = "∥";
var par = "∥";
var parsim = "⫳";
var parsl = "⫽";
var part = "∂";
var PartialD = "∂";
var Pcy = "П";
var pcy = "п";
var percnt = "%";
var period = ".";
var permil = "‰";
var perp = "⊥";
var pertenk = "‱";
var Pfr = "𝔓";
var pfr = "𝔭";
var Phi = "Φ";
var phi = "φ";
var phiv = "ϕ";
var phmmat = "ℳ";
var phone = "☎";
var Pi = "Π";
var pi = "π";
var pitchfork = "⋔";
var piv = "ϖ";
var planck = "ℏ";
var planckh = "ℎ";
var plankv = "ℏ";
var plusacir = "⨣";
var plusb = "⊞";
var pluscir = "⨢";
var plus = "+";
var plusdo = "∔";
var plusdu = "⨥";
var pluse = "⩲";
var PlusMinus = "±";
var plusmn$1 = "±";
var plussim = "⨦";
var plustwo = "⨧";
var pm = "±";
var Poincareplane = "ℌ";
var pointint = "⨕";
var popf = "𝕡";
var Popf = "ℙ";
var pound$1 = "£";
var prap = "⪷";
var Pr = "⪻";
var pr = "≺";
var prcue = "≼";
var precapprox = "⪷";
var prec = "≺";
var preccurlyeq = "≼";
var Precedes = "≺";
var PrecedesEqual = "⪯";
var PrecedesSlantEqual = "≼";
var PrecedesTilde = "≾";
var preceq = "⪯";
var precnapprox = "⪹";
var precneqq = "⪵";
var precnsim = "⋨";
var pre = "⪯";
var prE = "⪳";
var precsim = "≾";
var prime = "′";
var Prime = "″";
var primes = "ℙ";
var prnap = "⪹";
var prnE = "⪵";
var prnsim = "⋨";
var prod = "∏";
var Product = "∏";
var profalar = "⌮";
var profline = "⌒";
var profsurf = "⌓";
var prop = "∝";
var Proportional = "∝";
var Proportion = "∷";
var propto = "∝";
var prsim = "≾";
var prurel = "⊰";
var Pscr = "𝒫";
var pscr = "𝓅";
var Psi = "Ψ";
var psi = "ψ";
var puncsp = " ";
var Qfr = "𝔔";
var qfr = "𝔮";
var qint = "⨌";
var qopf = "𝕢";
var Qopf = "ℚ";
var qprime = "⁗";
var Qscr = "𝒬";
var qscr = "𝓆";
var quaternions = "ℍ";
var quatint = "⨖";
var quest = "?";
var questeq = "≟";
var quot$2 = "\"";
var QUOT$1 = "\"";
var rAarr = "⇛";
var race = "∽̱";
var Racute = "Ŕ";
var racute = "ŕ";
var radic = "√";
var raemptyv = "⦳";
var rang = "⟩";
var Rang = "⟫";
var rangd = "⦒";
var range = "⦥";
var rangle = "⟩";
var raquo$1 = "»";
var rarrap = "⥵";
var rarrb = "⇥";
var rarrbfs = "⤠";
var rarrc = "⤳";
var rarr = "→";
var Rarr = "↠";
var rArr = "⇒";
var rarrfs = "⤞";
var rarrhk = "↪";
var rarrlp = "↬";
var rarrpl = "⥅";
var rarrsim = "⥴";
var Rarrtl = "⤖";
var rarrtl = "↣";
var rarrw = "↝";
var ratail = "⤚";
var rAtail = "⤜";
var ratio = "∶";
var rationals = "ℚ";
var rbarr = "⤍";
var rBarr = "⤏";
var RBarr = "⤐";
var rbbrk = "❳";
var rbrace = "}";
var rbrack = "]";
var rbrke = "⦌";
var rbrksld = "⦎";
var rbrkslu = "⦐";
var Rcaron = "Ř";
var rcaron = "ř";
var Rcedil = "Ŗ";
var rcedil = "ŗ";
var rceil = "⌉";
var rcub = "}";
var Rcy = "Р";
var rcy = "р";
var rdca = "⤷";
var rdldhar = "⥩";
var rdquo = "”";
var rdquor = "”";
var rdsh = "↳";
var real = "ℜ";
var realine = "ℛ";
var realpart = "ℜ";
var reals = "ℝ";
var Re = "ℜ";
var rect = "▭";
var reg$1 = "®";
var REG$1 = "®";
var ReverseElement = "∋";
var ReverseEquilibrium = "⇋";
var ReverseUpEquilibrium = "⥯";
var rfisht = "⥽";
var rfloor = "⌋";
var rfr = "𝔯";
var Rfr = "ℜ";
var rHar = "⥤";
var rhard = "⇁";
var rharu = "⇀";
var rharul = "⥬";
var Rho = "Ρ";
var rho = "ρ";
var rhov = "ϱ";
var RightAngleBracket = "⟩";
var RightArrowBar = "⇥";
var rightarrow = "→";
var RightArrow = "→";
var Rightarrow = "⇒";
var RightArrowLeftArrow = "⇄";
var rightarrowtail = "↣";
var RightCeiling = "⌉";
var RightDoubleBracket = "⟧";
var RightDownTeeVector = "⥝";
var RightDownVectorBar = "⥕";
var RightDownVector = "⇂";
var RightFloor = "⌋";
var rightharpoondown = "⇁";
var rightharpoonup = "⇀";
var rightleftarrows = "⇄";
var rightleftharpoons = "⇌";
var rightrightarrows = "⇉";
var rightsquigarrow = "↝";
var RightTeeArrow = "↦";
var RightTee = "⊢";
var RightTeeVector = "⥛";
var rightthreetimes = "⋌";
var RightTriangleBar = "⧐";
var RightTriangle = "⊳";
var RightTriangleEqual = "⊵";
var RightUpDownVector = "⥏";
var RightUpTeeVector = "⥜";
var RightUpVectorBar = "⥔";
var RightUpVector = "↾";
var RightVectorBar = "⥓";
var RightVector = "⇀";
var ring = "˚";
var risingdotseq = "≓";
var rlarr = "⇄";
var rlhar = "⇌";
var rlm = "‏";
var rmoustache = "⎱";
var rmoust = "⎱";
var rnmid = "⫮";
var roang = "⟭";
var roarr = "⇾";
var robrk = "⟧";
var ropar = "⦆";
var ropf = "𝕣";
var Ropf = "ℝ";
var roplus = "⨮";
var rotimes = "⨵";
var RoundImplies = "⥰";
var rpar = ")";
var rpargt = "⦔";
var rppolint = "⨒";
var rrarr = "⇉";
var Rrightarrow = "⇛";
var rsaquo = "›";
var rscr = "𝓇";
var Rscr = "ℛ";
var rsh = "↱";
var Rsh = "↱";
var rsqb = "]";
var rsquo = "’";
var rsquor = "’";
var rthree = "⋌";
var rtimes = "⋊";
var rtri = "▹";
var rtrie = "⊵";
var rtrif = "▸";
var rtriltri = "⧎";
var RuleDelayed = "⧴";
var ruluhar = "⥨";
var rx = "℞";
var Sacute = "Ś";
var sacute = "ś";
var sbquo = "‚";
var scap = "⪸";
var Scaron = "Š";
var scaron = "š";
var Sc = "⪼";
var sc = "≻";
var sccue = "≽";
var sce = "⪰";
var scE = "⪴";
var Scedil = "Ş";
var scedil = "ş";
var Scirc = "Ŝ";
var scirc = "ŝ";
var scnap = "⪺";
var scnE = "⪶";
var scnsim = "⋩";
var scpolint = "⨓";
var scsim = "≿";
var Scy = "С";
var scy = "с";
var sdotb = "⊡";
var sdot = "⋅";
var sdote = "⩦";
var searhk = "⤥";
var searr = "↘";
var seArr = "⇘";
var searrow = "↘";
var sect$1 = "§";
var semi = ";";
var seswar = "⤩";
var setminus = "∖";
var setmn = "∖";
var sext = "✶";
var Sfr = "𝔖";
var sfr = "𝔰";
var sfrown = "⌢";
var sharp = "♯";
var SHCHcy = "Щ";
var shchcy = "щ";
var SHcy = "Ш";
var shcy = "ш";
var ShortDownArrow = "↓";
var ShortLeftArrow = "←";
var shortmid = "∣";
var shortparallel = "∥";
var ShortRightArrow = "→";
var ShortUpArrow = "↑";
var shy$1 = "­";
var Sigma = "Σ";
var sigma = "σ";
var sigmaf = "ς";
var sigmav = "ς";
var sim = "∼";
var simdot = "⩪";
var sime = "≃";
var simeq = "≃";
var simg = "⪞";
var simgE = "⪠";
var siml = "⪝";
var simlE = "⪟";
var simne = "≆";
var simplus = "⨤";
var simrarr = "⥲";
var slarr = "←";
var SmallCircle = "∘";
var smallsetminus = "∖";
var smashp = "⨳";
var smeparsl = "⧤";
var smid = "∣";
var smile = "⌣";
var smt = "⪪";
var smte = "⪬";
var smtes = "⪬︀";
var SOFTcy = "Ь";
var softcy = "ь";
var solbar = "⌿";
var solb = "⧄";
var sol = "/";
var Sopf = "𝕊";
var sopf = "𝕤";
var spades = "♠";
var spadesuit = "♠";
var spar = "∥";
var sqcap = "⊓";
var sqcaps = "⊓︀";
var sqcup = "⊔";
var sqcups = "⊔︀";
var Sqrt = "√";
var sqsub = "⊏";
var sqsube = "⊑";
var sqsubset = "⊏";
var sqsubseteq = "⊑";
var sqsup = "⊐";
var sqsupe = "⊒";
var sqsupset = "⊐";
var sqsupseteq = "⊒";
var square = "□";
var Square = "□";
var SquareIntersection = "⊓";
var SquareSubset = "⊏";
var SquareSubsetEqual = "⊑";
var SquareSuperset = "⊐";
var SquareSupersetEqual = "⊒";
var SquareUnion = "⊔";
var squarf = "▪";
var squ = "□";
var squf = "▪";
var srarr = "→";
var Sscr = "𝒮";
var sscr = "𝓈";
var ssetmn = "∖";
var ssmile = "⌣";
var sstarf = "⋆";
var Star = "⋆";
var star = "☆";
var starf = "★";
var straightepsilon = "ϵ";
var straightphi = "ϕ";
var strns = "¯";
var sub = "⊂";
var Sub = "⋐";
var subdot = "⪽";
var subE = "⫅";
var sube = "⊆";
var subedot = "⫃";
var submult = "⫁";
var subnE = "⫋";
var subne = "⊊";
var subplus = "⪿";
var subrarr = "⥹";
var subset = "⊂";
var Subset = "⋐";
var subseteq = "⊆";
var subseteqq = "⫅";
var SubsetEqual = "⊆";
var subsetneq = "⊊";
var subsetneqq = "⫋";
var subsim = "⫇";
var subsub = "⫕";
var subsup = "⫓";
var succapprox = "⪸";
var succ = "≻";
var succcurlyeq = "≽";
var Succeeds = "≻";
var SucceedsEqual = "⪰";
var SucceedsSlantEqual = "≽";
var SucceedsTilde = "≿";
var succeq = "⪰";
var succnapprox = "⪺";
var succneqq = "⪶";
var succnsim = "⋩";
var succsim = "≿";
var SuchThat = "∋";
var sum = "∑";
var Sum = "∑";
var sung = "♪";
var sup1$1 = "¹";
var sup2$1 = "²";
var sup3$1 = "³";
var sup = "⊃";
var Sup = "⋑";
var supdot = "⪾";
var supdsub = "⫘";
var supE = "⫆";
var supe = "⊇";
var supedot = "⫄";
var Superset = "⊃";
var SupersetEqual = "⊇";
var suphsol = "⟉";
var suphsub = "⫗";
var suplarr = "⥻";
var supmult = "⫂";
var supnE = "⫌";
var supne = "⊋";
var supplus = "⫀";
var supset = "⊃";
var Supset = "⋑";
var supseteq = "⊇";
var supseteqq = "⫆";
var supsetneq = "⊋";
var supsetneqq = "⫌";
var supsim = "⫈";
var supsub = "⫔";
var supsup = "⫖";
var swarhk = "⤦";
var swarr = "↙";
var swArr = "⇙";
var swarrow = "↙";
var swnwar = "⤪";
var szlig$1 = "ß";
var Tab = "\t";
var target = "⌖";
var Tau = "Τ";
var tau = "τ";
var tbrk = "⎴";
var Tcaron = "Ť";
var tcaron = "ť";
var Tcedil = "Ţ";
var tcedil = "ţ";
var Tcy = "Т";
var tcy = "т";
var tdot = "⃛";
var telrec = "⌕";
var Tfr = "𝔗";
var tfr = "𝔱";
var there4 = "∴";
var therefore = "∴";
var Therefore = "∴";
var Theta = "Θ";
var theta = "θ";
var thetasym = "ϑ";
var thetav = "ϑ";
var thickapprox = "≈";
var thicksim = "∼";
var ThickSpace = "  ";
var ThinSpace = " ";
var thinsp = " ";
var thkap = "≈";
var thksim = "∼";
var THORN$1 = "Þ";
var thorn$1 = "þ";
var tilde = "˜";
var Tilde = "∼";
var TildeEqual = "≃";
var TildeFullEqual = "≅";
var TildeTilde = "≈";
var timesbar = "⨱";
var timesb = "⊠";
var times$1 = "×";
var timesd = "⨰";
var tint = "∭";
var toea = "⤨";
var topbot = "⌶";
var topcir = "⫱";
var top = "⊤";
var Topf = "𝕋";
var topf = "𝕥";
var topfork = "⫚";
var tosa = "⤩";
var tprime = "‴";
var trade = "™";
var TRADE = "™";
var triangle = "▵";
var triangledown = "▿";
var triangleleft = "◃";
var trianglelefteq = "⊴";
var triangleq = "≜";
var triangleright = "▹";
var trianglerighteq = "⊵";
var tridot = "◬";
var trie = "≜";
var triminus = "⨺";
var TripleDot = "⃛";
var triplus = "⨹";
var trisb = "⧍";
var tritime = "⨻";
var trpezium = "⏢";
var Tscr = "𝒯";
var tscr = "𝓉";
var TScy = "Ц";
var tscy = "ц";
var TSHcy = "Ћ";
var tshcy = "ћ";
var Tstrok = "Ŧ";
var tstrok = "ŧ";
var twixt = "≬";
var twoheadleftarrow = "↞";
var twoheadrightarrow = "↠";
var Uacute$1 = "Ú";
var uacute$1 = "ú";
var uarr = "↑";
var Uarr = "↟";
var uArr = "⇑";
var Uarrocir = "⥉";
var Ubrcy = "Ў";
var ubrcy = "ў";
var Ubreve = "Ŭ";
var ubreve = "ŭ";
var Ucirc$1 = "Û";
var ucirc$1 = "û";
var Ucy = "У";
var ucy = "у";
var udarr = "⇅";
var Udblac = "Ű";
var udblac = "ű";
var udhar = "⥮";
var ufisht = "⥾";
var Ufr = "𝔘";
var ufr = "𝔲";
var Ugrave$1 = "Ù";
var ugrave$1 = "ù";
var uHar = "⥣";
var uharl = "↿";
var uharr = "↾";
var uhblk = "▀";
var ulcorn = "⌜";
var ulcorner = "⌜";
var ulcrop = "⌏";
var ultri = "◸";
var Umacr = "Ū";
var umacr = "ū";
var uml$1 = "¨";
var UnderBar = "_";
var UnderBrace = "⏟";
var UnderBracket = "⎵";
var UnderParenthesis = "⏝";
var Union = "⋃";
var UnionPlus = "⊎";
var Uogon = "Ų";
var uogon = "ų";
var Uopf = "𝕌";
var uopf = "𝕦";
var UpArrowBar = "⤒";
var uparrow = "↑";
var UpArrow = "↑";
var Uparrow = "⇑";
var UpArrowDownArrow = "⇅";
var updownarrow = "↕";
var UpDownArrow = "↕";
var Updownarrow = "⇕";
var UpEquilibrium = "⥮";
var upharpoonleft = "↿";
var upharpoonright = "↾";
var uplus = "⊎";
var UpperLeftArrow = "↖";
var UpperRightArrow = "↗";
var upsi = "υ";
var Upsi = "ϒ";
var upsih = "ϒ";
var Upsilon = "Υ";
var upsilon = "υ";
var UpTeeArrow = "↥";
var UpTee = "⊥";
var upuparrows = "⇈";
var urcorn = "⌝";
var urcorner = "⌝";
var urcrop = "⌎";
var Uring = "Ů";
var uring = "ů";
var urtri = "◹";
var Uscr = "𝒰";
var uscr = "𝓊";
var utdot = "⋰";
var Utilde = "Ũ";
var utilde = "ũ";
var utri = "▵";
var utrif = "▴";
var uuarr = "⇈";
var Uuml$1 = "Ü";
var uuml$1 = "ü";
var uwangle = "⦧";
var vangrt = "⦜";
var varepsilon = "ϵ";
var varkappa = "ϰ";
var varnothing = "∅";
var varphi = "ϕ";
var varpi = "ϖ";
var varpropto = "∝";
var varr = "↕";
var vArr = "⇕";
var varrho = "ϱ";
var varsigma = "ς";
var varsubsetneq = "⊊︀";
var varsubsetneqq = "⫋︀";
var varsupsetneq = "⊋︀";
var varsupsetneqq = "⫌︀";
var vartheta = "ϑ";
var vartriangleleft = "⊲";
var vartriangleright = "⊳";
var vBar = "⫨";
var Vbar = "⫫";
var vBarv = "⫩";
var Vcy = "В";
var vcy = "в";
var vdash = "⊢";
var vDash = "⊨";
var Vdash = "⊩";
var VDash = "⊫";
var Vdashl = "⫦";
var veebar = "⊻";
var vee = "∨";
var Vee = "⋁";
var veeeq = "≚";
var vellip = "⋮";
var verbar = "|";
var Verbar = "‖";
var vert = "|";
var Vert = "‖";
var VerticalBar = "∣";
var VerticalLine = "|";
var VerticalSeparator = "❘";
var VerticalTilde = "≀";
var VeryThinSpace = " ";
var Vfr = "𝔙";
var vfr = "𝔳";
var vltri = "⊲";
var vnsub = "⊂⃒";
var vnsup = "⊃⃒";
var Vopf = "𝕍";
var vopf = "𝕧";
var vprop = "∝";
var vrtri = "⊳";
var Vscr = "𝒱";
var vscr = "𝓋";
var vsubnE = "⫋︀";
var vsubne = "⊊︀";
var vsupnE = "⫌︀";
var vsupne = "⊋︀";
var Vvdash = "⊪";
var vzigzag = "⦚";
var Wcirc = "Ŵ";
var wcirc = "ŵ";
var wedbar = "⩟";
var wedge = "∧";
var Wedge = "⋀";
var wedgeq = "≙";
var weierp = "℘";
var Wfr = "𝔚";
var wfr = "𝔴";
var Wopf = "𝕎";
var wopf = "𝕨";
var wp = "℘";
var wr = "≀";
var wreath = "≀";
var Wscr = "𝒲";
var wscr = "𝓌";
var xcap = "⋂";
var xcirc = "◯";
var xcup = "⋃";
var xdtri = "▽";
var Xfr = "𝔛";
var xfr = "𝔵";
var xharr = "⟷";
var xhArr = "⟺";
var Xi = "Ξ";
var xi = "ξ";
var xlarr = "⟵";
var xlArr = "⟸";
var xmap = "⟼";
var xnis = "⋻";
var xodot = "⨀";
var Xopf = "𝕏";
var xopf = "𝕩";
var xoplus = "⨁";
var xotime = "⨂";
var xrarr = "⟶";
var xrArr = "⟹";
var Xscr = "𝒳";
var xscr = "𝓍";
var xsqcup = "⨆";
var xuplus = "⨄";
var xutri = "△";
var xvee = "⋁";
var xwedge = "⋀";
var Yacute$1 = "Ý";
var yacute$1 = "ý";
var YAcy = "Я";
var yacy = "я";
var Ycirc = "Ŷ";
var ycirc = "ŷ";
var Ycy = "Ы";
var ycy = "ы";
var yen$1 = "¥";
var Yfr = "𝔜";
var yfr = "𝔶";
var YIcy = "Ї";
var yicy = "ї";
var Yopf = "𝕐";
var yopf = "𝕪";
var Yscr = "𝒴";
var yscr = "𝓎";
var YUcy = "Ю";
var yucy = "ю";
var yuml$1 = "ÿ";
var Yuml = "Ÿ";
var Zacute = "Ź";
var zacute = "ź";
var Zcaron = "Ž";
var zcaron = "ž";
var Zcy = "З";
var zcy = "з";
var Zdot = "Ż";
var zdot = "ż";
var zeetrf = "ℨ";
var ZeroWidthSpace = "​";
var Zeta = "Ζ";
var zeta = "ζ";
var zfr = "𝔷";
var Zfr = "ℨ";
var ZHcy = "Ж";
var zhcy = "ж";
var zigrarr = "⇝";
var zopf = "𝕫";
var Zopf = "ℤ";
var Zscr = "𝒵";
var zscr = "𝓏";
var zwj = "‍";
var zwnj = "‌";
var entities = {
	Aacute: Aacute$1,
	aacute: aacute$1,
	Abreve: Abreve,
	abreve: abreve,
	ac: ac,
	acd: acd,
	acE: acE,
	Acirc: Acirc$1,
	acirc: acirc$1,
	acute: acute$1,
	Acy: Acy,
	acy: acy,
	AElig: AElig$1,
	aelig: aelig$1,
	af: af,
	Afr: Afr,
	afr: afr,
	Agrave: Agrave$1,
	agrave: agrave$1,
	alefsym: alefsym,
	aleph: aleph,
	Alpha: Alpha,
	alpha: alpha,
	Amacr: Amacr,
	amacr: amacr,
	amalg: amalg,
	amp: amp$2,
	AMP: AMP$1,
	andand: andand,
	And: And,
	and: and,
	andd: andd,
	andslope: andslope,
	andv: andv,
	ang: ang,
	ange: ange,
	angle: angle,
	angmsdaa: angmsdaa,
	angmsdab: angmsdab,
	angmsdac: angmsdac,
	angmsdad: angmsdad,
	angmsdae: angmsdae,
	angmsdaf: angmsdaf,
	angmsdag: angmsdag,
	angmsdah: angmsdah,
	angmsd: angmsd,
	angrt: angrt,
	angrtvb: angrtvb,
	angrtvbd: angrtvbd,
	angsph: angsph,
	angst: angst,
	angzarr: angzarr,
	Aogon: Aogon,
	aogon: aogon,
	Aopf: Aopf,
	aopf: aopf,
	apacir: apacir,
	ap: ap,
	apE: apE,
	ape: ape,
	apid: apid,
	apos: apos$1,
	ApplyFunction: ApplyFunction,
	approx: approx,
	approxeq: approxeq,
	Aring: Aring$1,
	aring: aring$1,
	Ascr: Ascr,
	ascr: ascr,
	Assign: Assign,
	ast: ast,
	asymp: asymp,
	asympeq: asympeq,
	Atilde: Atilde$1,
	atilde: atilde$1,
	Auml: Auml$1,
	auml: auml$1,
	awconint: awconint,
	awint: awint,
	backcong: backcong,
	backepsilon: backepsilon,
	backprime: backprime,
	backsim: backsim,
	backsimeq: backsimeq,
	Backslash: Backslash,
	Barv: Barv,
	barvee: barvee,
	barwed: barwed,
	Barwed: Barwed,
	barwedge: barwedge,
	bbrk: bbrk,
	bbrktbrk: bbrktbrk,
	bcong: bcong,
	Bcy: Bcy,
	bcy: bcy,
	bdquo: bdquo,
	becaus: becaus,
	because: because,
	Because: Because,
	bemptyv: bemptyv,
	bepsi: bepsi,
	bernou: bernou,
	Bernoullis: Bernoullis,
	Beta: Beta,
	beta: beta,
	beth: beth,
	between: between,
	Bfr: Bfr,
	bfr: bfr,
	bigcap: bigcap,
	bigcirc: bigcirc,
	bigcup: bigcup,
	bigodot: bigodot,
	bigoplus: bigoplus,
	bigotimes: bigotimes,
	bigsqcup: bigsqcup,
	bigstar: bigstar,
	bigtriangledown: bigtriangledown,
	bigtriangleup: bigtriangleup,
	biguplus: biguplus,
	bigvee: bigvee,
	bigwedge: bigwedge,
	bkarow: bkarow,
	blacklozenge: blacklozenge,
	blacksquare: blacksquare,
	blacktriangle: blacktriangle,
	blacktriangledown: blacktriangledown,
	blacktriangleleft: blacktriangleleft,
	blacktriangleright: blacktriangleright,
	blank: blank,
	blk12: blk12,
	blk14: blk14,
	blk34: blk34,
	block: block,
	bne: bne,
	bnequiv: bnequiv,
	bNot: bNot,
	bnot: bnot,
	Bopf: Bopf,
	bopf: bopf,
	bot: bot,
	bottom: bottom,
	bowtie: bowtie,
	boxbox: boxbox,
	boxdl: boxdl,
	boxdL: boxdL,
	boxDl: boxDl,
	boxDL: boxDL,
	boxdr: boxdr,
	boxdR: boxdR,
	boxDr: boxDr,
	boxDR: boxDR,
	boxh: boxh,
	boxH: boxH,
	boxhd: boxhd,
	boxHd: boxHd,
	boxhD: boxhD,
	boxHD: boxHD,
	boxhu: boxhu,
	boxHu: boxHu,
	boxhU: boxhU,
	boxHU: boxHU,
	boxminus: boxminus,
	boxplus: boxplus,
	boxtimes: boxtimes,
	boxul: boxul,
	boxuL: boxuL,
	boxUl: boxUl,
	boxUL: boxUL,
	boxur: boxur,
	boxuR: boxuR,
	boxUr: boxUr,
	boxUR: boxUR,
	boxv: boxv,
	boxV: boxV,
	boxvh: boxvh,
	boxvH: boxvH,
	boxVh: boxVh,
	boxVH: boxVH,
	boxvl: boxvl,
	boxvL: boxvL,
	boxVl: boxVl,
	boxVL: boxVL,
	boxvr: boxvr,
	boxvR: boxvR,
	boxVr: boxVr,
	boxVR: boxVR,
	bprime: bprime,
	breve: breve,
	Breve: Breve,
	brvbar: brvbar$1,
	bscr: bscr,
	Bscr: Bscr,
	bsemi: bsemi,
	bsim: bsim,
	bsime: bsime,
	bsolb: bsolb,
	bsol: bsol,
	bsolhsub: bsolhsub,
	bull: bull,
	bullet: bullet,
	bump: bump,
	bumpE: bumpE,
	bumpe: bumpe,
	Bumpeq: Bumpeq,
	bumpeq: bumpeq,
	Cacute: Cacute,
	cacute: cacute,
	capand: capand,
	capbrcup: capbrcup,
	capcap: capcap,
	cap: cap,
	Cap: Cap,
	capcup: capcup,
	capdot: capdot,
	CapitalDifferentialD: CapitalDifferentialD,
	caps: caps,
	caret: caret,
	caron: caron,
	Cayleys: Cayleys,
	ccaps: ccaps,
	Ccaron: Ccaron,
	ccaron: ccaron,
	Ccedil: Ccedil$1,
	ccedil: ccedil$1,
	Ccirc: Ccirc,
	ccirc: ccirc,
	Cconint: Cconint,
	ccups: ccups,
	ccupssm: ccupssm,
	Cdot: Cdot,
	cdot: cdot,
	cedil: cedil$1,
	Cedilla: Cedilla,
	cemptyv: cemptyv,
	cent: cent$1,
	centerdot: centerdot,
	CenterDot: CenterDot,
	cfr: cfr,
	Cfr: Cfr,
	CHcy: CHcy,
	chcy: chcy,
	check: check,
	checkmark: checkmark,
	Chi: Chi,
	chi: chi,
	circ: circ,
	circeq: circeq,
	circlearrowleft: circlearrowleft,
	circlearrowright: circlearrowright,
	circledast: circledast,
	circledcirc: circledcirc,
	circleddash: circleddash,
	CircleDot: CircleDot,
	circledR: circledR,
	circledS: circledS,
	CircleMinus: CircleMinus,
	CirclePlus: CirclePlus,
	CircleTimes: CircleTimes,
	cir: cir,
	cirE: cirE,
	cire: cire,
	cirfnint: cirfnint,
	cirmid: cirmid,
	cirscir: cirscir,
	ClockwiseContourIntegral: ClockwiseContourIntegral,
	CloseCurlyDoubleQuote: CloseCurlyDoubleQuote,
	CloseCurlyQuote: CloseCurlyQuote,
	clubs: clubs,
	clubsuit: clubsuit,
	colon: colon,
	Colon: Colon,
	Colone: Colone,
	colone: colone,
	coloneq: coloneq,
	comma: comma,
	commat: commat,
	comp: comp,
	compfn: compfn,
	complement: complement,
	complexes: complexes,
	cong: cong,
	congdot: congdot,
	Congruent: Congruent,
	conint: conint,
	Conint: Conint,
	ContourIntegral: ContourIntegral,
	copf: copf,
	Copf: Copf,
	coprod: coprod,
	Coproduct: Coproduct,
	copy: copy$1,
	COPY: COPY$1,
	copysr: copysr,
	CounterClockwiseContourIntegral: CounterClockwiseContourIntegral,
	crarr: crarr,
	cross: cross,
	Cross: Cross,
	Cscr: Cscr,
	cscr: cscr,
	csub: csub,
	csube: csube,
	csup: csup,
	csupe: csupe,
	ctdot: ctdot,
	cudarrl: cudarrl,
	cudarrr: cudarrr,
	cuepr: cuepr,
	cuesc: cuesc,
	cularr: cularr,
	cularrp: cularrp,
	cupbrcap: cupbrcap,
	cupcap: cupcap,
	CupCap: CupCap,
	cup: cup,
	Cup: Cup,
	cupcup: cupcup,
	cupdot: cupdot,
	cupor: cupor,
	cups: cups,
	curarr: curarr,
	curarrm: curarrm,
	curlyeqprec: curlyeqprec,
	curlyeqsucc: curlyeqsucc,
	curlyvee: curlyvee,
	curlywedge: curlywedge,
	curren: curren$1,
	curvearrowleft: curvearrowleft,
	curvearrowright: curvearrowright,
	cuvee: cuvee,
	cuwed: cuwed,
	cwconint: cwconint,
	cwint: cwint,
	cylcty: cylcty,
	dagger: dagger,
	Dagger: Dagger,
	daleth: daleth,
	darr: darr,
	Darr: Darr,
	dArr: dArr,
	dash: dash,
	Dashv: Dashv,
	dashv: dashv,
	dbkarow: dbkarow,
	dblac: dblac,
	Dcaron: Dcaron,
	dcaron: dcaron,
	Dcy: Dcy,
	dcy: dcy,
	ddagger: ddagger,
	ddarr: ddarr,
	DD: DD,
	dd: dd,
	DDotrahd: DDotrahd,
	ddotseq: ddotseq,
	deg: deg$1,
	Del: Del,
	Delta: Delta,
	delta: delta,
	demptyv: demptyv,
	dfisht: dfisht,
	Dfr: Dfr,
	dfr: dfr,
	dHar: dHar,
	dharl: dharl,
	dharr: dharr,
	DiacriticalAcute: DiacriticalAcute,
	DiacriticalDot: DiacriticalDot,
	DiacriticalDoubleAcute: DiacriticalDoubleAcute,
	DiacriticalGrave: DiacriticalGrave,
	DiacriticalTilde: DiacriticalTilde,
	diam: diam,
	diamond: diamond,
	Diamond: Diamond,
	diamondsuit: diamondsuit,
	diams: diams,
	die: die,
	DifferentialD: DifferentialD,
	digamma: digamma,
	disin: disin,
	div: div,
	divide: divide$1,
	divideontimes: divideontimes,
	divonx: divonx,
	DJcy: DJcy,
	djcy: djcy,
	dlcorn: dlcorn,
	dlcrop: dlcrop,
	dollar: dollar,
	Dopf: Dopf,
	dopf: dopf,
	Dot: Dot$1,
	dot: dot,
	DotDot: DotDot,
	doteq: doteq,
	doteqdot: doteqdot,
	DotEqual: DotEqual,
	dotminus: dotminus,
	dotplus: dotplus,
	dotsquare: dotsquare,
	doublebarwedge: doublebarwedge,
	DoubleContourIntegral: DoubleContourIntegral,
	DoubleDot: DoubleDot,
	DoubleDownArrow: DoubleDownArrow,
	DoubleLeftArrow: DoubleLeftArrow,
	DoubleLeftRightArrow: DoubleLeftRightArrow,
	DoubleLeftTee: DoubleLeftTee,
	DoubleLongLeftArrow: DoubleLongLeftArrow,
	DoubleLongLeftRightArrow: DoubleLongLeftRightArrow,
	DoubleLongRightArrow: DoubleLongRightArrow,
	DoubleRightArrow: DoubleRightArrow,
	DoubleRightTee: DoubleRightTee,
	DoubleUpArrow: DoubleUpArrow,
	DoubleUpDownArrow: DoubleUpDownArrow,
	DoubleVerticalBar: DoubleVerticalBar,
	DownArrowBar: DownArrowBar,
	downarrow: downarrow,
	DownArrow: DownArrow,
	Downarrow: Downarrow,
	DownArrowUpArrow: DownArrowUpArrow,
	DownBreve: DownBreve,
	downdownarrows: downdownarrows,
	downharpoonleft: downharpoonleft,
	downharpoonright: downharpoonright,
	DownLeftRightVector: DownLeftRightVector,
	DownLeftTeeVector: DownLeftTeeVector,
	DownLeftVectorBar: DownLeftVectorBar,
	DownLeftVector: DownLeftVector,
	DownRightTeeVector: DownRightTeeVector,
	DownRightVectorBar: DownRightVectorBar,
	DownRightVector: DownRightVector,
	DownTeeArrow: DownTeeArrow,
	DownTee: DownTee,
	drbkarow: drbkarow,
	drcorn: drcorn,
	drcrop: drcrop,
	Dscr: Dscr,
	dscr: dscr,
	DScy: DScy,
	dscy: dscy,
	dsol: dsol,
	Dstrok: Dstrok,
	dstrok: dstrok,
	dtdot: dtdot,
	dtri: dtri,
	dtrif: dtrif,
	duarr: duarr,
	duhar: duhar,
	dwangle: dwangle,
	DZcy: DZcy,
	dzcy: dzcy,
	dzigrarr: dzigrarr,
	Eacute: Eacute$1,
	eacute: eacute$1,
	easter: easter,
	Ecaron: Ecaron,
	ecaron: ecaron,
	Ecirc: Ecirc$1,
	ecirc: ecirc$1,
	ecir: ecir,
	ecolon: ecolon,
	Ecy: Ecy,
	ecy: ecy,
	eDDot: eDDot,
	Edot: Edot,
	edot: edot,
	eDot: eDot,
	ee: ee,
	efDot: efDot,
	Efr: Efr,
	efr: efr,
	eg: eg,
	Egrave: Egrave$1,
	egrave: egrave$1,
	egs: egs,
	egsdot: egsdot,
	el: el,
	Element: Element$2,
	elinters: elinters,
	ell: ell,
	els: els,
	elsdot: elsdot,
	Emacr: Emacr,
	emacr: emacr,
	empty: empty,
	emptyset: emptyset,
	EmptySmallSquare: EmptySmallSquare,
	emptyv: emptyv,
	EmptyVerySmallSquare: EmptyVerySmallSquare,
	emsp13: emsp13,
	emsp14: emsp14,
	emsp: emsp,
	ENG: ENG,
	eng: eng,
	ensp: ensp,
	Eogon: Eogon,
	eogon: eogon,
	Eopf: Eopf,
	eopf: eopf,
	epar: epar,
	eparsl: eparsl,
	eplus: eplus,
	epsi: epsi,
	Epsilon: Epsilon,
	epsilon: epsilon,
	epsiv: epsiv,
	eqcirc: eqcirc,
	eqcolon: eqcolon,
	eqsim: eqsim,
	eqslantgtr: eqslantgtr,
	eqslantless: eqslantless,
	Equal: Equal,
	equals: equals,
	EqualTilde: EqualTilde,
	equest: equest,
	Equilibrium: Equilibrium,
	equiv: equiv,
	equivDD: equivDD,
	eqvparsl: eqvparsl,
	erarr: erarr,
	erDot: erDot,
	escr: escr,
	Escr: Escr,
	esdot: esdot,
	Esim: Esim,
	esim: esim,
	Eta: Eta,
	eta: eta,
	ETH: ETH$1,
	eth: eth$1,
	Euml: Euml$1,
	euml: euml$1,
	euro: euro,
	excl: excl,
	exist: exist$1,
	Exists: Exists,
	expectation: expectation,
	exponentiale: exponentiale,
	ExponentialE: ExponentialE,
	fallingdotseq: fallingdotseq,
	Fcy: Fcy,
	fcy: fcy,
	female: female,
	ffilig: ffilig,
	fflig: fflig,
	ffllig: ffllig,
	Ffr: Ffr,
	ffr: ffr,
	filig: filig,
	FilledSmallSquare: FilledSmallSquare,
	FilledVerySmallSquare: FilledVerySmallSquare,
	fjlig: fjlig,
	flat: flat,
	fllig: fllig,
	fltns: fltns,
	fnof: fnof,
	Fopf: Fopf,
	fopf: fopf,
	forall: forall,
	ForAll: ForAll,
	fork: fork,
	forkv: forkv,
	Fouriertrf: Fouriertrf,
	fpartint: fpartint,
	frac12: frac12$1,
	frac13: frac13,
	frac14: frac14$1,
	frac15: frac15,
	frac16: frac16,
	frac18: frac18,
	frac23: frac23,
	frac25: frac25,
	frac34: frac34$1,
	frac35: frac35,
	frac38: frac38,
	frac45: frac45,
	frac56: frac56,
	frac58: frac58,
	frac78: frac78,
	frasl: frasl,
	frown: frown,
	fscr: fscr,
	Fscr: Fscr,
	gacute: gacute,
	Gamma: Gamma,
	gamma: gamma,
	Gammad: Gammad,
	gammad: gammad,
	gap: gap,
	Gbreve: Gbreve,
	gbreve: gbreve,
	Gcedil: Gcedil,
	Gcirc: Gcirc,
	gcirc: gcirc,
	Gcy: Gcy,
	gcy: gcy,
	Gdot: Gdot,
	gdot: gdot,
	ge: ge,
	gE: gE,
	gEl: gEl,
	gel: gel,
	geq: geq,
	geqq: geqq,
	geqslant: geqslant,
	gescc: gescc,
	ges: ges,
	gesdot: gesdot,
	gesdoto: gesdoto,
	gesdotol: gesdotol,
	gesl: gesl,
	gesles: gesles,
	Gfr: Gfr,
	gfr: gfr,
	gg: gg,
	Gg: Gg,
	ggg: ggg,
	gimel: gimel,
	GJcy: GJcy,
	gjcy: gjcy,
	gla: gla,
	gl: gl,
	glE: glE,
	glj: glj,
	gnap: gnap,
	gnapprox: gnapprox,
	gne: gne,
	gnE: gnE,
	gneq: gneq,
	gneqq: gneqq,
	gnsim: gnsim,
	Gopf: Gopf,
	gopf: gopf,
	grave: grave,
	GreaterEqual: GreaterEqual,
	GreaterEqualLess: GreaterEqualLess,
	GreaterFullEqual: GreaterFullEqual,
	GreaterGreater: GreaterGreater,
	GreaterLess: GreaterLess,
	GreaterSlantEqual: GreaterSlantEqual,
	GreaterTilde: GreaterTilde,
	Gscr: Gscr,
	gscr: gscr,
	gsim: gsim,
	gsime: gsime,
	gsiml: gsiml,
	gtcc: gtcc,
	gtcir: gtcir,
	gt: gt$2,
	GT: GT$1,
	Gt: Gt,
	gtdot: gtdot,
	gtlPar: gtlPar,
	gtquest: gtquest,
	gtrapprox: gtrapprox,
	gtrarr: gtrarr,
	gtrdot: gtrdot,
	gtreqless: gtreqless,
	gtreqqless: gtreqqless,
	gtrless: gtrless,
	gtrsim: gtrsim,
	gvertneqq: gvertneqq,
	gvnE: gvnE,
	Hacek: Hacek,
	hairsp: hairsp,
	half: half,
	hamilt: hamilt,
	HARDcy: HARDcy,
	hardcy: hardcy,
	harrcir: harrcir,
	harr: harr,
	hArr: hArr,
	harrw: harrw,
	Hat: Hat,
	hbar: hbar,
	Hcirc: Hcirc,
	hcirc: hcirc,
	hearts: hearts,
	heartsuit: heartsuit,
	hellip: hellip,
	hercon: hercon,
	hfr: hfr,
	Hfr: Hfr,
	HilbertSpace: HilbertSpace,
	hksearow: hksearow,
	hkswarow: hkswarow,
	hoarr: hoarr,
	homtht: homtht,
	hookleftarrow: hookleftarrow,
	hookrightarrow: hookrightarrow,
	hopf: hopf,
	Hopf: Hopf,
	horbar: horbar,
	HorizontalLine: HorizontalLine,
	hscr: hscr,
	Hscr: Hscr,
	hslash: hslash,
	Hstrok: Hstrok,
	hstrok: hstrok,
	HumpDownHump: HumpDownHump,
	HumpEqual: HumpEqual,
	hybull: hybull,
	hyphen: hyphen,
	Iacute: Iacute$1,
	iacute: iacute$1,
	ic: ic,
	Icirc: Icirc$1,
	icirc: icirc$1,
	Icy: Icy,
	icy: icy,
	Idot: Idot,
	IEcy: IEcy,
	iecy: iecy,
	iexcl: iexcl$1,
	iff: iff,
	ifr: ifr,
	Ifr: Ifr,
	Igrave: Igrave$1,
	igrave: igrave$1,
	ii: ii,
	iiiint: iiiint,
	iiint: iiint,
	iinfin: iinfin,
	iiota: iiota,
	IJlig: IJlig,
	ijlig: ijlig,
	Imacr: Imacr,
	imacr: imacr,
	image: image,
	ImaginaryI: ImaginaryI,
	imagline: imagline,
	imagpart: imagpart,
	imath: imath,
	Im: Im,
	imof: imof,
	imped: imped,
	Implies: Implies,
	incare: incare,
	"in": "∈",
	infin: infin,
	infintie: infintie,
	inodot: inodot,
	intcal: intcal,
	int: int,
	Int: Int,
	integers: integers,
	Integral: Integral,
	intercal: intercal,
	Intersection: Intersection,
	intlarhk: intlarhk,
	intprod: intprod,
	InvisibleComma: InvisibleComma,
	InvisibleTimes: InvisibleTimes,
	IOcy: IOcy,
	iocy: iocy,
	Iogon: Iogon,
	iogon: iogon,
	Iopf: Iopf,
	iopf: iopf,
	Iota: Iota,
	iota: iota,
	iprod: iprod,
	iquest: iquest$1,
	iscr: iscr,
	Iscr: Iscr,
	isin: isin,
	isindot: isindot,
	isinE: isinE,
	isins: isins,
	isinsv: isinsv,
	isinv: isinv,
	it: it,
	Itilde: Itilde,
	itilde: itilde,
	Iukcy: Iukcy,
	iukcy: iukcy,
	Iuml: Iuml$1,
	iuml: iuml$1,
	Jcirc: Jcirc,
	jcirc: jcirc,
	Jcy: Jcy,
	jcy: jcy,
	Jfr: Jfr,
	jfr: jfr,
	jmath: jmath,
	Jopf: Jopf,
	jopf: jopf,
	Jscr: Jscr,
	jscr: jscr,
	Jsercy: Jsercy,
	jsercy: jsercy,
	Jukcy: Jukcy,
	jukcy: jukcy,
	Kappa: Kappa,
	kappa: kappa,
	kappav: kappav,
	Kcedil: Kcedil,
	kcedil: kcedil,
	Kcy: Kcy,
	kcy: kcy,
	Kfr: Kfr,
	kfr: kfr,
	kgreen: kgreen,
	KHcy: KHcy,
	khcy: khcy,
	KJcy: KJcy,
	kjcy: kjcy,
	Kopf: Kopf,
	kopf: kopf,
	Kscr: Kscr,
	kscr: kscr,
	lAarr: lAarr,
	Lacute: Lacute,
	lacute: lacute,
	laemptyv: laemptyv,
	lagran: lagran,
	Lambda: Lambda,
	lambda: lambda,
	lang: lang,
	Lang: Lang,
	langd: langd,
	langle: langle,
	lap: lap,
	Laplacetrf: Laplacetrf,
	laquo: laquo$1,
	larrb: larrb,
	larrbfs: larrbfs,
	larr: larr,
	Larr: Larr,
	lArr: lArr,
	larrfs: larrfs,
	larrhk: larrhk,
	larrlp: larrlp,
	larrpl: larrpl,
	larrsim: larrsim,
	larrtl: larrtl,
	latail: latail,
	lAtail: lAtail,
	lat: lat,
	late: late,
	lates: lates,
	lbarr: lbarr,
	lBarr: lBarr,
	lbbrk: lbbrk,
	lbrace: lbrace,
	lbrack: lbrack,
	lbrke: lbrke,
	lbrksld: lbrksld,
	lbrkslu: lbrkslu,
	Lcaron: Lcaron,
	lcaron: lcaron,
	Lcedil: Lcedil,
	lcedil: lcedil,
	lceil: lceil,
	lcub: lcub,
	Lcy: Lcy,
	lcy: lcy,
	ldca: ldca,
	ldquo: ldquo,
	ldquor: ldquor,
	ldrdhar: ldrdhar,
	ldrushar: ldrushar,
	ldsh: ldsh,
	le: le,
	lE: lE,
	LeftAngleBracket: LeftAngleBracket,
	LeftArrowBar: LeftArrowBar,
	leftarrow: leftarrow,
	LeftArrow: LeftArrow,
	Leftarrow: Leftarrow,
	LeftArrowRightArrow: LeftArrowRightArrow,
	leftarrowtail: leftarrowtail,
	LeftCeiling: LeftCeiling,
	LeftDoubleBracket: LeftDoubleBracket,
	LeftDownTeeVector: LeftDownTeeVector,
	LeftDownVectorBar: LeftDownVectorBar,
	LeftDownVector: LeftDownVector,
	LeftFloor: LeftFloor,
	leftharpoondown: leftharpoondown,
	leftharpoonup: leftharpoonup,
	leftleftarrows: leftleftarrows,
	leftrightarrow: leftrightarrow,
	LeftRightArrow: LeftRightArrow,
	Leftrightarrow: Leftrightarrow,
	leftrightarrows: leftrightarrows,
	leftrightharpoons: leftrightharpoons,
	leftrightsquigarrow: leftrightsquigarrow,
	LeftRightVector: LeftRightVector,
	LeftTeeArrow: LeftTeeArrow,
	LeftTee: LeftTee,
	LeftTeeVector: LeftTeeVector,
	leftthreetimes: leftthreetimes,
	LeftTriangleBar: LeftTriangleBar,
	LeftTriangle: LeftTriangle,
	LeftTriangleEqual: LeftTriangleEqual,
	LeftUpDownVector: LeftUpDownVector,
	LeftUpTeeVector: LeftUpTeeVector,
	LeftUpVectorBar: LeftUpVectorBar,
	LeftUpVector: LeftUpVector,
	LeftVectorBar: LeftVectorBar,
	LeftVector: LeftVector,
	lEg: lEg,
	leg: leg,
	leq: leq,
	leqq: leqq,
	leqslant: leqslant,
	lescc: lescc,
	les: les,
	lesdot: lesdot,
	lesdoto: lesdoto,
	lesdotor: lesdotor,
	lesg: lesg,
	lesges: lesges,
	lessapprox: lessapprox,
	lessdot: lessdot,
	lesseqgtr: lesseqgtr,
	lesseqqgtr: lesseqqgtr,
	LessEqualGreater: LessEqualGreater,
	LessFullEqual: LessFullEqual,
	LessGreater: LessGreater,
	lessgtr: lessgtr,
	LessLess: LessLess,
	lesssim: lesssim,
	LessSlantEqual: LessSlantEqual,
	LessTilde: LessTilde,
	lfisht: lfisht,
	lfloor: lfloor,
	Lfr: Lfr,
	lfr: lfr,
	lg: lg,
	lgE: lgE,
	lHar: lHar,
	lhard: lhard,
	lharu: lharu,
	lharul: lharul,
	lhblk: lhblk,
	LJcy: LJcy,
	ljcy: ljcy,
	llarr: llarr,
	ll: ll,
	Ll: Ll,
	llcorner: llcorner,
	Lleftarrow: Lleftarrow,
	llhard: llhard,
	lltri: lltri,
	Lmidot: Lmidot,
	lmidot: lmidot,
	lmoustache: lmoustache,
	lmoust: lmoust,
	lnap: lnap,
	lnapprox: lnapprox,
	lne: lne,
	lnE: lnE,
	lneq: lneq,
	lneqq: lneqq,
	lnsim: lnsim,
	loang: loang,
	loarr: loarr,
	lobrk: lobrk,
	longleftarrow: longleftarrow,
	LongLeftArrow: LongLeftArrow,
	Longleftarrow: Longleftarrow,
	longleftrightarrow: longleftrightarrow,
	LongLeftRightArrow: LongLeftRightArrow,
	Longleftrightarrow: Longleftrightarrow,
	longmapsto: longmapsto,
	longrightarrow: longrightarrow,
	LongRightArrow: LongRightArrow,
	Longrightarrow: Longrightarrow,
	looparrowleft: looparrowleft,
	looparrowright: looparrowright,
	lopar: lopar,
	Lopf: Lopf,
	lopf: lopf,
	loplus: loplus,
	lotimes: lotimes,
	lowast: lowast,
	lowbar: lowbar,
	LowerLeftArrow: LowerLeftArrow,
	LowerRightArrow: LowerRightArrow,
	loz: loz,
	lozenge: lozenge,
	lozf: lozf,
	lpar: lpar,
	lparlt: lparlt,
	lrarr: lrarr,
	lrcorner: lrcorner,
	lrhar: lrhar,
	lrhard: lrhard,
	lrm: lrm,
	lrtri: lrtri,
	lsaquo: lsaquo,
	lscr: lscr,
	Lscr: Lscr,
	lsh: lsh,
	Lsh: Lsh,
	lsim: lsim,
	lsime: lsime,
	lsimg: lsimg,
	lsqb: lsqb,
	lsquo: lsquo,
	lsquor: lsquor,
	Lstrok: Lstrok,
	lstrok: lstrok,
	ltcc: ltcc,
	ltcir: ltcir,
	lt: lt$2,
	LT: LT$1,
	Lt: Lt,
	ltdot: ltdot,
	lthree: lthree,
	ltimes: ltimes,
	ltlarr: ltlarr,
	ltquest: ltquest,
	ltri: ltri,
	ltrie: ltrie,
	ltrif: ltrif,
	ltrPar: ltrPar,
	lurdshar: lurdshar,
	luruhar: luruhar,
	lvertneqq: lvertneqq,
	lvnE: lvnE,
	macr: macr$1,
	male: male,
	malt: malt,
	maltese: maltese,
	"Map": "⤅",
	map: map,
	mapsto: mapsto,
	mapstodown: mapstodown,
	mapstoleft: mapstoleft,
	mapstoup: mapstoup,
	marker: marker,
	mcomma: mcomma,
	Mcy: Mcy,
	mcy: mcy,
	mdash: mdash,
	mDDot: mDDot,
	measuredangle: measuredangle,
	MediumSpace: MediumSpace,
	Mellintrf: Mellintrf,
	Mfr: Mfr,
	mfr: mfr,
	mho: mho,
	micro: micro$1,
	midast: midast,
	midcir: midcir,
	mid: mid,
	middot: middot$1,
	minusb: minusb,
	minus: minus,
	minusd: minusd,
	minusdu: minusdu,
	MinusPlus: MinusPlus,
	mlcp: mlcp,
	mldr: mldr,
	mnplus: mnplus,
	models: models,
	Mopf: Mopf,
	mopf: mopf,
	mp: mp,
	mscr: mscr,
	Mscr: Mscr,
	mstpos: mstpos,
	Mu: Mu,
	mu: mu,
	multimap: multimap,
	mumap: mumap,
	nabla: nabla,
	Nacute: Nacute,
	nacute: nacute,
	nang: nang,
	nap: nap,
	napE: napE,
	napid: napid,
	napos: napos,
	napprox: napprox,
	natural: natural,
	naturals: naturals,
	natur: natur,
	nbsp: nbsp$1,
	nbump: nbump,
	nbumpe: nbumpe,
	ncap: ncap,
	Ncaron: Ncaron,
	ncaron: ncaron,
	Ncedil: Ncedil,
	ncedil: ncedil,
	ncong: ncong,
	ncongdot: ncongdot,
	ncup: ncup,
	Ncy: Ncy,
	ncy: ncy,
	ndash: ndash,
	nearhk: nearhk,
	nearr: nearr,
	neArr: neArr,
	nearrow: nearrow,
	ne: ne,
	nedot: nedot,
	NegativeMediumSpace: NegativeMediumSpace,
	NegativeThickSpace: NegativeThickSpace,
	NegativeThinSpace: NegativeThinSpace,
	NegativeVeryThinSpace: NegativeVeryThinSpace,
	nequiv: nequiv,
	nesear: nesear,
	nesim: nesim,
	NestedGreaterGreater: NestedGreaterGreater,
	NestedLessLess: NestedLessLess,
	NewLine: NewLine,
	nexist: nexist,
	nexists: nexists,
	Nfr: Nfr,
	nfr: nfr,
	ngE: ngE,
	nge: nge,
	ngeq: ngeq,
	ngeqq: ngeqq,
	ngeqslant: ngeqslant,
	nges: nges,
	nGg: nGg,
	ngsim: ngsim,
	nGt: nGt,
	ngt: ngt,
	ngtr: ngtr,
	nGtv: nGtv,
	nharr: nharr,
	nhArr: nhArr,
	nhpar: nhpar,
	ni: ni,
	nis: nis,
	nisd: nisd,
	niv: niv,
	NJcy: NJcy,
	njcy: njcy,
	nlarr: nlarr,
	nlArr: nlArr,
	nldr: nldr,
	nlE: nlE,
	nle: nle,
	nleftarrow: nleftarrow,
	nLeftarrow: nLeftarrow,
	nleftrightarrow: nleftrightarrow,
	nLeftrightarrow: nLeftrightarrow,
	nleq: nleq,
	nleqq: nleqq,
	nleqslant: nleqslant,
	nles: nles,
	nless: nless,
	nLl: nLl,
	nlsim: nlsim,
	nLt: nLt,
	nlt: nlt,
	nltri: nltri,
	nltrie: nltrie,
	nLtv: nLtv,
	nmid: nmid,
	NoBreak: NoBreak,
	NonBreakingSpace: NonBreakingSpace,
	nopf: nopf,
	Nopf: Nopf,
	Not: Not,
	not: not$1,
	NotCongruent: NotCongruent,
	NotCupCap: NotCupCap,
	NotDoubleVerticalBar: NotDoubleVerticalBar,
	NotElement: NotElement,
	NotEqual: NotEqual,
	NotEqualTilde: NotEqualTilde,
	NotExists: NotExists,
	NotGreater: NotGreater,
	NotGreaterEqual: NotGreaterEqual,
	NotGreaterFullEqual: NotGreaterFullEqual,
	NotGreaterGreater: NotGreaterGreater,
	NotGreaterLess: NotGreaterLess,
	NotGreaterSlantEqual: NotGreaterSlantEqual,
	NotGreaterTilde: NotGreaterTilde,
	NotHumpDownHump: NotHumpDownHump,
	NotHumpEqual: NotHumpEqual,
	notin: notin,
	notindot: notindot,
	notinE: notinE,
	notinva: notinva,
	notinvb: notinvb,
	notinvc: notinvc,
	NotLeftTriangleBar: NotLeftTriangleBar,
	NotLeftTriangle: NotLeftTriangle,
	NotLeftTriangleEqual: NotLeftTriangleEqual,
	NotLess: NotLess,
	NotLessEqual: NotLessEqual,
	NotLessGreater: NotLessGreater,
	NotLessLess: NotLessLess,
	NotLessSlantEqual: NotLessSlantEqual,
	NotLessTilde: NotLessTilde,
	NotNestedGreaterGreater: NotNestedGreaterGreater,
	NotNestedLessLess: NotNestedLessLess,
	notni: notni,
	notniva: notniva,
	notnivb: notnivb,
	notnivc: notnivc,
	NotPrecedes: NotPrecedes,
	NotPrecedesEqual: NotPrecedesEqual,
	NotPrecedesSlantEqual: NotPrecedesSlantEqual,
	NotReverseElement: NotReverseElement,
	NotRightTriangleBar: NotRightTriangleBar,
	NotRightTriangle: NotRightTriangle,
	NotRightTriangleEqual: NotRightTriangleEqual,
	NotSquareSubset: NotSquareSubset,
	NotSquareSubsetEqual: NotSquareSubsetEqual,
	NotSquareSuperset: NotSquareSuperset,
	NotSquareSupersetEqual: NotSquareSupersetEqual,
	NotSubset: NotSubset,
	NotSubsetEqual: NotSubsetEqual,
	NotSucceeds: NotSucceeds,
	NotSucceedsEqual: NotSucceedsEqual,
	NotSucceedsSlantEqual: NotSucceedsSlantEqual,
	NotSucceedsTilde: NotSucceedsTilde,
	NotSuperset: NotSuperset,
	NotSupersetEqual: NotSupersetEqual,
	NotTilde: NotTilde,
	NotTildeEqual: NotTildeEqual,
	NotTildeFullEqual: NotTildeFullEqual,
	NotTildeTilde: NotTildeTilde,
	NotVerticalBar: NotVerticalBar,
	nparallel: nparallel,
	npar: npar,
	nparsl: nparsl,
	npart: npart,
	npolint: npolint,
	npr: npr,
	nprcue: nprcue,
	nprec: nprec,
	npreceq: npreceq,
	npre: npre,
	nrarrc: nrarrc,
	nrarr: nrarr,
	nrArr: nrArr,
	nrarrw: nrarrw,
	nrightarrow: nrightarrow,
	nRightarrow: nRightarrow,
	nrtri: nrtri,
	nrtrie: nrtrie,
	nsc: nsc,
	nsccue: nsccue,
	nsce: nsce,
	Nscr: Nscr,
	nscr: nscr,
	nshortmid: nshortmid,
	nshortparallel: nshortparallel,
	nsim: nsim,
	nsime: nsime,
	nsimeq: nsimeq,
	nsmid: nsmid,
	nspar: nspar,
	nsqsube: nsqsube,
	nsqsupe: nsqsupe,
	nsub: nsub,
	nsubE: nsubE,
	nsube: nsube,
	nsubset: nsubset,
	nsubseteq: nsubseteq,
	nsubseteqq: nsubseteqq,
	nsucc: nsucc,
	nsucceq: nsucceq,
	nsup: nsup,
	nsupE: nsupE,
	nsupe: nsupe,
	nsupset: nsupset,
	nsupseteq: nsupseteq,
	nsupseteqq: nsupseteqq,
	ntgl: ntgl,
	Ntilde: Ntilde$1,
	ntilde: ntilde$1,
	ntlg: ntlg,
	ntriangleleft: ntriangleleft,
	ntrianglelefteq: ntrianglelefteq,
	ntriangleright: ntriangleright,
	ntrianglerighteq: ntrianglerighteq,
	Nu: Nu,
	nu: nu,
	num: num,
	numero: numero,
	numsp: numsp,
	nvap: nvap,
	nvdash: nvdash,
	nvDash: nvDash,
	nVdash: nVdash,
	nVDash: nVDash,
	nvge: nvge,
	nvgt: nvgt,
	nvHarr: nvHarr,
	nvinfin: nvinfin,
	nvlArr: nvlArr,
	nvle: nvle,
	nvlt: nvlt,
	nvltrie: nvltrie,
	nvrArr: nvrArr,
	nvrtrie: nvrtrie,
	nvsim: nvsim,
	nwarhk: nwarhk,
	nwarr: nwarr,
	nwArr: nwArr,
	nwarrow: nwarrow,
	nwnear: nwnear,
	Oacute: Oacute$1,
	oacute: oacute$1,
	oast: oast,
	Ocirc: Ocirc$1,
	ocirc: ocirc$1,
	ocir: ocir,
	Ocy: Ocy,
	ocy: ocy,
	odash: odash,
	Odblac: Odblac,
	odblac: odblac,
	odiv: odiv,
	odot: odot,
	odsold: odsold,
	OElig: OElig,
	oelig: oelig,
	ofcir: ofcir,
	Ofr: Ofr,
	ofr: ofr,
	ogon: ogon,
	Ograve: Ograve$1,
	ograve: ograve$1,
	ogt: ogt,
	ohbar: ohbar,
	ohm: ohm,
	oint: oint,
	olarr: olarr,
	olcir: olcir,
	olcross: olcross,
	oline: oline,
	olt: olt,
	Omacr: Omacr,
	omacr: omacr,
	Omega: Omega,
	omega: omega,
	Omicron: Omicron,
	omicron: omicron,
	omid: omid,
	ominus: ominus,
	Oopf: Oopf,
	oopf: oopf,
	opar: opar,
	OpenCurlyDoubleQuote: OpenCurlyDoubleQuote,
	OpenCurlyQuote: OpenCurlyQuote,
	operp: operp,
	oplus: oplus,
	orarr: orarr,
	Or: Or,
	or: or,
	ord: ord,
	order: order,
	orderof: orderof,
	ordf: ordf$1,
	ordm: ordm$1,
	origof: origof,
	oror: oror,
	orslope: orslope,
	orv: orv,
	oS: oS,
	Oscr: Oscr,
	oscr: oscr,
	Oslash: Oslash$1,
	oslash: oslash$1,
	osol: osol,
	Otilde: Otilde$1,
	otilde: otilde$1,
	otimesas: otimesas,
	Otimes: Otimes,
	otimes: otimes,
	Ouml: Ouml$1,
	ouml: ouml$1,
	ovbar: ovbar,
	OverBar: OverBar,
	OverBrace: OverBrace,
	OverBracket: OverBracket,
	OverParenthesis: OverParenthesis,
	para: para$1,
	parallel: parallel,
	par: par,
	parsim: parsim,
	parsl: parsl,
	part: part,
	PartialD: PartialD,
	Pcy: Pcy,
	pcy: pcy,
	percnt: percnt,
	period: period,
	permil: permil,
	perp: perp,
	pertenk: pertenk,
	Pfr: Pfr,
	pfr: pfr,
	Phi: Phi,
	phi: phi,
	phiv: phiv,
	phmmat: phmmat,
	phone: phone,
	Pi: Pi,
	pi: pi,
	pitchfork: pitchfork,
	piv: piv,
	planck: planck,
	planckh: planckh,
	plankv: plankv,
	plusacir: plusacir,
	plusb: plusb,
	pluscir: pluscir,
	plus: plus,
	plusdo: plusdo,
	plusdu: plusdu,
	pluse: pluse,
	PlusMinus: PlusMinus,
	plusmn: plusmn$1,
	plussim: plussim,
	plustwo: plustwo,
	pm: pm,
	Poincareplane: Poincareplane,
	pointint: pointint,
	popf: popf,
	Popf: Popf,
	pound: pound$1,
	prap: prap,
	Pr: Pr,
	pr: pr,
	prcue: prcue,
	precapprox: precapprox,
	prec: prec,
	preccurlyeq: preccurlyeq,
	Precedes: Precedes,
	PrecedesEqual: PrecedesEqual,
	PrecedesSlantEqual: PrecedesSlantEqual,
	PrecedesTilde: PrecedesTilde,
	preceq: preceq,
	precnapprox: precnapprox,
	precneqq: precneqq,
	precnsim: precnsim,
	pre: pre,
	prE: prE,
	precsim: precsim,
	prime: prime,
	Prime: Prime,
	primes: primes,
	prnap: prnap,
	prnE: prnE,
	prnsim: prnsim,
	prod: prod,
	Product: Product,
	profalar: profalar,
	profline: profline,
	profsurf: profsurf,
	prop: prop,
	Proportional: Proportional,
	Proportion: Proportion,
	propto: propto,
	prsim: prsim,
	prurel: prurel,
	Pscr: Pscr,
	pscr: pscr,
	Psi: Psi,
	psi: psi,
	puncsp: puncsp,
	Qfr: Qfr,
	qfr: qfr,
	qint: qint,
	qopf: qopf,
	Qopf: Qopf,
	qprime: qprime,
	Qscr: Qscr,
	qscr: qscr,
	quaternions: quaternions,
	quatint: quatint,
	quest: quest,
	questeq: questeq,
	quot: quot$2,
	QUOT: QUOT$1,
	rAarr: rAarr,
	race: race,
	Racute: Racute,
	racute: racute,
	radic: radic,
	raemptyv: raemptyv,
	rang: rang,
	Rang: Rang,
	rangd: rangd,
	range: range,
	rangle: rangle,
	raquo: raquo$1,
	rarrap: rarrap,
	rarrb: rarrb,
	rarrbfs: rarrbfs,
	rarrc: rarrc,
	rarr: rarr,
	Rarr: Rarr,
	rArr: rArr,
	rarrfs: rarrfs,
	rarrhk: rarrhk,
	rarrlp: rarrlp,
	rarrpl: rarrpl,
	rarrsim: rarrsim,
	Rarrtl: Rarrtl,
	rarrtl: rarrtl,
	rarrw: rarrw,
	ratail: ratail,
	rAtail: rAtail,
	ratio: ratio,
	rationals: rationals,
	rbarr: rbarr,
	rBarr: rBarr,
	RBarr: RBarr,
	rbbrk: rbbrk,
	rbrace: rbrace,
	rbrack: rbrack,
	rbrke: rbrke,
	rbrksld: rbrksld,
	rbrkslu: rbrkslu,
	Rcaron: Rcaron,
	rcaron: rcaron,
	Rcedil: Rcedil,
	rcedil: rcedil,
	rceil: rceil,
	rcub: rcub,
	Rcy: Rcy,
	rcy: rcy,
	rdca: rdca,
	rdldhar: rdldhar,
	rdquo: rdquo,
	rdquor: rdquor,
	rdsh: rdsh,
	real: real,
	realine: realine,
	realpart: realpart,
	reals: reals,
	Re: Re,
	rect: rect,
	reg: reg$1,
	REG: REG$1,
	ReverseElement: ReverseElement,
	ReverseEquilibrium: ReverseEquilibrium,
	ReverseUpEquilibrium: ReverseUpEquilibrium,
	rfisht: rfisht,
	rfloor: rfloor,
	rfr: rfr,
	Rfr: Rfr,
	rHar: rHar,
	rhard: rhard,
	rharu: rharu,
	rharul: rharul,
	Rho: Rho,
	rho: rho,
	rhov: rhov,
	RightAngleBracket: RightAngleBracket,
	RightArrowBar: RightArrowBar,
	rightarrow: rightarrow,
	RightArrow: RightArrow,
	Rightarrow: Rightarrow,
	RightArrowLeftArrow: RightArrowLeftArrow,
	rightarrowtail: rightarrowtail,
	RightCeiling: RightCeiling,
	RightDoubleBracket: RightDoubleBracket,
	RightDownTeeVector: RightDownTeeVector,
	RightDownVectorBar: RightDownVectorBar,
	RightDownVector: RightDownVector,
	RightFloor: RightFloor,
	rightharpoondown: rightharpoondown,
	rightharpoonup: rightharpoonup,
	rightleftarrows: rightleftarrows,
	rightleftharpoons: rightleftharpoons,
	rightrightarrows: rightrightarrows,
	rightsquigarrow: rightsquigarrow,
	RightTeeArrow: RightTeeArrow,
	RightTee: RightTee,
	RightTeeVector: RightTeeVector,
	rightthreetimes: rightthreetimes,
	RightTriangleBar: RightTriangleBar,
	RightTriangle: RightTriangle,
	RightTriangleEqual: RightTriangleEqual,
	RightUpDownVector: RightUpDownVector,
	RightUpTeeVector: RightUpTeeVector,
	RightUpVectorBar: RightUpVectorBar,
	RightUpVector: RightUpVector,
	RightVectorBar: RightVectorBar,
	RightVector: RightVector,
	ring: ring,
	risingdotseq: risingdotseq,
	rlarr: rlarr,
	rlhar: rlhar,
	rlm: rlm,
	rmoustache: rmoustache,
	rmoust: rmoust,
	rnmid: rnmid,
	roang: roang,
	roarr: roarr,
	robrk: robrk,
	ropar: ropar,
	ropf: ropf,
	Ropf: Ropf,
	roplus: roplus,
	rotimes: rotimes,
	RoundImplies: RoundImplies,
	rpar: rpar,
	rpargt: rpargt,
	rppolint: rppolint,
	rrarr: rrarr,
	Rrightarrow: Rrightarrow,
	rsaquo: rsaquo,
	rscr: rscr,
	Rscr: Rscr,
	rsh: rsh,
	Rsh: Rsh,
	rsqb: rsqb,
	rsquo: rsquo,
	rsquor: rsquor,
	rthree: rthree,
	rtimes: rtimes,
	rtri: rtri,
	rtrie: rtrie,
	rtrif: rtrif,
	rtriltri: rtriltri,
	RuleDelayed: RuleDelayed,
	ruluhar: ruluhar,
	rx: rx,
	Sacute: Sacute,
	sacute: sacute,
	sbquo: sbquo,
	scap: scap,
	Scaron: Scaron,
	scaron: scaron,
	Sc: Sc,
	sc: sc,
	sccue: sccue,
	sce: sce,
	scE: scE,
	Scedil: Scedil,
	scedil: scedil,
	Scirc: Scirc,
	scirc: scirc,
	scnap: scnap,
	scnE: scnE,
	scnsim: scnsim,
	scpolint: scpolint,
	scsim: scsim,
	Scy: Scy,
	scy: scy,
	sdotb: sdotb,
	sdot: sdot,
	sdote: sdote,
	searhk: searhk,
	searr: searr,
	seArr: seArr,
	searrow: searrow,
	sect: sect$1,
	semi: semi,
	seswar: seswar,
	setminus: setminus,
	setmn: setmn,
	sext: sext,
	Sfr: Sfr,
	sfr: sfr,
	sfrown: sfrown,
	sharp: sharp,
	SHCHcy: SHCHcy,
	shchcy: shchcy,
	SHcy: SHcy,
	shcy: shcy,
	ShortDownArrow: ShortDownArrow,
	ShortLeftArrow: ShortLeftArrow,
	shortmid: shortmid,
	shortparallel: shortparallel,
	ShortRightArrow: ShortRightArrow,
	ShortUpArrow: ShortUpArrow,
	shy: shy$1,
	Sigma: Sigma,
	sigma: sigma,
	sigmaf: sigmaf,
	sigmav: sigmav,
	sim: sim,
	simdot: simdot,
	sime: sime,
	simeq: simeq,
	simg: simg,
	simgE: simgE,
	siml: siml,
	simlE: simlE,
	simne: simne,
	simplus: simplus,
	simrarr: simrarr,
	slarr: slarr,
	SmallCircle: SmallCircle,
	smallsetminus: smallsetminus,
	smashp: smashp,
	smeparsl: smeparsl,
	smid: smid,
	smile: smile,
	smt: smt,
	smte: smte,
	smtes: smtes,
	SOFTcy: SOFTcy,
	softcy: softcy,
	solbar: solbar,
	solb: solb,
	sol: sol,
	Sopf: Sopf,
	sopf: sopf,
	spades: spades,
	spadesuit: spadesuit,
	spar: spar,
	sqcap: sqcap,
	sqcaps: sqcaps,
	sqcup: sqcup,
	sqcups: sqcups,
	Sqrt: Sqrt,
	sqsub: sqsub,
	sqsube: sqsube,
	sqsubset: sqsubset,
	sqsubseteq: sqsubseteq,
	sqsup: sqsup,
	sqsupe: sqsupe,
	sqsupset: sqsupset,
	sqsupseteq: sqsupseteq,
	square: square,
	Square: Square,
	SquareIntersection: SquareIntersection,
	SquareSubset: SquareSubset,
	SquareSubsetEqual: SquareSubsetEqual,
	SquareSuperset: SquareSuperset,
	SquareSupersetEqual: SquareSupersetEqual,
	SquareUnion: SquareUnion,
	squarf: squarf,
	squ: squ,
	squf: squf,
	srarr: srarr,
	Sscr: Sscr,
	sscr: sscr,
	ssetmn: ssetmn,
	ssmile: ssmile,
	sstarf: sstarf,
	Star: Star,
	star: star,
	starf: starf,
	straightepsilon: straightepsilon,
	straightphi: straightphi,
	strns: strns,
	sub: sub,
	Sub: Sub,
	subdot: subdot,
	subE: subE,
	sube: sube,
	subedot: subedot,
	submult: submult,
	subnE: subnE,
	subne: subne,
	subplus: subplus,
	subrarr: subrarr,
	subset: subset,
	Subset: Subset,
	subseteq: subseteq,
	subseteqq: subseteqq,
	SubsetEqual: SubsetEqual,
	subsetneq: subsetneq,
	subsetneqq: subsetneqq,
	subsim: subsim,
	subsub: subsub,
	subsup: subsup,
	succapprox: succapprox,
	succ: succ,
	succcurlyeq: succcurlyeq,
	Succeeds: Succeeds,
	SucceedsEqual: SucceedsEqual,
	SucceedsSlantEqual: SucceedsSlantEqual,
	SucceedsTilde: SucceedsTilde,
	succeq: succeq,
	succnapprox: succnapprox,
	succneqq: succneqq,
	succnsim: succnsim,
	succsim: succsim,
	SuchThat: SuchThat,
	sum: sum,
	Sum: Sum,
	sung: sung,
	sup1: sup1$1,
	sup2: sup2$1,
	sup3: sup3$1,
	sup: sup,
	Sup: Sup,
	supdot: supdot,
	supdsub: supdsub,
	supE: supE,
	supe: supe,
	supedot: supedot,
	Superset: Superset,
	SupersetEqual: SupersetEqual,
	suphsol: suphsol,
	suphsub: suphsub,
	suplarr: suplarr,
	supmult: supmult,
	supnE: supnE,
	supne: supne,
	supplus: supplus,
	supset: supset,
	Supset: Supset,
	supseteq: supseteq,
	supseteqq: supseteqq,
	supsetneq: supsetneq,
	supsetneqq: supsetneqq,
	supsim: supsim,
	supsub: supsub,
	supsup: supsup,
	swarhk: swarhk,
	swarr: swarr,
	swArr: swArr,
	swarrow: swarrow,
	swnwar: swnwar,
	szlig: szlig$1,
	Tab: Tab,
	target: target,
	Tau: Tau,
	tau: tau,
	tbrk: tbrk,
	Tcaron: Tcaron,
	tcaron: tcaron,
	Tcedil: Tcedil,
	tcedil: tcedil,
	Tcy: Tcy,
	tcy: tcy,
	tdot: tdot,
	telrec: telrec,
	Tfr: Tfr,
	tfr: tfr,
	there4: there4,
	therefore: therefore,
	Therefore: Therefore,
	Theta: Theta,
	theta: theta,
	thetasym: thetasym,
	thetav: thetav,
	thickapprox: thickapprox,
	thicksim: thicksim,
	ThickSpace: ThickSpace,
	ThinSpace: ThinSpace,
	thinsp: thinsp,
	thkap: thkap,
	thksim: thksim,
	THORN: THORN$1,
	thorn: thorn$1,
	tilde: tilde,
	Tilde: Tilde,
	TildeEqual: TildeEqual,
	TildeFullEqual: TildeFullEqual,
	TildeTilde: TildeTilde,
	timesbar: timesbar,
	timesb: timesb,
	times: times$1,
	timesd: timesd,
	tint: tint,
	toea: toea,
	topbot: topbot,
	topcir: topcir,
	top: top,
	Topf: Topf,
	topf: topf,
	topfork: topfork,
	tosa: tosa,
	tprime: tprime,
	trade: trade,
	TRADE: TRADE,
	triangle: triangle,
	triangledown: triangledown,
	triangleleft: triangleleft,
	trianglelefteq: trianglelefteq,
	triangleq: triangleq,
	triangleright: triangleright,
	trianglerighteq: trianglerighteq,
	tridot: tridot,
	trie: trie,
	triminus: triminus,
	TripleDot: TripleDot,
	triplus: triplus,
	trisb: trisb,
	tritime: tritime,
	trpezium: trpezium,
	Tscr: Tscr,
	tscr: tscr,
	TScy: TScy,
	tscy: tscy,
	TSHcy: TSHcy,
	tshcy: tshcy,
	Tstrok: Tstrok,
	tstrok: tstrok,
	twixt: twixt,
	twoheadleftarrow: twoheadleftarrow,
	twoheadrightarrow: twoheadrightarrow,
	Uacute: Uacute$1,
	uacute: uacute$1,
	uarr: uarr,
	Uarr: Uarr,
	uArr: uArr,
	Uarrocir: Uarrocir,
	Ubrcy: Ubrcy,
	ubrcy: ubrcy,
	Ubreve: Ubreve,
	ubreve: ubreve,
	Ucirc: Ucirc$1,
	ucirc: ucirc$1,
	Ucy: Ucy,
	ucy: ucy,
	udarr: udarr,
	Udblac: Udblac,
	udblac: udblac,
	udhar: udhar,
	ufisht: ufisht,
	Ufr: Ufr,
	ufr: ufr,
	Ugrave: Ugrave$1,
	ugrave: ugrave$1,
	uHar: uHar,
	uharl: uharl,
	uharr: uharr,
	uhblk: uhblk,
	ulcorn: ulcorn,
	ulcorner: ulcorner,
	ulcrop: ulcrop,
	ultri: ultri,
	Umacr: Umacr,
	umacr: umacr,
	uml: uml$1,
	UnderBar: UnderBar,
	UnderBrace: UnderBrace,
	UnderBracket: UnderBracket,
	UnderParenthesis: UnderParenthesis,
	Union: Union,
	UnionPlus: UnionPlus,
	Uogon: Uogon,
	uogon: uogon,
	Uopf: Uopf,
	uopf: uopf,
	UpArrowBar: UpArrowBar,
	uparrow: uparrow,
	UpArrow: UpArrow,
	Uparrow: Uparrow,
	UpArrowDownArrow: UpArrowDownArrow,
	updownarrow: updownarrow,
	UpDownArrow: UpDownArrow,
	Updownarrow: Updownarrow,
	UpEquilibrium: UpEquilibrium,
	upharpoonleft: upharpoonleft,
	upharpoonright: upharpoonright,
	uplus: uplus,
	UpperLeftArrow: UpperLeftArrow,
	UpperRightArrow: UpperRightArrow,
	upsi: upsi,
	Upsi: Upsi,
	upsih: upsih,
	Upsilon: Upsilon,
	upsilon: upsilon,
	UpTeeArrow: UpTeeArrow,
	UpTee: UpTee,
	upuparrows: upuparrows,
	urcorn: urcorn,
	urcorner: urcorner,
	urcrop: urcrop,
	Uring: Uring,
	uring: uring,
	urtri: urtri,
	Uscr: Uscr,
	uscr: uscr,
	utdot: utdot,
	Utilde: Utilde,
	utilde: utilde,
	utri: utri,
	utrif: utrif,
	uuarr: uuarr,
	Uuml: Uuml$1,
	uuml: uuml$1,
	uwangle: uwangle,
	vangrt: vangrt,
	varepsilon: varepsilon,
	varkappa: varkappa,
	varnothing: varnothing,
	varphi: varphi,
	varpi: varpi,
	varpropto: varpropto,
	varr: varr,
	vArr: vArr,
	varrho: varrho,
	varsigma: varsigma,
	varsubsetneq: varsubsetneq,
	varsubsetneqq: varsubsetneqq,
	varsupsetneq: varsupsetneq,
	varsupsetneqq: varsupsetneqq,
	vartheta: vartheta,
	vartriangleleft: vartriangleleft,
	vartriangleright: vartriangleright,
	vBar: vBar,
	Vbar: Vbar,
	vBarv: vBarv,
	Vcy: Vcy,
	vcy: vcy,
	vdash: vdash,
	vDash: vDash,
	Vdash: Vdash,
	VDash: VDash,
	Vdashl: Vdashl,
	veebar: veebar,
	vee: vee,
	Vee: Vee,
	veeeq: veeeq,
	vellip: vellip,
	verbar: verbar,
	Verbar: Verbar,
	vert: vert,
	Vert: Vert,
	VerticalBar: VerticalBar,
	VerticalLine: VerticalLine,
	VerticalSeparator: VerticalSeparator,
	VerticalTilde: VerticalTilde,
	VeryThinSpace: VeryThinSpace,
	Vfr: Vfr,
	vfr: vfr,
	vltri: vltri,
	vnsub: vnsub,
	vnsup: vnsup,
	Vopf: Vopf,
	vopf: vopf,
	vprop: vprop,
	vrtri: vrtri,
	Vscr: Vscr,
	vscr: vscr,
	vsubnE: vsubnE,
	vsubne: vsubne,
	vsupnE: vsupnE,
	vsupne: vsupne,
	Vvdash: Vvdash,
	vzigzag: vzigzag,
	Wcirc: Wcirc,
	wcirc: wcirc,
	wedbar: wedbar,
	wedge: wedge,
	Wedge: Wedge,
	wedgeq: wedgeq,
	weierp: weierp,
	Wfr: Wfr,
	wfr: wfr,
	Wopf: Wopf,
	wopf: wopf,
	wp: wp,
	wr: wr,
	wreath: wreath,
	Wscr: Wscr,
	wscr: wscr,
	xcap: xcap,
	xcirc: xcirc,
	xcup: xcup,
	xdtri: xdtri,
	Xfr: Xfr,
	xfr: xfr,
	xharr: xharr,
	xhArr: xhArr,
	Xi: Xi,
	xi: xi,
	xlarr: xlarr,
	xlArr: xlArr,
	xmap: xmap,
	xnis: xnis,
	xodot: xodot,
	Xopf: Xopf,
	xopf: xopf,
	xoplus: xoplus,
	xotime: xotime,
	xrarr: xrarr,
	xrArr: xrArr,
	Xscr: Xscr,
	xscr: xscr,
	xsqcup: xsqcup,
	xuplus: xuplus,
	xutri: xutri,
	xvee: xvee,
	xwedge: xwedge,
	Yacute: Yacute$1,
	yacute: yacute$1,
	YAcy: YAcy,
	yacy: yacy,
	Ycirc: Ycirc,
	ycirc: ycirc,
	Ycy: Ycy,
	ycy: ycy,
	yen: yen$1,
	Yfr: Yfr,
	yfr: yfr,
	YIcy: YIcy,
	yicy: yicy,
	Yopf: Yopf,
	yopf: yopf,
	Yscr: Yscr,
	yscr: yscr,
	YUcy: YUcy,
	yucy: yucy,
	yuml: yuml$1,
	Yuml: Yuml,
	Zacute: Zacute,
	zacute: zacute,
	Zcaron: Zcaron,
	zcaron: zcaron,
	Zcy: Zcy,
	zcy: zcy,
	Zdot: Zdot,
	zdot: zdot,
	zeetrf: zeetrf,
	ZeroWidthSpace: ZeroWidthSpace,
	Zeta: Zeta,
	zeta: zeta,
	zfr: zfr,
	Zfr: Zfr,
	ZHcy: ZHcy,
	zhcy: zhcy,
	zigrarr: zigrarr,
	zopf: zopf,
	Zopf: Zopf,
	Zscr: Zscr,
	zscr: zscr,
	zwj: zwj,
	zwnj: zwnj
};

var entities$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Aacute: Aacute$1,
  aacute: aacute$1,
  Abreve: Abreve,
  abreve: abreve,
  ac: ac,
  acd: acd,
  acE: acE,
  Acirc: Acirc$1,
  acirc: acirc$1,
  acute: acute$1,
  Acy: Acy,
  acy: acy,
  AElig: AElig$1,
  aelig: aelig$1,
  af: af,
  Afr: Afr,
  afr: afr,
  Agrave: Agrave$1,
  agrave: agrave$1,
  alefsym: alefsym,
  aleph: aleph,
  Alpha: Alpha,
  alpha: alpha,
  Amacr: Amacr,
  amacr: amacr,
  amalg: amalg,
  amp: amp$2,
  AMP: AMP$1,
  andand: andand,
  And: And,
  and: and,
  andd: andd,
  andslope: andslope,
  andv: andv,
  ang: ang,
  ange: ange,
  angle: angle,
  angmsdaa: angmsdaa,
  angmsdab: angmsdab,
  angmsdac: angmsdac,
  angmsdad: angmsdad,
  angmsdae: angmsdae,
  angmsdaf: angmsdaf,
  angmsdag: angmsdag,
  angmsdah: angmsdah,
  angmsd: angmsd,
  angrt: angrt,
  angrtvb: angrtvb,
  angrtvbd: angrtvbd,
  angsph: angsph,
  angst: angst,
  angzarr: angzarr,
  Aogon: Aogon,
  aogon: aogon,
  Aopf: Aopf,
  aopf: aopf,
  apacir: apacir,
  ap: ap,
  apE: apE,
  ape: ape,
  apid: apid,
  apos: apos$1,
  ApplyFunction: ApplyFunction,
  approx: approx,
  approxeq: approxeq,
  Aring: Aring$1,
  aring: aring$1,
  Ascr: Ascr,
  ascr: ascr,
  Assign: Assign,
  ast: ast,
  asymp: asymp,
  asympeq: asympeq,
  Atilde: Atilde$1,
  atilde: atilde$1,
  Auml: Auml$1,
  auml: auml$1,
  awconint: awconint,
  awint: awint,
  backcong: backcong,
  backepsilon: backepsilon,
  backprime: backprime,
  backsim: backsim,
  backsimeq: backsimeq,
  Backslash: Backslash,
  Barv: Barv,
  barvee: barvee,
  barwed: barwed,
  Barwed: Barwed,
  barwedge: barwedge,
  bbrk: bbrk,
  bbrktbrk: bbrktbrk,
  bcong: bcong,
  Bcy: Bcy,
  bcy: bcy,
  bdquo: bdquo,
  becaus: becaus,
  because: because,
  Because: Because,
  bemptyv: bemptyv,
  bepsi: bepsi,
  bernou: bernou,
  Bernoullis: Bernoullis,
  Beta: Beta,
  beta: beta,
  beth: beth,
  between: between,
  Bfr: Bfr,
  bfr: bfr,
  bigcap: bigcap,
  bigcirc: bigcirc,
  bigcup: bigcup,
  bigodot: bigodot,
  bigoplus: bigoplus,
  bigotimes: bigotimes,
  bigsqcup: bigsqcup,
  bigstar: bigstar,
  bigtriangledown: bigtriangledown,
  bigtriangleup: bigtriangleup,
  biguplus: biguplus,
  bigvee: bigvee,
  bigwedge: bigwedge,
  bkarow: bkarow,
  blacklozenge: blacklozenge,
  blacksquare: blacksquare,
  blacktriangle: blacktriangle,
  blacktriangledown: blacktriangledown,
  blacktriangleleft: blacktriangleleft,
  blacktriangleright: blacktriangleright,
  blank: blank,
  blk12: blk12,
  blk14: blk14,
  blk34: blk34,
  block: block,
  bne: bne,
  bnequiv: bnequiv,
  bNot: bNot,
  bnot: bnot,
  Bopf: Bopf,
  bopf: bopf,
  bot: bot,
  bottom: bottom,
  bowtie: bowtie,
  boxbox: boxbox,
  boxdl: boxdl,
  boxdL: boxdL,
  boxDl: boxDl,
  boxDL: boxDL,
  boxdr: boxdr,
  boxdR: boxdR,
  boxDr: boxDr,
  boxDR: boxDR,
  boxh: boxh,
  boxH: boxH,
  boxhd: boxhd,
  boxHd: boxHd,
  boxhD: boxhD,
  boxHD: boxHD,
  boxhu: boxhu,
  boxHu: boxHu,
  boxhU: boxhU,
  boxHU: boxHU,
  boxminus: boxminus,
  boxplus: boxplus,
  boxtimes: boxtimes,
  boxul: boxul,
  boxuL: boxuL,
  boxUl: boxUl,
  boxUL: boxUL,
  boxur: boxur,
  boxuR: boxuR,
  boxUr: boxUr,
  boxUR: boxUR,
  boxv: boxv,
  boxV: boxV,
  boxvh: boxvh,
  boxvH: boxvH,
  boxVh: boxVh,
  boxVH: boxVH,
  boxvl: boxvl,
  boxvL: boxvL,
  boxVl: boxVl,
  boxVL: boxVL,
  boxvr: boxvr,
  boxvR: boxvR,
  boxVr: boxVr,
  boxVR: boxVR,
  bprime: bprime,
  breve: breve,
  Breve: Breve,
  brvbar: brvbar$1,
  bscr: bscr,
  Bscr: Bscr,
  bsemi: bsemi,
  bsim: bsim,
  bsime: bsime,
  bsolb: bsolb,
  bsol: bsol,
  bsolhsub: bsolhsub,
  bull: bull,
  bullet: bullet,
  bump: bump,
  bumpE: bumpE,
  bumpe: bumpe,
  Bumpeq: Bumpeq,
  bumpeq: bumpeq,
  Cacute: Cacute,
  cacute: cacute,
  capand: capand,
  capbrcup: capbrcup,
  capcap: capcap,
  cap: cap,
  Cap: Cap,
  capcup: capcup,
  capdot: capdot,
  CapitalDifferentialD: CapitalDifferentialD,
  caps: caps,
  caret: caret,
  caron: caron,
  Cayleys: Cayleys,
  ccaps: ccaps,
  Ccaron: Ccaron,
  ccaron: ccaron,
  Ccedil: Ccedil$1,
  ccedil: ccedil$1,
  Ccirc: Ccirc,
  ccirc: ccirc,
  Cconint: Cconint,
  ccups: ccups,
  ccupssm: ccupssm,
  Cdot: Cdot,
  cdot: cdot,
  cedil: cedil$1,
  Cedilla: Cedilla,
  cemptyv: cemptyv,
  cent: cent$1,
  centerdot: centerdot,
  CenterDot: CenterDot,
  cfr: cfr,
  Cfr: Cfr,
  CHcy: CHcy,
  chcy: chcy,
  check: check,
  checkmark: checkmark,
  Chi: Chi,
  chi: chi,
  circ: circ,
  circeq: circeq,
  circlearrowleft: circlearrowleft,
  circlearrowright: circlearrowright,
  circledast: circledast,
  circledcirc: circledcirc,
  circleddash: circleddash,
  CircleDot: CircleDot,
  circledR: circledR,
  circledS: circledS,
  CircleMinus: CircleMinus,
  CirclePlus: CirclePlus,
  CircleTimes: CircleTimes,
  cir: cir,
  cirE: cirE,
  cire: cire,
  cirfnint: cirfnint,
  cirmid: cirmid,
  cirscir: cirscir,
  ClockwiseContourIntegral: ClockwiseContourIntegral,
  CloseCurlyDoubleQuote: CloseCurlyDoubleQuote,
  CloseCurlyQuote: CloseCurlyQuote,
  clubs: clubs,
  clubsuit: clubsuit,
  colon: colon,
  Colon: Colon,
  Colone: Colone,
  colone: colone,
  coloneq: coloneq,
  comma: comma,
  commat: commat,
  comp: comp,
  compfn: compfn,
  complement: complement,
  complexes: complexes,
  cong: cong,
  congdot: congdot,
  Congruent: Congruent,
  conint: conint,
  Conint: Conint,
  ContourIntegral: ContourIntegral,
  copf: copf,
  Copf: Copf,
  coprod: coprod,
  Coproduct: Coproduct,
  copy: copy$1,
  COPY: COPY$1,
  copysr: copysr,
  CounterClockwiseContourIntegral: CounterClockwiseContourIntegral,
  crarr: crarr,
  cross: cross,
  Cross: Cross,
  Cscr: Cscr,
  cscr: cscr,
  csub: csub,
  csube: csube,
  csup: csup,
  csupe: csupe,
  ctdot: ctdot,
  cudarrl: cudarrl,
  cudarrr: cudarrr,
  cuepr: cuepr,
  cuesc: cuesc,
  cularr: cularr,
  cularrp: cularrp,
  cupbrcap: cupbrcap,
  cupcap: cupcap,
  CupCap: CupCap,
  cup: cup,
  Cup: Cup,
  cupcup: cupcup,
  cupdot: cupdot,
  cupor: cupor,
  cups: cups,
  curarr: curarr,
  curarrm: curarrm,
  curlyeqprec: curlyeqprec,
  curlyeqsucc: curlyeqsucc,
  curlyvee: curlyvee,
  curlywedge: curlywedge,
  curren: curren$1,
  curvearrowleft: curvearrowleft,
  curvearrowright: curvearrowright,
  cuvee: cuvee,
  cuwed: cuwed,
  cwconint: cwconint,
  cwint: cwint,
  cylcty: cylcty,
  dagger: dagger,
  Dagger: Dagger,
  daleth: daleth,
  darr: darr,
  Darr: Darr,
  dArr: dArr,
  dash: dash,
  Dashv: Dashv,
  dashv: dashv,
  dbkarow: dbkarow,
  dblac: dblac,
  Dcaron: Dcaron,
  dcaron: dcaron,
  Dcy: Dcy,
  dcy: dcy,
  ddagger: ddagger,
  ddarr: ddarr,
  DD: DD,
  dd: dd,
  DDotrahd: DDotrahd,
  ddotseq: ddotseq,
  deg: deg$1,
  Del: Del,
  Delta: Delta,
  delta: delta,
  demptyv: demptyv,
  dfisht: dfisht,
  Dfr: Dfr,
  dfr: dfr,
  dHar: dHar,
  dharl: dharl,
  dharr: dharr,
  DiacriticalAcute: DiacriticalAcute,
  DiacriticalDot: DiacriticalDot,
  DiacriticalDoubleAcute: DiacriticalDoubleAcute,
  DiacriticalGrave: DiacriticalGrave,
  DiacriticalTilde: DiacriticalTilde,
  diam: diam,
  diamond: diamond,
  Diamond: Diamond,
  diamondsuit: diamondsuit,
  diams: diams,
  die: die,
  DifferentialD: DifferentialD,
  digamma: digamma,
  disin: disin,
  div: div,
  divide: divide$1,
  divideontimes: divideontimes,
  divonx: divonx,
  DJcy: DJcy,
  djcy: djcy,
  dlcorn: dlcorn,
  dlcrop: dlcrop,
  dollar: dollar,
  Dopf: Dopf,
  dopf: dopf,
  Dot: Dot$1,
  dot: dot,
  DotDot: DotDot,
  doteq: doteq,
  doteqdot: doteqdot,
  DotEqual: DotEqual,
  dotminus: dotminus,
  dotplus: dotplus,
  dotsquare: dotsquare,
  doublebarwedge: doublebarwedge,
  DoubleContourIntegral: DoubleContourIntegral,
  DoubleDot: DoubleDot,
  DoubleDownArrow: DoubleDownArrow,
  DoubleLeftArrow: DoubleLeftArrow,
  DoubleLeftRightArrow: DoubleLeftRightArrow,
  DoubleLeftTee: DoubleLeftTee,
  DoubleLongLeftArrow: DoubleLongLeftArrow,
  DoubleLongLeftRightArrow: DoubleLongLeftRightArrow,
  DoubleLongRightArrow: DoubleLongRightArrow,
  DoubleRightArrow: DoubleRightArrow,
  DoubleRightTee: DoubleRightTee,
  DoubleUpArrow: DoubleUpArrow,
  DoubleUpDownArrow: DoubleUpDownArrow,
  DoubleVerticalBar: DoubleVerticalBar,
  DownArrowBar: DownArrowBar,
  downarrow: downarrow,
  DownArrow: DownArrow,
  Downarrow: Downarrow,
  DownArrowUpArrow: DownArrowUpArrow,
  DownBreve: DownBreve,
  downdownarrows: downdownarrows,
  downharpoonleft: downharpoonleft,
  downharpoonright: downharpoonright,
  DownLeftRightVector: DownLeftRightVector,
  DownLeftTeeVector: DownLeftTeeVector,
  DownLeftVectorBar: DownLeftVectorBar,
  DownLeftVector: DownLeftVector,
  DownRightTeeVector: DownRightTeeVector,
  DownRightVectorBar: DownRightVectorBar,
  DownRightVector: DownRightVector,
  DownTeeArrow: DownTeeArrow,
  DownTee: DownTee,
  drbkarow: drbkarow,
  drcorn: drcorn,
  drcrop: drcrop,
  Dscr: Dscr,
  dscr: dscr,
  DScy: DScy,
  dscy: dscy,
  dsol: dsol,
  Dstrok: Dstrok,
  dstrok: dstrok,
  dtdot: dtdot,
  dtri: dtri,
  dtrif: dtrif,
  duarr: duarr,
  duhar: duhar,
  dwangle: dwangle,
  DZcy: DZcy,
  dzcy: dzcy,
  dzigrarr: dzigrarr,
  Eacute: Eacute$1,
  eacute: eacute$1,
  easter: easter,
  Ecaron: Ecaron,
  ecaron: ecaron,
  Ecirc: Ecirc$1,
  ecirc: ecirc$1,
  ecir: ecir,
  ecolon: ecolon,
  Ecy: Ecy,
  ecy: ecy,
  eDDot: eDDot,
  Edot: Edot,
  edot: edot,
  eDot: eDot,
  ee: ee,
  efDot: efDot,
  Efr: Efr,
  efr: efr,
  eg: eg,
  Egrave: Egrave$1,
  egrave: egrave$1,
  egs: egs,
  egsdot: egsdot,
  el: el,
  Element: Element$2,
  elinters: elinters,
  ell: ell,
  els: els,
  elsdot: elsdot,
  Emacr: Emacr,
  emacr: emacr,
  empty: empty,
  emptyset: emptyset,
  EmptySmallSquare: EmptySmallSquare,
  emptyv: emptyv,
  EmptyVerySmallSquare: EmptyVerySmallSquare,
  emsp13: emsp13,
  emsp14: emsp14,
  emsp: emsp,
  ENG: ENG,
  eng: eng,
  ensp: ensp,
  Eogon: Eogon,
  eogon: eogon,
  Eopf: Eopf,
  eopf: eopf,
  epar: epar,
  eparsl: eparsl,
  eplus: eplus,
  epsi: epsi,
  Epsilon: Epsilon,
  epsilon: epsilon,
  epsiv: epsiv,
  eqcirc: eqcirc,
  eqcolon: eqcolon,
  eqsim: eqsim,
  eqslantgtr: eqslantgtr,
  eqslantless: eqslantless,
  Equal: Equal,
  equals: equals,
  EqualTilde: EqualTilde,
  equest: equest,
  Equilibrium: Equilibrium,
  equiv: equiv,
  equivDD: equivDD,
  eqvparsl: eqvparsl,
  erarr: erarr,
  erDot: erDot,
  escr: escr,
  Escr: Escr,
  esdot: esdot,
  Esim: Esim,
  esim: esim,
  Eta: Eta,
  eta: eta,
  ETH: ETH$1,
  eth: eth$1,
  Euml: Euml$1,
  euml: euml$1,
  euro: euro,
  excl: excl,
  exist: exist$1,
  Exists: Exists,
  expectation: expectation,
  exponentiale: exponentiale,
  ExponentialE: ExponentialE,
  fallingdotseq: fallingdotseq,
  Fcy: Fcy,
  fcy: fcy,
  female: female,
  ffilig: ffilig,
  fflig: fflig,
  ffllig: ffllig,
  Ffr: Ffr,
  ffr: ffr,
  filig: filig,
  FilledSmallSquare: FilledSmallSquare,
  FilledVerySmallSquare: FilledVerySmallSquare,
  fjlig: fjlig,
  flat: flat,
  fllig: fllig,
  fltns: fltns,
  fnof: fnof,
  Fopf: Fopf,
  fopf: fopf,
  forall: forall,
  ForAll: ForAll,
  fork: fork,
  forkv: forkv,
  Fouriertrf: Fouriertrf,
  fpartint: fpartint,
  frac12: frac12$1,
  frac13: frac13,
  frac14: frac14$1,
  frac15: frac15,
  frac16: frac16,
  frac18: frac18,
  frac23: frac23,
  frac25: frac25,
  frac34: frac34$1,
  frac35: frac35,
  frac38: frac38,
  frac45: frac45,
  frac56: frac56,
  frac58: frac58,
  frac78: frac78,
  frasl: frasl,
  frown: frown,
  fscr: fscr,
  Fscr: Fscr,
  gacute: gacute,
  Gamma: Gamma,
  gamma: gamma,
  Gammad: Gammad,
  gammad: gammad,
  gap: gap,
  Gbreve: Gbreve,
  gbreve: gbreve,
  Gcedil: Gcedil,
  Gcirc: Gcirc,
  gcirc: gcirc,
  Gcy: Gcy,
  gcy: gcy,
  Gdot: Gdot,
  gdot: gdot,
  ge: ge,
  gE: gE,
  gEl: gEl,
  gel: gel,
  geq: geq,
  geqq: geqq,
  geqslant: geqslant,
  gescc: gescc,
  ges: ges,
  gesdot: gesdot,
  gesdoto: gesdoto,
  gesdotol: gesdotol,
  gesl: gesl,
  gesles: gesles,
  Gfr: Gfr,
  gfr: gfr,
  gg: gg,
  Gg: Gg,
  ggg: ggg,
  gimel: gimel,
  GJcy: GJcy,
  gjcy: gjcy,
  gla: gla,
  gl: gl,
  glE: glE,
  glj: glj,
  gnap: gnap,
  gnapprox: gnapprox,
  gne: gne,
  gnE: gnE,
  gneq: gneq,
  gneqq: gneqq,
  gnsim: gnsim,
  Gopf: Gopf,
  gopf: gopf,
  grave: grave,
  GreaterEqual: GreaterEqual,
  GreaterEqualLess: GreaterEqualLess,
  GreaterFullEqual: GreaterFullEqual,
  GreaterGreater: GreaterGreater,
  GreaterLess: GreaterLess,
  GreaterSlantEqual: GreaterSlantEqual,
  GreaterTilde: GreaterTilde,
  Gscr: Gscr,
  gscr: gscr,
  gsim: gsim,
  gsime: gsime,
  gsiml: gsiml,
  gtcc: gtcc,
  gtcir: gtcir,
  gt: gt$2,
  GT: GT$1,
  Gt: Gt,
  gtdot: gtdot,
  gtlPar: gtlPar,
  gtquest: gtquest,
  gtrapprox: gtrapprox,
  gtrarr: gtrarr,
  gtrdot: gtrdot,
  gtreqless: gtreqless,
  gtreqqless: gtreqqless,
  gtrless: gtrless,
  gtrsim: gtrsim,
  gvertneqq: gvertneqq,
  gvnE: gvnE,
  Hacek: Hacek,
  hairsp: hairsp,
  half: half,
  hamilt: hamilt,
  HARDcy: HARDcy,
  hardcy: hardcy,
  harrcir: harrcir,
  harr: harr,
  hArr: hArr,
  harrw: harrw,
  Hat: Hat,
  hbar: hbar,
  Hcirc: Hcirc,
  hcirc: hcirc,
  hearts: hearts,
  heartsuit: heartsuit,
  hellip: hellip,
  hercon: hercon,
  hfr: hfr,
  Hfr: Hfr,
  HilbertSpace: HilbertSpace,
  hksearow: hksearow,
  hkswarow: hkswarow,
  hoarr: hoarr,
  homtht: homtht,
  hookleftarrow: hookleftarrow,
  hookrightarrow: hookrightarrow,
  hopf: hopf,
  Hopf: Hopf,
  horbar: horbar,
  HorizontalLine: HorizontalLine,
  hscr: hscr,
  Hscr: Hscr,
  hslash: hslash,
  Hstrok: Hstrok,
  hstrok: hstrok,
  HumpDownHump: HumpDownHump,
  HumpEqual: HumpEqual,
  hybull: hybull,
  hyphen: hyphen,
  Iacute: Iacute$1,
  iacute: iacute$1,
  ic: ic,
  Icirc: Icirc$1,
  icirc: icirc$1,
  Icy: Icy,
  icy: icy,
  Idot: Idot,
  IEcy: IEcy,
  iecy: iecy,
  iexcl: iexcl$1,
  iff: iff,
  ifr: ifr,
  Ifr: Ifr,
  Igrave: Igrave$1,
  igrave: igrave$1,
  ii: ii,
  iiiint: iiiint,
  iiint: iiint,
  iinfin: iinfin,
  iiota: iiota,
  IJlig: IJlig,
  ijlig: ijlig,
  Imacr: Imacr,
  imacr: imacr,
  image: image,
  ImaginaryI: ImaginaryI,
  imagline: imagline,
  imagpart: imagpart,
  imath: imath,
  Im: Im,
  imof: imof,
  imped: imped,
  Implies: Implies,
  incare: incare,
  infin: infin,
  infintie: infintie,
  inodot: inodot,
  intcal: intcal,
  int: int,
  Int: Int,
  integers: integers,
  Integral: Integral,
  intercal: intercal,
  Intersection: Intersection,
  intlarhk: intlarhk,
  intprod: intprod,
  InvisibleComma: InvisibleComma,
  InvisibleTimes: InvisibleTimes,
  IOcy: IOcy,
  iocy: iocy,
  Iogon: Iogon,
  iogon: iogon,
  Iopf: Iopf,
  iopf: iopf,
  Iota: Iota,
  iota: iota,
  iprod: iprod,
  iquest: iquest$1,
  iscr: iscr,
  Iscr: Iscr,
  isin: isin,
  isindot: isindot,
  isinE: isinE,
  isins: isins,
  isinsv: isinsv,
  isinv: isinv,
  it: it,
  Itilde: Itilde,
  itilde: itilde,
  Iukcy: Iukcy,
  iukcy: iukcy,
  Iuml: Iuml$1,
  iuml: iuml$1,
  Jcirc: Jcirc,
  jcirc: jcirc,
  Jcy: Jcy,
  jcy: jcy,
  Jfr: Jfr,
  jfr: jfr,
  jmath: jmath,
  Jopf: Jopf,
  jopf: jopf,
  Jscr: Jscr,
  jscr: jscr,
  Jsercy: Jsercy,
  jsercy: jsercy,
  Jukcy: Jukcy,
  jukcy: jukcy,
  Kappa: Kappa,
  kappa: kappa,
  kappav: kappav,
  Kcedil: Kcedil,
  kcedil: kcedil,
  Kcy: Kcy,
  kcy: kcy,
  Kfr: Kfr,
  kfr: kfr,
  kgreen: kgreen,
  KHcy: KHcy,
  khcy: khcy,
  KJcy: KJcy,
  kjcy: kjcy,
  Kopf: Kopf,
  kopf: kopf,
  Kscr: Kscr,
  kscr: kscr,
  lAarr: lAarr,
  Lacute: Lacute,
  lacute: lacute,
  laemptyv: laemptyv,
  lagran: lagran,
  Lambda: Lambda,
  lambda: lambda,
  lang: lang,
  Lang: Lang,
  langd: langd,
  langle: langle,
  lap: lap,
  Laplacetrf: Laplacetrf,
  laquo: laquo$1,
  larrb: larrb,
  larrbfs: larrbfs,
  larr: larr,
  Larr: Larr,
  lArr: lArr,
  larrfs: larrfs,
  larrhk: larrhk,
  larrlp: larrlp,
  larrpl: larrpl,
  larrsim: larrsim,
  larrtl: larrtl,
  latail: latail,
  lAtail: lAtail,
  lat: lat,
  late: late,
  lates: lates,
  lbarr: lbarr,
  lBarr: lBarr,
  lbbrk: lbbrk,
  lbrace: lbrace,
  lbrack: lbrack,
  lbrke: lbrke,
  lbrksld: lbrksld,
  lbrkslu: lbrkslu,
  Lcaron: Lcaron,
  lcaron: lcaron,
  Lcedil: Lcedil,
  lcedil: lcedil,
  lceil: lceil,
  lcub: lcub,
  Lcy: Lcy,
  lcy: lcy,
  ldca: ldca,
  ldquo: ldquo,
  ldquor: ldquor,
  ldrdhar: ldrdhar,
  ldrushar: ldrushar,
  ldsh: ldsh,
  le: le,
  lE: lE,
  LeftAngleBracket: LeftAngleBracket,
  LeftArrowBar: LeftArrowBar,
  leftarrow: leftarrow,
  LeftArrow: LeftArrow,
  Leftarrow: Leftarrow,
  LeftArrowRightArrow: LeftArrowRightArrow,
  leftarrowtail: leftarrowtail,
  LeftCeiling: LeftCeiling,
  LeftDoubleBracket: LeftDoubleBracket,
  LeftDownTeeVector: LeftDownTeeVector,
  LeftDownVectorBar: LeftDownVectorBar,
  LeftDownVector: LeftDownVector,
  LeftFloor: LeftFloor,
  leftharpoondown: leftharpoondown,
  leftharpoonup: leftharpoonup,
  leftleftarrows: leftleftarrows,
  leftrightarrow: leftrightarrow,
  LeftRightArrow: LeftRightArrow,
  Leftrightarrow: Leftrightarrow,
  leftrightarrows: leftrightarrows,
  leftrightharpoons: leftrightharpoons,
  leftrightsquigarrow: leftrightsquigarrow,
  LeftRightVector: LeftRightVector,
  LeftTeeArrow: LeftTeeArrow,
  LeftTee: LeftTee,
  LeftTeeVector: LeftTeeVector,
  leftthreetimes: leftthreetimes,
  LeftTriangleBar: LeftTriangleBar,
  LeftTriangle: LeftTriangle,
  LeftTriangleEqual: LeftTriangleEqual,
  LeftUpDownVector: LeftUpDownVector,
  LeftUpTeeVector: LeftUpTeeVector,
  LeftUpVectorBar: LeftUpVectorBar,
  LeftUpVector: LeftUpVector,
  LeftVectorBar: LeftVectorBar,
  LeftVector: LeftVector,
  lEg: lEg,
  leg: leg,
  leq: leq,
  leqq: leqq,
  leqslant: leqslant,
  lescc: lescc,
  les: les,
  lesdot: lesdot,
  lesdoto: lesdoto,
  lesdotor: lesdotor,
  lesg: lesg,
  lesges: lesges,
  lessapprox: lessapprox,
  lessdot: lessdot,
  lesseqgtr: lesseqgtr,
  lesseqqgtr: lesseqqgtr,
  LessEqualGreater: LessEqualGreater,
  LessFullEqual: LessFullEqual,
  LessGreater: LessGreater,
  lessgtr: lessgtr,
  LessLess: LessLess,
  lesssim: lesssim,
  LessSlantEqual: LessSlantEqual,
  LessTilde: LessTilde,
  lfisht: lfisht,
  lfloor: lfloor,
  Lfr: Lfr,
  lfr: lfr,
  lg: lg,
  lgE: lgE,
  lHar: lHar,
  lhard: lhard,
  lharu: lharu,
  lharul: lharul,
  lhblk: lhblk,
  LJcy: LJcy,
  ljcy: ljcy,
  llarr: llarr,
  ll: ll,
  Ll: Ll,
  llcorner: llcorner,
  Lleftarrow: Lleftarrow,
  llhard: llhard,
  lltri: lltri,
  Lmidot: Lmidot,
  lmidot: lmidot,
  lmoustache: lmoustache,
  lmoust: lmoust,
  lnap: lnap,
  lnapprox: lnapprox,
  lne: lne,
  lnE: lnE,
  lneq: lneq,
  lneqq: lneqq,
  lnsim: lnsim,
  loang: loang,
  loarr: loarr,
  lobrk: lobrk,
  longleftarrow: longleftarrow,
  LongLeftArrow: LongLeftArrow,
  Longleftarrow: Longleftarrow,
  longleftrightarrow: longleftrightarrow,
  LongLeftRightArrow: LongLeftRightArrow,
  Longleftrightarrow: Longleftrightarrow,
  longmapsto: longmapsto,
  longrightarrow: longrightarrow,
  LongRightArrow: LongRightArrow,
  Longrightarrow: Longrightarrow,
  looparrowleft: looparrowleft,
  looparrowright: looparrowright,
  lopar: lopar,
  Lopf: Lopf,
  lopf: lopf,
  loplus: loplus,
  lotimes: lotimes,
  lowast: lowast,
  lowbar: lowbar,
  LowerLeftArrow: LowerLeftArrow,
  LowerRightArrow: LowerRightArrow,
  loz: loz,
  lozenge: lozenge,
  lozf: lozf,
  lpar: lpar,
  lparlt: lparlt,
  lrarr: lrarr,
  lrcorner: lrcorner,
  lrhar: lrhar,
  lrhard: lrhard,
  lrm: lrm,
  lrtri: lrtri,
  lsaquo: lsaquo,
  lscr: lscr,
  Lscr: Lscr,
  lsh: lsh,
  Lsh: Lsh,
  lsim: lsim,
  lsime: lsime,
  lsimg: lsimg,
  lsqb: lsqb,
  lsquo: lsquo,
  lsquor: lsquor,
  Lstrok: Lstrok,
  lstrok: lstrok,
  ltcc: ltcc,
  ltcir: ltcir,
  lt: lt$2,
  LT: LT$1,
  Lt: Lt,
  ltdot: ltdot,
  lthree: lthree,
  ltimes: ltimes,
  ltlarr: ltlarr,
  ltquest: ltquest,
  ltri: ltri,
  ltrie: ltrie,
  ltrif: ltrif,
  ltrPar: ltrPar,
  lurdshar: lurdshar,
  luruhar: luruhar,
  lvertneqq: lvertneqq,
  lvnE: lvnE,
  macr: macr$1,
  male: male,
  malt: malt,
  maltese: maltese,
  map: map,
  mapsto: mapsto,
  mapstodown: mapstodown,
  mapstoleft: mapstoleft,
  mapstoup: mapstoup,
  marker: marker,
  mcomma: mcomma,
  Mcy: Mcy,
  mcy: mcy,
  mdash: mdash,
  mDDot: mDDot,
  measuredangle: measuredangle,
  MediumSpace: MediumSpace,
  Mellintrf: Mellintrf,
  Mfr: Mfr,
  mfr: mfr,
  mho: mho,
  micro: micro$1,
  midast: midast,
  midcir: midcir,
  mid: mid,
  middot: middot$1,
  minusb: minusb,
  minus: minus,
  minusd: minusd,
  minusdu: minusdu,
  MinusPlus: MinusPlus,
  mlcp: mlcp,
  mldr: mldr,
  mnplus: mnplus,
  models: models,
  Mopf: Mopf,
  mopf: mopf,
  mp: mp,
  mscr: mscr,
  Mscr: Mscr,
  mstpos: mstpos,
  Mu: Mu,
  mu: mu,
  multimap: multimap,
  mumap: mumap,
  nabla: nabla,
  Nacute: Nacute,
  nacute: nacute,
  nang: nang,
  nap: nap,
  napE: napE,
  napid: napid,
  napos: napos,
  napprox: napprox,
  natural: natural,
  naturals: naturals,
  natur: natur,
  nbsp: nbsp$1,
  nbump: nbump,
  nbumpe: nbumpe,
  ncap: ncap,
  Ncaron: Ncaron,
  ncaron: ncaron,
  Ncedil: Ncedil,
  ncedil: ncedil,
  ncong: ncong,
  ncongdot: ncongdot,
  ncup: ncup,
  Ncy: Ncy,
  ncy: ncy,
  ndash: ndash,
  nearhk: nearhk,
  nearr: nearr,
  neArr: neArr,
  nearrow: nearrow,
  ne: ne,
  nedot: nedot,
  NegativeMediumSpace: NegativeMediumSpace,
  NegativeThickSpace: NegativeThickSpace,
  NegativeThinSpace: NegativeThinSpace,
  NegativeVeryThinSpace: NegativeVeryThinSpace,
  nequiv: nequiv,
  nesear: nesear,
  nesim: nesim,
  NestedGreaterGreater: NestedGreaterGreater,
  NestedLessLess: NestedLessLess,
  NewLine: NewLine,
  nexist: nexist,
  nexists: nexists,
  Nfr: Nfr,
  nfr: nfr,
  ngE: ngE,
  nge: nge,
  ngeq: ngeq,
  ngeqq: ngeqq,
  ngeqslant: ngeqslant,
  nges: nges,
  nGg: nGg,
  ngsim: ngsim,
  nGt: nGt,
  ngt: ngt,
  ngtr: ngtr,
  nGtv: nGtv,
  nharr: nharr,
  nhArr: nhArr,
  nhpar: nhpar,
  ni: ni,
  nis: nis,
  nisd: nisd,
  niv: niv,
  NJcy: NJcy,
  njcy: njcy,
  nlarr: nlarr,
  nlArr: nlArr,
  nldr: nldr,
  nlE: nlE,
  nle: nle,
  nleftarrow: nleftarrow,
  nLeftarrow: nLeftarrow,
  nleftrightarrow: nleftrightarrow,
  nLeftrightarrow: nLeftrightarrow,
  nleq: nleq,
  nleqq: nleqq,
  nleqslant: nleqslant,
  nles: nles,
  nless: nless,
  nLl: nLl,
  nlsim: nlsim,
  nLt: nLt,
  nlt: nlt,
  nltri: nltri,
  nltrie: nltrie,
  nLtv: nLtv,
  nmid: nmid,
  NoBreak: NoBreak,
  NonBreakingSpace: NonBreakingSpace,
  nopf: nopf,
  Nopf: Nopf,
  Not: Not,
  not: not$1,
  NotCongruent: NotCongruent,
  NotCupCap: NotCupCap,
  NotDoubleVerticalBar: NotDoubleVerticalBar,
  NotElement: NotElement,
  NotEqual: NotEqual,
  NotEqualTilde: NotEqualTilde,
  NotExists: NotExists,
  NotGreater: NotGreater,
  NotGreaterEqual: NotGreaterEqual,
  NotGreaterFullEqual: NotGreaterFullEqual,
  NotGreaterGreater: NotGreaterGreater,
  NotGreaterLess: NotGreaterLess,
  NotGreaterSlantEqual: NotGreaterSlantEqual,
  NotGreaterTilde: NotGreaterTilde,
  NotHumpDownHump: NotHumpDownHump,
  NotHumpEqual: NotHumpEqual,
  notin: notin,
  notindot: notindot,
  notinE: notinE,
  notinva: notinva,
  notinvb: notinvb,
  notinvc: notinvc,
  NotLeftTriangleBar: NotLeftTriangleBar,
  NotLeftTriangle: NotLeftTriangle,
  NotLeftTriangleEqual: NotLeftTriangleEqual,
  NotLess: NotLess,
  NotLessEqual: NotLessEqual,
  NotLessGreater: NotLessGreater,
  NotLessLess: NotLessLess,
  NotLessSlantEqual: NotLessSlantEqual,
  NotLessTilde: NotLessTilde,
  NotNestedGreaterGreater: NotNestedGreaterGreater,
  NotNestedLessLess: NotNestedLessLess,
  notni: notni,
  notniva: notniva,
  notnivb: notnivb,
  notnivc: notnivc,
  NotPrecedes: NotPrecedes,
  NotPrecedesEqual: NotPrecedesEqual,
  NotPrecedesSlantEqual: NotPrecedesSlantEqual,
  NotReverseElement: NotReverseElement,
  NotRightTriangleBar: NotRightTriangleBar,
  NotRightTriangle: NotRightTriangle,
  NotRightTriangleEqual: NotRightTriangleEqual,
  NotSquareSubset: NotSquareSubset,
  NotSquareSubsetEqual: NotSquareSubsetEqual,
  NotSquareSuperset: NotSquareSuperset,
  NotSquareSupersetEqual: NotSquareSupersetEqual,
  NotSubset: NotSubset,
  NotSubsetEqual: NotSubsetEqual,
  NotSucceeds: NotSucceeds,
  NotSucceedsEqual: NotSucceedsEqual,
  NotSucceedsSlantEqual: NotSucceedsSlantEqual,
  NotSucceedsTilde: NotSucceedsTilde,
  NotSuperset: NotSuperset,
  NotSupersetEqual: NotSupersetEqual,
  NotTilde: NotTilde,
  NotTildeEqual: NotTildeEqual,
  NotTildeFullEqual: NotTildeFullEqual,
  NotTildeTilde: NotTildeTilde,
  NotVerticalBar: NotVerticalBar,
  nparallel: nparallel,
  npar: npar,
  nparsl: nparsl,
  npart: npart,
  npolint: npolint,
  npr: npr,
  nprcue: nprcue,
  nprec: nprec,
  npreceq: npreceq,
  npre: npre,
  nrarrc: nrarrc,
  nrarr: nrarr,
  nrArr: nrArr,
  nrarrw: nrarrw,
  nrightarrow: nrightarrow,
  nRightarrow: nRightarrow,
  nrtri: nrtri,
  nrtrie: nrtrie,
  nsc: nsc,
  nsccue: nsccue,
  nsce: nsce,
  Nscr: Nscr,
  nscr: nscr,
  nshortmid: nshortmid,
  nshortparallel: nshortparallel,
  nsim: nsim,
  nsime: nsime,
  nsimeq: nsimeq,
  nsmid: nsmid,
  nspar: nspar,
  nsqsube: nsqsube,
  nsqsupe: nsqsupe,
  nsub: nsub,
  nsubE: nsubE,
  nsube: nsube,
  nsubset: nsubset,
  nsubseteq: nsubseteq,
  nsubseteqq: nsubseteqq,
  nsucc: nsucc,
  nsucceq: nsucceq,
  nsup: nsup,
  nsupE: nsupE,
  nsupe: nsupe,
  nsupset: nsupset,
  nsupseteq: nsupseteq,
  nsupseteqq: nsupseteqq,
  ntgl: ntgl,
  Ntilde: Ntilde$1,
  ntilde: ntilde$1,
  ntlg: ntlg,
  ntriangleleft: ntriangleleft,
  ntrianglelefteq: ntrianglelefteq,
  ntriangleright: ntriangleright,
  ntrianglerighteq: ntrianglerighteq,
  Nu: Nu,
  nu: nu,
  num: num,
  numero: numero,
  numsp: numsp,
  nvap: nvap,
  nvdash: nvdash,
  nvDash: nvDash,
  nVdash: nVdash,
  nVDash: nVDash,
  nvge: nvge,
  nvgt: nvgt,
  nvHarr: nvHarr,
  nvinfin: nvinfin,
  nvlArr: nvlArr,
  nvle: nvle,
  nvlt: nvlt,
  nvltrie: nvltrie,
  nvrArr: nvrArr,
  nvrtrie: nvrtrie,
  nvsim: nvsim,
  nwarhk: nwarhk,
  nwarr: nwarr,
  nwArr: nwArr,
  nwarrow: nwarrow,
  nwnear: nwnear,
  Oacute: Oacute$1,
  oacute: oacute$1,
  oast: oast,
  Ocirc: Ocirc$1,
  ocirc: ocirc$1,
  ocir: ocir,
  Ocy: Ocy,
  ocy: ocy,
  odash: odash,
  Odblac: Odblac,
  odblac: odblac,
  odiv: odiv,
  odot: odot,
  odsold: odsold,
  OElig: OElig,
  oelig: oelig,
  ofcir: ofcir,
  Ofr: Ofr,
  ofr: ofr,
  ogon: ogon,
  Ograve: Ograve$1,
  ograve: ograve$1,
  ogt: ogt,
  ohbar: ohbar,
  ohm: ohm,
  oint: oint,
  olarr: olarr,
  olcir: olcir,
  olcross: olcross,
  oline: oline,
  olt: olt,
  Omacr: Omacr,
  omacr: omacr,
  Omega: Omega,
  omega: omega,
  Omicron: Omicron,
  omicron: omicron,
  omid: omid,
  ominus: ominus,
  Oopf: Oopf,
  oopf: oopf,
  opar: opar,
  OpenCurlyDoubleQuote: OpenCurlyDoubleQuote,
  OpenCurlyQuote: OpenCurlyQuote,
  operp: operp,
  oplus: oplus,
  orarr: orarr,
  Or: Or,
  or: or,
  ord: ord,
  order: order,
  orderof: orderof,
  ordf: ordf$1,
  ordm: ordm$1,
  origof: origof,
  oror: oror,
  orslope: orslope,
  orv: orv,
  oS: oS,
  Oscr: Oscr,
  oscr: oscr,
  Oslash: Oslash$1,
  oslash: oslash$1,
  osol: osol,
  Otilde: Otilde$1,
  otilde: otilde$1,
  otimesas: otimesas,
  Otimes: Otimes,
  otimes: otimes,
  Ouml: Ouml$1,
  ouml: ouml$1,
  ovbar: ovbar,
  OverBar: OverBar,
  OverBrace: OverBrace,
  OverBracket: OverBracket,
  OverParenthesis: OverParenthesis,
  para: para$1,
  parallel: parallel,
  par: par,
  parsim: parsim,
  parsl: parsl,
  part: part,
  PartialD: PartialD,
  Pcy: Pcy,
  pcy: pcy,
  percnt: percnt,
  period: period,
  permil: permil,
  perp: perp,
  pertenk: pertenk,
  Pfr: Pfr,
  pfr: pfr,
  Phi: Phi,
  phi: phi,
  phiv: phiv,
  phmmat: phmmat,
  phone: phone,
  Pi: Pi,
  pi: pi,
  pitchfork: pitchfork,
  piv: piv,
  planck: planck,
  planckh: planckh,
  plankv: plankv,
  plusacir: plusacir,
  plusb: plusb,
  pluscir: pluscir,
  plus: plus,
  plusdo: plusdo,
  plusdu: plusdu,
  pluse: pluse,
  PlusMinus: PlusMinus,
  plusmn: plusmn$1,
  plussim: plussim,
  plustwo: plustwo,
  pm: pm,
  Poincareplane: Poincareplane,
  pointint: pointint,
  popf: popf,
  Popf: Popf,
  pound: pound$1,
  prap: prap,
  Pr: Pr,
  pr: pr,
  prcue: prcue,
  precapprox: precapprox,
  prec: prec,
  preccurlyeq: preccurlyeq,
  Precedes: Precedes,
  PrecedesEqual: PrecedesEqual,
  PrecedesSlantEqual: PrecedesSlantEqual,
  PrecedesTilde: PrecedesTilde,
  preceq: preceq,
  precnapprox: precnapprox,
  precneqq: precneqq,
  precnsim: precnsim,
  pre: pre,
  prE: prE,
  precsim: precsim,
  prime: prime,
  Prime: Prime,
  primes: primes,
  prnap: prnap,
  prnE: prnE,
  prnsim: prnsim,
  prod: prod,
  Product: Product,
  profalar: profalar,
  profline: profline,
  profsurf: profsurf,
  prop: prop,
  Proportional: Proportional,
  Proportion: Proportion,
  propto: propto,
  prsim: prsim,
  prurel: prurel,
  Pscr: Pscr,
  pscr: pscr,
  Psi: Psi,
  psi: psi,
  puncsp: puncsp,
  Qfr: Qfr,
  qfr: qfr,
  qint: qint,
  qopf: qopf,
  Qopf: Qopf,
  qprime: qprime,
  Qscr: Qscr,
  qscr: qscr,
  quaternions: quaternions,
  quatint: quatint,
  quest: quest,
  questeq: questeq,
  quot: quot$2,
  QUOT: QUOT$1,
  rAarr: rAarr,
  race: race,
  Racute: Racute,
  racute: racute,
  radic: radic,
  raemptyv: raemptyv,
  rang: rang,
  Rang: Rang,
  rangd: rangd,
  range: range,
  rangle: rangle,
  raquo: raquo$1,
  rarrap: rarrap,
  rarrb: rarrb,
  rarrbfs: rarrbfs,
  rarrc: rarrc,
  rarr: rarr,
  Rarr: Rarr,
  rArr: rArr,
  rarrfs: rarrfs,
  rarrhk: rarrhk,
  rarrlp: rarrlp,
  rarrpl: rarrpl,
  rarrsim: rarrsim,
  Rarrtl: Rarrtl,
  rarrtl: rarrtl,
  rarrw: rarrw,
  ratail: ratail,
  rAtail: rAtail,
  ratio: ratio,
  rationals: rationals,
  rbarr: rbarr,
  rBarr: rBarr,
  RBarr: RBarr,
  rbbrk: rbbrk,
  rbrace: rbrace,
  rbrack: rbrack,
  rbrke: rbrke,
  rbrksld: rbrksld,
  rbrkslu: rbrkslu,
  Rcaron: Rcaron,
  rcaron: rcaron,
  Rcedil: Rcedil,
  rcedil: rcedil,
  rceil: rceil,
  rcub: rcub,
  Rcy: Rcy,
  rcy: rcy,
  rdca: rdca,
  rdldhar: rdldhar,
  rdquo: rdquo,
  rdquor: rdquor,
  rdsh: rdsh,
  real: real,
  realine: realine,
  realpart: realpart,
  reals: reals,
  Re: Re,
  rect: rect,
  reg: reg$1,
  REG: REG$1,
  ReverseElement: ReverseElement,
  ReverseEquilibrium: ReverseEquilibrium,
  ReverseUpEquilibrium: ReverseUpEquilibrium,
  rfisht: rfisht,
  rfloor: rfloor,
  rfr: rfr,
  Rfr: Rfr,
  rHar: rHar,
  rhard: rhard,
  rharu: rharu,
  rharul: rharul,
  Rho: Rho,
  rho: rho,
  rhov: rhov,
  RightAngleBracket: RightAngleBracket,
  RightArrowBar: RightArrowBar,
  rightarrow: rightarrow,
  RightArrow: RightArrow,
  Rightarrow: Rightarrow,
  RightArrowLeftArrow: RightArrowLeftArrow,
  rightarrowtail: rightarrowtail,
  RightCeiling: RightCeiling,
  RightDoubleBracket: RightDoubleBracket,
  RightDownTeeVector: RightDownTeeVector,
  RightDownVectorBar: RightDownVectorBar,
  RightDownVector: RightDownVector,
  RightFloor: RightFloor,
  rightharpoondown: rightharpoondown,
  rightharpoonup: rightharpoonup,
  rightleftarrows: rightleftarrows,
  rightleftharpoons: rightleftharpoons,
  rightrightarrows: rightrightarrows,
  rightsquigarrow: rightsquigarrow,
  RightTeeArrow: RightTeeArrow,
  RightTee: RightTee,
  RightTeeVector: RightTeeVector,
  rightthreetimes: rightthreetimes,
  RightTriangleBar: RightTriangleBar,
  RightTriangle: RightTriangle,
  RightTriangleEqual: RightTriangleEqual,
  RightUpDownVector: RightUpDownVector,
  RightUpTeeVector: RightUpTeeVector,
  RightUpVectorBar: RightUpVectorBar,
  RightUpVector: RightUpVector,
  RightVectorBar: RightVectorBar,
  RightVector: RightVector,
  ring: ring,
  risingdotseq: risingdotseq,
  rlarr: rlarr,
  rlhar: rlhar,
  rlm: rlm,
  rmoustache: rmoustache,
  rmoust: rmoust,
  rnmid: rnmid,
  roang: roang,
  roarr: roarr,
  robrk: robrk,
  ropar: ropar,
  ropf: ropf,
  Ropf: Ropf,
  roplus: roplus,
  rotimes: rotimes,
  RoundImplies: RoundImplies,
  rpar: rpar,
  rpargt: rpargt,
  rppolint: rppolint,
  rrarr: rrarr,
  Rrightarrow: Rrightarrow,
  rsaquo: rsaquo,
  rscr: rscr,
  Rscr: Rscr,
  rsh: rsh,
  Rsh: Rsh,
  rsqb: rsqb,
  rsquo: rsquo,
  rsquor: rsquor,
  rthree: rthree,
  rtimes: rtimes,
  rtri: rtri,
  rtrie: rtrie,
  rtrif: rtrif,
  rtriltri: rtriltri,
  RuleDelayed: RuleDelayed,
  ruluhar: ruluhar,
  rx: rx,
  Sacute: Sacute,
  sacute: sacute,
  sbquo: sbquo,
  scap: scap,
  Scaron: Scaron,
  scaron: scaron,
  Sc: Sc,
  sc: sc,
  sccue: sccue,
  sce: sce,
  scE: scE,
  Scedil: Scedil,
  scedil: scedil,
  Scirc: Scirc,
  scirc: scirc,
  scnap: scnap,
  scnE: scnE,
  scnsim: scnsim,
  scpolint: scpolint,
  scsim: scsim,
  Scy: Scy,
  scy: scy,
  sdotb: sdotb,
  sdot: sdot,
  sdote: sdote,
  searhk: searhk,
  searr: searr,
  seArr: seArr,
  searrow: searrow,
  sect: sect$1,
  semi: semi,
  seswar: seswar,
  setminus: setminus,
  setmn: setmn,
  sext: sext,
  Sfr: Sfr,
  sfr: sfr,
  sfrown: sfrown,
  sharp: sharp,
  SHCHcy: SHCHcy,
  shchcy: shchcy,
  SHcy: SHcy,
  shcy: shcy,
  ShortDownArrow: ShortDownArrow,
  ShortLeftArrow: ShortLeftArrow,
  shortmid: shortmid,
  shortparallel: shortparallel,
  ShortRightArrow: ShortRightArrow,
  ShortUpArrow: ShortUpArrow,
  shy: shy$1,
  Sigma: Sigma,
  sigma: sigma,
  sigmaf: sigmaf,
  sigmav: sigmav,
  sim: sim,
  simdot: simdot,
  sime: sime,
  simeq: simeq,
  simg: simg,
  simgE: simgE,
  siml: siml,
  simlE: simlE,
  simne: simne,
  simplus: simplus,
  simrarr: simrarr,
  slarr: slarr,
  SmallCircle: SmallCircle,
  smallsetminus: smallsetminus,
  smashp: smashp,
  smeparsl: smeparsl,
  smid: smid,
  smile: smile,
  smt: smt,
  smte: smte,
  smtes: smtes,
  SOFTcy: SOFTcy,
  softcy: softcy,
  solbar: solbar,
  solb: solb,
  sol: sol,
  Sopf: Sopf,
  sopf: sopf,
  spades: spades,
  spadesuit: spadesuit,
  spar: spar,
  sqcap: sqcap,
  sqcaps: sqcaps,
  sqcup: sqcup,
  sqcups: sqcups,
  Sqrt: Sqrt,
  sqsub: sqsub,
  sqsube: sqsube,
  sqsubset: sqsubset,
  sqsubseteq: sqsubseteq,
  sqsup: sqsup,
  sqsupe: sqsupe,
  sqsupset: sqsupset,
  sqsupseteq: sqsupseteq,
  square: square,
  Square: Square,
  SquareIntersection: SquareIntersection,
  SquareSubset: SquareSubset,
  SquareSubsetEqual: SquareSubsetEqual,
  SquareSuperset: SquareSuperset,
  SquareSupersetEqual: SquareSupersetEqual,
  SquareUnion: SquareUnion,
  squarf: squarf,
  squ: squ,
  squf: squf,
  srarr: srarr,
  Sscr: Sscr,
  sscr: sscr,
  ssetmn: ssetmn,
  ssmile: ssmile,
  sstarf: sstarf,
  Star: Star,
  star: star,
  starf: starf,
  straightepsilon: straightepsilon,
  straightphi: straightphi,
  strns: strns,
  sub: sub,
  Sub: Sub,
  subdot: subdot,
  subE: subE,
  sube: sube,
  subedot: subedot,
  submult: submult,
  subnE: subnE,
  subne: subne,
  subplus: subplus,
  subrarr: subrarr,
  subset: subset,
  Subset: Subset,
  subseteq: subseteq,
  subseteqq: subseteqq,
  SubsetEqual: SubsetEqual,
  subsetneq: subsetneq,
  subsetneqq: subsetneqq,
  subsim: subsim,
  subsub: subsub,
  subsup: subsup,
  succapprox: succapprox,
  succ: succ,
  succcurlyeq: succcurlyeq,
  Succeeds: Succeeds,
  SucceedsEqual: SucceedsEqual,
  SucceedsSlantEqual: SucceedsSlantEqual,
  SucceedsTilde: SucceedsTilde,
  succeq: succeq,
  succnapprox: succnapprox,
  succneqq: succneqq,
  succnsim: succnsim,
  succsim: succsim,
  SuchThat: SuchThat,
  sum: sum,
  Sum: Sum,
  sung: sung,
  sup1: sup1$1,
  sup2: sup2$1,
  sup3: sup3$1,
  sup: sup,
  Sup: Sup,
  supdot: supdot,
  supdsub: supdsub,
  supE: supE,
  supe: supe,
  supedot: supedot,
  Superset: Superset,
  SupersetEqual: SupersetEqual,
  suphsol: suphsol,
  suphsub: suphsub,
  suplarr: suplarr,
  supmult: supmult,
  supnE: supnE,
  supne: supne,
  supplus: supplus,
  supset: supset,
  Supset: Supset,
  supseteq: supseteq,
  supseteqq: supseteqq,
  supsetneq: supsetneq,
  supsetneqq: supsetneqq,
  supsim: supsim,
  supsub: supsub,
  supsup: supsup,
  swarhk: swarhk,
  swarr: swarr,
  swArr: swArr,
  swarrow: swarrow,
  swnwar: swnwar,
  szlig: szlig$1,
  Tab: Tab,
  target: target,
  Tau: Tau,
  tau: tau,
  tbrk: tbrk,
  Tcaron: Tcaron,
  tcaron: tcaron,
  Tcedil: Tcedil,
  tcedil: tcedil,
  Tcy: Tcy,
  tcy: tcy,
  tdot: tdot,
  telrec: telrec,
  Tfr: Tfr,
  tfr: tfr,
  there4: there4,
  therefore: therefore,
  Therefore: Therefore,
  Theta: Theta,
  theta: theta,
  thetasym: thetasym,
  thetav: thetav,
  thickapprox: thickapprox,
  thicksim: thicksim,
  ThickSpace: ThickSpace,
  ThinSpace: ThinSpace,
  thinsp: thinsp,
  thkap: thkap,
  thksim: thksim,
  THORN: THORN$1,
  thorn: thorn$1,
  tilde: tilde,
  Tilde: Tilde,
  TildeEqual: TildeEqual,
  TildeFullEqual: TildeFullEqual,
  TildeTilde: TildeTilde,
  timesbar: timesbar,
  timesb: timesb,
  times: times$1,
  timesd: timesd,
  tint: tint,
  toea: toea,
  topbot: topbot,
  topcir: topcir,
  top: top,
  Topf: Topf,
  topf: topf,
  topfork: topfork,
  tosa: tosa,
  tprime: tprime,
  trade: trade,
  TRADE: TRADE,
  triangle: triangle,
  triangledown: triangledown,
  triangleleft: triangleleft,
  trianglelefteq: trianglelefteq,
  triangleq: triangleq,
  triangleright: triangleright,
  trianglerighteq: trianglerighteq,
  tridot: tridot,
  trie: trie,
  triminus: triminus,
  TripleDot: TripleDot,
  triplus: triplus,
  trisb: trisb,
  tritime: tritime,
  trpezium: trpezium,
  Tscr: Tscr,
  tscr: tscr,
  TScy: TScy,
  tscy: tscy,
  TSHcy: TSHcy,
  tshcy: tshcy,
  Tstrok: Tstrok,
  tstrok: tstrok,
  twixt: twixt,
  twoheadleftarrow: twoheadleftarrow,
  twoheadrightarrow: twoheadrightarrow,
  Uacute: Uacute$1,
  uacute: uacute$1,
  uarr: uarr,
  Uarr: Uarr,
  uArr: uArr,
  Uarrocir: Uarrocir,
  Ubrcy: Ubrcy,
  ubrcy: ubrcy,
  Ubreve: Ubreve,
  ubreve: ubreve,
  Ucirc: Ucirc$1,
  ucirc: ucirc$1,
  Ucy: Ucy,
  ucy: ucy,
  udarr: udarr,
  Udblac: Udblac,
  udblac: udblac,
  udhar: udhar,
  ufisht: ufisht,
  Ufr: Ufr,
  ufr: ufr,
  Ugrave: Ugrave$1,
  ugrave: ugrave$1,
  uHar: uHar,
  uharl: uharl,
  uharr: uharr,
  uhblk: uhblk,
  ulcorn: ulcorn,
  ulcorner: ulcorner,
  ulcrop: ulcrop,
  ultri: ultri,
  Umacr: Umacr,
  umacr: umacr,
  uml: uml$1,
  UnderBar: UnderBar,
  UnderBrace: UnderBrace,
  UnderBracket: UnderBracket,
  UnderParenthesis: UnderParenthesis,
  Union: Union,
  UnionPlus: UnionPlus,
  Uogon: Uogon,
  uogon: uogon,
  Uopf: Uopf,
  uopf: uopf,
  UpArrowBar: UpArrowBar,
  uparrow: uparrow,
  UpArrow: UpArrow,
  Uparrow: Uparrow,
  UpArrowDownArrow: UpArrowDownArrow,
  updownarrow: updownarrow,
  UpDownArrow: UpDownArrow,
  Updownarrow: Updownarrow,
  UpEquilibrium: UpEquilibrium,
  upharpoonleft: upharpoonleft,
  upharpoonright: upharpoonright,
  uplus: uplus,
  UpperLeftArrow: UpperLeftArrow,
  UpperRightArrow: UpperRightArrow,
  upsi: upsi,
  Upsi: Upsi,
  upsih: upsih,
  Upsilon: Upsilon,
  upsilon: upsilon,
  UpTeeArrow: UpTeeArrow,
  UpTee: UpTee,
  upuparrows: upuparrows,
  urcorn: urcorn,
  urcorner: urcorner,
  urcrop: urcrop,
  Uring: Uring,
  uring: uring,
  urtri: urtri,
  Uscr: Uscr,
  uscr: uscr,
  utdot: utdot,
  Utilde: Utilde,
  utilde: utilde,
  utri: utri,
  utrif: utrif,
  uuarr: uuarr,
  Uuml: Uuml$1,
  uuml: uuml$1,
  uwangle: uwangle,
  vangrt: vangrt,
  varepsilon: varepsilon,
  varkappa: varkappa,
  varnothing: varnothing,
  varphi: varphi,
  varpi: varpi,
  varpropto: varpropto,
  varr: varr,
  vArr: vArr,
  varrho: varrho,
  varsigma: varsigma,
  varsubsetneq: varsubsetneq,
  varsubsetneqq: varsubsetneqq,
  varsupsetneq: varsupsetneq,
  varsupsetneqq: varsupsetneqq,
  vartheta: vartheta,
  vartriangleleft: vartriangleleft,
  vartriangleright: vartriangleright,
  vBar: vBar,
  Vbar: Vbar,
  vBarv: vBarv,
  Vcy: Vcy,
  vcy: vcy,
  vdash: vdash,
  vDash: vDash,
  Vdash: Vdash,
  VDash: VDash,
  Vdashl: Vdashl,
  veebar: veebar,
  vee: vee,
  Vee: Vee,
  veeeq: veeeq,
  vellip: vellip,
  verbar: verbar,
  Verbar: Verbar,
  vert: vert,
  Vert: Vert,
  VerticalBar: VerticalBar,
  VerticalLine: VerticalLine,
  VerticalSeparator: VerticalSeparator,
  VerticalTilde: VerticalTilde,
  VeryThinSpace: VeryThinSpace,
  Vfr: Vfr,
  vfr: vfr,
  vltri: vltri,
  vnsub: vnsub,
  vnsup: vnsup,
  Vopf: Vopf,
  vopf: vopf,
  vprop: vprop,
  vrtri: vrtri,
  Vscr: Vscr,
  vscr: vscr,
  vsubnE: vsubnE,
  vsubne: vsubne,
  vsupnE: vsupnE,
  vsupne: vsupne,
  Vvdash: Vvdash,
  vzigzag: vzigzag,
  Wcirc: Wcirc,
  wcirc: wcirc,
  wedbar: wedbar,
  wedge: wedge,
  Wedge: Wedge,
  wedgeq: wedgeq,
  weierp: weierp,
  Wfr: Wfr,
  wfr: wfr,
  Wopf: Wopf,
  wopf: wopf,
  wp: wp,
  wr: wr,
  wreath: wreath,
  Wscr: Wscr,
  wscr: wscr,
  xcap: xcap,
  xcirc: xcirc,
  xcup: xcup,
  xdtri: xdtri,
  Xfr: Xfr,
  xfr: xfr,
  xharr: xharr,
  xhArr: xhArr,
  Xi: Xi,
  xi: xi,
  xlarr: xlarr,
  xlArr: xlArr,
  xmap: xmap,
  xnis: xnis,
  xodot: xodot,
  Xopf: Xopf,
  xopf: xopf,
  xoplus: xoplus,
  xotime: xotime,
  xrarr: xrarr,
  xrArr: xrArr,
  Xscr: Xscr,
  xscr: xscr,
  xsqcup: xsqcup,
  xuplus: xuplus,
  xutri: xutri,
  xvee: xvee,
  xwedge: xwedge,
  Yacute: Yacute$1,
  yacute: yacute$1,
  YAcy: YAcy,
  yacy: yacy,
  Ycirc: Ycirc,
  ycirc: ycirc,
  Ycy: Ycy,
  ycy: ycy,
  yen: yen$1,
  Yfr: Yfr,
  yfr: yfr,
  YIcy: YIcy,
  yicy: yicy,
  Yopf: Yopf,
  yopf: yopf,
  Yscr: Yscr,
  yscr: yscr,
  YUcy: YUcy,
  yucy: yucy,
  yuml: yuml$1,
  Yuml: Yuml,
  Zacute: Zacute,
  zacute: zacute,
  Zcaron: Zcaron,
  zcaron: zcaron,
  Zcy: Zcy,
  zcy: zcy,
  Zdot: Zdot,
  zdot: zdot,
  zeetrf: zeetrf,
  ZeroWidthSpace: ZeroWidthSpace,
  Zeta: Zeta,
  zeta: zeta,
  zfr: zfr,
  Zfr: Zfr,
  ZHcy: ZHcy,
  zhcy: zhcy,
  zigrarr: zigrarr,
  zopf: zopf,
  Zopf: Zopf,
  Zscr: Zscr,
  zscr: zscr,
  zwj: zwj,
  zwnj: zwnj,
  'default': entities
});

var Aacute = "Á";
var aacute = "á";
var Acirc = "Â";
var acirc = "â";
var acute = "´";
var AElig = "Æ";
var aelig = "æ";
var Agrave = "À";
var agrave = "à";
var amp$1 = "&";
var AMP = "&";
var Aring = "Å";
var aring = "å";
var Atilde = "Ã";
var atilde = "ã";
var Auml = "Ä";
var auml = "ä";
var brvbar = "¦";
var Ccedil = "Ç";
var ccedil = "ç";
var cedil = "¸";
var cent = "¢";
var copy = "©";
var COPY = "©";
var curren = "¤";
var deg = "°";
var divide = "÷";
var Eacute = "É";
var eacute = "é";
var Ecirc = "Ê";
var ecirc = "ê";
var Egrave = "È";
var egrave = "è";
var ETH = "Ð";
var eth = "ð";
var Euml = "Ë";
var euml = "ë";
var frac12 = "½";
var frac14 = "¼";
var frac34 = "¾";
var gt$1 = ">";
var GT = ">";
var Iacute = "Í";
var iacute = "í";
var Icirc = "Î";
var icirc = "î";
var iexcl = "¡";
var Igrave = "Ì";
var igrave = "ì";
var iquest = "¿";
var Iuml = "Ï";
var iuml = "ï";
var laquo = "«";
var lt$1 = "<";
var LT = "<";
var macr = "¯";
var micro = "µ";
var middot = "·";
var nbsp = " ";
var not = "¬";
var Ntilde = "Ñ";
var ntilde = "ñ";
var Oacute = "Ó";
var oacute = "ó";
var Ocirc = "Ô";
var ocirc = "ô";
var Ograve = "Ò";
var ograve = "ò";
var ordf = "ª";
var ordm = "º";
var Oslash = "Ø";
var oslash = "ø";
var Otilde = "Õ";
var otilde = "õ";
var Ouml = "Ö";
var ouml = "ö";
var para = "¶";
var plusmn = "±";
var pound = "£";
var quot$1 = "\"";
var QUOT = "\"";
var raquo = "»";
var reg = "®";
var REG = "®";
var sect = "§";
var shy = "­";
var sup1 = "¹";
var sup2 = "²";
var sup3 = "³";
var szlig = "ß";
var THORN = "Þ";
var thorn = "þ";
var times = "×";
var Uacute = "Ú";
var uacute = "ú";
var Ucirc = "Û";
var ucirc = "û";
var Ugrave = "Ù";
var ugrave = "ù";
var uml = "¨";
var Uuml = "Ü";
var uuml = "ü";
var Yacute = "Ý";
var yacute = "ý";
var yen = "¥";
var yuml = "ÿ";
var legacy = {
	Aacute: Aacute,
	aacute: aacute,
	Acirc: Acirc,
	acirc: acirc,
	acute: acute,
	AElig: AElig,
	aelig: aelig,
	Agrave: Agrave,
	agrave: agrave,
	amp: amp$1,
	AMP: AMP,
	Aring: Aring,
	aring: aring,
	Atilde: Atilde,
	atilde: atilde,
	Auml: Auml,
	auml: auml,
	brvbar: brvbar,
	Ccedil: Ccedil,
	ccedil: ccedil,
	cedil: cedil,
	cent: cent,
	copy: copy,
	COPY: COPY,
	curren: curren,
	deg: deg,
	divide: divide,
	Eacute: Eacute,
	eacute: eacute,
	Ecirc: Ecirc,
	ecirc: ecirc,
	Egrave: Egrave,
	egrave: egrave,
	ETH: ETH,
	eth: eth,
	Euml: Euml,
	euml: euml,
	frac12: frac12,
	frac14: frac14,
	frac34: frac34,
	gt: gt$1,
	GT: GT,
	Iacute: Iacute,
	iacute: iacute,
	Icirc: Icirc,
	icirc: icirc,
	iexcl: iexcl,
	Igrave: Igrave,
	igrave: igrave,
	iquest: iquest,
	Iuml: Iuml,
	iuml: iuml,
	laquo: laquo,
	lt: lt$1,
	LT: LT,
	macr: macr,
	micro: micro,
	middot: middot,
	nbsp: nbsp,
	not: not,
	Ntilde: Ntilde,
	ntilde: ntilde,
	Oacute: Oacute,
	oacute: oacute,
	Ocirc: Ocirc,
	ocirc: ocirc,
	Ograve: Ograve,
	ograve: ograve,
	ordf: ordf,
	ordm: ordm,
	Oslash: Oslash,
	oslash: oslash,
	Otilde: Otilde,
	otilde: otilde,
	Ouml: Ouml,
	ouml: ouml,
	para: para,
	plusmn: plusmn,
	pound: pound,
	quot: quot$1,
	QUOT: QUOT,
	raquo: raquo,
	reg: reg,
	REG: REG,
	sect: sect,
	shy: shy,
	sup1: sup1,
	sup2: sup2,
	sup3: sup3,
	szlig: szlig,
	THORN: THORN,
	thorn: thorn,
	times: times,
	Uacute: Uacute,
	uacute: uacute,
	Ucirc: Ucirc,
	ucirc: ucirc,
	Ugrave: Ugrave,
	ugrave: ugrave,
	uml: uml,
	Uuml: Uuml,
	uuml: uuml,
	Yacute: Yacute,
	yacute: yacute,
	yen: yen,
	yuml: yuml
};

var legacy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Aacute: Aacute,
  aacute: aacute,
  Acirc: Acirc,
  acirc: acirc,
  acute: acute,
  AElig: AElig,
  aelig: aelig,
  Agrave: Agrave,
  agrave: agrave,
  amp: amp$1,
  AMP: AMP,
  Aring: Aring,
  aring: aring,
  Atilde: Atilde,
  atilde: atilde,
  Auml: Auml,
  auml: auml,
  brvbar: brvbar,
  Ccedil: Ccedil,
  ccedil: ccedil,
  cedil: cedil,
  cent: cent,
  copy: copy,
  COPY: COPY,
  curren: curren,
  deg: deg,
  divide: divide,
  Eacute: Eacute,
  eacute: eacute,
  Ecirc: Ecirc,
  ecirc: ecirc,
  Egrave: Egrave,
  egrave: egrave,
  ETH: ETH,
  eth: eth,
  Euml: Euml,
  euml: euml,
  frac12: frac12,
  frac14: frac14,
  frac34: frac34,
  gt: gt$1,
  GT: GT,
  Iacute: Iacute,
  iacute: iacute,
  Icirc: Icirc,
  icirc: icirc,
  iexcl: iexcl,
  Igrave: Igrave,
  igrave: igrave,
  iquest: iquest,
  Iuml: Iuml,
  iuml: iuml,
  laquo: laquo,
  lt: lt$1,
  LT: LT,
  macr: macr,
  micro: micro,
  middot: middot,
  nbsp: nbsp,
  not: not,
  Ntilde: Ntilde,
  ntilde: ntilde,
  Oacute: Oacute,
  oacute: oacute,
  Ocirc: Ocirc,
  ocirc: ocirc,
  Ograve: Ograve,
  ograve: ograve,
  ordf: ordf,
  ordm: ordm,
  Oslash: Oslash,
  oslash: oslash,
  Otilde: Otilde,
  otilde: otilde,
  Ouml: Ouml,
  ouml: ouml,
  para: para,
  plusmn: plusmn,
  pound: pound,
  quot: quot$1,
  QUOT: QUOT,
  raquo: raquo,
  reg: reg,
  REG: REG,
  sect: sect,
  shy: shy,
  sup1: sup1,
  sup2: sup2,
  sup3: sup3,
  szlig: szlig,
  THORN: THORN,
  thorn: thorn,
  times: times,
  Uacute: Uacute,
  uacute: uacute,
  Ucirc: Ucirc,
  ucirc: ucirc,
  Ugrave: Ugrave,
  ugrave: ugrave,
  uml: uml,
  Uuml: Uuml,
  uuml: uuml,
  Yacute: Yacute,
  yacute: yacute,
  yen: yen,
  yuml: yuml,
  'default': legacy
});

var amp = "&";
var apos = "'";
var gt = ">";
var lt = "<";
var quot = "\"";
var xml = {
	amp: amp,
	apos: apos,
	gt: gt,
	lt: lt,
	quot: quot
};

var xml$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  amp: amp,
  apos: apos,
  gt: gt,
  lt: lt,
  quot: quot,
  'default': xml
});

var require$$1 = getCjsExportFromNamespace(entities$1);

var require$$2 = getCjsExportFromNamespace(legacy$1);

var require$$3 = getCjsExportFromNamespace(xml$1);

var Tokenizer_1 = createCommonjsModule(function (module, exports) {

  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var decode_codepoint_1 = __importDefault(decode_codepoint);

  var entities_json_1 = __importDefault(require$$1);

  var legacy_json_1 = __importDefault(require$$2);

  var xml_json_1 = __importDefault(require$$3);

  function whitespace(c) {
    return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
  }

  function isASCIIAlpha(c) {
    return c >= "a" && c <= "z" || c >= "A" && c <= "Z";
  }

  function ifElseState(upper, SUCCESS, FAILURE) {
    var lower = upper.toLowerCase();

    if (upper === lower) {
      return function (t, c) {
        if (c === lower) {
          t._state = SUCCESS;
        } else {
          t._state = FAILURE;
          t._index--;
        }
      };
    }

    return function (t, c) {
      if (c === lower || c === upper) {
        t._state = SUCCESS;
      } else {
        t._state = FAILURE;
        t._index--;
      }
    };
  }

  function consumeSpecialNameChar(upper, NEXT_STATE) {
    var lower = upper.toLowerCase();
    return function (t, c) {
      if (c === lower || c === upper) {
        t._state = NEXT_STATE;
      } else {
        t._state = 3
        /* InTagName */
        ;
        t._index--; // Consume the token again
      }
    };
  }

  var stateBeforeCdata1 = ifElseState("C", 24
  /* BeforeCdata2 */
  , 16
  /* InDeclaration */
  );
  var stateBeforeCdata2 = ifElseState("D", 25
  /* BeforeCdata3 */
  , 16
  /* InDeclaration */
  );
  var stateBeforeCdata3 = ifElseState("A", 26
  /* BeforeCdata4 */
  , 16
  /* InDeclaration */
  );
  var stateBeforeCdata4 = ifElseState("T", 27
  /* BeforeCdata5 */
  , 16
  /* InDeclaration */
  );
  var stateBeforeCdata5 = ifElseState("A", 28
  /* BeforeCdata6 */
  , 16
  /* InDeclaration */
  );
  var stateBeforeScript1 = consumeSpecialNameChar("R", 35
  /* BeforeScript2 */
  );
  var stateBeforeScript2 = consumeSpecialNameChar("I", 36
  /* BeforeScript3 */
  );
  var stateBeforeScript3 = consumeSpecialNameChar("P", 37
  /* BeforeScript4 */
  );
  var stateBeforeScript4 = consumeSpecialNameChar("T", 38
  /* BeforeScript5 */
  );
  var stateAfterScript1 = ifElseState("R", 40
  /* AfterScript2 */
  , 1
  /* Text */
  );
  var stateAfterScript2 = ifElseState("I", 41
  /* AfterScript3 */
  , 1
  /* Text */
  );
  var stateAfterScript3 = ifElseState("P", 42
  /* AfterScript4 */
  , 1
  /* Text */
  );
  var stateAfterScript4 = ifElseState("T", 43
  /* AfterScript5 */
  , 1
  /* Text */
  );
  var stateBeforeStyle1 = consumeSpecialNameChar("Y", 45
  /* BeforeStyle2 */
  );
  var stateBeforeStyle2 = consumeSpecialNameChar("L", 46
  /* BeforeStyle3 */
  );
  var stateBeforeStyle3 = consumeSpecialNameChar("E", 47
  /* BeforeStyle4 */
  );
  var stateAfterStyle1 = ifElseState("Y", 49
  /* AfterStyle2 */
  , 1
  /* Text */
  );
  var stateAfterStyle2 = ifElseState("L", 50
  /* AfterStyle3 */
  , 1
  /* Text */
  );
  var stateAfterStyle3 = ifElseState("E", 51
  /* AfterStyle4 */
  , 1
  /* Text */
  );
  var stateBeforeSpecialT = consumeSpecialNameChar("I", 54
  /* BeforeTitle1 */
  );
  var stateBeforeTitle1 = consumeSpecialNameChar("T", 55
  /* BeforeTitle2 */
  );
  var stateBeforeTitle2 = consumeSpecialNameChar("L", 56
  /* BeforeTitle3 */
  );
  var stateBeforeTitle3 = consumeSpecialNameChar("E", 57
  /* BeforeTitle4 */
  );
  var stateAfterSpecialTEnd = ifElseState("I", 58
  /* AfterTitle1 */
  , 1
  /* Text */
  );
  var stateAfterTitle1 = ifElseState("T", 59
  /* AfterTitle2 */
  , 1
  /* Text */
  );
  var stateAfterTitle2 = ifElseState("L", 60
  /* AfterTitle3 */
  , 1
  /* Text */
  );
  var stateAfterTitle3 = ifElseState("E", 61
  /* AfterTitle4 */
  , 1
  /* Text */
  );
  var stateBeforeEntity = ifElseState("#", 63
  /* BeforeNumericEntity */
  , 64
  /* InNamedEntity */
  );
  var stateBeforeNumericEntity = ifElseState("X", 66
  /* InHexEntity */
  , 65
  /* InNumericEntity */
  );

  var Tokenizer =
  /** @class */
  function () {
    function Tokenizer(options, cbs) {
      var _a;
      /** The current state the tokenizer is in. */


      this._state = 1
      /* Text */
      ;
      /** The read buffer. */

      this.buffer = "";
      /** The beginning of the section that is currently being read. */

      this.sectionStart = 0;
      /** The index within the buffer that we are currently looking at. */

      this._index = 0;
      /**
       * Data that has already been processed will be removed from the buffer occasionally.
       * `_bufferOffset` keeps track of how many characters have been removed, to make sure position information is accurate.
       */

      this.bufferOffset = 0;
      /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */

      this.baseState = 1
      /* Text */
      ;
      /** For special parsing behavior inside of script and style tags. */

      this.special = 1
      /* None */
      ;
      /** Indicates whether the tokenizer has been paused. */

      this.running = true;
      /** Indicates whether the tokenizer has finished running / `.end` has been called. */

      this.ended = false;
      this.cbs = cbs;
      this.xmlMode = !!(options === null || options === void 0 ? void 0 : options.xmlMode);
      this.decodeEntities = (_a = options === null || options === void 0 ? void 0 : options.decodeEntities) !== null && _a !== void 0 ? _a : true;
    }

    Tokenizer.prototype.reset = function () {
      this._state = 1
      /* Text */
      ;
      this.buffer = "";
      this.sectionStart = 0;
      this._index = 0;
      this.bufferOffset = 0;
      this.baseState = 1
      /* Text */
      ;
      this.special = 1
      /* None */
      ;
      this.running = true;
      this.ended = false;
    };

    Tokenizer.prototype.write = function (chunk) {
      if (this.ended) this.cbs.onerror(Error(".write() after done!"));
      this.buffer += chunk;
      this.parse();
    };

    Tokenizer.prototype.end = function (chunk) {
      if (this.ended) this.cbs.onerror(Error(".end() after done!"));
      if (chunk) this.write(chunk);
      this.ended = true;
      if (this.running) this.finish();
    };

    Tokenizer.prototype.pause = function () {
      this.running = false;
    };

    Tokenizer.prototype.resume = function () {
      this.running = true;

      if (this._index < this.buffer.length) {
        this.parse();
      }

      if (this.ended) {
        this.finish();
      }
    };
    /**
     * The current index within all of the written data.
     */


    Tokenizer.prototype.getAbsoluteIndex = function () {
      return this.bufferOffset + this._index;
    };

    Tokenizer.prototype.stateText = function (c) {
      if (c === "<") {
        if (this._index > this.sectionStart) {
          this.cbs.ontext(this.getSection());
        }

        this._state = 2
        /* BeforeTagName */
        ;
        this.sectionStart = this._index;
      } else if (this.decodeEntities && c === "&" && (this.special === 1
      /* None */
      || this.special === 4
      /* Title */
      )) {
        if (this._index > this.sectionStart) {
          this.cbs.ontext(this.getSection());
        }

        this.baseState = 1
        /* Text */
        ;
        this._state = 62
        /* BeforeEntity */
        ;
        this.sectionStart = this._index;
      }
    };

    Tokenizer.prototype.stateBeforeTagName = function (c) {
      if (c === "/") {
        this._state = 5
        /* BeforeClosingTagName */
        ;
      } else if (c === "<") {
        this.cbs.ontext(this.getSection());
        this.sectionStart = this._index;
      } else if (c === ">" || this.special !== 1
      /* None */
      || whitespace(c)) {
        this._state = 1
        /* Text */
        ;
      } else if (c === "!") {
        this._state = 15
        /* BeforeDeclaration */
        ;
        this.sectionStart = this._index + 1;
      } else if (c === "?") {
        this._state = 17
        /* InProcessingInstruction */
        ;
        this.sectionStart = this._index + 1;
      } else if (!isASCIIAlpha(c)) {
        this._state = 1
        /* Text */
        ;
      } else {
        this._state = !this.xmlMode && (c === "s" || c === "S") ? 32
        /* BeforeSpecialS */
        : !this.xmlMode && (c === "t" || c === "T") ? 52
        /* BeforeSpecialT */
        : 3
        /* InTagName */
        ;
        this.sectionStart = this._index;
      }
    };

    Tokenizer.prototype.stateInTagName = function (c) {
      if (c === "/" || c === ">" || whitespace(c)) {
        this.emitToken("onopentagname");
        this._state = 8
        /* BeforeAttributeName */
        ;
        this._index--;
      }
    };

    Tokenizer.prototype.stateBeforeClosingTagName = function (c) {
      if (whitespace(c)) ; else if (c === ">") {
        this._state = 1
        /* Text */
        ;
      } else if (this.special !== 1
      /* None */
      ) {
          if (c === "s" || c === "S") {
            this._state = 33
            /* BeforeSpecialSEnd */
            ;
          } else if (c === "t" || c === "T") {
            this._state = 53
            /* BeforeSpecialTEnd */
            ;
          } else {
            this._state = 1
            /* Text */
            ;
            this._index--;
          }
        } else if (!isASCIIAlpha(c)) {
        this._state = 20
        /* InSpecialComment */
        ;
        this.sectionStart = this._index;
      } else {
        this._state = 6
        /* InClosingTagName */
        ;
        this.sectionStart = this._index;
      }
    };

    Tokenizer.prototype.stateInClosingTagName = function (c) {
      if (c === ">" || whitespace(c)) {
        this.emitToken("onclosetag");
        this._state = 7
        /* AfterClosingTagName */
        ;
        this._index--;
      }
    };

    Tokenizer.prototype.stateAfterClosingTagName = function (c) {
      // Skip everything until ">"
      if (c === ">") {
        this._state = 1
        /* Text */
        ;
        this.sectionStart = this._index + 1;
      }
    };

    Tokenizer.prototype.stateBeforeAttributeName = function (c) {
      if (c === ">") {
        this.cbs.onopentagend();
        this._state = 1
        /* Text */
        ;
        this.sectionStart = this._index + 1;
      } else if (c === "/") {
        this._state = 4
        /* InSelfClosingTag */
        ;
      } else if (!whitespace(c)) {
        this._state = 9
        /* InAttributeName */
        ;
        this.sectionStart = this._index;
      }
    };

    Tokenizer.prototype.stateInSelfClosingTag = function (c) {
      if (c === ">") {
        this.cbs.onselfclosingtag();
        this._state = 1
        /* Text */
        ;
        this.sectionStart = this._index + 1;
        this.special = 1
        /* None */
        ; // Reset special state, in case of self-closing special tags
      } else if (!whitespace(c)) {
        this._state = 8
        /* BeforeAttributeName */
        ;
        this._index--;
      }
    };

    Tokenizer.prototype.stateInAttributeName = function (c) {
      if (c === "=" || c === "/" || c === ">" || whitespace(c)) {
        this.cbs.onattribname(this.getSection());
        this.sectionStart = -1;
        this._state = 10
        /* AfterAttributeName */
        ;
        this._index--;
      }
    };

    Tokenizer.prototype.stateAfterAttributeName = function (c) {
      if (c === "=") {
        this._state = 11
        /* BeforeAttributeValue */
        ;
      } else if (c === "/" || c === ">") {
        this.cbs.onattribend(undefined);
        this._state = 8
        /* BeforeAttributeName */
        ;
        this._index--;
      } else if (!whitespace(c)) {
        this.cbs.onattribend(undefined);
        this._state = 9
        /* InAttributeName */
        ;
        this.sectionStart = this._index;
      }
    };

    Tokenizer.prototype.stateBeforeAttributeValue = function (c) {
      if (c === '"') {
        this._state = 12
        /* InAttributeValueDq */
        ;
        this.sectionStart = this._index + 1;
      } else if (c === "'") {
        this._state = 13
        /* InAttributeValueSq */
        ;
        this.sectionStart = this._index + 1;
      } else if (!whitespace(c)) {
        this._state = 14
        /* InAttributeValueNq */
        ;
        this.sectionStart = this._index;
        this._index--; // Reconsume token
      }
    };

    Tokenizer.prototype.handleInAttributeValue = function (c, quote) {
      if (c === quote) {
        this.emitToken("onattribdata");
        this.cbs.onattribend(quote);
        this._state = 8
        /* BeforeAttributeName */
        ;
      } else if (this.decodeEntities && c === "&") {
        this.emitToken("onattribdata");
        this.baseState = this._state;
        this._state = 62
        /* BeforeEntity */
        ;
        this.sectionStart = this._index;
      }
    };

    Tokenizer.prototype.stateInAttributeValueDoubleQuotes = function (c) {
      this.handleInAttributeValue(c, '"');
    };

    Tokenizer.prototype.stateInAttributeValueSingleQuotes = function (c) {
      this.handleInAttributeValue(c, "'");
    };

    Tokenizer.prototype.stateInAttributeValueNoQuotes = function (c) {
      if (whitespace(c) || c === ">") {
        this.emitToken("onattribdata");
        this.cbs.onattribend(null);
        this._state = 8
        /* BeforeAttributeName */
        ;
        this._index--;
      } else if (this.decodeEntities && c === "&") {
        this.emitToken("onattribdata");
        this.baseState = this._state;
        this._state = 62
        /* BeforeEntity */
        ;
        this.sectionStart = this._index;
      }
    };

    Tokenizer.prototype.stateBeforeDeclaration = function (c) {
      this._state = c === "[" ? 23
      /* BeforeCdata1 */
      : c === "-" ? 18
      /* BeforeComment */
      : 16
      /* InDeclaration */
      ;
    };

    Tokenizer.prototype.stateInDeclaration = function (c) {
      if (c === ">") {
        this.cbs.ondeclaration(this.getSection());
        this._state = 1
        /* Text */
        ;
        this.sectionStart = this._index + 1;
      }
    };

    Tokenizer.prototype.stateInProcessingInstruction = function (c) {
      if (c === ">") {
        this.cbs.onprocessinginstruction(this.getSection());
        this._state = 1
        /* Text */
        ;
        this.sectionStart = this._index + 1;
      }
    };

    Tokenizer.prototype.stateBeforeComment = function (c) {
      if (c === "-") {
        this._state = 19
        /* InComment */
        ;
        this.sectionStart = this._index + 1;
      } else {
        this._state = 16
        /* InDeclaration */
        ;
      }
    };

    Tokenizer.prototype.stateInComment = function (c) {
      if (c === "-") this._state = 21
      /* AfterComment1 */
      ;
    };

    Tokenizer.prototype.stateInSpecialComment = function (c) {
      if (c === ">") {
        this.cbs.oncomment(this.buffer.substring(this.sectionStart, this._index));
        this._state = 1
        /* Text */
        ;
        this.sectionStart = this._index + 1;
      }
    };

    Tokenizer.prototype.stateAfterComment1 = function (c) {
      if (c === "-") {
        this._state = 22
        /* AfterComment2 */
        ;
      } else {
        this._state = 19
        /* InComment */
        ;
      }
    };

    Tokenizer.prototype.stateAfterComment2 = function (c) {
      if (c === ">") {
        // Remove 2 trailing chars
        this.cbs.oncomment(this.buffer.substring(this.sectionStart, this._index - 2));
        this._state = 1
        /* Text */
        ;
        this.sectionStart = this._index + 1;
      } else if (c !== "-") {
        this._state = 19
        /* InComment */
        ;
      } // Else: stay in AFTER_COMMENT_2 (`--->`)

    };

    Tokenizer.prototype.stateBeforeCdata6 = function (c) {
      if (c === "[") {
        this._state = 29
        /* InCdata */
        ;
        this.sectionStart = this._index + 1;
      } else {
        this._state = 16
        /* InDeclaration */
        ;
        this._index--;
      }
    };

    Tokenizer.prototype.stateInCdata = function (c) {
      if (c === "]") this._state = 30
      /* AfterCdata1 */
      ;
    };

    Tokenizer.prototype.stateAfterCdata1 = function (c) {
      if (c === "]") this._state = 31
      /* AfterCdata2 */
      ;else this._state = 29
      /* InCdata */
      ;
    };

    Tokenizer.prototype.stateAfterCdata2 = function (c) {
      if (c === ">") {
        // Remove 2 trailing chars
        this.cbs.oncdata(this.buffer.substring(this.sectionStart, this._index - 2));
        this._state = 1
        /* Text */
        ;
        this.sectionStart = this._index + 1;
      } else if (c !== "]") {
        this._state = 29
        /* InCdata */
        ;
      } // Else: stay in AFTER_CDATA_2 (`]]]>`)

    };

    Tokenizer.prototype.stateBeforeSpecialS = function (c) {
      if (c === "c" || c === "C") {
        this._state = 34
        /* BeforeScript1 */
        ;
      } else if (c === "t" || c === "T") {
        this._state = 44
        /* BeforeStyle1 */
        ;
      } else {
        this._state = 3
        /* InTagName */
        ;
        this._index--; // Consume the token again
      }
    };

    Tokenizer.prototype.stateBeforeSpecialSEnd = function (c) {
      if (this.special === 2
      /* Script */
      && (c === "c" || c === "C")) {
        this._state = 39
        /* AfterScript1 */
        ;
      } else if (this.special === 3
      /* Style */
      && (c === "t" || c === "T")) {
        this._state = 48
        /* AfterStyle1 */
        ;
      } else this._state = 1
      /* Text */
      ;
    };

    Tokenizer.prototype.stateBeforeSpecialLast = function (c, special) {
      if (c === "/" || c === ">" || whitespace(c)) {
        this.special = special;
      }

      this._state = 3
      /* InTagName */
      ;
      this._index--; // Consume the token again
    };

    Tokenizer.prototype.stateAfterSpecialLast = function (c, sectionStartOffset) {
      if (c === ">" || whitespace(c)) {
        this.special = 1
        /* None */
        ;
        this._state = 6
        /* InClosingTagName */
        ;
        this.sectionStart = this._index - sectionStartOffset;
        this._index--; // Reconsume the token
      } else this._state = 1
      /* Text */
      ;
    }; // For entities terminated with a semicolon


    Tokenizer.prototype.parseFixedEntity = function (map) {
      if (map === void 0) {
        map = this.xmlMode ? xml_json_1["default"] : entities_json_1["default"];
      } // Offset = 1


      if (this.sectionStart + 1 < this._index) {
        var entity = this.buffer.substring(this.sectionStart + 1, this._index);

        if (Object.prototype.hasOwnProperty.call(map, entity)) {
          this.emitPartial(map[entity]);
          this.sectionStart = this._index + 1;
        }
      }
    }; // Parses legacy entities (without trailing semicolon)


    Tokenizer.prototype.parseLegacyEntity = function () {
      var start = this.sectionStart + 1; // The max length of legacy entities is 6

      var limit = Math.min(this._index - start, 6);

      while (limit >= 2) {
        // The min length of legacy entities is 2
        var entity = this.buffer.substr(start, limit);

        if (Object.prototype.hasOwnProperty.call(legacy_json_1["default"], entity)) {
          this.emitPartial(legacy_json_1["default"][entity]);
          this.sectionStart += limit + 1;
          return;
        }

        limit--;
      }
    };

    Tokenizer.prototype.stateInNamedEntity = function (c) {
      if (c === ";") {
        this.parseFixedEntity(); // Retry as legacy entity if entity wasn't parsed

        if (this.baseState === 1
        /* Text */
        && this.sectionStart + 1 < this._index && !this.xmlMode) {
          this.parseLegacyEntity();
        }

        this._state = this.baseState;
      } else if ((c < "0" || c > "9") && !isASCIIAlpha(c)) {
        if (this.xmlMode || this.sectionStart + 1 === this._index) ; else if (this.baseState !== 1
        /* Text */
        ) {
            if (c !== "=") {
              // Parse as legacy entity, without allowing additional characters.
              this.parseFixedEntity(legacy_json_1["default"]);
            }
          } else {
          this.parseLegacyEntity();
        }

        this._state = this.baseState;
        this._index--;
      }
    };

    Tokenizer.prototype.decodeNumericEntity = function (offset, base, strict) {
      var sectionStart = this.sectionStart + offset;

      if (sectionStart !== this._index) {
        // Parse entity
        var entity = this.buffer.substring(sectionStart, this._index);
        var parsed = parseInt(entity, base);
        this.emitPartial(decode_codepoint_1["default"](parsed));
        this.sectionStart = strict ? this._index + 1 : this._index;
      }

      this._state = this.baseState;
    };

    Tokenizer.prototype.stateInNumericEntity = function (c) {
      if (c === ";") {
        this.decodeNumericEntity(2, 10, true);
      } else if (c < "0" || c > "9") {
        if (!this.xmlMode) {
          this.decodeNumericEntity(2, 10, false);
        } else {
          this._state = this.baseState;
        }

        this._index--;
      }
    };

    Tokenizer.prototype.stateInHexEntity = function (c) {
      if (c === ";") {
        this.decodeNumericEntity(3, 16, true);
      } else if ((c < "a" || c > "f") && (c < "A" || c > "F") && (c < "0" || c > "9")) {
        if (!this.xmlMode) {
          this.decodeNumericEntity(3, 16, false);
        } else {
          this._state = this.baseState;
        }

        this._index--;
      }
    };

    Tokenizer.prototype.cleanup = function () {
      if (this.sectionStart < 0) {
        this.buffer = "";
        this.bufferOffset += this._index;
        this._index = 0;
      } else if (this.running) {
        if (this._state === 1
        /* Text */
        ) {
            if (this.sectionStart !== this._index) {
              this.cbs.ontext(this.buffer.substr(this.sectionStart));
            }

            this.buffer = "";
            this.bufferOffset += this._index;
            this._index = 0;
          } else if (this.sectionStart === this._index) {
          // The section just started
          this.buffer = "";
          this.bufferOffset += this._index;
          this._index = 0;
        } else {
          // Remove everything unnecessary
          this.buffer = this.buffer.substr(this.sectionStart);
          this._index -= this.sectionStart;
          this.bufferOffset += this.sectionStart;
        }

        this.sectionStart = 0;
      }
    };
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */


    Tokenizer.prototype.parse = function () {
      while (this._index < this.buffer.length && this.running) {
        var c = this.buffer.charAt(this._index);

        if (this._state === 1
        /* Text */
        ) {
            this.stateText(c);
          } else if (this._state === 12
        /* InAttributeValueDq */
        ) {
            this.stateInAttributeValueDoubleQuotes(c);
          } else if (this._state === 9
        /* InAttributeName */
        ) {
            this.stateInAttributeName(c);
          } else if (this._state === 19
        /* InComment */
        ) {
            this.stateInComment(c);
          } else if (this._state === 20
        /* InSpecialComment */
        ) {
            this.stateInSpecialComment(c);
          } else if (this._state === 8
        /* BeforeAttributeName */
        ) {
            this.stateBeforeAttributeName(c);
          } else if (this._state === 3
        /* InTagName */
        ) {
            this.stateInTagName(c);
          } else if (this._state === 6
        /* InClosingTagName */
        ) {
            this.stateInClosingTagName(c);
          } else if (this._state === 2
        /* BeforeTagName */
        ) {
            this.stateBeforeTagName(c);
          } else if (this._state === 10
        /* AfterAttributeName */
        ) {
            this.stateAfterAttributeName(c);
          } else if (this._state === 13
        /* InAttributeValueSq */
        ) {
            this.stateInAttributeValueSingleQuotes(c);
          } else if (this._state === 11
        /* BeforeAttributeValue */
        ) {
            this.stateBeforeAttributeValue(c);
          } else if (this._state === 5
        /* BeforeClosingTagName */
        ) {
            this.stateBeforeClosingTagName(c);
          } else if (this._state === 7
        /* AfterClosingTagName */
        ) {
            this.stateAfterClosingTagName(c);
          } else if (this._state === 32
        /* BeforeSpecialS */
        ) {
            this.stateBeforeSpecialS(c);
          } else if (this._state === 21
        /* AfterComment1 */
        ) {
            this.stateAfterComment1(c);
          } else if (this._state === 14
        /* InAttributeValueNq */
        ) {
            this.stateInAttributeValueNoQuotes(c);
          } else if (this._state === 4
        /* InSelfClosingTag */
        ) {
            this.stateInSelfClosingTag(c);
          } else if (this._state === 16
        /* InDeclaration */
        ) {
            this.stateInDeclaration(c);
          } else if (this._state === 15
        /* BeforeDeclaration */
        ) {
            this.stateBeforeDeclaration(c);
          } else if (this._state === 22
        /* AfterComment2 */
        ) {
            this.stateAfterComment2(c);
          } else if (this._state === 18
        /* BeforeComment */
        ) {
            this.stateBeforeComment(c);
          } else if (this._state === 33
        /* BeforeSpecialSEnd */
        ) {
            this.stateBeforeSpecialSEnd(c);
          } else if (this._state === 53
        /* BeforeSpecialTEnd */
        ) {
            stateAfterSpecialTEnd(this, c);
          } else if (this._state === 39
        /* AfterScript1 */
        ) {
            stateAfterScript1(this, c);
          } else if (this._state === 40
        /* AfterScript2 */
        ) {
            stateAfterScript2(this, c);
          } else if (this._state === 41
        /* AfterScript3 */
        ) {
            stateAfterScript3(this, c);
          } else if (this._state === 34
        /* BeforeScript1 */
        ) {
            stateBeforeScript1(this, c);
          } else if (this._state === 35
        /* BeforeScript2 */
        ) {
            stateBeforeScript2(this, c);
          } else if (this._state === 36
        /* BeforeScript3 */
        ) {
            stateBeforeScript3(this, c);
          } else if (this._state === 37
        /* BeforeScript4 */
        ) {
            stateBeforeScript4(this, c);
          } else if (this._state === 38
        /* BeforeScript5 */
        ) {
            this.stateBeforeSpecialLast(c, 2
            /* Script */
            );
          } else if (this._state === 42
        /* AfterScript4 */
        ) {
            stateAfterScript4(this, c);
          } else if (this._state === 43
        /* AfterScript5 */
        ) {
            this.stateAfterSpecialLast(c, 6);
          } else if (this._state === 44
        /* BeforeStyle1 */
        ) {
            stateBeforeStyle1(this, c);
          } else if (this._state === 29
        /* InCdata */
        ) {
            this.stateInCdata(c);
          } else if (this._state === 45
        /* BeforeStyle2 */
        ) {
            stateBeforeStyle2(this, c);
          } else if (this._state === 46
        /* BeforeStyle3 */
        ) {
            stateBeforeStyle3(this, c);
          } else if (this._state === 47
        /* BeforeStyle4 */
        ) {
            this.stateBeforeSpecialLast(c, 3
            /* Style */
            );
          } else if (this._state === 48
        /* AfterStyle1 */
        ) {
            stateAfterStyle1(this, c);
          } else if (this._state === 49
        /* AfterStyle2 */
        ) {
            stateAfterStyle2(this, c);
          } else if (this._state === 50
        /* AfterStyle3 */
        ) {
            stateAfterStyle3(this, c);
          } else if (this._state === 51
        /* AfterStyle4 */
        ) {
            this.stateAfterSpecialLast(c, 5);
          } else if (this._state === 52
        /* BeforeSpecialT */
        ) {
            stateBeforeSpecialT(this, c);
          } else if (this._state === 54
        /* BeforeTitle1 */
        ) {
            stateBeforeTitle1(this, c);
          } else if (this._state === 55
        /* BeforeTitle2 */
        ) {
            stateBeforeTitle2(this, c);
          } else if (this._state === 56
        /* BeforeTitle3 */
        ) {
            stateBeforeTitle3(this, c);
          } else if (this._state === 57
        /* BeforeTitle4 */
        ) {
            this.stateBeforeSpecialLast(c, 4
            /* Title */
            );
          } else if (this._state === 58
        /* AfterTitle1 */
        ) {
            stateAfterTitle1(this, c);
          } else if (this._state === 59
        /* AfterTitle2 */
        ) {
            stateAfterTitle2(this, c);
          } else if (this._state === 60
        /* AfterTitle3 */
        ) {
            stateAfterTitle3(this, c);
          } else if (this._state === 61
        /* AfterTitle4 */
        ) {
            this.stateAfterSpecialLast(c, 5);
          } else if (this._state === 17
        /* InProcessingInstruction */
        ) {
            this.stateInProcessingInstruction(c);
          } else if (this._state === 64
        /* InNamedEntity */
        ) {
            this.stateInNamedEntity(c);
          } else if (this._state === 23
        /* BeforeCdata1 */
        ) {
            stateBeforeCdata1(this, c);
          } else if (this._state === 62
        /* BeforeEntity */
        ) {
            stateBeforeEntity(this, c);
          } else if (this._state === 24
        /* BeforeCdata2 */
        ) {
            stateBeforeCdata2(this, c);
          } else if (this._state === 25
        /* BeforeCdata3 */
        ) {
            stateBeforeCdata3(this, c);
          } else if (this._state === 30
        /* AfterCdata1 */
        ) {
            this.stateAfterCdata1(c);
          } else if (this._state === 31
        /* AfterCdata2 */
        ) {
            this.stateAfterCdata2(c);
          } else if (this._state === 26
        /* BeforeCdata4 */
        ) {
            stateBeforeCdata4(this, c);
          } else if (this._state === 27
        /* BeforeCdata5 */
        ) {
            stateBeforeCdata5(this, c);
          } else if (this._state === 28
        /* BeforeCdata6 */
        ) {
            this.stateBeforeCdata6(c);
          } else if (this._state === 66
        /* InHexEntity */
        ) {
            this.stateInHexEntity(c);
          } else if (this._state === 65
        /* InNumericEntity */
        ) {
            this.stateInNumericEntity(c); // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          } else if (this._state === 63
        /* BeforeNumericEntity */
        ) {
            stateBeforeNumericEntity(this, c);
          } else {
          this.cbs.onerror(Error("unknown _state"), this._state);
        }

        this._index++;
      }

      this.cleanup();
    };

    Tokenizer.prototype.finish = function () {
      // If there is remaining data, emit it in a reasonable way
      if (this.sectionStart < this._index) {
        this.handleTrailingData();
      }

      this.cbs.onend();
    };

    Tokenizer.prototype.handleTrailingData = function () {
      var data = this.buffer.substr(this.sectionStart);

      if (this._state === 29
      /* InCdata */
      || this._state === 30
      /* AfterCdata1 */
      || this._state === 31
      /* AfterCdata2 */
      ) {
          this.cbs.oncdata(data);
        } else if (this._state === 19
      /* InComment */
      || this._state === 21
      /* AfterComment1 */
      || this._state === 22
      /* AfterComment2 */
      ) {
          this.cbs.oncomment(data);
        } else if (this._state === 64
      /* InNamedEntity */
      && !this.xmlMode) {
        this.parseLegacyEntity();

        if (this.sectionStart < this._index) {
          this._state = this.baseState;
          this.handleTrailingData();
        }
      } else if (this._state === 65
      /* InNumericEntity */
      && !this.xmlMode) {
        this.decodeNumericEntity(2, 10, false);

        if (this.sectionStart < this._index) {
          this._state = this.baseState;
          this.handleTrailingData();
        }
      } else if (this._state === 66
      /* InHexEntity */
      && !this.xmlMode) {
        this.decodeNumericEntity(3, 16, false);

        if (this.sectionStart < this._index) {
          this._state = this.baseState;
          this.handleTrailingData();
        }
      } else if (this._state !== 3
      /* InTagName */
      && this._state !== 8
      /* BeforeAttributeName */
      && this._state !== 11
      /* BeforeAttributeValue */
      && this._state !== 10
      /* AfterAttributeName */
      && this._state !== 9
      /* InAttributeName */
      && this._state !== 13
      /* InAttributeValueSq */
      && this._state !== 12
      /* InAttributeValueDq */
      && this._state !== 14
      /* InAttributeValueNq */
      && this._state !== 6
      /* InClosingTagName */
      ) {
          this.cbs.ontext(data);
        }
      /*
       * Else, ignore remaining data
       * TODO add a way to remove current tag
       */

    };

    Tokenizer.prototype.getSection = function () {
      return this.buffer.substring(this.sectionStart, this._index);
    };

    Tokenizer.prototype.emitToken = function (name) {
      this.cbs[name](this.getSection());
      this.sectionStart = -1;
    };

    Tokenizer.prototype.emitPartial = function (value) {
      if (this.baseState !== 1
      /* Text */
      ) {
          this.cbs.onattribdata(value); // TODO implement the new event
        } else {
        this.cbs.ontext(value);
      }
    };

    return Tokenizer;
  }();

  exports["default"] = Tokenizer;
});
unwrapExports(Tokenizer_1);

var Parser_1 = createCommonjsModule(function (module, exports) {

  var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Parser = void 0;

  var Tokenizer_1$1 = __importDefault(Tokenizer_1);

  var formTags = new Set(["input", "option", "optgroup", "select", "button", "datalist", "textarea"]);
  var pTag = new Set(["p"]);
  var openImpliesClose = {
    tr: new Set(["tr", "th", "td"]),
    th: new Set(["th"]),
    td: new Set(["thead", "th", "td"]),
    body: new Set(["head", "link", "script"]),
    li: new Set(["li"]),
    p: pTag,
    h1: pTag,
    h2: pTag,
    h3: pTag,
    h4: pTag,
    h5: pTag,
    h6: pTag,
    select: formTags,
    input: formTags,
    output: formTags,
    button: formTags,
    datalist: formTags,
    textarea: formTags,
    option: new Set(["option"]),
    optgroup: new Set(["optgroup", "option"]),
    dd: new Set(["dt", "dd"]),
    dt: new Set(["dt", "dd"]),
    address: pTag,
    article: pTag,
    aside: pTag,
    blockquote: pTag,
    details: pTag,
    div: pTag,
    dl: pTag,
    fieldset: pTag,
    figcaption: pTag,
    figure: pTag,
    footer: pTag,
    form: pTag,
    header: pTag,
    hr: pTag,
    main: pTag,
    nav: pTag,
    ol: pTag,
    pre: pTag,
    section: pTag,
    table: pTag,
    ul: pTag,
    rt: new Set(["rt", "rp"]),
    rp: new Set(["rt", "rp"]),
    tbody: new Set(["thead", "tbody"]),
    tfoot: new Set(["thead", "tbody"])
  };
  var voidElements = new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]);
  var foreignContextElements = new Set(["math", "svg"]);
  var htmlIntegrationElements = new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignObject", "desc", "title"]);
  var reNameEnd = /\s|\//;

  var Parser =
  /** @class */
  function () {
    function Parser(cbs, options) {
      if (options === void 0) {
        options = {};
      }

      var _a, _b, _c, _d, _e;
      /** The start index of the last event. */


      this.startIndex = 0;
      /** The end index of the last event. */

      this.endIndex = null;
      this.tagname = "";
      this.attribname = "";
      this.attribvalue = "";
      this.attribs = null;
      this.stack = [];
      this.foreignContext = [];
      this.options = options;
      this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
      this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
      this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
      this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : Tokenizer_1$1["default"])(this.options, this);
      (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 ? void 0 : _e.call(_d, this);
    }

    Parser.prototype.updatePosition = function (initialOffset) {
      if (this.endIndex === null) {
        if (this.tokenizer.sectionStart <= initialOffset) {
          this.startIndex = 0;
        } else {
          this.startIndex = this.tokenizer.sectionStart - initialOffset;
        }
      } else {
        this.startIndex = this.endIndex + 1;
      }

      this.endIndex = this.tokenizer.getAbsoluteIndex();
    }; // Tokenizer event handlers


    Parser.prototype.ontext = function (data) {
      var _a, _b;

      this.updatePosition(1);
      this.endIndex--;
      (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, data);
    };

    Parser.prototype.onopentagname = function (name) {
      var _a, _b;

      if (this.lowerCaseTagNames) {
        name = name.toLowerCase();
      }

      this.tagname = name;

      if (!this.options.xmlMode && Object.prototype.hasOwnProperty.call(openImpliesClose, name)) {
        var el = void 0;

        while (this.stack.length > 0 && openImpliesClose[name].has(el = this.stack[this.stack.length - 1])) {
          this.onclosetag(el);
        }
      }

      if (this.options.xmlMode || !voidElements.has(name)) {
        this.stack.push(name);

        if (foreignContextElements.has(name)) {
          this.foreignContext.push(true);
        } else if (htmlIntegrationElements.has(name)) {
          this.foreignContext.push(false);
        }
      }

      (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 ? void 0 : _b.call(_a, name);
      if (this.cbs.onopentag) this.attribs = {};
    };

    Parser.prototype.onopentagend = function () {
      var _a, _b;

      this.updatePosition(1);

      if (this.attribs) {
        (_b = (_a = this.cbs).onopentag) === null || _b === void 0 ? void 0 : _b.call(_a, this.tagname, this.attribs);
        this.attribs = null;
      }

      if (!this.options.xmlMode && this.cbs.onclosetag && voidElements.has(this.tagname)) {
        this.cbs.onclosetag(this.tagname);
      }

      this.tagname = "";
    };

    Parser.prototype.onclosetag = function (name) {
      this.updatePosition(1);

      if (this.lowerCaseTagNames) {
        name = name.toLowerCase();
      }

      if (foreignContextElements.has(name) || htmlIntegrationElements.has(name)) {
        this.foreignContext.pop();
      }

      if (this.stack.length && (this.options.xmlMode || !voidElements.has(name))) {
        var pos = this.stack.lastIndexOf(name);

        if (pos !== -1) {
          if (this.cbs.onclosetag) {
            pos = this.stack.length - pos;

            while (pos--) {
              // We know the stack has sufficient elements.
              this.cbs.onclosetag(this.stack.pop());
            }
          } else this.stack.length = pos;
        } else if (name === "p" && !this.options.xmlMode) {
          this.onopentagname(name);
          this.closeCurrentTag();
        }
      } else if (!this.options.xmlMode && (name === "br" || name === "p")) {
        this.onopentagname(name);
        this.closeCurrentTag();
      }
    };

    Parser.prototype.onselfclosingtag = function () {
      if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
        this.closeCurrentTag();
      } else {
        this.onopentagend();
      }
    };

    Parser.prototype.closeCurrentTag = function () {
      var _a, _b;

      var name = this.tagname;
      this.onopentagend();
      /*
       * Self-closing tags will be on the top of the stack
       * (cheaper check than in onclosetag)
       */

      if (this.stack[this.stack.length - 1] === name) {
        (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, name);
        this.stack.pop();
      }
    };

    Parser.prototype.onattribname = function (name) {
      if (this.lowerCaseAttributeNames) {
        name = name.toLowerCase();
      }

      this.attribname = name;
    };

    Parser.prototype.onattribdata = function (value) {
      this.attribvalue += value;
    };

    Parser.prototype.onattribend = function (quote) {
      var _a, _b;

      (_b = (_a = this.cbs).onattribute) === null || _b === void 0 ? void 0 : _b.call(_a, this.attribname, this.attribvalue, quote);

      if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) {
        this.attribs[this.attribname] = this.attribvalue;
      }

      this.attribname = "";
      this.attribvalue = "";
    };

    Parser.prototype.getInstructionName = function (value) {
      var idx = value.search(reNameEnd);
      var name = idx < 0 ? value : value.substr(0, idx);

      if (this.lowerCaseTagNames) {
        name = name.toLowerCase();
      }

      return name;
    };

    Parser.prototype.ondeclaration = function (value) {
      if (this.cbs.onprocessinginstruction) {
        var name_1 = this.getInstructionName(value);
        this.cbs.onprocessinginstruction("!" + name_1, "!" + value);
      }
    };

    Parser.prototype.onprocessinginstruction = function (value) {
      if (this.cbs.onprocessinginstruction) {
        var name_2 = this.getInstructionName(value);
        this.cbs.onprocessinginstruction("?" + name_2, "?" + value);
      }
    };

    Parser.prototype.oncomment = function (value) {
      var _a, _b, _c, _d;

      this.updatePosition(4);
      (_b = (_a = this.cbs).oncomment) === null || _b === void 0 ? void 0 : _b.call(_a, value);
      (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 ? void 0 : _d.call(_c);
    };

    Parser.prototype.oncdata = function (value) {
      var _a, _b, _c, _d, _e, _f;

      this.updatePosition(1);

      if (this.options.xmlMode || this.options.recognizeCDATA) {
        (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 ? void 0 : _b.call(_a);
        (_d = (_c = this.cbs).ontext) === null || _d === void 0 ? void 0 : _d.call(_c, value);
        (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 ? void 0 : _f.call(_e);
      } else {
        this.oncomment("[CDATA[" + value + "]]");
      }
    };

    Parser.prototype.onerror = function (err) {
      var _a, _b;

      (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, err);
    };

    Parser.prototype.onend = function () {
      var _a, _b;

      if (this.cbs.onclosetag) {
        for (var i = this.stack.length; i > 0; this.cbs.onclosetag(this.stack[--i])) {
        }
      }

      (_b = (_a = this.cbs).onend) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */


    Parser.prototype.reset = function () {
      var _a, _b, _c, _d;

      (_b = (_a = this.cbs).onreset) === null || _b === void 0 ? void 0 : _b.call(_a);
      this.tokenizer.reset();
      this.tagname = "";
      this.attribname = "";
      this.attribs = null;
      this.stack = [];
      (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 ? void 0 : _d.call(_c, this);
    };
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */


    Parser.prototype.parseComplete = function (data) {
      this.reset();
      this.end(data);
    };
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */


    Parser.prototype.write = function (chunk) {
      this.tokenizer.write(chunk);
    };
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */


    Parser.prototype.end = function (chunk) {
      this.tokenizer.end(chunk);
    };
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */


    Parser.prototype.pause = function () {
      this.tokenizer.pause();
    };
    /**
     * Resumes parsing after `pause` was called.
     */


    Parser.prototype.resume = function () {
      this.tokenizer.resume();
    };
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */


    Parser.prototype.parseChunk = function (chunk) {
      this.write(chunk);
    };
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */


    Parser.prototype.done = function (chunk) {
      this.end(chunk);
    };

    return Parser;
  }();

  exports.Parser = Parser;
});
unwrapExports(Parser_1);
Parser_1.Parser;

var node = createCommonjsModule(function (module, exports) {

  var __extends = commonjsGlobal && commonjsGlobal.__extends || function () {
    var _extendStatics = function extendStatics(d, b) {
      _extendStatics = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) {
          if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        }
      };

      return _extendStatics(d, b);
    };

    return function (d, b) {
      _extendStatics(d, b);

      function __() {
        this.constructor = d;
      }

      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();

  var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return __assign.apply(this, arguments);
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.cloneNode = exports.Element = exports.Document = exports.NodeWithChildren = exports.ProcessingInstruction = exports.Comment = exports.Text = exports.DataNode = exports.Node = void 0;
  var nodeTypes = new Map([["tag"
  /* Tag */
  , 1], ["script"
  /* Script */
  , 1], ["style"
  /* Style */
  , 1], ["directive"
  /* Directive */
  , 1], ["text"
  /* Text */
  , 3], ["cdata"
  /* CDATA */
  , 4], ["comment"
  /* Comment */
  , 8], ["root"
  /* Root */
  , 9]]);
  /**
   * This object will be used as the prototype for Nodes when creating a
   * DOM-Level-1-compliant structure.
   */

  var Node =
  /** @class */
  function () {
    /**
     *
     * @param type The type of the node.
     */
    function Node(type) {
      this.type = type;
      /** Parent of the node */

      this.parent = null;
      /** Previous sibling */

      this.prev = null;
      /** Next sibling */

      this.next = null;
      /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */

      this.startIndex = null;
      /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */

      this.endIndex = null;
    }

    Object.defineProperty(Node.prototype, "nodeType", {
      // Read-only aliases
      get: function get() {
        var _a;

        return (_a = nodeTypes.get(this.type)) !== null && _a !== void 0 ? _a : 1;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Node.prototype, "parentNode", {
      // Read-write aliases for properties
      get: function get() {
        return this.parent;
      },
      set: function set(parent) {
        this.parent = parent;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
      get: function get() {
        return this.prev;
      },
      set: function set(prev) {
        this.prev = prev;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
      get: function get() {
        return this.next;
      },
      set: function set(next) {
        this.next = next;
      },
      enumerable: false,
      configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */

    Node.prototype.cloneNode = function (recursive) {
      if (recursive === void 0) {
        recursive = false;
      }

      return cloneNode(this, recursive);
    };

    return Node;
  }();

  exports.Node = Node;

  var DataNode =
  /** @class */
  function (_super) {
    __extends(DataNode, _super);
    /**
     * @param type The type of the node
     * @param data The content of the data node
     */


    function DataNode(type, data) {
      var _this = _super.call(this, type) || this;

      _this.data = data;
      return _this;
    }

    Object.defineProperty(DataNode.prototype, "nodeValue", {
      get: function get() {
        return this.data;
      },
      set: function set(data) {
        this.data = data;
      },
      enumerable: false,
      configurable: true
    });
    return DataNode;
  }(Node);

  exports.DataNode = DataNode;

  var Text =
  /** @class */
  function (_super) {
    __extends(Text, _super);

    function Text(data) {
      return _super.call(this, "text"
      /* Text */
      , data) || this;
    }

    return Text;
  }(DataNode);

  exports.Text = Text;

  var Comment =
  /** @class */
  function (_super) {
    __extends(Comment, _super);

    function Comment(data) {
      return _super.call(this, "comment"
      /* Comment */
      , data) || this;
    }

    return Comment;
  }(DataNode);

  exports.Comment = Comment;

  var ProcessingInstruction =
  /** @class */
  function (_super) {
    __extends(ProcessingInstruction, _super);

    function ProcessingInstruction(name, data) {
      var _this = _super.call(this, "directive"
      /* Directive */
      , data) || this;

      _this.name = name;
      return _this;
    }

    return ProcessingInstruction;
  }(DataNode);

  exports.ProcessingInstruction = ProcessingInstruction;
  /**
   * A `Node` that can have children.
   */

  var NodeWithChildren =
  /** @class */
  function (_super) {
    __extends(NodeWithChildren, _super);
    /**
     * @param type Type of the node.
     * @param children Children of the node. Only certain node types can have children.
     */


    function NodeWithChildren(type, children) {
      var _this = _super.call(this, type) || this;

      _this.children = children;
      return _this;
    }

    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
      // Aliases
      get: function get() {
        var _a;

        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
      get: function get() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
      get: function get() {
        return this.children;
      },
      set: function set(children) {
        this.children = children;
      },
      enumerable: false,
      configurable: true
    });
    return NodeWithChildren;
  }(Node);

  exports.NodeWithChildren = NodeWithChildren;

  var Document =
  /** @class */
  function (_super) {
    __extends(Document, _super);

    function Document(children) {
      return _super.call(this, "root"
      /* Root */
      , children) || this;
    }

    return Document;
  }(NodeWithChildren);

  exports.Document = Document;

  var Element =
  /** @class */
  function (_super) {
    __extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */


    function Element(name, attribs, children) {
      if (children === void 0) {
        children = [];
      }

      var _this = _super.call(this, name === "script" ? "script"
      /* Script */
      : name === "style" ? "style"
      /* Style */
      : "tag"
      /* Tag */
      , children) || this;

      _this.name = name;
      _this.attribs = attribs;
      _this.attribs = attribs;
      return _this;
    }

    Object.defineProperty(Element.prototype, "tagName", {
      // DOM Level 1 aliases
      get: function get() {
        return this.name;
      },
      set: function set(name) {
        this.name = name;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
      get: function get() {
        var _this = this;

        return Object.keys(this.attribs).map(function (name) {
          var _a, _b;

          return {
            name: name,
            value: _this.attribs[name],
            namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
            prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
          };
        });
      },
      enumerable: false,
      configurable: true
    });
    return Element;
  }(NodeWithChildren);

  exports.Element = Element;
  /**
   * Clone a node, and optionally its children.
   *
   * @param recursive Clone child nodes as well.
   * @returns A clone of the node.
   */

  function cloneNode(node, recursive) {
    if (recursive === void 0) {
      recursive = false;
    }

    var result;

    switch (node.type) {
      case "text"
      /* Text */
      :
        result = new Text(node.data);
        break;

      case "directive"
      /* Directive */
      :
        {
          var instr = node;
          result = new ProcessingInstruction(instr.name, instr.data);

          if (instr["x-name"] != null) {
            result["x-name"] = instr["x-name"];
            result["x-publicId"] = instr["x-publicId"];
            result["x-systemId"] = instr["x-systemId"];
          }

          break;
        }

      case "comment"
      /* Comment */
      :
        result = new Comment(node.data);
        break;

      case "tag"
      /* Tag */
      :
      case "script"
      /* Script */
      :
      case "style"
      /* Style */
      :
        {
          var elem = node;
          var children = recursive ? cloneChildren(elem.children) : [];
          var clone_1 = new Element(elem.name, __assign({}, elem.attribs), children);
          children.forEach(function (child) {
            return child.parent = clone_1;
          });

          if (elem["x-attribsNamespace"]) {
            clone_1["x-attribsNamespace"] = __assign({}, elem["x-attribsNamespace"]);
          }

          if (elem["x-attribsPrefix"]) {
            clone_1["x-attribsPrefix"] = __assign({}, elem["x-attribsPrefix"]);
          }

          result = clone_1;
          break;
        }

      case "cdata"
      /* CDATA */
      :
        {
          var cdata = node;
          var children = recursive ? cloneChildren(cdata.children) : [];
          var clone_2 = new NodeWithChildren(node.type, children);
          children.forEach(function (child) {
            return child.parent = clone_2;
          });
          result = clone_2;
          break;
        }

      case "root"
      /* Root */
      :
        {
          var doc = node;
          var children = recursive ? cloneChildren(doc.children) : [];
          var clone_3 = new Document(children);
          children.forEach(function (child) {
            return child.parent = clone_3;
          });

          if (doc["x-mode"]) {
            clone_3["x-mode"] = doc["x-mode"];
          }

          result = clone_3;
          break;
        }

      case "doctype"
      /* Doctype */
      :
        {
          // This type isn't used yet.
          throw new Error("Not implemented yet: ElementType.Doctype case");
        }
    }

    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    return result;
  }

  exports.cloneNode = cloneNode;

  function cloneChildren(childs) {
    var children = childs.map(function (child) {
      return cloneNode(child, true);
    });

    for (var i = 1; i < children.length; i++) {
      children[i].prev = children[i - 1];
      children[i - 1].next = children[i];
    }

    return children;
  }
});
unwrapExports(node);
node.cloneNode;
node.Element;
node.Document;
node.NodeWithChildren;
node.ProcessingInstruction;
node.Comment;
node.Text;
node.DataNode;
node.Node;

var lib = createCommonjsModule(function (module, exports) {

  var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    });
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });

  var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function (m, exports) {
    for (var p in m) {
      if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
    }
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.DomHandler = void 0;

  __exportStar(node, exports);

  var reWhitespace = /\s+/g; // Default options

  var defaultOpts = {
    normalizeWhitespace: false,
    withStartIndices: false,
    withEndIndices: false
  };

  var DomHandler =
  /** @class */
  function () {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */
    function DomHandler(callback, options, elementCB) {
      /** The elements of the DOM */
      this.dom = [];
      /** The root element for the DOM */

      this.root = new node.Document(this.dom);
      /** Indicated whether parsing has been completed. */

      this.done = false;
      /** Stack of open tags. */

      this.tagStack = [this.root];
      /** A data node that is still being written to. */

      this.lastNode = null;
      /** Reference to the parser instance. Used for location information. */

      this.parser = null; // Make it possible to skip arguments, for backwards-compatibility

      if (typeof options === "function") {
        elementCB = options;
        options = defaultOpts;
      }

      if (typeof callback === "object") {
        options = callback;
        callback = undefined;
      }

      this.callback = callback !== null && callback !== void 0 ? callback : null;
      this.options = options !== null && options !== void 0 ? options : defaultOpts;
      this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }

    DomHandler.prototype.onparserinit = function (parser) {
      this.parser = parser;
    }; // Resets the handler back to starting state


    DomHandler.prototype.onreset = function () {
      var _a;

      this.dom = [];
      this.root = new node.Document(this.dom);
      this.done = false;
      this.tagStack = [this.root];
      this.lastNode = null;
      this.parser = (_a = this.parser) !== null && _a !== void 0 ? _a : null;
    }; // Signals the handler that parsing is done


    DomHandler.prototype.onend = function () {
      if (this.done) return;
      this.done = true;
      this.parser = null;
      this.handleCallback(null);
    };

    DomHandler.prototype.onerror = function (error) {
      this.handleCallback(error);
    };

    DomHandler.prototype.onclosetag = function () {
      this.lastNode = null;
      var elem = this.tagStack.pop();

      if (this.options.withEndIndices) {
        elem.endIndex = this.parser.endIndex;
      }

      if (this.elementCB) this.elementCB(elem);
    };

    DomHandler.prototype.onopentag = function (name, attribs) {
      var element = new node.Element(name, attribs);
      this.addNode(element);
      this.tagStack.push(element);
    };

    DomHandler.prototype.ontext = function (data) {
      var normalizeWhitespace = this.options.normalizeWhitespace;
      var lastNode = this.lastNode;

      if (lastNode && lastNode.type === "text"
      /* Text */
      ) {
          if (normalizeWhitespace) {
            lastNode.data = (lastNode.data + data).replace(reWhitespace, " ");
          } else {
            lastNode.data += data;
          }
        } else {
        if (normalizeWhitespace) {
          data = data.replace(reWhitespace, " ");
        }

        var node$1 = new node.Text(data);
        this.addNode(node$1);
        this.lastNode = node$1;
      }
    };

    DomHandler.prototype.oncomment = function (data) {
      if (this.lastNode && this.lastNode.type === "comment"
      /* Comment */
      ) {
          this.lastNode.data += data;
          return;
        }

      var node$1 = new node.Comment(data);
      this.addNode(node$1);
      this.lastNode = node$1;
    };

    DomHandler.prototype.oncommentend = function () {
      this.lastNode = null;
    };

    DomHandler.prototype.oncdatastart = function () {
      var text = new node.Text("");
      var node$1 = new node.NodeWithChildren("cdata"
      /* CDATA */
      , [text]);
      this.addNode(node$1);
      text.parent = node$1;
      this.lastNode = text;
    };

    DomHandler.prototype.oncdataend = function () {
      this.lastNode = null;
    };

    DomHandler.prototype.onprocessinginstruction = function (name, data) {
      var node$1 = new node.ProcessingInstruction(name, data);
      this.addNode(node$1);
    };

    DomHandler.prototype.handleCallback = function (error) {
      if (typeof this.callback === "function") {
        this.callback(error, this.dom);
      } else if (error) {
        throw error;
      }
    };

    DomHandler.prototype.addNode = function (node) {
      var parent = this.tagStack[this.tagStack.length - 1];
      var previousSibling = parent.children[parent.children.length - 1];

      if (this.options.withStartIndices) {
        node.startIndex = this.parser.startIndex;
      }

      if (this.options.withEndIndices) {
        node.endIndex = this.parser.endIndex;
      }

      parent.children.push(node);

      if (previousSibling) {
        node.prev = previousSibling;
        previousSibling.next = node;
      }

      node.parent = parent;
      this.lastNode = null;
    };

    DomHandler.prototype.addDataNode = function (node) {
      this.addNode(node);
      this.lastNode = node;
    };

    return DomHandler;
  }();

  exports.DomHandler = DomHandler;
  exports["default"] = DomHandler;
});
unwrapExports(lib);
lib.DomHandler;

/**
 * Sets root parent to null.
 *
 * @param  {Array<Comment|Element|ProcessingInstruction|Text>} nodes
 * @return {Array<Comment|Element|ProcessingInstruction|Text>}
 */
function unsetRootParent$1(nodes) {
  for (var index = 0, len = nodes.length; index < len; index++) {
    var node = nodes[index];
    node.parent = null;
  }

  return nodes;
}

var utilities = {
  unsetRootParent: unsetRootParent$1
};

var Parser = Parser_1.Parser;
var DomHandler = lib.DomHandler;
var unsetRootParent = utilities.unsetRootParent;
/**
 * Parses HTML string to DOM nodes in Node.js.
 *
 * This is the same method as `require('htmlparser2').parseDOM`
 * https://github.com/fb55/htmlparser2/blob/v6.0.0/src/index.ts#L29-L41
 *
 * @param  {string}            html      - HTML markup.
 * @param  {DomHandlerOptions} [options] - Parser options (https://github.com/fb55/domhandler/tree/v4.0.0#readme).
 * @return {Array<Comment|Element|ProcessingInstruction|Text>} - DOM nodes.
 */

function HTMLDOMParser(html, options) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string.');
  }

  if (html === '') {
    return [];
  }

  var handler = new DomHandler(undefined, options);
  new Parser(handler, options).end(html);
  return unsetRootParent(handler.dom);
}

var htmlToDom = HTMLDOMParser;

/**
 * When running on Node.js, use the server parser.
 * When bundling for the browser, use the client parser.
 *
 * @see {@link https://github.com/substack/node-browserify#browser-field}
 */

var htmlDomParser = htmlToDom;

var domParserOptions = {
  lowerCaseAttributeNames: false
};
/**
 * Converts HTML string to React elements.
 *
 * @param  {String}   html                    - HTML string.
 * @param  {Object}   [options]               - Parser options.
 * @param  {Object}   [options.htmlparser2]   - htmlparser2 options.
 * @param  {Object}   [options.library]       - Library for React, Preact, etc.
 * @param  {Function} [options.replace]       - Replace method.
 * @return {JSX.Element|JSX.Element[]|String} - React element(s), empty array, or string.
 */

function HTMLReactParser(html, options) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (html === '') {
    return [];
  }

  options = options || {};
  return domToReact_1(htmlDomParser(html, options.htmlparser2 || domParserOptions), options);
}

HTMLReactParser.domToReact = domToReact_1;
HTMLReactParser.htmlToDOM = htmlDomParser;
HTMLReactParser.attributesToProps = attributesToProps_1; // support CommonJS and ES Modules

var htmlReactParser = HTMLReactParser;
var default_1 = HTMLReactParser;
htmlReactParser["default"] = default_1;

var domToReact = htmlReactParser.domToReact;
var attributesToProps = htmlReactParser.attributesToProps;

var HtmlParser = function HtmlParser(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/jsx(Fragment$1, {
    children: htmlReactParser(children, {
      replace: function replace(domNode) {
        if (domNode.name === 'a' && typeof domNode.attribs.onclick === 'string') {
          return /*#__PURE__*/jsx("a", _extends$2({}, attributesToProps(domNode.attribs), {
            onClick: function onClick() {
              return eval(domNode.attribs.onclick);
            },
            children: domToReact(domNode.children)
          }));
        }
      }
    })
  });
};

var _StyledPath = styled("path").withConfig({
  displayName: "IsotypeColor___StyledPath",
  componentId: "h480fj-0"
})(["fill:url(#Degradado1-loader-panel);"]);

var _StyledPath2 = styled("path").withConfig({
  displayName: "IsotypeColor___StyledPath2",
  componentId: "h480fj-1"
})(["fill:url(#Degradado2-loader-panel);"]);

var _StyledPath3 = styled("path").withConfig({
  displayName: "IsotypeColor___StyledPath3",
  componentId: "h480fj-2"
})(["fill:url(#Degradado3-loader-panel);"]);

var _StyledPath4 = styled("path").withConfig({
  displayName: "IsotypeColor___StyledPath4",
  componentId: "h480fj-3"
})(["fill:url(#Degradado4-loader-panel);"]);

var _StyledPath5 = styled("path").withConfig({
  displayName: "IsotypeColor___StyledPath5",
  componentId: "h480fj-4"
})(["fill:url(#Degradado5-loader-panel);"]);

var _StyledPath6 = styled("path").withConfig({
  displayName: "IsotypeColor___StyledPath6",
  componentId: "h480fj-5"
})(["fill:url(#Degradado6-loader-panel);"]);

var IsotypeColor = function IsotypeColor(props) {
  return /*#__PURE__*/jsxs("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238.18 238.18"
  }, props, {
    children: [/*#__PURE__*/jsxs("linearGradient", {
      id: "Degradado1-loader-panel",
      x1: "114.9",
      y1: "47.92",
      x2: "179.64",
      y2: "85.29",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/jsx("stop", {
        offset: "0",
        stopColor: "#f3b444"
      }), /*#__PURE__*/jsx("stop", {
        offset: "1",
        stopColor: "#f15480"
      })]
    }), /*#__PURE__*/jsxs("linearGradient", {
      id: "Degradado2-loader-panel",
      x1: "178.63",
      y1: "156.46",
      x2: "178.63",
      y2: "84.94",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/jsx("stop", {
        offset: "0",
        stopColor: "#b157ce"
      }), /*#__PURE__*/jsx("stop", {
        offset: "1",
        stopColor: "#f15480"
      })]
    }), /*#__PURE__*/jsxs("linearGradient", {
      id: "Degradado3-loader-panel",
      x1: "116.42",
      y1: "189.38",
      x2: "180.26",
      y2: "152.53",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/jsx("stop", {
        offset: "0",
        stopColor: "#5da5fb"
      }), /*#__PURE__*/jsx("stop", {
        offset: "1",
        stopColor: "#b157ce"
      })]
    }), /*#__PURE__*/jsxs("linearGradient", {
      id: "Degradado4-loader-panel",
      x1: "56.89",
      y1: "151.94",
      x2: "119.21",
      y2: "187.91",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/jsx("stop", {
        offset: "0",
        stopColor: "#74e6a7"
      }), /*#__PURE__*/jsx("stop", {
        offset: "1",
        stopColor: "#5da5fb"
      })]
    }), /*#__PURE__*/jsxs("linearGradient", {
      id: "Degradado5-loader-panel",
      x1: "59.54",
      y1: "82.17",
      x2: "59.54",
      y2: "153.75",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/jsx("stop", {
        offset: "0",
        stopColor: "#c8ed5c"
      }), /*#__PURE__*/jsx("stop", {
        offset: "1",
        stopColor: "#74e6a7"
      })]
    }), /*#__PURE__*/jsxs("linearGradient", {
      id: "Degradado6-loader-panel",
      x1: "60.24",
      y1: "84.31",
      x2: "120.04",
      y2: "49.79",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/jsx("stop", {
        offset: "0",
        stopColor: "#c8ed5c"
      }), /*#__PURE__*/jsx("stop", {
        offset: "1",
        stopColor: "#f3b444"
      })]
    }), /*#__PURE__*/jsx(_StyledPath, {
      d: "M223.22,61.37A119,119,0,0,0,119.09,0V119.09Z"
    }), /*#__PURE__*/jsx(_StyledPath2, {
      d: "M221.14,180.41a119,119,0,0,0,1.08-120.87L119.09,119.09Z"
    }), /*#__PURE__*/jsx(_StyledPath3, {
      d: "M117,238.13a119,119,0,0,0,105.21-59.5L119.09,119.09Z"
    }), /*#__PURE__*/jsx(_StyledPath4, {
      d: "M15,176.81a119,119,0,0,0,104.14,61.37V119.09Z"
    }), /*#__PURE__*/jsx(_StyledPath5, {
      d: "M17,57.77A119,119,0,0,0,16,178.63l103.14-59.54Z"
    }), /*#__PURE__*/jsx(_StyledPath6, {
      d: "M121.17.05A119,119,0,0,0,16,59.54l103.14,59.55Z"
    }), /*#__PURE__*/jsx("circle", {
      fill: theme.colors.black,
      cx: "119.09",
      cy: "119.09",
      r: "94.02"
    }), /*#__PURE__*/jsx("path", {
      fill: theme.colors.white,
      d: "M179.3,117.68A11.64,11.64,0,0,0,167.86,127a47.49,47.49,0,1,1-30.94-54.21A11.34,11.34,0,0,0,150.53,68l.5-.85a11.25,11.25,0,0,0-6-16.29,70.87,70.87,0,1,0,45.79,80.59A11.65,11.65,0,0,0,179.3,117.68Z"
    }), /*#__PURE__*/jsx("path", {
      fill: theme.colors.white,
      d: "M138.42,110.61a15.25,15.25,0,1,0,15.24,15.25A15.25,15.25,0,0,0,138.42,110.61Z"
    })]
  }));
};

var IsotypeGrey = function IsotypeGrey() {
  return /*#__PURE__*/jsx("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.38419 7.7813C2.26319 11.0843 4.90419 13.7983 8.17919 13.7983C10.9952 13.7983 13.3422 11.7913 13.8672 9.1293C13.9832 8.5433 13.5232 8.00031 12.9272 8.00031C12.4722 8.00031 12.0792 8.3193 11.9902 8.7653C11.6352 10.5443 10.0632 11.8863 8.17919 11.8863C5.95119 11.8863 4.16119 10.0113 4.30019 7.7543C4.42319 5.7653 6.07719 4.1703 8.06919 4.1153C8.55719 4.1013 9.02519 4.1783 9.45919 4.3303C9.88019 4.4773 10.3462 4.3213 10.5722 3.9373L10.6132 3.8683C10.9072 3.3683 10.6672 2.7303 10.1202 2.5353C9.45219 2.2973 8.72719 2.1783 7.97219 2.2053C4.95619 2.3103 2.49519 4.7663 2.38419 7.7813ZM9.58117 9.91726C10.2702 9.91726 10.8292 9.35826 10.8292 8.66926C10.8292 7.98026 10.2702 7.42126 9.58117 7.42126C8.89217 7.42126 8.33417 7.98026 8.33417 8.66926C8.33417 9.35826 8.89217 9.91726 9.58117 9.91726ZM8.00018 0.000244141C3.58118 0.000244141 0.000183105 3.58224 0.000183105 8.00024C0.000183105 12.4182 3.58118 16.0002 8.00018 16.0002C12.4182 16.0002 16.0002 12.4182 16.0002 8.00024C16.0002 3.58224 12.4182 0.000244141 8.00018 0.000244141Z",
      fill: "#696B74"
    })
  });
};

var IsotypeWhite = function IsotypeWhite() {
  return /*#__PURE__*/jsx("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.99988 14.5479C9.74888 14.5479 11.3939 13.8659 12.6299 12.6299C13.8659 11.3939 14.5479 9.74888 14.5479 7.99988C14.5479 6.25088 13.8659 4.60688 12.6299 3.36988C11.3939 2.13288 9.74888 1.45288 7.99988 1.45288C6.25088 1.45288 4.60688 2.13288 3.36988 3.36988C2.13288 4.60688 1.45288 6.25088 1.45288 7.99988C1.45288 9.74888 2.13288 11.3939 3.36988 12.6299C4.60688 13.8659 6.25088 14.5479 7.99988 14.5479ZM2.34288 2.34288C5.46688 -0.781122 10.5319 -0.781122 13.6569 2.34288C16.7809 5.46688 16.7809 10.5319 13.6569 13.6569C10.5319 16.7809 5.46688 16.7809 2.34288 13.6569C-0.781122 10.5319 -0.781122 5.46688 2.34288 2.34288ZM11.9814 8.00003C11.6144 8.00003 11.2964 8.25803 11.2244 8.61803C10.9374 10.057 9.66837 11.141 8.14437 11.141C6.34437 11.141 4.89837 9.62603 5.01037 7.80103C5.10837 6.19403 6.44637 4.90503 8.05537 4.86003C8.45037 4.85003 8.82837 4.91203 9.17837 5.03403C9.51837 5.15303 9.89537 5.02703 10.0784 4.71703L10.1114 4.66103C10.3494 4.25703 10.1554 3.74103 9.71337 3.58403C9.17337 3.39203 8.58837 3.29503 7.97737 3.31703C5.54037 3.40203 3.55137 5.38703 3.46137 7.82403C3.36337 10.492 5.49837 12.687 8.14437 12.687C10.4194 12.687 12.3174 11.063 12.7424 8.91303C12.8354 8.43903 12.4634 8.00003 11.9814 8.00003ZM9.27829 7.53271C8.72129 7.53271 8.26929 7.98471 8.26929 8.54071C8.26929 9.09772 8.72129 9.54871 9.27829 9.54871C9.83529 9.54871 10.2863 9.09772 10.2863 8.54071C10.2863 7.98471 9.83529 7.53271 9.27829 7.53271Z",
      fill: "white"
    })
  });
};

var isotypes = {
  color: IsotypeColor,
  grey: IsotypeGrey,
  white: IsotypeWhite
};

var _excluded$u = ["name"];
var Isotype = function Isotype(_ref) {
  var name = _ref.name,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$u);

  var IsotypeToRender = isotypes[name];
  return /*#__PURE__*/jsx(IsotypeToRender, _extends$2({}, rest));
};

var _excluded$t = ["children"];

var _StyledFlex$t = styled(Flex).withConfig({
  displayName: "ErrorBox___StyledFlex",
  componentId: "wwovo-0"
})(["background:", ";padding:", " ", ";border-radius:", ";text-align:center;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

var ErrorBox = function ErrorBox(_ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$t);

  return /*#__PURE__*/jsx(_StyledFlex$t, _extends$2({
    justifyContent: {
      mobile: 'center'
    },
    alignItems: {
      mobile: 'center'
    }
  }, rest, {
    _css: theme.colors.black50,
    _css2: rem(6),
    _css3: rem(16),
    _css4: rem('4px'),
    children: children
  }));
};

var reactResponsive = createCommonjsModule(function (module, exports) {
  !function (root, factory) {
    module.exports = factory(React) ;
  }("undefined" != typeof self ? self : commonjsGlobal, function (__WEBPACK_EXTERNAL_MODULE_1__) {
    return function (modules) {
      function __webpack_require__(moduleId) {
        if (installedModules[moduleId]) return installedModules[moduleId].exports;
        var module = installedModules[moduleId] = {
          i: moduleId,
          l: !1,
          exports: {}
        };
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
      }

      var installedModules = {};
      return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function (exports, name, getter) {
        __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
          configurable: !1,
          enumerable: !0,
          get: getter
        });
      }, __webpack_require__.n = function (module) {
        var getter = module && module.__esModule ? function () {
          return module["default"];
        } : function () {
          return module;
        };
        return __webpack_require__.d(getter, "a", getter), getter;
      }, __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 7);
    }([function (module, __webpack_exports__, __webpack_require__) {

      function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
      }

      function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      function _unsupportedIterableToArray(o, minLen) {
        if (o) {
          if ("string" == typeof o) return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          return "Object" === n && o.constructor && (n = o.constructor.name), "Map" === n || "Set" === n ? Array.from(o) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray(o, minLen) : void 0;
        }
      }

      function _arrayLikeToArray(arr, len) {
        (null == len || len > arr.length) && (len = arr.length);

        for (var i = 0, arr2 = new Array(len); i < len; i++) {
          arr2[i] = arr[i];
        }

        return arr2;
      }

      function _iterableToArrayLimit(arr, i) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(arr)) {
          var _arr = [],
              _n = !0,
              _d = !1,
              _e = void 0;

          try {
            for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !i || _arr.length !== i); _n = !0) {
              ;
            }
          } catch (err) {
            _d = !0, _e = err;
          } finally {
            try {
              _n || null == _i["return"] || _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }

          return _arr;
        }
      }

      function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
      }

      var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1),
          __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__),
          __WEBPACK_IMPORTED_MODULE_1_matchmediaquery__ = __webpack_require__(8),
          __WEBPACK_IMPORTED_MODULE_1_matchmediaquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_matchmediaquery__),
          __WEBPACK_IMPORTED_MODULE_2_hyphenate_style_name__ = __webpack_require__(2),
          __WEBPACK_IMPORTED_MODULE_3_shallow_equal_objects__ = __webpack_require__(10),
          __WEBPACK_IMPORTED_MODULE_3_shallow_equal_objects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shallow_equal_objects__),
          __WEBPACK_IMPORTED_MODULE_4__toQuery__ = __webpack_require__(3),
          __WEBPACK_IMPORTED_MODULE_5__Context__ = __webpack_require__(6),
          makeQuery = function makeQuery(settings) {
        return settings.query || Object(__WEBPACK_IMPORTED_MODULE_4__toQuery__.a)(settings);
      },
          hyphenateKeys = function hyphenateKeys(obj) {
        if (!obj) return null;
        var keys = Object.keys(obj);
        return 0 === keys.length ? null : keys.reduce(function (result, key) {
          return result[Object(__WEBPACK_IMPORTED_MODULE_2_hyphenate_style_name__.a)(key)] = obj[key], result;
        }, {});
      },
          useIsUpdate = function useIsUpdate() {
        var ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(!1);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
          ref.current = !0;
        }, []), ref.current;
      },
          useDevice = function useDevice(deviceFromProps) {
        var deviceFromContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_5__Context__.a),
            getDevice = function getDevice() {
          return hyphenateKeys(deviceFromProps) || hyphenateKeys(deviceFromContext);
        },
            _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(getDevice),
            _React$useState2 = _slicedToArray(_React$useState, 2),
            device = _React$useState2[0],
            setDevice = _React$useState2[1];

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
          var newDevice = getDevice();
          __WEBPACK_IMPORTED_MODULE_3_shallow_equal_objects___default()(device, newDevice) || setDevice(newDevice);
        }, [deviceFromProps, deviceFromContext]), device;
      },
          useQuery = function useQuery(settings) {
        var getQuery = function getQuery() {
          return makeQuery(settings);
        },
            _React$useState3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(getQuery),
            _React$useState4 = _slicedToArray(_React$useState3, 2),
            query = _React$useState4[0],
            setQuery = _React$useState4[1];

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
          var newQuery = getQuery();
          query !== newQuery && setQuery(newQuery);
        }, [settings]), query;
      },
          useMatchMedia = function useMatchMedia(query, device) {
        var getMatchMedia = function getMatchMedia() {
          return __WEBPACK_IMPORTED_MODULE_1_matchmediaquery___default()(query, device || {}, !!device);
        },
            _React$useState5 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(getMatchMedia),
            _React$useState6 = _slicedToArray(_React$useState5, 2),
            mq = _React$useState6[0],
            setMq = _React$useState6[1],
            isUpdate = useIsUpdate();

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
          return isUpdate && setMq(getMatchMedia()), function () {
            mq.dispose();
          };
        }, [query, device]), mq;
      },
          useMatches = function useMatches(mediaQuery) {
        var _React$useState7 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(mediaQuery.matches),
            _React$useState8 = _slicedToArray(_React$useState7, 2),
            matches = _React$useState8[0],
            setMatches = _React$useState8[1];

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
          var updateMatches = function updateMatches() {
            setMatches(mediaQuery.matches);
          };

          return mediaQuery.addListener(updateMatches), updateMatches(), function () {
            mediaQuery.removeListener(updateMatches);
          };
        }, [mediaQuery]), matches;
      },
          useMediaQuery = function useMediaQuery(settings, device, onChange) {
        var deviceSettings = useDevice(device),
            query = useQuery(settings);
        if (!query) throw new Error("Invalid or missing MediaQuery!");
        var mq = useMatchMedia(query, deviceSettings),
            matches = useMatches(mq),
            isUpdate = useIsUpdate();
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
          isUpdate && onChange && onChange(matches);
        }, [matches]), matches;
      };

      __webpack_exports__.a = useMediaQuery;
    }, function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
    }, function (module, __webpack_exports__, __webpack_require__) {

      function toHyphenLower(match) {
        return "-" + match.toLowerCase();
      }

      function hyphenateStyleName(name) {
        if (cache.hasOwnProperty(name)) return cache[name];
        var hName = name.replace(uppercasePattern, toHyphenLower);
        return cache[name] = msPattern.test(hName) ? "-" + hName : hName;
      }

      var uppercasePattern = /[A-Z]/g,
          msPattern = /^ms-/,
          cache = {};
      __webpack_exports__.a = hyphenateStyleName;
    }, function (module, __webpack_exports__, __webpack_require__) {

      var __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__ = __webpack_require__(2),
          __WEBPACK_IMPORTED_MODULE_1__mediaQuery__ = __webpack_require__(11),
          negate = function negate(cond) {
        return "not ".concat(cond);
      },
          keyVal = function keyVal(k, v) {
        var realKey = Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__.a)(k);
        return "number" == typeof v && (v = "".concat(v, "px")), !0 === v ? realKey : !1 === v ? negate(realKey) : "(".concat(realKey, ": ").concat(v, ")");
      },
          join = function join(conds) {
        return conds.join(" and ");
      },
          toQuery = function toQuery(obj) {
        var rules = [];
        return Object.keys(__WEBPACK_IMPORTED_MODULE_1__mediaQuery__.a.all).forEach(function (k) {
          var v = obj[k];
          null != v && rules.push(keyVal(k, v));
        }), join(rules);
      };

      __webpack_exports__.a = toQuery;
    }, function (module, exports, __webpack_require__) {

      module.exports = __webpack_require__(13);
    }, function (module, exports, __webpack_require__) {

      module.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    }, function (module, __webpack_exports__, __webpack_require__) {

      var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1),
          __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__),
          Context = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();

      __webpack_exports__.a = Context;
    }, function (module, __webpack_exports__, __webpack_require__) {

      Object.defineProperty(__webpack_exports__, "__esModule", {
        value: !0
      });

      var __WEBPACK_IMPORTED_MODULE_0__useMediaQuery__ = __webpack_require__(0),
          __WEBPACK_IMPORTED_MODULE_1__Component__ = __webpack_require__(17),
          __WEBPACK_IMPORTED_MODULE_2__toQuery__ = __webpack_require__(3),
          __WEBPACK_IMPORTED_MODULE_3__Context__ = __webpack_require__(6);

      __webpack_require__.d(__webpack_exports__, "default", function () {
        return __WEBPACK_IMPORTED_MODULE_1__Component__.a;
      }), __webpack_require__.d(__webpack_exports__, "useMediaQuery", function () {
        return __WEBPACK_IMPORTED_MODULE_0__useMediaQuery__.a;
      }), __webpack_require__.d(__webpack_exports__, "toQuery", function () {
        return __WEBPACK_IMPORTED_MODULE_2__toQuery__.a;
      }), __webpack_require__.d(__webpack_exports__, "Context", function () {
        return __WEBPACK_IMPORTED_MODULE_3__Context__.a;
      });
    }, function (module, exports, __webpack_require__) {

      function Mql(query, values, forceStatic) {
        function addListener(listener) {
          mql && mql.addListener(listener);
        }

        function removeListener(listener) {
          mql && mql.removeListener(listener);
        }

        function update(evt) {
          self.matches = evt.matches, self.media = evt.media;
        }

        function dispose() {
          mql && mql.removeListener(update);
        }

        var self = this;

        if (dynamicMatch && !forceStatic) {
          var mql = dynamicMatch.call(window, query);
          this.matches = mql.matches, this.media = mql.media, mql.addListener(update);
        } else this.matches = staticMatch(query, values), this.media = query;

        this.addListener = addListener, this.removeListener = removeListener, this.dispose = dispose;
      }

      function matchMedia(query, values, forceStatic) {
        return new Mql(query, values, forceStatic);
      }

      var staticMatch = __webpack_require__(9).match,
          dynamicMatch = "undefined" != typeof window ? window.matchMedia : null;

      module.exports = matchMedia;
    }, function (module, exports, __webpack_require__) {

      function matchQuery(mediaQuery, values) {
        return parseQuery(mediaQuery).some(function (query) {
          var inverse = query.inverse,
              typeMatch = "all" === query.type || values.type === query.type;
          if (typeMatch && inverse || !typeMatch && !inverse) return !1;
          var expressionsMatch = query.expressions.every(function (expression) {
            var feature = expression.feature,
                modifier = expression.modifier,
                expValue = expression.value,
                value = values[feature];
            if (!value) return !1;

            switch (feature) {
              case "orientation":
              case "scan":
                return value.toLowerCase() === expValue.toLowerCase();

              case "width":
              case "height":
              case "device-width":
              case "device-height":
                expValue = toPx(expValue), value = toPx(value);
                break;

              case "resolution":
                expValue = toDpi(expValue), value = toDpi(value);
                break;

              case "aspect-ratio":
              case "device-aspect-ratio":
              case "device-pixel-ratio":
                expValue = toDecimal(expValue), value = toDecimal(value);
                break;

              case "grid":
              case "color":
              case "color-index":
              case "monochrome":
                expValue = parseInt(expValue, 10) || 1, value = parseInt(value, 10) || 0;
            }

            switch (modifier) {
              case "min":
                return value >= expValue;

              case "max":
                return value <= expValue;

              default:
                return value === expValue;
            }
          });
          return expressionsMatch && !inverse || !expressionsMatch && inverse;
        });
      }

      function parseQuery(mediaQuery) {
        return mediaQuery.split(",").map(function (query) {
          query = query.trim();
          var captures = query.match(RE_MEDIA_QUERY),
              modifier = captures[1],
              type = captures[2],
              expressions = captures[3] || "",
              parsed = {};
          return parsed.inverse = !!modifier && "not" === modifier.toLowerCase(), parsed.type = type ? type.toLowerCase() : "all", expressions = expressions.match(/\([^\)]+\)/g) || [], parsed.expressions = expressions.map(function (expression) {
            var captures = expression.match(RE_MQ_EXPRESSION),
                feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);
            return {
              modifier: feature[1],
              feature: feature[2],
              value: captures[2]
            };
          }), parsed;
        });
      }

      function toDecimal(ratio) {
        var numbers,
            decimal = Number(ratio);
        return decimal || (numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/), decimal = numbers[1] / numbers[2]), decimal;
      }

      function toDpi(resolution) {
        var value = parseFloat(resolution);

        switch (String(resolution).match(RE_RESOLUTION_UNIT)[1]) {
          case "dpcm":
            return value / 2.54;

          case "dppx":
            return 96 * value;

          default:
            return value;
        }
      }

      function toPx(length) {
        var value = parseFloat(length);

        switch (String(length).match(RE_LENGTH_UNIT)[1]) {
          case "em":
          case "rem":
            return 16 * value;

          case "cm":
            return 96 * value / 2.54;

          case "mm":
            return 96 * value / 2.54 / 10;

          case "in":
            return 96 * value;

          case "pt":
            return 72 * value;

          case "pc":
            return 72 * value / 12;

          default:
            return value;
        }
      }

      exports.match = matchQuery, exports.parse = parseQuery;
      var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i,
          RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/,
          RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/,
          RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/,
          RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
    }, function (module, exports, __webpack_require__) {

      function shallowEqualObjects(objA, objB) {
        if (objA === objB) return !0;
        if (!objA || !objB) return !1;
        var aKeys = Object.keys(objA),
            bKeys = Object.keys(objB),
            len = aKeys.length;
        if (bKeys.length !== len) return !1;

        for (var i = 0; i < len; i++) {
          var key = aKeys[i];
          if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return !1;
        }

        return !0;
      }

      module.exports = shallowEqualObjects;
    }, function (module, __webpack_exports__, __webpack_require__) {

      function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);

        if (Object.getOwnPropertySymbols) {
          var symbols = Object.getOwnPropertySymbols(object);
          enumerableOnly && (symbols = symbols.filter(function (sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
          })), keys.push.apply(keys, symbols);
        }

        return keys;
      }

      function _objectSpread(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = null != arguments[i] ? arguments[i] : {};
          i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
            _defineProperty(target, key, source[key]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }

        return target;
      }

      function _defineProperty(obj, key, value) {
        return key in obj ? Object.defineProperty(obj, key, {
          value: value,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : obj[key] = value, obj;
      }

      var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(12),
          __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__),
          stringOrNumber = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number]),
          matchers = {
        orientation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(["portrait", "landscape"]),
        scan: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(["progressive", "interlace"]),
        aspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        deviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        height: stringOrNumber,
        deviceHeight: stringOrNumber,
        width: stringOrNumber,
        deviceWidth: stringOrNumber,
        color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        colorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        monochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        resolution: stringOrNumber
      },
          features = _objectSpread({
        minAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        maxAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        minDeviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        maxDeviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        minHeight: stringOrNumber,
        maxHeight: stringOrNumber,
        minDeviceHeight: stringOrNumber,
        maxDeviceHeight: stringOrNumber,
        minWidth: stringOrNumber,
        maxWidth: stringOrNumber,
        minDeviceWidth: stringOrNumber,
        maxDeviceWidth: stringOrNumber,
        minColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
        maxColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
        minColorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
        maxColorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
        minMonochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
        maxMonochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
        minResolution: stringOrNumber,
        maxResolution: stringOrNumber
      }, matchers),
          types = {
        all: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        grid: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        aural: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        braille: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        handheld: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        print: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        projection: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        screen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        tty: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        tv: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        embossed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
      },
          all = _objectSpread(_objectSpread({}, types), features);

      matchers.type = Object.keys(types), __webpack_exports__.a = {
        all: all,
        types: types,
        matchers: matchers,
        features: features
      };
    }, function (module, exports, __webpack_require__) {
      var ReactIs = __webpack_require__(4);

      module.exports = __webpack_require__(14)(ReactIs.isElement, !0);
    }, function (module, exports, __webpack_require__) {

      !function () {
        function isValidElementType(type) {
          return "string" == typeof type || "function" == typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" == typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }

        function typeOf(object) {
          if ("object" == typeof object && null !== object) {
            var $$typeof = object.$$typeof;

            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;

                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;

                  default:
                    var $$typeofType = type && type.$$typeof;

                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;

                      default:
                        return $$typeof;
                    }

                }

              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
        }

        function isAsyncMode(object) {
          return hasWarnedAboutDeprecatedIsAsyncMode || (hasWarnedAboutDeprecatedIsAsyncMode = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }

        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }

        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }

        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }

        function isElement(object) {
          return "object" == typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
        }

        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }

        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }

        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }

        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }

        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }

        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }

        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }

        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }

        var hasSymbol = "function" == typeof Symbol && Symbol["for"],
            REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]("react.element") : 60103,
            REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]("react.portal") : 60106,
            REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]("react.fragment") : 60107,
            REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]("react.strict_mode") : 60108,
            REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]("react.profiler") : 60114,
            REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]("react.provider") : 60109,
            REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]("react.context") : 60110,
            REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]("react.async_mode") : 60111,
            REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]("react.concurrent_mode") : 60111,
            REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]("react.forward_ref") : 60112,
            REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]("react.suspense") : 60113,
            REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]("react.suspense_list") : 60120,
            REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]("react.memo") : 60115,
            REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]("react.lazy") : 60116,
            REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]("react.block") : 60121,
            REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]("react.fundamental") : 60117,
            REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]("react.responder") : 60118,
            REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]("react.scope") : 60119,
            AsyncMode = REACT_ASYNC_MODE_TYPE,
            ConcurrentMode = REACT_CONCURRENT_MODE_TYPE,
            ContextConsumer = REACT_CONTEXT_TYPE,
            ContextProvider = REACT_PROVIDER_TYPE,
            Element = REACT_ELEMENT_TYPE,
            ForwardRef = REACT_FORWARD_REF_TYPE,
            Fragment = REACT_FRAGMENT_TYPE,
            Lazy = REACT_LAZY_TYPE,
            Memo = REACT_MEMO_TYPE,
            Portal = REACT_PORTAL_TYPE,
            Profiler = REACT_PROFILER_TYPE,
            StrictMode = REACT_STRICT_MODE_TYPE,
            Suspense = REACT_SUSPENSE_TYPE,
            hasWarnedAboutDeprecatedIsAsyncMode = !1;
        exports.AsyncMode = AsyncMode, exports.ConcurrentMode = ConcurrentMode, exports.ContextConsumer = ContextConsumer, exports.ContextProvider = ContextProvider, exports.Element = Element, exports.ForwardRef = ForwardRef, exports.Fragment = Fragment, exports.Lazy = Lazy, exports.Memo = Memo, exports.Portal = Portal, exports.Profiler = Profiler, exports.StrictMode = StrictMode, exports.Suspense = Suspense, exports.isAsyncMode = isAsyncMode, exports.isConcurrentMode = isConcurrentMode, exports.isContextConsumer = isContextConsumer, exports.isContextProvider = isContextProvider, exports.isElement = isElement, exports.isForwardRef = isForwardRef, exports.isFragment = isFragment, exports.isLazy = isLazy, exports.isMemo = isMemo, exports.isPortal = isPortal, exports.isProfiler = isProfiler, exports.isStrictMode = isStrictMode, exports.isSuspense = isSuspense, exports.isValidElementType = isValidElementType, exports.typeOf = typeOf;
      }();
    }, function (module, exports, __webpack_require__) {

      function emptyFunctionThatReturnsNull() {
        return null;
      }

      var ReactIs = __webpack_require__(4),
          assign = __webpack_require__(15),
          ReactPropTypesSecret = __webpack_require__(5),
          checkPropTypes = __webpack_require__(16),
          has = Function.call.bind(Object.prototype.hasOwnProperty),
          printWarning = function printWarning() {};

      printWarning = function printWarning(text) {
        var message = "Warning: " + text;
        "undefined" != typeof console && console.error(message);

        try {
          throw new Error(message);
        } catch (x) {}
      }, module.exports = function (isValidElement, throwOnDirectAccess) {
        function getIteratorFn(maybeIterable) {
          var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
          if ("function" == typeof iteratorFn) return iteratorFn;
        }

        function is(x, y) {
          return x === y ? 0 !== x || 1 / x == 1 / y : x !== x && y !== y;
        }

        function PropTypeError(message) {
          this.message = message, this.stack = "";
        }

        function createChainableTypeChecker(validate) {
          function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            if (componentName = componentName || ANONYMOUS, propFullName = propFullName || propName, secret !== ReactPropTypesSecret) {
              if (throwOnDirectAccess) {
                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                throw err.name = "Invariant Violation", err;
              }

              if ("undefined" != typeof console) {
                var cacheKey = componentName + ":" + propName;
                !manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3 && (printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), manualPropTypeCallCache[cacheKey] = !0, manualPropTypeWarningCount++);
              }
            }

            return null == props[propName] ? isRequired ? new PropTypeError(null === props[propName] ? "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `null`." : "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `undefined`.") : null : validate(props, propName, componentName, location, propFullName);
          }

          var manualPropTypeCallCache = {},
              manualPropTypeWarningCount = 0,
              chainedCheckType = checkType.bind(null, !1);
          return chainedCheckType.isRequired = checkType.bind(null, !0), chainedCheckType;
        }

        function createPrimitiveTypeChecker(expectedType) {
          function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            if (getPropType(propValue) !== expectedType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPreciseType(propValue) + "` supplied to `" + componentName + "`, expected `" + expectedType + "`.");
            return null;
          }

          return createChainableTypeChecker(validate);
        }

        function createArrayOfTypeChecker(typeChecker) {
          function validate(props, propName, componentName, location, propFullName) {
            if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
            var propValue = props[propName];

            if (!Array.isArray(propValue)) {
              return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected an array.");
            }

            for (var i = 0; i < propValue.length; i++) {
              var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
              if (error instanceof Error) return error;
            }

            return null;
          }

          return createChainableTypeChecker(validate);
        }

        function createInstanceTypeChecker(expectedClass) {
          function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
              var expectedClassName = expectedClass.name || ANONYMOUS;
              return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getClassName(props[propName]) + "` supplied to `" + componentName + "`, expected instance of `" + expectedClassName + "`.");
            }

            return null;
          }

          return createChainableTypeChecker(validate);
        }

        function createEnumTypeChecker(expectedValues) {
          function validate(props, propName, componentName, location, propFullName) {
            for (var propValue = props[propName], i = 0; i < expectedValues.length; i++) {
              if (is(propValue, expectedValues[i])) return null;
            }

            var valuesString = JSON.stringify(expectedValues, function (key, value) {
              return "symbol" === getPreciseType(value) ? String(value) : value;
            });
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` supplied to `" + componentName + "`, expected one of " + valuesString + ".");
          }

          return Array.isArray(expectedValues) ? createChainableTypeChecker(validate) : (printWarning(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), emptyFunctionThatReturnsNull);
        }

        function createObjectOfTypeChecker(typeChecker) {
          function validate(props, propName, componentName, location, propFullName) {
            if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
            var propValue = props[propName],
                propType = getPropType(propValue);
            if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected an object.");

            for (var key in propValue) {
              if (has(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                if (error instanceof Error) return error;
              }
            }

            return null;
          }

          return createChainableTypeChecker(validate);
        }

        function createUnionTypeChecker(arrayOfTypeCheckers) {
          function validate(props, propName, componentName, location, propFullName) {
            for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
              if (null == (0, arrayOfTypeCheckers[i])(props, propName, componentName, location, propFullName, ReactPropTypesSecret)) return null;
            }

            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`.");
          }

          if (!Array.isArray(arrayOfTypeCheckers)) return printWarning("Invalid argument supplied to oneOfType, expected an instance of array."), emptyFunctionThatReturnsNull;

          for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
            var checker = arrayOfTypeCheckers[i];
            if ("function" != typeof checker) return printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."), emptyFunctionThatReturnsNull;
          }

          return createChainableTypeChecker(validate);
        }

        function createShapeTypeChecker(shapeTypes) {
          function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName],
                propType = getPropType(propValue);
            if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");

            for (var key in shapeTypes) {
              var checker = shapeTypes[key];

              if (checker) {
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                if (error) return error;
              }
            }

            return null;
          }

          return createChainableTypeChecker(validate);
        }

        function createStrictShapeTypeChecker(shapeTypes) {
          function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName],
                propType = getPropType(propValue);
            if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
            var allKeys = assign({}, props[propName], shapeTypes);

            for (var key in allKeys) {
              var checker = shapeTypes[key];
              if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
              var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
              if (error) return error;
            }

            return null;
          }

          return createChainableTypeChecker(validate);
        }

        function isNode(propValue) {
          switch (typeof propValue) {
            case "number":
            case "string":
            case "undefined":
              return !0;

            case "boolean":
              return !propValue;

            case "object":
              if (Array.isArray(propValue)) return propValue.every(isNode);
              if (null === propValue || isValidElement(propValue)) return !0;
              var iteratorFn = getIteratorFn(propValue);
              if (!iteratorFn) return !1;
              var step,
                  iterator = iteratorFn.call(propValue);

              if (iteratorFn !== propValue.entries) {
                for (; !(step = iterator.next()).done;) {
                  if (!isNode(step.value)) return !1;
                }
              } else for (; !(step = iterator.next()).done;) {
                var entry = step.value;
                if (entry && !isNode(entry[1])) return !1;
              }

              return !0;

            default:
              return !1;
          }
        }

        function isSymbol(propType, propValue) {
          return "symbol" === propType || !!propValue && ("Symbol" === propValue["@@toStringTag"] || "function" == typeof Symbol && propValue instanceof Symbol);
        }

        function getPropType(propValue) {
          var propType = typeof propValue;
          return Array.isArray(propValue) ? "array" : propValue instanceof RegExp ? "object" : isSymbol(propType, propValue) ? "symbol" : propType;
        }

        function getPreciseType(propValue) {
          if (void 0 === propValue || null === propValue) return "" + propValue;
          var propType = getPropType(propValue);

          if ("object" === propType) {
            if (propValue instanceof Date) return "date";
            if (propValue instanceof RegExp) return "regexp";
          }

          return propType;
        }

        function getPostfixForTypeWarning(value) {
          var type = getPreciseType(value);

          switch (type) {
            case "array":
            case "object":
              return "an " + type;

            case "boolean":
            case "date":
            case "regexp":
              return "a " + type;

            default:
              return type;
          }
        }

        function getClassName(propValue) {
          return propValue.constructor && propValue.constructor.name ? propValue.constructor.name : ANONYMOUS;
        }

        var ITERATOR_SYMBOL = "function" == typeof Symbol && Symbol.iterator,
            FAUX_ITERATOR_SYMBOL = "@@iterator",
            ANONYMOUS = "<<anonymous>>",
            ReactPropTypes = {
          array: createPrimitiveTypeChecker("array"),
          bool: createPrimitiveTypeChecker("boolean"),
          func: createPrimitiveTypeChecker("function"),
          number: createPrimitiveTypeChecker("number"),
          object: createPrimitiveTypeChecker("object"),
          string: createPrimitiveTypeChecker("string"),
          symbol: createPrimitiveTypeChecker("symbol"),
          any: function () {
            return createChainableTypeChecker(emptyFunctionThatReturnsNull);
          }(),
          arrayOf: createArrayOfTypeChecker,
          element: function () {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];

              if (!isValidElement(propValue)) {
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement.");
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }(),
          elementType: function () {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];

              if (!ReactIs.isValidElementType(propValue)) {
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement type.");
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }(),
          instanceOf: createInstanceTypeChecker,
          node: function () {
            function validate(props, propName, componentName, location, propFullName) {
              return isNode(props[propName]) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`, expected a ReactNode.");
            }

            return createChainableTypeChecker(validate);
          }(),
          objectOf: createObjectOfTypeChecker,
          oneOf: createEnumTypeChecker,
          oneOfType: createUnionTypeChecker,
          shape: createShapeTypeChecker,
          exact: createStrictShapeTypeChecker
        };
        return PropTypeError.prototype = Error.prototype, ReactPropTypes.checkPropTypes = checkPropTypes, ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache, ReactPropTypes.PropTypes = ReactPropTypes, ReactPropTypes;
      };
    }, function (module, exports, __webpack_require__) {

      function toObject(val) {
        if (null === val || void 0 === val) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(val);
      }
      /*
      object-assign
      (c) Sindre Sorhus
      @license MIT
      */


      var getOwnPropertySymbols = Object.getOwnPropertySymbols,
          hasOwnProperty = Object.prototype.hasOwnProperty,
          propIsEnumerable = Object.prototype.propertyIsEnumerable;
      module.exports = function () {
        try {
          if (!Object.assign) return !1;
          var test1 = new String("abc");
          if (test1[5] = "de", "5" === Object.getOwnPropertyNames(test1)[0]) return !1;

          for (var test2 = {}, i = 0; i < 10; i++) {
            test2["_" + String.fromCharCode(i)] = i;
          }

          if ("0123456789" !== Object.getOwnPropertyNames(test2).map(function (n) {
            return test2[n];
          }).join("")) return !1;
          var test3 = {};
          return "abcdefghijklmnopqrst".split("").forEach(function (letter) {
            test3[letter] = letter;
          }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, test3)).join("");
        } catch (err) {
          return !1;
        }
      }() ? Object.assign : function (target, source) {
        for (var from, symbols, to = toObject(target), s = 1; s < arguments.length; s++) {
          from = Object(arguments[s]);

          for (var key in from) {
            hasOwnProperty.call(from, key) && (to[key] = from[key]);
          }

          if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);

            for (var i = 0; i < symbols.length; i++) {
              propIsEnumerable.call(from, symbols[i]) && (to[symbols[i]] = from[symbols[i]]);
            }
          }
        }

        return to;
      };
    }, function (module, exports, __webpack_require__) {

      function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error;

            try {
              if ("function" != typeof typeSpecs[typeSpecName]) {
                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.");
                throw err.name = "Invariant Violation", err;
              }

              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }

            if (!error || error instanceof Error || printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = !0;
              var stack = getStack ? getStack() : "";
              printWarning("Failed " + location + " type: " + error.message + (null != stack ? stack : ""));
            }
          }
        }
      }

      var printWarning = function printWarning() {},
          ReactPropTypesSecret = __webpack_require__(5),
          loggedTypeFailures = {},
          has = Function.call.bind(Object.prototype.hasOwnProperty);

      printWarning = function printWarning(text) {
        var message = "Warning: " + text;
        "undefined" != typeof console && console.error(message);

        try {
          throw new Error(message);
        } catch (x) {}
      }, checkPropTypes.resetWarningCache = function () {
        loggedTypeFailures = {};
      }, module.exports = checkPropTypes;
    }, function (module, __webpack_exports__, __webpack_require__) {

      function _objectWithoutProperties(source, excluded) {
        if (null == source) return {};

        var key,
            i,
            target = _objectWithoutPropertiesLoose(source, excluded);

        if (Object.getOwnPropertySymbols) {
          var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

          for (i = 0; i < sourceSymbolKeys.length; i++) {
            key = sourceSymbolKeys[i], excluded.indexOf(key) >= 0 || Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
          }
        }

        return target;
      }

      function _objectWithoutPropertiesLoose(source, excluded) {
        if (null == source) return {};
        var key,
            i,
            target = {},
            sourceKeys = Object.keys(source);

        for (i = 0; i < sourceKeys.length; i++) {
          key = sourceKeys[i], excluded.indexOf(key) >= 0 || (target[key] = source[key]);
        }

        return target;
      }

      function MediaQuery(_ref) {
        var children = _ref.children,
            device = _ref.device,
            onChange = _ref.onChange,
            settings = _objectWithoutProperties(_ref, ["children", "device", "onChange"]),
            matches = Object(__WEBPACK_IMPORTED_MODULE_0__useMediaQuery__.a)(settings, device, onChange);

        return "function" == typeof children ? children(matches) : matches ? children : null;
      }

      __webpack_exports__.a = MediaQuery;

      var __WEBPACK_IMPORTED_MODULE_0__useMediaQuery__ = __webpack_require__(0);
    }]);
  });
});
unwrapExports(reactResponsive);
var reactResponsive_1 = reactResponsive.useMediaQuery;
reactResponsive.MediaQuery;

var useMedia = function useMedia() {
  var isDesktop = reactResponsive_1({
    query: device.desktop
  });
  var isLaptop = reactResponsive_1({
    query: device.laptop
  });
  var isTablet = reactResponsive_1({
    query: device.tablet
  });
  var isMobile = reactResponsive_1({
    query: device.mobile
  });
  return useMemo(function () {
    return {
      isDesktop: isDesktop,
      isLaptop: isLaptop,
      isTablet: isTablet,
      isMobile: isMobile
    };
  }, [isDesktop, isLaptop, isTablet, isMobile]);
};

var useHomepage = function useHomepage() {
  var url = typeof window !== 'undefined' ? window.location.href : null;
  var isHome = false;
  if (url === null || url === undefined) return false;
  var urlParts = url.split('/');
  var lastParam = urlParts[urlParts.length - 2] !== undefined ? urlParts[urlParts.length - 2] : urlParts[urlParts.length - 1];

  if (lastParam !== undefined && (lastParam.includes('genially.com') || lastParam.includes('localhost') || lastParam == 'es' || lastParam == 'en' || lastParam == 'pt-br' || lastParam == 'it' || lastParam == 'de' || lastParam == 'fr')) {
    isHome = true;
  }

  return isHome;
};

var useOnClickOutside = function useOnClickOutside(ref, handler) {
  useEffect(function () {
    var listener = function listener(event) {
      var element = ref === null || ref === void 0 ? void 0 : ref.current;

      if (!element || element.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

var asyncToGenerator = createCommonjsModule(function (module) {
  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }

    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }

  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
          args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);

        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }

        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }

        _next(undefined);
      });
    };
  }

  module.exports = _asyncToGenerator;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
var _asyncToGenerator = unwrapExports(asyncToGenerator);

var runtime_1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var runtime = function (exports) {

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }

    try {
      // IE 8 has a broken Object.defineProperty that only works on DOM objects.
      define({}, "");
    } catch (err) {
      define = function define(obj, key, value) {
        return obj[key] = value;
      };
    }

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports );

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});

var regenerator = runtime_1;

var apiClient = {
  isLoggedUser: function isLoggedUser() {
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch('https://auth.genially.com/logged', {
                method: 'GET',
                credentials: 'include'
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  getCurrency: function getCurrency() {
    return _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetch('https://api.genially.com/api/v1/currency', {
                method: 'GET',
                credentials: 'include'
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};

var isLoggedUser = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
    var authResponse;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return apiClient.isLoggedUser();

          case 2:
            authResponse = _context.sent;
            return _context.abrupt("return", authResponse.status === 200);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function isLoggedUser() {
    return _ref.apply(this, arguments);
  };
}();

var getCurrencyUser = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
    var currencyResponse;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return apiClient.getCurrency();

          case 2:
            currencyResponse = _context2.sent;
            return _context2.abrupt("return", currencyResponse.status === 200 ? currencyResponse.text() : 'usd');

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getCurrencyUser() {
    return _ref2.apply(this, arguments);
  };
}();

var userService = {
  isLoggedUser: isLoggedUser,
  getCurrencyUser: getCurrencyUser
};

var IsLoggedInContext = /*#__PURE__*/createContext(false);
var IsLoggedInProvider = function IsLoggedInProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(false),
      isLoggedIn = _useState[0],
      setIsLoggedIn = _useState[1];

  useEffect(function () {
    userService.isLoggedUser().then(setIsLoggedIn);
  }, []);
  return /*#__PURE__*/jsx(IsLoggedInContext.Provider, {
    value: isLoggedIn,
    children: children
  });
};

var useIsLoggedIn = function useIsLoggedIn() {
  return useContext(IsLoggedInContext);
};

var _excluded$s = ["children"];

var DefaultLink = function DefaultLink(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$s);

  return /*#__PURE__*/jsx("a", _extends$2({}, props, {
    children: children
  }));
};

var LinkContext = /*#__PURE__*/createContext(DefaultLink);
var LinkProvider = function LinkProvider(_ref2) {
  var children = _ref2.children,
      customLink = _ref2.customLink;
  return /*#__PURE__*/jsx(LinkContext.Provider, {
    value: customLink,
    children: children
  });
};

var useLink = function useLink() {
  return useContext(LinkContext);
};

var _excluded$r = ["children"],
    _excluded2$2 = ["children", "variant"];
var LinkText = styled(Text).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'variant';
  }
}).withConfig({
  displayName: "Link__LinkText",
  componentId: "sc-1tnbas8-0"
})(["text-decoration:", ";&:active,:visited,:link{color:", ";}"], function (_ref) {
  var $underline = _ref.$underline;
  return $underline ? 'underline' : 'none';
}, function (_ref2) {
  var $color = _ref2.$color;
  return !$color ? theme.colors.rBlack : theme.colors[$color];
});

var BaseLink = function BaseLink(_ref3) {
  var children = _ref3.children,
      props = _objectWithoutPropertiesLoose$2(_ref3, _excluded$r);

  var CustomLink = useLink();
  return /*#__PURE__*/jsx(CustomLink, _extends$2({}, props, {
    children: children
  }));
};

var StyledLink = styled(function (props) {
  return /*#__PURE__*/jsx(BaseLink, _extends$2({}, props));
}).withConfig({
  displayName: "Link__StyledLink",
  componentId: "sc-1tnbas8-1"
})(["", " text-decoration:", ";color:", ";"], theme.marginsCss, function (_ref4) {
  var $underline = _ref4.$underline;
  return $underline ? 'underline' : 'none';
}, function (_ref5) {
  var $color = _ref5.$color;
  return !$color ? theme.colors.rBlack : theme.colors[$color];
});
var Link = function Link(_ref6) {
  var children = _ref6.children,
      variant = _ref6.variant,
      rest = _objectWithoutPropertiesLoose$2(_ref6, _excluded2$2);

  if (typeof children === 'string' && variant) {
    return /*#__PURE__*/jsx(LinkText, _extends$2({
      variant: variant,
      as: BaseLink
    }, rest, {
      children: children
    }));
  }

  return /*#__PURE__*/jsx(StyledLink, _extends$2({}, rest, {
    children: children
  }));
};

var SimpleList = styled.ul.withConfig({
  displayName: "SimpleList",
  componentId: "sc-5b142t-0"
})(["position:relative;display:flex;flex-wrap:wrap;padding:0 !important;", " ", ""], function (_ref) {
  var colDirection = _ref.colDirection;
  return colDirection ? "\n    flex-direction: column;\n  " : "\n    flex-direction: row;\n    li {\n      padding: 0 " + rem(theme.sizes.xmini) + ";\n      flex: 1;\n      flex-basis: 30%;\n      @media " + theme.device.tablet + " { \n        flex-basis: auto;\n      }\n      text-align: center;\n    }\n    li:first-child {\n      padding: 0;\n    }\n  ";
}, function (_ref2) {
  var border = _ref2.border;
  return border && "\n    li:not(:last-child) {\n      border-right: " + rem(1) + " solid;\n    }\n  ";
});

var SimpleListItem = styled.li.withConfig({
  displayName: "SimpleListItem",
  componentId: "vti6il-0"
})(["display:inline-table;position:relative;"]);

var iconGKeyframe = keyframes$1(["1%{transform:translate(0px,0px);}4.33%{transform:translate(", ",", ");}6%{transform:translate(", ",", ");}9.3%{transform:translate(", ",", ");}11%{transform:translate(", ",", ");}14.6%{transform:translate(0px,0px);}100%{transform:translate(0px,0px);}"], rem(-1), rem(-1), rem(-1), rem(-1), rem(-1), rem(1), rem(-1), rem(1));
var pointGKeyframe = keyframes$1(["1%{transform:translate(0px,0px);}4.33%{transform:translate(", ",", ");}6%{transform:translate(", ",", ");}9.33%{transform:translate(", ",", ");}11%{transform:translate(", ",", ");}14.66%{transform:translate(0px,0px);}100%{transform:translate(0px,0px);}"], rem(-4.5), rem(-4.5), rem(-4.5), rem(-4.5), rem(-5), rem(2), rem(-5), rem(2));
var winkKeyframe = keyframes$1(["0%{clip-path:ellipse(100% 100% at 50% 50%);}23.3%{clip-path:ellipse(100% 100% at 50% 50%);}24.6%{clip-path:ellipse(100% 0% at 50% 50%);}25.6%{clip-path:ellipse(100% 100% at 50% 50%);}26%{clip-path:ellipse(100% 100% at 50% 50%);}27.3%{clip-path:ellipse(100% 0% at 50% 50%);}28.3%{clip-path:ellipse(100% 100% at 50% 50%);}70.3%{clip-path:ellipse(100% 100% at 50% 50%);}71.6%{clip-path:ellipse(100% 0% at 50% 50%);}72.6%{clip-path:ellipse(100% 100% at 50% 50%);}73%{clip-path:ellipse(100% 100% at 50% 50%);}74.3%{clip-path:ellipse(100% 0% at 50% 50%);}75.3%{clip-path:ellipse(100% 100% at 50% 50%);}100%{clip-path:ellipse(100% 100% at 50% 50%);}"]);
var rotateGradientKeyframe = keyframes$1(["0%{transform:rotate(0deg);}6%{transform:rotate(90deg);}11%{transform:rotate(-90deg);}18.33%{transform:rotate(0deg);}100%{transform:rotate(0deg);}"]);
var pointGAnimation = css(["animation:", " 10s cubic-bezier(0.2,1.06,0.61,0.97) infinite;"], pointGKeyframe);
var winkAnimation = css(["animation:", " 10s cubic-bezier(0.2,1.06,0.61,0.97) infinite;"], winkKeyframe);
var rotateGradientAnimation = css(["transform-origin:", " ", ";animation:", " 10s cubic-bezier(0.2,1.06,0.61,0.97) infinite;"], rem(14.83), rem(15.83), rotateGradientKeyframe);
var iconGAnimation = css(["animation:", " 10s cubic-bezier(0.2,1.06,0.61,0.97) infinite;"], iconGKeyframe);

var animations$3 = {
  iconG: iconGAnimation,
  pointG: pointGAnimation,
  wink: winkAnimation,
  rotateGradient: rotateGradientAnimation
};
var gradients = {
  secondary: 'fill: url(#Degradado1);',
  tertiary: 'fill: url(#Degradado2);',
  quaternary: 'fill: url(#Degradado3);',
  quinary: 'fill: url(#Degradado4);',
  senary: 'fill: url(#Degradado5);',
  septenary: 'fill: url(#Degradado6);',
  iconG: "fill: " + theme.colors.white,
  pointG: "fill: " + theme.colors.white
};
var Path = styled.path.withConfig({
  displayName: "Logovariants__Path",
  componentId: "sc-1y3h6v6-0"
})(["", ";", ";"], function (_ref) {
  var gradient = _ref.gradient;
  return gradient ? gradients[gradient] : '';
}, function (_ref2) {
  var animation = _ref2.animation;
  return animation ? animations$3[animation] : '';
});
var G = styled.g.withConfig({
  displayName: "Logovariants__G",
  componentId: "sc-1y3h6v6-1"
})(["", ";", ";"], function (_ref3) {
  var type = _ref3.type;
  return type && gTypes[type];
}, function (_ref4) {
  var animation = _ref4.animation;
  return animation ? animations$3[animation] : '';
});
var gTypes = {
  black: "fill: " + theme.colors.black,
  primaryColor: "fill: " + theme.colors.black,
  isotype: "fill: " + theme.colors.white,
  gradient: 'transform-origin: 20.5035555556% 50%;',
  white: "fill: " + theme.colors.white
};
var StyledSvg = styled.svg.withConfig({
  displayName: "Logovariants__StyledSvg",
  componentId: "sc-1y3h6v6-2"
})(["", ";"], function (_ref5) {
  var width = _ref5.width;
  return width ? 'width:' + width : '96px';
});
var LogoBlackText = function LogoBlackText(_ref6) {
  var className = _ref6.className;
  return /*#__PURE__*/jsxs(StyledSvg, {
    className: className,
    width: "96px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 32",
    children: [/*#__PURE__*/jsxs(G, {
      animation: "rotateGradient",
      children: [/*#__PURE__*/jsx(Path, {
        fill: "url(#paint0_linear)",
        d: "M14.83 1v14.83L27.795 8.64C25.266 4.086 20.41 1 14.83 1z"
      }), /*#__PURE__*/jsx(Path, {
        fill: "url(#paint1_linear)",
        d: "M14.83 15.829l12.708 7.636c2.68-4.47 2.924-10.217.134-15.05l-12.843 7.414z"
      }), /*#__PURE__*/jsx(Path, {
        fill: "url(#paint2_linear)",
        d: "M14.57 30.653c5.211.086 10.311-2.576 13.102-7.41L14.829 15.83l-.259 14.824z"
      }), /*#__PURE__*/jsx(Path, {
        fill: "url(#paint3_linear)",
        d: "M1.862 23.017c2.531 4.556 7.387 7.641 12.967 7.641V15.83L1.862 23.017z"
      }), /*#__PURE__*/jsx(Path, {
        fill: "url(#paint4_linear)",
        d: "M1.987 23.244l12.842-7.415L2.121 8.193c-2.68 4.47-2.925 10.218-.134 15.05z"
      }), /*#__PURE__*/jsx(Path, {
        fill: "url(#paint5_linear)",
        d: "M1.987 8.415l12.842 7.414.259-14.823a14.714 14.714 0 00-.245-.003c-5.126 0-10.11 2.654-12.856 7.412z"
      })]
    }), /*#__PURE__*/jsx(Path, {
      fill: theme.colors.black,
      d: "M26.537 15.83c0 6.465-5.242 11.707-11.708 11.707S3.122 22.294 3.122 15.829 8.363 4.122 14.829 4.122c6.466 0 11.707 5.241 11.707 11.707z"
    }), /*#__PURE__*/jsxs(G, {
      animation: "wink",
      children: [/*#__PURE__*/jsx(Path, {
        animation: "iconG",
        fill: theme.colors.white,
        d: "M22.327 15.653c-.692 0-1.29.486-1.425 1.165a5.916 5.916 0 01-11.703-1.539c.186-3.026 2.704-5.454 5.735-5.538a5.903 5.903 0 012.116.327c.64.223 1.35-.013 1.694-.597l.062-.106a1.4 1.4 0 00-.75-2.028 8.806 8.806 0 00-3.27-.503c-4.589.16-8.334 3.898-8.503 8.487a8.825 8.825 0 0017.476 2.051c.176-.892-.523-1.719-1.432-1.719"
      }), /*#__PURE__*/jsx(Path, {
        fill: theme.colors.white,
        animation: "pointG",
        d: "M17.236 14.773a1.898 1.898 0 100 3.797 1.898 1.898 0 000-3.797"
      })]
    }), /*#__PURE__*/jsx(Path, {
      fill: theme.colors.black,
      d: "M42.965 11.509c.162-.155.38-.234.656-.234s.494.081.656.243c.162.161.243.375.243.638v7.368c0 1.342-.357 2.355-1.07 3.037-.713.684-1.764 1.025-3.154 1.025-1.294 0-2.372-.245-3.234-.737l-.003-.001a.324.324 0 01-.133-.413l.338-.766a.325.325 0 01.453-.155l.01.005c.43.204.832.362 1.203.476.371.114.815.172 1.33.172 1.654 0 2.48-.833 2.48-2.5v-1.383a2.749 2.749 0 01-1.15 1.231c-.515.294-1.114.44-1.797.44-.767 0-1.45-.18-2.049-.538a3.625 3.625 0 01-1.392-1.528c-.33-.659-.495-1.42-.495-2.283 0-.862.168-1.623.503-2.282.336-.659.8-1.17 1.393-1.537.593-.364 1.273-.548 2.04-.548.671 0 1.26.144 1.77.432.51.287.896.695 1.16 1.222v-.755c0-.264.08-.473.242-.629zm-2.74 7.009c.778 0 1.39-.258 1.833-.773.443-.515.664-1.228.664-2.139 0-.898-.218-1.608-.656-2.129-.437-.521-1.05-.782-1.842-.782-.79 0-1.41.258-1.86.773-.449.515-.674 1.228-.674 2.138 0 .911.228 1.624.683 2.14.455.514 1.072.772 1.851.772zm12.802-6.147c.683.756 1.025 1.774 1.025 3.056 0 .479-.216.718-.647.718H47.85c.12 1.858 1.013 2.787 2.678 2.787.443 0 .827-.06 1.15-.18.324-.12.666-.276 1.025-.468.036-.024.135-.075.297-.152a.986.986 0 01.404-.117c.168 0 .305.066.413.198.108.131.162.3.162.503 0 .347-.216.64-.647.88a5.69 5.69 0 01-1.375.557 5.587 5.587 0 01-1.429.198c-1.39 0-2.486-.404-3.289-1.213-.803-.809-1.204-1.914-1.204-3.316 0-.898.177-1.695.53-2.39a3.893 3.893 0 011.492-1.617c.641-.384 1.369-.576 2.184-.576 1.174 0 2.103.378 2.785 1.132zm-4.42.864c-.42.443-.672 1.066-.756 1.745h4.637c-.036-.691-.242-1.317-.62-1.755-.377-.437-.907-.655-1.59-.655-.695 0-1.252.221-1.672.665zm15.35 1.545v5.301c0 .13-.105.234-.234.234h-1.348a.234.234 0 01-.234-.234V14.87c0-.743-.147-1.288-.44-1.635-.294-.348-.752-.522-1.375-.522-.73 0-1.318.228-1.761.683-.444.455-.665 1.066-.665 1.833v4.852c0 .13-.105.234-.234.234h-1.347a.234.234 0 01-.234-.234v-7.943a.81.81 0 01.26-.62.925.925 0 01.656-.243c.264 0 .474.079.63.234a.83.83 0 01.233.611v.39c0 .098.124.135.18.056a2.89 2.89 0 011.024-.914c.515-.275 1.096-.413 1.743-.413 2.097 0 3.145 1.18 3.145 3.54zm3.28-5.237a1.052 1.052 0 100-2.104 1.052 1.052 0 000 2.104zm.907 2.613c0-.287-.084-.506-.252-.656-.167-.15-.383-.225-.646-.225a.967.967 0 00-.656.225c-.174.15-.26.369-.26.656v7.959c0 .11.089.2.199.2h1.415a.2.2 0 00.2-.2v-7.96zm4.463-.71a6.868 6.868 0 011.636-.207c1.162 0 2.028.294 2.597.881.569.588.854 1.48.854 2.678v5.247a.27.27 0 01-.27.27H76.22a.27.27 0 01-.27-.27v-1.258a2.53 2.53 0 01-1.015 1.16c-.45.27-.974.404-1.573.404a3.569 3.569 0 01-1.581-.35 2.722 2.722 0 01-1.124-.98 2.537 2.537 0 01-.404-1.401c0-.635.165-1.136.494-1.501.33-.365.875-.626 1.636-.782.76-.156 1.806-.234 3.136-.234h.413v-.521c0-.67-.138-1.156-.413-1.455-.276-.3-.719-.45-1.33-.45-.42 0-.815.054-1.186.162a8.936 8.936 0 00-1.222.467c-.324.18-.552.27-.683.27a.553.553 0 01-.44-.198.742.742 0 01-.171-.503.78.78 0 01.153-.477c.101-.137.266-.272.494-.404.419-.228.91-.41 1.473-.548zm2.697 6.883c.418-.45.628-1.027.628-1.734v-.467h-.323c-.935 0-1.654.042-2.157.125-.503.084-.862.225-1.078.423-.216.198-.324.482-.324.854 0 .43.156.784.468 1.06.311.276.7.413 1.168.413.659 0 1.198-.224 1.617-.674zm6.314-9.494v11.218a.262.262 0 01-.262.262h-1.292a.262.262 0 01-.261-.262V8.835c0-.288.084-.504.251-.647.168-.144.384-.216.647-.216.264 0 .483.072.656.216.174.143.26.359.26.647zm3.916 0v11.218a.262.262 0 01-.262.262H83.98a.262.262 0 01-.261-.262V8.835c0-.288.083-.504.251-.647.168-.144.384-.216.647-.216.264 0 .483.072.656.216.174.143.26.359.26.647zm10.42 3.25c0 .119-.025.233-.072.34l-5.33 11.315a.845.845 0 01-.316.386.79.79 0 01-.44.135.89.89 0 01-.584-.216.671.671 0 01-.26-.54c0-.095.03-.215.09-.358l1.574-3.353-3.469-7.369a.711.711 0 01-.072-.323c0-.228.096-.42.288-.575a1 1 0 01.647-.234c.36 0 .617.168.772.504l2.786 6.182 2.768-6.164a.786.786 0 01.755-.522c.227 0 .428.079.602.234.173.156.26.342.26.557z"
    }), /*#__PURE__*/jsxs("defs", {
      children: [/*#__PURE__*/jsxs("linearGradient", {
        id: "paint0_linear",
        x1: "12.273",
        x2: "20.739",
        y1: "11.576",
        y2: "15.313",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx("stop", {
          stopColor: "#F2B344"
        }), /*#__PURE__*/jsx("stop", {
          offset: "1",
          stopColor: "#F05480"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint1_linear",
        x1: "26.631",
        x2: "26.631",
        y1: "20.482",
        y2: "11.578",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx("stop", {
          stopColor: "#B156CD"
        }), /*#__PURE__*/jsx("stop", {
          offset: "1",
          stopColor: "#F05480"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint2_linear",
        x1: "20.817",
        x2: "11.74",
        y1: "15.429",
        y2: "20.38",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx("stop", {
          stopColor: "#B157CE"
        }), /*#__PURE__*/jsx("stop", {
          offset: "1",
          stopColor: "#5DA5FB"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint3_linear",
        x1: "5.126",
        x2: "13.275",
        y1: "24.357",
        y2: "27.954",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx("stop", {
          stopColor: "#74E6A7"
        }), /*#__PURE__*/jsx("stop", {
          offset: "1",
          stopColor: "#5DA5FB"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint4_linear",
        x1: "3.023",
        x2: "3.023",
        y1: "11.232",
        y2: "20.146",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx("stop", {
          stopColor: "#C8ED5B"
        }), /*#__PURE__*/jsx("stop", {
          offset: "1",
          stopColor: "#74E6A7"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint5_linear",
        x1: "9.4",
        x2: "17.2",
        y1: "15.712",
        y2: "12.195",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx("stop", {
          stopColor: "#C8ED5B"
        }), /*#__PURE__*/jsx("stop", {
          offset: "1",
          stopColor: "#F2B344"
        })]
      })]
    })]
  });
};
var LogoWhiteText = function LogoWhiteText(_ref7) {
  var className = _ref7.className;
  return /*#__PURE__*/jsxs(StyledSvg, {
    width: "96px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 32",
    className: className,
    children: [/*#__PURE__*/jsxs(G, {
      animation: "rotateGradient",
      children: [/*#__PURE__*/jsx(Path, {
        fill: "url(#paint0_linear)",
        d: "M14.83 1v14.83L27.795 8.64C25.266 4.086 20.41 1 14.83 1z"
      }), /*#__PURE__*/jsx(Path, {
        fill: "url(#paint1_linear)",
        d: "M14.83 15.829l12.708 7.636c2.68-4.47 2.924-10.217.134-15.05l-12.843 7.414z"
      }), /*#__PURE__*/jsx(Path, {
        fill: "url(#paint2_linear)",
        d: "M14.57 30.653c5.211.086 10.311-2.576 13.102-7.41L14.829 15.83l-.259 14.824z"
      }), /*#__PURE__*/jsx(Path, {
        fill: "url(#paint3_linear)",
        d: "M1.862 23.017c2.531 4.556 7.387 7.641 12.967 7.641V15.83L1.862 23.017z"
      }), /*#__PURE__*/jsx(Path, {
        fill: "url(#paint4_linear)",
        d: "M1.987 23.244l12.842-7.415L2.121 8.193c-2.68 4.47-2.925 10.218-.134 15.05z"
      }), /*#__PURE__*/jsx(Path, {
        fill: "url(#paint5_linear)",
        d: "M1.987 8.415l12.842 7.414.259-14.823a14.714 14.714 0 00-.245-.003c-5.126 0-10.11 2.654-12.856 7.412z"
      })]
    }), /*#__PURE__*/jsx(Path, {
      fill: "#000F33",
      d: "M26.537 15.83c0 6.465-5.242 11.707-11.708 11.707S3.122 22.294 3.122 15.829 8.363 4.122 14.829 4.122c6.466 0 11.707 5.241 11.707 11.707z"
    }), /*#__PURE__*/jsxs(G, {
      animation: "wink",
      children: [/*#__PURE__*/jsx(Path, {
        className: "icon-g",
        animation: "iconG",
        fill: theme.colors.white,
        d: "M22.327 15.653c-.692 0-1.29.486-1.425 1.165a5.916 5.916 0 01-11.703-1.539c.186-3.026 2.704-5.454 5.735-5.538a5.903 5.903 0 012.116.327c.64.223 1.35-.013 1.694-.597l.062-.106a1.4 1.4 0 00-.75-2.028 8.806 8.806 0 00-3.27-.503c-4.589.16-8.334 3.898-8.503 8.487a8.825 8.825 0 0017.476 2.051c.176-.892-.523-1.719-1.432-1.719"
      }), /*#__PURE__*/jsx(Path, {
        fill: theme.colors.white,
        className: "point-g",
        animation: "pointG",
        d: "M17.236 14.773a1.898 1.898 0 100 3.797 1.898 1.898 0 000-3.797"
      })]
    }), /*#__PURE__*/jsx(Path, {
      fill: theme.colors.white,
      d: "M42.965 11.509c.162-.155.38-.234.656-.234s.494.081.656.243c.162.161.243.375.243.638v7.368c0 1.342-.357 2.355-1.07 3.037-.713.684-1.764 1.025-3.154 1.025-1.294 0-2.372-.245-3.234-.737l-.003-.001a.324.324 0 01-.133-.413l.338-.766a.325.325 0 01.453-.155l.01.005c.43.204.832.362 1.203.476.371.114.815.172 1.33.172 1.654 0 2.48-.833 2.48-2.5v-1.383a2.749 2.749 0 01-1.15 1.231c-.515.294-1.114.44-1.797.44-.767 0-1.45-.18-2.049-.538a3.625 3.625 0 01-1.392-1.528c-.33-.659-.495-1.42-.495-2.283 0-.862.168-1.623.503-2.282.336-.659.8-1.17 1.393-1.537.593-.364 1.273-.548 2.04-.548.671 0 1.26.144 1.77.432.51.287.896.695 1.16 1.222v-.755c0-.264.08-.473.242-.629zm-2.74 7.009c.778 0 1.39-.258 1.833-.773.443-.515.664-1.228.664-2.139 0-.898-.218-1.608-.656-2.129-.437-.521-1.05-.782-1.842-.782-.79 0-1.41.258-1.86.773-.449.515-.674 1.228-.674 2.138 0 .911.228 1.624.683 2.14.455.514 1.072.772 1.851.772zm12.802-6.147c.683.756 1.025 1.774 1.025 3.056 0 .479-.216.718-.647.718H47.85c.12 1.858 1.013 2.787 2.678 2.787.443 0 .827-.06 1.15-.18.324-.12.666-.276 1.025-.468.036-.024.135-.075.297-.152a.986.986 0 01.404-.117c.168 0 .305.066.413.198.108.131.162.3.162.503 0 .347-.216.64-.647.88a5.69 5.69 0 01-1.375.557 5.587 5.587 0 01-1.429.198c-1.39 0-2.486-.404-3.289-1.213-.803-.809-1.204-1.914-1.204-3.316 0-.898.177-1.695.53-2.39a3.893 3.893 0 011.492-1.617c.641-.384 1.369-.576 2.184-.576 1.174 0 2.103.378 2.785 1.132zm-4.42.864c-.42.443-.672 1.066-.756 1.745h4.637c-.036-.691-.242-1.317-.62-1.755-.377-.437-.907-.655-1.59-.655-.695 0-1.252.221-1.672.665zm15.35 1.545v5.301c0 .13-.105.234-.234.234h-1.348a.234.234 0 01-.234-.234V14.87c0-.743-.147-1.288-.44-1.635-.294-.348-.752-.522-1.375-.522-.73 0-1.318.228-1.761.683-.444.455-.665 1.066-.665 1.833v4.852c0 .13-.105.234-.234.234h-1.347a.234.234 0 01-.234-.234v-7.943a.81.81 0 01.26-.62.925.925 0 01.656-.243c.264 0 .474.079.63.234a.83.83 0 01.233.611v.39c0 .098.124.135.18.056a2.89 2.89 0 011.024-.914c.515-.275 1.096-.413 1.743-.413 2.097 0 3.145 1.18 3.145 3.54zm3.28-5.237a1.052 1.052 0 100-2.104 1.052 1.052 0 000 2.104zm.907 2.613c0-.287-.084-.506-.252-.656-.167-.15-.383-.225-.646-.225a.967.967 0 00-.656.225c-.174.15-.26.369-.26.656v7.959c0 .11.089.2.199.2h1.415a.2.2 0 00.2-.2v-7.96zm4.463-.71a6.868 6.868 0 011.636-.207c1.162 0 2.028.294 2.597.881.569.588.854 1.48.854 2.678v5.247a.27.27 0 01-.27.27H76.22a.27.27 0 01-.27-.27v-1.258a2.53 2.53 0 01-1.015 1.16c-.45.27-.974.404-1.573.404a3.569 3.569 0 01-1.581-.35 2.722 2.722 0 01-1.124-.98 2.537 2.537 0 01-.404-1.401c0-.635.165-1.136.494-1.501.33-.365.875-.626 1.636-.782.76-.156 1.806-.234 3.136-.234h.413v-.521c0-.67-.138-1.156-.413-1.455-.276-.3-.719-.45-1.33-.45-.42 0-.815.054-1.186.162a8.936 8.936 0 00-1.222.467c-.324.18-.552.27-.683.27a.553.553 0 01-.44-.198.742.742 0 01-.171-.503.78.78 0 01.153-.477c.101-.137.266-.272.494-.404.419-.228.91-.41 1.473-.548zm2.697 6.883c.418-.45.628-1.027.628-1.734v-.467h-.323c-.935 0-1.654.042-2.157.125-.503.084-.862.225-1.078.423-.216.198-.324.482-.324.854 0 .43.156.784.468 1.06.311.276.7.413 1.168.413.659 0 1.198-.224 1.617-.674zm6.314-9.494v11.218a.262.262 0 01-.262.262h-1.292a.262.262 0 01-.261-.262V8.835c0-.288.084-.504.251-.647.168-.144.384-.216.647-.216.264 0 .483.072.656.216.174.143.26.359.26.647zm3.916 0v11.218a.262.262 0 01-.262.262H83.98a.262.262 0 01-.261-.262V8.835c0-.288.083-.504.251-.647.168-.144.384-.216.647-.216.264 0 .483.072.656.216.174.143.26.359.26.647zm10.42 3.25c0 .119-.025.233-.072.34l-5.33 11.315a.845.845 0 01-.316.386.79.79 0 01-.44.135.89.89 0 01-.584-.216.671.671 0 01-.26-.54c0-.095.03-.215.09-.358l1.574-3.353-3.469-7.369a.711.711 0 01-.072-.323c0-.228.096-.42.288-.575a1 1 0 01.647-.234c.36 0 .617.168.772.504l2.786 6.182 2.768-6.164a.786.786 0 01.755-.522c.227 0 .428.079.602.234.173.156.26.342.26.557z"
    }), /*#__PURE__*/jsxs("defs", {
      children: [/*#__PURE__*/jsxs("linearGradient", {
        id: "paint0_linear",
        x1: "12.273",
        x2: "20.739",
        y1: "11.576",
        y2: "15.313",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx("stop", {
          stopColor: "#F2B344"
        }), /*#__PURE__*/jsx("stop", {
          offset: "1",
          stopColor: "#F05480"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint1_linear",
        x1: "26.631",
        x2: "26.631",
        y1: "20.482",
        y2: "11.578",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx("stop", {
          stopColor: "#B156CD"
        }), /*#__PURE__*/jsx("stop", {
          offset: "1",
          stopColor: "#F05480"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint2_linear",
        x1: "20.817",
        x2: "11.74",
        y1: "15.429",
        y2: "20.38",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx("stop", {
          stopColor: "#B157CE"
        }), /*#__PURE__*/jsx("stop", {
          offset: "1",
          stopColor: "#5DA5FB"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint3_linear",
        x1: "5.126",
        x2: "13.275",
        y1: "24.357",
        y2: "27.954",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx("stop", {
          stopColor: "#74E6A7"
        }), /*#__PURE__*/jsx("stop", {
          offset: "1",
          stopColor: "#5DA5FB"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint4_linear",
        x1: "3.023",
        x2: "3.023",
        y1: "11.232",
        y2: "20.146",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx("stop", {
          stopColor: "#C8ED5B"
        }), /*#__PURE__*/jsx("stop", {
          offset: "1",
          stopColor: "#74E6A7"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint5_linear",
        x1: "9.4",
        x2: "17.2",
        y1: "15.712",
        y2: "12.195",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx("stop", {
          stopColor: "#C8ED5B"
        }), /*#__PURE__*/jsx("stop", {
          offset: "1",
          stopColor: "#F2B344"
        })]
      })]
    })]
  });
};
var LogoAcademy = function LogoAcademy(_ref8) {
  var className = _ref8.className;
  return /*#__PURE__*/jsxs(StyledSvg, {
    width: "172",
    height: "32",
    viewBox: "0 0 172 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    children: [/*#__PURE__*/jsx(Path, {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M29.9999 15.9999C29.9999 24.2844 23.2842 30.9999 14.9999 30.9999C6.71569 30.9999 -6.10352e-05 24.2844 -6.10352e-05 15.9999C-6.10352e-05 7.71563 6.71569 0.999878 14.9999 0.999878C23.2842 0.999878 29.9999 7.71563 29.9999 15.9999Z",
      fill: "url(#gradient_academy)"
    }), /*#__PURE__*/jsx(Path, {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M26.842 15.9999C26.842 22.5403 21.5401 27.842 14.9999 27.842C8.45974 27.842 3.15784 22.5403 3.15784 15.9999C3.15784 9.45974 8.45974 4.15784 14.9999 4.15784C21.5401 4.15784 26.842 9.45974 26.842 15.9999Z",
      fill: "#000F33"
    }), /*#__PURE__*/jsx(Path, {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M21.1426 17C21.2797 16.3139 21.8843 15.8221 22.5838 15.8221C23.5035 15.8221 24.2111 16.6585 24.0328 17.5611C23.2238 21.6584 19.6108 24.7484 15.2758 24.7484C10.2344 24.7484 6.16902 20.5692 6.35534 15.4859C6.52587 10.8438 10.3147 7.06344 14.9571 6.9012C16.1205 6.86055 17.2359 7.04351 18.2646 7.40982C19.1061 7.70943 19.476 8.69173 19.0228 9.46127L18.9597 9.56844C18.6111 10.1598 17.8937 10.3986 17.2459 10.1722C16.5786 9.9389 15.8576 9.82088 15.1059 9.8416C12.0403 9.92686 9.4931 12.3827 9.30462 15.4435C9.09067 18.9194 11.8463 21.8049 15.2758 21.8049C18.1769 21.8049 20.5957 19.74 21.1426 17ZM15.5141 16.8526C15.5141 15.7919 16.3736 14.9322 17.4343 14.9322C18.4949 14.9322 19.3547 15.7919 19.3547 16.8526C19.3547 17.9132 18.4949 18.773 17.4343 18.773C16.3736 18.773 15.5141 17.9132 15.5141 16.8526Z",
      fill: "white"
    }), /*#__PURE__*/jsx(Path, {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M131.474 17.7537C131.902 17.2086 132.116 16.4341 132.116 15.4289C132.116 14.4238 131.905 13.6482 131.482 13.1031C131.06 12.5581 130.456 12.2861 129.67 12.2861C128.885 12.2861 128.276 12.5559 127.841 13.0946C127.406 13.6333 127.189 14.3994 127.189 15.3928C127.189 16.3852 127.409 17.1629 127.85 17.7261C128.29 18.2892 128.897 18.5707 129.67 18.5707C130.444 18.5707 131.046 18.2987 131.474 17.7537ZM133.652 7.236C133.819 7.39431 133.902 7.60575 133.902 7.87243V19.0977C133.902 19.3772 133.822 19.5939 133.661 19.7522C133.499 19.9084 133.283 19.9881 133.009 19.9881C132.735 19.9881 132.518 19.9084 132.357 19.7522C132.196 19.5939 132.116 19.3772 132.116 19.0977V18.3721C131.855 18.9044 131.474 19.3124 130.974 19.5971C130.474 19.8819 129.897 20.0242 129.242 20.0242C128.493 20.0242 127.823 19.8309 127.234 19.4431C126.645 19.0552 126.187 18.5102 125.859 17.8079C125.533 17.1066 125.369 16.3002 125.369 15.3928C125.369 14.4716 125.533 13.6662 125.859 12.9756C126.187 12.2861 126.643 11.7527 127.225 11.3776C127.808 11.0026 128.48 10.8145 129.242 10.8145C129.897 10.8145 130.471 10.9579 130.965 11.2416C131.458 11.5264 131.837 11.9291 132.099 12.4497V7.83525C132.099 7.58131 132.178 7.37837 132.34 7.2275C132.5 7.07556 132.717 7.00012 132.992 7.00012C133.264 7.00012 133.485 7.07875 133.652 7.236ZM103.016 17.9803C103.433 17.5266 103.642 16.9423 103.642 16.2283V15.7554H103.321C102.392 15.7554 101.678 15.7979 101.179 15.8829C100.679 15.9679 100.321 16.1093 100.107 16.3101C99.8934 16.5088 99.7859 16.7967 99.7859 17.1718C99.7859 17.6084 99.9404 17.9654 100.249 18.2449C100.56 18.5233 100.946 18.6624 101.409 18.6624C102.064 18.6624 102.601 18.4351 103.016 17.9803ZM104.543 11.7041C105.109 12.2981 105.391 13.2001 105.391 14.4114V19.1151C105.391 19.3945 105.313 19.6091 105.159 19.7611C105.003 19.9119 104.79 19.9874 104.517 19.9874C104.255 19.9874 104.046 19.9088 103.891 19.7515C103.737 19.5943 103.66 19.3828 103.66 19.1151V18.4436C103.433 18.9536 103.097 19.3435 102.65 19.6155C102.205 19.8875 101.684 20.0246 101.089 20.0246C100.518 20.0246 99.9968 19.9056 99.5269 19.6708C99.0571 19.4338 98.6854 19.1098 98.4118 18.6975C98.1372 18.2874 98.0004 17.8209 98.0004 17.2993C97.99 16.6458 98.1487 16.1348 98.4828 15.765C98.8159 15.3953 99.3578 15.1286 100.107 14.966C100.857 14.8024 101.898 14.7206 103.23 14.7206H103.642V14.1936C103.642 13.5146 103.505 13.0248 103.23 12.722C102.958 12.4192 102.516 12.2683 101.911 12.2683C101.493 12.2683 101.101 12.3225 100.732 12.4309C100.363 12.5403 99.9581 12.6976 99.5186 12.9037C99.197 13.0854 98.9704 13.1757 98.8399 13.1757C98.6613 13.1757 98.5152 13.1098 98.4035 12.9759C98.2896 12.8431 98.2333 12.6731 98.2333 12.467C98.2333 12.2864 98.2834 12.1249 98.3847 11.9857C98.4849 11.8476 98.6488 11.7116 98.8754 11.5777C99.292 11.3482 99.7796 11.1623 100.339 11.0241C100.899 10.8849 101.44 10.8148 101.964 10.8148C103.119 10.8148 103.977 11.1113 104.543 11.7041ZM109.266 19.4615C108.629 19.0854 108.136 18.5531 107.785 17.8635C107.433 17.1719 107.257 16.3729 107.257 15.4655C107.257 14.5454 107.439 13.7336 107.801 13.0313C108.165 12.329 108.673 11.7829 109.328 11.3961C109.983 11.0083 110.732 10.8149 111.578 10.8149C112.03 10.8149 112.485 10.8819 112.943 11.0147C113.401 11.1475 113.809 11.3292 114.165 11.5597C114.546 11.8254 114.736 12.1345 114.736 12.4862C114.736 12.6924 114.683 12.8645 114.576 13.0037C114.469 13.1429 114.332 13.213 114.165 13.213C114.059 13.213 113.951 13.1843 113.845 13.1312C113.737 13.0759 113.6 12.9952 113.434 12.8857C113.136 12.6924 112.86 12.5436 112.604 12.4405C112.348 12.3375 112.042 12.2865 111.685 12.2865C110.876 12.2865 110.248 12.5649 109.802 13.1216C109.355 13.6784 109.133 14.454 109.133 15.4464C109.133 16.4398 109.353 17.2059 109.792 17.7445C110.232 18.2843 110.858 18.5531 111.667 18.5531C112.024 18.5531 112.339 18.4989 112.614 18.3895C112.886 18.2811 113.166 18.1345 113.452 17.9539C113.583 17.8689 113.713 17.7966 113.845 17.736C113.975 17.6744 114.095 17.6447 114.202 17.6447C114.368 17.6447 114.506 17.7137 114.612 17.8529C114.72 17.9932 114.773 18.1653 114.773 18.3714C114.773 18.5414 114.728 18.6955 114.639 18.8347C114.551 18.9739 114.398 19.1152 114.184 19.2618C113.827 19.504 113.41 19.691 112.934 19.8239C112.458 19.9567 111.976 20.0247 111.488 20.0247C110.644 20.0247 109.902 19.8377 109.266 19.4615ZM121.751 16.2283C121.751 16.9423 121.543 17.5266 121.127 17.9803C120.71 18.4351 120.175 18.6624 119.52 18.6624C119.056 18.6624 118.67 18.5233 118.36 18.2449C118.051 17.9654 117.896 17.6084 117.896 17.1718C117.896 16.7967 118.004 16.5088 118.218 16.3101C118.431 16.1093 118.789 15.9679 119.289 15.8829C119.788 15.7979 120.503 15.7554 121.431 15.7554H121.751V16.2283ZM123.501 14.4114C123.501 13.2001 123.218 12.2981 122.653 11.7041C122.087 11.1113 121.228 10.8148 120.074 10.8148C119.55 10.8148 119.009 10.8849 118.45 11.0241C117.89 11.1623 117.403 11.3482 116.986 11.5777C116.759 11.7116 116.595 11.8476 116.494 11.9857C116.394 12.1249 116.344 12.2864 116.344 12.467C116.344 12.6731 116.4 12.8431 116.513 12.9759C116.626 13.1098 116.772 13.1757 116.95 13.1757C117.081 13.1757 117.308 13.0854 117.629 12.9037C118.069 12.6976 118.473 12.5403 118.842 12.4309C119.212 12.3225 119.604 12.2683 120.021 12.2683C120.627 12.2683 121.067 12.4192 121.341 12.722C121.615 13.0248 121.751 13.5146 121.751 14.1936V14.7206H121.341C120.009 14.7206 118.968 14.8024 118.218 14.966C117.468 15.1286 116.926 15.3953 116.593 15.765C116.259 16.1348 116.099 16.6458 116.111 17.2993C116.111 17.8209 116.248 18.2874 116.521 18.6975C116.795 19.1098 117.168 19.4338 117.637 19.6708C118.107 19.9056 118.628 20.0246 119.199 20.0246C119.795 20.0246 120.316 19.8875 120.76 19.6155C121.207 19.3435 121.543 18.9536 121.77 18.4436V19.1151C121.77 19.3828 121.847 19.5943 122.001 19.7515C122.156 19.9088 122.365 19.9874 122.627 19.9874C122.9 19.9874 123.114 19.9119 123.269 19.7611C123.424 19.6091 123.501 19.3945 123.501 19.1151V14.4114ZM137.637 14.7199C137.721 13.9092 137.97 13.2792 138.387 12.8308C138.802 12.3824 139.356 12.1593 140.047 12.1593C140.726 12.1593 141.252 12.3792 141.627 12.8223C142.001 13.2632 142.206 13.8965 142.242 14.7199H137.637ZM143.723 18.3717C143.723 18.1656 143.671 17.9956 143.564 17.8628C143.456 17.73 143.319 17.6631 143.152 17.6631C143.046 17.6631 142.911 17.7024 142.751 17.781C142.591 17.8596 142.492 17.9117 142.456 17.9351C142.1 18.1295 141.76 18.2867 141.439 18.4079C141.118 18.529 140.737 18.5896 140.297 18.5896C138.643 18.5896 137.755 17.6514 137.637 15.7739H143.152C143.581 15.7739 143.795 15.5317 143.795 15.0472C143.795 13.752 143.456 12.7214 142.777 11.9585C142.1 11.1956 141.177 10.8152 140.01 10.8152C139.201 10.8152 138.479 11.0086 137.843 11.3964C137.205 11.7832 136.711 12.3282 136.361 13.0306C136.009 13.7339 135.834 14.5382 135.834 15.4467C135.834 16.8641 136.233 17.9807 137.03 18.7989C137.827 19.6149 138.916 20.025 140.297 20.025C140.749 20.025 141.222 19.957 141.716 19.8242C142.209 19.6914 142.665 19.5044 143.082 19.2611C143.51 19.0188 143.723 18.7224 143.723 18.3717ZM158.663 14.3929V19.1157C158.663 19.3951 158.579 19.6098 158.413 19.7606C158.246 19.9115 158.027 19.988 157.752 19.988C157.49 19.988 157.275 19.9115 157.109 19.7606C156.943 19.6098 156.859 19.3951 156.859 19.1157V14.412C156.859 13.6725 156.728 13.136 156.467 12.8034C156.205 12.4698 155.794 12.304 155.235 12.304C154.58 12.304 154.063 12.5314 153.681 12.9861C153.301 13.4398 153.111 14.0603 153.111 14.8476V19.1157C153.111 19.3951 153.029 19.6098 152.861 19.7606C152.693 19.9115 152.474 19.988 152.202 19.988C151.938 19.988 151.724 19.9115 151.557 19.7606C151.391 19.6098 151.308 19.3951 151.308 19.1157V14.412C151.308 13.6725 151.177 13.136 150.916 12.8034C150.653 12.4698 150.243 12.304 149.683 12.304C149.029 12.304 148.508 12.5314 148.121 12.9861C147.735 13.4398 147.542 14.0603 147.542 14.8476V19.1157C147.542 19.3951 147.458 19.6098 147.291 19.7606C147.125 19.9115 146.91 19.988 146.649 19.988C146.387 19.988 146.17 19.9115 145.999 19.7606C145.825 19.6098 145.739 19.3951 145.739 19.1157V11.7228C145.739 11.4561 145.827 11.2447 146.007 11.0864C146.184 10.9302 146.398 10.8516 146.649 10.8516C146.899 10.8516 147.104 10.927 147.264 11.0779C147.426 11.2298 147.505 11.4381 147.505 11.7048V12.3773C147.767 11.8684 148.131 11.4806 148.594 11.215C149.059 10.9472 149.594 10.8144 150.201 10.8144C150.867 10.8144 151.417 10.9536 151.853 11.232C152.287 11.5114 152.612 11.9406 152.826 12.5229C153.087 12.0012 153.473 11.5858 153.986 11.2776C154.497 10.9695 155.08 10.8144 155.735 10.8144C157.686 10.8144 158.663 12.0065 158.663 14.3929ZM167.862 10.8683C167.708 10.8683 167.563 10.9108 167.426 10.9958C167.288 11.0808 167.185 11.2147 167.114 11.3963L164.365 17.6268L161.598 11.3772C161.443 11.0393 161.187 10.8683 160.83 10.8683C160.592 10.8683 160.378 10.948 160.188 11.1052C159.997 11.2625 159.902 11.4569 159.902 11.6864C159.902 11.8086 159.925 11.917 159.973 12.0137L163.419 19.4618L162.187 22.1308C162.127 22.2774 162.098 22.3975 162.098 22.4952C162.098 22.713 162.183 22.8937 162.357 23.0392C162.529 23.1848 162.722 23.2581 162.936 23.2581C163.092 23.2581 163.236 23.2124 163.374 23.1221C163.51 23.0307 163.614 22.9 163.686 22.73L168.648 12.0137C168.696 11.9042 168.72 11.7895 168.72 11.6683C168.72 11.4505 168.634 11.2625 168.462 11.1052C168.288 10.948 168.089 10.8683 167.862 10.8683Z",
      fill: "#F969D7"
    }), /*#__PURE__*/jsx(Path, {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M43.0962 11.1132C43.2577 10.9561 43.476 10.877 43.7513 10.877C44.0264 10.877 44.2448 10.9586 44.4061 11.1221C44.5678 11.2854 44.6484 11.5009 44.6484 11.7667V19.2136C44.6484 20.5693 44.2925 21.5931 43.5808 22.2829C42.8688 22.9732 41.8194 23.3185 40.4319 23.3185C39.14 23.3185 38.0632 23.0703 37.2022 22.5735L37.1993 22.572C37.0559 22.4891 37 22.3081 37.0666 22.1549L37.4042 21.3811C37.48 21.2072 37.6861 21.1327 37.8523 21.222C37.8537 21.2228 37.8552 21.2236 37.8566 21.2244C37.8597 21.226 37.8628 21.2277 37.8661 21.2293C38.2966 21.4354 38.697 21.5955 39.0681 21.7106C39.4386 21.826 39.8814 21.8838 40.3959 21.8838C42.0467 21.8838 42.8719 21.042 42.8719 19.3585V17.9601C42.6208 18.4935 42.2378 18.9078 41.7235 19.2041C41.2092 19.5013 40.6112 19.6496 39.9295 19.6496C39.1637 19.6496 38.4819 19.4676 37.8838 19.1046C37.2856 18.7413 36.8221 18.2267 36.4933 17.561C36.164 16.8952 36 16.1264 36 15.254C36 14.3824 36.1671 13.6134 36.5022 12.9477C36.8371 12.2818 37.3007 11.7643 37.8926 11.3944C38.4848 11.0259 39.1637 10.8407 39.9295 10.8407C40.5993 10.8407 41.1882 10.9858 41.6968 11.2765C42.2051 11.5673 42.5908 11.9791 42.854 12.5119V11.7492C42.854 11.4824 42.9349 11.271 43.0962 11.1132ZM40.3598 18.1965C41.1375 18.1965 41.7475 17.936 42.1903 17.4154C42.6327 16.8952 42.854 16.1745 42.854 15.254C42.854 14.3463 42.6356 13.6286 42.199 13.1023C41.7623 12.575 41.1496 12.3115 40.3598 12.3115C39.5705 12.3115 38.9516 12.5724 38.5029 13.0926C38.0545 13.6134 37.8298 14.3343 37.8298 15.254C37.8298 16.1745 38.057 16.8952 38.5119 17.4154C38.9662 17.936 39.5822 18.1965 40.3598 18.1965ZM53.1425 11.9848C53.8244 12.7479 54.1653 13.7769 54.1653 15.0728C54.1653 15.5567 53.95 15.7989 53.5193 15.7989H47.9748C48.0944 17.6763 48.9857 18.6143 50.6486 18.6143C51.0908 18.6143 51.4738 18.5536 51.7968 18.4325C52.1198 18.3117 52.4609 18.1539 52.8195 17.9603C52.8554 17.936 52.9543 17.8847 53.1156 17.8061C53.2771 17.7276 53.4119 17.6877 53.5193 17.6877C53.6868 17.6877 53.8244 17.755 53.9319 17.8879C54.0396 18.0208 54.0936 18.1908 54.0936 18.3966C54.0936 18.7474 53.8781 19.044 53.4476 19.286C53.0286 19.5285 52.5711 19.7161 52.0748 19.8492C51.5784 19.9821 51.1029 20.0491 50.6486 20.0491C49.2607 20.0491 48.1661 19.6407 47.3648 18.823C46.5632 18.0056 46.1627 16.8889 46.1627 15.4721C46.1627 14.5642 46.3392 13.7591 46.692 13.0567C47.0446 12.3547 47.5411 11.8091 48.1813 11.4222C48.821 11.0347 49.5479 10.8407 50.3612 10.8407C51.5334 10.8407 52.4609 11.2221 53.1425 11.9848ZM48.7287 12.857C48.3097 13.3048 48.0586 13.9347 47.9748 14.6207H52.6043C52.5682 13.9224 52.3621 13.2896 51.9852 12.8475C51.6084 12.4062 51.0791 12.1852 50.3973 12.1852C49.7033 12.1852 49.1472 12.409 48.7287 12.857ZM64.054 14.4185V19.7762C64.054 19.9067 63.9496 20.0124 63.8207 20.0124H62.4755C62.3465 20.0124 62.2419 19.9067 62.2419 19.7762V14.5098C62.2419 13.7591 62.0952 13.208 61.8022 12.857C61.509 12.5056 61.0514 12.3299 60.4296 12.3299C59.7 12.3299 59.1137 12.56 58.6712 13.0204C58.2284 13.4803 58.0071 14.0979 58.0071 14.8725V19.7762C58.0071 19.9067 57.9027 20.0124 57.7738 20.0124H56.4286C56.2996 20.0124 56.195 19.9067 56.195 19.7762V11.7492C56.195 11.4946 56.2817 11.2856 56.4553 11.1221C56.6287 10.9586 56.8468 10.8768 57.11 10.8768C57.3732 10.8768 57.5828 10.9561 57.7383 11.113C57.8934 11.271 57.9715 11.4768 57.9715 11.7308V12.1256C57.9715 12.2234 58.0954 12.2615 58.1503 12.1812C58.4176 11.7912 58.7585 11.4831 59.1737 11.2582C59.6878 10.9801 60.2681 10.8407 60.9141 10.8407C63.0073 10.8407 64.054 12.0337 64.054 14.4185ZM67.3292 9.12631C67.9092 9.12631 68.3794 8.65029 68.3794 8.06305C68.3794 7.47602 67.9092 7 67.3292 7C66.7491 7 66.279 7.47602 66.279 8.06305C66.279 8.65029 66.7491 9.12631 67.3292 9.12631ZM68.2353 11.7666C68.2353 11.4768 68.1517 11.2557 67.984 11.1043C67.8164 10.9528 67.601 10.8767 67.338 10.8767C67.0748 10.8767 66.8564 10.9528 66.6834 11.1043C66.5097 11.2557 66.4232 11.4768 66.4232 11.7666V19.8104C66.4232 19.9218 66.5124 20.0124 66.6226 20.0124H68.0356C68.1459 20.0124 68.2353 19.9218 68.2353 19.8104V11.7666ZM72.6913 11.0499C73.2536 10.9105 73.7977 10.8407 74.3242 10.8407C75.4843 10.8407 76.3487 11.1379 76.917 11.7306C77.485 12.3244 77.7694 13.2263 77.7694 14.4371V19.7395C77.7694 19.8902 77.6487 20.0126 77.4996 20.0126H76.2984C76.1494 20.0126 76.0286 19.8902 76.0286 19.7395V18.4688C75.8013 18.9774 75.4635 19.3682 75.015 19.6407C74.5664 19.913 74.0431 20.0491 73.445 20.0491C72.8709 20.0491 72.3442 19.9308 71.8659 19.6953C71.3875 19.4587 71.0138 19.1288 70.7444 18.7051C70.4754 18.2813 70.3409 17.8094 70.3409 17.2886C70.3409 16.647 70.5052 16.1414 70.8342 15.7716C71.1632 15.4029 71.7073 15.1395 72.4671 14.9815C73.2265 14.8243 74.2705 14.7453 75.5981 14.7453H76.0109V14.2188C76.0109 13.5412 75.873 13.0508 75.5981 12.7481C75.3228 12.4452 74.8806 12.2938 74.2705 12.2938C73.8514 12.2938 73.4567 12.3484 73.086 12.4573C72.7151 12.5663 72.3085 12.7235 71.8659 12.9291C71.5431 13.111 71.3156 13.2017 71.1843 13.2017C71.0047 13.2017 70.858 13.1358 70.7444 13.0021C70.6306 12.869 70.5739 12.6992 70.5739 12.4934C70.5739 12.3115 70.625 12.1514 70.7267 12.012C70.8282 11.8734 70.9928 11.7371 71.2201 11.6034C71.6386 11.3733 72.1291 11.1893 72.6913 11.0499ZM75.383 18.0056C75.8013 17.5515 76.0109 16.9676 76.0109 16.2528V15.7811H75.6879C74.7547 15.7811 74.0371 15.8235 73.5346 15.9077C73.0322 15.9927 72.6736 16.1353 72.4581 16.3348C72.2429 16.5348 72.1351 16.8225 72.1351 17.1975C72.1351 17.6331 72.2906 17.9905 72.6017 18.2691C72.9126 18.5479 73.3015 18.6865 73.768 18.6865C74.4257 18.6865 74.964 18.46 75.383 18.0056ZM81.6873 8.4105V19.748C81.6873 19.8939 81.5702 20.0124 81.4259 20.0124H80.1364C79.9919 20.0124 79.875 19.8939 79.875 19.748V8.4105C79.875 8.11945 79.9589 7.90175 80.1263 7.75682C80.294 7.61109 80.5093 7.53872 80.7721 7.53872C81.0355 7.53872 81.2538 7.61109 81.427 7.75682C81.6008 7.90175 81.6873 8.11945 81.6873 8.4105ZM85.5969 8.4105V19.748C85.5969 19.8939 85.4799 20.0124 85.3357 20.0124H84.0461C83.9015 20.0124 83.7846 19.8939 83.7846 19.748V8.4105C83.7846 8.11945 83.8684 7.90175 84.0359 7.75682C84.2035 7.61109 84.4189 7.53872 84.6815 7.53872C84.9451 7.53872 85.1635 7.61109 85.3367 7.75682C85.5102 7.90175 85.5969 8.11945 85.5969 8.4105ZM96 11.6945C96 11.8156 95.9758 11.9304 95.9283 12.0392L90.6063 23.4737C90.5344 23.6427 90.4296 23.7732 90.2923 23.8637C90.1545 23.955 90.0078 24 89.8526 24C89.6373 24 89.4427 23.9278 89.2695 23.7821C89.0959 23.6372 89.0092 23.4552 89.0092 23.2373C89.0092 23.1404 89.039 23.0194 89.0989 22.8744L90.6708 19.4861L87.2078 12.0392C87.1601 11.943 87.1361 11.8339 87.1361 11.7123C87.1361 11.4823 87.2316 11.2887 87.4229 11.1315C87.6144 10.9744 87.8297 10.8953 88.0691 10.8953C88.4281 10.8953 88.6851 11.0651 88.8405 11.4039L91.6218 17.6514L94.385 11.4222C94.4569 11.2406 94.5615 11.1075 94.6991 11.0225C94.8364 10.9375 94.9831 10.8953 95.1387 10.8953C95.3659 10.8953 95.566 10.9744 95.7397 11.1315C95.9131 11.2887 96 11.4768 96 11.6945Z",
      fill: theme.colors.black
    }), /*#__PURE__*/jsx("defs", {
      children: /*#__PURE__*/jsxs("linearGradient", {
        id: "gradient_academy",
        x1: "14.7842",
        y1: "-5.69172",
        x2: "-6.59237",
        y2: "15.3434",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx("stop", {
          stopColor: "#F2399D"
        }), /*#__PURE__*/jsx("stop", {
          offset: "1",
          stopColor: "#EA5FE5"
        })]
      })
    })]
  });
};

var logos = {
  black: LogoBlackText,
  white: LogoWhiteText,
  academy: LogoAcademy
};

var _excluded$q = ["color"];
var Logo = function Logo(_ref) {
  var color = _ref.color,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$q);

  var LogoToRender = logos[color];
  return /*#__PURE__*/jsx(LogoToRender, _extends$2({}, rest));
};

var _excluded$p = ["onChange", "checked", "label", "textVariant"];
var ClickArea = styled(Flex).withConfig({
  displayName: "RadioButton__ClickArea",
  componentId: "sc-73aiiq-0"
})(["cursor:pointer;width:", ";height:", ";"], rem(16), rem(16));
var RadioBox = styled(Flex).withConfig({
  displayName: "RadioButton__RadioBox",
  componentId: "sc-73aiiq-1"
})(["width:", ";height:", ";border:", " solid ", ";border-radius:50%;background:", ";"], rem(16), rem(16), rem(2), theme.colors.coal, theme.colors.white);
var Background = styled.div.withConfig({
  displayName: "RadioButton__Background",
  componentId: "sc-73aiiq-2"
})(["position:absolute;width:", ";height:", ";z-index:-1;border-radius:50%;background:", ";transform:scale(0);transition:transform 0.15s ", ",opacity 0.15s ", ";", ":hover &{transform:scale(1);}", ":active &{transform:scale(0.5);transition:transform 0.1s ", ",opacity 0.1s ", ";}"], rem(32), rem(32), theme.colors.primary10, theme.transitions.easeInOut, theme.transitions.easeInOut,
/*sc-selector*/
ClickArea,
/*sc-selector*/
ClickArea, theme.transitions.easeInOut, theme.transitions.easeInOut);
var Checkmark = styled.div.withConfig({
  displayName: "RadioButton__Checkmark",
  componentId: "sc-73aiiq-3"
})(["width:", ";height:", ";border-radius:50%;background:", ";transition:transform 0.2s ", ",opacity 0.2s ", ",background 0.15s ", ";", ""], rem(8), rem(8), theme.colors.rAkihabara, theme.transitions.easeInOut, theme.transitions.easeInOut, theme.transitions.easeInOut, function (_ref) {
  var checked = _ref.checked;
  return checked ? "\n            transform: scale(1);\n            opacity: 1;\n            \n            " + ClickArea + ":hover & {\n                background: " + theme.colors.rAkihabaraDark + ";\n            }\n        " : "\n            transform: scale(0);\n            opacity: 0;   \n      ";
});
var RadioInput = styled.input.withConfig({
  displayName: "RadioButton__RadioInput",
  componentId: "sc-73aiiq-4"
})(["position:absolute;cursor:pointer;opacity:0;height:0;width:0;margin:0;"]);
var RadioButton = function RadioButton(_ref2) {
  var _props$value;

  var _onChange = _ref2.onChange,
      checked = _ref2.checked,
      label = _ref2.label,
      _ref2$textVariant = _ref2.textVariant,
      textVariant = _ref2$textVariant === void 0 ? 'paragraphL' : _ref2$textVariant,
      props = _objectWithoutPropertiesLoose$2(_ref2, _excluded$p);

  return /*#__PURE__*/jsxs(Flex, {
    alignItems: {
      mobile: 'center'
    },
    children: [/*#__PURE__*/jsxs(ClickArea, {
      justifyContent: {
        mobile: 'center'
      },
      alignItems: {
        mobile: 'center'
      },
      onClick: function onClick() {
        return _onChange(!checked);
      },
      marginRight: "xmini",
      children: [/*#__PURE__*/jsx(RadioInput, _extends$2({
        type: "radio",
        value: ((_props$value = props.value) != null ? _props$value : checked) ? 1 : 0,
        checked: checked,
        onChange: function onChange() {
          return _onChange(!checked);
        },
        textVariant: "paragraphL"
      }, props)), /*#__PURE__*/jsxs(RadioBox, {
        justifyContent: {
          mobile: 'center'
        },
        alignItems: {
          mobile: 'center'
        },
        children: [/*#__PURE__*/jsx(Background, {}), /*#__PURE__*/jsx(Checkmark, {
          checked: checked
        })]
      })]
    }), /*#__PURE__*/jsx(Text, {
      as: "label",
      variant: textVariant,
      $color: "rOnyx",
      children: label
    })]
  });
};

var SwitchSlider = styled.div.withConfig({
  displayName: "Switchstyles__SwitchSlider",
  componentId: "sc-10m4ill-0"
})(["position:absolute;left:", ";top:", ";width:", ";height:", ";background:", ";border-radius:", ";"], rem(1), rem(6), rem(30), rem(4), theme.colors.cement, rem(4));
var SwitchHandle = styled.div.withConfig({
  displayName: "Switchstyles__SwitchHandle",
  componentId: "sc-10m4ill-1"
})(["position:absolute;top:0;bottom:0;left:0;width:", ";background:", ";border-radius:", ";box-shadow:", ";transition:all 0.3s ", ";", ""], rem(16), function (_ref) {
  var status = _ref.status;
  return status ? theme.colors.primary : theme.colors.white;
}, rem(16), theme.shadows.shortDarker, theme.transitions.easeOut, function (_ref2) {
  var status = _ref2.status;
  return status && "                      \n      right: 0;        \n      transform: translateX(" + rem(16) + ");\n    ";
});
var SwitchHandleHover = styled.div.withConfig({
  displayName: "Switchstyles__SwitchHandleHover",
  componentId: "sc-10m4ill-2"
})(["position:absolute;top:-50%;bottom:-50%;right:25%;left:", ";width:", ";background:", ";border-radius:50%;z-index:-2;opacity:0;transform:scale(0);transition:all 0.2s ", ";"], function (_ref3) {
  var status = _ref3.status;
  return status ? '25%' : '-25%';
}, rem(32), theme.colors.primary10, theme.transitions.easeInOut);
var SwitchArea = styled(Flex).withConfig({
  displayName: "Switchstyles__SwitchArea",
  componentId: "sc-10m4ill-3"
})(["position:relative;width:", ";height:", ";cursor:pointer;&:hover ", "{background:", ";}&:active ", "{background:", ";width:", ";transform:translateX(0px);}&:hover ", "{transform:scale(1);opacity:1;}&:active ", "{transform:scale(0);opacity:0;}"], rem(32), rem(16),
/*sc-selector*/
SwitchHandle, function (_ref4) {
  var status = _ref4.status;
  return status ? theme.colors.primaryHover : theme.colors.white;
},
/*sc-selector*/
SwitchHandle, function (_ref5) {
  var status = _ref5.status;
  return status ? theme.colors.white : theme.colors.primaryHover;
}, rem(32),
/*sc-selector*/
SwitchHandleHover,
/*sc-selector*/
SwitchHandleHover);

var _excluded$o = ["onChange"];
var Switch = function Switch(_ref) {
  var onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$o);

  return /*#__PURE__*/jsxs(SwitchArea, _extends$2({
    role: "switch",
    onClick: function onClick() {
      return onChange(!props.status);
    }
  }, props, {
    children: [/*#__PURE__*/jsx(SwitchSlider, {}), /*#__PURE__*/jsx(SwitchHandleHover, {
      status: props.status
    }), /*#__PURE__*/jsx(SwitchHandle, {
      status: props.status
    })]
  }));
};

var positionBySize = {
  big: "\n    top: " + rem(56) + ";\n  ",
  medium: "\n    top: " + rem(48) + ";\n  ",
  small: "\n    top: " + rem(40) + ";\n  "
};
var DropDownContainer = styled.div.withConfig({
  displayName: "DisplayInputDesktopstyles__DropDownContainer",
  componentId: "sc-12c8bj8-0"
})(["appearance:none;position:relative;display:flex;align-items:center;", " min-width:", ";width:100%;background:", ";border:", " solid ", ";border-radius:", ";outline:none;", ";color:", ";cursor:pointer;&::placeholder{color:", ";}&:focus{border:", " solid ", ";}", " ", ""], function (_ref) {
  var isPlaceholderCentered = _ref.isPlaceholderCentered;
  return isPlaceholderCentered && "justify-content: center;";
}, rem(136), theme.colors.white, rem(1), theme.colors.rBlack, rem(theme.sizes.large), textCssFactory(textVariants.paragraphS), function (_ref2) {
  var isPlaceholder = _ref2.isPlaceholder;
  return isPlaceholder ? theme.colors.rBlack : theme.colors.rBlack;
}, theme.colors.rBlack, rem(1), theme.colors.rAkihabara, function (_ref3) {
  var status = _ref3.status;
  return statusStyles[status];
}, function (_ref4) {
  var size = _ref4.size;
  return sizeStyles[size];
});
var DropDownHeader$1 = styled.div.withConfig({
  displayName: "DisplayInputDesktopstyles__DropDownHeader",
  componentId: "sc-12c8bj8-1"
})(["display:flex;align-items:center;user-select:none;", ";"], textCssFactory(textVariants.paragraphS));
var DropDownList = styled.div.withConfig({
  displayName: "DisplayInputDesktopstyles__DropDownList",
  componentId: "sc-12c8bj8-2"
})(["position:absolute;left:0;", " padding:", ";width:100%;overflow-y:hidden;overflow-x:hidden;background:", ";border:none;border-radius:", ";box-shadow:", ";z-index:10;animation:", " 0.2s ", ";animation-fill-mode:both;"], function (_ref5) {
  var size = _ref5.size;
  return positionBySize[size];
}, rem(theme.sizes.xmini), theme.colors.white, rem(8), theme.shadows.modal, theme.animations.fadeInDown, theme.transitions.easeInOut);
var DropDownListInner = styled.div.withConfig({
  displayName: "DisplayInputDesktopstyles__DropDownListInner",
  componentId: "sc-12c8bj8-3"
})(["overflow-y:auto;overflow-x:hidden;width:100%;max-height:", ";"], rem(128));
var DropDownListItem = styled.div.withConfig({
  displayName: "DisplayInputDesktopstyles__DropDownListItem",
  componentId: "sc-12c8bj8-4"
})(["display:flex;align-items:center;padding:", " ", ";border-radius:", ";color:", ";&:hover{background-color:", ";}"], rem(6), rem(theme.sizes.xmini), rem(4), theme.colors.rBlack, theme.colors.rSilver);

var iconVariants = {
  error: {
    name: 'WarningBasic',
    color: "" + theme.colors.danger,
    secondaryColor: "" + theme.colors.white
  },
  success: {
    name: 'Success',
    color: "" + theme.colors.primary
  }
};
var iconBySize = {
  big: "\n    top: " + rem(16) + ";\n    right: " + rem(16) + ";\n  ",
  medium: "\n    top: " + rem(12) + ";\n    right: " + rem(12) + ";\n  ",
  small: "\n    top: " + rem(8) + ";\n    right: " + rem(8) + ";\n  "
};
var InputIcon = styled(Icon).withConfig({
  displayName: "InputIcon",
  componentId: "sc-8l75c4-0"
})(["position:absolute;", ";", ";", ";"], function (_ref) {
  var size = _ref.size;
  return iconBySize[size];
}, function (_ref2) {
  var isClickable = _ref2.isClickable;
  return isClickable && "cursor: pointer";
}, function (_ref3) {
  var status = _ref3.status;
  return status == 'disabled' && "cursor: not-allowed";
});

var _excluded$n = ["options", "onSelectOption", "value", "dataCy", "placeholderIsLabel"];

var _StyledText$i = styled(Text).withConfig({
  displayName: "DisplayInputDesktop___StyledText",
  componentId: "sc-1rt1fa1-0"
})(["white-space:nowrap;"]);

var DisplayInputDesktop = function DisplayInputDesktop(_ref) {
  var _rest$disabled;

  var options = _ref.options,
      onSelectOption = _ref.onSelectOption,
      value = _ref.value,
      dataCy = _ref.dataCy,
      placeholderIsLabel = _ref.placeholderIsLabel,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$n);

  var ref = useRef(null);

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = useState(''),
      selectedOption = _useState2[0],
      setSelectedOption = _useState2[1];

  useOnClickOutside(ref, function () {
    return setIsOpen(false);
  });
  var isDisabled = (_rest$disabled = rest.disabled) != null ? _rest$disabled : false;

  var handleClick = function handleClick() {
    return !isDisabled && setIsOpen(function (prevIsOpen) {
      return !prevIsOpen;
    });
  };

  return /*#__PURE__*/jsxs(DropDownContainer, _extends$2({
    ref: ref,
    onClick: handleClick
  }, rest, {
    isPlaceholder: !selectedOption && !placeholderIsLabel,
    "data-cy": dataCy,
    role: "listbox",
    children: [/*#__PURE__*/jsx(DropDownHeader$1, _extends$2({}, rest, {
      children: selectedOption ? selectedOption : value || rest.placeholder
    })), isOpen && /*#__PURE__*/jsx(DropDownList, {
      role: "list",
      size: rest.size,
      children: /*#__PURE__*/jsx(DropDownListInner, {
        children: options === null || options === void 0 ? void 0 : options.map(function (element) {
          return /*#__PURE__*/jsxs(DropDownListItem, _extends$2({
            role: "listitem",
            onClick: function onClick() {
              if (onSelectOption) {
                onSelectOption(element);
              }

              setSelectedOption(element.value);
            }
          }, rest, {
            "data-cy": element.dataCy,
            children: [element.icon && /*#__PURE__*/jsx(Icon, {
              name: element.icon.name,
              isInColor: element.icon.isInColor
            }), /*#__PURE__*/jsx(_StyledText$i, {
              variant: "paragraphS",
              marginLeft: element.icon && 'mini',
              children: element.label || element.value
            })]
          }), element.value);
        })
      })
    }), /*#__PURE__*/jsx(InputIcon, {
      size: rest.size,
      name: isOpen ? 'DisplayUp' : 'DisplayDown',
      color: getIconColor(rest.status)
    })]
  }));
};

var StyledSelect = styled.select.withConfig({
  displayName: "DisplayInputMobilestyles__StyledSelect",
  componentId: "sc-2e31vl-0"
})(["appearance:none;", " min-width:", ";width:100%;background:", ";border:", " solid ", ";border-radius:", ";outline:none;", ";color:", ";cursor:pointer;&::placeholder{color:", ";}&:focus{border:", " solid ", ";}", " ", ""], function (_ref) {
  var isPlaceholderCentered = _ref.isPlaceholderCentered;
  return isPlaceholderCentered && "text-align: center;";
}, rem(136), theme.colors.white, rem(1), theme.colors.rBlack, rem(theme.sizes.large), textCssFactory(textVariants.paragraphS), function (_ref2) {
  var isPlaceholder = _ref2.isPlaceholder;
  return isPlaceholder ? theme.colors.cement : theme.colors.rBlack;
}, theme.colors.rBlack, rem(1), theme.colors.rAkihabara, function (_ref3) {
  var status = _ref3.status;
  return statusStyles[status];
}, function (_ref4) {
  var size = _ref4.size;
  return sizeStyles[size];
});
var SelectIcon = styled(InputIcon).withConfig({
  displayName: "DisplayInputMobilestyles__SelectIcon",
  componentId: "sc-2e31vl-1"
})(["pointer-events:none;cursor:pointer;"]);
var Wrapper$2 = styled.div.withConfig({
  displayName: "DisplayInputMobilestyles__Wrapper",
  componentId: "sc-2e31vl-2"
})(["position:relative;", "{position:absolute;}"], SelectIcon);

var _excluded$m = ["options", "onSelectOption", "value", "dataCy"];
var DisplayInputMobile = function DisplayInputMobile(_ref) {
  var options = _ref.options,
      onSelectOption = _ref.onSelectOption,
      value = _ref.value,
      dataCy = _ref.dataCy,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$m);

  var handleOnChange = useCallback(function (event) {
    var selectedOption = options === null || options === void 0 ? void 0 : options.find(function (option) {
      return option.value === event.target.value;
    });

    if (selectedOption) {
      onSelectOption === null || onSelectOption === void 0 ? void 0 : onSelectOption(selectedOption);
    }
  }, [options, onSelectOption]);
  return /*#__PURE__*/jsxs(Wrapper$2, {
    children: [/*#__PURE__*/jsxs(StyledSelect, _extends$2({
      "data-cy": dataCy
    }, rest, {
      onChange: handleOnChange,
      defaultValue: value ? value : rest.placeholder,
      children: [rest.placeholder && /*#__PURE__*/jsx("option", {
        value: rest.placeholder,
        disabled: true,
        children: rest.placeholder
      }), options === null || options === void 0 ? void 0 : options.map(function (element) {
        return /*#__PURE__*/jsx("option", {
          "data-cy": element.dataCy,
          value: element.value,
          children: element.label || element.value
        }, element.value);
      })]
    })), /*#__PURE__*/jsx(SelectIcon, {
      size: rest.size,
      name: "DisplayDown",
      color: getIconColor(rest.status)
    })]
  });
};

var _excluded$l = ["errorMessage"];
var isMobileAndroidOrIphone = function isMobileAndroidOrIphone(userAgent) {
  var md = new MobileDetect(userAgent);
  var isAndroidMobile = md && md.mobile() && md.is('AndroidOS');
  var isIphone = md && md.is('iPhone');
  return isAndroidMobile || isIphone;
};
var getIconColor = function getIconColor(status) {
  switch (status) {
    case 'disabled':
      return theme.colors.cloud;

    case 'success':
      return theme.colors.rAkihabara;

    case 'error':
      return theme.colors.danger;

    default:
      return theme.colors.rOnyx;
  }
};
var DisplayInput = function DisplayInput(_ref) {
  var errorMessage = _ref.errorMessage,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$l);

  var _useState = useState(undefined),
      isMobile = _useState[0],
      setIsMobile = _useState[1];

  useEffect(function () {
    setIsMobile(isMobileAndroidOrIphone(window.navigator.userAgent));
  }, []);
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [isMobile === false && /*#__PURE__*/jsx(DisplayInputDesktop, _extends$2({}, rest)), isMobile === true && /*#__PURE__*/jsx(DisplayInputMobile, _extends$2({}, rest)), errorMessage && /*#__PURE__*/jsx(Label, {
      children: errorMessage
    })]
  });
};

var _excluded$k = ["errorMessage", "dataCy"],
    _excluded2$1 = ["errorMessage", "hasParentIcon", "size", "dataCy"],
    _excluded3 = ["errorMessage", "hasParentIcon", "dataCy"],
    _excluded4 = ["errorMessage", "hasParentIcon", "dataCy"];
var InputStyles = css(["display:flex;align-items:center;min-width:", ";width:100%;border:", " solid ", ";border-radius:", ";", ";color:", ";outline:none;&::placeholder{color:rgb(57,54,69,0.5);}&:focus{border:", " solid ", ";}", " ", ""], rem(220), rem(1), theme.colors.rLavender, rem(8), textCssFactory(textVariants.paragraphS), theme.colors.rGranite, rem(1), theme.colors.rAkihabara, function (_ref) {
  var status = _ref.status;
  return statusStyles[status];
}, function (_ref2) {
  var size = _ref2.size;
  return sizeStyles[size];
});
var statusStyles = {
  "default": "\n      &:hover {\n        border: " + rem(1) + " solid " + theme.colors.coal + ";\n      }\n      &:active {\n        border: " + rem(1) + " solid " + theme.colors.rAkihabara + ";\n      }\n  ",
  error: "\n        color: " + theme.colors.danger + ";\n        border: " + rem(1) + " solid " + theme.colors.danger + ";\n\n        &:hover,\n        &:active,\n        &:focus {\n          border: " + rem(1) + " solid " + theme.colors.danger + ";\n        }\n\n        &::placeholder {\n          color: " + theme.colors.danger + ";\n        }\n  ",
  success: "\n        color: " + theme.colors.rAkihabara + ";\n        border: " + rem(1) + " solid " + theme.colors.rAkihabara + ";\n        &::placeholder {\n          color: " + theme.colors.rAkihabara + ";\n        }\n  ",
  disabled: "\n      color: " + theme.colors.cloud + ";\n      border: " + rem(1) + " solid " + theme.colors.cloud + ";\n      cursor: not-allowed;\n      &::placeholder {\n        color: " + theme.colors.cloud + ";\n      }\n  "
};
var sizeStyles = {
  big: "\n    height: " + rem(theme.sizes.huge) + ";\n    padding: " + rem(theme.sizes.mini) + " " + rem(theme.sizes.small) + ";\n  ",
  medium: "\n    height: " + rem(theme.sizes.xlarge) + ";\n    padding: " + rem(theme.sizes.xmini) + " " + rem(theme.sizes.mini) + ";\n  ",
  small: "\n    height: " + rem(theme.sizes.large) + ";\n    padding: " + rem(theme.sizes.tiny) + " " + rem(theme.sizes.xmini) + ";\n  "
};

var _StyledInput = styled("input").withConfig({
  displayName: "Inputvariants___StyledInput",
  componentId: "wycezz-0"
})(["", ""], InputStyles);

var BaseInput = function BaseInput(_ref3) {
  var errorMessage = _ref3.errorMessage,
      dataCy = _ref3.dataCy,
      rest = _objectWithoutPropertiesLoose$2(_ref3, _excluded$k);

  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(_StyledInput, _extends$2({}, rest, {
      "data-cy": dataCy
    })), errorMessage && /*#__PURE__*/jsx(Label, {
      children: errorMessage
    })]
  });
};

var _StyledInput2 = styled("input").withConfig({
  displayName: "Inputvariants___StyledInput2",
  componentId: "wycezz-1"
})(["", ""], InputStyles);

var UrlInput = function UrlInput(_ref4) {
  var errorMessage = _ref4.errorMessage,
      hasParentIcon = _ref4.hasParentIcon,
      size = _ref4.size,
      dataCy = _ref4.dataCy,
      rest = _objectWithoutPropertiesLoose$2(_ref4, _excluded2$1);

  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(_StyledInput2, _extends$2({
      //@ts-ignore
      size: size
    }, rest, {
      "data-cy": dataCy
    })), !hasParentIcon && /*#__PURE__*/jsx(InputIcon, {
      size: size,
      name: "DisplayRight",
      color: theme.colors.coal,
      isClickable: true
    }), errorMessage && /*#__PURE__*/jsx(Label, {
      children: errorMessage
    })]
  });
};

var _StyledInput3 = styled("input").withConfig({
  displayName: "Inputvariants___StyledInput3",
  componentId: "wycezz-2"
})(["", ""], InputStyles);

var SearchInput = function SearchInput(_ref5) {
  var errorMessage = _ref5.errorMessage,
      hasParentIcon = _ref5.hasParentIcon,
      dataCy = _ref5.dataCy,
      rest = _objectWithoutPropertiesLoose$2(_ref5, _excluded3);

  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(_StyledInput3, _extends$2({}, rest, {
      "data-cy": dataCy
    })), !hasParentIcon && /*#__PURE__*/jsx(InputIcon, {
      size: rest.size,
      name: "Search",
      color: theme.colors.coal
    }), errorMessage && /*#__PURE__*/jsx(Label, {
      children: errorMessage
    })]
  });
};

var _StyledDiv$a = styled("div").withConfig({
  displayName: "Inputvariants___StyledDiv",
  componentId: "wycezz-3"
})(["position:relative;"]);

var _StyledInput4 = styled("input").withConfig({
  displayName: "Inputvariants___StyledInput4",
  componentId: "wycezz-4"
})(["", ""], InputStyles);

var _StyledButton = styled("button").withConfig({
  displayName: "Inputvariants___StyledButton",
  componentId: "wycezz-5"
})(["all:unset;position:absolute;top:", ";right:", ";"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
});

var PasswordInput$1 = function PasswordInput(_ref6) {
  var errorMessage = _ref6.errorMessage,
      hasParentIcon = _ref6.hasParentIcon,
      dataCy = _ref6.dataCy,
      rest = _objectWithoutPropertiesLoose$2(_ref6, _excluded4);

  var _useState = useState(false),
      isPasswordVisible = _useState[0],
      setIsPasswordVisible = _useState[1];

  return /*#__PURE__*/jsxs(_StyledDiv$a, {
    children: [/*#__PURE__*/jsx(_StyledInput4, _extends$2({
      type: isPasswordVisible ? 'text' : 'password' //@ts-ignore

    }, rest, {
      "data-cy": dataCy
    })), !hasParentIcon && /*#__PURE__*/jsx(_StyledButton, {
      type: "button",
      onClick: function onClick() {
        return setIsPasswordVisible(function (prevIsPasswordVisible) {
          return !prevIsPasswordVisible;
        });
      },
      _css: rem(0),
      _css2: rem(0),
      children: /*#__PURE__*/jsx(InputIcon, {
        size: "big",
        name: "Preview",
        color: rest.status == 'disabled' ? theme.colors.cloud : theme.colors.coal,
        isClickable: true,
        status: rest.status
      })
    }), errorMessage && /*#__PURE__*/jsx(Label, {
      children: errorMessage
    })]
  });
};
var variants = {
  base: BaseInput,
  url: UrlInput,
  search: SearchInput,
  display: DisplayInput,
  password: PasswordInput$1
};

var _excluded$j = ["size", "status", "errorMessage", "variant", "isPlaceholderCentered", "placeholderIsLabel", "dataCy"];
var InputWrapper = styled.div.withConfig({
  displayName: "Input__InputWrapper",
  componentId: "sc-1w5g8je-0"
})(["@media ", "{position:relative;width:100%;}", ""], theme.device.tablet, function (_ref) {
  var status = _ref.status;
  return status == 'error' && "\n         " + Label + " {\n            color: " + theme.colors.danger + ";\n        }\n  ";
});
var Label = styled.label.withConfig({
  displayName: "Input__Label",
  componentId: "sc-1w5g8je-1"
})(["display:block;margin-top:", ";", ";"], rem(2), textCssFactory(textVariants.paragraphS));
var Input = function Input(_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'big' : _ref2$size,
      _ref2$status = _ref2.status,
      status = _ref2$status === void 0 ? 'default' : _ref2$status,
      errorMessage = _ref2.errorMessage,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'base' : _ref2$variant,
      isPlaceholderCentered = _ref2.isPlaceholderCentered,
      placeholderIsLabel = _ref2.placeholderIsLabel,
      dataCy = _ref2.dataCy,
      rest = _objectWithoutPropertiesLoose$2(_ref2, _excluded$j);

  var InputContainer = variants[variant];

  var hasIcon = function hasIcon(status) {
    return status !== 'disabled' && status !== 'default';
  };

  return /*#__PURE__*/jsxs(InputWrapper, {
    status: status,
    children: [/*#__PURE__*/jsx(InputContainer, _extends$2({
      hasParentIcon: hasIcon(status),
      size: size,
      status: status,
      errorMessage: errorMessage
    }, rest, {
      disabled: status === 'disabled',
      isPlaceholderCentered: variant === 'display' && isPlaceholderCentered,
      placeholderIsLabel: variant === 'display' && placeholderIsLabel,
      dataCy: dataCy
    })), hasIcon(status) && variant !== 'display' && /*#__PURE__*/jsx(InputIcon, {
      size: size,
      name: iconVariants[status].name,
      color: iconVariants[status].color,
      status: status,
      secondaryColor: iconVariants[status].secondaryColor
    })]
  });
};

var Image = /*#__PURE__*/forwardRef(function Image(props, ref) {
  return /*#__PURE__*/jsx("img", _extends$2({}, props, {
    ref: ref,
    loading: !props.first ? 'lazy' : undefined,
    fetchpriority: props.first ? 'high' : undefined
  }));
});

var IframeSizes = {
  width: {
    horizontal: {
      desktop: '1200',
      laptop: '1030'
    },
    vertical: {
      desktop: '360',
      laptop: '360'
    },
    square: {
      desktop: '640',
      laptop: '640'
    }
  },
  height: {
    horizontal: {
      desktop: '675',
      laptop: '675'
    },
    vertical: {
      desktop: '640',
      laptop: '640'
    },
    square: {
      desktop: '640',
      laptop: '640'
    }
  }
};

var ResponsiveIframe = styled.iframe.withConfig({
  displayName: "Iframestyle__ResponsiveIframe",
  componentId: "kqqy6g-0"
})(["", " ", " ", " ", ""], function (_ref) {
  var preset = _ref.preset;
  return preset === 'horizontal' && "\n        width: calc(100vw - " + theme.grid.horizontalMargin["default"] + "px);\n        height: " + rem(250) + ";\n        @media " + theme.device.tablet + " {\n            width: calc(100vw - " + theme.grid.horizontalMargin.tablet + "px);\n            height: " + rem(500) + ";\n        }\n        @media " + theme.device.laptop + " {\n            width: " + IframeSizes.width.horizontal.laptop + "px;\n            height: " + IframeSizes.height.horizontal.laptop + "px;\n        }\n        @media " + theme.device.desktop + " {\n            width: " + IframeSizes.width.horizontal.desktop + "px;\n            height: " + IframeSizes.height.horizontal.desktop + "px;\n        }\n    ";
}, function (_ref2) {
  var preset = _ref2.preset;
  return preset === 'vertical' && "\n        width: 100%;\n        height: 100%;\n        @media " + theme.device.tablet + " {\n            width: calc(100vw - " + theme.grid.horizontalMargin.tablet + ")px;\n            height: 100%;\n        }\n        @media " + theme.device.laptop + " {\n            width: " + IframeSizes.width.vertical.laptop + "px;\n            height: " + IframeSizes.height.vertical.laptop + "px;\n        }\n        @media " + theme.device.desktop + " {\n            width: " + IframeSizes.width.vertical.desktop + "px;\n            height: " + IframeSizes.height.vertical.desktop + "px;\n        }\n        ";
}, function (_ref3) {
  var preset = _ref3.preset;
  return preset === 'square' && "\n        width: 100%;\n        height: 100%;\n        @media " + theme.device.tablet + " {\n            width: calc(100vw - " + theme.grid.horizontalMargin.tablet + "px);\n            height: 100%;\n        }\n        @media " + theme.device.laptop + " {\n            width: " + IframeSizes.width.square.laptop + "px;\n            height: " + IframeSizes.height.square.laptop + "px;\n        }\n        @media " + theme.device.desktop + " {\n            width: " + IframeSizes.width.square.desktop + "px;\n            height: " + IframeSizes.height.square.desktop + "px;\n        }\n    ";
}, function (_ref4) {
  var boxShadowBol = _ref4.boxShadowBol;
  return boxShadowBol && "\n        filter: " + (boxShadowBol ? 'drop-shadow(rgba(0, 15, 51, 0.2) 0px 1px 4px)' : 0) + ",\n    ";
});
var IframeWrapper = styled.div.withConfig({
  displayName: "Iframestyle__IframeWrapper",
  componentId: "kqqy6g-1"
})(["", " ", " ", ""], function (_ref5) {
  var preset = _ref5.preset;
  return preset === 'horizontal' && "\n            height: 31vh;\n            @media " + theme.device.tablet + " {\n                height: 57vh;\n            }\n            @media " + theme.device.laptop + " {\n                height: 100%;\n            }\n        ";
}, function (_ref6) {
  var preset = _ref6.preset;
  return preset === 'vertical' && "       \n        height: 80vh;\n        @media " + theme.device.laptop + " {\n            height: 100%;\n        }\n    ";
}, function (_ref7) {
  var preset = _ref7.preset;
  return preset === 'square' && "\n        height: 44vh;\n        @media " + theme.device.laptop + " {\n            height: 100%;\n        }\n        ";
});

var Iframe = function Iframe(_ref) {
  var src = _ref.src,
      urlIframe = _ref.urlIframe,
      boxShadowBol = _ref.boxShadowBol,
      allowFullscreen = _ref.allowFullscreen,
      allowPopups = _ref.allowPopups,
      allowSameorigin = _ref.allowSameorigin,
      allowScripts = _ref.allowScripts,
      fullSizeFromParent = _ref.fullSizeFromParent,
      preset = _ref.preset;
  var sizeWidth = '1200';
  var sizeHeight = '675';

  switch (preset) {
    case 'horizontal':
      sizeWidth = IframeSizes.width.horizontal.desktop;
      sizeHeight = IframeSizes.height.horizontal.desktop;
      break;

    case 'vertical':
      sizeWidth = IframeSizes.width.vertical.desktop;
      sizeHeight = IframeSizes.height.vertical.desktop;
      break;

    case 'square':
      sizeWidth = IframeSizes.width.square.desktop;
      sizeHeight = IframeSizes.height.square.desktop;
      break;
  }

  var elementRef = useRef(null);

  var _useState = useState(0),
      parentWidth = _useState[0],
      setparentWidth = _useState[1];

  useEffect(function () {
    if (elementRef.current) {
      setparentWidth(elementRef.current.getBoundingClientRect().width);
    }
  }, []);
  var parentStyle = {};
  var iframeStyle = {};

  if (parentWidth < parseInt(sizeWidth)) {
    parentStyle = {
      position: 'relative',
      width: '100%',
      paddingBottom: '56.25%',
      maxWidth: '100%',
      margin: 'auto',
      filter: "" + (boxShadowBol ? 'drop-shadow(rgba(0, 15, 51, 0.2) 0px 1px 4px)' : 0)
    };
    iframeStyle = {
      position: 'absolute',
      width: '100%',
      height: '100%'
    };
  } else {
    parentStyle = {
      textAlign: 'center',
      margin: 'auto'
    };
    iframeStyle = {
      width: sizeWidth + 'px',
      height: sizeHeight + 'px'
    };
  }

  if (urlIframe) {
    // this if takes the value of the parent that sets the size of the container
    if (!fullSizeFromParent || fullSizeFromParent === undefined) {
      return /*#__PURE__*/jsx("div", {
        ref: elementRef,
        style: parentStyle,
        children: /*#__PURE__*/jsx("iframe", {
          sandbox: (allowScripts ? 'allow-scripts' : 'allow-scripts') + " " + (allowPopups ? 'allow-popups' : '') + " " + (allowSameorigin ? 'allow-same-origin' : '') + " ",
          allowFullScreen: allowFullscreen,
          loading: "lazy",
          src: urlIframe,
          "data-cy": 'iframeButton',
          style: iframeStyle
        })
      });
    } //this takes the full size of the iframe, for modal case or layouter if needed


    return /*#__PURE__*/jsx(IframeWrapper, {
      preset: preset,
      children: /*#__PURE__*/jsx(ResponsiveIframe, {
        sandbox: (allowScripts ? 'allow-scripts' : 'allow-scripts') + " " + (allowPopups ? 'allow-popups' : '') + " " + (allowSameorigin ? 'allow-same-origin' : '') + " ",
        allowFullScreen: allowFullscreen,
        loading: "lazy",
        src: urlIframe,
        "data-cy": 'iframeButton',
        preset: preset,
        boxShadowBol: boxShadowBol
      })
    });
  }

  return /*#__PURE__*/jsx(HtmlParser, {
    children: src
  });
};

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function () {

  if (typeof window !== 'object') {
    return;
  } // Exit early if all IntersectionObserver and IntersectionObserverEntry
  // features are natively supported.


  if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get: function get() {
          return this.intersectionRatio > 0;
        }
      });
    }

    return;
  }
  /**
   * Returns the embedding frame element, if any.
   * @param {!Document} doc
   * @return {!Element}
   */


  function getFrameElement(doc) {
    try {
      return doc.defaultView && doc.defaultView.frameElement || null;
    } catch (e) {
      // Ignore the error.
      return null;
    }
  }
  /**
   * A local reference to the root document.
   */


  var document = function (startDoc) {
    var doc = startDoc;
    var frame = getFrameElement(doc);

    while (frame) {
      doc = frame.ownerDocument;
      frame = getFrameElement(doc);
    }

    return doc;
  }(window.document);
  /**
   * An IntersectionObserver registry. This registry exists to hold a strong
   * reference to IntersectionObserver instances currently observing a target
   * element. Without this registry, instances without another reference may be
   * garbage collected.
   */


  var registry = [];
  /**
   * The signal updater for cross-origin intersection. When not null, it means
   * that the polyfill is configured to work in a cross-origin mode.
   * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
   */

  var crossOriginUpdater = null;
  /**
   * The current cross-origin intersection. Only used in the cross-origin mode.
   * @type {DOMRect|ClientRect}
   */

  var crossOriginRect = null;
  /**
   * Creates the global IntersectionObserverEntry constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
   * @param {Object} entry A dictionary of instance properties.
   * @constructor
   */

  function IntersectionObserverEntry(entry) {
    this.time = entry.time;
    this.target = entry.target;
    this.rootBounds = ensureDOMRect(entry.rootBounds);
    this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
    this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
    this.isIntersecting = !!entry.intersectionRect; // Calculates the intersection ratio.

    var targetRect = this.boundingClientRect;
    var targetArea = targetRect.width * targetRect.height;
    var intersectionRect = this.intersectionRect;
    var intersectionArea = intersectionRect.width * intersectionRect.height; // Sets intersection ratio.

    if (targetArea) {
      // Round the intersection ratio to avoid floating point math issues:
      // https://github.com/w3c/IntersectionObserver/issues/324
      this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
    } else {
      // If area is zero and is intersecting, sets to 1, otherwise to 0
      this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
  }
  /**
   * Creates the global IntersectionObserver constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
   * @param {Function} callback The function to be invoked after intersection
   *     changes have queued. The function is not invoked if the queue has
   *     been emptied by calling the `takeRecords` method.
   * @param {Object=} opt_options Optional configuration options.
   * @constructor
   */


  function IntersectionObserver(callback, opt_options) {
    var options = opt_options || {};

    if (typeof callback != 'function') {
      throw new Error('callback must be a function');
    }

    if (options.root && options.root.nodeType != 1 && options.root.nodeType != 9) {
      throw new Error('root must be a Document or Element');
    } // Binds and throttles `this._checkForIntersections`.


    this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT); // Private properties.

    this._callback = callback;
    this._observationTargets = [];
    this._queuedEntries = [];
    this._rootMarginValues = this._parseRootMargin(options.rootMargin); // Public properties.

    this.thresholds = this._initThresholds(options.threshold);
    this.root = options.root || null;
    this.rootMargin = this._rootMarginValues.map(function (margin) {
      return margin.value + margin.unit;
    }).join(' ');
    /** @private @const {!Array<!Document>} */

    this._monitoringDocuments = [];
    /** @private @const {!Array<function()>} */

    this._monitoringUnsubscribes = [];
  }
  /**
   * The minimum interval within which the document will be checked for
   * intersection changes.
   */


  IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
  /**
   * The frequency in which the polyfill polls for intersection changes.
   * this can be updated on a per instance basis and must be set prior to
   * calling `observe` on the first target.
   */

  IntersectionObserver.prototype.POLL_INTERVAL = null;
  /**
   * Use a mutation observer on the root element
   * to detect intersection changes.
   */

  IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
  /**
   * Sets up the polyfill in the cross-origin mode. The result is the
   * updater function that accepts two arguments: `boundingClientRect` and
   * `intersectionRect` - just as these fields would be available to the
   * parent via `IntersectionObserverEntry`. This function should be called
   * each time the iframe receives intersection information from the parent
   * window, e.g. via messaging.
   * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
   */

  IntersectionObserver._setupCrossOriginUpdater = function () {
    if (!crossOriginUpdater) {
      /**
       * @param {DOMRect|ClientRect} boundingClientRect
       * @param {DOMRect|ClientRect} intersectionRect
       */
      crossOriginUpdater = function crossOriginUpdater(boundingClientRect, intersectionRect) {
        if (!boundingClientRect || !intersectionRect) {
          crossOriginRect = getEmptyRect();
        } else {
          crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
        }

        registry.forEach(function (observer) {
          observer._checkForIntersections();
        });
      };
    }

    return crossOriginUpdater;
  };
  /**
   * Resets the cross-origin mode.
   */


  IntersectionObserver._resetCrossOriginUpdater = function () {
    crossOriginUpdater = null;
    crossOriginRect = null;
  };
  /**
   * Starts observing a target element for intersection changes based on
   * the thresholds values.
   * @param {Element} target The DOM element to observe.
   */


  IntersectionObserver.prototype.observe = function (target) {
    var isTargetAlreadyObserved = this._observationTargets.some(function (item) {
      return item.element == target;
    });

    if (isTargetAlreadyObserved) {
      return;
    }

    if (!(target && target.nodeType == 1)) {
      throw new Error('target must be an Element');
    }

    this._registerInstance();

    this._observationTargets.push({
      element: target,
      entry: null
    });

    this._monitorIntersections(target.ownerDocument);

    this._checkForIntersections();
  };
  /**
   * Stops observing a target element for intersection changes.
   * @param {Element} target The DOM element to observe.
   */


  IntersectionObserver.prototype.unobserve = function (target) {
    this._observationTargets = this._observationTargets.filter(function (item) {
      return item.element != target;
    });

    this._unmonitorIntersections(target.ownerDocument);

    if (this._observationTargets.length == 0) {
      this._unregisterInstance();
    }
  };
  /**
   * Stops observing all target elements for intersection changes.
   */


  IntersectionObserver.prototype.disconnect = function () {
    this._observationTargets = [];

    this._unmonitorAllIntersections();

    this._unregisterInstance();
  };
  /**
   * Returns any queue entries that have not yet been reported to the
   * callback and clears the queue. This can be used in conjunction with the
   * callback to obtain the absolute most up-to-date intersection information.
   * @return {Array} The currently queued entries.
   */


  IntersectionObserver.prototype.takeRecords = function () {
    var records = this._queuedEntries.slice();

    this._queuedEntries = [];
    return records;
  };
  /**
   * Accepts the threshold value from the user configuration object and
   * returns a sorted array of unique threshold values. If a value is not
   * between 0 and 1 and error is thrown.
   * @private
   * @param {Array|number=} opt_threshold An optional threshold value or
   *     a list of threshold values, defaulting to [0].
   * @return {Array} A sorted list of unique and valid threshold values.
   */


  IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
    var threshold = opt_threshold || [0];
    if (!Array.isArray(threshold)) threshold = [threshold];
    return threshold.sort().filter(function (t, i, a) {
      if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
        throw new Error('threshold must be a number between 0 and 1 inclusively');
      }

      return t !== a[i - 1];
    });
  };
  /**
   * Accepts the rootMargin value from the user configuration object
   * and returns an array of the four margin values as an object containing
   * the value and unit properties. If any of the values are not properly
   * formatted or use a unit other than px or %, and error is thrown.
   * @private
   * @param {string=} opt_rootMargin An optional rootMargin value,
   *     defaulting to '0px'.
   * @return {Array<Object>} An array of margin objects with the keys
   *     value and unit.
   */


  IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
    var marginString = opt_rootMargin || '0px';
    var margins = marginString.split(/\s+/).map(function (margin) {
      var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);

      if (!parts) {
        throw new Error('rootMargin must be specified in pixels or percent');
      }

      return {
        value: parseFloat(parts[1]),
        unit: parts[2]
      };
    }); // Handles shorthand.

    margins[1] = margins[1] || margins[0];
    margins[2] = margins[2] || margins[0];
    margins[3] = margins[3] || margins[1];
    return margins;
  };
  /**
   * Starts polling for intersection changes if the polling is not already
   * happening, and if the page's visibility state is visible.
   * @param {!Document} doc
   * @private
   */


  IntersectionObserver.prototype._monitorIntersections = function (doc) {
    var win = doc.defaultView;

    if (!win) {
      // Already destroyed.
      return;
    }

    if (this._monitoringDocuments.indexOf(doc) != -1) {
      // Already monitoring.
      return;
    } // Private state for monitoring.


    var callback = this._checkForIntersections;
    var monitoringInterval = null;
    var domObserver = null; // If a poll interval is set, use polling instead of listening to
    // resize and scroll events or DOM mutations.

    if (this.POLL_INTERVAL) {
      monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
    } else {
      addEvent(win, 'resize', callback, true);
      addEvent(doc, 'scroll', callback, true);

      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in win) {
        domObserver = new win.MutationObserver(callback);
        domObserver.observe(doc, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }

    this._monitoringDocuments.push(doc);

    this._monitoringUnsubscribes.push(function () {
      // Get the window object again. When a friendly iframe is destroyed, it
      // will be null.
      var win = doc.defaultView;

      if (win) {
        if (monitoringInterval) {
          win.clearInterval(monitoringInterval);
        }

        removeEvent(win, 'resize', callback, true);
      }

      removeEvent(doc, 'scroll', callback, true);

      if (domObserver) {
        domObserver.disconnect();
      }
    }); // Also monitor the parent.


    var rootDoc = this.root && (this.root.ownerDocument || this.root) || document;

    if (doc != rootDoc) {
      var frame = getFrameElement(doc);

      if (frame) {
        this._monitorIntersections(frame.ownerDocument);
      }
    }
  };
  /**
   * Stops polling for intersection changes.
   * @param {!Document} doc
   * @private
   */


  IntersectionObserver.prototype._unmonitorIntersections = function (doc) {
    var index = this._monitoringDocuments.indexOf(doc);

    if (index == -1) {
      return;
    }

    var rootDoc = this.root && (this.root.ownerDocument || this.root) || document; // Check if any dependent targets are still remaining.

    var hasDependentTargets = this._observationTargets.some(function (item) {
      var itemDoc = item.element.ownerDocument; // Target is in this context.

      if (itemDoc == doc) {
        return true;
      } // Target is nested in this context.


      while (itemDoc && itemDoc != rootDoc) {
        var frame = getFrameElement(itemDoc);
        itemDoc = frame && frame.ownerDocument;

        if (itemDoc == doc) {
          return true;
        }
      }

      return false;
    });

    if (hasDependentTargets) {
      return;
    } // Unsubscribe.


    var unsubscribe = this._monitoringUnsubscribes[index];

    this._monitoringDocuments.splice(index, 1);

    this._monitoringUnsubscribes.splice(index, 1);

    unsubscribe(); // Also unmonitor the parent.

    if (doc != rootDoc) {
      var frame = getFrameElement(doc);

      if (frame) {
        this._unmonitorIntersections(frame.ownerDocument);
      }
    }
  };
  /**
   * Stops polling for intersection changes.
   * @param {!Document} doc
   * @private
   */


  IntersectionObserver.prototype._unmonitorAllIntersections = function () {
    var unsubscribes = this._monitoringUnsubscribes.slice(0);

    this._monitoringDocuments.length = 0;
    this._monitoringUnsubscribes.length = 0;

    for (var i = 0; i < unsubscribes.length; i++) {
      unsubscribes[i]();
    }
  };
  /**
   * Scans each observation target for intersection changes and adds them
   * to the internal entries queue. If new entries are found, it
   * schedules the callback to be invoked.
   * @private
   */


  IntersectionObserver.prototype._checkForIntersections = function () {
    if (!this.root && crossOriginUpdater && !crossOriginRect) {
      // Cross origin monitoring, but no initial data available yet.
      return;
    }

    var rootIsInDom = this._rootIsInDom();

    var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

    this._observationTargets.forEach(function (item) {
      var target = item.element;
      var targetRect = getBoundingClientRect(target);

      var rootContainsTarget = this._rootContainsTarget(target);

      var oldEntry = item.entry;

      var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, targetRect, rootRect);

      var rootBounds = null;

      if (!this._rootContainsTarget(target)) {
        rootBounds = getEmptyRect();
      } else if (!crossOriginUpdater || this.root) {
        rootBounds = rootRect;
      }

      var newEntry = item.entry = new IntersectionObserverEntry({
        time: now(),
        target: target,
        boundingClientRect: targetRect,
        rootBounds: rootBounds,
        intersectionRect: intersectionRect
      });

      if (!oldEntry) {
        this._queuedEntries.push(newEntry);
      } else if (rootIsInDom && rootContainsTarget) {
        // If the new entry intersection ratio has crossed any of the
        // thresholds, add a new entry.
        if (this._hasCrossedThreshold(oldEntry, newEntry)) {
          this._queuedEntries.push(newEntry);
        }
      } else {
        // If the root is not in the DOM or target is not contained within
        // root but the previous entry for this target had an intersection,
        // add a new record indicating removal.
        if (oldEntry && oldEntry.isIntersecting) {
          this._queuedEntries.push(newEntry);
        }
      }
    }, this);

    if (this._queuedEntries.length) {
      this._callback(this.takeRecords(), this);
    }
  };
  /**
   * Accepts a target and root rect computes the intersection between then
   * following the algorithm in the spec.
   * TODO(philipwalton): at this time clip-path is not considered.
   * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
   * @param {Element} target The target DOM element
   * @param {Object} targetRect The bounding rect of the target.
   * @param {Object} rootRect The bounding rect of the root after being
   *     expanded by the rootMargin value.
   * @return {?Object} The final intersection rect object or undefined if no
   *     intersection is found.
   * @private
   */


  IntersectionObserver.prototype._computeTargetAndRootIntersection = function (target, targetRect, rootRect) {
    // If the element isn't displayed, an intersection can't happen.
    if (window.getComputedStyle(target).display == 'none') return;
    var intersectionRect = targetRect;
    var parent = getParentNode(target);
    var atRoot = false;

    while (!atRoot && parent) {
      var parentRect = null;
      var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {}; // If the parent isn't displayed, an intersection can't happen.

      if (parentComputedStyle.display == 'none') return null;

      if (parent == this.root || parent.nodeType ==
      /* DOCUMENT */
      9) {
        atRoot = true;

        if (parent == this.root || parent == document) {
          if (crossOriginUpdater && !this.root) {
            if (!crossOriginRect || crossOriginRect.width == 0 && crossOriginRect.height == 0) {
              // A 0-size cross-origin intersection means no-intersection.
              parent = null;
              parentRect = null;
              intersectionRect = null;
            } else {
              parentRect = crossOriginRect;
            }
          } else {
            parentRect = rootRect;
          }
        } else {
          // Check if there's a frame that can be navigated to.
          var frame = getParentNode(parent);
          var frameRect = frame && getBoundingClientRect(frame);

          var frameIntersect = frame && this._computeTargetAndRootIntersection(frame, frameRect, rootRect);

          if (frameRect && frameIntersect) {
            parent = frame;
            parentRect = convertFromParentRect(frameRect, frameIntersect);
          } else {
            parent = null;
            intersectionRect = null;
          }
        }
      } else {
        // If the element has a non-visible overflow, and it's not the <body>
        // or <html> element, update the intersection rect.
        // Note: <body> and <html> cannot be clipped to a rect that's not also
        // the document rect, so no need to compute a new intersection.
        var doc = parent.ownerDocument;

        if (parent != doc.body && parent != doc.documentElement && parentComputedStyle.overflow != 'visible') {
          parentRect = getBoundingClientRect(parent);
        }
      } // If either of the above conditionals set a new parentRect,
      // calculate new intersection data.


      if (parentRect) {
        intersectionRect = computeRectIntersection(parentRect, intersectionRect);
      }

      if (!intersectionRect) break;
      parent = parent && getParentNode(parent);
    }

    return intersectionRect;
  };
  /**
   * Returns the root rect after being expanded by the rootMargin value.
   * @return {ClientRect} The expanded root rect.
   * @private
   */


  IntersectionObserver.prototype._getRootRect = function () {
    var rootRect;

    if (this.root && !isDoc(this.root)) {
      rootRect = getBoundingClientRect(this.root);
    } else {
      // Use <html>/<body> instead of window since scroll bars affect size.
      var doc = isDoc(this.root) ? this.root : document;
      var html = doc.documentElement;
      var body = doc.body;
      rootRect = {
        top: 0,
        left: 0,
        right: html.clientWidth || body.clientWidth,
        width: html.clientWidth || body.clientWidth,
        bottom: html.clientHeight || body.clientHeight,
        height: html.clientHeight || body.clientHeight
      };
    }

    return this._expandRectByRootMargin(rootRect);
  };
  /**
   * Accepts a rect and expands it by the rootMargin value.
   * @param {DOMRect|ClientRect} rect The rect object to expand.
   * @return {ClientRect} The expanded rect.
   * @private
   */


  IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
    var margins = this._rootMarginValues.map(function (margin, i) {
      return margin.unit == 'px' ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
    });

    var newRect = {
      top: rect.top - margins[0],
      right: rect.right + margins[1],
      bottom: rect.bottom + margins[2],
      left: rect.left - margins[3]
    };
    newRect.width = newRect.right - newRect.left;
    newRect.height = newRect.bottom - newRect.top;
    return newRect;
  };
  /**
   * Accepts an old and new entry and returns true if at least one of the
   * threshold values has been crossed.
   * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
   *    particular target element or null if no previous entry exists.
   * @param {IntersectionObserverEntry} newEntry The current entry for a
   *    particular target element.
   * @return {boolean} Returns true if a any threshold has been crossed.
   * @private
   */


  IntersectionObserver.prototype._hasCrossedThreshold = function (oldEntry, newEntry) {
    // To make comparing easier, an entry that has a ratio of 0
    // but does not actually intersect is given a value of -1
    var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
    var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1; // Ignore unchanged ratios

    if (oldRatio === newRatio) return;

    for (var i = 0; i < this.thresholds.length; i++) {
      var threshold = this.thresholds[i]; // Return true if an entry matches a threshold or if the new ratio
      // and the old ratio are on the opposite sides of a threshold.

      if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
        return true;
      }
    }
  };
  /**
   * Returns whether or not the root element is an element and is in the DOM.
   * @return {boolean} True if the root element is an element and is in the DOM.
   * @private
   */


  IntersectionObserver.prototype._rootIsInDom = function () {
    return !this.root || containsDeep(document, this.root);
  };
  /**
   * Returns whether or not the target element is a child of root.
   * @param {Element} target The target element to check.
   * @return {boolean} True if the target element is a child of root.
   * @private
   */


  IntersectionObserver.prototype._rootContainsTarget = function (target) {
    var rootDoc = this.root && (this.root.ownerDocument || this.root) || document;
    return containsDeep(rootDoc, target) && (!this.root || rootDoc == target.ownerDocument);
  };
  /**
   * Adds the instance to the global IntersectionObserver registry if it isn't
   * already present.
   * @private
   */


  IntersectionObserver.prototype._registerInstance = function () {
    if (registry.indexOf(this) < 0) {
      registry.push(this);
    }
  };
  /**
   * Removes the instance from the global IntersectionObserver registry.
   * @private
   */


  IntersectionObserver.prototype._unregisterInstance = function () {
    var index = registry.indexOf(this);
    if (index != -1) registry.splice(index, 1);
  };
  /**
   * Returns the result of the performance.now() method or null in browsers
   * that don't support the API.
   * @return {number} The elapsed time since the page was requested.
   */


  function now() {
    return window.performance && performance.now && performance.now();
  }
  /**
   * Throttles a function and delays its execution, so it's only called at most
   * once within a given time period.
   * @param {Function} fn The function to throttle.
   * @param {number} timeout The amount of time that must pass before the
   *     function can be called again.
   * @return {Function} The throttled function.
   */


  function throttle(fn, timeout) {
    var timer = null;
    return function () {
      if (!timer) {
        timer = setTimeout(function () {
          fn();
          timer = null;
        }, timeout);
      }
    };
  }
  /**
   * Adds an event handler to a DOM node ensuring cross-browser compatibility.
   * @param {Node} node The DOM node to add the event handler to.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to add.
   * @param {boolean} opt_useCapture Optionally adds the even to the capture
   *     phase. Note: this only works in modern browsers.
   */


  function addEvent(node, event, fn, opt_useCapture) {
    if (typeof node.addEventListener == 'function') {
      node.addEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.attachEvent == 'function') {
      node.attachEvent('on' + event, fn);
    }
  }
  /**
   * Removes a previously added event handler from a DOM node.
   * @param {Node} node The DOM node to remove the event handler from.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to remove.
   * @param {boolean} opt_useCapture If the event handler was added with this
   *     flag set to true, it should be set to true here in order to remove it.
   */


  function removeEvent(node, event, fn, opt_useCapture) {
    if (typeof node.removeEventListener == 'function') {
      node.removeEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.detatchEvent == 'function') {
      node.detatchEvent('on' + event, fn);
    }
  }
  /**
   * Returns the intersection between two rect objects.
   * @param {Object} rect1 The first rect.
   * @param {Object} rect2 The second rect.
   * @return {?Object|?ClientRect} The intersection rect or undefined if no
   *     intersection is found.
   */


  function computeRectIntersection(rect1, rect2) {
    var top = Math.max(rect1.top, rect2.top);
    var bottom = Math.min(rect1.bottom, rect2.bottom);
    var left = Math.max(rect1.left, rect2.left);
    var right = Math.min(rect1.right, rect2.right);
    var width = right - left;
    var height = bottom - top;
    return width >= 0 && height >= 0 && {
      top: top,
      bottom: bottom,
      left: left,
      right: right,
      width: width,
      height: height
    } || null;
  }
  /**
   * Shims the native getBoundingClientRect for compatibility with older IE.
   * @param {Element} el The element whose bounding rect to get.
   * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
   */


  function getBoundingClientRect(el) {
    var rect;

    try {
      rect = el.getBoundingClientRect();
    } catch (err) {// Ignore Windows 7 IE11 "Unspecified error"
      // https://github.com/w3c/IntersectionObserver/pull/205
    }

    if (!rect) return getEmptyRect(); // Older IE

    if (!(rect.width && rect.height)) {
      rect = {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
      };
    }

    return rect;
  }
  /**
   * Returns an empty rect object. An empty rect is returned when an element
   * is not in the DOM.
   * @return {ClientRect} The empty rect.
   */


  function getEmptyRect() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }
  /**
   * Ensure that the result has all of the necessary fields of the DOMRect.
   * Specifically this ensures that `x` and `y` fields are set.
   *
   * @param {?DOMRect|?ClientRect} rect
   * @return {?DOMRect}
   */


  function ensureDOMRect(rect) {
    // A `DOMRect` object has `x` and `y` fields.
    if (!rect || 'x' in rect) {
      return rect;
    } // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
    // for internally calculated Rect objects. For the purposes of
    // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
    // for these fields.


    return {
      top: rect.top,
      y: rect.top,
      bottom: rect.bottom,
      left: rect.left,
      x: rect.left,
      right: rect.right,
      width: rect.width,
      height: rect.height
    };
  }
  /**
   * Inverts the intersection and bounding rect from the parent (frame) BCR to
   * the local BCR space.
   * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
   * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
   * @return {ClientRect} The local root bounding rect for the parent's children.
   */


  function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
    var top = parentIntersectionRect.top - parentBoundingRect.top;
    var left = parentIntersectionRect.left - parentBoundingRect.left;
    return {
      top: top,
      left: left,
      height: parentIntersectionRect.height,
      width: parentIntersectionRect.width,
      bottom: top + parentIntersectionRect.height,
      right: left + parentIntersectionRect.width
    };
  }
  /**
   * Checks to see if a parent element contains a child element (including inside
   * shadow DOM).
   * @param {Node} parent The parent element.
   * @param {Node} child The child element.
   * @return {boolean} True if the parent node contains the child node.
   */


  function containsDeep(parent, child) {
    var node = child;

    while (node) {
      if (node == parent) return true;
      node = getParentNode(node);
    }

    return false;
  }
  /**
   * Gets the parent node of an element or its host element if the parent node
   * is a shadow root.
   * @param {Node} node The node whose parent to get.
   * @return {Node|null} The parent node or null if no parent exists.
   */


  function getParentNode(node) {
    var parent = node.parentNode;

    if (node.nodeType ==
    /* DOCUMENT */
    9 && node != document) {
      // If this node is a document node, look for the embedding frame.
      return getFrameElement(node);
    } // If the parent has element that is assigned through shadow root slot


    if (parent && parent.assignedSlot) {
      parent = parent.assignedSlot.parentNode;
    }

    if (parent && parent.nodeType == 11 && parent.host) {
      // If the parent is a shadow root, return the host element.
      return parent.host;
    }

    return parent;
  }
  /**
   * Returns true if `node` is a Document.
   * @param {!Node} node
   * @returns {boolean}
   */


  function isDoc(node) {
    return node && node.nodeType === 9;
  } // Exposes the constructors globally.


  window.IntersectionObserver = IntersectionObserver;
  window.IntersectionObserverEntry = IntersectionObserverEntry;
})();

var DEFAULT_ROOT_MARGIN = '0px';
var DEFAULT_THRESHOLD = [0.5];
var useEffectInViewport = function useEffectInViewport(effectFunction) {
  var nodeRef = useRef(null);
  var observerRef = useRef(null);

  var _useState = useState(),
      entry = _useState[0],
      setEntry = _useState[1];

  var unobserve = useCallback(function () {
    var _observerRef$current;

    (_observerRef$current = observerRef.current) === null || _observerRef$current === void 0 ? void 0 : _observerRef$current.disconnect();
    observerRef.current = null;
  }, []);
  useEffect(function () {
    return unobserve;
  }, [unobserve]);
  var observe = useCallback(function () {
    var node = nodeRef.current;

    if (node) {
      var options = {
        rootMargin: DEFAULT_ROOT_MARGIN,
        threshold: DEFAULT_THRESHOLD
      };
      var observer = new IntersectionObserver(function (_ref) {
        var newEntry = _ref[0];
        setEntry(newEntry);
      }, options);
      observer.observe(node);
      observerRef.current = observer;
    }
  }, [DEFAULT_ROOT_MARGIN, DEFAULT_THRESHOLD]);
  var refCallback = useCallback(function (node) {
    nodeRef.current = node;
    unobserve();
    observe();
  }, [observe, unobserve]);
  useEffect(function () {
    if (entry && entry.isIntersecting) {
      effectFunction();
    }
  }, [entry]);
  return refCallback;
};

var _excluded$i = ["children", "duration", "type"];

var _StyledDiv$9 = styled("div").withConfig({
  displayName: "Animation___StyledDiv",
  componentId: "sc-8uk42e-0"
})(["display:inherit;margin:inherit;width:100%;opacity:0;", ""], function (p) {
  return p._css;
});

var Animation = function Animation(_ref) {
  var children = _ref.children,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? '0.3' : _ref$duration,
      type = _ref.type,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$i);

  var _useState = useState(false),
      animate = _useState[0],
      setAnimate = _useState[1];

  var ref = useEffectInViewport(function () {
    setAnimate(true);
  });

  if (type == 'none') {
    return /*#__PURE__*/jsx(Fragment$1, {
      children: children
    });
  }

  return /*#__PURE__*/jsx(_StyledDiv$9, _extends$2({}, rest, {
    ref: ref,
    _css: animate && css(["animation:", " ", "s ", ";animation-fill-mode:both;"], theme.animations[type], duration, theme.transitions.easeInOut),
    children: children
  }));
};

var _excluded$h = ["alt", "animation"];

var _StyledVideo = styled("video").withConfig({
  displayName: "Video___StyledVideo",
  componentId: "v3q1a-0"
})(["width:100%;height:auto;"]);

var Video = /*#__PURE__*/forwardRef(function Video(_ref, ref) {
  var alt = _ref.alt,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? 'fadeInUp' : _ref$animation,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$h);

  return /*#__PURE__*/jsx(Animation, {
    type: animation,
    children: /*#__PURE__*/jsxs(_StyledVideo, {
      autoPlay: true,
      loop: true,
      muted: true,
      playsInline: true,
      ref: ref,
      children: [/*#__PURE__*/jsx("source", _extends$2({}, props)), alt]
    }, props.src)
  });
});

var Divider = styled.div.attrs(function (props) {
  return {
    'data-testid': props['data-testid'] || 'divider'
  };
}).withConfig({
  displayName: "Divider",
  componentId: "wlt0pa-0"
})(["height:", ";width:100%;", ";", " ", ""], rem(1), theme.marginsCss, function (_ref) {
  var $color = _ref.$color;
  return "\n      background-color: " + theme.colors[$color] + ";\n    ";
}, function (_ref2) {
  var vertical = _ref2.vertical;
  return vertical && "\n      height: auto;\n      width: " + rem(1) + ";\n    ";
});

var _excluded$g = ["options", "disabled", "state", "url"];

var _StyledDivider = styled(Divider).withConfig({
  displayName: "DropdownList___StyledDivider",
  componentId: "aj0t5t-0"
})(["margin:", " 0;"], function (p) {
  return p._css;
});

var _StyledIcon$4 = styled(Icon).withConfig({
  displayName: "DropdownList___StyledIcon",
  componentId: "aj0t5t-1"
})(["margin-right:", ";&:hover{path{fill:", ";}}"], function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var DropdownList = function DropdownList(_ref) {
  var options = _ref.options,
      disabled = _ref.disabled,
      state = _ref.state,
      url = _ref.url,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$g);

  var firstBottomIndex = options.findIndex(function (element) {
    return element.isBottom;
  });
  return /*#__PURE__*/jsx(ListWrapper, _extends$2({
    disabled: disabled,
    state: state
  }, rest, {
    role: "listbox",
    children: options === null || options === void 0 ? void 0 : options.map(function (element, index) {
      return /*#__PURE__*/jsxs(Fragment$2, {
        children: [index === firstBottomIndex && /*#__PURE__*/jsx(_StyledDivider, {
          $color: "smoke",
          _css: rem(theme.sizes.tiny)
        }), /*#__PURE__*/jsx(ListItem, _extends$2({
          role: "option",
          href: element.url
        }, rest, {
          "data-cy": element.dataCy ? element.dataCy : undefined,
          onClick: function onClick() {
            if (element.onClick) {
              element.onClick();
            }
          },
          children: /*#__PURE__*/jsxs(Flex, {
            alignItems: "center",
            justifyContent: rest.bigList ? 'flex-start' : 'space-between',
            children: [element.icon && /*#__PURE__*/jsx(_StyledIcon$4, {
              name: element.icon.value,
              color: element.icon.color ? element.icon.color : theme.colors.rOnyx,
              _css2: rem(theme.sizes.mini),
              _css3: theme.colors.rBlack
            }), /*#__PURE__*/jsx(Text, {
              variant: "paragraphS",
              children: element.value
            }), !rest.bigList && url === element.url && /*#__PURE__*/jsx(Icon, {
              name: "Success",
              color: theme.colors.rAkihabara
            })]
          })
        }), element.value)]
      }, element.value);
    })
  }));
};
var animations$2 = {
  entered: undefined,
  entering: css(["animation:", " 0.2s ", ";"], theme.animations.fadeInDown, theme.transitions.easeInOut),
  exiting: css(["animation:", " 0.2s ", " reverse;"], theme.animations.fadeOutDown, theme.transitions.easeInOut),
  exited: css(["display:none;"]),
  unmounted: undefined
};
var ListWrapper = styled.div.withConfig({
  displayName: "DropdownList__ListWrapper",
  componentId: "aj0t5t-2"
})(["position:absolute;", ";height:auto;padding:", ";margin-top:", ";overflow-x:hidden;background:", ";border-radius:", ";box-shadow:", ";z-index:10;", ";", ""], function (_ref2) {
  var rightAlign = _ref2.rightAlign;
  return rightAlign ? "right: " + rem(-8) : "left: " + rem(-8);
}, rem(theme.sizes.xmini), rem(theme.sizes.xmini), theme.colors.rWhite, rem(8), theme.shadows.modal, function (_ref3) {
  var state = _ref3.state;
  return state && animations$2[state];
}, function (_ref4) {
  var bigList = _ref4.bigList;
  return bigList ? "\n      width: " + rem(288) + ";\n    " : "\n      width: " + rem(220) + ";\n    ";
});
var ListItem = styled.a.withConfig({
  displayName: "DropdownList__ListItem",
  componentId: "aj0t5t-3"
})(["display:flex;justify-content:space-between;flex-direction:column;width:100%;padding:", " ", ";border-radius:", ";text-decoration:none;cursor:pointer;", ";color:", ";&:hover{background-color:", ";color:", ";", "}"], rem(6), rem(theme.sizes.xmini), rem(4), textCssFactory(textVariants.paragraphS), theme.colors.rOnyx, theme.colors.rSilver, theme.colors.rBlack, function (_ref5) {
  var bigList = _ref5.bigList;
  return bigList && "\n      path {\n      fill: " + theme.colors.rBlack + " !important;\n    }\n    ";
});

var manageCustomSpacing$1 = function manageCustomSpacing(customSpacing, defaultSpacing) {
  if (customSpacing === 999) {
    return rem(defaultSpacing);
  }

  if (customSpacing) {
    return rem(customSpacing);
  }

  if (customSpacing === 0) {
    return 0;
  }

  return rem(defaultSpacing);
};
var ComponentContainer = styled.article.withConfig({
  displayName: "ComponentContainer",
  componentId: "ul9wa2-0"
})(["width:100%;margin:0 auto;padding-left:", ";padding-right:", ";padding-top:", ";padding-bottom:", ";@media ", "{padding-left:", ";padding-right:", ";padding-top:", ";padding-bottom:", ";}@media ", "{padding-left:", ";padding-right:", ";padding-top:", ";padding-bottom:", ";}@media ", "{", " padding-left:", ";padding-right:", ";padding-top:", ";padding-bottom:", ";}", ""], function (_ref) {
  var _customSpacing$mobile;

  var customSpacing = _ref.customSpacing;
  return manageCustomSpacing$1(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$mobile = customSpacing.mobile) === null || _customSpacing$mobile === void 0 ? void 0 : _customSpacing$mobile.left, theme.grid.horizontalMargin["default"]);
}, function (_ref2) {
  var _customSpacing$mobile2;

  var customSpacing = _ref2.customSpacing;
  return manageCustomSpacing$1(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$mobile2 = customSpacing.mobile) === null || _customSpacing$mobile2 === void 0 ? void 0 : _customSpacing$mobile2.right, theme.grid.horizontalMargin["default"]);
}, function (_ref3) {
  var _customSpacing$mobile3;

  var customSpacing = _ref3.customSpacing;
  return manageCustomSpacing$1(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$mobile3 = customSpacing.mobile) === null || _customSpacing$mobile3 === void 0 ? void 0 : _customSpacing$mobile3.top, theme.grid.verticalMargin["default"]);
}, function (_ref4) {
  var _customSpacing$mobile4;

  var customSpacing = _ref4.customSpacing;
  return manageCustomSpacing$1(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$mobile4 = customSpacing.mobile) === null || _customSpacing$mobile4 === void 0 ? void 0 : _customSpacing$mobile4.bottom, theme.grid.verticalMargin["default"]);
}, theme.device.tablet, function (_ref5) {
  var _customSpacing$tablet;

  var customSpacing = _ref5.customSpacing;
  return manageCustomSpacing$1(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$tablet = customSpacing.tablet) === null || _customSpacing$tablet === void 0 ? void 0 : _customSpacing$tablet.left, theme.grid.horizontalMargin.tablet);
}, function (_ref6) {
  var _customSpacing$tablet2;

  var customSpacing = _ref6.customSpacing;
  return manageCustomSpacing$1(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$tablet2 = customSpacing.tablet) === null || _customSpacing$tablet2 === void 0 ? void 0 : _customSpacing$tablet2.right, theme.grid.horizontalMargin.tablet);
}, function (_ref7) {
  var _customSpacing$tablet3;

  var customSpacing = _ref7.customSpacing;
  return manageCustomSpacing$1(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$tablet3 = customSpacing.tablet) === null || _customSpacing$tablet3 === void 0 ? void 0 : _customSpacing$tablet3.top, theme.grid.verticalMargin.tablet);
}, function (_ref8) {
  var _customSpacing$tablet4;

  var customSpacing = _ref8.customSpacing;
  return manageCustomSpacing$1(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$tablet4 = customSpacing.tablet) === null || _customSpacing$tablet4 === void 0 ? void 0 : _customSpacing$tablet4.bottom, theme.grid.verticalMargin.tablet);
}, theme.device.laptop, function (_ref9) {
  var _customSpacing$laptop;

  var customSpacing = _ref9.customSpacing;
  return manageCustomSpacing$1(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$laptop = customSpacing.laptop) === null || _customSpacing$laptop === void 0 ? void 0 : _customSpacing$laptop.left, theme.grid.horizontalMargin.desktop);
}, function (_ref10) {
  var _customSpacing$laptop2;

  var customSpacing = _ref10.customSpacing;
  return manageCustomSpacing$1(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$laptop2 = customSpacing.laptop) === null || _customSpacing$laptop2 === void 0 ? void 0 : _customSpacing$laptop2.right, theme.grid.horizontalMargin.desktop);
}, function (_ref11) {
  var _customSpacing$laptop3;

  var customSpacing = _ref11.customSpacing;
  return manageCustomSpacing$1(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$laptop3 = customSpacing.laptop) === null || _customSpacing$laptop3 === void 0 ? void 0 : _customSpacing$laptop3.top, theme.grid.verticalMargin.laptop);
}, function (_ref12) {
  var _customSpacing$laptop4;

  var customSpacing = _ref12.customSpacing;
  return manageCustomSpacing$1(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$laptop4 = customSpacing.laptop) === null || _customSpacing$laptop4 === void 0 ? void 0 : _customSpacing$laptop4.bottom, theme.grid.verticalMargin.laptop);
}, theme.device.desktop, function (_ref13) {
  var fullWidth = _ref13.fullWidth;
  return fullWidth ? "\n      max-width: 100%;\n      " : "\n        max-width: " + rem(theme.grid.contentMaxWidth) + ";\n        \n      ";
}, function (_ref14) {
  var _customSpacing$deskto;

  var customSpacing = _ref14.customSpacing;
  return manageCustomSpacing$1(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$deskto = customSpacing.desktop) === null || _customSpacing$deskto === void 0 ? void 0 : _customSpacing$deskto.left, theme.grid.horizontalMargin.desktop);
}, function (_ref15) {
  var _customSpacing$deskto2;

  var customSpacing = _ref15.customSpacing;
  return manageCustomSpacing$1(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$deskto2 = customSpacing.desktop) === null || _customSpacing$deskto2 === void 0 ? void 0 : _customSpacing$deskto2.right, theme.grid.horizontalMargin.desktop);
}, function (_ref16) {
  var _customSpacing$deskto3;

  var customSpacing = _ref16.customSpacing;
  return manageCustomSpacing$1(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$deskto3 = customSpacing.desktop) === null || _customSpacing$deskto3 === void 0 ? void 0 : _customSpacing$deskto3.top, theme.grid.verticalMargin.desktop);
}, function (_ref17) {
  var _customSpacing$deskto4;

  var customSpacing = _ref17.customSpacing;
  return manageCustomSpacing$1(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$deskto4 = customSpacing.desktop) === null || _customSpacing$deskto4 === void 0 ? void 0 : _customSpacing$deskto4.bottom, theme.grid.verticalMargin.desktop);
}, function (_ref18) {
  var atomicComponent = _ref18.atomicComponent;
  return atomicComponent && " margin: unset;\n      max-width: unset;\n  ";
});

var backgroundImageByDevice$2 = css(["", " ", " ", " ", " ", ""], function (_ref) {
  var _background$image;

  var background = _ref.background;
  return (background === null || background === void 0 ? void 0 : (_background$image = background.image) === null || _background$image === void 0 ? void 0 : _background$image.mobile) && "\n        background: url('" + background.image.mobile.src + "') center center no-repeat content-box;\n        background-size: cover;\n    ";
}, function (_ref2) {
  var _background$image2;

  var background = _ref2.background;
  return (background === null || background === void 0 ? void 0 : (_background$image2 = background.image) === null || _background$image2 === void 0 ? void 0 : _background$image2.tablet) && "\n      @media " + theme.device.tablet + " {\n        background: url('" + background.image.tablet.src + "') no-repeat center center content-box;\n        background-size: cover;\n      }  \n    ";
}, function (_ref3) {
  var _background$image3;

  var background = _ref3.background;
  return (background === null || background === void 0 ? void 0 : (_background$image3 = background.image) === null || _background$image3 === void 0 ? void 0 : _background$image3.laptop) && "\n      @media " + theme.device.laptop + " {\n        background: url('" + background.image.laptop.src + "') no-repeat center center content-box;\n        background-size: cover;\n      }\n    ";
}, function (_ref4) {
  var _background$image4;

  var background = _ref4.background;
  return (background === null || background === void 0 ? void 0 : (_background$image4 = background.image) === null || _background$image4 === void 0 ? void 0 : _background$image4.desktop) && "\n      @media " + theme.device.desktop + " {\n        background: url('" + background.image.desktop.src + "') no-repeat center center content-box;\n        background-size: cover;\n      }\n    ";
}, function (_ref5) {
  var background = _ref5.background;
  return (background === null || background === void 0 ? void 0 : background.color) && (background === null || background === void 0 ? void 0 : background.color) !== 'transparent' && "\n      background: " + (background.color === 'white' ? 'none' : theme.colors[background.color]) + ";\n  ";
});
var SimpleSection = styled.div.withConfig({
  displayName: "SimpleSection",
  componentId: "sc-155yp26-0"
})(["display:table;", " ", " ", " ", " ", " ", " ", " ", " ", " ", ";", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], function (_ref6) {
  var display = _ref6.display;
  return display && "\n      display: " + display + ";\n    ";
}, function (_ref7) {
  var fullWidth = _ref7.fullWidth;
  return fullWidth && "\n      width: 100%;\n    ";
}, function (_ref8) {
  var direction = _ref8.direction;
  return direction && "\n      flex-direction: " + direction + ";\n    ";
}, function (_ref9) {
  var minHeight = _ref9.minHeight;
  return minHeight && " min-heoght: auto;\n      @media " + theme.device.desktop + " {\n        min-height: " + minHeight + "px;\n      }\n    ";
}, function (_ref10) {
  var hovers = _ref10.hovers;
  return hovers && hovers.enabled && "\n      &:hover {\n        cursor: pointer;\n        background: " + theme.colors[hovers.color.color] + ";\n      }\n    ";
}, function (_ref11) {
  var borderRad = _ref11.borderRad;
  return (borderRad === null || borderRad === void 0 ? void 0 : borderRad.leftBottom) && "\n     border-bottom-left-radius: " + borderRad.leftBottom + "px;\n    ";
}, function (_ref12) {
  var borderRad = _ref12.borderRad;
  return (borderRad === null || borderRad === void 0 ? void 0 : borderRad.rightBottom) && "\n     border-bottom-right-radius: " + borderRad.rightBottom + "px;\n    ";
}, function (_ref13) {
  var borderRad = _ref13.borderRad;
  return (borderRad === null || borderRad === void 0 ? void 0 : borderRad.leftTop) && "\n     border-top-left-radius: " + borderRad.leftTop + "px;\n    ";
}, function (_ref14) {
  var borderRad = _ref14.borderRad;
  return (borderRad === null || borderRad === void 0 ? void 0 : borderRad.rightTop) && "\n     border-top-right-radius: " + borderRad.rightTop + "px;\n    ";
}, backgroundImageByDevice$2, function (_ref15) {
  var borders = _ref15.borders;
  return borders && "\n      border-top: " + (borders.mobile.top.width ? borders.mobile.top.width : '0') + "px " + borders.mobile.top.style + " " + theme.colors[borders.mobile.top.color.color] + ";\n\n    ";
}, function (_ref16) {
  var borders = _ref16.borders;
  return borders && "\n    @media " + theme.device.tablet + " {\n      border-top: " + (borders.tablet.top.width ? borders.tablet.top.width : '0') + "px " + borders.tablet.top.style + " " + theme.colors[borders.tablet.top.color.color] + ";\n    }\n    ";
}, function (_ref17) {
  var borders = _ref17.borders;
  return borders && "\n    @media " + theme.device.laptop + " {\n      border-top: " + (borders.laptop.top.width ? borders.laptop.top.width : '0') + "px " + borders.laptop.top.style + " " + theme.colors[borders.laptop.top.color.color] + ";\n    }\n    ";
}, function (_ref18) {
  var borders = _ref18.borders;
  return borders && "\n    @media " + theme.device.desktop + " {\n      border-top: " + (borders.desktop.top.width ? borders.desktop.top.width : '0') + "px " + borders.desktop.top.style + " " + theme.colors[borders.desktop.top.color.color] + ";\n    }\n    ";
}, function (_ref19) {
  var borders = _ref19.borders;
  return borders && "\n      border-bottom: " + (borders.mobile.bottom.width ? borders.mobile.bottom.width : '0') + "px " + borders.mobile.bottom.style + " " + theme.colors[borders.mobile.bottom.color.color] + ";\n\n    ";
}, function (_ref20) {
  var borders = _ref20.borders;
  return borders && "\n    @media " + theme.device.tablet + " {\n      border-bottom: " + (borders.tablet.bottom.width ? borders.tablet.bottom.width : '0') + "px " + borders.tablet.bottom.style + " " + theme.colors[borders.tablet.bottom.color.color] + ";\n    }\n    ";
}, function (_ref21) {
  var borders = _ref21.borders;
  return borders && "\n    @media " + theme.device.laptop + " {\n      border-bottom: " + (borders.laptop.bottom.width ? borders.laptop.bottom.width : '0') + "px " + borders.laptop.bottom.style + " " + theme.colors[borders.laptop.bottom.color.color] + ";\n    }\n    ";
}, function (_ref22) {
  var borders = _ref22.borders;
  return borders && "\n    @media " + theme.device.desktop + " {\n      border-bottom: " + (borders.desktop.bottom.width ? borders.desktop.bottom.width : '0') + "px " + borders.desktop.bottom.style + " " + theme.colors[borders.desktop.bottom.color.color] + ";\n    }\n    ";
}, function (_ref23) {
  var borders = _ref23.borders;
  return borders && "\n      border-left: " + borders.mobile.left.width + "px " + borders.mobile.left.style + " " + theme.colors[borders.mobile.left.color.color] + ";\n\n    ";
}, function (_ref24) {
  var borders = _ref24.borders;
  return borders && "\n    @media " + theme.device.tablet + " {\n      border-left: " + borders.tablet.left.width + "px " + borders.tablet.left.style + " " + theme.colors[borders.tablet.left.color.color] + ";\n    }\n    ";
}, function (_ref25) {
  var borders = _ref25.borders;
  return borders && "\n    @media " + theme.device.laptop + " {\n      border-left: " + borders.laptop.left.width + "px " + borders.laptop.left.style + " " + theme.colors[borders.laptop.left.color.color] + ";\n    }\n    ";
}, function (_ref26) {
  var borders = _ref26.borders;
  return borders && "\n    @media " + theme.device.desktop + " {\n      border-left: " + borders.desktop.left.width + "px " + borders.desktop.left.style + " " + theme.colors[borders.desktop.left.color.color] + ";\n    }\n    ";
}, function (_ref27) {
  var borders = _ref27.borders;
  return borders && "\n      border-right: " + borders.mobile.right.width + "px " + borders.mobile.right.style + " " + theme.colors[borders.mobile.right.color.color] + ";\n\n    ";
}, function (_ref28) {
  var borders = _ref28.borders;
  return borders && "\n    @media " + theme.device.tablet + " {\n      border-right: " + borders.tablet.right.width + "px " + borders.tablet.right.style + " " + theme.colors[borders.tablet.right.color.color] + ";\n    }\n    ";
}, function (_ref29) {
  var borders = _ref29.borders;
  return borders && "\n    @media " + theme.device.laptop + " {\n      border-right: " + borders.laptop.right.width + "px " + borders.laptop.right.style + " " + theme.colors[borders.laptop.right.color.color] + ";\n    }\n    ";
}, function (_ref30) {
  var borders = _ref30.borders;
  return borders && "\n    @media " + theme.device.desktop + " {\n      border-right: " + borders.desktop.right.width + "px " + borders.desktop.right.style + " " + theme.colors[borders.desktop.right.color.color] + ";\n    }\n    ";
});

var IconContainer = function IconContainer(_ref) {
  var background = _ref.background,
      customSpacing = _ref.customSpacing,
      icon = _ref.icon;
  return /*#__PURE__*/jsx(SimpleSection, {
    id: "iconContainer",
    background: background,
    children: /*#__PURE__*/jsx(ComponentContainer, {
      customSpacing: customSpacing,
      atomicComponent: true,
      children: (icon === null || icon === void 0 ? void 0 : icon.icon.icon) && /*#__PURE__*/jsx(Icon, {
        color: theme.colors[icon !== null && icon !== void 0 && icon.iconColor ? icon === null || icon === void 0 ? void 0 : icon.iconColor : 'rBlack'],
        name: icon === null || icon === void 0 ? void 0 : icon.icon.icon.sprite,
        family: icon === null || icon === void 0 ? void 0 : icon.icon.icon.sheet,
        iconSize: icon === null || icon === void 0 ? void 0 : icon.iconSize
      })
    })
  });
};

var _excluded$f = ["href", "size", "variant", "children", "fullwidth", "uppercase"];

var _StyledLink$3 = styled(Link).withConfig({
  displayName: "ButtonLink___StyledLink",
  componentId: "sc-1iht9p9-0"
})(["text-decoration:none;", ""], function (p) {
  return p._css;
});

var ButtonLink = function ButtonLink(_ref) {
  var href = _ref.href,
      size = _ref.size,
      variant = _ref.variant,
      children = _ref.children,
      fullwidth = _ref.fullwidth,
      uppercase = _ref.uppercase,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$f);

  return /*#__PURE__*/jsx(_StyledLink$3, _extends$2({
    href: href,
    "data-cy": children
  }, rest, {
    _css: fullwidth && "width: 100%;",
    children: /*#__PURE__*/jsx(Button, {
      size: size,
      variant: variant,
      uppercase: uppercase,
      fullwidth: fullwidth,
      children: children
    })
  }));
};

var _StyledSimpleSection$2 = styled(SimpleSection).withConfig({
  displayName: "ButtonContainer___StyledSimpleSection",
  componentId: "sc-1lf3pcw-0"
})(["width:100%;@media ", "{width:unset;}"], function (p) {
  return p._css;
});

var _StyledFlex$s = styled(Flex).withConfig({
  displayName: "ButtonContainer___StyledFlex",
  componentId: "sc-1lf3pcw-1"
})(["width:100%;@media ", "{width:unset;}"], function (p) {
  return p._css2;
});

var ButtonContainer = function ButtonContainer(_ref) {
  var background = _ref.background,
      customSpacing = _ref.customSpacing,
      title = _ref.title,
      url = _ref.url,
      size = _ref.size,
      variant = _ref.variant;
  return /*#__PURE__*/jsx(_StyledSimpleSection$2, {
    background: background,
    _css: theme.device.laptop,
    children: /*#__PURE__*/jsx(ComponentContainer, {
      customSpacing: customSpacing,
      children: /*#__PURE__*/jsx(_StyledFlex$s, {
        flexDirection: {
          mobile: 'column',
          tablet: 'row'
        },
        justifyContent: {
          mobile: 'center',
          laptop: 'flex-start'
        },
        _css2: theme.device.tablet,
        children: /*#__PURE__*/jsx(ButtonLink, {
          href: url,
          size: size ? size : 'big',
          variant: variant,
          children: title
        })
      })
    })
  });
};

var _excluded$e = ["src", "animation"],
    _excluded2 = ["type"];
var mediaTypes = {
  image: Image,
  video: Video,
  iframe: Iframe
};

var useMediaSrc = function useMediaSrc(src) {
  var _useState = useState(typeof src === 'string' ? src : ''),
      mediaSrc = _useState[0],
      setMediaSrc = _useState[1];

  var medias = useMedia();
  useEffect(function () {
    if (typeof src === 'string') return;
    var srcForDevice = getUrlForDevice(medias, src);
    if (typeof srcForDevice == undefined) return;
    setMediaSrc(srcForDevice);
  }, [medias, src]);
  return mediaSrc;
};

var Media = /*#__PURE__*/forwardRef(function Media(_ref, ref) {
  var src = _ref.src,
      animation = _ref.animation,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$e);

  var type = props.type,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded2);

  var MediaToRender = mediaTypes[type];

  if (type === 'image') {
    if (typeof src === 'string' || !src) return null;
    return /*#__PURE__*/jsxs("picture", {
      children: [/*#__PURE__*/jsx("source", {
        media: "(min-width:1440px)",
        srcSet: src.desktop
      }), /*#__PURE__*/jsx("source", {
        media: "(min-width:1024px)",
        srcSet: src.laptop
      }), /*#__PURE__*/jsx("source", {
        media: "(min-width:768px)",
        srcSet: src.tablet
      }), /*#__PURE__*/jsx("source", {
        media: "(min-width:0)",
        srcSet: src.mobile
      }), /*#__PURE__*/jsx("img", _extends$2({
        ref: ref
      }, rest, {
        src: src.desktop,
        "data-cy": props.alt
      }))]
    });
  }

  var mediaSrc = type === 'image' ? '' : useMediaSrc(src);
  if (mediaSrc === '') return null;
  return /*#__PURE__*/jsx(MediaToRender, _extends$2({
    src: mediaSrc,
    animation: animation
  }, rest, {
    ref: ref
  }));
});

var getUrlForDevice = function getUrlForDevice(medias, urls) {
  var device = Object.keys(medias).find(function (media) {
    return medias[media];
  });
  return device && urls ? // @ts-ignore
  urls[device.replace('is', '').toLowerCase()] : undefined;
};

var _StyledSimpleSection$1 = styled(SimpleSection).withConfig({
  displayName: "MediaContainer___StyledSimpleSection",
  componentId: "sc-1j48vct-0"
})(["flex:auto;width:100%;"]);

var MediaContainer = function MediaContainer(_ref) {
  var background = _ref.background,
      customSpacing = _ref.customSpacing,
      media = _ref.media,
      mediaBorRadius = _ref.mediaBorRadius,
      boxShadowBol = _ref.boxShadowBol,
      fullSizeFromParent = _ref.fullSizeFromParent;
  return /*#__PURE__*/jsx(_StyledSimpleSection$1, {
    background: background,
    children: /*#__PURE__*/jsx(ComponentContainer, {
      customSpacing: customSpacing,
      children: media && /*#__PURE__*/jsx(MediaColumn$1, {
        mediaBorRadius: mediaBorRadius,
        children: /*#__PURE__*/jsx(Media, _extends$2({}, media, {
          boxShadowBol: boxShadowBol,
          fullSizeFromParent: fullSizeFromParent
        }))
      })
    })
  });
};
var MediaColumn$1 = styled.div.withConfig({
  displayName: "MediaContainer__MediaColumn",
  componentId: "sc-1j48vct-1"
})(["display:block;@media ", "{display:flex;}justify-content:center;iframe{border:0;}", " width:100%;height:100%;img{align-self:flex-start;}"], theme.device.laptop, function (_ref2) {
  var mediaBorRadius = _ref2.mediaBorRadius;
  return mediaBorRadius && mediaBorRadius > 0 && "\n      img,\n      video,\n      iframe {\n        border-radius: " + rem(mediaBorRadius) + ";\n      }\n    ";
});

var ModalOverlay = styled.div.withConfig({
  displayName: "ModalContainerStyles__ModalOverlay",
  componentId: "u46pl1-0"
})(["z-index:300;width:100vw;max-width:100%;height:100vh;position:fixed;top:0;left:0;background:rgba(0,0,0,0.7);display:flex;justify-content:center;align-items:center;"]);
var ModalBox = styled.div.withConfig({
  displayName: "ModalContainerStyles__ModalBox",
  componentId: "u46pl1-1"
})(["display:flex;@media ", "{width:100%;}@media ", "{width:100%;height:100%;}iframe{max-width:100%;@media ", "{max-width:unset;}}"], theme.device.tablet, theme.device.laptop, theme.device.laptop);
var CloseModalBg = styled.div.withConfig({
  displayName: "ModalContainerStyles__CloseModalBg",
  componentId: "u46pl1-2"
})(["width:48px;height:48px;background:", ";border-radius:50%;display:flex;justify-content:center;align-items:center;position:absolute;top:0.5rem;right:1rem;cursor:pointer;"], theme.colors.rOnyx);
var CloseModal = styled.div.withConfig({
  displayName: "ModalContainerStyles__CloseModal",
  componentId: "u46pl1-3"
})(["color:white;font-size:22px;font-weight:bold;line-height:1;&:before{content:'\u2715';}"]);

function useModal() {
  var _useState = useState(false),
      isOpen = _useState[0],
      setisOpen = _useState[1];

  var toggle = function toggle() {
    setisOpen(!isOpen);
  };

  return {
    isOpen: isOpen,
    toggle: toggle
  };
}

var _StyledSimpleSection = styled(SimpleSection).withConfig({
  displayName: "ModalContainer___StyledSimpleSection",
  componentId: "sc-1u06lt0-0"
})(["&:hover{cursor:pointer;}"]);

var ModalContainer = function ModalContainer(_ref) {
  var children = _ref.children;

  var _useModal = useModal(),
      isOpen = _useModal.isOpen,
      toggle = _useModal.toggle;

  return /*#__PURE__*/jsx("div", {
    children: /*#__PURE__*/jsxs(_StyledSimpleSection, {
      onClick: toggle,
      children: [children.props.children[0], /*#__PURE__*/jsx(ModalOpen, {
        isOpen: isOpen,
        toggle: toggle,
        children: children.props.children[1]
      })]
    })
  });
};
var ModalOpen = function ModalOpen(_ref2) {
  var children = _ref2.children,
      isOpen = _ref2.isOpen,
      toggle = _ref2.toggle;
  useEffect(function () {
    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === 'Escape' && isOpen) {
        toggle === null || toggle === void 0 ? void 0 : toggle();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, toggle]);
  return /*#__PURE__*/jsx(Fragment$1, {
    children: isOpen && /*#__PURE__*/jsx(ModalOverlay, {
      onClick: toggle,
      children: /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx(CloseModalBg, {
          children: /*#__PURE__*/jsx(CloseModal, {})
        }), /*#__PURE__*/jsx(ModalBox, {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          children: children
        })]
      })
    })
  });
};

var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "xtpscn-0"
})(["width:100%;margin:0 auto;@media ", "{max-width:", ";}@media ", "{max-width:", ";}"], theme.device.laptop, rem(theme.maxWidth.laptop), theme.device.desktop, rem(theme.maxWidth.desktop));

var SinglePageContainer = function SinglePageContainer(_ref) {
  var backgroundColor = _ref.backgroundColor,
      children = _ref.children,
      withTopbar = _ref.withTopbar;
  return /*#__PURE__*/jsx(FullWidthContainer, {
    backgroundColor: backgroundColor || 'white',
    children: /*#__PURE__*/jsx(InnerContainer, {
      withTopbar: withTopbar,
      children: children
    })
  });
};
var FullWidthContainer = styled.section.withConfig({
  displayName: "SinglePageContainer__FullWidthContainer",
  componentId: "c7tkae-0"
})(["width:100vw;background-color:", ";"], function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return theme.colors[backgroundColor];
});
var InnerContainer = styled.div.withConfig({
  displayName: "SinglePageContainer__InnerContainer",
  componentId: "c7tkae-1"
})(["display:flex;align-items:center;justify-content:center;margin:0 auto;height:100vh;", ";padding-right:", ";padding-left:", ";@media ", "{padding-right:", ";padding-left:", ";}@media ", "{padding-right:", ";padding-left:", ";}@media ", "{max-width:", ";}"], function (_ref3) {
  var withTopbar = _ref3.withTopbar;
  return withTopbar && "height: calc(100vh - " + theme.topbarSize + ")";
}, rem(theme.grid.horizontalMargin["default"]), rem(theme.grid.horizontalMargin["default"]), theme.device.tablet, rem(theme.grid.horizontalMargin.tablet), rem(theme.grid.horizontalMargin.tablet), theme.device.laptop, rem(theme.grid.horizontalMargin.laptop), rem(theme.grid.horizontalMargin.laptop), theme.device.desktop, rem(theme.grid.contentMaxWidth));

var Spacing = styled.div.attrs(function (props) {
  return {
    'data-testid': props['data-testid'] || 'spacing',
    'size': props.size || 'xxs'
  };
}).withConfig({
  displayName: "Spacing",
  componentId: "sc-1bdoqtq-0"
})(["display:inline-block;flex-shrink:0;", " ", " ", ""], function (_ref) {
  var size = _ref.size;
  if (!size) return '';
  var space = theme.spaces[size];
  return "width: " + space + "; height: " + space + ";";
}, function (_ref2) {
  var flex = _ref2.flex;
  return flex && "display: flex;";
}, function (_ref3) {
  var grow = _ref3.grow;
  return grow && "flex-grow: " + grow + ";";
});

var backgroundImageByDevice$1 = css(["", " ", " ", " ", " ", " ", ""], function (_ref) {
  var templatesHeader = _ref.templatesHeader;
  return templatesHeader && "\n    background-position: top !important;\n    @media " + theme.device.tablet + " {\n      background-position: center !important;\n    }\n    @media " + theme.device.laptop + " {\n      min-height: " + rem(424) + ";\n    }\n  ";
}, function (_ref2) {
  var background = _ref2.background;
  return (background === null || background === void 0 ? void 0 : background.color) && "\n      background: " + theme.colors[background.color] + ";\n  ";
}, function (_ref3) {
  var _background$image;

  var background = _ref3.background;
  return (background === null || background === void 0 ? void 0 : (_background$image = background.image) === null || _background$image === void 0 ? void 0 : _background$image.mobile) && "\n        background: url('" + background.image.mobile.src + "') center center no-repeat content-box;\n        background-size: cover;\n    ";
}, function (_ref4) {
  var _background$image2;

  var background = _ref4.background;
  return (background === null || background === void 0 ? void 0 : (_background$image2 = background.image) === null || _background$image2 === void 0 ? void 0 : _background$image2.tablet) && "\n      @media " + theme.device.tablet + " {\n        background: url('" + background.image.tablet.src + "') no-repeat center center content-box;\n        background-size: cover;\n      }  \n    ";
}, function (_ref5) {
  var _background$image3;

  var background = _ref5.background;
  return (background === null || background === void 0 ? void 0 : (_background$image3 = background.image) === null || _background$image3 === void 0 ? void 0 : _background$image3.laptop) && "\n      @media " + theme.device.laptop + " {\n        background: url('" + background.image.laptop.src + "') no-repeat center center content-box;\n        background-size: cover;\n      }\n    ";
}, function (_ref6) {
  var _background$image4;

  var background = _ref6.background;
  return (background === null || background === void 0 ? void 0 : (_background$image4 = background.image) === null || _background$image4 === void 0 ? void 0 : _background$image4.desktop) && "\n      @media " + theme.device.desktop + " {\n        background: url('" + background.image.desktop.src + "') no-repeat center center content-box;\n        background-size: cover;\n      }\n    ";
});
var Section = styled.div.withConfig({
  displayName: "Section",
  componentId: "cfzm6t-0"
})(["width:100vw;display:grid;margin:0 auto;", " ", " ", " ", ""], function (_ref7) {
  var flex = _ref7.flex;
  return flex && "display: flex;";
}, backgroundImageByDevice$1, function (_ref8) {
  var color = _ref8.color;
  return color && "color: " + theme.colors[color] + ";";
}, function (_ref9) {
  var fullHeight = _ref9.fullHeight;
  return fullHeight && "\n          display: flex;\n          backgroundColor: white;\n          @media " + theme.device.laptop + " {\n            height: calc(100vh  - " + theme.topbarSize + ");\n          }\n          alignItems: center;\n          justifyContent: center;\n  ";
});

var SectionColumn = styled.div.withConfig({
  displayName: "SectionColumn",
  componentId: "sc-12wr0zy-0"
})(["display:grid;margin:0 auto;", " ", ""], function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor && "background-color: " + theme.colors[backgroundColor] + ";";
}, function (_ref2) {
  var color = _ref2.color;
  return color && "color: " + theme.colors[color] + ";";
});

var MediaQuery = styled.div.withConfig({
  displayName: "MediaQuery",
  componentId: "sc-14ma1tz-0"
})(["width:100%;", " ", " ", " ", ""], function (_ref) {
  var mobile = _ref.mobile;
  return !mobile && "\n    @media " + theme.device.mobile + " and (max-width: " + (getValueAndUnit(theme.deviceSize.tablet)[0] - 1) + "px) {\n      display: none;  \n    }\n  ";
}, function (_ref2) {
  var tablet = _ref2.tablet;
  return !tablet && "\n    @media " + theme.device.tablet + " and (max-width: " + (getValueAndUnit(theme.deviceSize.laptop)[0] - 1) + "px) {\n      display: none;  \n    }\n  ";
}, function (_ref3) {
  var laptop = _ref3.laptop;
  return !laptop && "\n    @media " + theme.device.laptop + " and (max-width: " + (getValueAndUnit(theme.deviceSize.desktop)[0] - 1) + "px) {\n      display: none;  \n    }\n  ";
}, function (_ref4) {
  var desktop = _ref4.desktop;
  return !desktop && "\n    @media " + theme.device.desktop + " {\n      display: none;  \n    }\n  ";
});

var VisuallyHidden = styled.span.withConfig({
  displayName: "VisuallyHidden",
  componentId: "sc-1io8dsy-0"
})(["", ""], theme.visuallyHidden);

var ParagraphWrapper = styled.div.withConfig({
  displayName: "ParagraphWrapper",
  componentId: "sc-31cyaz-0"
})(["a{text-decoration:underline;color:unset;&:visited{color:unset;}}ul,ul li{list-style:disc;padding:revert;}ol,ol li{list-style-type:decimal;}ol li,ul li{padding:", ";}.highlighted{background-color:", ";color:", ";padding:", ";border-radius:", ";font-weight:700;}.munchOnMelon{color:", ";}.centerElement{display:flex;justify-content:center;}.nohover{td:hover,&:hover{background-color:transparent;border-radius:", ";}}table{max-width:100%;height:auto;width:100%;border-spacing:0;table-layout:fixed;@media ", "{table-layout:inherit;min-width:", ";}}tbody{position:relative;transform:translateZ(0);}thead th{position:sticky;top:", ";z-index:2;background:white;}tr{height:", ";@media ", "{height:", ";}&:hover{background-color:", ";border-radius:", ";td{background-color:", ";padding:", ";&:first-child{border-top-left-radius:", ";border-bottom-left-radius:", ";}&:last-child{border-top-right-radius:", ";border-bottom-right-radius:", ";}}}&.nohover{&:hover{background-color:transparent;}td{background-color:transparent;}}td{padding:", ";}}", ""], rem(4), theme.colors['rAkihabara'], theme.colors['rWhite'], rem(8), rem(8), theme.colors['rMunchOnMelon'], rem(8), theme.device.laptop, rem(1024), rem(64), rem(56), theme.device.tablet, rem(40), theme.colors.rGhost, rem(8), theme.colors.rGhost, rem(16), rem(8), rem(8), rem(8), rem(8), rem(16), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor === 'rBlack' || backgroundColor === 'black' || backgroundColor === 'rAkihabara' ? "a {\n        color: " + theme.colors['rWhite'] + ";\n        &:hover {\n        color:  " + theme.colors['rLavender'] + ";\n        }\n    }" : "a {\n    &:hover {\n    color: " + theme.colors['rGranite'] + ";\n    }";
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b = "function" === typeof Symbol && Symbol["for"],
    c = b ? Symbol["for"]("react.element") : 60103,
    d = b ? Symbol["for"]("react.portal") : 60106,
    e = b ? Symbol["for"]("react.fragment") : 60107,
    f = b ? Symbol["for"]("react.strict_mode") : 60108,
    g = b ? Symbol["for"]("react.profiler") : 60114,
    h = b ? Symbol["for"]("react.provider") : 60109,
    k = b ? Symbol["for"]("react.context") : 60110,
    l = b ? Symbol["for"]("react.async_mode") : 60111,
    m = b ? Symbol["for"]("react.concurrent_mode") : 60111,
    n = b ? Symbol["for"]("react.forward_ref") : 60112,
    p = b ? Symbol["for"]("react.suspense") : 60113,
    q = b ? Symbol["for"]("react.suspense_list") : 60120,
    r = b ? Symbol["for"]("react.memo") : 60115,
    t = b ? Symbol["for"]("react.lazy") : 60116,
    v = b ? Symbol["for"]("react.block") : 60121,
    w = b ? Symbol["for"]("react.fundamental") : 60117,
    x = b ? Symbol["for"]("react.responder") : 60118,
    y = b ? Symbol["for"]("react.scope") : 60119;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element$1 = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;

var isAsyncMode = function isAsyncMode(a) {
  return A(a) || z(a) === l;
};

var isConcurrentMode = A;

var isContextConsumer = function isContextConsumer(a) {
  return z(a) === k;
};

var isContextProvider = function isContextProvider(a) {
  return z(a) === h;
};

var isElement = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};

var isForwardRef = function isForwardRef(a) {
  return z(a) === n;
};

var isFragment = function isFragment(a) {
  return z(a) === e;
};

var isLazy = function isLazy(a) {
  return z(a) === t;
};

var isMemo = function isMemo(a) {
  return z(a) === r;
};

var isPortal = function isPortal(a) {
  return z(a) === d;
};

var isProfiler = function isProfiler(a) {
  return z(a) === g;
};

var isStrictMode = function isStrictMode(a) {
  return z(a) === f;
};

var isSuspense = function isSuspense(a) {
  return z(a) === p;
};

var isValidElementType = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};

var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element$1,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {

  if (process.env.NODE_ENV !== "production") {
    (function () {
      // nor polyfill, then a plain number is used for performance.

      var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
reactIs_development.AsyncMode;
reactIs_development.ConcurrentMode;
reactIs_development.ContextConsumer;
reactIs_development.ContextProvider;
reactIs_development.Element;
reactIs_development.ForwardRef;
reactIs_development.Fragment;
reactIs_development.Lazy;
reactIs_development.Memo;
reactIs_development.Portal;
reactIs_development.Profiler;
reactIs_development.StrictMode;
reactIs_development.Suspense;
reactIs_development.isAsyncMode;
reactIs_development.isConcurrentMode;
reactIs_development.isContextConsumer;
reactIs_development.isContextProvider;
reactIs_development.isElement;
reactIs_development.isForwardRef;
reactIs_development.isFragment;
reactIs_development.isLazy;
reactIs_development.isMemo;
reactIs_development.isPortal;
reactIs_development.isProfiler;
reactIs_development.isStrictMode;
reactIs_development.isSuspense;
reactIs_development.isValidElementType;
reactIs_development.typeOf;

var reactIs = createCommonjsModule(function (module) {

  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

var printWarning$1 = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$1 = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (!checker) {
          continue;
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from
      // props.


      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = typeof propValue;

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;

  function getShim() {
    return shim;
  }
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs; // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod

    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? propTypes.oneOfType([propTypes.number, propTypes.shape({
  enter: propTypes.number,
  exit: propTypes.number,
  appear: propTypes.number
}).isRequired]) : null;
process.env.NODE_ENV !== 'production' ? propTypes.oneOfType([propTypes.string, propTypes.shape({
  enter: propTypes.string,
  exit: propTypes.string,
  active: propTypes.string
}), propTypes.shape({
  enter: propTypes.string,
  enterDone: propTypes.string,
  enterActive: propTypes.string,
  exit: propTypes.string,
  exitDone: propTypes.string,
  exitActive: propTypes.string
})]) : null;

var TransitionGroupContext = /*#__PURE__*/React.createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition$1 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props["in"]) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref["in"];

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props["in"]) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props["in"];
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : /*#__PURE__*/React.cloneElement(React.Children.only(children), childProps))
    );
  };

  return Transition;
}(React.Component);

Transition$1.contextType = TransitionGroupContext;
Transition$1.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: propTypes.shape({
    current: typeof Element === 'undefined' ? propTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return propTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: propTypes.oneOfType([propTypes.func.isRequired, propTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  "in": propTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: propTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: propTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: propTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: propTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: propTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: propTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: propTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: propTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: propTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: propTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: propTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: propTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition$1.defaultProps = {
  "in": false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition$1.UNMOUNTED = UNMOUNTED;
Transition$1.EXITED = EXITED;
Transition$1.ENTERING = ENTERING;
Transition$1.ENTERED = ENTERED;
Transition$1.EXITING = EXITING;

var _excluded$d = ["options", "url", "dataCy"];
var showOptionValue = function showOptionValue(options, url) {
  var option = options.find(function (option) {
    return url === option.url;
  });

  if (!option) {
    var firstOption = options[0];
    if (typeof firstOption !== 'undefined' && 'activeValue' in firstOption) return firstOption.activeValue;
    return firstOption.value;
  }

  if (!(option !== null && option !== void 0 && option.activeValue)) return option.value;
  return option.activeValue;
};
var Dropdown = function Dropdown(_ref) {
  var options = _ref.options,
      url = _ref.url,
      dataCy = _ref.dataCy,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$d);

  var ref = useRef(null);

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var isDisabled = rest.disabled ? rest.disabled : false;

  var handleClick = function handleClick() {
    if (!isDisabled) {
      setIsOpen(function (prevIsOpen) {
        return !prevIsOpen;
      });
    }
  };

  var handleClickOutside = function handleClickOutside() {
    if (!isDisabled) {
      setIsOpen(false);
    }
  };

  useOnClickOutside(ref, handleClickOutside);
  return /*#__PURE__*/jsxs(DropdownContainer, _extends$2({
    ref: ref,
    "data-cy": dataCy,
    onClick: handleClick
  }, rest, {
    "aria-label": rest.ariaLabel,
    children: [/*#__PURE__*/jsxs(DropDownHeader, _extends$2({}, rest, {
      children: [rest.defaultValue ? rest.defaultValue : showOptionValue(options, url), /*#__PURE__*/jsx(DropdownIcon, {
        name: isOpen ? 'DisplayUpSmall' : 'DisplayDownSmall',
        color: theme.colors.rBlack
      })]
    })), /*#__PURE__*/jsx(Transition$1, {
      "in": isOpen,
      timeout: {
        enter: 200,
        exit: 200
      },
      children: function children(state) {
        return /*#__PURE__*/jsx(DropdownList, {
          state: state,
          options: options,
          bigList: rest.bigList,
          rightAlign: rest.rightAlign,
          url: url
        });
      }
    })]
  }));
};
var DropdownContainer = styled.div.withConfig({
  displayName: "Dropdown__DropdownContainer",
  componentId: "sc-17fwtub-0"
})(["appearance:none;position:relative;color:", ";width:100%;padding-right:", ";background:", ";outline:none;cursor:pointer;&::placeholder{color:", ";}&:focus{border:", " solid ", ";}"], theme.colors.rBlack, rem(theme.sizes.base), theme.colors.white, theme.colors.cement, rem(1), theme.colors.rAkihabara);
var DropDownHeader = styled.div.withConfig({
  displayName: "Dropdown__DropDownHeader",
  componentId: "sc-17fwtub-1"
})(["font-weight:bold;color:", ";transition:color 0.15s ", ";&:hover,&:focus{color:", ";transition:color 0.16s ", ";path{fill:", ";transition:fill 0.15s ", ";}}"], theme.colors.rBlack, theme.transitions.easeInOut, theme.colors.rAkihabara, theme.transitions.easeInOut, theme.colors.rAkihabara, theme.transitions.easeInOut);
var DropdownIcon = styled(Icon).withConfig({
  displayName: "Dropdown__DropdownIcon",
  componentId: "sc-17fwtub-2"
})(["position:absolute;top:0;right:0;bottom:0;margin:auto 0;"]);

/*!
 * Glide.js v3.4.1
 * (c) 2013-2019 Jędrzej Chałubek <jedrzej.chalubek@gmail.com> (http://jedrzejchalubek.com/)
 * Released under the MIT License.
 */
var defaults = {
  /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */
  type: 'slider',

  /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */
  startAt: 0,

  /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */
  perView: 1,

  /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */
  focusAt: 0,

  /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */
  gap: 10,

  /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */
  autoplay: false,

  /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */
  hoverpause: true,

  /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */
  keyboard: true,

  /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */
  bound: false,

  /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */
  swipeThreshold: 80,

  /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */
  dragThreshold: 120,

  /**
   * A maximum number of slides to which movement will be made on swiping or dragging. Use `false` for unlimited.
   *
   * @type {Number|Boolean}
   */
  perTouch: false,

  /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */
  touchRatio: 0.5,

  /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */
  touchAngle: 45,

  /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */
  animationDuration: 400,

  /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */
  rewind: true,

  /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */
  rewindDuration: 800,

  /**
   * Easing function for the animation.
   *
   * @type {String}
   */
  animationTimingFunc: 'cubic-bezier(.165, .840, .440, 1)',

  /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */
  throttle: 10,

  /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */
  direction: 'ltr',

  /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */
  peek: 0,

  /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */
  breakpoints: {},

  /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */
  classes: {
    direction: {
      ltr: 'glide--ltr',
      rtl: 'glide--rtl'
    },
    slider: 'glide--slider',
    carousel: 'glide--carousel',
    swipeable: 'glide--swipeable',
    dragging: 'glide--dragging',
    cloneSlide: 'glide__slide--clone',
    activeNav: 'glide__bullet--active',
    activeSlide: 'glide__slide--active',
    disabledArrow: 'glide__arrow--disabled'
  }
};
/**
 * Outputs warning message to the bowser console.
 *
 * @param  {String} msg
 * @return {Void}
 */

function warn(msg) {
  console.error("[Glide warn]: " + msg);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
/**
 * Converts value entered as number
 * or string to integer value.
 *
 * @param {String} value
 * @returns {Number}
 */


function toInt(value) {
  return parseInt(value);
}
/**
 * Converts value entered as number
 * or string to flat value.
 *
 * @param {String} value
 * @returns {Number}
 */


function toFloat(value) {
  return parseFloat(value);
}
/**
 * Indicates whether the specified value is a string.
 *
 * @param  {*}   value
 * @return {Boolean}
 */


function isString(value) {
  return typeof value === 'string';
}
/**
 * Indicates whether the specified value is an object.
 *
 * @param  {*} value
 * @return {Boolean}
 *
 * @see https://github.com/jashkenas/underscore
 */


function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return type === 'function' || type === 'object' && !!value; // eslint-disable-line no-mixed-operators
}
/**
 * Indicates whether the specified value is a number.
 *
 * @param  {*} value
 * @return {Boolean}
 */


function isNumber$1(value) {
  return typeof value === 'number';
}
/**
 * Indicates whether the specified value is a function.
 *
 * @param  {*} value
 * @return {Boolean}
 */


function isFunction(value) {
  return typeof value === 'function';
}
/**
 * Indicates whether the specified value is undefined.
 *
 * @param  {*} value
 * @return {Boolean}
 */


function isUndefined(value) {
  return typeof value === 'undefined';
}
/**
 * Indicates whether the specified value is an array.
 *
 * @param  {*} value
 * @return {Boolean}
 */


function isArray(value) {
  return value.constructor === Array;
}
/**
 * Creates and initializes specified collection of extensions.
 * Each extension receives access to instance of glide and rest of components.
 *
 * @param {Object} glide
 * @param {Object} extensions
 *
 * @returns {Object}
 */


function mount(glide, extensions, events) {
  var components = {};

  for (var name in extensions) {
    if (isFunction(extensions[name])) {
      components[name] = extensions[name](glide, components, events);
    } else {
      warn('Extension must be a function');
    }
  }

  for (var _name in components) {
    if (isFunction(components[_name].mount)) {
      components[_name].mount();
    }
  }

  return components;
}
/**
 * Defines getter and setter property on the specified object.
 *
 * @param  {Object} obj         Object where property has to be defined.
 * @param  {String} prop        Name of the defined property.
 * @param  {Object} definition  Get and set definitions for the property.
 * @return {Void}
 */


function define(obj, prop, definition) {
  Object.defineProperty(obj, prop, definition);
}
/**
 * Sorts aphabetically object keys.
 *
 * @param  {Object} obj
 * @return {Object}
 */


function sortKeys(obj) {
  return Object.keys(obj).sort().reduce(function (r, k) {
    r[k] = obj[k];
    return r[k], r;
  }, {});
}
/**
 * Merges passed settings object with default options.
 *
 * @param  {Object} defaults
 * @param  {Object} settings
 * @return {Object}
 */


function mergeOptions(defaults, settings) {
  var options = _extends({}, defaults, settings); // `Object.assign` do not deeply merge objects, so we
  // have to do it manually for every nested object
  // in options. Although it does not look smart,
  // it's smaller and faster than some fancy
  // merging deep-merge algorithm script.


  if (settings.hasOwnProperty('classes')) {
    options.classes = _extends({}, defaults.classes, settings.classes);

    if (settings.classes.hasOwnProperty('direction')) {
      options.classes.direction = _extends({}, defaults.classes.direction, settings.classes.direction);
    }
  }

  if (settings.hasOwnProperty('breakpoints')) {
    options.breakpoints = _extends({}, defaults.breakpoints, settings.breakpoints);
  }

  return options;
}

var EventsBus = function () {
  /**
   * Construct a EventBus instance.
   *
   * @param {Object} events
   */
  function EventsBus() {
    var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    classCallCheck(this, EventsBus);
    this.events = events;
    this.hop = events.hasOwnProperty;
  }
  /**
   * Adds listener to the specifed event.
   *
   * @param {String|Array} event
   * @param {Function} handler
   */


  createClass(EventsBus, [{
    key: 'on',
    value: function on(event, handler) {
      if (isArray(event)) {
        for (var i = 0; i < event.length; i++) {
          this.on(event[i], handler);
        }
      } // Create the event's object if not yet created


      if (!this.hop.call(this.events, event)) {
        this.events[event] = [];
      } // Add the handler to queue


      var index = this.events[event].push(handler) - 1; // Provide handle back for removal of event

      return {
        remove: function remove() {
          delete this.events[event][index];
        }
      };
    }
    /**
     * Runs registered handlers for specified event.
     *
     * @param {String|Array} event
     * @param {Object=} context
     */

  }, {
    key: 'emit',
    value: function emit(event, context) {
      if (isArray(event)) {
        for (var i = 0; i < event.length; i++) {
          this.emit(event[i], context);
        }
      } // If the event doesn't exist, or there's no handlers in queue, just leave


      if (!this.hop.call(this.events, event)) {
        return;
      } // Cycle through events queue, fire!


      this.events[event].forEach(function (item) {
        item(context || {});
      });
    }
  }]);
  return EventsBus;
}();

var Glide = function () {
  /**
   * Construct glide.
   *
   * @param  {String} selector
   * @param  {Object} options
   */
  function Glide(selector) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, Glide);
    this._c = {};
    this._t = [];
    this._e = new EventsBus();
    this.disabled = false;
    this.selector = selector;
    this.settings = mergeOptions(defaults, options);
    this.index = this.settings.startAt;
  }
  /**
   * Initializes glide.
   *
   * @param {Object} extensions Collection of extensions to initialize.
   * @return {Glide}
   */


  createClass(Glide, [{
    key: 'mount',
    value: function mount$$1() {
      var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this._e.emit('mount.before');

      if (isObject(extensions)) {
        this._c = mount(this, extensions, this._e);
      } else {
        warn('You need to provide a object on `mount()`');
      }

      this._e.emit('mount.after');

      return this;
    }
    /**
     * Collects an instance `translate` transformers.
     *
     * @param  {Array} transformers Collection of transformers.
     * @return {Void}
     */

  }, {
    key: 'mutate',
    value: function mutate() {
      var transformers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (isArray(transformers)) {
        this._t = transformers;
      } else {
        warn('You need to provide a array on `mutate()`');
      }

      return this;
    }
    /**
     * Updates glide with specified settings.
     *
     * @param {Object} settings
     * @return {Glide}
     */

  }, {
    key: 'update',
    value: function update() {
      var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.settings = mergeOptions(this.settings, settings);

      if (settings.hasOwnProperty('startAt')) {
        this.index = settings.startAt;
      }

      this._e.emit('update');

      return this;
    }
    /**
     * Change slide with specified pattern. A pattern must be in the special format:
     * `>` - Move one forward
     * `<` - Move one backward
     * `={i}` - Go to {i} zero-based slide (eq. '=1', will go to second slide)
     * `>>` - Rewinds to end (last slide)
     * `<<` - Rewinds to start (first slide)
     *
     * @param {String} pattern
     * @return {Glide}
     */

  }, {
    key: 'go',
    value: function go(pattern) {
      this._c.Run.make(pattern);

      return this;
    }
    /**
     * Move track by specified distance.
     *
     * @param {String} distance
     * @return {Glide}
     */

  }, {
    key: 'move',
    value: function move(distance) {
      this._c.Transition.disable();

      this._c.Move.make(distance);

      return this;
    }
    /**
     * Destroy instance and revert all changes done by this._c.
     *
     * @return {Glide}
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      this._e.emit('destroy');

      return this;
    }
    /**
     * Start instance autoplaying.
     *
     * @param {Boolean|Number} interval Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Glide}
     */

  }, {
    key: 'play',
    value: function play() {
      var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (interval) {
        this.settings.autoplay = interval;
      }

      this._e.emit('play');

      return this;
    }
    /**
     * Stop instance autoplaying.
     *
     * @return {Glide}
     */

  }, {
    key: 'pause',
    value: function pause() {
      this._e.emit('pause');

      return this;
    }
    /**
     * Sets glide into a idle status.
     *
     * @return {Glide}
     */

  }, {
    key: 'disable',
    value: function disable() {
      this.disabled = true;
      return this;
    }
    /**
     * Sets glide into a active status.
     *
     * @return {Glide}
     */

  }, {
    key: 'enable',
    value: function enable() {
      this.disabled = false;
      return this;
    }
    /**
     * Adds cuutom event listener with handler.
     *
     * @param  {String|Array} event
     * @param  {Function} handler
     * @return {Glide}
     */

  }, {
    key: 'on',
    value: function on(event, handler) {
      this._e.on(event, handler);

      return this;
    }
    /**
     * Checks if glide is a precised type.
     *
     * @param  {String} name
     * @return {Boolean}
     */

  }, {
    key: 'isType',
    value: function isType(name) {
      return this.settings.type === name;
    }
    /**
     * Gets value of the core options.
     *
     * @return {Object}
     */

  }, {
    key: 'settings',
    get: function get$$1() {
      return this._o;
    }
    /**
     * Sets value of the core options.
     *
     * @param  {Object} o
     * @return {Void}
     */
    ,
    set: function set$$1(o) {
      if (isObject(o)) {
        this._o = o;
      } else {
        warn('Options must be an `object` instance.');
      }
    }
    /**
     * Gets current index of the slider.
     *
     * @return {Object}
     */

  }, {
    key: 'index',
    get: function get$$1() {
      return this._i;
    }
    /**
     * Sets current index a slider.
     *
     * @return {Object}
     */
    ,
    set: function set$$1(i) {
      this._i = toInt(i);
    }
    /**
     * Gets type name of the slider.
     *
     * @return {String}
     */

  }, {
    key: 'type',
    get: function get$$1() {
      return this.settings.type;
    }
    /**
     * Gets value of the idle status.
     *
     * @return {Boolean}
     */

  }, {
    key: 'disabled',
    get: function get$$1() {
      return this._d;
    }
    /**
     * Sets value of the idle status.
     *
     * @return {Boolean}
     */
    ,
    set: function set$$1(status) {
      this._d = !!status;
    }
  }]);
  return Glide;
}();

function Run(Glide, Components, Events) {
  var Run = {
    /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */
    mount: function mount() {
      this._o = false;
    },

    /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */
    make: function make(move) {
      var _this = this;

      if (!Glide.disabled) {
        Glide.disable();
        this.move = move;
        Events.emit('run.before', this.move);
        this.calculate();
        Events.emit('run', this.move);
        Components.Transition.after(function () {
          if (_this.isStart()) {
            Events.emit('run.start', _this.move);
          }

          if (_this.isEnd()) {
            Events.emit('run.end', _this.move);
          }

          if (_this.isOffset('<') || _this.isOffset('>')) {
            _this._o = false;
            Events.emit('run.offset', _this.move);
          }

          Events.emit('run.after', _this.move);
          Glide.enable();
        });
      }
    },

    /**
     * Calculates current index based on defined move.
     *
     * @return {Void}
     */
    calculate: function calculate() {
      var move = this.move,
          length = this.length;
      var steps = move.steps,
          direction = move.direction;
      var countableSteps = isNumber$1(toInt(steps)) && toInt(steps) !== 0;

      switch (direction) {
        case '>':
          if (steps === '>') {
            Glide.index = length;
          } else if (this.isEnd()) {
            if (!(Glide.isType('slider') && !Glide.settings.rewind)) {
              this._o = true;
              Glide.index = 0;
            }
          } else if (countableSteps) {
            Glide.index += Math.min(length - Glide.index, -toInt(steps));
          } else {
            Glide.index++;
          }

          break;

        case '<':
          if (steps === '<') {
            Glide.index = 0;
          } else if (this.isStart()) {
            if (!(Glide.isType('slider') && !Glide.settings.rewind)) {
              this._o = true;
              Glide.index = length;
            }
          } else if (countableSteps) {
            Glide.index -= Math.min(Glide.index, toInt(steps));
          } else {
            Glide.index--;
          }

          break;

        case '=':
          Glide.index = steps;
          break;

        default:
          warn('Invalid direction pattern [' + direction + steps + '] has been used');
          break;
      }
    },

    /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */
    isStart: function isStart() {
      return Glide.index === 0;
    },

    /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */
    isEnd: function isEnd() {
      return Glide.index === this.length;
    },

    /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */
    isOffset: function isOffset(direction) {
      return this._o && this.move.direction === direction;
    }
  };
  define(Run, 'move', {
    /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */
    get: function get() {
      return this._m;
    },

    /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */
    set: function set(value) {
      var step = value.substr(1);
      this._m = {
        direction: value.substr(0, 1),
        steps: step ? toInt(step) ? toInt(step) : step : 0
      };
    }
  });
  define(Run, 'length', {
    /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */
    get: function get() {
      var settings = Glide.settings;
      var length = Components.Html.slides.length; // If the `bound` option is acitve, a maximum running distance should be
      // reduced by `perView` and `focusAt` settings. Running distance
      // should end before creating an empty space after instance.

      if (Glide.isType('slider') && settings.focusAt !== 'center' && settings.bound) {
        return length - 1 - (toInt(settings.perView) - 1) + toInt(settings.focusAt);
      }

      return length - 1;
    }
  });
  define(Run, 'offset', {
    /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */
    get: function get() {
      return this._o;
    }
  });
  return Run;
}
/**
 * Returns a current time.
 *
 * @return {Number}
 */


function now() {
  return new Date().getTime();
}
/**
 * Returns a function, that, when invoked, will only be triggered
 * at most once during a given window of time.
 *
 * @param {Function} func
 * @param {Number} wait
 * @param {Object=} options
 * @return {Function}
 *
 * @see https://github.com/jashkenas/underscore
 */


function throttle(func, wait, options) {
  var timeout = void 0,
      context = void 0,
      args = void 0,
      result = void 0;
  var previous = 0;
  if (!options) options = {};

  var later = function later() {
    previous = options.leading === false ? 0 : now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };

  var throttled = function throttled() {
    var at = now();
    if (!previous && options.leading === false) previous = at;
    var remaining = wait - (at - previous);
    context = this;
    args = arguments;

    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }

      previous = at;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }

    return result;
  };

  throttled.cancel = function () {
    clearTimeout(timeout);
    previous = 0;
    timeout = context = args = null;
  };

  return throttled;
}

var MARGIN_TYPE = {
  ltr: ['marginLeft', 'marginRight'],
  rtl: ['marginRight', 'marginLeft']
};

function Gaps(Glide, Components, Events) {
  var Gaps = {
    /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */
    apply: function apply(slides) {
      for (var i = 0, len = slides.length; i < len; i++) {
        var style = slides[i].style;
        var direction = Components.Direction.value;

        if (i !== 0) {
          style[MARGIN_TYPE[direction][0]] = this.value / 2 + 'px';
        } else {
          style[MARGIN_TYPE[direction][0]] = '';
        }

        if (i !== slides.length - 1) {
          style[MARGIN_TYPE[direction][1]] = this.value / 2 + 'px';
        } else {
          style[MARGIN_TYPE[direction][1]] = '';
        }
      }
    },

    /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */
    remove: function remove(slides) {
      for (var i = 0, len = slides.length; i < len; i++) {
        var style = slides[i].style;
        style.marginLeft = '';
        style.marginRight = '';
      }
    }
  };
  define(Gaps, 'value', {
    /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */
    get: function get() {
      return toInt(Glide.settings.gap);
    }
  });
  define(Gaps, 'grow', {
    /**
     * Gets additional dimentions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */
    get: function get() {
      return Gaps.value * (Components.Sizes.length - 1);
    }
  });
  define(Gaps, 'reductor', {
    /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */
    get: function get() {
      var perView = Glide.settings.perView;
      return Gaps.value * (perView - 1) / perView;
    }
  });
  /**
   * Apply calculated gaps:
   * - after building, so slides (including clones) will receive proper margins
   * - on updating via API, to recalculate gaps with new options
   */

  Events.on(['build.after', 'update'], throttle(function () {
    Gaps.apply(Components.Html.wrapper.children);
  }, 30));
  /**
   * Remove gaps:
   * - on destroying to bring markup to its inital state
   */

  Events.on('destroy', function () {
    Gaps.remove(Components.Html.wrapper.children);
  });
  return Gaps;
}
/**
 * Finds siblings nodes of the passed node.
 *
 * @param  {Element} node
 * @return {Array}
 */


function siblings(node) {
  if (node && node.parentNode) {
    var n = node.parentNode.firstChild;
    var matched = [];

    for (; n; n = n.nextSibling) {
      if (n.nodeType === 1 && n !== node) {
        matched.push(n);
      }
    }

    return matched;
  }

  return [];
}
/**
 * Checks if passed node exist and is a valid element.
 *
 * @param  {Element} node
 * @return {Boolean}
 */


function exist(node) {
  if (node && node instanceof window.HTMLElement) {
    return true;
  }

  return false;
}

var TRACK_SELECTOR = '[data-glide-el="track"]';

function Html(Glide, Components) {
  var Html = {
    /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */
    mount: function mount() {
      this.root = Glide.selector;
      this.track = this.root.querySelector(TRACK_SELECTOR);
      this.slides = Array.prototype.slice.call(this.wrapper.children).filter(function (slide) {
        return !slide.classList.contains(Glide.settings.classes.cloneSlide);
      });
    }
  };
  define(Html, 'root', {
    /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */
    get: function get() {
      return Html._r;
    },

    /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */
    set: function set(r) {
      if (isString(r)) {
        r = document.querySelector(r);
      }

      if (exist(r)) {
        Html._r = r;
      } else {
        warn('Root element must be a existing Html node');
      }
    }
  });
  define(Html, 'track', {
    /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */
    get: function get() {
      return Html._t;
    },

    /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */
    set: function set(t) {
      if (exist(t)) {
        Html._t = t;
      } else {
        warn('Could not find track element. Please use ' + TRACK_SELECTOR + ' attribute.');
      }
    }
  });
  define(Html, 'wrapper', {
    /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */
    get: function get() {
      return Html.track.children[0];
    }
  });
  return Html;
}

function Peek(Glide, Components, Events) {
  var Peek = {
    /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.value = Glide.settings.peek;
    }
  };
  define(Peek, 'value', {
    /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */
    get: function get() {
      return Peek._v;
    },

    /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */
    set: function set(value) {
      if (isObject(value)) {
        value.before = toInt(value.before);
        value.after = toInt(value.after);
      } else {
        value = toInt(value);
      }

      Peek._v = value;
    }
  });
  define(Peek, 'reductor', {
    /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */
    get: function get() {
      var value = Peek.value;
      var perView = Glide.settings.perView;

      if (isObject(value)) {
        return value.before / perView + value.after / perView;
      }

      return value * 2 / perView;
    }
  });
  /**
   * Recalculate peeking sizes on:
   * - when resizing window to update to proper percents
   */

  Events.on(['resize', 'update'], function () {
    Peek.mount();
  });
  return Peek;
}

function Move(Glide, Components, Events) {
  var Move = {
    /**
     * Constructs move component.
     *
     * @returns {Void}
     */
    mount: function mount() {
      this._o = 0;
    },

    /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */
    make: function make() {
      var _this = this;

      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.offset = offset;
      Events.emit('move', {
        movement: this.value
      });
      Components.Transition.after(function () {
        Events.emit('move.after', {
          movement: _this.value
        });
      });
    }
  };
  define(Move, 'offset', {
    /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    get: function get() {
      return Move._o;
    },

    /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    set: function set(value) {
      Move._o = !isUndefined(value) ? toInt(value) : 0;
    }
  });
  define(Move, 'translate', {
    /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */
    get: function get() {
      return Components.Sizes.slideWidth * Glide.index;
    }
  });
  define(Move, 'value', {
    /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */
    get: function get() {
      var offset = this.offset;
      var translate = this.translate;

      if (Components.Direction.is('rtl')) {
        return translate + offset;
      }

      return translate - offset;
    }
  });
  /**
   * Make movement to proper slide on:
   * - before build, so glide will start at `startAt` index
   * - on each standard run to move to newly calculated index
   */

  Events.on(['build.before', 'run'], function () {
    Move.make();
  });
  return Move;
}

function Sizes(Glide, Components, Events) {
  var Sizes = {
    /**
     * Setups dimentions of slides.
     *
     * @return {Void}
     */
    setupSlides: function setupSlides() {
      var width = this.slideWidth + 'px';
      var slides = Components.Html.slides;

      for (var i = 0; i < slides.length; i++) {
        slides[i].style.width = width;
      }
    },

    /**
     * Setups dimentions of slides wrapper.
     *
     * @return {Void}
     */
    setupWrapper: function setupWrapper(dimention) {
      Components.Html.wrapper.style.width = this.wrapperSize + 'px';
    },

    /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */
    remove: function remove() {
      var slides = Components.Html.slides;

      for (var i = 0; i < slides.length; i++) {
        slides[i].style.width = '';
      }

      Components.Html.wrapper.style.width = '';
    }
  };
  define(Sizes, 'length', {
    /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */
    get: function get() {
      return Components.Html.slides.length;
    }
  });
  define(Sizes, 'width', {
    /**
     * Gets width value of the glide.
     *
     * @return {Number}
     */
    get: function get() {
      return Components.Html.root.offsetWidth;
    }
  });
  define(Sizes, 'wrapperSize', {
    /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */
    get: function get() {
      return Sizes.slideWidth * Sizes.length + Components.Gaps.grow + Components.Clones.grow;
    }
  });
  define(Sizes, 'slideWidth', {
    /**
     * Gets width value of the single slide.
     *
     * @return {Number}
     */
    get: function get() {
      return Sizes.width / Glide.settings.perView - Components.Peek.reductor - Components.Gaps.reductor;
    }
  });
  /**
   * Apply calculated glide's dimensions:
   * - before building, so other dimentions (e.g. translate) will be calculated propertly
   * - when resizing window to recalculate sildes dimensions
   * - on updating via API, to calculate dimensions based on new options
   */

  Events.on(['build.before', 'resize', 'update'], function () {
    Sizes.setupSlides();
    Sizes.setupWrapper();
  });
  /**
   * Remove calculated glide's dimensions:
   * - on destoting to bring markup to its inital state
   */

  Events.on('destroy', function () {
    Sizes.remove();
  });
  return Sizes;
}

function Build(Glide, Components, Events) {
  var Build = {
    /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */
    mount: function mount() {
      Events.emit('build.before');
      this.typeClass();
      this.activeClass();
      Events.emit('build.after');
    },

    /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */
    typeClass: function typeClass() {
      Components.Html.root.classList.add(Glide.settings.classes[Glide.settings.type]);
    },

    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    activeClass: function activeClass() {
      var classes = Glide.settings.classes;
      var slide = Components.Html.slides[Glide.index];

      if (slide) {
        slide.classList.add(classes.activeSlide);
        siblings(slide).forEach(function (sibling) {
          sibling.classList.remove(classes.activeSlide);
        });
      }
    },

    /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */
    removeClasses: function removeClasses() {
      var classes = Glide.settings.classes;
      Components.Html.root.classList.remove(classes[Glide.settings.type]);
      Components.Html.slides.forEach(function (sibling) {
        sibling.classList.remove(classes.activeSlide);
      });
    }
  };
  /**
   * Clear building classes:
   * - on destroying to bring HTML to its initial state
   * - on updating to remove classes before remounting component
   */

  Events.on(['destroy', 'update'], function () {
    Build.removeClasses();
  });
  /**
   * Remount component:
   * - on resizing of the window to calculate new dimentions
   * - on updating settings via API
   */

  Events.on(['resize', 'update'], function () {
    Build.mount();
  });
  /**
   * Swap active class of current slide:
   * - after each move to the new index
   */

  Events.on('move.after', function () {
    Build.activeClass();
  });
  return Build;
}

function Clones(Glide, Components, Events) {
  var Clones = {
    /**
     * Create pattern map and collect slides to be cloned.
     */
    mount: function mount() {
      this.items = [];

      if (Glide.isType('carousel')) {
        this.items = this.collect();
      }
    },

    /**
     * Collect clones with pattern.
     *
     * @return {Void}
     */
    collect: function collect() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var slides = Components.Html.slides;
      var _Glide$settings = Glide.settings,
          perView = _Glide$settings.perView,
          classes = _Glide$settings.classes;
      var peekIncrementer = +!!Glide.settings.peek;
      var part = perView + peekIncrementer;
      var start = slides.slice(0, part);
      var end = slides.slice(-part);

      for (var r = 0; r < Math.max(1, Math.floor(perView / slides.length)); r++) {
        for (var i = 0; i < start.length; i++) {
          var clone = start[i].cloneNode(true);
          clone.classList.add(classes.cloneSlide);
          items.push(clone);
        }

        for (var _i = 0; _i < end.length; _i++) {
          var _clone = end[_i].cloneNode(true);

          _clone.classList.add(classes.cloneSlide);

          items.unshift(_clone);
        }
      }

      return items;
    },

    /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */
    append: function append() {
      var items = this.items;
      var _Components$Html = Components.Html,
          wrapper = _Components$Html.wrapper,
          slides = _Components$Html.slides;
      var half = Math.floor(items.length / 2);
      var prepend = items.slice(0, half).reverse();
      var append = items.slice(half, items.length);
      var width = Components.Sizes.slideWidth + 'px';

      for (var i = 0; i < append.length; i++) {
        wrapper.appendChild(append[i]);
      }

      for (var _i2 = 0; _i2 < prepend.length; _i2++) {
        wrapper.insertBefore(prepend[_i2], slides[0]);
      }

      for (var _i3 = 0; _i3 < items.length; _i3++) {
        items[_i3].style.width = width;
      }
    },

    /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */
    remove: function remove() {
      var items = this.items;

      for (var i = 0; i < items.length; i++) {
        Components.Html.wrapper.removeChild(items[i]);
      }
    }
  };
  define(Clones, 'grow', {
    /**
     * Gets additional dimentions value caused by clones.
     *
     * @return {Number}
     */
    get: function get() {
      return (Components.Sizes.slideWidth + Components.Gaps.value) * Clones.items.length;
    }
  });
  /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */

  Events.on('update', function () {
    Clones.remove();
    Clones.mount();
    Clones.append();
  });
  /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */

  Events.on('build.before', function () {
    if (Glide.isType('carousel')) {
      Clones.append();
    }
  });
  /**
   * Remove clones HTMLElements:
   * - on destroying, to bring HTML to its initial state
   */

  Events.on('destroy', function () {
    Clones.remove();
  });
  return Clones;
}

var EventsBinder = function () {
  /**
   * Construct a EventsBinder instance.
   */
  function EventsBinder() {
    var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    classCallCheck(this, EventsBinder);
    this.listeners = listeners;
  }
  /**
   * Adds events listeners to arrows HTML elements.
   *
   * @param  {String|Array} events
   * @param  {Element|Window|Document} el
   * @param  {Function} closure
   * @param  {Boolean|Object} capture
   * @return {Void}
   */


  createClass(EventsBinder, [{
    key: 'on',
    value: function on(events, el, closure) {
      var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (isString(events)) {
        events = [events];
      }

      for (var i = 0; i < events.length; i++) {
        this.listeners[events[i]] = closure;
        el.addEventListener(events[i], this.listeners[events[i]], capture);
      }
    }
    /**
     * Removes event listeners from arrows HTML elements.
     *
     * @param  {String|Array} events
     * @param  {Element|Window|Document} el
     * @param  {Boolean|Object} capture
     * @return {Void}
     */

  }, {
    key: 'off',
    value: function off(events, el) {
      var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (isString(events)) {
        events = [events];
      }

      for (var i = 0; i < events.length; i++) {
        el.removeEventListener(events[i], this.listeners[events[i]], capture);
      }
    }
    /**
     * Destroy collected listeners.
     *
     * @returns {Void}
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      delete this.listeners;
    }
  }]);
  return EventsBinder;
}();

function Resize(Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();
  var Resize = {
    /**
     * Initializes window bindings.
     */
    mount: function mount() {
      this.bind();
    },

    /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */
    bind: function bind() {
      Binder.on('resize', window, throttle(function () {
        Events.emit('resize');
      }, Glide.settings.throttle));
    },

    /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */
    unbind: function unbind() {
      Binder.off('resize', window);
    }
  };
  /**
   * Remove bindings from window:
   * - on destroying, to remove added EventListener
   */

  Events.on('destroy', function () {
    Resize.unbind();
    Binder.destroy();
  });
  return Resize;
}

var VALID_DIRECTIONS = ['ltr', 'rtl'];
var FLIPED_MOVEMENTS = {
  '>': '<',
  '<': '>',
  '=': '='
};

function Direction(Glide, Components, Events) {
  var Direction = {
    /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.value = Glide.settings.direction;
    },

    /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */
    resolve: function resolve(pattern) {
      var token = pattern.slice(0, 1);

      if (this.is('rtl')) {
        return pattern.split(token).join(FLIPED_MOVEMENTS[token]);
      }

      return pattern;
    },

    /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */
    is: function is(direction) {
      return this.value === direction;
    },

    /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */
    addClass: function addClass() {
      Components.Html.root.classList.add(Glide.settings.classes.direction[this.value]);
    },

    /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */
    removeClass: function removeClass() {
      Components.Html.root.classList.remove(Glide.settings.classes.direction[this.value]);
    }
  };
  define(Direction, 'value', {
    /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */
    get: function get() {
      return Direction._v;
    },

    /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */
    set: function set(value) {
      if (VALID_DIRECTIONS.indexOf(value) > -1) {
        Direction._v = value;
      } else {
        warn('Direction value must be `ltr` or `rtl`');
      }
    }
  });
  /**
   * Clear direction class:
   * - on destroy to bring HTML to its initial state
   * - on update to remove class before reappling bellow
   */

  Events.on(['destroy', 'update'], function () {
    Direction.removeClass();
  });
  /**
   * Remount component:
   * - on update to reflect changes in direction value
   */

  Events.on('update', function () {
    Direction.mount();
  });
  /**
   * Apply direction class:
   * - before building to apply class for the first time
   * - on updating to reapply direction class that may changed
   */

  Events.on(['build.before', 'update'], function () {
    Direction.addClass();
  });
  return Direction;
}
/**
 * Reflects value of glide movement.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */


function Rtl(Glide, Components) {
  return {
    /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      if (Components.Direction.is('rtl')) {
        return -translate;
      }

      return translate;
    }
  };
}
/**
 * Updates glide movement with a `gap` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */


function Gap(Glide, Components) {
  return {
    /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      return translate + Components.Gaps.value * Glide.index;
    }
  };
}
/**
 * Updates glide movement with width of additional clones width.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */


function Grow(Glide, Components) {
  return {
    /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      return translate + Components.Clones.grow / 2;
    }
  };
}
/**
 * Updates glide movement with a `peek` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */


function Peeking(Glide, Components) {
  return {
    /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      if (Glide.settings.focusAt >= 0) {
        var peek = Components.Peek.value;

        if (isObject(peek)) {
          return translate - peek.before;
        }

        return translate - peek;
      }

      return translate;
    }
  };
}
/**
 * Updates glide movement with a `focusAt` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */


function Focusing(Glide, Components) {
  return {
    /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      var gap = Components.Gaps.value;
      var width = Components.Sizes.width;
      var focusAt = Glide.settings.focusAt;
      var slideWidth = Components.Sizes.slideWidth;

      if (focusAt === 'center') {
        return translate - (width / 2 - slideWidth / 2);
      }

      return translate - slideWidth * focusAt - gap * focusAt;
    }
  };
}
/**
 * Applies diffrent transformers on translate value.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */


function mutator(Glide, Components, Events) {
  /**
   * Merge instance transformers with collection of default transformers.
   * It's important that the Rtl component be last on the list,
   * so it reflects all previous transformations.
   *
   * @type {Array}
   */
  var TRANSFORMERS = [Gap, Grow, Peeking, Focusing].concat(Glide._t, [Rtl]);
  return {
    /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    mutate: function mutate(translate) {
      for (var i = 0; i < TRANSFORMERS.length; i++) {
        var transformer = TRANSFORMERS[i];

        if (isFunction(transformer) && isFunction(transformer().modify)) {
          translate = transformer(Glide, Components, Events).modify(translate);
        } else {
          warn('Transformer should be a function that returns an object with `modify()` method');
        }
      }

      return translate;
    }
  };
}

function Translate(Glide, Components, Events) {
  var Translate = {
    /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */
    set: function set(value) {
      var transform = mutator(Glide, Components).mutate(value);
      Components.Html.wrapper.style.transform = 'translate3d(' + -1 * transform + 'px, 0px, 0px)';
    },

    /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */
    remove: function remove() {
      Components.Html.wrapper.style.transform = '';
    }
  };
  /**
   * Set new translate value:
   * - on move to reflect index change
   * - on updating via API to reflect possible changes in options
   */

  Events.on('move', function (context) {
    var gap = Components.Gaps.value;
    var length = Components.Sizes.length;
    var width = Components.Sizes.slideWidth;

    if (Glide.isType('carousel') && Components.Run.isOffset('<')) {
      Components.Transition.after(function () {
        Events.emit('translate.jump');
        Translate.set(width * (length - 1));
      });
      return Translate.set(-width - gap * length);
    }

    if (Glide.isType('carousel') && Components.Run.isOffset('>')) {
      Components.Transition.after(function () {
        Events.emit('translate.jump');
        Translate.set(0);
      });
      return Translate.set(width * length + gap * length);
    }

    return Translate.set(context.movement);
  });
  /**
   * Remove translate:
   * - on destroying to bring markup to its inital state
   */

  Events.on('destroy', function () {
    Translate.remove();
  });
  return Translate;
}

function Transition(Glide, Components, Events) {
  /**
   * Holds inactivity status of transition.
   * When true transition is not applied.
   *
   * @type {Boolean}
   */
  var disabled = false;
  var Transition = {
    /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */
    compose: function compose(property) {
      var settings = Glide.settings;

      if (!disabled) {
        return property + ' ' + this.duration + 'ms ' + settings.animationTimingFunc;
      }

      return property + ' 0ms ' + settings.animationTimingFunc;
    },

    /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */
    set: function set() {
      var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
      Components.Html.wrapper.style.transition = this.compose(property);
    },

    /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */
    remove: function remove() {
      Components.Html.wrapper.style.transition = '';
    },

    /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */
    after: function after(callback) {
      setTimeout(function () {
        callback();
      }, this.duration);
    },

    /**
     * Enable transition.
     *
     * @return {Void}
     */
    enable: function enable() {
      disabled = false;
      this.set();
    },

    /**
     * Disable transition.
     *
     * @return {Void}
     */
    disable: function disable() {
      disabled = true;
      this.set();
    }
  };
  define(Transition, 'duration', {
    /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */
    get: function get() {
      var settings = Glide.settings;

      if (Glide.isType('slider') && Components.Run.offset) {
        return settings.rewindDuration;
      }

      return settings.animationDuration;
    }
  });
  /**
   * Set transition `style` value:
   * - on each moving, because it may be cleared by offset move
   */

  Events.on('move', function () {
    Transition.set();
  });
  /**
   * Disable transition:
   * - before initial build to avoid transitioning from `0` to `startAt` index
   * - while resizing window and recalculating dimentions
   * - on jumping from offset transition at start and end edges in `carousel` type
   */

  Events.on(['build.before', 'resize', 'translate.jump'], function () {
    Transition.disable();
  });
  /**
   * Enable transition:
   * - on each running, because it may be disabled by offset move
   */

  Events.on('run', function () {
    Transition.enable();
  });
  /**
   * Remove transition:
   * - on destroying to bring markup to its inital state
   */

  Events.on('destroy', function () {
    Transition.remove();
  });
  return Transition;
}
/**
 * Test via a getter in the options object to see
 * if the passive property is accessed.
 *
 * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
 */


var supportsPassive = false;

try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      supportsPassive = true;
    }
  });
  window.addEventListener('testPassive', null, opts);
  window.removeEventListener('testPassive', null, opts);
} catch (e) {}

var supportsPassive$1 = supportsPassive;
var START_EVENTS = ['touchstart', 'mousedown'];
var MOVE_EVENTS = ['touchmove', 'mousemove'];
var END_EVENTS = ['touchend', 'touchcancel', 'mouseup', 'mouseleave'];
var MOUSE_EVENTS = ['mousedown', 'mousemove', 'mouseup', 'mouseleave'];

function Swipe(Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();
  var swipeSin = 0;
  var swipeStartX = 0;
  var swipeStartY = 0;
  var disabled = false;
  var capture = supportsPassive$1 ? {
    passive: true
  } : false;
  var Swipe = {
    /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.bindSwipeStart();
    },

    /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */
    start: function start(event) {
      if (!disabled && !Glide.disabled) {
        this.disable();
        var swipe = this.touches(event);
        swipeSin = null;
        swipeStartX = toInt(swipe.pageX);
        swipeStartY = toInt(swipe.pageY);
        this.bindSwipeMove();
        this.bindSwipeEnd();
        Events.emit('swipe.start');
      }
    },

    /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */
    move: function move(event) {
      if (!Glide.disabled) {
        var _Glide$settings = Glide.settings,
            touchAngle = _Glide$settings.touchAngle,
            touchRatio = _Glide$settings.touchRatio,
            classes = _Glide$settings.classes;
        var swipe = this.touches(event);
        var subExSx = toInt(swipe.pageX) - swipeStartX;
        var subEySy = toInt(swipe.pageY) - swipeStartY;
        var powEX = Math.abs(subExSx << 2);
        var powEY = Math.abs(subEySy << 2);
        var swipeHypotenuse = Math.sqrt(powEX + powEY);
        var swipeCathetus = Math.sqrt(powEY);
        swipeSin = Math.asin(swipeCathetus / swipeHypotenuse);

        if (swipeSin * 180 / Math.PI < touchAngle) {
          event.stopPropagation();
          Components.Move.make(subExSx * toFloat(touchRatio));
          Components.Html.root.classList.add(classes.dragging);
          Events.emit('swipe.move');
        } else {
          return false;
        }
      }
    },

    /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */
    end: function end(event) {
      if (!Glide.disabled) {
        var settings = Glide.settings;
        var swipe = this.touches(event);
        var threshold = this.threshold(event);
        var swipeDistance = swipe.pageX - swipeStartX;
        var swipeDeg = swipeSin * 180 / Math.PI;
        var steps = Math.round(swipeDistance / Components.Sizes.slideWidth);
        this.enable();

        if (swipeDistance > threshold && swipeDeg < settings.touchAngle) {
          // While swipe is positive and greater than threshold move backward.
          if (settings.perTouch) {
            steps = Math.min(steps, toInt(settings.perTouch));
          }

          if (Components.Direction.is('rtl')) {
            steps = -steps;
          }

          Components.Run.make(Components.Direction.resolve('<' + steps));
        } else if (swipeDistance < -threshold && swipeDeg < settings.touchAngle) {
          // While swipe is negative and lower than negative threshold move forward.
          if (settings.perTouch) {
            steps = Math.max(steps, -toInt(settings.perTouch));
          }

          if (Components.Direction.is('rtl')) {
            steps = -steps;
          }

          Components.Run.make(Components.Direction.resolve('>' + steps));
        } else {
          // While swipe don't reach distance apply previous transform.
          Components.Move.make();
        }

        Components.Html.root.classList.remove(settings.classes.dragging);
        this.unbindSwipeMove();
        this.unbindSwipeEnd();
        Events.emit('swipe.end');
      }
    },

    /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */
    bindSwipeStart: function bindSwipeStart() {
      var _this = this;

      var settings = Glide.settings;

      if (settings.swipeThreshold) {
        Binder.on(START_EVENTS[0], Components.Html.wrapper, function (event) {
          _this.start(event);
        }, capture);
      }

      if (settings.dragThreshold) {
        Binder.on(START_EVENTS[1], Components.Html.wrapper, function (event) {
          _this.start(event);
        }, capture);
      }
    },

    /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */
    unbindSwipeStart: function unbindSwipeStart() {
      Binder.off(START_EVENTS[0], Components.Html.wrapper, capture);
      Binder.off(START_EVENTS[1], Components.Html.wrapper, capture);
    },

    /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */
    bindSwipeMove: function bindSwipeMove() {
      var _this2 = this;

      Binder.on(MOVE_EVENTS, Components.Html.wrapper, throttle(function (event) {
        _this2.move(event);
      }, Glide.settings.throttle), capture);
    },

    /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */
    unbindSwipeMove: function unbindSwipeMove() {
      Binder.off(MOVE_EVENTS, Components.Html.wrapper, capture);
    },

    /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */
    bindSwipeEnd: function bindSwipeEnd() {
      var _this3 = this;

      Binder.on(END_EVENTS, Components.Html.wrapper, function (event) {
        _this3.end(event);
      });
    },

    /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */
    unbindSwipeEnd: function unbindSwipeEnd() {
      Binder.off(END_EVENTS, Components.Html.wrapper);
    },

    /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */
    touches: function touches(event) {
      if (MOUSE_EVENTS.indexOf(event.type) > -1) {
        return event;
      }

      return event.touches[0] || event.changedTouches[0];
    },

    /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */
    threshold: function threshold(event) {
      var settings = Glide.settings;

      if (MOUSE_EVENTS.indexOf(event.type) > -1) {
        return settings.dragThreshold;
      }

      return settings.swipeThreshold;
    },

    /**
     * Enables swipe event.
     *
     * @return {self}
     */
    enable: function enable() {
      disabled = false;
      Components.Transition.enable();
      return this;
    },

    /**
     * Disables swipe event.
     *
     * @return {self}
     */
    disable: function disable() {
      disabled = true;
      Components.Transition.disable();
      return this;
    }
  };
  /**
   * Add component class:
   * - after initial building
   */

  Events.on('build.after', function () {
    Components.Html.root.classList.add(Glide.settings.classes.swipeable);
  });
  /**
   * Remove swiping bindings:
   * - on destroying, to remove added EventListeners
   */

  Events.on('destroy', function () {
    Swipe.unbindSwipeStart();
    Swipe.unbindSwipeMove();
    Swipe.unbindSwipeEnd();
    Binder.destroy();
  });
  return Swipe;
}

function Images(Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();
  var Images = {
    /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.bind();
    },

    /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */
    bind: function bind() {
      Binder.on('dragstart', Components.Html.wrapper, this.dragstart);
    },

    /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */
    unbind: function unbind() {
      Binder.off('dragstart', Components.Html.wrapper);
    },

    /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */
    dragstart: function dragstart(event) {
      event.preventDefault();
    }
  };
  /**
   * Remove bindings from images:
   * - on destroying, to remove added EventListeners
   */

  Events.on('destroy', function () {
    Images.unbind();
    Binder.destroy();
  });
  return Images;
}

function Anchors(Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();
  /**
   * Holds detaching status of anchors.
   * Prevents detaching of already detached anchors.
   *
   * @private
   * @type {Boolean}
   */

  var detached = false;
  /**
   * Holds preventing status of anchors.
   * If `true` redirection after click will be disabled.
   *
   * @private
   * @type {Boolean}
   */

  var prevented = false;
  var Anchors = {
    /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */
    mount: function mount() {
      /**
       * Holds collection of anchors elements.
       *
       * @private
       * @type {HTMLCollection}
       */
      this._a = Components.Html.wrapper.querySelectorAll('a');
      this.bind();
    },

    /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */
    bind: function bind() {
      Binder.on('click', Components.Html.wrapper, this.click);
    },

    /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */
    unbind: function unbind() {
      Binder.off('click', Components.Html.wrapper);
    },

    /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */
    click: function click(event) {
      if (prevented) {
        event.stopPropagation();
        event.preventDefault();
      }
    },

    /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */
    detach: function detach() {
      prevented = true;

      if (!detached) {
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].draggable = false;
          this.items[i].setAttribute('data-href', this.items[i].getAttribute('href'));
          this.items[i].removeAttribute('href');
        }

        detached = true;
      }

      return this;
    },

    /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */
    attach: function attach() {
      prevented = false;

      if (detached) {
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].draggable = true;
          this.items[i].setAttribute('href', this.items[i].getAttribute('data-href'));
        }

        detached = false;
      }

      return this;
    }
  };
  define(Anchors, 'items', {
    /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function get() {
      return Anchors._a;
    }
  });
  /**
   * Detach anchors inside slides:
   * - on swiping, so they won't redirect to its `href` attributes
   */

  Events.on('swipe.move', function () {
    Anchors.detach();
  });
  /**
   * Attach anchors inside slides:
   * - after swiping and transitions ends, so they can redirect after click again
   */

  Events.on('swipe.end', function () {
    Components.Transition.after(function () {
      Anchors.attach();
    });
  });
  /**
   * Unbind anchors inside slides:
   * - on destroying, to bring anchors to its initial state
   */

  Events.on('destroy', function () {
    Anchors.attach();
    Anchors.unbind();
    Binder.destroy();
  });
  return Anchors;
}

var NAV_SELECTOR = '[data-glide-el="controls[nav]"]';
var CONTROLS_SELECTOR = '[data-glide-el^="controls"]';

function Controls(Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();
  var capture = supportsPassive$1 ? {
    passive: true
  } : false;
  var Controls = {
    /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */
    mount: function mount() {
      /**
       * Collection of navigation HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */
      this._n = Components.Html.root.querySelectorAll(NAV_SELECTOR);
      /**
       * Collection of controls HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */

      this._c = Components.Html.root.querySelectorAll(CONTROLS_SELECTOR);
      this.addBindings();
    },

    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    setActive: function setActive() {
      for (var i = 0; i < this._n.length; i++) {
        this.addClass(this._n[i].children);
      }
    },

    /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */
    removeActive: function removeActive() {
      for (var i = 0; i < this._n.length; i++) {
        this.removeClass(this._n[i].children);
      }
    },

    /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    addClass: function addClass(controls) {
      var settings = Glide.settings;
      var item = controls[Glide.index];

      if (item) {
        item.classList.add(settings.classes.activeNav);
        siblings(item).forEach(function (sibling) {
          sibling.classList.remove(settings.classes.activeNav);
        });
      }
    },

    /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    removeClass: function removeClass(controls) {
      var item = controls[Glide.index];

      if (item) {
        item.classList.remove(Glide.settings.classes.activeNav);
      }
    },

    /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */
    addBindings: function addBindings() {
      for (var i = 0; i < this._c.length; i++) {
        this.bind(this._c[i].children);
      }
    },

    /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */
    removeBindings: function removeBindings() {
      for (var i = 0; i < this._c.length; i++) {
        this.unbind(this._c[i].children);
      }
    },

    /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    bind: function bind(elements) {
      for (var i = 0; i < elements.length; i++) {
        Binder.on('click', elements[i], this.click);
        Binder.on('touchstart', elements[i], this.click, capture);
      }
    },

    /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    unbind: function unbind(elements) {
      for (var i = 0; i < elements.length; i++) {
        Binder.off(['click', 'touchstart'], elements[i]);
      }
    },

    /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in driection precised in
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {Void}
     */
    click: function click(event) {
      event.preventDefault();
      Components.Run.make(Components.Direction.resolve(event.currentTarget.getAttribute('data-glide-dir')));
    }
  };
  define(Controls, 'items', {
    /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function get() {
      return Controls._c;
    }
  });
  /**
   * Swap active class of current navigation item:
   * - after mounting to set it to initial index
   * - after each move to the new index
   */

  Events.on(['mount.after', 'move.after'], function () {
    Controls.setActive();
  });
  /**
   * Remove bindings and HTML Classes:
   * - on destroying, to bring markup to its initial state
   */

  Events.on('destroy', function () {
    Controls.removeBindings();
    Controls.removeActive();
    Binder.destroy();
  });
  return Controls;
}

function Keyboard(Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();
  var Keyboard = {
    /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */
    mount: function mount() {
      if (Glide.settings.keyboard) {
        this.bind();
      }
    },

    /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */
    bind: function bind() {
      Binder.on('keyup', document, this.press);
    },

    /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */
    unbind: function unbind() {
      Binder.off('keyup', document);
    },

    /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */
    press: function press(event) {
      if (event.keyCode === 39) {
        Components.Run.make(Components.Direction.resolve('>'));
      }

      if (event.keyCode === 37) {
        Components.Run.make(Components.Direction.resolve('<'));
      }
    }
  };
  /**
   * Remove bindings from keyboard:
   * - on destroying to remove added events
   * - on updating to remove events before remounting
   */

  Events.on(['destroy', 'update'], function () {
    Keyboard.unbind();
  });
  /**
   * Remount component
   * - on updating to reflect potential changes in settings
   */

  Events.on('update', function () {
    Keyboard.mount();
  });
  /**
   * Destroy binder:
   * - on destroying to remove listeners
   */

  Events.on('destroy', function () {
    Binder.destroy();
  });
  return Keyboard;
}

function Autoplay(Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();
  var Autoplay = {
    /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.start();

      if (Glide.settings.hoverpause) {
        this.bind();
      }
    },

    /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */
    start: function start() {
      var _this = this;

      if (Glide.settings.autoplay) {
        if (isUndefined(this._i)) {
          this._i = setInterval(function () {
            _this.stop();

            Components.Run.make('>');

            _this.start();
          }, this.time);
        }
      }
    },

    /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */
    stop: function stop() {
      this._i = clearInterval(this._i);
    },

    /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */
    bind: function bind() {
      var _this2 = this;

      Binder.on('mouseover', Components.Html.root, function () {
        _this2.stop();
      });
      Binder.on('mouseout', Components.Html.root, function () {
        _this2.start();
      });
    },

    /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */
    unbind: function unbind() {
      Binder.off(['mouseover', 'mouseout'], Components.Html.root);
    }
  };
  define(Autoplay, 'time', {
    /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */
    get: function get() {
      var autoplay = Components.Html.slides[Glide.index].getAttribute('data-glide-autoplay');

      if (autoplay) {
        return toInt(autoplay);
      }

      return toInt(Glide.settings.autoplay);
    }
  });
  /**
   * Stop autoplaying and unbind events:
   * - on destroying, to clear defined interval
   * - on updating via API to reset interval that may changed
   */

  Events.on(['destroy', 'update'], function () {
    Autoplay.unbind();
  });
  /**
   * Stop autoplaying:
   * - before each run, to restart autoplaying
   * - on pausing via API
   * - on destroying, to clear defined interval
   * - while starting a swipe
   * - on updating via API to reset interval that may changed
   */

  Events.on(['run.before', 'pause', 'destroy', 'swipe.start', 'update'], function () {
    Autoplay.stop();
  });
  /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */

  Events.on(['run.after', 'play', 'swipe.end'], function () {
    Autoplay.start();
  });
  /**
   * Remount autoplaying:
   * - on updating via API to reset interval that may changed
   */

  Events.on('update', function () {
    Autoplay.mount();
  });
  /**
   * Destroy a binder:
   * - on destroying glide instance to clearup listeners
   */

  Events.on('destroy', function () {
    Binder.destroy();
  });
  return Autoplay;
}
/**
 * Sorts keys of breakpoint object so they will be ordered from lower to bigger.
 *
 * @param {Object} points
 * @returns {Object}
 */


function sortBreakpoints(points) {
  if (isObject(points)) {
    return sortKeys(points);
  } else {
    warn('Breakpoints option must be an object');
  }

  return {};
}

function Breakpoints(Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();
  /**
   * Holds reference to settings.
   *
   * @type {Object}
   */

  var settings = Glide.settings;
  /**
   * Holds reference to breakpoints object in settings. Sorts breakpoints
   * from smaller to larger. It is required in order to proper
   * matching currently active breakpoint settings.
   *
   * @type {Object}
   */

  var points = sortBreakpoints(settings.breakpoints);
  /**
   * Cache initial settings before overwritting.
   *
   * @type {Object}
   */

  var defaults = _extends({}, settings);

  var Breakpoints = {
    /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */
    match: function match(points) {
      if (typeof window.matchMedia !== 'undefined') {
        for (var point in points) {
          if (points.hasOwnProperty(point)) {
            if (window.matchMedia('(max-width: ' + point + 'px)').matches) {
              return points[point];
            }
          }
        }
      }

      return defaults;
    }
  };
  /**
   * Overwrite instance settings with currently matching breakpoint settings.
   * This happens right after component initialization.
   */

  _extends(settings, Breakpoints.match(points));
  /**
   * Update glide with settings of matched brekpoint:
   * - window resize to update slider
   */


  Binder.on('resize', window, throttle(function () {
    Glide.settings = mergeOptions(settings, Breakpoints.match(points));
  }, Glide.settings.throttle));
  /**
   * Resort and update default settings:
   * - on reinit via API, so breakpoint matching will be performed with options
   */

  Events.on('update', function () {
    points = sortBreakpoints(points);
    defaults = _extends({}, settings);
  });
  /**
   * Unbind resize listener:
   * - on destroying, to bring markup to its initial state
   */

  Events.on('destroy', function () {
    Binder.off('resize', window);
  });
  return Breakpoints;
}

var COMPONENTS = {
  // Required
  Html: Html,
  Translate: Translate,
  Transition: Transition,
  Direction: Direction,
  Peek: Peek,
  Sizes: Sizes,
  Gaps: Gaps,
  Move: Move,
  Clones: Clones,
  Resize: Resize,
  Build: Build,
  Run: Run,
  // Optional
  Swipe: Swipe,
  Images: Images,
  Anchors: Anchors,
  Controls: Controls,
  Keyboard: Keyboard,
  Autoplay: Autoplay,
  Breakpoints: Breakpoints
};

var Glide$1 = function (_Core) {
  inherits(Glide$$1, _Core);

  function Glide$$1() {
    classCallCheck(this, Glide$$1);
    return possibleConstructorReturn(this, (Glide$$1.__proto__ || Object.getPrototypeOf(Glide$$1)).apply(this, arguments));
  }

  createClass(Glide$$1, [{
    key: 'mount',
    value: function mount() {
      var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return get(Glide$$1.prototype.__proto__ || Object.getPrototypeOf(Glide$$1.prototype), 'mount', this).call(this, _extends({}, COMPONENTS, extensions));
    }
  }]);
  return Glide$$1;
}(Glide);

var GlideCarouselControls = function GlideCarouselControls(props) {
  return /*#__PURE__*/jsxs(GlideArrows, {
    className: "glide__arrows",
    "data-glide-el": "controls",
    children: [/*#__PURE__*/jsx(GlideLeft, {
      className: "glide__arrow glide__arrow--left",
      "data-glide-dir": "<",
      children: /*#__PURE__*/jsx(Icon, {
        name: "DisplayLeft",
        color: theme.colors.rOnyx
      })
    }), /*#__PURE__*/jsx(GlideRight, {
      className: "glide__arrow glide__arrow--right",
      "data-glide-dir": ">",
      children: /*#__PURE__*/jsx(Icon, {
        name: "DisplayRight",
        color: theme.colors.rOnyx
      })
    })]
  }); // return (
  //   <Flex justifyContent="center" className="glide" marginTop="large" {...props}>
  //     {Array.from({ length: props.slides }).map((slide, i) => (
  //       <BulletContainer
  //         justifyContent={{ mobile: 'center' }}
  //         alignItems={{ mobile: 'center' }}
  //         active={i === props.active}
  //         key={i}
  //       >
  //         <Bullet active={i === props.active} />
  //       </BulletContainer>
  //     ))}
  //   </Flex>
  // );
}; // const Bullet = styled(Flex) <ContainerBulletProps>`
//   width: ${rem(16)};
//   height: ${rem(16)};
//   background: ${theme.colors.black};
//   border-radius: 50%;
// `;
// const BulletContainer = styled(Flex) <ContainerBulletProps>`
//   width: ${rem(24)};
//   height: ${rem(24)};
//   border-radius: 50%;
//   &:not(:first-child) {
//     margin-left: ${rem(12)};
//   }
//   ${({ active }) => active && `background: ${theme.colors.black15} `};
// `;

var GlideArrows = styled.div.withConfig({
  displayName: "GlideCarouselControls__GlideArrows",
  componentId: "ifuqsa-0"
})(["direction:ltr;@media ", "{max-width:", ";margin:0 auto;}@media (max-width:1024px){display:none;}"], theme.device.desktop, rem(theme.grid.contentMaxWidth));
var GlideLeft = styled.div.withConfig({
  displayName: "GlideCarouselControls__GlideLeft",
  componentId: "ifuqsa-1"
})(["position:absolute;top:40%;@media ", "{left:-1.25rem;}display:flex;justify-content:center;padding:12px;z-index:150;background:", ";box-shadow:0px 1px 4px rgba(0,15,51,0.2);border-radius:100px;&:hover{cursor:pointer;background:", ";}"], theme.device.tablet, theme.colors.rWhite, theme.colors.rGhost);
var GlideRight = styled.div.withConfig({
  displayName: "GlideCarouselControls__GlideRight",
  componentId: "ifuqsa-2"
})(["position:absolute;top:40%;@media ", "{right:", ";}@media ", "{right:-1.25rem;}display:flex;justify-content:center;padding:12px;z-index:150;background:", ";box-shadow:0px 1px 4px rgba(0,15,51,0.2);border-radius:100px;&:hover{cursor:pointer;background:", ";}"], theme.device.tablet, rem(theme.grid.horizontalMargin.tablet), theme.device.laptop, theme.colors.rWhite, theme.colors.rGhost);

var _excluded$c = ["glideOptions", "hideControls"];
var defaultOptions = {
  type: 'carousel',
  direction: 'ltr',
  autoplay: 1,
  hoverpause: true,
  gap: 24,
  focusAt: 0
};

var _StyledUl = styled("ul").withConfig({
  displayName: "GlideCarousel___StyledUl",
  componentId: "lb6xn1-0"
})(["direction:ltr;padding:", ";"], function (p) {
  return p._css;
});

var GlideCarousel = function GlideCarousel(_ref) {
  var glideOptions = _ref.glideOptions,
      hideControls = _ref.hideControls,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$c);

  var _useState = useState(0),
      active = _useState[0],
      setActive = _useState[1];

  var glideRef = useRef(null);
  useEffect(function () {
    if (!glideRef.current) return; // @ts-ignore

    var glide = new Glide$1(glideRef.current, _extends$2({}, defaultOptions, glideOptions));
    glide.on(['mount.before', 'run'], function () {
      // @ts-ignore
      setActive(glide.index);
    });
    var glideInstance = glide.mount();
    return function () {
      return glideInstance.destroy();
    };
  }, [glideOptions]);
  return /*#__PURE__*/jsxs("div", _extends$2({
    className: "glide",
    ref: glideRef
  }, props, {
    children: [/*#__PURE__*/jsx("div", {
      className: "glide__track",
      "data-glide-el": "track",
      children: /*#__PURE__*/jsx(_StyledUl, {
        className: "glide__slides",
        _css: rem(theme.sizes.xmini),
        children: props.children
      })
    }), !hideControls && /*#__PURE__*/jsx(GlideCarouselControls, {
      active: active,
      slides: props.children.length
    })]
  }));
};
var GlideCarouselItem = function GlideCarouselItem(_ref2) {
  var children = _ref2.children,
      templateCard = _ref2.templateCard,
      autoplay = _ref2.autoplay;
  return /*#__PURE__*/jsx(GlideSlide, {
    templateCard: templateCard,
    autoplay: autoplay,
    className: "glide__slide",
    children: children
  });
};
var GlideSlide = styled.li.withConfig({
  displayName: "GlideCarousel__GlideSlide",
  componentId: "lb6xn1-1"
})(["@media (max-width:768px){display:flex;justify-content:center;flex-direction:column;}@media (min-width:767px){width:auto !important;}img{margin:auto;}", " ", ""], function (_ref3) {
  var templateCard = _ref3.templateCard;
  return templateCard && "img {\n      border-radius: " + rem(8) + ";\n    }\n  ";
}, function (_ref4) {
  var autoplay = _ref4.autoplay;
  return autoplay && "width: auto !important;\n  ";
});

var _excluded$b = ["children"];
var IconList = function IconList(_ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$b);

  return /*#__PURE__*/jsx(Flex, _extends$2({
    fullwidth: true,
    flexDirection: {
      mobile: 'column'
    },
    justifyContent: {
      mobile: 'flex-start'
    }
  }, rest, {
    children: children
  }));
};

var _excluded$a = ["icon", "children"];

var _StyledFlex$r = styled(Flex).withConfig({
  displayName: "IconListItem___StyledFlex",
  componentId: "sc-1dsvpqa-0"
})(["&:not(:first-child){margin-top:", ";}& >:last-child{margin-left:", ";}"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
});

var _StyledFlex2$c = styled(Flex).withConfig({
  displayName: "IconListItem___StyledFlex2",
  componentId: "sc-1dsvpqa-1"
})(["max-width:100%;height:", ";"], function (p) {
  return p._css3;
});

var _StyledDiv$8 = styled("div").withConfig({
  displayName: "IconListItem___StyledDiv",
  componentId: "sc-1dsvpqa-2"
})(["flex-grow:1;"]);

var IconListItem = function IconListItem(_ref) {
  var icon = _ref.icon,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$a);

  return /*#__PURE__*/jsxs(_StyledFlex$r, _extends$2({
    alignItems: "center",
    justifyContent: "flex-start",
    fullwidth: true
  }, rest, {
    _css: rem(theme.sizes.mini),
    _css2: rem(theme.sizes.xmini),
    children: [icon && /*#__PURE__*/jsx(_StyledFlex2$c, {
      alignItems: "center",
      _css3: textVariants.paragraphM.lineHeight,
      children: /*#__PURE__*/jsx(Icon, {
        name: icon.name
      })
    }), /*#__PURE__*/jsx(_StyledDiv$8, {
      children: children
    })]
  }));
};

var _excluded$9 = ["active", "children", "onChange", "hideOnLaptop"];

var _StyledNav = styled("nav").withConfig({
  displayName: "HorizontalMenu___StyledNav",
  componentId: "sc-1ooe9mp-0"
})(["display:flex;justify-content:center;flex-wrap:wrap;row-gap:", ";column-gap:", ";width:100%;white-space:nowrap;overflow-x:auto;&::-webkit-scrollbar{display:none;}"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
});

var HorizontalMenu = function HorizontalMenu(_ref) {
  var active = _ref.active,
      children = _ref.children,
      onChange = _ref.onChange,
      hideOnLaptop = _ref.hideOnLaptop,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$9);

  var _useMedia = useMedia(),
      isLaptop = _useMedia.isLaptop;

  if (isLaptop && hideOnLaptop) {
    return null;
  }

  return /*#__PURE__*/jsx(_StyledNav, _extends$2({
    "aria-labelledby": "tabs-navigation"
  }, rest, {
    _css: rem(theme.sizes.small),
    _css2: rem(theme.sizes.large),
    children: Children.map(children, function (child, index) {
      return /*#__PURE__*/cloneElement(child, {
        onClick: function onClick() {
          if (onChange) onChange(index);
        },
        isActive: active === index
      });
    })
  }));
};

var _excluded$8 = ["children", "isActive", "variant", "color", "activeColor", "backgroundColor"];

var _StyledDiv$7 = styled("div").withConfig({
  displayName: "HorizontalMenuItem___StyledDiv",
  componentId: "sc-1n91ndw-0"
})(["display:inline-block;"]);

var _StyledDiv2$4 = styled("div").withConfig({
  displayName: "HorizontalMenuItem___StyledDiv2",
  componentId: "sc-1n91ndw-1"
})(["position:relative;display:flex;justify-content:center;padding:", " ", " ", " ", ";&:after{content:'';position:absolute;bottom:0;width:100%;height:", ";background:", ";opacity:0;transform:scaleX(0);transition:transform 0.2s ", ",opacity 0.1s ", " 0.1s;", "}"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
}, function (p) {
  return p._css5;
}, function (p) {
  return p._css6;
}, function (p) {
  return p._css7;
}, function (p) {
  return p._css8;
}, function (p) {
  return p._css9;
});

var _StyledText$h = styled(Text).withConfig({
  displayName: "HorizontalMenuItem___StyledText",
  componentId: "sc-1n91ndw-2"
})(["cursor:pointer;transition:color 0.2s ", ";&:active,&:hover{color:", ";}"], function (p) {
  return p._css10;
}, function (p) {
  return p._css11;
});

var HorizontalMenuItem = function HorizontalMenuItem(_ref) {
  var children = _ref.children,
      isActive = _ref.isActive,
      variant = _ref.variant,
      color = _ref.color,
      activeColor = _ref.activeColor,
      backgroundColor = _ref.backgroundColor,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$8);

  return /*#__PURE__*/jsx(_StyledDiv$7, _extends$2({}, rest, {
    children: /*#__PURE__*/jsx(_StyledDiv2$4, {
      _css: rem(theme.sizes.tiny),
      _css2: rem(theme.sizes.tiny),
      _css3: rem(isActive ? 6 : theme.sizes.xmini),
      _css4: rem(theme.sizes.tiny),
      _css5: rem(theme.sizes.xtiny),
      _css6: activeColor ? theme.colors[activeColor] : 'rBlack',
      _css7: theme.transitions.easeInOut,
      _css8: theme.transitions.easeInOut,
      _css9: isActive && " opacity: 1;\n              transform: scaleX(1);\n              transition: transform .2s " + theme.transitions.easeInOut + ", opacity .1s " + theme.transitions.easeInOut + ";\n            ",
      children: /*#__PURE__*/jsx(_StyledText$h, {
        variant: variant != null ? variant : 'paragraphMBold',
        $color: isActive ? activeColor : color,
        _css10: theme.transitions.easeInOut,
        _css11: isActive ? activeColor : backgroundColor === 'rBlack' ? theme.colors['rLavender'] : theme.colors.rOnyx,
        children: children
      })
    })
  }));
};

var _excluded$7 = ["strengthText", "strength"];

var _StyledFlex$q = styled(Flex).withConfig({
  displayName: "PasswordInput___StyledFlex",
  componentId: "yp4wam-0"
})(["background:", ";border-radius:", ";"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
});

var _StyledFlex2$b = styled(Flex).withConfig({
  displayName: "PasswordInput___StyledFlex2",
  componentId: "yp4wam-1"
})(["background:", ";width:", "%;transition:width 0.4s ", ";height:", ";border-radius:", ";"], function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
}, function (p) {
  return p._css5;
}, function (p) {
  return p._css6;
}, function (p) {
  return p._css7;
});

var PasswordInput = function PasswordInput(_ref) {
  var _strengthBackground$s;

  var strengthText = _ref.strengthText,
      strength = _ref.strength,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$7);

  var _ref2 = (_strengthBackground$s = strengthBackground[strength]) != null ? _strengthBackground$s : {},
      color = _ref2.color,
      percentage = _ref2.percentage;

  return /*#__PURE__*/jsxs(Flex, {
    flexDirection: "column",
    children: [/*#__PURE__*/jsx(Input, _extends$2({}, rest, {
      variant: "password",
      status: strength === 'weak' ? 'error' : rest.status
    })), strength && /*#__PURE__*/jsx(_StyledFlex$q, {
      flexDirection: "row",
      marginTop: "xmini",
      _css: theme.colors.cloud,
      _css2: rem(100),
      children: /*#__PURE__*/jsx(_StyledFlex2$b, {
        "data-cy": "passwordStrength",
        _css3: color ? theme.colors[color] : 'none',
        _css4: percentage != null ? percentage : '0',
        _css5: theme.transitions.easeInOut,
        _css6: rem(4),
        _css7: rem(100)
      })
    }), strength && /*#__PURE__*/jsx(Text, {
      "data-cy": "passwordStrengthMessage",
      variant: "paragraphS",
      $color: strength === 'weak' ? color : 'coal',
      marginTop: "xtiny",
      children: strengthText
    })]
  });
};
var strengthBackground = {
  weak: {
    color: 'danger',
    percentage: 33
  },
  medium: {
    color: 'secondary',
    percentage: 66
  },
  strong: {
    color: 'edu',
    percentage: 100
  }
};

var PricingCardContent = styled.div.withConfig({
  displayName: "PricingCardstyles__PricingCardContent",
  componentId: "xf3289-0"
})(["display:flex;position:relative;flex-direction:column;align-items:center;min-width:", ";max-width:", ";height:", ";margin:0 auto;border-radius:", ";padding:", " ", " ", " ", ";text-align:center;", " ", ""], rem(256), rem(272), rem(336), rem(8), rem(theme.sizes.medium), rem(theme.sizes.medium), rem(theme.sizes.large), rem(theme.sizes.medium), function (_ref) {
  var border = _ref.border;
  return border && "\n       border: " + rem(1) + " solid " + theme.colors[border] + ";\n    ";
}, function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor && "\n       background: " + (backgroundColor ? theme.colors[backgroundColor] : 'none') + ";\n    ";
});
var PeopleWrapper = styled.div.withConfig({
  displayName: "PricingCardstyles__PeopleWrapper",
  componentId: "xf3289-1"
})(["", " ", ""], function (_ref3) {
  var BackgroundColor = _ref3.BackgroundColor;
  return BackgroundColor && "\n  background: " + theme.colors[BackgroundColor] + ";\n  padding: " + rem(8) + " " + rem(16) + ";\n  border-radius: " + rem(24) + ";\n  display: flex;\n\n  position: absolute;\n  top: " + rem(126) + ";\n  gap: " + rem(8) + ";\n";
}, function (_ref4) {
  var color = _ref4.color;
  return color && "\n  color: " + theme.colors[color] + ";\n";
});
var HighlightBannerContainer = styled.div.withConfig({
  displayName: "PricingCardstyles__HighlightBannerContainer",
  componentId: "xf3289-2"
})(["position:absolute;right:", ";top:0;display:flex;flex-direction:column;align-items:end;"], rem(-6));
var HighlightBannerWrapper = styled.div.withConfig({
  displayName: "PricingCardstyles__HighlightBannerWrapper",
  componentId: "xf3289-3"
})(["", " ", " display:inline-flex;padding:", ";justify-content:flex-end;align-items:center;gap:", ";margin-top:", ";"], function (_ref5) {
  var ribbonBackgroundColor = _ref5.ribbonBackgroundColor;
  return ribbonBackgroundColor && "\n      background: " + theme.colors[ribbonBackgroundColor] + ";\n  ";
}, function (_ref6) {
  var ribbonBorderRadius = _ref6.ribbonBorderRadius;
  return ribbonBorderRadius && "\n      border-radius: " + ribbonBorderRadius + "px;\n  ";
}, rem(theme.sizes.tiny), rem(theme.sizes.tiny), rem(theme.sizes.tiny));

var EURO_CURRENCY = '€';
var DOLAR_CURRENCY = '$';
var USD_TEXT = 'usd';
var setCurrency = function setCurrency(price, currency) {
  var priceValue = price.text;

  if (priceValue.includes(EURO_CURRENCY) && currency == '"' + USD_TEXT + '"') {
    var splitedPrice = priceValue.split(EURO_CURRENCY);
    return DOLAR_CURRENCY + splitedPrice[0] + splitedPrice[1];
  }

  return price.text;
};

var _StyledDiv$6 = styled("div").withConfig({
  displayName: "PricingCard___StyledDiv",
  componentId: "sc-8fnpzf-0"
})(["position:absolute;top:", ";"], function (p) {
  return p._css;
});

var _StyledText$g = styled(Text).withConfig({
  displayName: "PricingCard___StyledText",
  componentId: "sc-8fnpzf-1"
})(["text-decoration:line-through 3px;text-decoration-color:", ";"], function (p) {
  return p._css2;
});

var _StyledFlex$p = styled(Flex).withConfig({
  displayName: "PricingCard___StyledFlex",
  componentId: "sc-8fnpzf-2"
})(["display:block;font-weight:unset;"]);

var _StyledFlex2$a = styled(Flex).withConfig({
  displayName: "PricingCard___StyledFlex2",
  componentId: "sc-8fnpzf-3"
})(["display:block;font-weight:unset;"]);

var _StyledFlex3$7 = styled(Flex).withConfig({
  displayName: "PricingCard___StyledFlex3",
  componentId: "sc-8fnpzf-4"
})(["display:block;font-weight:unset;"]);

var _StyledDiv2$3 = styled("div").withConfig({
  displayName: "PricingCard___StyledDiv2",
  componentId: "sc-8fnpzf-5"
})(["display:inline;font-size:15px;font-style:normal;font-weight:400;line-height:20px;"]);

var _StyledFlex4$4 = styled(Flex).withConfig({
  displayName: "PricingCard___StyledFlex4",
  componentId: "sc-8fnpzf-6"
})(["display:block;"]);

var _StyledDiv3 = styled("div").withConfig({
  displayName: "PricingCard___StyledDiv3",
  componentId: "sc-8fnpzf-7"
})(["display:inline;font-size:15px;font-style:normal;font-weight:400;line-height:20px;"]);

var _StyledDiv4 = styled("div").withConfig({
  displayName: "PricingCard___StyledDiv4",
  componentId: "sc-8fnpzf-8"
})(["display:inline;font-size:15px;font-style:normal;font-weight:400;line-height:20px;"]);

var _StyledIcon$3 = styled(Icon).withConfig({
  displayName: "PricingCard___StyledIcon",
  componentId: "sc-8fnpzf-9"
})(["width:67px !important;height:67px !important;"]);

var _StyledButtonLink$3 = styled(ButtonLink).withConfig({
  displayName: "PricingCard___StyledButtonLink",
  componentId: "sc-8fnpzf-10"
})(["position:absolute;top:", ";max-width:", ";"], function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

var PricingCard = function PricingCard(_ref) {
  var _highlightBanner$type;

  var backgroundColor = _ref.backgroundColor,
      border = _ref.border,
      title = _ref.title,
      description = _ref.description,
      price = _ref.price,
      people = _ref.people,
      highlightBanner = _ref.highlightBanner,
      ribbonBackgroundColor = _ref.ribbonBackgroundColor,
      ribbonBorderRadius = _ref.ribbonBorderRadius,
      ribbonIcon = _ref.ribbonIcon,
      peopleBackground = _ref.peopleBackground,
      membersMonthText = _ref.membersMonthText,
      icon = _ref.icon,
      iconColor = _ref.iconColor,
      priceText = _ref.priceText,
      recurring = _ref.recurring,
      priceDescription = _ref.priceDescription,
      button = _ref.button,
      _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? '"usd"' : _ref$currency,
      getCurrency = _ref.getCurrency,
      priceFromAPI = _ref.priceFromAPI,
      discountPercentage = _ref.discountPercentage,
      crossedOutPrice = _ref.crossedOutPrice,
      crossedOutLineColor = _ref.crossedOutLineColor,
      plans = _ref.plans;

  var _useState = useState({
    price: 0,
    currency: ''
  }),
      newPrice = _useState[0],
      setNewPrice = _useState[1]; // 2: usando como filtro el plan name, sacamos el objeto de ese array de planes


  useEffect(function () {
    var obj = plans === null || plans === void 0 ? void 0 : plans.find(function (obj) {
      var _title$text;

      return obj.name === (title === null || title === void 0 ? void 0 : (_title$text = title.text) === null || _title$text === void 0 ? void 0 : _title$text.replace(/ /g, ''));
    });

    if (obj) {
      // 2.1:  seteamos en un state propio el precio, currency, etc
      if (obj.name === 'Pro') {
        var _newPrice = obj.tiers[0].unitAmount / 100;

        setNewPrice({
          price: parseFloat(_newPrice.toFixed(2)),
          currency: obj.currency
        });
      } else {
        var _newPrice2 = obj.tiers[0].unitAmount / 100 / 12;

        setNewPrice({
          price: parseFloat(_newPrice2.toFixed(2)),
          currency: obj.currency
        });
      }
    }
  }, [plans, title]);
  return /*#__PURE__*/jsxs(PricingCardContent, {
    backgroundColor: backgroundColor,
    border: border,
    children: [title && /*#__PURE__*/jsx(Text, {
      variant: "paragraphLBold",
      $color: title.color,
      children: title.text
    }), description && /*#__PURE__*/jsx(Text, {
      variant: "paragraphS",
      $color: backgroundColor === 'white' ? 'black' : description.color,
      marginTop: "small",
      children: /*#__PURE__*/jsx(HtmlParser, {
        children: description.text
      })
    }), /*#__PURE__*/jsx(Fragment$1, {
      children: price && /*#__PURE__*/jsxs(Fragment$1, {
        children: [price.text && /*#__PURE__*/jsxs(Fragment$1, {
          children: [people && /*#__PURE__*/jsxs(PeopleWrapper, {
            BackgroundColor: peopleBackground,
            color: priceText ? priceText.color : 'rWhite',
            children: [/*#__PURE__*/jsx(Icon, {
              name: "Collaborative",
              color: priceText ? priceText.color : 'rWhite'
            }), /*#__PURE__*/jsx(Text, {
              variant: "paragraphXS",
              $color: priceText ? priceText.color : 'rAkihabara',
              children: people
            })]
          }), highlightBanner && /*#__PURE__*/jsxs(HighlightBannerContainer, {
            children: [/*#__PURE__*/jsxs(HighlightBannerWrapper, {
              ribbonBorderRadius: ribbonBorderRadius,
              ribbonBackgroundColor: ribbonBackgroundColor,
              children: [/*#__PURE__*/jsx(Icon, {
                name: ribbonIcon === null || ribbonIcon === void 0 ? void 0 : ribbonIcon.name,
                color: theme.colors[ribbonIcon !== null && ribbonIcon !== void 0 && ribbonIcon.ribbonIconColor ? ribbonIcon === null || ribbonIcon === void 0 ? void 0 : ribbonIcon.ribbonIconColor : 'rWhite'],
                family: ribbonIcon === null || ribbonIcon === void 0 ? void 0 : ribbonIcon.sheet
              }), /*#__PURE__*/jsx(Text, {
                variant: (_highlightBanner$type = highlightBanner === null || highlightBanner === void 0 ? void 0 : highlightBanner.type) != null ? _highlightBanner$type : 'paragraphS',
                $color: highlightBanner.color,
                children: highlightBanner.text
              })]
            }), /*#__PURE__*/jsx("svg", {
              width: 5,
              height: 5,
              display: ribbonBorderRadius ? 'none' : 'visible',
              children: /*#__PURE__*/jsx("polygon", {
                points: "0,0 0,7 7,0 0",
                fill: theme.colors[ribbonBackgroundColor ? ribbonBackgroundColor : 'rWhite']
              })
            })]
          }), /*#__PURE__*/jsxs(_StyledDiv$6, {
            _css: rem(170),
            children: [/*#__PURE__*/jsx(_StyledText$g, {
              variant: "paragraphMBold",
              $color: priceText ? priceText.color : 'rAkihabara',
              _css2: theme.colors[crossedOutLineColor ? crossedOutLineColor : 'rWhite'],
              children: crossedOutPrice && (newPrice.currency === 'EUR' ? /*#__PURE__*/jsx(_StyledFlex$p, {
                children: "\n                            " + parseFloat(newPrice.price.toFixed(2)) + convertCurrency(newPrice.currency) + (recurring !== null && recurring !== void 0 && recurring.text ? recurring === null || recurring === void 0 ? void 0 : recurring.text : '') + "\n                            "
              }) : /*#__PURE__*/jsx(_StyledFlex2$a, {
                children: "\n                            " + convertCurrency(newPrice.currency) + parseFloat(newPrice.price.toFixed(2)) + (recurring !== null && recurring !== void 0 && recurring.text ? recurring === null || recurring === void 0 ? void 0 : recurring.text : '') + "\n                            "
              }))
            }), /*#__PURE__*/jsx(Text, {
              variant: "paragraphXLBold",
              $color: priceText ? priceText.color : 'rAkihabara',
              children: !priceFromAPI ? getCurrency ? /*#__PURE__*/jsx(Fragment$1, {
                children: setCurrency(price, currency)
              }) : /*#__PURE__*/jsx(Loading, {
                size: 24,
                color: "white"
              }) : newPrice.currency === 'EUR' ? /*#__PURE__*/jsxs(_StyledFlex3$7, {
                children: [discountPercentage && discountPercentage > 0 ? (parseFloat(newPrice.price.toFixed(2)) - parseFloat(newPrice.price.toFixed(2)) * discountPercentage / 100).toFixed(2) : parseFloat(newPrice.price.toFixed(2)), /*#__PURE__*/jsxs(_StyledDiv2$3, {
                  children: [convertCurrency(newPrice.currency), recurring !== null && recurring !== void 0 && recurring.text ? recurring === null || recurring === void 0 ? void 0 : recurring.text : '']
                })]
              }) : /*#__PURE__*/jsx(_StyledFlex4$4, {
                children: /*#__PURE__*/jsxs("div", {
                  children: [/*#__PURE__*/jsx(_StyledDiv3, {
                    children: convertCurrency(newPrice.currency)
                  }), discountPercentage ? (parseFloat(newPrice.price.toFixed(2)) - parseFloat(newPrice.price.toFixed(2)) * discountPercentage / 100).toFixed(2) : parseFloat(newPrice.price.toFixed(2)), /*#__PURE__*/jsx(_StyledDiv4, {
                    children: recurring !== null && recurring !== void 0 && recurring.text ? recurring === null || recurring === void 0 ? void 0 : recurring.text : ''
                  })]
                })
              })
            }), priceDescription && priceText && priceText.color && /*#__PURE__*/jsx(Text, {
              variant: "paragraphXS",
              $color: priceText ? priceText.color : 'rAkihabara',
              children: priceDescription.text
            }), /*#__PURE__*/jsx(Text, {
              variant: "paragraphS",
              $color: priceText ? priceText.color : 'rAkihabara',
              children: membersMonthText ? membersMonthText : null
            })]
          })]
        }), !price.text && icon && /*#__PURE__*/jsx(_StyledIcon$3, {
          color: iconColor,
          name: icon === null || icon === void 0 ? void 0 : icon.name,
          iconSize: 'medium',
          family: icon === null || icon === void 0 ? void 0 : icon.sheet
        })]
      })
    }), button && /*#__PURE__*/jsx(_StyledButtonLink$3, {
      href: button.href,
      variant: button.variant,
      "data-cy": button.dataCy ? button.dataCy : undefined,
      fullwidth: true,
      size: "default",
      _css3: rem(280),
      _css4: rem(208),
      children: button.value
    })]
  });
};

function convertCurrency(currency) {
  switch (currency) {
    case 'EUR':
      return '€';

    case 'USD':
      return '$';
  }
}

var _StyledLink$2 = styled(Link).withConfig({
  displayName: "PricingTab___StyledLink",
  componentId: "sc-1bomlx2-0"
})(["width:100%;@media ", "{width:unset;}"], function (p) {
  return p._css;
});

var _StyledFlex$o = styled(Flex).withConfig({
  displayName: "PricingTab___StyledFlex",
  componentId: "sc-1bomlx2-1"
})(["border-radius:", " ", " 0 0};background:", ";padding:", " 0px;height:", ";width:100%;@media ", "{width:", ";height:", ";}"], function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
}, function (p) {
  return p._css5;
}, function (p) {
  return p._css6;
}, function (p) {
  return p._css7;
}, function (p) {
  return p._css8;
}, function (p) {
  return p._css9;
});

var _StyledText$f = styled(Text).withConfig({
  displayName: "PricingTab___StyledText",
  componentId: "sc-1bomlx2-2"
})(["display:none;@media ", "{display:block;}"], function (p) {
  return p._css10;
});

var PricingTab = function PricingTab(_ref) {
  var isActive = _ref.isActive,
      href = _ref.href,
      title = _ref.title,
      description = _ref.description,
      dataCy = _ref.dataCy;
  var textColor = isActive ? 'black' : 'coal';
  return /*#__PURE__*/jsx(_StyledLink$2, {
    href: href,
    "data-cy": dataCy ? dataCy : undefined,
    _css: theme.device.laptop,
    children: /*#__PURE__*/jsxs(_StyledFlex$o, {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      _css2: rem(8),
      _css3: rem(8),
      _css4: isActive ? theme.colors.white : theme.colors.cloud,
      _css5: rem(12),
      _css6: rem(48),
      _css7: theme.device.laptop,
      _css8: rem(268),
      _css9: rem(63),
      children: [/*#__PURE__*/jsx(Text, {
        variant: "spanMBold",
        $color: textColor,
        children: title
      }), /*#__PURE__*/jsx(_StyledText$f, {
        variant: "paragraphXS",
        $color: textColor,
        _css10: theme.device.laptop,
        children: description
      })]
    })
  });
};

var _StyledFlex$n = styled(Flex).withConfig({
  displayName: "DividerWithText___StyledFlex",
  componentId: "sc-11bmyhb-0"
})(["white-space:nowrap;"]);

var _StyledText$e = styled(Text).withConfig({
  displayName: "DividerWithText___StyledText",
  componentId: "sc-11bmyhb-1"
})(["white-space:nowrap;"]);

var DividerWithText = function DividerWithText(props) {
  return /*#__PURE__*/jsxs(_StyledFlex$n, {
    role: "separator",
    flexDirection: "row",
    alignItems: {
      mobile: 'center'
    },
    justifyContent: {
      mobile: 'space-between'
    },
    children: [/*#__PURE__*/jsx(Divider, {
      $color: props.dividerColor
    }), /*#__PURE__*/jsx(_StyledText$e, {
      $color: props.textColor,
      variant: props.variant,
      marginLeft: "xmini",
      marginRight: "xmini",
      children: props.text
    }), /*#__PURE__*/jsx(Divider, {
      $color: props.dividerColor
    })]
  });
};

var _excluded$6 = ["children"];
var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$6);

  return /*#__PURE__*/jsx(TooltipBox, _extends$2({
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
  }, rest, {
    children: /*#__PURE__*/jsx(Text, {
      variant: "paragraphS",
      $color: "white",
      as: "span",
      children: children
    })
  }));
};
var TooltipBox = styled(Flex).withConfig({
  displayName: "Tooltip__TooltipBox",
  componentId: "l72wj4-0"
})(["position:relative;border-radius:", ";min-width:", ";height:", ";padding:", " ", ";background-color:", ";pointer-events:none;&:after{content:'';position:absolute;top:100%;border:", ";border-style:solid;border-color:", " transparent transparent transparent;}"], rem(4), rem(76), rem(24), rem(theme.sizes.tiny), rem(theme.sizes.xmini), theme.colors.black, rem(4), theme.colors.black);

var _StyledFlex$m = styled(Flex).withConfig({
  displayName: "VerticalMenu___StyledFlex",
  componentId: "sc-1cqwti4-0"
})(["gap:", ";"], function (p) {
  return p._css;
});

var VerticalMenu = function VerticalMenu(_ref) {
  var active = _ref.active,
      children = _ref.children,
      onChange = _ref.onChange;
  return /*#__PURE__*/jsx(_StyledFlex$m, {
    flexDirection: "column",
    justifyContent: "flex-start",
    _css: rem(theme.sizes.small),
    children: Children.map(children, function (child, index) {
      return /*#__PURE__*/cloneElement(child, {
        onClick: function onClick() {
          if (onChange) onChange(index);
        },
        isActive: active === index,
        isOpen: active === index
      });
    })
  });
};

var _excluded$5 = ["children", "title", "isActive", "isOpen", "textAlign"];

var _StyledText$d = styled(Text).withConfig({
  displayName: "VerticalMenuItemBasic___StyledText",
  componentId: "ccwnjm-0"
})(["cursor:pointer;transition:color 0.2s ", ";&:hover{color:", ";}&:active{color:", ";}"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var VerticalMenuItemBasic = function VerticalMenuItemBasic(_ref) {
  var _title$type;

  var children = _ref.children,
      title = _ref.title,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      textAlign = _ref.textAlign,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$5);

  return /*#__PURE__*/jsxs(VerticalMenuItem, _extends$2({
    flexDirection: "column",
    justifyContent: "flex-start",
    role: "region"
  }, rest, {
    children: [title && /*#__PURE__*/jsx(Header$1, {
      isActive: isActive,
      isOpen: isOpen,
      children: /*#__PURE__*/jsx(_StyledText$d, {
        variant: (_title$type = title.type) != null ? _title$type : 'paragraphMBold',
        $color: isActive ? title.color : 'rGranite',
        _css: theme.transitions.easeInOut,
        _css2: title.color ? theme.colors[title.color] : theme.colors.black,
        _css3: title.color ? theme.colors[title.color] : theme.colors.black,
        children: title.text
      })
    }), isOpen && /*#__PURE__*/jsx(_StyledContent, {
      isActive: isActive,
      isOpen: isOpen,
      textAlign: textAlign ? textAlign : 'center',
      _css4: theme.animations.fadeInDown,
      _css5: theme.transitions.easeInOut,
      children: children
    })]
  }));
};
var VerticalMenuItem = styled(Flex).withConfig({
  displayName: "VerticalMenuItemBasic__VerticalMenuItem",
  componentId: "ccwnjm-1"
})(["cursor:pointer;width:100%;"]);
var Header$1 = styled.div.withConfig({
  displayName: "VerticalMenuItemBasic__Header",
  componentId: "ccwnjm-2"
})(["display:flex;justify-content:center;padding:", ";margin-right:auto;margin-bottom:", ";cursor:pointer;position:relative;&:after{content:'';position:absolute;bottom:0;height:", ";width:100%;background:", ";opacity:0;transform:scaleX(0);transition:transform 0.2s ", ",opacity 0.1s ", " 0.1s;", "}"], (rem(theme.sizes.xtiny), rem(theme.sizes.tiny), rem(6), rem(theme.sizes.tiny)), rem(theme.sizes.small), rem(2), theme.colors.rBlack, theme.transitions.easeInOut, theme.transitions.easeInOut, function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen && "opacity: 1;\n      transform: scaleX(1);\n      transition: transform .2s " + theme.transitions.easeInOut + ", opacity .1s " + theme.transitions.easeInOut + ";\n    ";
});
var Content$1 = styled.div.withConfig({
  displayName: "VerticalMenuItemBasic__Content",
  componentId: "ccwnjm-3"
})(["margin-bottom:", ";", ";"], rem(theme.sizes.small), function (_ref3) {
  var textAlign = _ref3.textAlign;
  return textAlign && 'text-align: ' + textAlign;
});

var _StyledContent = styled(Content$1).withConfig({
  displayName: "VerticalMenuItemBasic___StyledContent",
  componentId: "ccwnjm-4"
})(["animation:", " 1s ", ";animation-fill-mode:both;"], function (p) {
  return p._css4;
}, function (p) {
  return p._css5;
});

var _excluded$4 = ["children", "title", "variant", "isActive", "isOpen", "order"];
var Header = styled(Flex).withConfig({
  displayName: "VerticalMenuItemNumeric__Header",
  componentId: "sc-1caowdi-0"
})(["cursor:pointer;padding:", ";position:relative;"], (rem('2px'), rem('4px'), rem('6px'), rem('4px')));
var Content = styled.div.withConfig({
  displayName: "VerticalMenuItemNumeric__Content",
  componentId: "sc-1caowdi-1"
})(["opacity:", ";max-height:", ";overflow:hidden;transition:", ";padding-bottom:", ";margin-bottom:", ";margin-left:", ";text-align:left;"], function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen ? '1' : '0';
}, function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? '100%' : '0';
}, function (_ref3) {
  var isOpen = _ref3.isOpen;
  return isOpen ? 'all 0.2s ease-out' : 'all 0.1s ease-in';
}, function (_ref4) {
  var isOpen = _ref4.isOpen;
  return isOpen ? rem('16px') : '0';
}, rem('18px'), rem(theme.sizes.xmini));

var _StyledText$c = styled(Text).withConfig({
  displayName: "VerticalMenuItemNumeric___StyledText",
  componentId: "sc-1caowdi-2"
})(["cursor:pointer;transition:color 0.2s ", ";&:hover{color:", ";}&:active{color:", ";}"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var VerticalMenuItemNumeric = function VerticalMenuItemNumeric(_ref5) {
  var children = _ref5.children,
      title = _ref5.title,
      variant = _ref5.variant,
      _ref5$isActive = _ref5.isActive,
      isActive = _ref5$isActive === void 0 ? false : _ref5$isActive,
      _ref5$isOpen = _ref5.isOpen,
      isOpen = _ref5$isOpen === void 0 ? false : _ref5$isOpen,
      order = _ref5.order,
      rest = _objectWithoutPropertiesLoose$2(_ref5, _excluded$4);

  var activeColor = isActive ? 'primary' : 'cement';
  return /*#__PURE__*/jsx(VerticalMenuItem, _extends$2({
    flexDirection: {
      mobile: 'row'
    },
    justifyContent: {
      mobile: 'flex-start'
    },
    role: "region"
  }, rest, {
    children: /*#__PURE__*/jsxs(Header, {
      justifyContent: {
        mobile: 'center'
      },
      marginRight: "auto",
      children: [order && /*#__PURE__*/jsx(Text, {
        $color: isActive ? 'primary' : 'cement',
        variant: "title2",
        children: order < 10 ? '0' + order : order
      }), /*#__PURE__*/jsxs(Flex, {
        alignItems: {
          mobile: 'flex-start'
        },
        flexDirection: {
          mobile: 'column'
        },
        marginLeft: "xmini",
        marginBottom: "medium",
        children: [/*#__PURE__*/jsx(_StyledText$c, {
          $color: activeColor,
          marginTop: "xmini",
          marginLeft: "xmini",
          variant: variant != null ? variant : 'paragraphM',
          _css: theme.transitions.easeInOut,
          _css2: activeColor,
          _css3: activeColor,
          children: title
        }), /*#__PURE__*/jsx(Content, {
          isActive: isActive,
          isOpen: isOpen,
          children: children
        })]
      })]
    })
  }));
};

var _StyledFlex$l = styled(Flex).withConfig({
  displayName: "layoutFourcolSection___StyledFlex",
  componentId: "sc-17lbk52-0"
})(["width:100%;height:100%;line-height:0;gap:", ";"], function (p) {
  return p._css;
});

var layoutFourcolSection = function layoutFourcolSection(_ref) {
  var children = _ref.children,
      gap = _ref.gap;
  return /*#__PURE__*/jsxs(_StyledFlex$l, {
    id: "layout-4col",
    flexDirection: {
      mobile: 'column',
      tablet: 'column',
      laptop: 'row'
    },
    _css: gap ? gap + 'px' : 'unset',
    children: [/*#__PURE__*/jsx("div", {
      style: {
        flex: 1,
        display: 'flex'
      },
      children: children && children.map(function (element) {
        if ((element === null || element === void 0 ? void 0 : element.props.behaviorSettings.layout_paragraphs.region) === 'first') {
          return element;
        }
      })
    }), /*#__PURE__*/jsx("div", {
      style: {
        flex: 1,
        display: 'flex'
      },
      children: children && children.map(function (element) {
        if ((element === null || element === void 0 ? void 0 : element.props.behaviorSettings.layout_paragraphs.region) === 'second') {
          return element;
        }
      })
    }), /*#__PURE__*/jsx("div", {
      style: {
        flex: 1,
        display: 'flex'
      },
      children: children && children.map(function (element) {
        if ((element === null || element === void 0 ? void 0 : element.props.behaviorSettings.layout_paragraphs.region) === 'third') {
          return element;
        }
      })
    }), /*#__PURE__*/jsx("div", {
      style: {
        flex: 1,
        display: 'flex'
      },
      children: children && children.map(function (element) {
        if ((element === null || element === void 0 ? void 0 : element.props.behaviorSettings.layout_paragraphs.region) === 'fourth') {
          return element;
        }
      })
    })]
  });
};

var _StyledDiv$5 = styled("div").withConfig({
  displayName: "layoutOnecol___StyledDiv",
  componentId: "sc-1r4481c-0"
})(["width:100%;height:100%;line-height:0;display:flex;flex-direction:", ";align-items:", ";"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
});

var layoutOnecol = function layoutOnecol(_ref) {
  var children = _ref.children,
      direction = _ref.direction,
      alignItems = _ref.alignItems;
  return /*#__PURE__*/jsx(_StyledDiv$5, {
    id: "layout-1col",
    _css: direction,
    _css2: alignItems,
    children: children && children.map(function (element) {
      if ((element === null || element === void 0 ? void 0 : element.props.behaviorSettings.layout_paragraphs.region) === 'content') {
        return element;
      }
    })
  });
};

var _StyledFlex$k = styled(Flex).withConfig({
  displayName: "layoutThreecolSection___StyledFlex",
  componentId: "d7ayyu-0"
})(["width:100%;height:100%;line-height:0;gap:", ";flex-direction:", ";@media ", "{flex-direction:", ";}"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

var layoutThreecolSection = function layoutThreecolSection(_ref) {
  var children = _ref.children,
      gap = _ref.gap,
      flip = _ref.flip,
      flipMobile = _ref.flipMobile;
  return /*#__PURE__*/jsxs(_StyledFlex$k, {
    id: "layout-3col",
    flexDirection: {
      mobile: 'column',
      tablet: 'column',
      laptop: 'row'
    },
    _css: gap ? gap + 'px' : 'unset',
    _css2: flipMobile ? 'column-reverse' : 'column',
    _css3: theme.device.laptop,
    _css4: flip ? 'row-reverse' : 'row',
    children: [/*#__PURE__*/jsx("div", {
      style: {
        flex: 1,
        display: 'flex'
      },
      children: children && children.map(function (element) {
        if ((element === null || element === void 0 ? void 0 : element.props.behaviorSettings.layout_paragraphs.region) === 'first') {
          return element;
        }
      })
    }), /*#__PURE__*/jsx("div", {
      style: {
        flex: 1,
        display: 'flex'
      },
      children: children && children.map(function (element) {
        if ((element === null || element === void 0 ? void 0 : element.props.behaviorSettings.layout_paragraphs.region) === 'second') {
          return element;
        }
      })
    }), /*#__PURE__*/jsx("div", {
      style: {
        flex: 1,
        display: 'flex'
      },
      children: children && children.map(function (element) {
        if ((element === null || element === void 0 ? void 0 : element.props.behaviorSettings.layout_paragraphs.region) === 'third') {
          return element;
        }
      })
    })]
  });
};

var _StyledFlex$j = styled(Flex).withConfig({
  displayName: "layoutTwocolSection___StyledFlex",
  componentId: "sc-14advp5-0"
})(["width:100%;height:100%;line-height:0;gap:", ";flex-direction:", ";@media ", "{flex-direction:", ";}"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

var _StyledDiv$4 = styled("div").withConfig({
  displayName: "layoutTwocolSection___StyledDiv",
  componentId: "sc-14advp5-1"
})(["flex:", ";display:flex;"], function (p) {
  return p._css5;
});

var _StyledDiv2$2 = styled("div").withConfig({
  displayName: "layoutTwocolSection___StyledDiv2",
  componentId: "sc-14advp5-2"
})(["flex:", ";display:flex;"], function (p) {
  return p._css6;
});

var layoutTwocolSection = function layoutTwocolSection(_ref) {
  var children = _ref.children,
      type = _ref.type,
      gap = _ref.gap,
      flip = _ref.flip,
      flipMobile = _ref.flipMobile;
  var firstCol = '50%';
  var secondCol = '50%';

  if (type === '25-75') {
    firstCol = '25%';
    secondCol = '75%';
  }

  switch (type) {
    case '25-75':
      firstCol = '25%';
      secondCol = '75%';
      break;

    case '33-67':
      firstCol = '33%';
      secondCol = '67%';
      break;

    case '50-50':
      firstCol = '50%';
      secondCol = '50%';
      break;

    case '67-33':
      firstCol = '67%';
      secondCol = '33%';
      break;

    case '75-25':
      firstCol = '75%';
      secondCol = '25%';
      break;

    default:
      firstCol = '50%';
      secondCol = '50%';
      break;
  }

  return /*#__PURE__*/jsxs(_StyledFlex$j, {
    id: "layout-2col",
    flexDirection: {
      mobile: 'column',
      tablet: 'column',
      laptop: 'row'
    },
    _css: gap ? gap + 'px' : 'unset',
    _css2: flipMobile ? 'column-reverse' : 'column',
    _css3: theme.device.laptop,
    _css4: flip ? 'row-reverse' : 'row',
    children: [/*#__PURE__*/jsx(_StyledDiv$4, {
      _css5: firstCol,
      children: children && children.map(function (element) {
        if ((element === null || element === void 0 ? void 0 : element.props.behaviorSettings.layout_paragraphs.region) === 'first') {
          return element;
        }
      })
    }), /*#__PURE__*/jsx(_StyledDiv2$2, {
      _css6: secondCol,
      children: children && children.map(function (element) {
        if ((element === null || element === void 0 ? void 0 : element.props.behaviorSettings.layout_paragraphs.region) === 'second') {
          return element;
        }
      })
    })]
  });
};

var layouts = {
  layout_onecol: layoutOnecol,
  layout_twocol_section: layoutTwocolSection,
  layout_threecol_section: layoutThreecolSection,
  layout_fourcol_section: layoutFourcolSection
};
var Columns = function Columns(_ref) {
  var _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? 'layout_twocol_section' : _ref$layout,
      layoutType = _ref.layoutType,
      children = _ref.children,
      background = _ref.background,
      customSpacing = _ref.customSpacing,
      general = _ref.general,
      borders = _ref.borders,
      link = _ref.link,
      hovers = _ref.hovers;
  var Element = layouts[layout];

  if (layout === 'layout_onecol') {
    return /*#__PURE__*/jsx(WithLink$1, {
      path: link === null || link === void 0 ? void 0 : link.url.path,
      fullWidth: general !== null && general !== void 0 && general.fullWidth ? true : false,
      HoverColor: hovers !== null && hovers !== void 0 && hovers.enabled && hovers !== null && hovers !== void 0 && hovers.color.color ? hovers.color.color : background === null || background === void 0 ? void 0 : background.color,
      children: /*#__PURE__*/jsx(SimpleSection, {
        id: "onecol-wrapper",
        background: background,
        fullWidth: general !== null && general !== void 0 && general.fullWidth ? true : false,
        minHeight: general === null || general === void 0 ? void 0 : general.minHeight,
        borders: borders,
        borderRad: {
          leftTop: borders === null || borders === void 0 ? void 0 : borders.borderRadiusTopLeft,
          rightTop: borders === null || borders === void 0 ? void 0 : borders.borderRadiusTopRight,
          leftBottom: borders === null || borders === void 0 ? void 0 : borders.borderRadiusBottomLeft,
          rightBottom: borders === null || borders === void 0 ? void 0 : borders.borderRadiusBottomRight
        },
        hovers: hovers,
        children: /*#__PURE__*/jsx(ComponentContainer, {
          customSpacing: customSpacing,
          children: /*#__PURE__*/jsx(Element, {
            direction: (general === null || general === void 0 ? void 0 : general.direction) === 'vertical' ? 'column' : 'row',
            alignItems: general === null || general === void 0 ? void 0 : general.verticalAlign,
            type: layoutType,
            children: children
          })
        })
      })
    });
  }

  return /*#__PURE__*/jsx(Section, {
    background: background,
    style: {
      width: '100%'
    },
    id: layout,
    children: /*#__PURE__*/jsx(ComponentContainer, {
      customSpacing: customSpacing,
      children: /*#__PURE__*/jsx(Element, {
        type: layoutType,
        gap: general === null || general === void 0 ? void 0 : general.gap,
        flip: general === null || general === void 0 ? void 0 : general.flip,
        flipMobile: general === null || general === void 0 ? void 0 : general.flipMobile,
        children: children
      })
    })
  });
};

var _StyledA$1 = styled("a").withConfig({
  displayName: "Columns___StyledA",
  componentId: "sc-1u10zdc-0"
})(["display:", ";width:", ";text-decoration:none;&:hover{cursor:pointer;", "}"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var WithLink$1 = function WithLink(_ref2) {
  var path = _ref2.path,
      children = _ref2.children,
      fullWidth = _ref2.fullWidth,
      HoverColor = _ref2.HoverColor;
  return path ? /*#__PURE__*/jsx(_StyledA$1, {
    href: path,
    _css: fullWidth ? 'block' : 'inline',
    _css2: fullWidth ? '100%' : 'auto',
    _css3: HoverColor === 'rBlack' || HoverColor === 'black' || HoverColor === 'rAkihabara' ? "p svg {\n                color: " + theme.colors['rWhite'] + ";\n              &:hover {\n                color:  " + theme.colors['rLavender'] + " !important;\n              }\n          }" : "&:hover {\n                p,svg {\n                color: " + theme.colors['rGranite'] + " !important;\n              }",
    children: children
  }) : children;
};

var _StyledText$b = styled(Text).withConfig({
  displayName: "Paragraph___StyledText",
  componentId: "sc-1ekswt6-0"
})(["p{font-weight:inherit;}"]);

var Paragraph = function Paragraph(_ref) {
  var _paragraph$type;

  var background = _ref.background,
      customSpacing = _ref.customSpacing,
      paragraph = _ref.paragraph;

  function removeTags(str) {
    if (str === null || str === '') return false;else str = str.toString();
    str = str.replace(/(<([^>]+)>)/gi, '');
    str = str.slice(0, -1);
    return str;
  }

  return /*#__PURE__*/jsx(SimpleSection, {
    background: background,
    id: 'ParagraphParagraph',
    children: /*#__PURE__*/jsx(ComponentContainer, {
      customSpacing: customSpacing,
      atomicComponent: true,
      children: paragraph && /*#__PURE__*/jsx(ParagraphWrapper, {
        backgroundColor: background === null || background === void 0 ? void 0 : background.color,
        children: /*#__PURE__*/jsx(_StyledText$b, {
          variant: (_paragraph$type = paragraph.type) != null ? _paragraph$type : 'paragraphM',
          "data-cy": removeTags(paragraph.text),
          $color: paragraph.color,
          children: /*#__PURE__*/jsx(HtmlParser, {
            children: paragraph.text
          })
        })
      })
    })
  });
};

var AccordionColumn = styled.div.withConfig({
  displayName: "Accordionstyles__AccordionColumn",
  componentId: "sc-150u28x-0"
})(["flex:0 0 50%;width:100%;@media ", "{padding:0 ", ";}"], theme.device.laptop, rem(theme.sizes.xlarge));

var AccordionItemContent = styled.div.withConfig({
  displayName: "AccordionItemstyles__AccordionItemContent",
  componentId: "sc-1h9t2j1-0"
})(["padding-bottom:", ";&:not(:last-child){margin-bottom:", ";border-bottom:", " solid ", ";}"], rem(theme.sizes.medium), rem(theme.sizes.medium), rem(1), theme.colors.rLavender);
var AccordionItemHeader = styled(Flex).withConfig({
  displayName: "AccordionItemstyles__AccordionItemHeader",
  componentId: "sc-1h9t2j1-1"
})(["cursor:pointer;overflow:hidden;"]);
var AccordionItemPanel = styled.div.withConfig({
  displayName: "AccordionItemstyles__AccordionItemPanel",
  componentId: "sc-1h9t2j1-2"
})(["transform:translateY(", ");opacity:0;height:0px;overflow:hidden;", " transition:transform .2s ", ",opacity .2s ", ";"], rem('-20px'), function (_ref) {
  var isExpanded = _ref.isExpanded;
  return !isExpanded && "\n    opacity: 1;\n    height: auto;\n    margin-top: " + rem(theme.sizes.small) + ";  \n    transform: translateY(0px);\n    ";
}, theme.transitions.easeInOut, theme.transitions.easeInOut);

var _StyledText$a = styled(Text).withConfig({
  displayName: "AccordionItem___StyledText",
  componentId: "sc-1lxpx6s-0"
})(["flex-grow:1;"]);

var _StyledFlex$i = styled(Flex).withConfig({
  displayName: "AccordionItem___StyledFlex",
  componentId: "sc-1lxpx6s-1"
})(["max-width:100%;height:", ";"], function (p) {
  return p._css;
});

var AccordionItem = function AccordionItem(_ref) {
  var _paragraph$color, _paragraph$text;

  var id = _ref.id,
      title = _ref.title,
      paragraph = _ref.paragraph,
      isExpanded = _ref.isExpanded,
      background = _ref.background,
      onClick = _ref.onClick;
  return /*#__PURE__*/jsxs(AccordionItemContent, {
    children: [/*#__PURE__*/jsxs(AccordionItemHeader, {
      id: id + '-header',
      "aria-controls": id + "-panel",
      "aria-expanded": isExpanded,
      onClick: onClick,
      justifyContent: {
        mobile: 'space-between'
      },
      children: [/*#__PURE__*/jsx(_StyledText$a, {
        variant: 'title2ldm',
        $color: title === null || title === void 0 ? void 0 : title.color,
        children: title === null || title === void 0 ? void 0 : title.text
      }), /*#__PURE__*/jsx(_StyledFlex$i, {
        alignItems: "center",
        marginLeft: 10,
        _css: textVariants.paragraphM.lineHeight,
        children: /*#__PURE__*/jsx(Icon, {
          name: isExpanded ? 'MinusBig' : 'PlusBig',
          color: title === null || title === void 0 ? void 0 : title.color,
          secondaryColor: theme.colors.rBlack
        })
      })]
    }), /*#__PURE__*/jsx(AccordionItemPanel, {
      id: id + "-panel",
      "aria-labelledby": id + "-header",
      isExpanded: !isExpanded,
      children: /*#__PURE__*/jsx(ParagraphWrapper, {
        backgroundColor: background === null || background === void 0 ? void 0 : background.color,
        children: /*#__PURE__*/jsx(Text, {
          variant: "paragraphM",
          $color: (_paragraph$color = paragraph === null || paragraph === void 0 ? void 0 : paragraph.color) != null ? _paragraph$color : 'rBlack',
          children: /*#__PURE__*/jsx(HtmlParser, {
            children: (_paragraph$text = paragraph === null || paragraph === void 0 ? void 0 : paragraph.text) != null ? _paragraph$text : ''
          })
        })
      })
    })]
  });
};

var _StyledFlex$h = styled(Flex).withConfig({
  displayName: "Accordion___StyledFlex",
  componentId: "sc-6u5fh0-0"
})(["gap:", ";@media ", "{gap:", ";}"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var Accordion = function Accordion(_ref) {
  var _subtitle$type, _subtitle$color, _title$type;

  var _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? 'fadeInUp' : _ref$animation,
      background = _ref.background,
      customSpacing = _ref.customSpacing,
      subtitle = _ref.subtitle,
      title = _ref.title,
      text = _ref.text,
      button = _ref.button,
      accordionItems = _ref.accordionItems;

  var _useState = useState(),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  return /*#__PURE__*/jsx(Section, {
    background: background,
    children: /*#__PURE__*/jsx(Animation, {
      type: animation,
      children: /*#__PURE__*/jsx(ComponentContainer, {
        customSpacing: customSpacing,
        children: /*#__PURE__*/jsxs(_StyledFlex$h, {
          alignItems: {
            tablet: 'center'
          },
          flexDirection: {
            mobile: 'column',
            laptop: 'row'
          },
          justifyContent: "center",
          _css: rem(theme.sizes.xhuge),
          _css2: theme.device.laptop,
          _css3: rem(theme.sizes.medium),
          children: [(subtitle || title || text || button) && /*#__PURE__*/jsxs(AccordionColumn, {
            children: [subtitle && /*#__PURE__*/jsx(Text, {
              variant: (_subtitle$type = subtitle.type) != null ? _subtitle$type : 'paragraphMBold',
              $color: (_subtitle$color = subtitle.color) != null ? _subtitle$color : 'rAkihabara',
              uppercase: true,
              children: subtitle.text
            }), title && /*#__PURE__*/jsx(Text, {
              variant: (_title$type = title.type) != null ? _title$type : 'title2XXL',
              marginTop: "xmini",
              $color: title.color,
              children: title.text
            }), text && /*#__PURE__*/jsx(ParagraphWrapper, {
              backgroundColor: background === null || background === void 0 ? void 0 : background.color,
              children: /*#__PURE__*/jsx(Text, {
                variant: "paragraphM",
                marginTop: "small",
                $color: text.color,
                children: /*#__PURE__*/jsx(HtmlParser, {
                  children: text.text
                })
              })
            }), button && /*#__PURE__*/jsx(Flex, {
              marginTop: "large",
              children: /*#__PURE__*/jsx(ButtonLink, {
                href: button.href,
                variant: button.variant,
                size: "big",
                children: button.title
              })
            })]
          }), accordionItems && /*#__PURE__*/jsx(AccordionColumn, {
            children: accordionItems === null || accordionItems === void 0 ? void 0 : accordionItems.map(function (element, index) {
              return /*#__PURE__*/jsx(AccordionItem, {
                id: element.id,
                title: element.title,
                paragraph: element.paragraph,
                isExpanded: isExpanded === index,
                onClick: function onClick() {
                  return isExpanded === index ? setIsExpanded(undefined) : setIsExpanded(index);
                }
              }, 'accordion-item' + index);
            })
          })]
        })
      })
    })
  });
};

var BannerContainer = styled.div.withConfig({
  displayName: "Bannerstyles__BannerContainer",
  componentId: "pw13lk-0"
})(["display:flex;align-items:center;flex-direction:column;text-align:center;margin:0 auto;width:100%;"]);

var _StyledText$9 = styled(Text).withConfig({
  displayName: "Banner___StyledText",
  componentId: "sc-1o41mfv-0"
})(["width:100%;@media ", "{max-width:100%;}@media ", "{max-width:calc((100% / 12) * 10);}"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
});

var _StyledText2$3 = styled(Text).withConfig({
  displayName: "Banner___StyledText2",
  componentId: "sc-1o41mfv-1"
})(["font-style:italic;width:100%;@media ", "{max-width:calc((100% / 12) * 10);}@media ", "{max-width:calc((100% / 12) * 8);}"], function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

var _StyledFlex$g = styled(Flex).withConfig({
  displayName: "Banner___StyledFlex",
  componentId: "sc-1o41mfv-2"
})(["width:100%;@media ", "{width:fit-content;}"], function (p) {
  return p._css5;
});

var Banner = function Banner(_ref) {
  var _title$type, _subtitle$type;

  var background = _ref.background,
      customSpacing = _ref.customSpacing,
      icon = _ref.icon,
      title = _ref.title,
      subtitle = _ref.subtitle,
      button = _ref.button,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? 'fadeInUp' : _ref$animation;
  return /*#__PURE__*/jsx(Section, {
    flex: true,
    background: background,
    children: /*#__PURE__*/jsx(Animation, {
      type: animation,
      children: /*#__PURE__*/jsx(ComponentContainer, {
        customSpacing: customSpacing,
        children: /*#__PURE__*/jsxs(BannerContainer, {
          children: [(icon === null || icon === void 0 ? void 0 : icon.icon.icon) && /*#__PURE__*/jsx(Icon, {
            color: theme.colors[icon !== null && icon !== void 0 && icon.iconColor ? icon === null || icon === void 0 ? void 0 : icon.iconColor : 'rBlack'],
            name: icon === null || icon === void 0 ? void 0 : icon.icon.icon.sprite,
            family: icon === null || icon === void 0 ? void 0 : icon.icon.icon.sheet,
            iconSize: icon === null || icon === void 0 ? void 0 : icon.iconSize
          }), title && /*#__PURE__*/jsx(_StyledText$9, {
            variant: (_title$type = title.type) != null ? _title$type : 'title2XXL',
            marginTop: "medium",
            $color: title.color,
            _css: theme.device.laptop,
            _css2: theme.device.desktop,
            children: title.text
          }), subtitle && /*#__PURE__*/jsx(_StyledText2$3, {
            variant: (_subtitle$type = subtitle.type) != null ? _subtitle$type : 'paragraphL',
            marginTop: "small",
            $color: subtitle.color,
            _css3: theme.device.laptop,
            _css4: theme.device.desktop,
            children: subtitle.text
          }), button && /*#__PURE__*/jsx(_StyledFlex$g, {
            marginTop: "xlarge",
            _css5: theme.device.tablet,
            children: /*#__PURE__*/jsx(ButtonLink, {
              href: button.href,
              size: button.size,
              variant: button.variant,
              fullwidth: true,
              children: button.children
            })
          })]
        })
      })
    })
  });
};

var Wrapper$1 = styled.div.withConfig({
  displayName: "Breadcrumbstyles__Wrapper",
  componentId: "j7fav8-0"
})(["position:relative;display:flex;overflow:auto;"]);
var Item = styled.div.withConfig({
  displayName: "Breadcrumbstyles__Item",
  componentId: "j7fav8-1"
})(["flex-shrink:0;text-decoration:none;"]);

var _StyledLink$1 = styled(Link).withConfig({
  displayName: "Breadcrumb___StyledLink",
  componentId: "sc-1a1dyv7-0"
})(["display:flex;align-items:center;"]);

var _StyledIcon$2 = styled(Icon).withConfig({
  displayName: "Breadcrumb___StyledIcon",
  componentId: "sc-1a1dyv7-1"
})(["", ""], function (p) {
  return p._css;
});

var Breadcrumb = function Breadcrumb(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/jsx(Wrapper$1, {
    children: items === null || items === void 0 ? void 0 : items.map(function (item, index, row) {
      if (!item.title) return;

      if (index + 1 === row.length) {
        return /*#__PURE__*/jsx("div", {
          style: {
            display: 'flex',
            flexShrink: 0
          },
          children: /*#__PURE__*/jsx(Text, {
            variant: 'paragraphSBold',
            children: item.title
          })
        }, index);
      }

      return /*#__PURE__*/jsx(Item, {
        children: /*#__PURE__*/jsxs(_StyledLink$1, {
          href: item.url,
          "data-cy": item.title,
          children: [/*#__PURE__*/jsx(Text, {
            variant: 'paragraphS',
            children: item.title
          }), /*#__PURE__*/jsx(_StyledIcon$2, {
            name: "DisplayRight",
            width: '14px',
            height: '14px',
            _css: 'margin: 0 4px'
          })]
        }, index)
      }, index);
    })
  });
};

var BrandsInfoContainer = styled.div.withConfig({
  displayName: "Brandsstyles__BrandsInfoContainer",
  componentId: "g8wt8e-0"
})(["display:flex;flex-direction:column;align-items:center;margin-bottom:", ";@media ", "{margin:0 auto;margin-bottom:", ";width:calc((100% / 12) * 10);}"], rem('40px'), theme.device.laptop, rem('40px'));

var _StyledDiv$3 = styled("div").withConfig({
  displayName: "Brands___StyledDiv",
  componentId: "sc-1810kpc-0"
})(["display:grid;grid-template-columns:repeat(2,1fr);align-items:center;justify-items:center;grid-gap:", " ", ";@media ", "{grid-gap:", " ", ";}@media ", "{grid-template-columns:repeat(4,1fr);grid-gap:", ";}"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
}, function (p) {
  return p._css5;
}, function (p) {
  return p._css6;
}, function (p) {
  return p._css7;
});

var _StyledDiv2$1 = styled("div").withConfig({
  displayName: "Brands___StyledDiv2",
  componentId: "sc-1810kpc-1"
})(["max-width:", ";"], function (p) {
  return p._css8;
});

var _StyledFlex$f = styled(Flex).withConfig({
  displayName: "Brands___StyledFlex",
  componentId: "sc-1810kpc-2"
})(["width:100%;"]);

var Brands = function Brands(_ref) {
  var _category$type, _title$type;

  var background = _ref.background,
      customSpacing = _ref.customSpacing,
      category = _ref.category,
      title = _ref.title,
      brands = _ref.brands,
      button = _ref.button,
      paragraph = _ref.paragraph,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? 'fadeInUp' : _ref$animation,
      _ref$first = _ref.first,
      first = _ref$first === void 0 ? false : _ref$first;

  var _useState = useState(true),
      header = _useState[0],
      setHeader = _useState[1];

  useEffect(function () {
    setHeader(category || title || paragraph ? true : false);
  }, []);
  return /*#__PURE__*/jsx(Section, {
    flex: true,
    background: background,
    children: /*#__PURE__*/jsx(Animation, {
      type: animation,
      children: /*#__PURE__*/jsx(ComponentContainer, {
        customSpacing: customSpacing,
        children: /*#__PURE__*/jsxs(Flex, {
          flexDirection: "column",
          alignItems: "center",
          children: [header && /*#__PURE__*/jsxs(BrandsInfoContainer, {
            children: [category && /*#__PURE__*/jsx(Text, {
              variant: (_category$type = category.type) != null ? _category$type : 'paragraphMBold',
              $color: category.color,
              center: true,
              children: category.text
            }), title && /*#__PURE__*/jsx(Text, {
              variant: (_title$type = title.type) != null ? _title$type : 'title2XXL',
              $color: title.color,
              center: true,
              marginTop: "xmini",
              children: title.text
            }), paragraph ? /*#__PURE__*/jsx(Flex, {
              marginTop: "small",
              children: /*#__PURE__*/jsx(ParagraphWrapper, {
                backgroundColor: background === null || background === void 0 ? void 0 : background.color,
                children: /*#__PURE__*/jsx(Text, {
                  variant: "paragraphL",
                  center: true,
                  $color: paragraph.color,
                  children: /*#__PURE__*/jsx(HtmlParser, {
                    children: paragraph.text
                  })
                })
              })
            }) : null]
          }), brands && brands.length > 0 && /*#__PURE__*/jsx(_StyledDiv$3, {
            _css: rem(theme.sizes.xlarge),
            _css2: rem(theme.sizes.small),
            _css3: theme.device.laptop,
            _css4: rem(theme.sizes.medium),
            _css5: rem(theme.sizes.small),
            _css6: theme.device.laptop,
            _css7: rem(theme.sizes.medium),
            children: brands === null || brands === void 0 ? void 0 : brands.map(function (brand, index) {
              return /*#__PURE__*/jsx(_StyledDiv2$1, {
                _css8: rem(288),
                children: /*#__PURE__*/jsx(Media, {
                  type: brand.type,
                  // @ts-ignore
                  src: brand.src,
                  alt: brand.alt,
                  width: brand.width,
                  height: brand.height,
                  first: first
                }, 'media-' + index)
              }, 'div-logo-' + index);
            })
          }), button && /*#__PURE__*/jsx(_StyledFlex$f, {
            flexDirection: {
              mobile: 'column',
              tablet: 'row'
            },
            justifyContent: {
              mobile: 'center'
            },
            marginTop: "xlarge",
            children: /*#__PURE__*/jsx(ButtonLink, {
              href: button.href,
              size: button.size,
              variant: button.variant,
              children: button.children
            })
          })]
        })
      })
    })
  });
};

var CardItem = styled(Media).withConfig({
  displayName: "CardItem",
  componentId: "mkvhid-0"
})(["", " box-shadow:", ";cursor:pointer;&:hover{box-shadow:", ";transform:scale(1.02);transition:transform 0.2s ", ";}", " transform:scale(1);transition:transform 0.2s ", ",box-shadow 0.2s ", ";"], function (_ref) {
  var templateCard = _ref.templateCard;
  return templateCard && "\n        border-radius: " + rem(8) + ";\n    ";
}, theme.shadows["short"], theme.shadows.shortHover, theme.transitions.easeInOut, function (_ref2) {
  var noPointer = _ref2.noPointer;
  return noPointer && "\n       cursor:unset;\n       &:hover {\n        box-shadow: " + theme.shadows["short"] + ";\n        transform: none;\n        transition: none;\n      }\n    ";
}, theme.transitions.easeInOut, theme.transitions.easeInOut);

var _StyledDiv$2 = styled("div").withConfig({
  displayName: "CardsCarouselItem___StyledDiv",
  componentId: "sc-18kpg1s-0"
})(["p{max-width:155px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;margin:8px auto;}"]);

var _StyledText$8 = styled(Text).withConfig({
  displayName: "CardsCarouselItem___StyledText",
  componentId: "sc-18kpg1s-1"
})(["margin:8px auto;:hover{color:", ";}"], function (p) {
  return p._css;
});

var CardsCarouselItem = function CardsCarouselItem(_ref) {
  var _element$url, _element$title$type, _element$title$type2;

  var element = _ref.element,
      templateCard = _ref.templateCard,
      autoplay = _ref.autoplay,
      backgroundColor = _ref.backgroundColor;
  var containerRef = useRef(null);

  var _useMedia = useMedia(),
      isTablet = _useMedia.isTablet;

  var style = {
    maxHeight: '240px',
    width: '100%'
  };
  var styleDevices = {
    maxHeight: '240px',
    width: 'auto'
  };
  return /*#__PURE__*/jsx(GlideCarouselItem, {
    templateCard: templateCard,
    autoplay: autoplay,
    children: /*#__PURE__*/jsx(_StyledDiv$2, {
      ref: containerRef,
      children: element.url ? /*#__PURE__*/jsxs(Link, {
        href: (_element$url = element.url) != null ? _element$url : '#',
        "data-cy": element.title && element.title.text,
        children: [/*#__PURE__*/jsxs(MediaWrapper$1, {
          children: [element.media && /*#__PURE__*/jsx(CardItem, {
            type: element.media.type,
            alt: element.media.alt,
            src: element.media.src,
            width: element.media.width,
            height: element.media.height,
            style: isTablet ? style : styleDevices,
            templateCard: templateCard
          }), templateCard && element.price === 'premium' && /*#__PURE__*/jsxs(PremiumWrapper$2, {
            children: [/*#__PURE__*/jsx(Icon, {
              name: "Premium",
              color: theme.colors.rPremium
            }), /*#__PURE__*/jsx(Text, {
              variant: 'paragraphXSBold',
              $color: 'rPremium',
              uppercase: true,
              style: {
                margin: 0
              },
              children: "premium"
            })]
          })]
        }), element.title && /*#__PURE__*/jsx(_StyledText$8, {
          variant: (_element$title$type = element.title.type) != null ? _element$title$type : 'paragraphSBold',
          $color: element.title.color ? element.title.color : backgroundColor === 'rBlack' || backgroundColor === 'black' ? 'rWhite' : 'rBlack',
          marginTop: "xmini",
          center: true,
          _css: backgroundColor ? backgroundColor === 'rBlack' || backgroundColor === 'black' ? theme.colors.rLavender : theme.colors.rGranite : theme.colors.rGranite,
          children: element.title.text
        })]
      }) : /*#__PURE__*/jsxs(MediaWrapper$1, {
        children: [element.media && /*#__PURE__*/jsx(CardItem, {
          type: element.media.type,
          alt: element.media.alt,
          src: element.media.src,
          width: element.media.width,
          height: element.media.height,
          style: isTablet ? style : styleDevices,
          templateCard: templateCard,
          noPointer: true
        }), element.price === 'premium' && /*#__PURE__*/jsxs(PremiumWrapper$2, {
          children: [/*#__PURE__*/jsx(Icon, {
            name: "Premium",
            color: theme.colors.rPremium
          }), /*#__PURE__*/jsx(Text, {
            variant: 'paragraphXSBold',
            $color: 'rPremium',
            uppercase: true,
            style: {
              margin: 0
            },
            children: "premium"
          })]
        }), element.title && /*#__PURE__*/jsx(Text, {
          variant: (_element$title$type2 = element.title.type) != null ? _element$title$type2 : 'paragraphSBold',
          $color: element.title.color ? element.title.color : backgroundColor === 'rBlack' || backgroundColor === 'black' ? 'rWhite' : 'rBlack',
          marginTop: "xmini",
          center: true,
          children: element.title.text
        })]
      })
    })
  });
};
var PremiumWrapper$2 = styled.div.withConfig({
  displayName: "CardsCarouselItem__PremiumWrapper",
  componentId: "sc-18kpg1s-2"
})(["display:flex;gap:", ";padding:", " ", ";border-radius:", ";align-items:center;background:", ";position:absolute;left:", ";bottom:", ";"], rem(4), rem(4), rem(5), rem(6), theme.colors.rBlack80, rem(8), rem(8));
var MediaWrapper$1 = styled.div.withConfig({
  displayName: "CardsCarouselItem__MediaWrapper",
  componentId: "sc-18kpg1s-3"
})(["position:relative;&:hover img{box-shadow:", ";transform:scale(1.02);transition:transform 0.2s ", ";}"], theme.shadows.shortHover, theme.transitions.easeInOut);

var glideCardsCarouselConfiguration = function glideCardsCarouselConfiguration(slider, direction, autoplay, startAt) {
  return autoplay === 1 ? {
    direction: direction,
    animationDuration: slider.length * 2000,
    animationTimingFunc: 'linear',
    autoplay: 1,
    gap: 24,
    rewind: true,
    startAt: startAt ? startAt : 0,
    breakpoints: {
      768: {
        perView: 1
      },
      1024: {
        perView: 2
      },
      1440: {
        perView: 4
      },
      9999: {
        perView: 4
      }
    }
  } : {
    direction: direction,
    autoplay: false,
    bound: true,
    startAt: startAt ? startAt : 0,
    peek: {
      before: 60,
      after: 60
    },
    rewind: true,
    rewindDuration: 1200,
    breakpoints: {
      768: {
        perView: 1
      },
      1024: {
        perView: 2
      },
      1440: {
        perView: 4
      },
      9999: {
        perView: 4
      }
    }
  };
};

var _StyledFlex$e = styled(Flex).withConfig({
  displayName: "CardsCarousel___StyledFlex",
  componentId: "sc-1qqey39-0"
})(["position:relative;"]);

var _StyledText$7 = styled(Text).withConfig({
  displayName: "CardsCarousel___StyledText",
  componentId: "sc-1qqey39-1"
})([":hover{color:", ";}"], function (p) {
  return p._css;
});

var _StyledGlideCarousel = styled(GlideCarousel).withConfig({
  displayName: "CardsCarousel___StyledGlideCarousel",
  componentId: "sc-1qqey39-2"
})(["position:relative;"]);

var _StyledGlideCarousel2 = styled(GlideCarousel).withConfig({
  displayName: "CardsCarousel___StyledGlideCarousel2",
  componentId: "sc-1qqey39-3"
})(["margin-top:", ";position:relative;"], function (p) {
  return p._css2;
});

var _StyledFlex2$9 = styled(Flex).withConfig({
  displayName: "CardsCarousel___StyledFlex2",
  componentId: "sc-1qqey39-4"
})(["width:100%;@media (max-width:768px){padding:0 ", ";}"], function (p) {
  return p._css3;
});

var _StyledFlex3$6 = styled(Flex).withConfig({
  displayName: "CardsCarousel___StyledFlex3",
  componentId: "sc-1qqey39-5"
})(["width:100%;@media ", "{width:unset;}"], function (p) {
  return p._css4;
});

var CardsCarousel = function CardsCarousel(_ref) {
  var _customSpacing$laptop, _customSpacing$laptop2, _customSpacing$deskto, _customSpacing$deskto2, _customSpacing$tablet, _customSpacing$tablet2, _customSpacing$mobile, _customSpacing$mobile2, _heading$type, _title$type, _title$type2, _subtitle$type, _firstSlider$concat, _firstSlider$concat2;

  var background = _ref.background,
      customSpacing = _ref.customSpacing,
      heading = _ref.heading,
      title = _ref.title,
      paragraph = _ref.paragraph,
      firstSlider = _ref.firstSlider,
      secondSlider = _ref.secondSlider,
      hideControls = _ref.hideControls,
      _ref$autoplay = _ref.autoplay,
      autoplay = _ref$autoplay === void 0 ? 1 : _ref$autoplay,
      buttons = _ref.buttons,
      _ref$templateCard = _ref.templateCard,
      templateCard = _ref$templateCard === void 0 ? false : _ref$templateCard,
      subtitle = _ref.subtitle,
      titleURL = _ref.titleURL,
      titlePosition = _ref.titlePosition;

  var _useMedia = useMedia(),
      isTablet = _useMedia.isTablet;

  var titleSpacing = {
    mobile: {
      top: 0,
      bottom: 16
    },
    tablet: {
      top: 0,
      bottom: 16
    },
    laptop: {
      top: 0,
      bottom: 16
    },
    desktop: {
      top: 0,
      bottom: 16
    }
  };
  var customSpacingData = {
    laptop: {
      enabled: 1,
      left: 0,
      right: 0,
      top: customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$laptop = customSpacing.laptop) === null || _customSpacing$laptop === void 0 ? void 0 : _customSpacing$laptop.top,
      bottom: customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$laptop2 = customSpacing.laptop) === null || _customSpacing$laptop2 === void 0 ? void 0 : _customSpacing$laptop2.bottom
    },
    desktop: {
      enabled: 1,
      left: 0,
      right: 0,
      top: customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$deskto = customSpacing.desktop) === null || _customSpacing$deskto === void 0 ? void 0 : _customSpacing$deskto.top,
      bottom: customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$deskto2 = customSpacing.desktop) === null || _customSpacing$deskto2 === void 0 ? void 0 : _customSpacing$deskto2.bottom
    },
    tablet: {
      enabled: 1,
      left: 0,
      right: 0,
      top: customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$tablet = customSpacing.tablet) === null || _customSpacing$tablet === void 0 ? void 0 : _customSpacing$tablet.top,
      bottom: customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$tablet2 = customSpacing.tablet) === null || _customSpacing$tablet2 === void 0 ? void 0 : _customSpacing$tablet2.bottom
    },
    mobile: {
      enabled: 1,
      left: 0,
      right: 0,
      top: customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$mobile = customSpacing.mobile) === null || _customSpacing$mobile === void 0 ? void 0 : _customSpacing$mobile.top,
      bottom: customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$mobile2 = customSpacing.mobile) === null || _customSpacing$mobile2 === void 0 ? void 0 : _customSpacing$mobile2.bottom
    }
  };
  return /*#__PURE__*/jsx(Section, {
    background: background,
    children: /*#__PURE__*/jsxs(ComponentContainer, {
      customSpacing: customSpacingData,
      fullWidth: true,
      children: [(heading || title || paragraph || titleURL) && /*#__PURE__*/jsx(ComponentContainer, {
        customSpacing: titleSpacing,
        children: /*#__PURE__*/jsxs(_StyledFlex$e, {
          flexDirection: {
            mobile: 'column'
          },
          children: [heading && /*#__PURE__*/jsx(Text, {
            variant: (_heading$type = heading.type) != null ? _heading$type : 'paragraphMBold',
            center: true,
            $color: heading.color,
            uppercase: true,
            marginBottom: 'xmini',
            children: heading.text
          }), title && (!titleURL ? /*#__PURE__*/jsx(Flex, {
            alignItems: titlePosition === 'left' ? 'flex-start' : 'center',
            justifyContent: titlePosition === 'left' ? 'flex-start' : 'center',
            fullwidth: true,
            children: /*#__PURE__*/jsx(Text, {
              variant: (_title$type = title.type) != null ? _title$type : 'title2',
              marginBottom: {
                mobile: 'medium',
                tablet: 'medium'
              },
              center: true,
              $color: title.color,
              children: title.text
            })
          }) : /*#__PURE__*/jsx(Flex, {
            alignItems: titlePosition === 'left' ? 'flex-start' : 'center',
            justifyContent: titlePosition === 'left' ? 'flex-start' : 'center',
            fullwidth: true,
            children: /*#__PURE__*/jsx(Link, {
              href: titleURL.url.path,
              "data-cy": title.text,
              children: /*#__PURE__*/jsx(_StyledText$7, {
                variant: (_title$type2 = title.type) != null ? _title$type2 : 'title2',
                marginBottom: {
                  mobile: 'xmini',
                  tablet: 'xmini'
                },
                $color: title.color,
                _css: background ? background.color === 'rBlack' ? theme.colors.rLavender : theme.colors.rGranite : theme.colors.rGranite,
                children: title.text
              })
            })
          })), subtitle && /*#__PURE__*/jsx(Text, {
            variant: (_subtitle$type = subtitle.type) != null ? _subtitle$type : 'paragraphLBold',
            $color: subtitle.color,
            marginBottom: {
              mobile: 'small',
              tablet: 'small'
            },
            center: true,
            children: subtitle.text
          }), paragraph && /*#__PURE__*/jsx(ParagraphWrapper, {
            backgroundColor: background === null || background === void 0 ? void 0 : background.color,
            children: /*#__PURE__*/jsx(Text, {
              variant: "paragraphL",
              center: true,
              marginBottom: "xlarge",
              $color: paragraph.color,
              children: /*#__PURE__*/jsx(HtmlParser, {
                children: paragraph.text
              })
            })
          })]
        })
      }), /*#__PURE__*/jsxs(CardsCarouselWrapper, {
        staticCarousel: autoplay ? false : true,
        children: [isTablet && hideControls === true && /*#__PURE__*/jsxs(Fragment$1, {
          children: [firstSlider && /*#__PURE__*/jsx(_StyledGlideCarousel, {
            hideControls: hideControls,
            autoplay: autoplay,
            glideOptions: glideCardsCarouselConfiguration(firstSlider, 'rtl', autoplay, firstSlider.length - 1),
            children: firstSlider === null || firstSlider === void 0 ? void 0 : firstSlider.map(function (element, index) {
              return /*#__PURE__*/jsx(CardsCarouselItem, {
                backgroundColor: background ? background.color : undefined,
                element: element,
                templateCard: templateCard || element.roundedBorder,
                autoplay: autoplay
              }, 'first-carousel-item' + index);
            })
          }), secondSlider && /*#__PURE__*/jsx(_StyledGlideCarousel2, {
            hideControls: hideControls,
            autoplay: autoplay,
            glideOptions: glideCardsCarouselConfiguration(secondSlider, 'ltr', autoplay, 0),
            _css2: rem(theme.sizes.xmini),
            children: secondSlider === null || secondSlider === void 0 ? void 0 : secondSlider.map(function (element, index) {
              return /*#__PURE__*/jsx(CardsCarouselItem, {
                backgroundColor: background ? background.color : undefined,
                element: element,
                templateCard: templateCard || element.roundedBorder,
                autoplay: autoplay
              }, 'second-carousel-item' + index);
            })
          })]
        }), !isTablet && /*#__PURE__*/jsxs(Fragment$1, {
          children: [firstSlider && secondSlider && /*#__PURE__*/jsx(GlideCarousel, {
            hideControls: hideControls,
            glideOptions: glideCardsCarouselConfiguration(firstSlider.concat(secondSlider), 'ltr', autoplay),
            children: (_firstSlider$concat = firstSlider.concat(secondSlider)) === null || _firstSlider$concat === void 0 ? void 0 : _firstSlider$concat.map(function (element, index) {
              return /*#__PURE__*/jsx(CardsCarouselItem, {
                backgroundColor: background ? background.color : undefined,
                element: element,
                templateCard: templateCard || element.roundedBorder,
                autoplay: autoplay
              }, 'mobile-carousel-item' + index);
            })
          }), firstSlider && !secondSlider && /*#__PURE__*/jsx(GlideCarousel, {
            hideControls: hideControls,
            glideOptions: glideCardsCarouselConfiguration(firstSlider, 'ltr', autoplay),
            children: firstSlider === null || firstSlider === void 0 ? void 0 : firstSlider.map(function (element, index) {
              return /*#__PURE__*/jsx(CardsCarouselItem, {
                backgroundColor: background ? background.color : undefined,
                element: element,
                templateCard: templateCard || element.roundedBorder,
                autoplay: autoplay
              }, 'mobile-carousel-item' + index);
            })
          })]
        }), isTablet && firstSlider && !secondSlider && hideControls == false && /*#__PURE__*/jsx(Fragment$1, {
          children: /*#__PURE__*/jsx(GlideCarousel, {
            hideControls: hideControls,
            glideOptions: glideCardsCarouselConfiguration(firstSlider, 'ltr', autoplay),
            children: firstSlider === null || firstSlider === void 0 ? void 0 : firstSlider.map(function (element, index) {
              return /*#__PURE__*/jsx(CardsCarouselItem, {
                backgroundColor: background ? background.color : undefined,
                element: element,
                templateCard: templateCard || element.roundedBorder,
                autoplay: autoplay
              }, 'mobile-carousel-item' + index);
            })
          })
        }), isTablet && !hideControls && firstSlider && secondSlider && /*#__PURE__*/jsx(Fragment$1, {
          children: firstSlider && secondSlider && /*#__PURE__*/jsx(GlideCarousel, {
            hideControls: hideControls,
            glideOptions: glideCardsCarouselConfiguration(firstSlider.concat(secondSlider), 'ltr', autoplay),
            children: (_firstSlider$concat2 = firstSlider.concat(secondSlider)) === null || _firstSlider$concat2 === void 0 ? void 0 : _firstSlider$concat2.map(function (element, index) {
              return /*#__PURE__*/jsx(CardsCarouselItem, {
                backgroundColor: background ? background.color : undefined,
                element: element,
                templateCard: templateCard || element.roundedBorder,
                autoplay: autoplay
              }, 'mobile-carousel-item' + index);
            })
          })
        })]
      }), buttons && buttons.length > 0 && /*#__PURE__*/jsx(_StyledFlex2$9, {
        flexDirection: {
          mobile: 'column',
          tablet: 'row'
        },
        alignItems: "center",
        justifyContent: 'center',
        marginTop: 'xlarge',
        _css3: rem(24),
        children: buttons === null || buttons === void 0 ? void 0 : buttons.map(function (button, index) {
          return /*#__PURE__*/createElement(_StyledFlex3$6, _extends$2({
            flexDirection: {
              mobile: 'column',
              tablet: 'row'
            },
            justifyContent: {
              tablet: 'flex-start'
            }
          }, index > 0 && {
            marginTop: {
              mobile: 'small',
              tablet: 0
            },
            marginLeft: {
              mobile: 0,
              tablet: 'small'
            }
          }, {
            key: 'button' + index,
            _css4: theme.device.tablet
          }), /*#__PURE__*/jsx(ButtonLink, {
            href: button.href,
            size: button.size,
            variant: button.variant,
            children: button.children
          }));
        })
      })]
    })
  });
};
var CardsCarouselWrapper = styled.div.withConfig({
  displayName: "CardsCarousel__CardsCarouselWrapper",
  componentId: "sc-1qqey39-6"
})(["max-width:100vw;", ""], function (_ref2) {
  var staticCarousel = _ref2.staticCarousel;
  return staticCarousel && "\n    @media " + theme.device.tablet + " {\n      padding-right: 0;\n      padding-left: 0;\n    }\n    @media " + theme.device.laptop + " {\n      padding-right: " + rem(theme.grid.horizontalMargin.laptop) + ";\n      padding-left: " + rem(theme.grid.horizontalMargin.laptop) + ";\n    }\n  ";
});
styled.div.withConfig({
  displayName: "CardsCarousel__ViewAll",
  componentId: "sc-1qqey39-7"
})(["position:absolute;right:0;@media ", "{right:40px;}bottom:26px;p{&:hover{color:", ";}}"], theme.device.tablet, theme.colors.rLavender);

var UpperMedia = styled.div.withConfig({
  displayName: "CardsGridItemstyles__UpperMedia",
  componentId: "sc-1vwj2ut-0"
})(["margin:", " 0 ", " 0;@media ", "{margin-top:", ";}"], rem(theme.sizes.medium), rem(theme.sizes.small), theme.device.laptop, rem(theme.sizes.medium));

var _StyledText$6 = styled(Text).withConfig({
  displayName: "CardsGridItem___StyledText",
  componentId: "pei35e-0"
})([":hover{color:", ";}"], function (p) {
  return p._css;
});

var CardsGridItem = function CardsGridItem(_ref) {
  var _element$url, _element$heading$type;

  var element = _ref.element,
      templateCard = _ref.templateCard,
      elementsPerRow = _ref.elementsPerRow,
      masonry = _ref.masonry,
      backgroundColor = _ref.backgroundColor;
  return /*#__PURE__*/jsxs(CardItemWrapper, {
    masonry: masonry,
    children: [element.upperMedia && /*#__PURE__*/jsx(UpperMedia, {
      children: /*#__PURE__*/jsx("img", {
        alt: element.upperMedia.alt,
        width: 90,
        src: element.upperMedia.src
      })
    }), /*#__PURE__*/jsxs(Link, {
      href: (_element$url = element.url) != null ? _element$url : '#',
      "data-cy": element.title && element.title.text,
      children: [element.media && /*#__PURE__*/jsxs(MediaWrapper, {
        children: [/*#__PURE__*/jsx(CardItem, {
          type: element.media.type,
          alt: element.media.alt,
          src: element.media.src,
          width: element.media.width,
          templateCard: templateCard
        }), templateCard && element.price === 'premium' && /*#__PURE__*/jsxs(PremiumWrapper$1, {
          children: [/*#__PURE__*/jsx(Icon, {
            name: "Premium",
            color: theme.colors.rPremium
          }), /*#__PURE__*/jsx(Text, {
            variant: 'paragraphXSBold',
            $color: 'rPremium',
            uppercase: true,
            style: {
              margin: 0
            },
            children: "premium"
          })]
        })]
      }), element.heading && /*#__PURE__*/jsx(Text, {
        variant: (_element$heading$type = element.heading.type) != null ? _element$heading$type : 'paragraphMBold',
        $color: element.heading.color,
        uppercase: true,
        marginTop: "small",
        children: element.heading.text
      }), element.title && /*#__PURE__*/jsx(_StyledText$6, {
        variant: templateCard ? 'paragraphSBold' : element.title.type ? element.title.type : elementsPerRow && elementsPerRow > 3 ? 'paragraphSBold' : 'paragraphMBold',
        $color: element.title.color ? element.title.color : backgroundColor === 'rBlack' || backgroundColor === 'black' ? 'rWhite' : 'rBlack',
        marginTop: element.heading ? 0 : 'xmini',
        center: element.heading || element.paragraph ? false : true,
        _css: backgroundColor ? backgroundColor === 'rBlack' || backgroundColor === 'black' ? theme.colors.rLavender : theme.colors.rGranite : theme.colors.rGranite,
        children: element.title.text
      })]
    }), element.paragraph && /*#__PURE__*/jsx(ParagraphWrapper, {
      backgroundColor: backgroundColor,
      children: /*#__PURE__*/jsx(Text, {
        variant: "paragraphM",
        marginTop: "xmini",
        $color: element.paragraph.color,
        children: /*#__PURE__*/jsx(HtmlParser, {
          children: element.paragraph.text
        })
      })
    })]
  });
};
var CardItemWrapper = styled.div.withConfig({
  displayName: "CardsGridItem__CardItemWrapper",
  componentId: "pei35e-1"
})(["", " page-break-inside:avoid;break-inside:avoid;width:100%;"], function (_ref2) {
  var masonry = _ref2.masonry;
  return masonry && "\n      padding-bottom: " + rem(24) + ";\n    ";
});
var PremiumWrapper$1 = styled.div.withConfig({
  displayName: "CardsGridItem__PremiumWrapper",
  componentId: "pei35e-2"
})(["display:flex;gap:", ";padding:", " ", ";border-radius:", ";align-items:center;background:", ";position:absolute;left:", ";bottom:", ";"], rem(4), rem(4), rem(5), rem(6), theme.colors.rBlack80, rem(8), rem(8));
var MediaWrapper = styled.div.withConfig({
  displayName: "CardsGridItem__MediaWrapper",
  componentId: "pei35e-3"
})(["position:relative;&:hover img{box-shadow:", ";transform:scale(1.02);transition:transform 0.2s ", ";}"], theme.shadows.shortHover, theme.transitions.easeInOut);

var _StyledFlex$d = styled(Flex).withConfig({
  displayName: "CardsGrid___StyledFlex",
  componentId: "sc-21vncj-0"
})(["width:100%;"]);

var _StyledButtonLink$2 = styled(ButtonLink).withConfig({
  displayName: "CardsGrid___StyledButtonLink",
  componentId: "sc-21vncj-1"
})(["@media ", "{width:auto;}"], function (p) {
  return p._css;
});

var CardsGrid = function CardsGrid(_ref) {
  var _heading$type, _title$type;

  var background = _ref.background,
      customSpacing = _ref.customSpacing,
      heading = _ref.heading,
      title = _ref.title,
      paragraph = _ref.paragraph,
      cards = _ref.cards,
      button = _ref.button,
      elementsPerRow = _ref.elementsPerRow,
      _ref$templateCard = _ref.templateCard,
      templateCard = _ref$templateCard === void 0 ? false : _ref$templateCard,
      _ref$masonry = _ref.masonry,
      masonry = _ref$masonry === void 0 ? false : _ref$masonry;
  return /*#__PURE__*/jsx(Section, {
    background: background,
    children: /*#__PURE__*/jsxs(ComponentContainer, {
      customSpacing: customSpacing,
      children: [(heading || title || paragraph) && /*#__PURE__*/jsxs(Flex, {
        flexDirection: {
          mobile: 'column'
        },
        alignItems: {
          mobile: 'center'
        },
        marginBottom: "xlarge",
        children: [heading && /*#__PURE__*/jsx(Text, {
          variant: (_heading$type = heading.type) != null ? _heading$type : 'paragraphMBold',
          center: true,
          $color: heading.color,
          uppercase: true,
          children: heading.text
        }), title && /*#__PURE__*/jsx(Text, {
          variant: (_title$type = title.type) != null ? _title$type : 'title2XXL',
          center: true,
          marginTop: "xmini",
          $color: title.color,
          children: title.text
        }), paragraph && /*#__PURE__*/jsx(ParagraphWrapper, {
          backgroundColor: background === null || background === void 0 ? void 0 : background.color,
          children: /*#__PURE__*/jsx(Text, {
            variant: "paragraphL",
            center: true,
            marginTop: "small",
            $color: paragraph.color,
            children: /*#__PURE__*/jsx(HtmlParser, {
              children: paragraph.text
            })
          })
        })]
      }), /*#__PURE__*/jsx(CardsGridContainer, {
        elements: elementsPerRow,
        masonry: masonry,
        children: cards === null || cards === void 0 ? void 0 : cards.map(function (element, index) {
          if (element.disabled) return;
          return /*#__PURE__*/jsx(CardsGridItem, {
            element: element,
            templateCard: templateCard || element.roundedBorder,
            elementsPerRow: elementsPerRow,
            masonry: masonry,
            backgroundColor: background === null || background === void 0 ? void 0 : background.color
          }, index);
        })
      }), button && /*#__PURE__*/jsx(_StyledFlex$d, {
        justifyContent: {
          mobile: 'center'
        }
        /* 8px - que los marcados por diseño por los 8px
        de padding-top/bottom para el hover de las imagenes en el carousel */
        ,
        marginTop: "xhuge",
        children: /*#__PURE__*/jsx(_StyledButtonLink$2, {
          href: button.href,
          size: button.size,
          variant: button.variant,
          fullwidth: true,
          _css: theme.device.tablet,
          children: button.children
        })
      })]
    })
  });
};
var CardsGridContainer = styled.div.withConfig({
  displayName: "CardsGrid__CardsGridContainer",
  componentId: "sc-21vncj-2"
})(["", ""], function (_ref2) {
  var masonry = _ref2.masonry,
      elements = _ref2.elements;
  return masonry ? "            \n      column-count: 1;\n      @media " + theme.device.tablet + " {\n        column-count: 2;\n      }\n      @media " + theme.device.laptop + " {\n        column-count: " + elements + ";\n      }\n      grid-gap: " + rem(24) + ";\n      justify-content: center;\n      width: 100%;\n    " : "\n      display: grid;\n      grid-gap: " + rem(24) + ";\n      justify-content: center;\n      width: 100%;\n      @media " + theme.device.tablet + " {\n        grid-template-columns: repeat(2, 1fr);\n      }\n      @media " + theme.device.laptop + " {\n        grid-template-columns: repeat(" + elements + ", 1fr);\n      }\n  ";
});

var _excluded$3 = ["variant"];
var Cards = function Cards(_ref) {
  var variant = _ref.variant,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$3);

  var CardVariant = cardsVariants[variant];
  return /*#__PURE__*/jsx(CardVariant, _extends$2({}, rest));
};
var cardsVariants = {
  carousel: CardsCarousel,
  grid: CardsGrid
};

var TopbarContainer = styled.header.withConfig({
  displayName: "Topbarstyles__TopbarContainer",
  componentId: "sc-1fh4pxn-0"
})(["display:flex;justify-content:space-between;align-items:center;gap:", ";height:", ";width:100%;margin:0 auto;padding-right:", ";padding-left:", ";@media ", "{padding-right:", ";padding-left:", ";}@media ", "{padding-right:", ";padding-left:", ";height:unset;}@media ", "{max-width:", ";}"], rem(theme.sizes.small), rem(theme.topbarSize), rem(theme.grid.horizontalMargin["default"]), rem(theme.grid.horizontalMargin["default"]), theme.device.tablet, rem(theme.grid.horizontalMargin.tablet), rem(theme.grid.horizontalMargin.tablet), theme.device.laptop, rem(theme.grid.horizontalMargin.laptop), rem(theme.grid.horizontalMargin.laptop), theme.device.desktop, rem(theme.grid.contentMaxWidth));
var LogoLinkWrapper = styled.a.withConfig({
  displayName: "Topbarstyles__LogoLinkWrapper",
  componentId: "sc-1fh4pxn-1"
})(["display:flex;align-items:center;"]);
var TopBarMenu = styled.ul.withConfig({
  displayName: "Topbarstyles__TopBarMenu",
  componentId: "sc-1fh4pxn-2"
})(["display:flex;justify-content:space-between;margin-left:", ";@media ", "{margin-left:", ";}"], rem(theme.sizes.xlarge), theme.device.desktop, rem(112));
var TopBarMenuItem = styled.li.withConfig({
  displayName: "Topbarstyles__TopBarMenuItem",
  componentId: "sc-1fh4pxn-3"
})(["", ";color:", ";height:", ";display:flex;align-items:center;&:not(:last-child){> div{padding-right:", ";@media ", "{padding-right:", ";}}}"], textCssFactory(textVariants.paragraphSBold), theme.colors.black, rem(63), rem(theme.sizes.medium), theme.device.desktop, rem(theme.sizes.xlarge));
var MegamenuContainer = styled.div.withConfig({
  displayName: "Topbarstyles__MegamenuContainer",
  componentId: "sc-1fh4pxn-4"
})(["width:", ";position:absolute;visibility:hidden;transition:visibility 0.6s linear;box-shadow:0px 12px 32px 0px rgba(108,41,255,0.15);opacity:0;", ";top:", ";left:0;right:0;margin:auto;max-width:", ";", ";", " ", " ", " ", ""], rem(1014), function (_ref) {
  var visible = _ref.visible;
  return visible && "\n      opacity: 1;\n      visibility: visible;\n    ";
}, rem(56), rem(1014), function (_ref2) {
  var state = _ref2.state;
  return animations$1[state];
}, function (_ref3) {
  var borderRad = _ref3.borderRad;
  return (borderRad === null || borderRad === void 0 ? void 0 : borderRad.leftBottom) && "\n     border-bottom-left-radius: " + borderRad.leftBottom + "px;\n    ";
}, function (_ref4) {
  var borderRad = _ref4.borderRad;
  return (borderRad === null || borderRad === void 0 ? void 0 : borderRad.rightBottom) && "\n     border-bottom-right-radius: " + borderRad.rightBottom + "px;\n    ";
}, function (_ref5) {
  var borderRad = _ref5.borderRad;
  return (borderRad === null || borderRad === void 0 ? void 0 : borderRad.leftTop) && "\n     border-top-left-radius: " + borderRad.leftTop + "px;\n    ";
}, function (_ref6) {
  var borderRad = _ref6.borderRad;
  return (borderRad === null || borderRad === void 0 ? void 0 : borderRad.rightTop) && "\n     border-top-right-radius: " + borderRad.rightTop + "px;\n    ";
});
var animations$1 = {
  entered: undefined,
  entering: css(["animation:", " 0.3s ", ";"], theme.animations.fadeInDown, theme.transitions.easeInOut),
  exiting: css(["animation:", " 0.3s ", " reverse;"], theme.animations.fadeInDown, theme.transitions.easeInOut),
  exited: css(["display:none;"]),
  unmounted: undefined
};

var HamburgerMenu = styled.div.withConfig({
  displayName: "HamburgerMenu",
  componentId: "sc-1uug49c-0"
})(["position:relative;display:flex;align-items:center;height:", ";padding:", ";justify-content:center;span,span::before,span::after{border-radius:", ";content:'';background:", ";position:absolute;width:", ";height:", ";transition:0.3s ease-in-out;}span::before{position:absolute;top:-6px;}span::after{position:absolute;bottom:-6px;}", ""], rem(60), rem(12), rem(3), function (_ref) {
  var bg = _ref.bg;
  return theme.colors[bg];
}, rem(16), rem(2), function (_ref2) {
  var isActive = _ref2.isActive;
  return isActive && "\n  span { background: transparent; } \n  span::before {\n    top: 0;\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n    }\n\n  span::after {\n    bottom: 0;\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n}\n  ";
});

var animations = {
  entered: undefined,
  entering: css(["animation:", " 0.5s ", ";"], theme.animations.fadeInLeft, theme.transitions.easeInOut),
  exiting: css(["animation:", " 0.5s ", " reverse;"], theme.animations.fadeOutLeft, theme.transitions.easeInOut),
  exited: css(["display:none;"]),
  unmounted: undefined
};
var MobileMenuWrapper = styled.div.withConfig({
  displayName: "MobileMenustyles__MobileMenuWrapper",
  componentId: "sc-1809k7u-0"
})(["position:fixed;right:0;padding-top:", ";overflow-y:auto;display:flex;flex-direction:column;width:100%;height:100%;&::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;z-index:100;text-decoration:none;box-shadow:", ";", ";"], rem(63), theme.shadows["short"], function (_ref) {
  var state = _ref.state;
  return animations[state];
});
var MobileMenuContent = styled.div.withConfig({
  displayName: "MobileMenustyles__MobileMenuContent",
  componentId: "sc-1809k7u-1"
})(["display:flex;flex-direction:column;flex-grow:1;flex-shrink:1;padding:", " ", " ", ";background-color:", ";"], rem(theme.sizes.medium), rem(theme.sizes.large), rem(80), theme.colors.white);
var MobileMenuButtonContainer = styled.div.withConfig({
  displayName: "MobileMenustyles__MobileMenuButtonContainer",
  componentId: "sc-1809k7u-2"
})(["display:flex;flex-direction:column;align-items:center;gap:", ";margin-top:", ";width:100%;"], rem(theme.sizes.small), rem(theme.sizes.large));
styled.ul.withConfig({
  displayName: "MobileMenustyles__MobileMenuFooter",
  componentId: "sc-1809k7u-3"
})(["display:flex;align-items:center;justify-content:center;padding:", ";background-color:", ";"], rem(theme.sizes.base), theme.colors.snow);
styled.li.withConfig({
  displayName: "MobileMenustyles__MobileMenuFooterItem",
  componentId: "sc-1809k7u-4"
})(["position:relative;color:", ";&:not(:last-child){padding-right:", ";margin-right:", ";&:before{content:'';position:absolute;top:0;bottom:0;right:0;margin:auto 0;width:", ";height:", ";background-color:", ";}}"], theme.colors.rOnyx, rem(theme.sizes.small), rem(theme.sizes.small), rem(1), rem(20), theme.colors.smoke);
var MegamenuMobile = styled.div.withConfig({
  displayName: "MobileMenustyles__MegamenuMobile",
  componentId: "sc-1809k7u-5"
})(["transform:translateY(", ");opacity:0;height:0px;overflow:hidden;", " transition:transform .2s ", ",opacity .2s ", ";"], rem('-20px'), function (_ref2) {
  var isExpanded = _ref2.isExpanded;
  return isExpanded && "\n    opacity: 1;\n    height: auto;\n    margin-top: " + rem(theme.sizes.small) + ";  \n    transform: translateY(0px);\n    ";
}, theme.transitions.easeInOut, theme.transitions.easeInOut);
var ToggleContainer = styled(Flex).withConfig({
  displayName: "MobileMenustyles__ToggleContainer",
  componentId: "sc-1809k7u-6"
})(["display:flex;"]);

var _StyledLi = styled("li").withConfig({
  displayName: "MobileMenu___StyledLi",
  componentId: "y6fb0v-0"
})(["&:not(:last-child){margin-bottom:", ";}"], function (p) {
  return p._css;
});

var _StyledFlex$c = styled(Flex).withConfig({
  displayName: "MobileMenu___StyledFlex",
  componentId: "y6fb0v-1"
})(["max-width:100%;"]);

var MobileMenu = function MobileMenu(_ref) {
  var state = _ref.state,
      links = _ref.links,
      loggedInButtons = _ref.loggedInButtons,
      buttons = _ref.buttons;
  var isLoggedIn = useIsLoggedIn();

  var _useState = useState(''),
      MM = _useState[0],
      setMM = _useState[1];

  var _useState2 = useState(),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  return /*#__PURE__*/jsx(MobileMenuWrapper, {
    state: state,
    children: /*#__PURE__*/jsxs(MobileMenuContent, {
      children: [/*#__PURE__*/jsx("ul", {
        children: links && links.map(function (option, index) {
          return /*#__PURE__*/jsx(_StyledLi, {
            "data-cy": option.dataCy ? option.dataCy : option.value,
            _css: rem(theme.sizes.large),
            children: option.megamenu ? /*#__PURE__*/jsxs("div", {
              children: [/*#__PURE__*/jsxs(ToggleContainer, {
                onClick: function onClick() {
                  setMM(option.value);
                  isExpanded === index ? setIsExpanded(undefined) : setIsExpanded(index);
                },
                children: [/*#__PURE__*/jsx(Text, {
                  variant: "bigButton",
                  children: option.value
                }), /*#__PURE__*/jsx(_StyledFlex$c, {
                  alignItems: "center",
                  marginLeft: 10,
                  children: /*#__PURE__*/jsx(Icon, {
                    name: isExpanded != undefined && MM === option.value ? 'DisplayUpSmall' : 'DisplayDownSmall'
                  })
                })]
              }), /*#__PURE__*/jsx(MegamenuMobile, {
                isExpanded: isExpanded === index,
                children: option.megamenu ? option.megamenuRender : /*#__PURE__*/jsx(Fragment$1, {})
              }, 'ItemNumber' + index)]
            }) : /*#__PURE__*/jsx(Link, {
              variant: "bigButton",
              href: option.megamenu ? '#' : option.url,
              children: option.value
            })
          }, 'menuElementMobileList-' + index);
        })
      }), /*#__PURE__*/jsx(MobileMenuButtonContainer, {
        children: isLoggedIn ? /*#__PURE__*/jsx(ButtonLink, {
          variant: 'stroke',
          href: loggedInButtons.url,
          "data-cy": "panelButton",
          fullwidth: true,
          children: loggedInButtons.children
        }, loggedInButtons.url) : /*#__PURE__*/jsxs(Fragment$1, {
          children: [/*#__PURE__*/jsx(ButtonLink, {
            variant: 'stroke',
            href: buttons[0].url,
            "data-cy": "loginButton",
            fullwidth: true,
            children: buttons[0].children
          }, buttons[0].url), /*#__PURE__*/jsx(ButtonLink, {
            variant: 'secondary',
            href: buttons[1].url,
            "data-cy": "registerButton",
            fullwidth: true,
            children: buttons[1].children
          }, buttons[1].url)]
        })
      })]
    })
  });
};

var _excluded$2 = ["links", "brandLink", "firstBg", "loggedInButtons", "buttons", "setScrolling"];
var Megamenu = function Megamenu(_ref) {
  var state = _ref.state,
      megamenuRender = _ref.megamenuRender,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible,
      borderRad = _ref.borderRad;
  return /*#__PURE__*/jsx(MegamenuContainer, {
    id: "megamenuContainer",
    state: state,
    visible: visible,
    borderRad: {
      leftTop: borderRad === null || borderRad === void 0 ? void 0 : borderRad.borderRadiusTopLeft,
      rightTop: borderRad === null || borderRad === void 0 ? void 0 : borderRad.borderRadiusTopRight,
      leftBottom: borderRad === null || borderRad === void 0 ? void 0 : borderRad.borderRadiusBottomLeft,
      rightBottom: borderRad === null || borderRad === void 0 ? void 0 : borderRad.borderRadiusBottomRight
    },
    children: /*#__PURE__*/jsx("div", {
      children: megamenuRender
    })
  });
};

var _StyledSection$3 = styled(Section).withConfig({
  displayName: "Topbar___StyledSection",
  componentId: "c3f8xn-0"
})(["position:fixed;top:0;z-index:200;border-bottom:", ";transition:background-color .2s;&:hover{@media ", "{background:", ";}"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var _StyledTopBarMenuItem = styled(TopBarMenuItem).withConfig({
  displayName: "Topbar___StyledTopBarMenuItem",
  componentId: "c3f8xn-1"
})(["&:hover{cursor:pointer;}"]);

var _StyledFlex$b = styled(Flex).withConfig({
  displayName: "Topbar___StyledFlex",
  componentId: "c3f8xn-2"
})(["&:hover{cursor:pointer;}"]);

var _StyledText$5 = styled(Text).withConfig({
  displayName: "Topbar___StyledText",
  componentId: "c3f8xn-3"
})(["&:hover{cursor:pointer;}"]);

var _StyledFlex2$8 = styled(Flex).withConfig({
  displayName: "Topbar___StyledFlex2",
  componentId: "c3f8xn-4"
})(["max-width:100%;"]);

var _StyledIcon$1 = styled(Icon).withConfig({
  displayName: "Topbar___StyledIcon",
  componentId: "c3f8xn-5"
})(["", ""], function (p) {
  return p._css4;
});

var _StyledLink = styled(Link).withConfig({
  displayName: "Topbar___StyledLink",
  componentId: "c3f8xn-6"
})(["transition:color 0.15s ", ";height:", ";display:flex;align-items:center;&:hover{color:", ";transition:color 0.15s ", ";}"], function (p) {
  return p._css5;
}, function (p) {
  return p._css6;
}, function (p) {
  return p._css7;
}, function (p) {
  return p._css8;
});

var _StyledText2$2 = styled(Text).withConfig({
  displayName: "Topbar___StyledText2",
  componentId: "c3f8xn-7"
})(["&:hover{color:", ";transition:color 0.15s ", ";}"], function (p) {
  return p._css9;
}, function (p) {
  return p._css10;
});

var _StyledFlex3$5 = styled(Flex).withConfig({
  displayName: "Topbar___StyledFlex3",
  componentId: "c3f8xn-8"
})(["gap:", ";@media", "{gap:", ";}@media", "{gap:", ";}"], function (p) {
  return p._css11;
}, function (p) {
  return p._css12;
}, function (p) {
  return p._css13;
}, function (p) {
  return p._css14;
}, function (p) {
  return p._css15;
});

var _StyledFlex4$3 = styled(Flex).withConfig({
  displayName: "Topbar___StyledFlex4",
  componentId: "c3f8xn-9"
})(["gap:", ";"], function (p) {
  return p._css16;
});

var _StyledButtonLink$1 = styled(ButtonLink).withConfig({
  displayName: "Topbar___StyledButtonLink",
  componentId: "c3f8xn-10"
})(["min-width:130px;"]);

var _StyledButtonLink2 = styled(ButtonLink).withConfig({
  displayName: "Topbar___StyledButtonLink2",
  componentId: "c3f8xn-11"
})(["min-width:130px;"]);

var _StyledFlex5$2 = styled(Flex).withConfig({
  displayName: "Topbar___StyledFlex5",
  componentId: "c3f8xn-12"
})(["cursor:pointer;width:", ";"], function (p) {
  return p._css17;
});

var Topbar = function Topbar(_ref2) {
  var links = _ref2.links,
      brandLink = _ref2.brandLink,
      firstBg = _ref2.firstBg,
      loggedInButtons = _ref2.loggedInButtons,
      buttons = _ref2.buttons,
      setScrolling = _ref2.setScrolling,
      rest = _objectWithoutPropertiesLoose$2(_ref2, _excluded$2);

  var _useState = useState(false),
      isOpenMenuMobile = _useState[0],
      setIsOpenMenuMobile = _useState[1];

  var isLoggedIn = useIsLoggedIn();

  var _useState2 = useState(''),
      MM = _useState2[0],
      setMM = _useState2[1];

  var _useState3 = useState(firstBg),
      actualBg = _useState3[0],
      setCurrentBg = _useState3[1];

  var _useState4 = useState(false),
      isScrolled = _useState4[0],
      setIsScrolled = _useState4[1];

  var _useMedia = useMedia(),
      isLaptop = _useMedia.isLaptop;

  useEffect(function () {
    window.addEventListener('scroll', handleScroll);
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  var handleScroll = function handleScroll() {
    if (window.scrollY > 40) {
      setCurrentBg('rWhite');
      setScrolling('rWhite');
      setIsScrolled(true);
    } else {
      setCurrentBg(firstBg);
      setScrolling(firstBg);
      setIsScrolled(false);
    }
  };

  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(_StyledSection$3, _extends$2({
      background: {
        color: isOpenMenuMobile ? 'rWhite' : actualBg
      },
      onMouseOver: function onMouseOver() {
        if (isLaptop) {
          setCurrentBg('rWhite');
          setScrolling('rWhite');
        }
      },
      onMouseOut: function onMouseOut() {
        if (isLaptop) {
          setCurrentBg(isScrolled ? 'rWhite' : actualBg === 'rWhite' ? firstBg : actualBg);
          setScrolling(isScrolled ? 'rWhite' : actualBg === 'rWhite' ? firstBg : actualBg);
        }
      }
    }, rest, {
      _css: isScrolled ? rem(1) + " solid " + theme.colors.rLavender : 'none',
      _css2: theme.device.laptop,
      _css3: theme.colors.rWhite,
      children: /*#__PURE__*/jsxs(TopbarContainer, {
        children: [/*#__PURE__*/jsxs(Flex, {
          alignItems: "center",
          children: [/*#__PURE__*/jsxs(LogoLinkWrapper, {
            href: brandLink,
            "data-cy": "geniallyLogoTopBar",
            children: [/*#__PURE__*/jsx(VisuallyHidden, {
              children: "Genialy home page"
            }), /*#__PURE__*/jsx(Logo, {
              width: "60px",
              color: isOpenMenuMobile ? 'black' : actualBg === 'black' || actualBg === 'rBlack' || actualBg === 'rAkihabara' ? 'white' : 'black'
            })]
          }), /*#__PURE__*/jsx(MediaQuery, {
            laptop: true,
            desktop: true,
            children: /*#__PURE__*/jsx("nav", {
              "aria-label": "mainmenu",
              children: /*#__PURE__*/jsx(TopBarMenu, {
                children: links && links.map(function (option) {
                  return /*#__PURE__*/jsx(_StyledTopBarMenuItem, {
                    "data-cy": option.dataCy ? option.dataCy : option.value,
                    onClick: function onClick() {
                      return MM === option.value ? setMM('') : setMM(option.value);
                    },
                    onMouseEnter: function onMouseEnter() {
                      setMM(option.value ? option.value : '');
                    },
                    onMouseLeave: function onMouseLeave() {
                      setMM('');
                    },
                    children: option.megamenu ? /*#__PURE__*/jsxs(_StyledFlex$b, {
                      flexDirection: 'row',
                      children: [/*#__PURE__*/jsx(_StyledText$5, {
                        variant: "paragraphSBold",
                        $color: MM === option.value ? 'rAkihabara' : actualBg === 'black' || actualBg === 'rBlack' || actualBg === 'rAkihabara' ? 'rWhite' : 'rBlack',
                        children: option.value
                      }), /*#__PURE__*/jsx(_StyledFlex2$8, {
                        alignItems: "center",
                        marginLeft: 10,
                        children: /*#__PURE__*/jsx(_StyledIcon$1, {
                          name: 'DisplayDownSmall',
                          style: {
                            transition: 'transform 0.5s;'
                          },
                          color: MM === option.value ? theme.colors.rAkihabara : actualBg === 'black' || actualBg === 'rBlack' || actualBg === 'rAkihabara' ? theme.colors.rWhite : theme.colors.rBlack,
                          _css4: MM === option.value ? "\n                                      transition: transform 0.5s;\n                                      transform: rotate(180deg);\n                                  " : "transition: transform 0.5s;\n                                      transform: rotate(0)"
                        })
                      }), /*#__PURE__*/jsx(Transition$1, {
                        "in": MM === option.value,
                        timeout: {
                          enter: 300,
                          exit: 300
                        },
                        children: function children(state) {
                          var _option$megamenu, _option$megamenu$para, _option$megamenu$para2, _option$megamenu$para3, _option$megamenu$para4;

                          return /*#__PURE__*/jsx(Megamenu, {
                            state: state,
                            megamenuRender: option.megamenuRender,
                            visible: MM === option.value ? true : false,
                            borderRad: (_option$megamenu = option.megamenu) === null || _option$megamenu === void 0 ? void 0 : (_option$megamenu$para = _option$megamenu.paragraphs[0]) === null || _option$megamenu$para === void 0 ? void 0 : (_option$megamenu$para2 = _option$megamenu$para.entity) === null || _option$megamenu$para2 === void 0 ? void 0 : (_option$megamenu$para3 = _option$megamenu$para2.behaviorSettings) === null || _option$megamenu$para3 === void 0 ? void 0 : (_option$megamenu$para4 = _option$megamenu$para3.rowStyle) === null || _option$megamenu$para4 === void 0 ? void 0 : _option$megamenu$para4.borders
                          });
                        }
                      })]
                    }) : /*#__PURE__*/jsx(Fragment$1, {
                      children: /*#__PURE__*/jsx(_StyledLink, {
                        href: option.url,
                        "data-cy": option.value,
                        _css5: theme.transitions.easeInOut,
                        _css6: rem(63),
                        _css7: theme.colors.rAkihabara,
                        _css8: theme.transitions.easeInOut,
                        children: /*#__PURE__*/jsx(_StyledText2$2, {
                          variant: "paragraphSBold",
                          $color: actualBg === 'black' || actualBg === 'rBlack' || actualBg === 'rAkihabara' ? 'rWhite' : 'rBlack',
                          _css9: theme.colors.rAkihabara,
                          _css10: theme.transitions.easeInOut,
                          children: option.value
                        })
                      })
                    })
                  }, 'topbarMenuElement-' + option.value);
                })
              })
            })
          })]
        }), /*#__PURE__*/jsxs(_StyledFlex3$5, {
          justifyContent: "space-between",
          alignItems: "center",
          _css11: rem(theme.sizes.medium),
          _css12: theme.device.laptop,
          _css13: rem(theme.sizes.small),
          _css14: theme.device.desktop,
          _css15: rem(theme.sizes.medium),
          children: [/*#__PURE__*/jsx(MediaQuery, {
            laptop: true,
            desktop: true,
            children: /*#__PURE__*/jsx(_StyledFlex4$3, {
              alignItems: "center",
              _css16: rem(theme.sizes.small),
              children: isLoggedIn ? /*#__PURE__*/jsx(_StyledButtonLink$1, {
                variant: isOpenMenuMobile ? 'stroke' : actualBg === 'black' || actualBg === 'rBlack' || actualBg === 'rAkihabara' ? 'strokeWhite' : 'stroke',
                href: loggedInButtons.url,
                fullwidth: true,
                "data-cy": "panelButton",
                children: loggedInButtons.children
              }, loggedInButtons.url) : /*#__PURE__*/jsxs(Fragment$1, {
                children: [/*#__PURE__*/jsx(ButtonLink, {
                  variant: actualBg === 'black' || actualBg === 'rBlack' || actualBg === 'rAkihabara' ? 'strokeWhite' : 'stroke',
                  href: buttons[0].url,
                  "data-cy": "loginButton",
                  children: buttons[0].children
                }, buttons[0].url), /*#__PURE__*/jsx(ButtonLink, {
                  variant: actualBg === 'rAkihabara' ? 'tertiary' : 'secondary',
                  href: buttons[1].url,
                  "data-cy": "registerButton",
                  children: buttons[1].children
                }, buttons[1].url)]
              })
            })
          }), /*#__PURE__*/jsx(MediaQuery, {
            mobile: true,
            tablet: true,
            children: isLoggedIn ? /*#__PURE__*/jsx(_StyledButtonLink2, {
              variant: isOpenMenuMobile ? 'stroke' : actualBg === 'black' || actualBg === 'rBlack' || actualBg === 'rAkihabara' ? 'strokeWhite' : 'stroke',
              href: loggedInButtons.url,
              fullwidth: true,
              "data-cy": "panelButton",
              children: loggedInButtons.children
            }, loggedInButtons.url) : /*#__PURE__*/jsx(Fragment$1, {
              children: /*#__PURE__*/jsx(ButtonLink, {
                variant: isOpenMenuMobile ? 'secondary' : actualBg === 'black' || actualBg === 'rBlack' || actualBg === 'rAkihabara' ? 'tertiary' : 'secondary',
                href: buttons[1].url,
                "data-cy": "panelButton",
                children: buttons[1].children
              }, buttons[1].url)
            })
          }), /*#__PURE__*/jsx(MediaQuery, {
            mobile: true,
            tablet: true,
            children: /*#__PURE__*/jsx(_StyledFlex5$2, {
              _css17: rem(16),
              children: /*#__PURE__*/jsx(HamburgerMenu, {
                onClick: function onClick() {
                  return setIsOpenMenuMobile(function (prevIsOpenMenuMobile) {
                    return !prevIsOpenMenuMobile;
                  });
                },
                isActive: isOpenMenuMobile,
                bg: isOpenMenuMobile ? 'rBlack' : actualBg === 'black' || actualBg === 'rBlack' || actualBg === 'rAkihabara' ? 'rWhite' : 'rBlack',
                children: /*#__PURE__*/jsx("span", {})
              })
            })
          })]
        })]
      })
    })), /*#__PURE__*/jsx(Transition$1, {
      "in": isOpenMenuMobile,
      timeout: {
        enter: 500,
        exit: 500
      },
      children: function children(state) {
        return /*#__PURE__*/jsx(MobileMenu, {
          state: state,
          links: links,
          loggedInButtons: loggedInButtons,
          buttons: buttons
        });
      }
    })]
  });
};

var AuthTopbarContainer = styled.header.withConfig({
  displayName: "AuthTopbarstyles__AuthTopbarContainer",
  componentId: "nqkii0-0"
})(["display:flex;justify-content:space-between;align-items:center;gap:", ";width:100%;height:", ";margin:0 auto;padding-right:", ";padding-left:", ";@media ", "{padding-right:", ";padding-left:", ";}@media ", "{padding-right:", ";padding-left:", ";}@media ", "{max-width:", ";}"], rem(theme.sizes.small), rem(theme.topbarSize), rem(theme.grid.horizontalMargin["default"]), rem(theme.grid.horizontalMargin["default"]), theme.device.tablet, rem(theme.grid.horizontalMargin.tablet), rem(theme.grid.horizontalMargin.tablet), theme.device.laptop, rem(theme.grid.horizontalMargin.laptop), rem(theme.grid.horizontalMargin.laptop), theme.device.desktop, rem(theme.grid.contentMaxWidth));
var AuthLogoLinkWrapper = styled.a.withConfig({
  displayName: "AuthTopbarstyles__AuthLogoLinkWrapper",
  componentId: "nqkii0-1"
})(["display:flex;align-items:center;"]);
styled.ul.withConfig({
  displayName: "AuthTopbarstyles__AuthTopBarMenu",
  componentId: "nqkii0-2"
})(["display:flex;justify-content:space-between;margin-left:", ";@media ", "{margin-left:", ";}"], rem(theme.sizes.xlarge), theme.device.desktop, rem(112));
styled.li.withConfig({
  displayName: "AuthTopbarstyles__AuthTopBarMenuItem",
  componentId: "nqkii0-3"
})(["cursor:pointer;", ";color:", ";&:not(:last-child){margin-right:", ";@media ", "{margin-right:", ";}}"], textCssFactory(textVariants.title6), theme.colors.black, rem(theme.sizes.medium), theme.device.desktop, rem(theme.sizes.xlarge));

var _excluded$1 = ["brandLink", "buttons", "languageOptions", "url"];

var _StyledSection$2 = styled(Section).withConfig({
  displayName: "AuthTopbar___StyledSection",
  componentId: "uv55pi-0"
})(["position:sticky;top:0;z-index:1000;border-bottom:", " solid ", ";"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
});

var _StyledFlex$a = styled(Flex).withConfig({
  displayName: "AuthTopbar___StyledFlex",
  componentId: "uv55pi-1"
})(["gap:", ";@media", "{gap:", ";}@media", "{gap:", ";}"], function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
}, function (p) {
  return p._css5;
}, function (p) {
  return p._css6;
}, function (p) {
  return p._css7;
});

var _StyledFlex2$7 = styled(Flex).withConfig({
  displayName: "AuthTopbar___StyledFlex2",
  componentId: "uv55pi-2"
})(["gap:", ";"], function (p) {
  return p._css8;
});

var _StyledDropdown = styled(Dropdown).withConfig({
  displayName: "AuthTopbar___StyledDropdown",
  componentId: "uv55pi-3"
})(["", ";"], function (p) {
  return p._css9;
});

var AuthTopbar = function AuthTopbar(_ref) {
  var brandLink = _ref.brandLink,
      buttons = _ref.buttons,
      languageOptions = _ref.languageOptions,
      url = _ref.url,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$1);

  return /*#__PURE__*/jsx(_StyledSection$2, _extends$2({
    background: {
      color: 'white'
    }
  }, rest, {
    _css: rem(1),
    _css2: theme.colors.smoke,
    children: /*#__PURE__*/jsxs(AuthTopbarContainer, {
      children: [/*#__PURE__*/jsx(Flex, {
        alignItems: "center",
        children: /*#__PURE__*/jsx(AuthLogoLinkWrapper, {
          href: brandLink,
          children: /*#__PURE__*/jsx(Logo, {
            width: "60px",
            color: "black"
          })
        })
      }), /*#__PURE__*/jsxs(_StyledFlex$a, {
        justifyContent: "space-between",
        alignItems: "center",
        _css3: rem(theme.sizes.medium),
        _css4: theme.device.laptop,
        _css5: rem(theme.sizes.small),
        _css6: theme.device.desktop,
        _css7: rem(theme.sizes.xlarge),
        children: [/*#__PURE__*/jsx(MediaQuery, {
          mobile: true,
          tablet: true,
          laptop: true,
          desktop: true,
          children: /*#__PURE__*/jsx(_StyledFlex2$7, {
            alignItems: "center",
            _css8: rem(theme.sizes.small),
            children: buttons && /*#__PURE__*/jsxs(Fragment$1, {
              children: [/*#__PURE__*/jsx(ButtonLink, {
                variant: 'stroke',
                href: buttons[0].url,
                "data-cy": "loginButton",
                children: buttons[0].children
              }, buttons[0].url), /*#__PURE__*/jsx(ButtonLink, {
                variant: 'secondary',
                href: buttons[1].url,
                "data-cy": "registerButton",
                children: buttons[1].children
              }, buttons[1].url)]
            })
          })
        }), /*#__PURE__*/jsx(_StyledDropdown, {
          url: url,
          options: languageOptions,
          rightAlign: true,
          dataCy: "languageButton",
          ariaLabel: "languageButton",
          _css9: textCssFactory(textVariants.paragraphMBold)
        })]
      })]
    })
  }));
};

var FooterContainer = styled(Container).withConfig({
  displayName: "Footerstyles__FooterContainer",
  componentId: "bhf5tk-0"
})(["width:100%;padding:", " ", ";@media ", "{padding:", " ", " ", ";}"], rem(theme.sizes.xlarge), rem(theme.sizes.medium), theme.device.laptop, rem(72), rem(theme.sizes.medium), rem(theme.sizes.large));
var FooterContent = styled.div.withConfig({
  displayName: "Footerstyles__FooterContent",
  componentId: "bhf5tk-1"
})(["display:flex;flex-direction:column;justify-content:center;margin:0 auto;@media ", "{flex-direction:row;max-width:100%;gap:", ";}"], theme.device.tablet, rem(theme.sizes.medium));
var FooterColumn = styled.div.withConfig({
  displayName: "Footerstyles__FooterColumn",
  componentId: "bhf5tk-2"
})(["display:flex;flex-direction:column;justify-content:flex-start;&:not(:first-child){margin-top:", ";}@media ", "{max-width:calc((100% / 8) * 2);margin:0 auto;&:not(:first-child){margin-top:0;}}@media ", "{max-width:calc((100% / 12) * 2);margin:0 auto;}"], rem(theme.sizes.large), theme.device.tablet, theme.device.desktop);
var FooterIsotype = styled(Isotype).withConfig({
  displayName: "Footerstyles__FooterIsotype",
  componentId: "bhf5tk-3"
})(["width:", ";height:", ";@media ", "{width:", ";height:", ";}"], rem(56), rem(56), theme.device.laptop, rem(80), rem(80));
var FooterClaim = styled.div.withConfig({
  displayName: "Footerstyles__FooterClaim",
  componentId: "bhf5tk-4"
})(["display:flex;align-items:center;flex-direction:column;justify-content:center;margin:", " auto;@media ", "{max-width:calc((100% / 8) * 6);}@media ", "{flex-direction:row;margin:", " auto ", " auto;max-width:calc((100% / 12) * 8);}"], rem(theme.sizes.xhuge), theme.device.tablet, theme.device.laptop, rem(96), rem(64));
var FooterAssoc = styled.div.withConfig({
  displayName: "Footerstyles__FooterAssoc",
  componentId: "bhf5tk-5"
})(["display:flex;gap:", ";@media ", "{flex-direction:row;}align-items:center;justify-content:center;flex-direction:column;margin:0 auto;"], rem(16), theme.device.laptop);
var FooterEuropeFlag = styled.div.withConfig({
  displayName: "Footerstyles__FooterEuropeFlag",
  componentId: "bhf5tk-6"
})(["display:flex;align-items:center;justify-content:center;flex-direction:column;"]);
var FooterEurope = styled.div.withConfig({
  displayName: "Footerstyles__FooterEurope",
  componentId: "bhf5tk-7"
})(["> div{@media ", "{max-width:70%;}display:flex;align-items:center;flex-direction:row;justify-content:center;margin:", " auto;flex-wrap:wrap;*{flex:1;}p{font-size:10px;line-height:12px;@media (max-width:768px){font-size:8px;line-height:10px;}}}"], theme.device.laptop, rem(32));
styled.div.withConfig({
  displayName: "Footerstyles__FooterLever",
  componentId: "bhf5tk-8"
})(["p{font-size:10px;line-height:12px;@media (max-width:768px){font-size:8px;line-height:10px;}}> div{display:flex;align-items:center;flex-direction:row;justify-content:center;margin:", " auto;margin-bottom:", ";max-width:", ";flex-wrap:wrap;*{flex:1;}p{font-size:10px;line-height:12px;@media (max-width:768px){font-size:8px;line-height:10px;}}}"], rem(16), rem(32), rem(680));
var FooterBeforeDividerLinks = styled.div.withConfig({
  displayName: "Footerstyles__FooterBeforeDividerLinks",
  componentId: "bhf5tk-9"
})(["display:flex;flex-direction:column;margin-bottom:", ";@media ", "{margin-bottom:", ";flex-direction:row-reverse;justify-content:space-between;}"], rem(theme.sizes.medium), theme.device.tablet, rem(theme.sizes.mini));
var FooterAfterDividerLinks = styled.div.withConfig({
  displayName: "Footerstyles__FooterAfterDividerLinks",
  componentId: "bhf5tk-10"
})(["display:flex;flex-direction:column;@media ", "{margin-top:", ";flex-direction:row-reverse;justify-content:space-between;}"], theme.device.tablet, rem(theme.sizes.medium));
var FooterLink = styled(Link).withConfig({
  displayName: "Footerstyles__FooterLink",
  componentId: "bhf5tk-11"
})(["color:", ";&:active,:visited,:link{color:", ";}&:hover{color:", ";}"], theme.colors.white, theme.colors.rWhite, theme.colors.rLavender);
var FooterLanguageList = styled.ul.withConfig({
  displayName: "Footerstyles__FooterLanguageList",
  componentId: "bhf5tk-12"
})(["display:flex;align-items:center;justify-content:center;@media ", "{flex-wrap:wrap;row-gap:", ";}"], theme.device.mobile, rem(theme.sizes.small));
var FooterLanguageListItem = styled.li.withConfig({
  displayName: "Footerstyles__FooterLanguageListItem",
  componentId: "bhf5tk-13"
})(["display:flex;align-items:center;justify-content:center;position:relative;color:", ";flex:25%;@media ", "{flex:1;}&:not(:last-child){padding-right:", ";margin-right:", ";&:before{content:'';position:absolute;top:0;bottom:0;right:0;margin:auto 0;width:", ";height:", ";background-color:", ";}}@media (max-width:760px){&:nth-child(3){&:before{content:none;background:none;}}}"], theme.colors.white, theme.device.tablet, rem(theme.sizes.small), rem(theme.sizes.small), rem(1), rem(12), theme.colors.white);

var _StyledFooterColumn = styled(FooterColumn).withConfig({
  displayName: "Footer___StyledFooterColumn",
  componentId: "sc-1gw64hh-0"
})(["justify-content:flex-start;"]);

var _StyledSimpleList = styled(SimpleList).withConfig({
  displayName: "Footer___StyledSimpleList",
  componentId: "sc-1gw64hh-1"
})(["margin-top:", ";"], function (p) {
  return p._css;
});

var _StyledSimpleListItem = styled(SimpleListItem).withConfig({
  displayName: "Footer___StyledSimpleListItem",
  componentId: "sc-1gw64hh-2"
})(["&:not(:first-child){margin-top:", ";}"], function (p) {
  return p._css2;
});

var _StyledButtonLink = styled(ButtonLink).withConfig({
  displayName: "Footer___StyledButtonLink",
  componentId: "sc-1gw64hh-3"
})(["@media ", "{width:fit-content;}"], function (p) {
  return p._css3;
});

var _StyledText$4 = styled(Text).withConfig({
  displayName: "Footer___StyledText",
  componentId: "sc-1gw64hh-4"
})(["max-width:100%;margin:0 auto;"]);

var Footer = function Footer(props) {
  var isLoggedIn = useIsLoggedIn();
  var button = isLoggedIn ? props.loggedInButton : props.anonymousButton;
  var isHomepage = useHomepage();
  var flag = {
    desktop: props.europeLogo
  };
  return /*#__PURE__*/jsx(Section, {
    background: {
      color: 'rBlack'
    },
    color: "white",
    as: "footer",
    children: /*#__PURE__*/jsxs(FooterContainer, {
      children: [/*#__PURE__*/jsxs(FooterContent, {
        children: [/*#__PURE__*/jsx(_StyledFooterColumn, {
          children: /*#__PURE__*/jsxs(Link, {
            href: props.brandLink,
            children: [/*#__PURE__*/jsx(VisuallyHidden, {
              children: "Genialy home page"
            }), /*#__PURE__*/jsx(FooterIsotype, {
              "data-cy": "geniallyIsotypeLogoFooter",
              name: "color"
            })]
          })
        }), props.lists && props.lists.map(function (list, index) {
          return /*#__PURE__*/jsxs(FooterColumn, {
            "data-cy": list.dataCy ? list.dataCy : undefined,
            children: [/*#__PURE__*/jsx(Text, {
              variant: "paragraphMBold",
              children: list.key
            }), /*#__PURE__*/jsx(_StyledSimpleList, {
              colDirection: true,
              _css: rem(theme.sizes.mini),
              children: list.options && list.options.map(function (option, indexOption) {
                return /*#__PURE__*/jsx(_StyledSimpleListItem, {
                  "data-cy": option.dataCy ? option.dataCy : undefined,
                  _css2: rem(theme.sizes.tiny),
                  children: /*#__PURE__*/jsx(FooterLink, {
                    href: option.url,
                    variant: "paragraphS",
                    $color: "white",
                    children: option.children
                  })
                }, 'simple-links-' + indexOption);
              })
            })]
          }, 'list-element' + index);
        })]
      }), (props.title || button) && /*#__PURE__*/jsxs(FooterClaim, {
        children: [props.title && /*#__PURE__*/jsx(Text, {
          variant: "paragraphLBold",
          $color: "white",
          center: true,
          children: props.title
        }), button ? /*#__PURE__*/jsx(_StyledButtonLink, {
          marginTop: {
            mobile: 'medium',
            laptop: '0'
          },
          "data-cy": "startNowFooterButton",
          variant: "secondary",
          size: "big",
          href: button.url,
          marginLeft: {
            laptop: 'xlarge'
          },
          fullwidth: true,
          _css3: theme.device.tablet,
          children: button.value
        }) : null]
      }), /*#__PURE__*/jsx(FooterAssoc, {
        children: /*#__PURE__*/jsx(FooterEurope, {
          children: isHomepage === true && props.lang === 'es' && /*#__PURE__*/jsxs(Fragment$1, {
            children: [/*#__PURE__*/jsx("div", {
              children: /*#__PURE__*/jsx(FooterEuropeFlag, {
                children: /*#__PURE__*/jsx(Media, {
                  alt: 'Genially Footer',
                  src: flag,
                  type: "image"
                })
              })
            }), /*#__PURE__*/jsx("div", {
              style: {
                display: 'block'
              },
              children: /*#__PURE__*/jsx(Text, {
                variant: "paragraphXSBold",
                $color: "white",
                center: true,
                children: 'GENIALLY WEB, S.L. ha sido beneficiario del Programa de Mentoring y Apoyo a la internacionalización de la pyme, entre otros gastos, la empresa ha cofinanciados con estos fondos material de difusión y promoción, en concreto campañas de publicidad en Google.'
              })
            })]
          })
        })
      }), (props.socialMediaLinks || props.languageOptions) && /*#__PURE__*/jsxs(FooterBeforeDividerLinks, {
        children: [props.socialMediaLinks && /*#__PURE__*/jsx(Flex, {
          justifyContent: {
            mobile: 'center',
            laptop: 'flex-end'
          },
          children: /*#__PURE__*/jsx(SimpleList, {
            style: {
              flexWrap: 'nowrap'
            },
            children: props.socialMediaLinks.map(function (link, index) {
              return /*#__PURE__*/jsx(SimpleListItem, {
                "data-cy": link.dataCy ? link.dataCy : undefined,
                children: /*#__PURE__*/jsxs(Link, {
                  href: link.url,
                  target: link.target,
                  $color: "white",
                  children: [/*#__PURE__*/jsxs(VisuallyHidden, {
                    children: ["$", link.icon + " Link"]
                  }), /*#__PURE__*/jsx(Icon, {
                    name: link.icon,
                    color: link.iconColor,
                    secondaryColor: link.iconColor
                  })]
                })
              }, 'social-media-list' + index);
            })
          })
        }), props.languageOptions && /*#__PURE__*/jsx(Flex, {
          justifyContent: {
            mobile: 'center',
            laptop: 'flex-start'
          },
          marginTop: {
            mobile: 'large',
            tablet: '0'
          },
          children: /*#__PURE__*/jsx(FooterLanguageList, {
            children: props.languageOptions.map(function (link, index) {
              if (link.hidden) return;
              var url = link.value === 'English' && link.url === '/es/' ? '/' : link.url;
              return /*#__PURE__*/jsx(FooterLanguageListItem, {
                "data-cy": link.dataCy ? link.dataCy : undefined,
                onClick: function onClick(event) {
                  if (link.onClick) {
                    link.onClick(event);
                  }
                },
                children: /*#__PURE__*/jsx(FooterLink, {
                  href: url,
                  variant: "paragraphXS",
                  $color: "white",
                  children: link.value
                })
              }, 'language-list' + index);
            })
          })
        })]
      }), /*#__PURE__*/jsx(Divider, {
        $color: "white"
      }), (props.bottomLinks || props.bottomBrandText) && /*#__PURE__*/jsxs(FooterAfterDividerLinks, {
        children: [props.bottomLinks && /*#__PURE__*/jsx(Flex, {
          justifyContent: {
            mobile: 'center',
            laptop: 'flex-end'
          },
          marginTop: {
            mobile: 'medium',
            tablet: '0'
          },
          children: /*#__PURE__*/jsx(SimpleList, {
            children: props.bottomLinks.map(function (link, index) {
              return /*#__PURE__*/jsx(SimpleListItem, {
                "data-cy": link.dataCy ? link.dataCy : undefined,
                style: {
                  maxWidth: '90%'
                },
                children: /*#__PURE__*/jsx(FooterLink, {
                  href: link.url,
                  variant: link.dataCy === 'privacyFooterLink' ? 'paragraphXSBold' : 'paragraphXS',
                  $color: "white",
                  children: link.value
                })
              }, 'bottom-link-list' + index);
            })
          })
        }), /*#__PURE__*/jsx(Flex, {
          justifyContent: {
            mobile: 'center',
            laptop: 'flex-start'
          },
          alignItems: "center",
          marginTop: {
            mobile: 'medium',
            tablet: '0'
          },
          children: /*#__PURE__*/jsx(_StyledText$4, {
            variant: "paragraphXS",
            $color: "white",
            center: true,
            children: props.bottomBrandText
          })
        })]
      })]
    })
  });
};

var ListContainer = styled.div.withConfig({
  displayName: "Liststyles__ListContainer",
  componentId: "sc-1ybg6f5-0"
})(["display:grid;justify-items:", ";grid-template-columns:repeat(1,1fr);grid-row-gap:", ";grid-column-gap:", ";@media ", "{grid-template-columns:repeat( ", ",1fr );}@media ", "{grid-template-columns:repeat(", ",1fr);}"], function (_ref) {
  var alignment = _ref.alignment;
  return alignment;
}, function (_ref2) {
  var gap = _ref2.gap;
  return rem(gap);
}, rem(16), theme.device.tablet, function (_ref3) {
  var columns = _ref3.columns;
  return columns === 3 ? 2 : columns ? columns : 2;
}, theme.device.laptop, function (_ref4) {
  var columns = _ref4.columns;
  return columns ? columns : 3;
});

var _StyledFlex$9 = styled(Flex).withConfig({
  displayName: "List___StyledFlex",
  componentId: "sc-1olvz6t-0"
})(["margin:0;@media ", "{margin:0 ", ";}"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
});

var _StyledFlex2$6 = styled(Flex).withConfig({
  displayName: "List___StyledFlex2",
  componentId: "sc-1olvz6t-1"
})(["gap:", ";padding:0 ", ";@media ", "{padding:0 ", ";}"], function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
}, function (p) {
  return p._css5;
}, function (p) {
  return p._css6;
});

var _StyledIcon = styled(Icon).withConfig({
  displayName: "List___StyledIcon",
  componentId: "sc-1olvz6t-2"
})(["min-width:", ";"], function (p) {
  return p._css7;
});

var _StyledFlex3$4 = styled(Flex).withConfig({
  displayName: "List___StyledFlex3",
  componentId: "sc-1olvz6t-3"
})(["gap:", ";padding:0 ", ";@media ", "{padding:0 ", ";}"], function (p) {
  return p._css8;
}, function (p) {
  return p._css9;
}, function (p) {
  return p._css10;
}, function (p) {
  return p._css11;
});

var _StyledIcon2 = styled(Icon).withConfig({
  displayName: "List___StyledIcon2",
  componentId: "sc-1olvz6t-4"
})(["min-width:", ";"], function (p) {
  return p._css12;
});

var _StyledFlex4$2 = styled(Flex).withConfig({
  displayName: "List___StyledFlex4",
  componentId: "sc-1olvz6t-5"
})(["width:100%;"]);

var _StyledFlex5$1 = styled(Flex).withConfig({
  displayName: "List___StyledFlex5",
  componentId: "sc-1olvz6t-6"
})(["margin:0;@media ", "{margin:0 ", ";}"], function (p) {
  return p._css13;
}, function (p) {
  return p._css14;
});

var _StyledFlex6$1 = styled(Flex).withConfig({
  displayName: "List___StyledFlex6",
  componentId: "sc-1olvz6t-7"
})(["gap:", ";padding:0 ", ";@media ", "{padding:0 ", ";}}"], function (p) {
  return p._css15;
}, function (p) {
  return p._css16;
}, function (p) {
  return p._css17;
}, function (p) {
  return p._css18;
});

var _StyledIcon3 = styled(Icon).withConfig({
  displayName: "List___StyledIcon3",
  componentId: "sc-1olvz6t-8"
})(["min-width:", ";"], function (p) {
  return p._css19;
});

var _StyledFlex7$1 = styled(Flex).withConfig({
  displayName: "List___StyledFlex7",
  componentId: "sc-1olvz6t-9"
})(["gap:", ";padding:0 ", ";@media ", "{padding:0 ", ";}"], function (p) {
  return p._css20;
}, function (p) {
  return p._css21;
}, function (p) {
  return p._css22;
}, function (p) {
  return p._css23;
});

var _StyledIcon4 = styled(Icon).withConfig({
  displayName: "List___StyledIcon4",
  componentId: "sc-1olvz6t-10"
})(["margin-top:", ";min-width:", ";"], function (p) {
  return p._css24;
}, function (p) {
  return p._css25;
});

var _StyledFlex8 = styled(Flex).withConfig({
  displayName: "List___StyledFlex8",
  componentId: "sc-1olvz6t-11"
})(["width:100%;"]);

var List = function List(_ref) {
  var _heading$type2, _title$type2;

  var alignment = _ref.alignment,
      background = _ref.background,
      button = _ref.button,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? 3 : _ref$columns,
      gapBetwItems = _ref.gapBetwItems,
      heading = _ref.heading,
      list = _ref.list,
      icon = _ref.icon,
      media = _ref.media,
      paragraph = _ref.paragraph,
      title = _ref.title,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? 'fadeInUp' : _ref$animation,
      customSpacing = _ref.customSpacing,
      _ref$noSection = _ref.noSection,
      noSection = _ref$noSection === void 0 ? false : _ref$noSection;

  function parseGap(gapBetwItems) {
    var value = gapBetwItems === 'regular' || !gapBetwItems ? 40 : 16;
    return value;
  }

  function parseAlignment(alignment) {
    var value;

    switch (alignment) {
      case 'left':
        {
          value = 'flex-start';
          break;
        }

      case 'right':
        {
          value = 'flex-end';
          break;
        }

      default:
        {
          value = 'center';
          break;
        }
    }

    return value;
  }

  var _useMedia = useMedia(),
      isMobile = _useMedia.isMobile;

  if (noSection) {
    var _heading$type, _title$type;

    return /*#__PURE__*/jsx(Animation, {
      type: isMobile ? 'none' : animation,
      children: /*#__PURE__*/jsx(ComponentContainer, {
        customSpacing: customSpacing,
        children: /*#__PURE__*/jsxs(_StyledFlex$9, {
          flexDirection: "column",
          alignItems: parseAlignment(alignment),
          _css: theme.device.laptop,
          _css2: rem(40),
          children: [(icon === null || icon === void 0 ? void 0 : icon.icon.icon) && /*#__PURE__*/jsx(Icon, {
            color: theme.colors[icon !== null && icon !== void 0 && icon.iconColor ? icon === null || icon === void 0 ? void 0 : icon.iconColor : 'rBlack'],
            name: icon === null || icon === void 0 ? void 0 : icon.icon.icon.sprite,
            family: icon === null || icon === void 0 ? void 0 : icon.icon.icon.sheet,
            iconSize: icon === null || icon === void 0 ? void 0 : icon.iconSize
          }), media && /*#__PURE__*/jsx(Media, {
            width: "104px",
            height: "104px",
            alt: media.alt,
            src: media.src,
            type: media.type
          }), heading && /*#__PURE__*/jsx(Text, {
            variant: (_heading$type = heading.type) != null ? _heading$type : 'paragraphMBold',
            $color: heading.color,
            marginTop: "xmini",
            center: true,
            children: heading.text
          }), title && /*#__PURE__*/jsx(Text, {
            variant: (_title$type = title.type) != null ? _title$type : 'title2XXL',
            $color: title.color,
            center: true,
            marginTop: "xmini",
            marginBottom: "xlarge",
            children: title.text
          }), paragraph && /*#__PURE__*/jsx(Flex, {
            marginBottom: "xlarge",
            children: /*#__PURE__*/jsx(ParagraphWrapper, {
              backgroundColor: background === null || background === void 0 ? void 0 : background.color,
              children: /*#__PURE__*/jsx(Text, {
                variant: "paragraphM",
                center: true,
                $color: paragraph.color,
                children: /*#__PURE__*/jsx(HtmlParser, {
                  children: paragraph.text
                })
              })
            })
          }), list && /*#__PURE__*/jsx(ListContainer, {
            gap: parseGap(gapBetwItems),
            alignment: parseAlignment(alignment),
            columns: columns ? columns : 3,
            children: list && list.map(function (listItem) {
              var _listItem$titleType;

              if (listItem.feature && listItem.featureColor) {
                var _listItem$feature, _listItem$feature$fea, _listItem$feature$fea2, _listItem$feature$fea3, _listItem$feature$fea4;

                return /*#__PURE__*/jsxs(_StyledFlex2$6, {
                  flexDirection: listItem.direction ? listItem.direction : 'column',
                  alignItems: listItem.direction ? listItem.direction === 'row' ? undefined : parseAlignment(alignment) : 'center',
                  _css3: rem(8),
                  _css4: rem(theme.sizes.small),
                  _css5: theme.device.laptop,
                  _css6: parseAlignment(alignment) === 'center' ? rem(40) : 0,
                  children: [((_listItem$feature$fea2 = listItem.feature.feature) === null || _listItem$feature$fea2 === void 0 ? void 0 : _listItem$feature$fea2.icon.icon) && /*#__PURE__*/jsx(_StyledIcon, {
                    color: theme.colors[listItem.featureIconColor],
                    name: listItem.feature.feature.icon.icon,
                    _css7: rem(20)
                  }), ((_listItem$feature$fea3 = listItem.feature.feature) === null || _listItem$feature$fea3 === void 0 ? void 0 : _listItem$feature$fea3.displayTitle) && /*#__PURE__*/jsx(Text, {
                    center: true,
                    variant: 'paragraphLBold',
                    $color: listItem.featureColor,
                    children: listItem.feature.feature.displayTitle
                  }), ((_listItem$feature$fea4 = listItem.feature.feature) === null || _listItem$feature$fea4 === void 0 ? void 0 : _listItem$feature$fea4.description) && /*#__PURE__*/jsx(ParagraphWrapper, {
                    backgroundColor: background === null || background === void 0 ? void 0 : background.color,
                    children: /*#__PURE__*/jsx(Text, {
                      center: parseAlignment(alignment) === 'center' ? true : false,
                      variant: "paragraphS",
                      $color: listItem.featureParagraphColor,
                      children: /*#__PURE__*/jsx(HtmlParser, {
                        children: listItem.feature.feature.description.value
                      })
                    })
                  })]
                }, (_listItem$feature = listItem.feature) === null || _listItem$feature === void 0 ? void 0 : (_listItem$feature$fea = _listItem$feature.feature) === null || _listItem$feature$fea === void 0 ? void 0 : _listItem$feature$fea.displayTitle);
              }

              return /*#__PURE__*/jsxs(_StyledFlex3$4, {
                flexDirection: listItem.direction ? listItem.direction : 'column',
                alignItems: listItem.direction ? listItem.direction === 'row' ? 'center' : parseAlignment(alignment) : 'center',
                _css8: rem(8),
                _css9: rem(theme.sizes.small),
                _css10: theme.device.laptop,
                _css11: parseAlignment(alignment) === 'center' ? rem(40) : 0,
                children: [listItem.icon.name && /*#__PURE__*/jsx(_StyledIcon2, {
                  color: theme.colors[listItem.icon.color],
                  name: listItem.icon.name,
                  iconSize: listItem.icon.size,
                  _css12: rem(20)
                }), listItem.title && /*#__PURE__*/jsx(Text, {
                  center: parseAlignment(alignment) === 'center' ? true : false,
                  variant: (_listItem$titleType = listItem.titleType) != null ? _listItem$titleType : 'paragraphLBold',
                  $color: listItem.titleColor,
                  children: listItem.title
                }), listItem.paragraph && /*#__PURE__*/jsx(ParagraphWrapper, {
                  backgroundColor: background === null || background === void 0 ? void 0 : background.color,
                  children: /*#__PURE__*/jsx(Text, {
                    center: parseAlignment(alignment) === 'center' ? true : false,
                    variant: listItem.paragraphType ? listItem.paragraphType : 'paragraphS',
                    $color: listItem.paragraphColor,
                    children: /*#__PURE__*/jsx(HtmlParser, {
                      children: listItem.paragraph
                    })
                  })
                })]
              }, listItem.title);
            })
          }), button && /*#__PURE__*/jsx(_StyledFlex4$2, {
            flexDirection: {
              mobile: 'column',
              tablet: 'row'
            },
            justifyContent: {
              mobile: 'center'
            },
            marginTop: "xlarge",
            children: /*#__PURE__*/jsx(ButtonLink, {
              href: button.href,
              size: button.size,
              variant: button.variant,
              children: button.children
            })
          })]
        })
      })
    });
  }

  return /*#__PURE__*/jsx(Section, {
    flex: true,
    background: background,
    children: /*#__PURE__*/jsx(Animation, {
      type: isMobile ? 'none' : animation,
      children: /*#__PURE__*/jsx(ComponentContainer, {
        customSpacing: customSpacing,
        children: /*#__PURE__*/jsxs(_StyledFlex5$1, {
          flexDirection: "column",
          alignItems: parseAlignment(alignment),
          _css13: theme.device.laptop,
          _css14: rem(40),
          children: [(icon === null || icon === void 0 ? void 0 : icon.icon.icon) && /*#__PURE__*/jsx(Icon, {
            color: theme.colors[icon !== null && icon !== void 0 && icon.iconColor ? icon === null || icon === void 0 ? void 0 : icon.iconColor : 'rBlack'],
            name: icon === null || icon === void 0 ? void 0 : icon.icon.icon.sprite,
            family: icon === null || icon === void 0 ? void 0 : icon.icon.icon.sheet,
            iconSize: icon === null || icon === void 0 ? void 0 : icon.iconSize
          }), media && /*#__PURE__*/jsx(Media, {
            width: "104px",
            height: "104px",
            alt: media.alt,
            src: media.src,
            type: media.type
          }), heading && /*#__PURE__*/jsx(Text, {
            variant: (_heading$type2 = heading.type) != null ? _heading$type2 : 'paragraphMBold',
            $color: heading.color,
            marginTop: "xmini",
            center: true,
            children: heading.text
          }), title && /*#__PURE__*/jsx(Text, {
            variant: (_title$type2 = title.type) != null ? _title$type2 : 'title2XXL',
            $color: title.color,
            center: true,
            marginTop: "xmini",
            marginBottom: "xlarge",
            children: title.text
          }), paragraph && /*#__PURE__*/jsx(Flex, {
            marginBottom: "xlarge",
            children: /*#__PURE__*/jsx(ParagraphWrapper, {
              backgroundColor: background === null || background === void 0 ? void 0 : background.color,
              children: /*#__PURE__*/jsx(Text, {
                variant: "paragraphL",
                center: true,
                $color: paragraph.color,
                children: /*#__PURE__*/jsx(HtmlParser, {
                  children: paragraph.text
                })
              })
            })
          }), list && /*#__PURE__*/jsx(ListContainer, {
            gap: parseGap(gapBetwItems),
            alignment: parseAlignment(alignment),
            columns: columns,
            children: list && list.map(function (listItem) {
              var _listItem$titleType2;

              if (listItem.feature && listItem.featureColor) {
                var _listItem$feature2, _listItem$feature2$fe, _listItem$feature$fea5, _listItem$feature$fea6, _listItem$feature$fea7, _listItem$feature$fea8;

                return /*#__PURE__*/jsxs(_StyledFlex6$1, {
                  flexDirection: listItem.direction ? listItem.direction : 'column',
                  alignItems: listItem.direction ? listItem.direction === 'row' ? 'center' : parseAlignment(alignment) : 'center',
                  _css15: rem(8),
                  _css16: rem(theme.sizes.small),
                  _css17: theme.device.laptop,
                  _css18: parseAlignment(alignment) === 'center' ? rem(40) : 0,
                  children: [((_listItem$feature$fea5 = listItem.feature.feature) === null || _listItem$feature$fea5 === void 0 ? void 0 : _listItem$feature$fea5.icon.icon) && /*#__PURE__*/jsx(_StyledIcon3, {
                    color: theme.colors[listItem.featureIconColor],
                    name: (_listItem$feature$fea6 = listItem.feature.feature.iconSVG) === null || _listItem$feature$fea6 === void 0 ? void 0 : _listItem$feature$fea6.sprite,
                    iconSize: listItem.featureIconSize,
                    _css19: rem(20)
                  }), ((_listItem$feature$fea7 = listItem.feature.feature) === null || _listItem$feature$fea7 === void 0 ? void 0 : _listItem$feature$fea7.displayTitle) && /*#__PURE__*/jsx(Text, {
                    center: true,
                    variant: 'paragraphLBold',
                    $color: listItem.featureColor,
                    children: listItem.feature.feature.displayTitle
                  }), ((_listItem$feature$fea8 = listItem.feature.feature) === null || _listItem$feature$fea8 === void 0 ? void 0 : _listItem$feature$fea8.description) && /*#__PURE__*/jsx(ParagraphWrapper, {
                    backgroundColor: background === null || background === void 0 ? void 0 : background.color,
                    children: /*#__PURE__*/jsx(Text, {
                      center: parseAlignment(alignment) === 'center' ? true : false,
                      variant: "paragraphS",
                      $color: listItem.featureParagraphColor,
                      children: /*#__PURE__*/jsx(HtmlParser, {
                        children: listItem.feature.feature.description.value
                      })
                    })
                  })]
                }, (_listItem$feature2 = listItem.feature) === null || _listItem$feature2 === void 0 ? void 0 : (_listItem$feature2$fe = _listItem$feature2.feature) === null || _listItem$feature2$fe === void 0 ? void 0 : _listItem$feature2$fe.displayTitle);
              }

              return /*#__PURE__*/jsxs(_StyledFlex7$1, {
                flexDirection: listItem.direction ? listItem.direction : 'column',
                alignItems: listItem.direction ? listItem.direction === 'row' ? 'center' : parseAlignment(alignment) : 'center',
                _css20: rem(8),
                _css21: rem(theme.sizes.small),
                _css22: theme.device.laptop,
                _css23: parseAlignment(alignment) === 'center' ? rem(40) : 0,
                children: [listItem.icon.name && /*#__PURE__*/jsx(_StyledIcon4, {
                  color: theme.colors[listItem.icon.color],
                  name: listItem.icon.name.sprite,
                  family: listItem.icon.name.sheet,
                  iconSize: listItem.icon.size,
                  _css24: rem(3),
                  _css25: rem(20)
                }), listItem.title && /*#__PURE__*/jsx(Text, {
                  center: parseAlignment(alignment) === 'center' ? true : false,
                  variant: (_listItem$titleType2 = listItem.titleType) != null ? _listItem$titleType2 : 'paragraphLBold',
                  $color: listItem.titleColor,
                  children: listItem.title
                }), listItem.paragraph && /*#__PURE__*/jsx(ParagraphWrapper, {
                  backgroundColor: background === null || background === void 0 ? void 0 : background.color,
                  children: /*#__PURE__*/jsx(Text, {
                    center: parseAlignment(alignment) === 'center' ? true : false,
                    variant: listItem.paragraphType ? listItem.paragraphType : 'paragraphS',
                    $color: listItem.paragraphColor,
                    children: /*#__PURE__*/jsx(HtmlParser, {
                      children: listItem.paragraph
                    })
                  })
                })]
              }, listItem.title);
            })
          }), button && /*#__PURE__*/jsx(_StyledFlex8, {
            flexDirection: {
              mobile: 'column',
              tablet: 'row'
            },
            justifyContent: {
              mobile: 'center'
            },
            marginTop: "xlarge",
            children: /*#__PURE__*/jsx(ButtonLink, {
              href: button.href,
              size: button.size,
              variant: button.variant,
              children: button.children
            })
          })]
        })
      })
    })
  });
};

var CategoryCTAWrapper = styled.div.withConfig({
  displayName: "Categoriesstyles__CategoryCTAWrapper",
  componentId: "sc-954w1r-0"
})(["flex:0 0 auto;"]);
var CategoryCTA = styled.div.withConfig({
  displayName: "Categoriesstyles__CategoryCTA",
  componentId: "sc-954w1r-1"
})(["display:flex;flex-direction:row;align-items:center;border:1px solid ", ";border-radius:", ";", " p{white-space:nowrap;}&:hover{border:1px solid ", ";p{color:", ";}}&:active{transform:scale(0.95);border:1px solid ", ";}", ""], theme.colors.rBlack, rem(32), function (_ref) {
  var size = _ref.size;
  return size && "  padding: " + (size === 'big' ? '16px 24px' : '8px 16px') + ";\n    ";
}, theme.colors.rLavender, theme.colors.rOnyx, theme.colors.rLavender, function (_ref2) {
  var active = _ref2.active;
  return active && "\n    background: " + theme.colors.snow + "; \n    border: 1px solid transparent;\n    p {\n      border: 0;\n      color: " + theme.colors.rBlack + ";\n      font-weight: 500;\n    }\n  ";
});
var SubCategoryCTA = styled.div.withConfig({
  displayName: "Categoriesstyles__SubCategoryCTA",
  componentId: "sc-954w1r-2"
})(["display:flex;flex-direction:row;align-items:center;border:1px solid ", ";border-radius:", ";padding:", " ", ";p{white-space:nowrap;}&:hover{border:1px solid ", ";p{color:", ";}}", " &:active{transform:scale(0.95);border:1px solid ", ";}"], theme.colors.rBlack, rem(24), rem(8), rem(16), theme.colors.rLavender, theme.colors.rOnyx, function (_ref3) {
  var active = _ref3.active;
  return active && "\n  background: " + theme.colors.rSilver + "; \n  border: 1px solid transparent;\n  &:hover {\n    border: 1px solid transparent !important; \n  }\n  p {\n    border: 0;\n    color: " + theme.colors.rBlack + ";\n    font-weight: 500;\n  }\n";
}, theme.colors.rLavender);
var CategoryWrapper = styled.div.withConfig({
  displayName: "Categoriesstyles__CategoryWrapper",
  componentId: "sc-954w1r-3"
})(["display:flex;gap:12px;flex-flow:nowrap;justify-content:start;width:100%;@media ", "{flex-wrap:wrap;}@media (min-width:960px){justify-content:center;width:100%;}overflow-x:auto;-webkit-overflow-scrolling:touch;"], theme.device.laptop);

var Links = function Links(_ref) {
  var background = _ref.background,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? 'fadeInUp' : _ref$animation,
      customSpacing = _ref.customSpacing,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      links = _ref.links;
  return /*#__PURE__*/jsx(Section, {
    flex: true,
    background: background,
    children: /*#__PURE__*/jsx(Animation, {
      type: animation,
      children: /*#__PURE__*/jsx(ComponentContainer, {
        customSpacing: customSpacing,
        children: /*#__PURE__*/jsx(CategoryWrapper, {
          children: links && links.map(function (link, index) {
            return /*#__PURE__*/jsx(CategoryCTAWrapper, {
              children: /*#__PURE__*/jsx(Link, {
                href: link.link,
                "data-cy": link.title,
                children: /*#__PURE__*/jsx(CategoryCTA, {
                  size: size,
                  children: /*#__PURE__*/jsx(Text, {
                    variant: size === 'big' ? 'bigButton' : 'mediumButton',
                    $color: 'rBlack',
                    children: link.title
                  })
                })
              }, index)
            }, index);
          })
        })
      })
    })
  });
};

var _StyledFlex$8 = styled(Flex).withConfig({
  displayName: "TabStyleText___StyledFlex",
  componentId: "sc-1nm54rr-0"
})(["gap:", ";width:100%;display:", ";animation:", " 1s ", ";animation-fill-mode:both;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

var _StyledFlex2$5 = styled(Flex).withConfig({
  displayName: "TabStyleText___StyledFlex2",
  componentId: "sc-1nm54rr-1"
})(["padding:0 ", ";width:calc((100% / 12) * 4);"], function (p) {
  return p._css5;
});

var _StyledFlex3$3 = styled(Flex).withConfig({
  displayName: "TabStyleText___StyledFlex3",
  componentId: "sc-1nm54rr-2"
})(["width:calc((100% / 12) * 8);flex:1;aspect-ratio:16 / 9;animation:", " 1s ", ";animation-fill-mode:both;img,video,iframe{border-radius:", ";}"], function (p) {
  return p._css6;
}, function (p) {
  return p._css7;
}, function (p) {
  return p._css8;
});

var _StyledMedia$1 = styled(Media).withConfig({
  displayName: "TabStyleText___StyledMedia",
  componentId: "sc-1nm54rr-3"
})(["width:100%;"]);

var _StyledFlex4$1 = styled(Flex).withConfig({
  displayName: "TabStyleText___StyledFlex4",
  componentId: "sc-1nm54rr-4"
})(["gap:24px;"]);

var _StyledFlex5 = styled(Flex).withConfig({
  displayName: "TabStyleText___StyledFlex5",
  componentId: "sc-1nm54rr-5"
})(["aspect-ratio:16 / 9;animation:", " 1s ", ";animation-fill-mode:both;width:100%;img,video,iframe{border-radius:", ";}"], function (p) {
  return p._css9;
}, function (p) {
  return p._css10;
}, function (p) {
  return p._css11;
});

var _StyledFlex6 = styled(Flex).withConfig({
  displayName: "TabStyleText___StyledFlex6",
  componentId: "sc-1nm54rr-6"
})(["text-align:left;"]);

var _StyledFlex7 = styled(Flex).withConfig({
  displayName: "TabStyleText___StyledFlex7",
  componentId: "sc-1nm54rr-7"
})(["width:100%;"]);

var TabStyleText = function TabStyleText(_ref) {
  var tabs = _ref.tabs,
      backgroundColor = _ref.backgroundColor;

  if (!tabs) {
    return null;
  }

  var _useState = useState(0),
      activeItemHorizontalMenu = _useState[0],
      setActiveItemHorizontalMenu = _useState[1];

  var _useMedia = useMedia(),
      isLaptop = _useMedia.isLaptop;

  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(MediaQuery, {
      laptop: true,
      desktop: true,
      children: isLaptop && /*#__PURE__*/jsxs(Fragment$1, {
        children: [tabs.length > 1 && /*#__PURE__*/jsx(HorizontalMenu, {
          active: activeItemHorizontalMenu,
          onChange: setActiveItemHorizontalMenu,
          children: tabs.map(function (tab, index) {
            var _tab$tabTitle;

            return /*#__PURE__*/jsx(HorizontalMenuItem, {
              variant: (_tab$tabTitle = tab.tabTitle) === null || _tab$tabTitle === void 0 ? void 0 : _tab$tabTitle.type,
              backgroundColor: backgroundColor ? backgroundColor.color : undefined,
              color: tab.tabTitle.color,
              activeColor: backgroundColor ? backgroundColor.color === 'rBlack' || backgroundColor.color === 'black' ? 'rWhite' : 'rBlack' : 'rBlack',
              children: tab.tabTitle.text
            }, 'horizontal-menu-tabs' + index);
          })
        }), tabs.map(function (tab, index) {
          var _tab$heading$type, _tab$heading, _tab$title$type, _tab$title, _tab$title$color;

          return /*#__PURE__*/jsxs(_StyledFlex$8, {
            alignItems: "center",
            flexDirection: {
              mobile: 'column-reverse',
              laptop: 'row'
            },
            marginTop: tabs.length > 1 ? 'large' : undefined,
            _css: rem(theme.sizes.medium),
            _css2: activeItemHorizontalMenu === index ? 'flex' : 'none',
            _css3: theme.animations.fadeIn,
            _css4: theme.transitions.easeInOut,
            children: [/*#__PURE__*/jsxs(_StyledFlex2$5, {
              alignItems: "flex-start",
              flexDirection: "column",
              _css5: rem(theme.sizes.medium),
              children: [tab.heading && /*#__PURE__*/jsx(Text, {
                variant: (_tab$heading$type = (_tab$heading = tab.heading) === null || _tab$heading === void 0 ? void 0 : _tab$heading.type) != null ? _tab$heading$type : 'paragraphMBold',
                $color: tab.heading.color,
                uppercase: true,
                children: tab.heading.text
              }), tab.title && /*#__PURE__*/jsx(Text, {
                variant: (_tab$title$type = (_tab$title = tab.title) === null || _tab$title === void 0 ? void 0 : _tab$title.type) != null ? _tab$title$type : 'title3',
                marginTop: "xmini",
                $color: (_tab$title$color = tab.title.color) != null ? _tab$title$color : 'rBlack',
                "data-cy": tab.title.text,
                children: tab.title.text
              }), tab.paragraph && /*#__PURE__*/jsx(Flex, {
                marginTop: "small",
                children: /*#__PURE__*/jsx(ParagraphWrapper, {
                  backgroundColor: backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.color,
                  children: /*#__PURE__*/jsx(Text, {
                    variant: tab.paragraph.type ? tab.paragraph.type : 'paragraphM',
                    $color: tab.paragraph.color,
                    children: /*#__PURE__*/jsx(HtmlParser, {
                      children: tab.paragraph.text
                    })
                  })
                })
              }), tab.button && /*#__PURE__*/jsx(Flex, {
                marginTop: "large",
                children: /*#__PURE__*/jsx(ButtonLink, {
                  href: tab.button.href,
                  size: tab.button.size,
                  variant: tab.button.variant,
                  children: tab.button.children
                })
              })]
            }), /*#__PURE__*/jsx(_StyledFlex3$3, {
              alignItems: "center",
              flexDirection: "column",
              _css6: theme.animations.fadeIn,
              _css7: theme.transitions.easeInOut,
              _css8: rem(tab.mediaBorRadius ? tab.mediaBorRadius : 0),
              children: tab.media && /*#__PURE__*/jsx(_StyledMedia$1, {
                type: tab.media.type,
                src: tab.media.src,
                alt: tab.media.alt
              }, tab.media.src)
            })]
          }, 'horizontal-menu-tabs' + index);
        })]
      })
    }), !isLaptop && /*#__PURE__*/jsx(MediaQuery, {
      mobile: true,
      tablet: true,
      children: /*#__PURE__*/jsx(Flex, {
        alignItems: "flex-start",
        flexDirection: "column",
        children: /*#__PURE__*/jsx(VerticalMenu, {
          active: activeItemHorizontalMenu,
          onChange: setActiveItemHorizontalMenu,
          children: tabs.map(function (tab, index) {
            var _tab$heading$type2, _tab$title$type2;

            return /*#__PURE__*/jsx(VerticalMenuItemBasic, {
              textAlign: "left",
              title: tabs.length > 1 ? tab.tabTitle : undefined,
              children: /*#__PURE__*/jsxs(_StyledFlex4$1, {
                flexDirection: tab.flipMobile ? 'column-reverse' : 'column',
                children: [/*#__PURE__*/jsx(_StyledFlex5, {
                  alignItems: "center",
                  _css9: theme.animations.fadeIn,
                  _css10: theme.transitions.easeInOut,
                  _css11: rem(tab.mediaBorRadius ? tab.mediaBorRadius : 0),
                  children: tab.media && /*#__PURE__*/jsx(Media, _extends$2({}, tab.media), 'vertical-menu-tabs' + index)
                }), /*#__PURE__*/jsxs(Flex, {
                  alignItems: "flex-start",
                  flexDirection: "column",
                  children: [tab.heading && /*#__PURE__*/jsx(Text, {
                    variant: (_tab$heading$type2 = tab.heading.type) != null ? _tab$heading$type2 : 'paragraphMBold',
                    $color: tab.heading.color,
                    uppercase: true,
                    children: tab.heading.text
                  }), tab.title && /*#__PURE__*/jsx(Text, {
                    variant: (_tab$title$type2 = tab.title.type) != null ? _tab$title$type2 : 'title3',
                    marginTop: "xmini",
                    $color: tab.title.color,
                    children: tab.title.text
                  }), tab.paragraph && /*#__PURE__*/jsx(_StyledFlex6, {
                    marginTop: "small",
                    children: /*#__PURE__*/jsx(Text, {
                      variant: tab.paragraph.type ? tab.paragraph.type : 'paragraphL',
                      $color: tab.paragraph.color,
                      children: /*#__PURE__*/jsx(HtmlParser, {
                        children: tab.paragraph.text
                      })
                    })
                  }), tab.button && /*#__PURE__*/jsx(_StyledFlex7, {
                    marginTop: "large",
                    children: /*#__PURE__*/jsx(ButtonLink, {
                      href: tab.button.href,
                      size: tab.button.size,
                      variant: tab.button.variant,
                      fullwidth: true,
                      children: tab.button.children
                    })
                  })]
                })]
              })
            }, 'vertical-menu-tabs' + index);
          })
        })
      })
    })]
  });
};

var tabVariants = {
  text: TabStyleText
};

var _StyledFlex$7 = styled(Flex).withConfig({
  displayName: "Tabs___StyledFlex",
  componentId: "sc-42t03x-0"
})(["gap:", ";"], function (p) {
  return p._css;
});

var _StyledFlex2$4 = styled(Flex).withConfig({
  displayName: "Tabs___StyledFlex2",
  componentId: "sc-42t03x-1"
})(["text-align:center;@media ", "{max-width:calc((100% / 12) * 10);}"], function (p) {
  return p._css2;
});

var _StyledText$3 = styled(Text).withConfig({
  displayName: "Tabs___StyledText",
  componentId: "sc-42t03x-2"
})(["&:not(:last-child){margin-bottom:", ";}"], function (p) {
  return p._css3;
});

var Tabs = function Tabs(props) {
  var _props$animation, _props$heading$type, _props$title$type, _props$background;

  var TabToRender = tabVariants[props.type];
  return /*#__PURE__*/jsx(Section, {
    background: props.background,
    children: /*#__PURE__*/jsx(Animation, {
      type: (_props$animation = props.animation) != null ? _props$animation : 'fadeInUp',
      children: /*#__PURE__*/jsx(ComponentContainer, {
        customSpacing: props.customSpacing,
        children: /*#__PURE__*/jsxs(_StyledFlex$7, {
          flexDirection: "column",
          alignItems: "center",
          _css: rem(theme.sizes.large),
          children: [/*#__PURE__*/jsxs(_StyledFlex2$4, {
            flexDirection: "column",
            alignItems: "center",
            _css2: theme.device.laptop,
            children: [props.heading && /*#__PURE__*/jsx(Text, {
              variant: (_props$heading$type = props.heading.type) != null ? _props$heading$type : 'paragraphMBold',
              $color: props.heading.color,
              center: true,
              uppercase: true,
              children: props.heading.text
            }), props.title && /*#__PURE__*/jsx(_StyledText$3, {
              variant: (_props$title$type = props.title.type) != null ? _props$title$type : 'title2XXL',
              center: true,
              marginTop: 'small',
              $color: props.title.color,
              _css3: rem(theme.sizes.small),
              children: props.title.text
            }), props.paragraph && /*#__PURE__*/jsx(ParagraphWrapper, {
              backgroundColor: (_props$background = props.background) === null || _props$background === void 0 ? void 0 : _props$background.color,
              children: /*#__PURE__*/jsx(Text, {
                variant: "paragraphL",
                center: true,
                $color: props.paragraph.color,
                children: /*#__PURE__*/jsx(HtmlParser, {
                  children: props.paragraph.text
                })
              })
            })]
          }), props.tabs && /*#__PURE__*/jsx(TabToRender, _extends$2({
            backgroundColor: props.background
          }, props))]
        })
      })
    })
  });
};

var MS_DURATION = 7000;
var S_DURATION = MS_DURATION / 1000;
var testimonialAnimation = keyframes$1(["0%{transform:translateX(", ");opacity:0;}20%{transform:translateX(", ");opacity:1;}80%{transform:translateX(", ");opacity:1;}100%{transform:translateX(", ");opacity:0;}"], rem(100), rem(0), rem(0), rem(-100));

var TextColorWrapper = styled.div.withConfig({
  displayName: "TestimonialChattestimony__TextColorWrapper",
  componentId: "g28wkq-0"
})(["display:flex;align-items:center;", ""], function (_ref) {
  var color = _ref.color;
  return color && "\n  color: " + theme.colors[color] + "; \n  p { \n    color: " + theme.colors[color] + ";\n    font-weight: 700;\n  } \n  ";
});

var _StyledTextColorWrapper2 = styled(TextColorWrapper).withConfig({
  displayName: "TestimonialChattestimony___StyledTextColorWrapper2",
  componentId: "g28wkq-1"
})(["padding-left:", ";"], function (p) {
  return p._css28;
});

var _StyledTextColorWrapper = styled(TextColorWrapper).withConfig({
  displayName: "TestimonialChattestimony___StyledTextColorWrapper",
  componentId: "g28wkq-2"
})(["padding-left:", ";"], function (p) {
  return p._css27;
});

var AvatarWrapper = styled.div.withConfig({
  displayName: "TestimonialChattestimony__AvatarWrapper",
  componentId: "g28wkq-3"
})(["flex:none;img{border-radius:", ";}z-index:99;@media ", "{img{border-radius:", ";}}@media ", "{img{border-radius:", ";}}"], rem(112), theme.device.tablet, rem(112), theme.device.laptop, rem(112));

var _StyledAvatarWrapper = styled(AvatarWrapper).withConfig({
  displayName: "TestimonialChattestimony___StyledAvatarWrapper",
  componentId: "g28wkq-4"
})(["width:", "px;"], function (p) {
  return p._css11;
});

var _StyledFlex$6 = styled(Flex).withConfig({
  displayName: "TestimonialChattestimony___StyledFlex",
  componentId: "g28wkq-5"
})(["animation:", " ", "s ", " 1 normal both;animation-timing-function:ease;animation:", ";"], testimonialAnimation, S_DURATION, function (p) {
  return p._css;
}, function (p) {
  return p._css2;
});

var _StyledFlex2$3 = styled(Flex).withConfig({
  displayName: "TestimonialChattestimony___StyledFlex2",
  componentId: "g28wkq-6"
})(["min-height:", ";justify-content:center;gap:", ";flex-direction:column;@media ", "{flex-direction:row;gap:", ";min-height:", ";align-items:center;}@media ", "{padding:", " 0;}position:relative;", ""], function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
}, function (p) {
  return p._css5;
}, function (p) {
  return p._css6;
}, function (p) {
  return p._css7;
}, function (p) {
  return p._css8;
}, function (p) {
  return p._css9;
}, function (p) {
  return p._css10;
});

var _StyledAvatar = styled(Avatar).withConfig({
  displayName: "TestimonialChattestimony___StyledAvatar",
  componentId: "g28wkq-7"
})(["height:", "px;width:", "px;@media ", "{height:", "px;width:", "px;}", ""], function (p) {
  return p._css12;
}, function (p) {
  return p._css13;
}, function (p) {
  return p._css14;
}, function (p) {
  return p._css15;
}, function (p) {
  return p._css16;
}, function (p) {
  return p._css17;
});

var _StyledText$2 = styled(Text).withConfig({
  displayName: "TestimonialChattestimony___StyledText",
  componentId: "g28wkq-8"
})(["a{text-decoration:underline;}a:active,a:visited{color:", ";}"], function (p) {
  return p._css18;
});

var _StyledFlex3$2 = styled(Flex).withConfig({
  displayName: "TestimonialChattestimony___StyledFlex3",
  componentId: "g28wkq-9"
})(["padding:", " 0 0 0;"], function (p) {
  return p._css19;
});

var _StyledDiv$1 = styled("div").withConfig({
  displayName: "TestimonialChattestimony___StyledDiv",
  componentId: "g28wkq-10"
})(["display:flex;align-items:center;padding-right:", ";margin-right:", ";border-right:", " solid ", ";"], function (p) {
  return p._css20;
}, function (p) {
  return p._css21;
}, function (p) {
  return p._css22;
}, function (p) {
  return p._css23;
});

var _StyledImage = styled(Image).withConfig({
  displayName: "TestimonialChattestimony___StyledImage",
  componentId: "g28wkq-11"
})(["height:auto;width:", ";@media ", "{width:", ";}"], function (p) {
  return p._css24;
}, function (p) {
  return p._css25;
}, function (p) {
  return p._css26;
});

var _StyledText2$1 = styled(Text).withConfig({
  displayName: "TestimonialChattestimony___StyledText2",
  componentId: "g28wkq-12"
})(["font-weight:400 !important;"]);

var _StyledFlex4 = styled(Flex).withConfig({
  displayName: "TestimonialChattestimony___StyledFlex4",
  componentId: "g28wkq-13"
})(["flex-direction:column;justify-content:start;", ""], function (p) {
  return p._css29;
});

var Testimony = function Testimony(_ref2) {
  var avatarSrc = _ref2.avatarSrc,
      avatarAlt = _ref2.avatarAlt,
      avatarWidth = _ref2.avatarWidth,
      avatarHeight = _ref2.avatarHeight,
      brand = _ref2.brand,
      _ref2$colorSet = _ref2.colorSet,
      colorSet = _ref2$colorSet === void 0 ? 'rBlack' : _ref2$colorSet,
      name = _ref2.name,
      role = _ref2.role,
      testimony = _ref2.testimony,
      _ref2$testimonySize = _ref2.testimonySize,
      testimonySize = _ref2$testimonySize === void 0 ? 'paragraphLBold' : _ref2$testimonySize,
      size = _ref2.size,
      _ref2$single = _ref2.single,
      single = _ref2$single === void 0 ? false : _ref2$single;

  var _useMedia = useMedia(),
      isMobile = _useMedia.isMobile;

  if (!avatarWidth) {
    avatarWidth = isMobile ? 144 : 172;
  }

  if (!avatarHeight) {
    avatarHeight = isMobile ? 184 : 225;
  }

  return /*#__PURE__*/jsx(_StyledFlex$6, {
    flexDirection: 'column',
    _css: theme.transitions.easeInOut,
    _css2: single && "none",
    children: /*#__PURE__*/jsxs(_StyledFlex2$3, {
      flexDirection: "row",
      _css3: rem(660),
      _css4: rem(24),
      _css5: theme.device.tablet,
      _css6: rem(32),
      _css7: rem(330),
      _css8: theme.device.laptop,
      _css9: rem(theme.sizes.large),
      _css10: !size && "\n            @media " + theme.device.laptop + " {\n              max-height: unset;\n              align-items: center;\n            }\n          ",
      children: [/*#__PURE__*/jsx(_StyledAvatarWrapper, {
        _css11: avatarWidth,
        children: avatarSrc && /*#__PURE__*/jsx(_StyledAvatar, {
          src: avatarSrc,
          alt: avatarAlt,
          loading: "lazy",
          _css12: avatarHeight,
          _css13: avatarWidth,
          _css14: theme.device.tablet,
          _css15: avatarHeight,
          _css16: avatarWidth,
          _css17: !size && "\n                @media " + theme.device.laptop + " {\n                  height: " + avatarHeight + "px\n                  width: " + avatarWidth + "px;\n                }\n              "
        })
      }), /*#__PURE__*/jsx(TextColorWrapper, {
        color: colorSet,
        children: /*#__PURE__*/jsxs(_StyledText$2, {
          variant: testimonySize,
          _css18: colorSet ? theme.colors[colorSet] : 'rBlack',
          children: [/*#__PURE__*/jsx(HtmlParser, {
            children: testimony
          }), /*#__PURE__*/jsxs(_StyledFlex3$2, {
            justifyContent: 'flex-start',
            _css19: rem(16),
            children: [(brand === null || brand === void 0 ? void 0 : brand.mediaImage.src) && /*#__PURE__*/jsx(_StyledDiv$1, {
              _css20: rem(theme.sizes.mini),
              _css21: rem(theme.sizes.mini),
              _css22: rem(1),
              _css23: colorSet ? theme.colors[colorSet] : theme.colors['rBlack'],
              children: /*#__PURE__*/jsx(_StyledImage, {
                src: brand.mediaImage.src,
                alt: brand.mediaImage.alt,
                width: '133',
                _css24: rem(140),
                _css25: theme.device.laptop,
                _css26: rem(164)
              })
            }), /*#__PURE__*/jsxs(Flex, {
              flexDirection: 'column',
              justifyContent: 'center',
              children: [name && /*#__PURE__*/jsx(_StyledTextColorWrapper, {
                color: colorSet,
                _css27: brand !== null && brand !== void 0 && brand.mediaImage.src ? rem(16) : 0,
                children: /*#__PURE__*/jsx(Text, {
                  variant: "paragraphMBold",
                  marginBottom: "tiny",
                  children: name
                })
              }), role && /*#__PURE__*/jsx(_StyledTextColorWrapper2, {
                color: colorSet,
                _css28: brand !== null && brand !== void 0 && brand.mediaImage.src ? rem(16) : 0,
                children: /*#__PURE__*/jsx(_StyledText2$1, {
                  variant: "paragraphS",
                  children: role
                })
              })]
            })]
          })]
        })
      }), /*#__PURE__*/jsx(_StyledFlex4, {
        _css29: !size && "\n                @media " + theme.device.laptop + " {\n                  padding-right: " + rem(theme.sizes.xmini) + ";\n                  flex-direction: row;\n                  justify-content: flex-start;\n                }\n              "
      })]
    })
  });
};

var _excluded = ["background", "customSpacing", "messages", "size", "fullwidth", "showDots"];
var TestimonialFlex = styled(Flex).withConfig({
  displayName: "TestimonialChat__TestimonialFlex",
  componentId: "sc-1y9v0ye-0"
})(["position:relative;width:100%;min-height:", ";@media ", "{min-height:", ";}", ";", ";"], rem(660), theme.device.tablet, rem(340), function (_ref) {
  var fullwidth = _ref.fullwidth;
  return !fullwidth && "\n    @media " + theme.device.laptop + " {\n      margin: 0 auto;\n      max-width: calc((100% / 12) * 8);\n    }\n  ";
}, function (_ref2) {
  var size = _ref2.size;
  return size && "\n    @media " + theme.device.laptop + " {\n      height: " + rem(546) + ";\n      max-width: " + rem(808) + ";\n    }\n    @media " + theme.device.desktop + " {\n      height: " + rem(546) + ";\n      max-width: " + rem(936) + ";\n    }\n  ";
});
var Dot = styled.div.withConfig({
  displayName: "TestimonialChat__Dot",
  componentId: "sc-1y9v0ye-1"
})(["display:none;@media ", "{", " border-radius:50%;display:inline-block;margin-right:", ";width:", ";height:", ";&:hover{cursor:pointer;opacity:0.8;}", "}"], theme.device.laptop, function (_ref3) {
  var color = _ref3.color;
  return color && "\n        background-color: " + theme.colors[color] + ";\n      ";
}, rem(12), rem(16), rem(16), function (_ref4) {
  var current = _ref4.current,
      color = _ref4.color;
  return current && "\n    width: " + rem(16) + " !important;\n    height: " + rem(16) + " !important;\n    box-shadow:  0 0 0 5px " + (color === 'rBlack' ? theme.colors['rBlack15'] : theme.colors['rWhite15']) + ";\n";
});
var TestimonyFlex = styled(Flex).withConfig({
  displayName: "TestimonialChat__TestimonyFlex",
  componentId: "sc-1y9v0ye-2"
})(["display:flex;"]);

var _StyledSection$1 = styled(Section).withConfig({
  displayName: "TestimonialChat___StyledSection",
  componentId: "sc-1y9v0ye-3"
})(["width:100%;max-width:100%;"]);

var _StyledDiv = styled("div").withConfig({
  displayName: "TestimonialChat___StyledDiv",
  componentId: "sc-1y9v0ye-4"
})(["max-width:100%;height:auto;"]);

var _StyledDiv2 = styled("div").withConfig({
  displayName: "TestimonialChat___StyledDiv2",
  componentId: "sc-1y9v0ye-5"
})(["display:none;@media ", "{display:flex;}"], function (p) {
  return p._css;
});

var TestimonialChat = function TestimonialChat(_ref5) {
  var background = _ref5.background,
      customSpacing = _ref5.customSpacing,
      messages = _ref5.messages,
      size = _ref5.size,
      fullwidth = _ref5.fullwidth,
      _ref5$showDots = _ref5.showDots,
      showDots = _ref5$showDots === void 0 ? true : _ref5$showDots,
      rest = _objectWithoutPropertiesLoose$2(_ref5, _excluded);

  var _useState = useState(0),
      activeMessageGroup = _useState[0],
      setActiveMessageGroup = _useState[1];

  useEffect(function () {
    setInterval(function () {
      setActiveMessageGroup(function (prevActive) {
        var newActive = prevActive + 1;

        if (newActive === messages.length) {
          return 0;
        }

        return newActive;
      });
    }, MS_DURATION);
  }, []);
  return /*#__PURE__*/jsx(_StyledSection$1, _extends$2({
    flex: true,
    background: background
  }, rest, {
    children: /*#__PURE__*/jsx(ComponentContainer, {
      customSpacing: customSpacing,
      children: /*#__PURE__*/jsx(TestimonialFlex, {
        flexDirection: "column",
        justifyContent: "center",
        margin: "0 auto",
        fullwidth: fullwidth,
        children: messages.map(function (messageGroup, index) {
          if (index !== activeMessageGroup) {
            return null;
          }

          return /*#__PURE__*/jsxs(_StyledDiv, {
            children: [/*#__PURE__*/jsx(TestimonyFlex, {
              flexDirection: "column",
              justifyContent: "center",
              children: messageGroup.map(function (message) {
                if (!('response' in message)) {
                  return /*#__PURE__*/jsx(Fragment$2, {
                    children: /*#__PURE__*/jsx(Testimony, _extends$2({
                      size: size,
                      single: messages.length === 1
                    }, message))
                  }, message.name);
                }
              })
            }), showDots && messages.length > 1 && /*#__PURE__*/jsx(_StyledDiv2, {
              style: {
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'center'
              },
              _css: theme.device.laptop,
              children: /*#__PURE__*/jsx(Fragment$1, {
                children: messages.map(function (mes, i) {
                  return /*#__PURE__*/jsx(Dot, {
                    color: background ? background.color === 'rBlack' ? 'rWhite' : 'rBlack' : 'rBlack',
                    current: i === activeMessageGroup,
                    onClick: function onClick() {
                      setActiveMessageGroup(i);
                    }
                  }, i);
                })
              })
            })]
          }, index);
        })
      })
    })
  }));
};

var InputsContainer = styled.div.withConfig({
  displayName: "SessionInputstyled__InputsContainer",
  componentId: "sc-1oi93fy-0"
})(["padding:0 ", ";display:flex;align-items:center;gap:", ";"], rem(16), rem(8));
var InputSeparator = styled.div.withConfig({
  displayName: "SessionInputstyled__InputSeparator",
  componentId: "sc-1oi93fy-1"
})(["width:", ";height:", ";background:", ";"], rem(8), rem(2), theme.colors.rWhite);
var StyledInput = styled.input.withConfig({
  displayName: "SessionInputstyled__StyledInput",
  componentId: "sc-1oi93fy-2"
})(["height:", ";width:", ";@media ", "{height:", ";width:", ";}padding:0px ", ";color:", ";border-radius:", ";border:1px solid ", ";background-color:", ";text-align:center;font-size:", ";font-weight:900;"], rem(32), rem(32), theme.device.laptop, rem(24), rem(24), rem(4), theme.colors.rBlack, rem(3), theme.colors.rLavender, theme.colors.rWhite, rem(18));
var Wrapper = styled.div.withConfig({
  displayName: "SessionInputstyled__Wrapper",
  componentId: "sc-1oi93fy-3"
})(["position:relative;display:flex;align-items:center;gap:", ";margin:", " auto;@media ", "{margin:unset;}"], rem(16), rem(16), theme.device.laptop);

var isNumber = function isNumber(value) {
  return /^\d+$/.test(value);
};

var SessionInput = function SessionInput(_ref) {
  var length = _ref.length;

  var _useState = useState(''),
      sessionId = _useState[0],
      setSessionId = _useState[1];

  var _useState2 = useState(undefined),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1];

  useEffect(function () {
    setIsMobile(isMobileAndroidOrIphone(window.navigator.userAgent));
  }, []);
  var inputs = useMemo(function () {
    return Array.from({
      length: length
    }, function () {
      return /*#__PURE__*/createRef();
    });
  }, [length]);

  var updateSessionId = function updateSessionId(index, value) {
    var newSessionId = "" + sessionId.substring(0, index) + (value != null ? value : ' ') + sessionId.substring(index + 1);
    setSessionId(newSessionId);

    if (newSessionId.length === 6) {
      window.location.href = 'https://play.genially.com/p?sessionId=' + newSessionId + '&from=web';
    }

    return newSessionId;
  };

  var extractSessionId = function extractSessionId(text) {
    var sessionIdRegex = new RegExp("^\\d{6}$");
    if (sessionIdRegex.test(text)) return text;
    return text;
  };

  var handleKeyDown = function handleKeyDown(index) {
    return function (event) {
      var _inputs$current;

      var hasValue = !!event.currentTarget.value;
      if (event.key !== 'Backspace' || index === 0 || hasValue) return;
      (_inputs$current = inputs[index - 1].current) === null || _inputs$current === void 0 ? void 0 : _inputs$current.focus();
    };
  };

  var handlePaste = function handlePaste(event) {
    event.preventDefault();
    var clipboardText = event.clipboardData.getData('text');
    var sessionCode = extractSessionId(clipboardText);

    if (!sessionCode || sessionCode.length !== 6) {
      return;
    } else {
      setSessionId(sessionCode);
      window.location.href = 'https://play.genially.com/p?sessionId=' + sessionCode;
    }
  };

  var handleInputChange = function handleInputChange(index, currentValue) {
    return function (event) {
      var isDeleting = !isNumber(event.target.value.trim());

      if (isDeleting) {
        if (currentValue) {
          updateSessionId(index);
        }

        if (index > 0) {
          var _inputs, _inputs$current2;

          updateSessionId(index);
          (_inputs = inputs[index - 1]) === null || _inputs === void 0 ? void 0 : (_inputs$current2 = _inputs.current) === null || _inputs$current2 === void 0 ? void 0 : _inputs$current2.focus();
        }

        return;
      }

      if (event.target.value.length > 1) {
        // eslint-disable-next-line prefer-destructuring, no-param-reassign
        event.target.value = event.target.value[event.target.value.length - 1];
      }

      updateSessionId(index, +event.target.value);

      if (index < 6 - 1) {
        var _inputs$current3;

        (_inputs$current3 = inputs[index + 1].current) === null || _inputs$current3 === void 0 ? void 0 : _inputs$current3.focus();
      }
    };
  };

  var handleBeforeInput = function handleBeforeInput(e) {
    var inputValue = e.nativeEvent;
    var regex = /^[0-9]+$/;

    if (inputValue.data && !regex.test(inputValue.data)) {
      e.preventDefault();
    }
  };

  var moveCursorAtEnd = function moveCursorAtEnd(index) {
    var input = inputs[index].current;
    if (!input) return;
    input.selectionStart = 1;
    input.selectionEnd = 1;
  };

  var handleClick = function handleClick(index) {
    return function () {
      if (!isMobile) {
        moveCursorAtEnd(index);
      }
    };
  };

  var mobileProps = isMobile ? {
    type: 'number',
    inputMode: 'numeric',
    pattern: '[0-9]*'
  } : {};
  return /*#__PURE__*/jsx(Wrapper, {
    children: /*#__PURE__*/jsx(InputsContainer, {
      children: inputs.map(function (ref, index, arr // eslint-disable-next-line react/no-array-index-key
      ) {
        var _sessionId$index, _sessionId$index2;

        return (
          /*#__PURE__*/
          jsxs(Fragment$2, {
            children: [/*#__PURE__*/jsx(StyledInput // eslint-disable-next-line react/jsx-props-no-spreading
            , _extends$2({}, mobileProps, {
              ref: ref,
              value: (_sessionId$index = sessionId[index]) != null ? _sessionId$index : '',
              onKeyDown: handleKeyDown(index),
              onClick: handleClick(index),
              onBeforeInput: handleBeforeInput,
              onChange: handleInputChange(index, (_sessionId$index2 = sessionId[index]) === null || _sessionId$index2 === void 0 ? void 0 : _sessionId$index2.trim()),
              onPaste: handlePaste
            })), index + 1 === arr.length / 2 && /*#__PURE__*/jsx(InputSeparator, {})]
          }, index)
        );
      })
    })
  });
};

var Play = function Play(_ref) {
  var background = _ref.background,
      customSpacing = _ref.customSpacing,
      paragraph = _ref.paragraph;
  var Container = styled.div.withConfig({
    displayName: "Play__Container",
    componentId: "p5pydy-0"
  })(["margin:0 auto;width:100%;@media ", "{max-width:", ";}"], theme.device.desktop, rem(900));
  return /*#__PURE__*/jsx(Section, {
    background: background,
    children: /*#__PURE__*/jsx(Container, {
      children: /*#__PURE__*/jsx(ComponentContainer, {
        customSpacing: customSpacing,
        children: paragraph ? /*#__PURE__*/jsx(ParagraphWrapper, {
          backgroundColor: background === null || background === void 0 ? void 0 : background.color,
          children: /*#__PURE__*/jsxs(Flex, {
            flexDirection: {
              mobile: 'column',
              tablet: 'column',
              laptop: 'row'
            },
            justifyContent: 'center',
            children: [/*#__PURE__*/jsx(Text, {
              variant: 'paragraphM',
              $color: paragraph.color,
              children: /*#__PURE__*/jsx(HtmlParser, {
                children: paragraph.text
              })
            }), /*#__PURE__*/jsx(SessionInput, {
              length: 6
            })]
          })
        }) : null
      })
    })
  });
};

var TeaserContainer = styled.div.withConfig({
  displayName: "Teaserstyles__TeaserContainer",
  componentId: "sc-1wjlz4g-0"
})(["display:flex;align-items:center;width:100%;", " ", " ", ""], function (_ref) {
  var mediaBorRadius = _ref.mediaBorRadius;
  return mediaBorRadius === 8 && "\n    border-radius: 34px;\n\n    img,\n    video,\n    iframe {\n      border-radius: 24px;\n    }\n  ";
}, function (_ref2) {
  var columns = _ref2.columns,
      flip = _ref2.flip,
      flipMobile = _ref2.flipMobile;
  return columns === 1 && "\n    gap: " + rem(theme.sizes.xlarge) + ";\n    justify-content: center;\n    text-align: center;\n    flex-direction: " + (flipMobile ? 'column-reverse' : 'column') + ";\n    \n    @media " + theme.device.laptop + " {\n      flex-direction: " + (flip ? 'column-reverse' : 'column') + ";\n      margin: 0 auto;\n      max-width: calc((100% / 12) * 10);\n    }\n  ";
}, function (_ref3) {
  var columns = _ref3.columns,
      flip = _ref3.flip,
      flipMobile = _ref3.flipMobile;
  return columns === 2 && "\n    gap: " + rem(theme.sizes.large) + ";\n    justify-content: flex-start;\n    text-align: left;\n    flex-direction: " + (flipMobile ? 'column-reverse' : 'column') + ";\n    @media " + theme.device.laptop + " {\n      flex-direction: " + (flip ? 'row-reverse' : 'row') + ";\n      gap: " + rem(theme.sizes.medium) + ";\n    }\n  ";
});
var MediaColumn = styled.div.withConfig({
  displayName: "Teaserstyles__MediaColumn",
  componentId: "sc-1wjlz4g-1"
})(["display:flex;justify-content:center;", " width:100%;img{align-self:flex-start;}", ""], function (_ref4) {
  var mediaBorRadius = _ref4.mediaBorRadius;
  return mediaBorRadius && mediaBorRadius > 0 && "\n      img,\n      video,\n      iframe {\n        border-radius: " + rem(mediaBorRadius) + ";\n      }\n    ";
}, function (_ref5) {
  var columns = _ref5.columns;
  return columns === 2 && " \n      flex: 1 1 50%;\n            \n      @media " + theme.device.laptop + " {\n        order: 1; \n        max-width: calc((100% / 12) * 6);\n      }\n    ";
});
var TeaserColumn = styled.div.withConfig({
  displayName: "Teaserstyles__TeaserColumn",
  componentId: "sc-1wjlz4g-2"
})(["display:flex;flex-direction:column;width:100%;", ""], function (_ref6) {
  var columns = _ref6.columns;
  return columns === 1 ? "\n        align-items: center;\n      " : "\n        flex: 1 1 50%;\n\n        @media " + theme.device.laptop + " {\n          padding: 0 " + rem(theme.sizes.xlarge) + ";\n          max-width: calc((100% / 12) * 6);\n        }\n      ";
});
var ParagraphsContainer = styled(Flex).withConfig({
  displayName: "Teaserstyles__ParagraphsContainer",
  componentId: "sc-1wjlz4g-3"
})(["", ""], function (_ref7) {
  var columns = _ref7.columns;
  return columns === 1 && "\n      @media " + theme.device.laptop + " {\n        max-width: calc((100% / 10) * 8);\n      }\n    ";
});

var _StyledFlex$5 = styled(Flex).withConfig({
  displayName: "Teaser___StyledFlex",
  componentId: "gwzzoa-0"
})(["width:100%;"]);

var _StyledFlex2$2 = styled(Flex).withConfig({
  displayName: "Teaser___StyledFlex2",
  componentId: "gwzzoa-1"
})(["width:100%;@media ", "{width:unset;}"], function (p) {
  return p._css;
});

var Teaser = function Teaser(_ref) {
  var _heading$type, _title$type, _subtitle$type, _paragraph$type;

  var background = _ref.background,
      media = _ref.media,
      heading = _ref.heading,
      title = _ref.title,
      subtitle = _ref.subtitle,
      paragraph = _ref.paragraph,
      buttons = _ref.buttons,
      mediaBorRadius = _ref.mediaBorRadius,
      _ref$flip = _ref.flip,
      flip = _ref$flip === void 0 ? false : _ref$flip,
      _ref$flipMobile = _ref.flipMobile,
      flipMobile = _ref$flipMobile === void 0 ? false : _ref$flipMobile,
      columns = _ref.columns,
      customSpacing = _ref.customSpacing,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? 'fadeInUp' : _ref$animation,
      _ref$templatesHeader = _ref.templatesHeader,
      templatesHeader = _ref$templatesHeader === void 0 ? false : _ref$templatesHeader,
      first = _ref.first,
      content = _ref.content;
  var listSpacing = {
    desktop: {
      top: 24,
      bottom: 24,
      left: 0,
      right: 0
    },
    laptop: {
      top: 24,
      bottom: 24,
      left: 0,
      right: 0
    },
    tablet: {
      top: 24,
      bottom: 24,
      left: 0,
      right: 0
    },
    mobile: {
      top: 24,
      bottom: 24,
      left: 0,
      right: 0
    }
  };
  return /*#__PURE__*/jsx(Section, {
    background: background,
    templatesHeader: templatesHeader,
    children: /*#__PURE__*/jsx(Animation, {
      type: animation,
      children: /*#__PURE__*/jsx(ComponentContainer, {
        customSpacing: customSpacing,
        style: {
          display: templatesHeader ? 'flex' : 'block'
        },
        children: /*#__PURE__*/jsxs(TeaserContainer, {
          $media: media,
          columns: columns,
          flip: flip,
          flipMobile: flipMobile,
          children: [media && /*#__PURE__*/jsx(MediaColumn, {
            columns: columns,
            mediaBorRadius: mediaBorRadius,
            children: /*#__PURE__*/jsx(Media, _extends$2({}, media, {
              first: first,
              animation: animation
            }))
          }), (heading || title || subtitle || paragraph || buttons && buttons.length > 0) && /*#__PURE__*/jsxs(TeaserColumn, {
            columns: columns,
            children: [heading && /*#__PURE__*/jsx(Text, {
              variant: (_heading$type = heading.type) != null ? _heading$type : 'paragraphMBold',
              $color: heading.color,
              uppercase: true,
              children: heading.text
            }), title && /*#__PURE__*/jsx(Text, {
              family: 'Unbounded',
              variant: (_title$type = title.type) != null ? _title$type : 'title2XXL',
              $color: title.color,
              marginTop: "xmini",
              children: title.text
            }), subtitle && /*#__PURE__*/jsx(Text, {
              variant: (_subtitle$type = subtitle.type) != null ? _subtitle$type : 'paragraphLBold',
              $color: subtitle.color,
              marginTop: "small",
              children: subtitle.text
            }), paragraph ? /*#__PURE__*/jsx(ParagraphsContainer, {
              columns: columns,
              flexDirection: {
                mobile: 'column'
              },
              marginTop: {
                mobile: 'xmini',
                laptop: theme.sizes.xmini + " auto 0 auto"
              },
              children: /*#__PURE__*/jsx(ParagraphWrapper, {
                backgroundColor: background === null || background === void 0 ? void 0 : background.color,
                children: /*#__PURE__*/jsx(Text, {
                  variant: (_paragraph$type = paragraph.type) != null ? _paragraph$type : 'paragraphM',
                  $color: paragraph.color,
                  children: /*#__PURE__*/jsx(HtmlParser, {
                    children: paragraph.text
                  })
                })
              })
            }) : null, content && content.entity.items !== undefined && content.entity.items.length > 0 && content.entity.items[0].item.title ? /*#__PURE__*/jsx(List, {
              noSection: true,
              customSpacing: listSpacing,
              animation: content.entity.animation // background={parseBackground(behaviorSettings?.rowStyle.background)}
              // customSpacing={content.behaviorSettings?.rowStyle.spacing}
              // media={parseMedia(media)}
              ,
              alignment: content.entity.alignment,
              gapBetwItems: content.entity.gapBetwItems,
              columns: content.entity.columns // heading={
              //   content.heading ? { text: content.heading, color: content.headingColor ?? 'primary', type: content.headingType } : undefined
              // }
              // title={content.title ? { text: content.title, color: content.titleColor ?? 'black', type: content.titleType } : undefined}
              // paragraph={
              //   paragraph ? { text: content.paragraph.processed, color: content.paragraphColor ?? 'black' } : undefined
              // }
              ,
              list: content.entity.items ? parseListItems(content.entity.items) : undefined
            }) : /*#__PURE__*/jsx(Fragment$1, {}), buttons && buttons.length > 0 && /*#__PURE__*/jsx(_StyledFlex$5, {
              flexDirection: {
                mobile: 'column',
                tablet: 'row'
              },
              alignItems: "center",
              justifyContent: columns === 1 ? 'center' : 'flex-start',
              marginTop: columns == 1 ? 'xlarge' : 'large',
              children: buttons === null || buttons === void 0 ? void 0 : buttons.map(function (button, index) {
                return /*#__PURE__*/createElement(_StyledFlex2$2, _extends$2({
                  flexDirection: {
                    mobile: 'column',
                    tablet: 'row'
                  },
                  justifyContent: {
                    tablet: 'flex-start'
                  }
                }, index > 0 && {
                  marginTop: {
                    mobile: 'small',
                    tablet: 0
                  },
                  marginLeft: {
                    mobile: 0,
                    tablet: 'small'
                  }
                }, {
                  key: 'button' + index,
                  _css: theme.device.tablet
                }), /*#__PURE__*/jsx(ButtonLink, {
                  href: button.href,
                  size: button.size,
                  variant: button.variant,
                  children: button.children
                }));
              })
            })]
          })]
        })
      })
    })
  });
};
var parseListItems = function parseListItems(itemsDTO) {
  if (itemsDTO === void 0) {
    itemsDTO = [];
  }

  if (!itemsDTO) return [];
  return itemsDTO.map(function (itemDTO) {
    var _itemDTO$item$titleCo, _itemDTO$item$paragra, _itemDTO$item$paragra2, _itemDTO$item$paragra3;

    return {
      feature: itemDTO.item.feature,
      featureColor: itemDTO.item.featureColor,
      featureIconColor: itemDTO.item.featureIconColor,
      featureIconSize: itemDTO.item.featureIconSize,
      featureParagraphColor: itemDTO.item.featureParagraphColor,
      direction: itemDTO.item.direction,
      title: itemDTO.item.title,
      titleType: itemDTO.item.titleType,
      titleColor: (_itemDTO$item$titleCo = itemDTO.item.titleColor) != null ? _itemDTO$item$titleCo : 'rBlack',
      paragraph: (_itemDTO$item$paragra = itemDTO.item.paragraph) === null || _itemDTO$item$paragra === void 0 ? void 0 : _itemDTO$item$paragra.value,
      paragraphColor: (_itemDTO$item$paragra2 = itemDTO.item.paragraphColor) != null ? _itemDTO$item$paragra2 : 'rBlack',
      paragraphType: (_itemDTO$item$paragra3 = itemDTO.item.paragraphType) != null ? _itemDTO$item$paragra3 : 'paragraphS',
      icon: {
        name: itemDTO.item.iconSVG ? itemDTO.item.iconSVG.sprite : itemDTO.item.icon ? itemDTO.item.icon.icon : '',
        color: itemDTO.item.iconColor ? itemDTO.item.iconColor : '',
        size: itemDTO.item.iconSize ? itemDTO.item.iconSize : ''
      }
    };
  });
};

var _StyledFlex$4 = styled(Flex).withConfig({
  displayName: "PricingCards___StyledFlex",
  componentId: "s0uimn-0"
})(["flex-wrap:wrap;gap:", ";"], function (p) {
  return p._css;
});

var _StyledFlex2$1 = styled(Flex).withConfig({
  displayName: "PricingCards___StyledFlex2",
  componentId: "s0uimn-1"
})([":not(:first-child){margin-top:0;}"]);

var _StyledFlex3$1 = styled(Flex).withConfig({
  displayName: "PricingCards___StyledFlex3",
  componentId: "s0uimn-2"
})(["padding-left:", ";width:", ";"], function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var _StyledIconList = styled(IconList).withConfig({
  displayName: "PricingCards___StyledIconList",
  componentId: "s0uimn-3"
})(["margin-top:", ";"], function (p) {
  return p._css4;
});

var _StyledText$1 = styled(Text).withConfig({
  displayName: "PricingCards___StyledText",
  componentId: "s0uimn-4"
})(["flex-grow:1;line-height:24px !important;"]);

var PricingCards = function PricingCards(_ref) {
  var plans = _ref.plans,
      currency = _ref.currency,
      getCurrency = _ref.getCurrency,
      plansPricingAPI = _ref.plansPricingAPI;

  var ComingSoon = function ComingSoon(text) {
    return /*#__PURE__*/jsxs("div", {
      children: [text.text, /*#__PURE__*/jsx("span", {
        style: {
          background: theme.colors.rBlack,
          color: theme.colors.rWhite,
          borderRadius: rem(4),
          padding: rem(2) + " " + rem(4)
        },
        children: "Coming Soon"
      })]
    });
  };

  return /*#__PURE__*/jsx(_StyledFlex$4, {
    alignItems: "flex-start",
    justifyContent: "center",
    _css: rem(theme.sizes.large),
    children: plans.map(function (plan, index) {
      return /*#__PURE__*/jsxs(_StyledFlex2$1, {
        flexDirection: {
          mobile: 'column'
        },
        children: [/*#__PURE__*/jsx(PricingCard, {
          title: plan.card.title,
          description: plan.card.description,
          price: plan.card.price,
          priceText: plan.card.priceText,
          priceDescription: plan.card.priceDescription,
          people: plan.card.people,
          recurring: plan.card.recurring,
          peopleBackground: plan.card.peopleBackground,
          membersMonthText: plan.card.membersMonthText,
          highlightBanner: plan.card.highlightBanner,
          ribbonBackgroundColor: plan.card.ribbonBackgroundColor,
          ribbonBorderRadius: plan.card.ribbonBorderRadius,
          ribbonIcon: plan.card.ribbonIcon,
          priceFromAPI: plan.card.priceFromAPI,
          icon: plan.card.icon,
          button: plan.card.button,
          border: plan.card.border,
          backgroundColor: plan.card.backgroundColor,
          currency: currency,
          getCurrency: getCurrency,
          discountPercentage: plan.card.discountPercentage,
          crossedOutPrice: plan.card.crossedOutPrice,
          crossedOutLineColor: plan.card.crossedOutLineColor,
          plans: plansPricingAPI
        }), plan.feats && /*#__PURE__*/jsx(_StyledFlex3$1, {
          marginTop: "large",
          alignItems: {
            mobile: 'flex-start'
          },
          flexDirection: {
            mobile: 'column'
          },
          _css2: rem(16),
          _css3: rem('272px'),
          children: plan.feats && /*#__PURE__*/jsx(_StyledIconList, {
            _css4: rem(16),
            children: plan.feats.includes.map(function (feat, index) {
              var _plan$feats;

              var text;

              if (feat.text.substring(feat.text.length - 3) === '***') {
                text = /*#__PURE__*/jsx(ComingSoon, {
                  text: feat.text.replace('***', '')
                });
              } else {
                text = feat.text;
              }

              return /*#__PURE__*/jsx(IconListItem, {
                icon: (_plan$feats = plan.feats) === null || _plan$feats === void 0 ? void 0 : _plan$feats.icon,
                children: /*#__PURE__*/jsx(_StyledText$1, {
                  variant: "paragraphS",
                  children: text
                })
              }, 'icon-' + index);
            })
          })
        })]
      }, 'plan' + '-' + index);
    })
  });
};

var PricingContent = styled.div.withConfig({
  displayName: "Pricingstyles__PricingContent",
  componentId: "sc-1y2g5s8-0"
})(["display:flex;flex-direction:column;width:100%;padding-bottom:", ";animation:", " 1s ", ";animation-fill-mode:both;"], rem(96), theme.animations.fadeIn, theme.transitions.easeInOut);
styled.div.withConfig({
  displayName: "Pricingstyles__TableContainer",
  componentId: "sc-1y2g5s8-1"
})(["overflow:hidden;height:auto;max-height:0px;transition:max-height 1.5s ", ";", ""], theme.transitions.easeOut, function (_ref) {
  var isCollapsed = _ref.isCollapsed;
  return !isCollapsed && "\n        max-height: " + rem(9628) + ";\n        \n        @media " + theme.device.laptop + " {\n          max-height: " + rem(6288) + ";\n        }      \n        transition: max-height 1.5s " + theme.transitions.easeInOut + ";\n    ";
});

var _StyledFlex$3 = styled(Flex).withConfig({
  displayName: "PricingFilters___StyledFlex",
  componentId: "sc-17r0j70-0"
})(["gap:", ";margin-top:", ";"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
});

var PricingFilters = function PricingFilters(_ref) {
  var filters = _ref.filters,
      filterPicked = _ref.filterPicked,
      snowplowEvent = _ref.snowplowEvent;

  var _useState = useState('individual'),
      keyPicked = _useState[0],
      setKey = _useState[1];

  var handleClick = function handleClick(key) {
    filterPicked(key);
    setKey(key);
    history.replaceState(null, '', '?filter=' + key);
    snowplowEvent ? snowplowEvent() : null;
  };

  useEffect(function () {
    var slug = window.location.search.split('filter=').pop();
    var firstPart = slug === null || slug === void 0 ? void 0 : slug.split('&')[0];
    setKey(firstPart ? firstPart : 'individual');
    filterPicked(firstPart ? firstPart : 'individual');
  }, []);
  if (!filters) return /*#__PURE__*/jsx(Fragment$1, {});
  return /*#__PURE__*/jsx(_StyledFlex$3, {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: {
      tablet: 'row',
      mobile: 'column',
      desktop: 'row'
    },
    _css: rem(16),
    _css2: rem(32),
    children: filters.map(function (filter) {
      return /*#__PURE__*/jsx(Button, {
        onClick: function onClick() {
          return handleClick(filter.first);
        },
        variant: filter.first === keyPicked ? 'primary' : 'stroke',
        children: filter.second
      }, filter.first);
    })
  });
};

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

var isNil_1 = isNil;

var _StyledSection = styled(Section).withConfig({
  displayName: "Pricing___StyledSection",
  componentId: "sc-1whk9s8-0"
})(["position:relative;justify-content:center;z-index:10;"]);

var _StyledFlex$2 = styled(Flex).withConfig({
  displayName: "Pricing___StyledFlex",
  componentId: "sc-1whk9s8-1"
})(["gap:", ";flex-wrap:wrap;width:100%;"], function (p) {
  return p._css;
});

var Pricing = function Pricing(_ref) {
  var plans = _ref.plans,
      types = _ref.types,
      components = _ref.components,
      components2 = _ref.components2,
      snowplowEvent = _ref.snowplowEvent,
      _ref$withoutFilters = _ref.withoutFilters,
      withoutFilters = _ref$withoutFilters === void 0 ? false : _ref$withoutFilters;

  var _useState = useState('usd'),
      currency = _useState[0],
      setCurrency = _useState[1];

  var _useState2 = useState(false),
      getCurrency = _useState2[0],
      setGetCurrency = _useState2[1];

  var _useState3 = useState('individual'),
      filterValue = _useState3[0],
      setFilter = _useState3[1];

  var _useState4 = useState([]),
      filteredPlans = _useState4[0],
      setFilteredPlans = _useState4[1];

  useEffect(function () {
    userService.getCurrencyUser().then(function (data) {
      setCurrency(data);
      setGetCurrency(true);
    });
  }, []);
  useEffect(function () {
    if (withoutFilters) {
      setFilteredPlans(plans ? plans : []);
    } else {
      var _filteredPlans = plans === null || plans === void 0 ? void 0 : plans.filter(function (plan) {
        return plan.type === filterValue;
      });

      setFilteredPlans(_filteredPlans ? _filteredPlans : []);
    }
  }, [filterValue, withoutFilters]);

  var getPickedFilter = function getPickedFilter(data) {
    setFilter(data);
  };

  var _useState5 = useState([]),
      plansPricingAPI = _useState5[0],
      setPlansPricingAPIAPI = _useState5[1];

  useEffect(function () {
    fetch('https://pricing-web.genially.com/').then(function (res) {
      return res.json();
    }).then(function (data) {
      // 1.1: seteamos esos planes en un state propio
      setPlansPricingAPIAPI(data.prices);
    });
  }, []);
  var VARIANT_1COL = '1col';
  return /*#__PURE__*/jsx(_StyledSection, {
    flex: true,
    children: /*#__PURE__*/jsx(PricingContent, {
      children: /*#__PURE__*/jsxs(Container, {
        children: [/*#__PURE__*/jsx(PricingFilters, {
          snowplowEvent: snowplowEvent,
          filters: types,
          filterPicked: getPickedFilter
        }), /*#__PURE__*/jsxs(Flex, {
          flexDirection: "column",
          alignItems: "center",
          children: [filteredPlans.length > 0 && /*#__PURE__*/jsx(_StyledFlex$2, {
            marginTop: 'large',
            alignItems: {
              mobile: 'center',
              laptop: 'flex-start'
            },
            justifyContent: "center",
            flexDirection: {
              mobile: 'column',
              laptop: 'row'
            },
            _css: rem(theme.sizes.large),
            children: filteredPlans.length > 0 && /*#__PURE__*/jsx(PricingCards, {
              plans: filteredPlans,
              currency: currency,
              getCurrency: getCurrency,
              plansPricingAPI: plansPricingAPI
            })
          }), filterValue === 'freeform2' && /*#__PURE__*/jsx("div", {
            children: components2.map(function (component, index) {
              if (component.component.bundle === 'teaser') {
                var buttonPrimary = components2[index].component.buttonPrimary;
                var buttonPrimaryStyle = components2[index].component.buttonPrimaryStyle;
                var buttonSecondary = components2[index].component.buttonSecondary;
                var buttonSecondaryStyle = components2[index].component.buttonSecondaryStyle;
                return /*#__PURE__*/jsx(Teaser, {
                  background: parseBackground$1(components2[index].component.behaviorSettings.rowStyle.background),
                  customSpacing: components2[index].component.behaviorSettings.rowStyle.spacing,
                  content: components2[index].component.teaserContent,
                  animation: 'none',
                  flip: components2[index].component.flip,
                  flipMobile: components2[index].component.flipMobile,
                  mediaBorRadius: components2[index].component.mediaBorRadius,
                  title: {
                    text: components2[index].component.title,
                    type: components2[index].component.titleType,
                    color: components2[index].component.titleColor
                  },
                  heading: {
                    text: components2[index].component.heading,
                    type: components2[index].component.headingType,
                    color: components2[index].component.headingColor
                  },
                  paragraph: {
                    text: components2[index].component.paragraph ? components2[index].component.paragraph.processed : '',
                    color: components2[index].component.paragraphColor,
                    type: components2[index].component.paragraphType
                  },
                  media: parseMedia$1(components2[index].component.media),
                  columns: components2[index].component.variant === VARIANT_1COL ? 1 : 2,
                  buttons: getButtons$1({
                    buttonPrimary: buttonPrimary,
                    buttonPrimaryStyle: buttonPrimaryStyle,
                    buttonSecondary: buttonSecondary,
                    buttonSecondaryStyle: buttonSecondaryStyle
                  })
                });
              }

              if (component.component.bundle === 'banner') {
                return /*#__PURE__*/jsx(Banner, {
                  background: parseBackground$1(components2[index].component.behaviorSettings.rowStyle.background),
                  customSpacing: components2[index].component.behaviorSettings.rowStyle.spacing,
                  title: {
                    text: components2[index].component.title ? components2[index].component.title : '',
                    type: components2[index].component.titleType,
                    color: components2[index].component.titleColor
                  },
                  subtitle: {
                    text: components2[index].component.subtitle,
                    type: components2[index].component.subtitleType,
                    color: components2[index].component.subtitleColor
                  },
                  button: components2[index].component.button ? {
                    variant: components2[index].component.buttonStyle.variant,
                    size: components2[index].component.buttonStyle.size,
                    children: components2[index].component.button ? components2[index].component.button.title : '',
                    href: components2[index].component.button ? components2[index].component.button.url.path : ''
                  } : undefined,
                  icon: {
                    icon: {
                      icon: components2[index].component.iconSVG ? components2[index].component.iconSVG : null
                    },
                    iconSize: components2[index].component.iconSize,
                    iconColor: components2[index].component.iconColor
                  }
                });
              }
            })
          }), filterValue === 'freeform' && /*#__PURE__*/jsx("div", {
            children: components.map(function (component, index) {
              if (component.component.bundle === 'teaser') {
                var buttonPrimary = components[index].component.buttonPrimary;
                var buttonPrimaryStyle = components[index].component.buttonPrimaryStyle;
                var buttonSecondary = components[index].component.buttonSecondary;
                var buttonSecondaryStyle = components[index].component.buttonSecondaryStyle;
                return /*#__PURE__*/jsx(Teaser, {
                  background: parseBackground$1(components[index].component.behaviorSettings.rowStyle.background),
                  customSpacing: components[index].component.behaviorSettings.rowStyle.spacing,
                  content: components[index].component.teaserContent,
                  animation: 'none',
                  flip: components[index].component.flip,
                  flipMobile: components[index].component.flipMobile,
                  mediaBorRadius: components[index].component.mediaBorRadius,
                  title: {
                    text: components[index].component.title,
                    type: components[index].component.titleType,
                    color: components[index].component.titleColor
                  },
                  heading: {
                    text: components[index].component.heading,
                    type: components[index].component.headingType,
                    color: components[index].component.headingColor
                  },
                  paragraph: {
                    text: components[index].component.paragraph.processed,
                    color: components[index].component.paragraphColor,
                    type: components[index].component.paragraphType
                  },
                  media: parseMedia$1(components[index].component.media),
                  columns: components[index].component.variant === VARIANT_1COL ? 1 : 2,
                  buttons: getButtons$1({
                    buttonPrimary: buttonPrimary,
                    buttonPrimaryStyle: buttonPrimaryStyle,
                    buttonSecondary: buttonSecondary,
                    buttonSecondaryStyle: buttonSecondaryStyle
                  })
                });
              }

              if (component.component.bundle === 'banner') {
                return /*#__PURE__*/jsx(Banner, {
                  background: parseBackground$1(components[index].component.behaviorSettings.rowStyle.background),
                  customSpacing: components[index].component.behaviorSettings.rowStyle.spacing,
                  title: {
                    text: components[index].component.title ? components[index].component.title : '',
                    type: components[index].component.titleType,
                    color: components[index].component.titleColor
                  },
                  subtitle: {
                    text: components[index].component.subtitle,
                    type: components[index].component.subtitleType,
                    color: components[index].component.subtitleColor
                  },
                  button: components[index].component.button ? {
                    variant: components[index].component.buttonStyle.variant,
                    size: components[index].component.buttonStyle.size,
                    children: components[index].component.button ? components[index].component.button.title : '',
                    href: components[index].component.button ? components[index].component.button.url.path : ''
                  } : undefined,
                  icon: {
                    icon: {
                      icon: components[index].component.iconSVG ? components[index].component.iconSVG : null
                    },
                    iconSize: components[index].component.iconSize,
                    iconColor: components[index].component.iconColor
                  }
                });
              }
            })
          })]
        })]
      })
    })
  });
};
var parseMedia$1 = function parseMedia(media) {
  if (isNil_1(media) || !('entity' in media)) return undefined;
  var entity = media.entity;
  if (isNil_1(entity)) return undefined;

  if (entity.type === 'MediaIframe') {
    return {
      type: 'iframe',
      src: entity.html.value
    };
  }

  if (entity.type === 'MediaVideo') {
    var _entity$desktop, _entity$mobile, _entity$tablet, _entity$laptop;

    return {
      type: 'video',
      alt: 'Esto es un vídeo',
      src: {
        desktop: (_entity$desktop = entity.desktop) === null || _entity$desktop === void 0 ? void 0 : _entity$desktop.video.src,
        mobile: (_entity$mobile = entity.mobile) === null || _entity$mobile === void 0 ? void 0 : _entity$mobile.video.src,
        tablet: (_entity$tablet = entity.tablet) === null || _entity$tablet === void 0 ? void 0 : _entity$tablet.video.src,
        laptop: (_entity$laptop = entity.laptop) === null || _entity$laptop === void 0 ? void 0 : _entity$laptop.video.src
      }
    };
  }

  if ('mediaImage' in entity && entity.type === 'MediaImage') {
    var _entity$mediaImage, _entity$mediaImage2, _entity$mediaImageMob, _entity$mediaImageMob2, _entity$mediaImage3, _entity$mediaImageTab, _entity$mediaImageTab2, _entity$mediaImage4, _entity$mediaImageLap, _entity$mediaImageLap2, _entity$mediaImage5, _entity$mediaImage6, _entity$mediaImage7, _entity$mediaImage8;

    return {
      type: 'image',
      src: {
        desktop: (_entity$mediaImage = entity.mediaImage) !== null && _entity$mediaImage !== void 0 && _entity$mediaImage.src ? (_entity$mediaImage2 = entity.mediaImage) === null || _entity$mediaImage2 === void 0 ? void 0 : _entity$mediaImage2.src : null,
        mobile: (_entity$mediaImageMob = entity.mediaImageMobile) !== null && _entity$mediaImageMob !== void 0 && _entity$mediaImageMob.src ? (_entity$mediaImageMob2 = entity.mediaImageMobile) === null || _entity$mediaImageMob2 === void 0 ? void 0 : _entity$mediaImageMob2.src : (_entity$mediaImage3 = entity.mediaImage) === null || _entity$mediaImage3 === void 0 ? void 0 : _entity$mediaImage3.src,
        tablet: (_entity$mediaImageTab = entity.mediaImageTablet) !== null && _entity$mediaImageTab !== void 0 && _entity$mediaImageTab.src ? (_entity$mediaImageTab2 = entity.mediaImageTablet) === null || _entity$mediaImageTab2 === void 0 ? void 0 : _entity$mediaImageTab2.src : (_entity$mediaImage4 = entity.mediaImage) === null || _entity$mediaImage4 === void 0 ? void 0 : _entity$mediaImage4.src,
        laptop: (_entity$mediaImageLap = entity.mediaImageLaptop) !== null && _entity$mediaImageLap !== void 0 && _entity$mediaImageLap.src ? (_entity$mediaImageLap2 = entity.mediaImageLaptop) === null || _entity$mediaImageLap2 === void 0 ? void 0 : _entity$mediaImageLap2.src : (_entity$mediaImage5 = entity.mediaImage) === null || _entity$mediaImage5 === void 0 ? void 0 : _entity$mediaImage5.src
      },
      width: ((_entity$mediaImage6 = entity.mediaImage) === null || _entity$mediaImage6 === void 0 ? void 0 : _entity$mediaImage6.width) + 'px',
      height: ((_entity$mediaImage7 = entity.mediaImage) === null || _entity$mediaImage7 === void 0 ? void 0 : _entity$mediaImage7.height) + 'px',
      alt: (_entity$mediaImage8 = entity.mediaImage) === null || _entity$mediaImage8 === void 0 ? void 0 : _entity$mediaImage8.alt
    };
  }
};
var parseBackground$1 = function parseBackground(backgroundDTO) {
  if (isNil_1(backgroundDTO)) return undefined;
  var background = {
    color: backgroundDTO === null || backgroundDTO === void 0 ? void 0 : backgroundDTO.baseColor.color
  };

  if (!isNil_1(backgroundDTO.image)) {
    background.image = backgroundDTO === null || backgroundDTO === void 0 ? void 0 : backgroundDTO.image;
  }

  return background;
};
var getButtons$1 = function getButtons(_ref2) {
  var buttonPrimary = _ref2.buttonPrimary,
      buttonPrimaryStyle = _ref2.buttonPrimaryStyle,
      buttonSecondary = _ref2.buttonSecondary,
      buttonSecondaryStyle = _ref2.buttonSecondaryStyle;
  var buttons = [];

  if (!isNil_1(buttonPrimary)) {
    buttons.push({
      variant: buttonPrimaryStyle.variant,
      size: buttonPrimaryStyle.size,
      children: buttonPrimary.title,
      href: buttonPrimary.url.path
    });
  }

  if (!isNil_1(buttonSecondary)) {
    buttons.push({
      variant: buttonSecondaryStyle.variant,
      size: buttonSecondaryStyle.size,
      children: buttonSecondary.title,
      href: buttonSecondary.url.path
    });
  }

  return buttons;
};

var translationXAxis = {
  left: function left() {
    return "0%";
  },
  center: function center(height) {
    return "calc(50% - " + height / 2 + "px)";
  },
  right: function right(height) {
    return "calc(100% - " + height + "px)";
  }
};

var _StyledFlex$1 = styled(Flex).withConfig({
  displayName: "Sticker___StyledFlex",
  componentId: "sc-16weu8y-0"
})(["height:0;width:100%;transform:translateX(", ");"], function (p) {
  return p._css;
});

var _StyledMedia = styled(Media).withConfig({
  displayName: "Sticker___StyledMedia",
  componentId: "sc-16weu8y-1"
})(["height:", ";width:", ";transform:translateY(-50%);object-fit:contain;@media ", "{height:", ";width:", ";}@media ", "{height:", ";width:", ";}"], function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
}, function (p) {
  return p._css5;
}, function (p) {
  return p._css6;
}, function (p) {
  return p._css7;
}, function (p) {
  return p._css8;
}, function (p) {
  return p._css9;
});

var Sticker = function Sticker(_ref) {
  var media = _ref.media,
      position = _ref.position,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? 'fadeInUp' : _ref$animation;
  var ref = useRef({
    clientHeight: 0
  });

  var _useState = useState(0),
      height = _useState[0],
      setHeight = _useState[1];

  useEffect(function () {
    if (ref.current) {
      setHeight(ref.current.clientHeight);
    }
  }, [ref.current]);
  return /*#__PURE__*/jsx(Section, {
    flex: true,
    children: /*#__PURE__*/jsx(Animation, {
      type: animation,
      children: /*#__PURE__*/jsx(Container, {
        children: /*#__PURE__*/jsx(_StyledFlex$1, {
          _css: translationXAxis[position](height),
          children: /*#__PURE__*/jsx(_StyledMedia, _extends$2({}, media, {
            ref: ref,
            type: "image",
            _css2: rem(175),
            _css3: rem(175),
            _css4: theme.device.tablet,
            _css5: rem(200),
            _css6: rem(200),
            _css7: theme.device.laptop,
            _css8: rem(250),
            _css9: rem(250)
          }))
        })
      })
    })
  });
};

var StaticPageContent = styled(Container).withConfig({
  displayName: "StaticPage__StaticPageContent",
  componentId: "sc-4486gl-0"
})(["padding:", " ", ";@media ", "{padding:", " ", ";}p,h1,h2,h3,h4,h5,h6,div,span{font-weight:normal;color:", ";}h1{margin-top:", ";font-weight:900;font-size:", ";line-height:", ";letter-spacing:", ";@media ", "{font-size:", ";line-height:", ";letter-spacing:", ";}@media ", "{font-size:", ";line-height:", ";letter-spacing:", ";}}h2{margin-top:", ";font-weight:900;font-size:", ";line-height:", ";letter-spacing:", ";@media ", "{font-size:", ";line-height:", ";}@media ", "{font-size:", ";line-height:", ";letter-spacing:", ";}}h3{margin-top:", ";font-weight:700;font-size:", ";line-height:", ";letter-spacing:", ";@media ", "{font-size:", ";line-height:", ";}@media ", "{font-size:", ";line-height:", ";}}p{margin-top:", ";font-size:", ";font-weight:'400';line-height:", ";letter-spacing:", ";}"], rem('40px'), rem('24px'), theme.device.tablet, rem('80px'), rem('24px'), theme.colors.black, theme.spaces.xxl, rem('36px'), rem('42px'), rem('0px'), theme.device.tablet, rem('48px'), rem('56px'), rem('-0.1px'), theme.device.laptop, rem('64px'), rem('64px'), rem('-0.2px'), theme.spaces.xxl, rem('32px'), rem('40px'), rem('0px'), theme.device.tablet, rem('40px'), rem('48px'), theme.device.laptop, rem('48px'), rem('56px'), rem('-0.1px'), theme.spaces.xxl, rem('28px'), rem('34px'), rem('0px'), theme.device.tablet, rem('30px'), rem('40px'), theme.device.laptop, rem('32px'), rem('40px'), theme.spaces.l, rem('18px'), rem('24px'), rem('0.1px'));
var StaticPage = function StaticPage(_ref) {
  var backgroundColor = _ref.backgroundColor,
      children = _ref.children;
  return /*#__PURE__*/jsx(Section, {
    flex: true,
    background: {
      color: backgroundColor
    },
    children: /*#__PURE__*/jsx(StaticPageContent, {
      children: children
    })
  });
};

var manageCustomSpacing = function manageCustomSpacing(customSpacing, defaultSpacing) {
  if (customSpacing === 999) {
    return rem(defaultSpacing);
  }

  if (customSpacing) {
    return rem(customSpacing);
  }

  if (customSpacing === 0) {
    return 0;
  }

  return rem(defaultSpacing);
};
var backgroundImageByDevice = css(["", " ", " ", " ", " ", ""], function (_ref) {
  var _background$image;

  var background = _ref.background;
  return (background === null || background === void 0 ? void 0 : (_background$image = background.image) === null || _background$image === void 0 ? void 0 : _background$image.mobile) && "\n        background: url('" + background.image.mobile.src + "') center center no-repeat content-box;\n        background-size: cover;\n    ";
}, function (_ref2) {
  var _background$image2;

  var background = _ref2.background;
  return (background === null || background === void 0 ? void 0 : (_background$image2 = background.image) === null || _background$image2 === void 0 ? void 0 : _background$image2.tablet) && "\n      @media " + theme.device.tablet + " {\n        background: url('" + background.image.tablet.src + "') no-repeat center center content-box;\n        background-size: cover;\n      }  \n    ";
}, function (_ref3) {
  var _background$image3;

  var background = _ref3.background;
  return (background === null || background === void 0 ? void 0 : (_background$image3 = background.image) === null || _background$image3 === void 0 ? void 0 : _background$image3.laptop) && "\n      @media " + theme.device.laptop + " {\n        background: url('" + background.image.laptop.src + "') no-repeat center center content-box;\n        background-size: cover;\n      }\n    ";
}, function (_ref4) {
  var _background$image4;

  var background = _ref4.background;
  return (background === null || background === void 0 ? void 0 : (_background$image4 = background.image) === null || _background$image4 === void 0 ? void 0 : _background$image4.desktop) && "\n      @media " + theme.device.desktop + " {\n        background: url('" + background.image.desktop.src + "') no-repeat center center content-box;\n        background-size: cover;\n      }\n    ";
}, function (_ref5) {
  var background = _ref5.background;
  return (background === null || background === void 0 ? void 0 : background.color) && (background === null || background === void 0 ? void 0 : background.color) !== 'transparent' && "\n      background: " + (background.color === 'white' ? 'none' : theme.colors[background.color]) + ";\n  ";
});
var SectionComponentWrapper = styled.div.withConfig({
  displayName: "SectionComponentstyles__SectionComponentWrapper",
  componentId: "sc-1ebvn7v-0"
})(["display:flex;flex-direction:column;overflow-x:clip;-webkit-overflow-scrolling:touch;", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ";", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " padding-left:", ";padding-right:", ";padding-top:", ";padding-bottom:", ";@media ", "{padding-left:", ";padding-right:", ";padding-top:", ";padding-bottom:", ";}@media ", "{padding-left:", ";padding-right:", ";padding-top:", ";padding-bottom:", ";}@media ", "{", " padding-left:", ";padding-right:", ";padding-top:", ";padding-bottom:", ";}", " ", " ", ""], function (_ref6) {
  var allowHorizontalScrolling = _ref6.allowHorizontalScrolling;
  return allowHorizontalScrolling && "\n      overflow-x: auto;\n   ";
}, function (_ref7) {
  var _direction$directionM, _direction$directionM2, _direction$directionM3, _direction$directionM4, _direction$directionM5;

  var direction = _ref7.direction;
  return (direction === null || direction === void 0 ? void 0 : (_direction$directionM = direction.directionMobile) === null || _direction$directionM === void 0 ? void 0 : _direction$directionM.value) === 'horizontal' && (direction === null || direction === void 0 ? void 0 : (_direction$directionM2 = direction.directionMobile) === null || _direction$directionM2 === void 0 ? void 0 : _direction$directionM2.elementsPerRow) && (direction === null || direction === void 0 ? void 0 : (_direction$directionM3 = direction.directionMobile) === null || _direction$directionM3 === void 0 ? void 0 : _direction$directionM3.elementsPerRow) > 0 && "\n    flex-wrap: wrap;\n  > div {\n    " + ((direction === null || direction === void 0 ? void 0 : (_direction$directionM4 = direction.directionMobile) === null || _direction$directionM4 === void 0 ? void 0 : _direction$directionM4.elementsPerRow) && (direction === null || direction === void 0 ? void 0 : (_direction$directionM5 = direction.directionMobile) === null || _direction$directionM5 === void 0 ? void 0 : _direction$directionM5.elementsPerRow) > 0 && "flex: 1") + ";\n  }";
}, function (_ref8) {
  var _direction$directionT, _direction$directionT2, _direction$directionT3, _direction$directionT4, _direction$directionT5, _direction$directionT6;

  var direction = _ref8.direction;
  return (direction === null || direction === void 0 ? void 0 : (_direction$directionT = direction.directionTablet) === null || _direction$directionT === void 0 ? void 0 : _direction$directionT.value) === 'horizontal' && (direction === null || direction === void 0 ? void 0 : (_direction$directionT2 = direction.directionTablet) === null || _direction$directionT2 === void 0 ? void 0 : _direction$directionT2.elementsPerRow) && (direction === null || direction === void 0 ? void 0 : (_direction$directionT3 = direction.directionTablet) === null || _direction$directionT3 === void 0 ? void 0 : _direction$directionT3.elementsPerRow) > 0 && "\n    @media " + theme.device.tablet + " {\n      display: grid;\n      grid-template-columns: repeat( " + (direction === null || direction === void 0 ? void 0 : (_direction$directionT4 = direction.directionTablet) === null || _direction$directionT4 === void 0 ? void 0 : _direction$directionT4.elementsPerRow) + " ,1fr);\n    }\n  > div {\n    " + ((direction === null || direction === void 0 ? void 0 : (_direction$directionT5 = direction.directionTablet) === null || _direction$directionT5 === void 0 ? void 0 : _direction$directionT5.elementsPerRow) && (direction === null || direction === void 0 ? void 0 : (_direction$directionT6 = direction.directionTablet) === null || _direction$directionT6 === void 0 ? void 0 : _direction$directionT6.elementsPerRow) > 0 && "\n      @media " + theme.device.tablet + " {\n        flex: 1;\n      }\n      ") + ";\n  }";
}, function (_ref9) {
  var _direction$directionL;

  var direction = _ref9.direction;
  return (direction === null || direction === void 0 ? void 0 : (_direction$directionL = direction.directionLaptop) === null || _direction$directionL === void 0 ? void 0 : _direction$directionL.value) === 'horizontal' && (direction === null || direction === void 0 ? void 0 : direction.directionLaptop.elementsPerRow) && (direction === null || direction === void 0 ? void 0 : direction.directionLaptop.elementsPerRow) > 0 && "\n    @media " + theme.device.laptop + " {\n      display: grid;\n      grid-template-columns: repeat( " + (direction === null || direction === void 0 ? void 0 : direction.directionLaptop.elementsPerRow) + " ,1fr);\n    }\n  > div {\n    " + ((direction === null || direction === void 0 ? void 0 : direction.directionLaptop.elementsPerRow) > 0 && (direction === null || direction === void 0 ? void 0 : direction.directionLaptop.elementsPerRow) && "\n      @media " + theme.device.laptop + " {\n        flex: 1;\n      }\n      ") + ";\n  }";
}, function (_ref10) {
  var _direction$directionD, _direction$directionD2, _direction$directionD3, _direction$directionD4, _direction$directionD5;

  var direction = _ref10.direction;
  return (direction === null || direction === void 0 ? void 0 : (_direction$directionD = direction.directionDesktop) === null || _direction$directionD === void 0 ? void 0 : _direction$directionD.value) === 'horizontal' && (direction === null || direction === void 0 ? void 0 : (_direction$directionD2 = direction.directionDesktop) === null || _direction$directionD2 === void 0 ? void 0 : _direction$directionD2.elementsPerRow) && (direction === null || direction === void 0 ? void 0 : (_direction$directionD3 = direction.directionDesktop) === null || _direction$directionD3 === void 0 ? void 0 : _direction$directionD3.elementsPerRow) > 0 && "\n    @media " + theme.device.desktop + " {\n      display: grid;\n      grid-template-columns: repeat( " + (direction === null || direction === void 0 ? void 0 : direction.directionDesktop.elementsPerRow) + " ,1fr);\n    }\n  > div {\n    " + ((direction === null || direction === void 0 ? void 0 : (_direction$directionD4 = direction.directionDesktop) === null || _direction$directionD4 === void 0 ? void 0 : _direction$directionD4.elementsPerRow) && (direction === null || direction === void 0 ? void 0 : (_direction$directionD5 = direction.directionDesktop) === null || _direction$directionD5 === void 0 ? void 0 : _direction$directionD5.elementsPerRow) > 0 && "\n      @media " + theme.device.desktop + " {\n        flex: 1;\n      }\n      ") + ";\n  }";
}, function (_ref11) {
  var fullWidth = _ref11.fullWidth,
      containerized = _ref11.containerized;
  return fullWidth && !containerized && "\n      width: 100%;\n    ";
}, function (_ref12) {
  var _direction$directionM6, _direction$directionT7, _direction$directionL2, _direction$directionD6;

  var direction = _ref12.direction;
  return direction && "\n      flex-direction: " + (((_direction$directionM6 = direction.directionMobile) === null || _direction$directionM6 === void 0 ? void 0 : _direction$directionM6.value) === 'horizontal' ? 'row' : 'column') + ";\n\n      @media " + theme.device.tablet + " {\n        flex-direction: " + (((_direction$directionT7 = direction.directionTablet) === null || _direction$directionT7 === void 0 ? void 0 : _direction$directionT7.value) === 'horizontal' ? 'row' : 'column') + ";\n      }\n\n      @media " + theme.device.laptop + " {\n        flex-direction: " + (((_direction$directionL2 = direction.directionLaptop) === null || _direction$directionL2 === void 0 ? void 0 : _direction$directionL2.value) === 'horizontal' ? 'row' : 'column') + ";\n      }\n     \n      @media " + theme.device.desktop + " {\n        flex-direction: " + (((_direction$directionD6 = direction.directionDesktop) === null || _direction$directionD6 === void 0 ? void 0 : _direction$directionD6.value) === 'horizontal' ? 'row' : 'column') + ";\n      }\n    ";
}, function (_ref13) {
  var _alignment$mobile, _alignment$mobile2, _alignment$mobile3, _alignment$mobile4, _alignment$mobile5, _alignment$mobile6, _alignment$tablet, _alignment$tablet2, _alignment$tablet3, _alignment$tablet4, _alignment$tablet5, _alignment$tablet6, _alignment$laptop, _alignment$laptop2, _alignment$laptop3, _alignment$laptop4, _alignment$laptop5, _alignment$laptop6, _alignment$desktop, _alignment$desktop2, _alignment$desktop3, _alignment$desktop4, _alignment$desktop5, _alignment$desktop6;

  var alignment = _ref13.alignment;
  return "\n    align-items: " + ((alignment === null || alignment === void 0 ? void 0 : (_alignment$mobile = alignment.mobile) === null || _alignment$mobile === void 0 ? void 0 : _alignment$mobile.verticalAlign) === 'baseline' ? 'baseline' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$mobile2 = alignment.mobile) === null || _alignment$mobile2 === void 0 ? void 0 : _alignment$mobile2.verticalAlign) === 'center' ? 'center' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$mobile3 = alignment.mobile) === null || _alignment$mobile3 === void 0 ? void 0 : _alignment$mobile3.verticalAlign) === 'end' ? 'end' : 'start') + ";\n    justify-content:" + ((alignment === null || alignment === void 0 ? void 0 : (_alignment$mobile4 = alignment.mobile) === null || _alignment$mobile4 === void 0 ? void 0 : _alignment$mobile4.horizontalAlign) === 'right' ? 'end' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$mobile5 = alignment.mobile) === null || _alignment$mobile5 === void 0 ? void 0 : _alignment$mobile5.horizontalAlign) === 'left' ? 'start' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$mobile6 = alignment.mobile) === null || _alignment$mobile6 === void 0 ? void 0 : _alignment$mobile6.horizontalAlign) === 'center' ? 'center' : 'start') + ";\n    @media " + theme.device.tablet + " {\n      align-items: " + ((alignment === null || alignment === void 0 ? void 0 : (_alignment$tablet = alignment.tablet) === null || _alignment$tablet === void 0 ? void 0 : _alignment$tablet.verticalAlign) === 'baseline' ? 'baseline' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$tablet2 = alignment.tablet) === null || _alignment$tablet2 === void 0 ? void 0 : _alignment$tablet2.verticalAlign) === 'center' ? 'center' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$tablet3 = alignment.tablet) === null || _alignment$tablet3 === void 0 ? void 0 : _alignment$tablet3.verticalAlign) === 'end' ? 'end' : 'start') + ";\n      justify-content:" + ((alignment === null || alignment === void 0 ? void 0 : (_alignment$tablet4 = alignment.tablet) === null || _alignment$tablet4 === void 0 ? void 0 : _alignment$tablet4.horizontalAlign) === 'right' ? 'end' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$tablet5 = alignment.tablet) === null || _alignment$tablet5 === void 0 ? void 0 : _alignment$tablet5.horizontalAlign) === 'left' ? 'start' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$tablet6 = alignment.tablet) === null || _alignment$tablet6 === void 0 ? void 0 : _alignment$tablet6.horizontalAlign) === 'center' ? 'center' : 'start') + ";\n    }\n    @media " + theme.device.laptop + " {\n      align-items: " + ((alignment === null || alignment === void 0 ? void 0 : (_alignment$laptop = alignment.laptop) === null || _alignment$laptop === void 0 ? void 0 : _alignment$laptop.verticalAlign) === 'baseline' ? 'baseline' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$laptop2 = alignment.laptop) === null || _alignment$laptop2 === void 0 ? void 0 : _alignment$laptop2.verticalAlign) === 'center' ? 'center' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$laptop3 = alignment.laptop) === null || _alignment$laptop3 === void 0 ? void 0 : _alignment$laptop3.verticalAlign) === 'end' ? 'end' : 'start') + ";\n      justify-content:" + ((alignment === null || alignment === void 0 ? void 0 : (_alignment$laptop4 = alignment.laptop) === null || _alignment$laptop4 === void 0 ? void 0 : _alignment$laptop4.horizontalAlign) === 'right' ? 'end' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$laptop5 = alignment.laptop) === null || _alignment$laptop5 === void 0 ? void 0 : _alignment$laptop5.horizontalAlign) === 'left' ? 'start' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$laptop6 = alignment.laptop) === null || _alignment$laptop6 === void 0 ? void 0 : _alignment$laptop6.horizontalAlign) === 'center' ? 'center' : 'start') + ";\n    }\n    @media " + theme.device.desktop + " {\n      align-items: " + ((alignment === null || alignment === void 0 ? void 0 : (_alignment$desktop = alignment.desktop) === null || _alignment$desktop === void 0 ? void 0 : _alignment$desktop.verticalAlign) === 'baseline' ? 'baseline' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$desktop2 = alignment.desktop) === null || _alignment$desktop2 === void 0 ? void 0 : _alignment$desktop2.verticalAlign) === 'center' ? 'center' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$desktop3 = alignment.desktop) === null || _alignment$desktop3 === void 0 ? void 0 : _alignment$desktop3.verticalAlign) === 'end' ? 'end' : 'start') + ";\n      justify-content:" + ((alignment === null || alignment === void 0 ? void 0 : (_alignment$desktop4 = alignment.desktop) === null || _alignment$desktop4 === void 0 ? void 0 : _alignment$desktop4.horizontalAlign) === 'right' ? 'end' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$desktop5 = alignment.desktop) === null || _alignment$desktop5 === void 0 ? void 0 : _alignment$desktop5.horizontalAlign) === 'left' ? 'start' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$desktop6 = alignment.desktop) === null || _alignment$desktop6 === void 0 ? void 0 : _alignment$desktop6.horizontalAlign) === 'center' ? 'center' : 'start') + ";\n    }\n  ";
}, function (_ref14) {
  var _direction$directionM7, _alignment$mobile7, _alignment$mobile8, _alignment$mobile9, _alignment$mobile10, _alignment$mobile11, _alignment$mobile12, _alignment$mobile13, _alignment$mobile14;

  var alignment = _ref14.alignment,
      direction = _ref14.direction;
  return (direction === null || direction === void 0 ? void 0 : (_direction$directionM7 = direction.directionMobile) === null || _direction$directionM7 === void 0 ? void 0 : _direction$directionM7.value) === 'vertical' && (alignment === null || alignment === void 0 ? void 0 : (_alignment$mobile7 = alignment.mobile) === null || _alignment$mobile7 === void 0 ? void 0 : _alignment$mobile7.verticalAlign) && (alignment === null || alignment === void 0 ? void 0 : (_alignment$mobile8 = alignment.mobile) === null || _alignment$mobile8 === void 0 ? void 0 : _alignment$mobile8.horizontalAlign) && "\n        display: flex;\n        align-items: " + ((alignment === null || alignment === void 0 ? void 0 : (_alignment$mobile9 = alignment.mobile) === null || _alignment$mobile9 === void 0 ? void 0 : _alignment$mobile9.horizontalAlign) === 'left' ? 'baseline' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$mobile10 = alignment.mobile) === null || _alignment$mobile10 === void 0 ? void 0 : _alignment$mobile10.horizontalAlign) === 'center' ? 'center' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$mobile11 = alignment.mobile) === null || _alignment$mobile11 === void 0 ? void 0 : _alignment$mobile11.horizontalAlign) === 'right' ? 'end' : 'start') + ";\n        justify-content:" + ((alignment === null || alignment === void 0 ? void 0 : (_alignment$mobile12 = alignment.mobile) === null || _alignment$mobile12 === void 0 ? void 0 : _alignment$mobile12.verticalAlign) === 'end' ? 'end' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$mobile13 = alignment.mobile) === null || _alignment$mobile13 === void 0 ? void 0 : _alignment$mobile13.verticalAlign) === 'baseline' ? 'start' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$mobile14 = alignment.mobile) === null || _alignment$mobile14 === void 0 ? void 0 : _alignment$mobile14.verticalAlign) === 'center' ? 'center' : 'start') + ";\n  ";
}, function (_ref15) {
  var _direction$directionT8, _alignment$tablet7, _alignment$tablet8, _alignment$tablet9, _alignment$tablet10, _alignment$tablet11, _alignment$tablet12, _alignment$tablet13, _alignment$tablet14;

  var alignment = _ref15.alignment,
      direction = _ref15.direction;
  return (direction === null || direction === void 0 ? void 0 : (_direction$directionT8 = direction.directionTablet) === null || _direction$directionT8 === void 0 ? void 0 : _direction$directionT8.value) === 'vertical' && (alignment === null || alignment === void 0 ? void 0 : (_alignment$tablet7 = alignment.tablet) === null || _alignment$tablet7 === void 0 ? void 0 : _alignment$tablet7.verticalAlign) && (alignment === null || alignment === void 0 ? void 0 : (_alignment$tablet8 = alignment.tablet) === null || _alignment$tablet8 === void 0 ? void 0 : _alignment$tablet8.horizontalAlign) && "\n    @media " + theme.device.tablet + " {\n        display: flex;\n        align-items: " + ((alignment === null || alignment === void 0 ? void 0 : (_alignment$tablet9 = alignment.tablet) === null || _alignment$tablet9 === void 0 ? void 0 : _alignment$tablet9.horizontalAlign) === 'left' ? 'baseline' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$tablet10 = alignment.tablet) === null || _alignment$tablet10 === void 0 ? void 0 : _alignment$tablet10.horizontalAlign) === 'center' ? 'center' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$tablet11 = alignment.tablet) === null || _alignment$tablet11 === void 0 ? void 0 : _alignment$tablet11.horizontalAlign) === 'right' ? 'end' : 'start') + ";\n        justify-content:" + ((alignment === null || alignment === void 0 ? void 0 : (_alignment$tablet12 = alignment.tablet) === null || _alignment$tablet12 === void 0 ? void 0 : _alignment$tablet12.verticalAlign) === 'end' ? 'end' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$tablet13 = alignment.tablet) === null || _alignment$tablet13 === void 0 ? void 0 : _alignment$tablet13.verticalAlign) === 'baseline' ? 'start' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$tablet14 = alignment.tablet) === null || _alignment$tablet14 === void 0 ? void 0 : _alignment$tablet14.verticalAlign) === 'center' ? 'center' : 'start') + ";\n    }\n  ";
}, function (_ref16) {
  var _direction$directionL3, _alignment$laptop7, _alignment$laptop8, _alignment$laptop9, _alignment$laptop10, _alignment$laptop11, _alignment$laptop12, _alignment$laptop13, _alignment$laptop14;

  var alignment = _ref16.alignment,
      direction = _ref16.direction;
  return (direction === null || direction === void 0 ? void 0 : (_direction$directionL3 = direction.directionLaptop) === null || _direction$directionL3 === void 0 ? void 0 : _direction$directionL3.value) === 'vertical' && (alignment === null || alignment === void 0 ? void 0 : (_alignment$laptop7 = alignment.laptop) === null || _alignment$laptop7 === void 0 ? void 0 : _alignment$laptop7.verticalAlign) && (alignment === null || alignment === void 0 ? void 0 : (_alignment$laptop8 = alignment.laptop) === null || _alignment$laptop8 === void 0 ? void 0 : _alignment$laptop8.horizontalAlign) && "\n    @media " + theme.device.laptop + " {\n        display: flex;\n        align-items: " + ((alignment === null || alignment === void 0 ? void 0 : (_alignment$laptop9 = alignment.laptop) === null || _alignment$laptop9 === void 0 ? void 0 : _alignment$laptop9.horizontalAlign) === 'left' ? 'baseline' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$laptop10 = alignment.laptop) === null || _alignment$laptop10 === void 0 ? void 0 : _alignment$laptop10.horizontalAlign) === 'center' ? 'center' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$laptop11 = alignment.laptop) === null || _alignment$laptop11 === void 0 ? void 0 : _alignment$laptop11.horizontalAlign) === 'right' ? 'end' : 'start') + ";\n        justify-content:" + ((alignment === null || alignment === void 0 ? void 0 : (_alignment$laptop12 = alignment.laptop) === null || _alignment$laptop12 === void 0 ? void 0 : _alignment$laptop12.verticalAlign) === 'end' ? 'end' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$laptop13 = alignment.laptop) === null || _alignment$laptop13 === void 0 ? void 0 : _alignment$laptop13.verticalAlign) === 'baseline' ? 'start' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$laptop14 = alignment.laptop) === null || _alignment$laptop14 === void 0 ? void 0 : _alignment$laptop14.verticalAlign) === 'center' ? 'center' : 'start') + ";\n    }\n  ";
}, function (_ref17) {
  var _direction$directionD7, _alignment$desktop7, _alignment$desktop8, _alignment$desktop9, _alignment$desktop10, _alignment$desktop11, _alignment$desktop12, _alignment$desktop13, _alignment$desktop14;

  var alignment = _ref17.alignment,
      direction = _ref17.direction;
  return (direction === null || direction === void 0 ? void 0 : (_direction$directionD7 = direction.directionDesktop) === null || _direction$directionD7 === void 0 ? void 0 : _direction$directionD7.value) === 'vertical' && (alignment === null || alignment === void 0 ? void 0 : (_alignment$desktop7 = alignment.desktop) === null || _alignment$desktop7 === void 0 ? void 0 : _alignment$desktop7.verticalAlign) && (alignment === null || alignment === void 0 ? void 0 : (_alignment$desktop8 = alignment.desktop) === null || _alignment$desktop8 === void 0 ? void 0 : _alignment$desktop8.horizontalAlign) && "\n    @media " + theme.device.desktop + " {\n        display: flex;\n        align-items: " + ((alignment === null || alignment === void 0 ? void 0 : (_alignment$desktop9 = alignment.desktop) === null || _alignment$desktop9 === void 0 ? void 0 : _alignment$desktop9.horizontalAlign) === 'left' ? 'baseline' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$desktop10 = alignment.desktop) === null || _alignment$desktop10 === void 0 ? void 0 : _alignment$desktop10.horizontalAlign) === 'center' ? 'center' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$desktop11 = alignment.desktop) === null || _alignment$desktop11 === void 0 ? void 0 : _alignment$desktop11.horizontalAlign) === 'right' ? 'end' : 'start') + ";\n        justify-content:" + ((alignment === null || alignment === void 0 ? void 0 : (_alignment$desktop12 = alignment.desktop) === null || _alignment$desktop12 === void 0 ? void 0 : _alignment$desktop12.verticalAlign) === 'end' ? 'end' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$desktop13 = alignment.desktop) === null || _alignment$desktop13 === void 0 ? void 0 : _alignment$desktop13.verticalAlign) === 'baseline' ? 'start' : (alignment === null || alignment === void 0 ? void 0 : (_alignment$desktop14 = alignment.desktop) === null || _alignment$desktop14 === void 0 ? void 0 : _alignment$desktop14.verticalAlign) === 'center' ? 'center' : 'start') + ";\n    }\n  ";
}, function (_ref18) {
  var flexWrapProp = _ref18.flexWrapProp;
  return flexWrapProp && "\n    flex-wrap: " + (flexWrapProp !== null && flexWrapProp !== void 0 && flexWrapProp.mobile ? 'wrap' : 'unset') + ";\n\n    @media " + theme.device.tablet + " {\n      flex-wrap: " + (flexWrapProp !== null && flexWrapProp !== void 0 && flexWrapProp.tablet ? 'wrap' : 'unset') + ";\n    }\n\n    @media " + theme.device.laptop + " {\n      flex-wrap: " + (flexWrapProp !== null && flexWrapProp !== void 0 && flexWrapProp.laptop ? 'wrap' : 'unset') + ";\n    }\n\n    @media " + theme.device.desktop + " {\n      flex-wrap: " + (flexWrapProp !== null && flexWrapProp !== void 0 && flexWrapProp.desktop ? 'wrap' : 'unset') + ";\n    }\n  ";
}, function (_ref19) {
  var gap = _ref19.gap;
  return gap && " gap: " + gap + "px;\n    ";
}, function (_ref20) {
  var minHeight = _ref20.minHeight;
  return minHeight && " min-height: auto;\n      @media " + theme.device.laptop + " {\n        min-height: " + minHeight + "px;\n      }\n    ";
}, function (_ref21) {
  var hovers = _ref21.hovers;
  return hovers && hovers.enabled && "\n      &:hover {\n        cursor: pointer;\n        background: " + theme.colors[hovers.color.color] + ";\n      }\n    ";
}, function (_ref22) {
  var borderRad = _ref22.borderRad;
  return (borderRad === null || borderRad === void 0 ? void 0 : borderRad.leftBottom) && "\n     border-bottom-left-radius: " + borderRad.leftBottom + "px;\n    ";
}, function (_ref23) {
  var borderRad = _ref23.borderRad;
  return (borderRad === null || borderRad === void 0 ? void 0 : borderRad.rightBottom) && "\n     border-bottom-right-radius: " + borderRad.rightBottom + "px;\n    ";
}, function (_ref24) {
  var borderRad = _ref24.borderRad;
  return (borderRad === null || borderRad === void 0 ? void 0 : borderRad.leftTop) && "\n     border-top-left-radius: " + borderRad.leftTop + "px;\n    ";
}, function (_ref25) {
  var borderRad = _ref25.borderRad;
  return (borderRad === null || borderRad === void 0 ? void 0 : borderRad.rightTop) && "\n     border-top-right-radius: " + borderRad.rightTop + "px;\n    ";
}, backgroundImageByDevice, function (_ref26) {
  var borders = _ref26.borders;
  return borders && "\n      border-top: " + (borders.mobile.top.width ? borders.mobile.top.width : '0') + "px " + borders.mobile.top.style + " " + theme.colors[borders.mobile.top.color.color] + ";\n\n    ";
}, function (_ref27) {
  var borders = _ref27.borders;
  return borders && "\n    @media " + theme.device.tablet + " {\n      border-top: " + (borders.tablet.top.width ? borders.tablet.top.width : '0') + "px " + borders.tablet.top.style + " " + theme.colors[borders.tablet.top.color.color] + ";\n    }\n    ";
}, function (_ref28) {
  var borders = _ref28.borders;
  return borders && "\n    @media " + theme.device.laptop + " {\n      border-top: " + (borders.laptop.top.width ? borders.laptop.top.width : '0') + "px " + borders.laptop.top.style + " " + theme.colors[borders.laptop.top.color.color] + ";\n    }\n    ";
}, function (_ref29) {
  var borders = _ref29.borders;
  return borders && "\n    @media " + theme.device.desktop + " {\n      border-top: " + (borders.desktop.top.width ? borders.desktop.top.width : '0') + "px " + borders.desktop.top.style + " " + theme.colors[borders.desktop.top.color.color] + ";\n    }\n    ";
}, function (_ref30) {
  var borders = _ref30.borders;
  return borders && "\n      border-bottom: " + (borders.mobile.bottom.width ? borders.mobile.bottom.width : '0') + "px " + borders.mobile.bottom.style + " " + theme.colors[borders.mobile.bottom.color.color] + ";\n\n    ";
}, function (_ref31) {
  var borders = _ref31.borders;
  return borders && "\n    @media " + theme.device.tablet + " {\n      border-bottom: " + (borders.tablet.bottom.width ? borders.tablet.bottom.width : '0') + "px " + borders.tablet.bottom.style + " " + theme.colors[borders.tablet.bottom.color.color] + ";\n    }\n    ";
}, function (_ref32) {
  var borders = _ref32.borders;
  return borders && "\n    @media " + theme.device.laptop + " {\n      border-bottom: " + (borders.laptop.bottom.width ? borders.laptop.bottom.width : '0') + "px " + borders.laptop.bottom.style + " " + theme.colors[borders.laptop.bottom.color.color] + ";\n    }\n    ";
}, function (_ref33) {
  var borders = _ref33.borders;
  return borders && "\n    @media " + theme.device.desktop + " {\n      border-bottom: " + (borders.desktop.bottom.width ? borders.desktop.bottom.width : '0') + "px " + borders.desktop.bottom.style + " " + theme.colors[borders.desktop.bottom.color.color] + ";\n    }\n    ";
}, function (_ref34) {
  var borders = _ref34.borders;
  return borders && "\n      border-left: " + borders.mobile.left.width + "px " + borders.mobile.left.style + " " + theme.colors[borders.mobile.left.color.color] + ";\n\n    ";
}, function (_ref35) {
  var borders = _ref35.borders;
  return borders && "\n    @media " + theme.device.tablet + " {\n      border-left: " + borders.tablet.left.width + "px " + borders.tablet.left.style + " " + theme.colors[borders.tablet.left.color.color] + ";\n    }\n    ";
}, function (_ref36) {
  var borders = _ref36.borders;
  return borders && "\n    @media " + theme.device.laptop + " {\n      border-left: " + borders.laptop.left.width + "px " + borders.laptop.left.style + " " + theme.colors[borders.laptop.left.color.color] + ";\n    }\n    ";
}, function (_ref37) {
  var borders = _ref37.borders;
  return borders && "\n    @media " + theme.device.desktop + " {\n      border-left: " + borders.desktop.left.width + "px " + borders.desktop.left.style + " " + theme.colors[borders.desktop.left.color.color] + ";\n    }\n    ";
}, function (_ref38) {
  var borders = _ref38.borders;
  return borders && "\n      border-right: " + borders.mobile.right.width + "px " + borders.mobile.right.style + " " + theme.colors[borders.mobile.right.color.color] + ";\n\n    ";
}, function (_ref39) {
  var borders = _ref39.borders;
  return borders && "\n    @media " + theme.device.tablet + " {\n      border-right: " + borders.tablet.right.width + "px " + borders.tablet.right.style + " " + theme.colors[borders.tablet.right.color.color] + ";\n    }\n    ";
}, function (_ref40) {
  var borders = _ref40.borders;
  return borders && "\n    @media " + theme.device.laptop + " {\n      border-right: " + borders.laptop.right.width + "px " + borders.laptop.right.style + " " + theme.colors[borders.laptop.right.color.color] + ";\n    }\n    ";
}, function (_ref41) {
  var borders = _ref41.borders;
  return borders && "\n    @media " + theme.device.desktop + " {\n      border-right: " + borders.desktop.right.width + "px " + borders.desktop.right.style + " " + theme.colors[borders.desktop.right.color.color] + ";\n    }\n    ";
}, function (_ref42) {
  var _customSpacing$mobile;

  var customSpacing = _ref42.customSpacing;
  return manageCustomSpacing(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$mobile = customSpacing.mobile) === null || _customSpacing$mobile === void 0 ? void 0 : _customSpacing$mobile.left, theme.grid.horizontalMargin["default"]);
}, function (_ref43) {
  var _customSpacing$mobile2;

  var customSpacing = _ref43.customSpacing;
  return manageCustomSpacing(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$mobile2 = customSpacing.mobile) === null || _customSpacing$mobile2 === void 0 ? void 0 : _customSpacing$mobile2.right, theme.grid.horizontalMargin["default"]);
}, function (_ref44) {
  var _customSpacing$mobile3;

  var customSpacing = _ref44.customSpacing;
  return manageCustomSpacing(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$mobile3 = customSpacing.mobile) === null || _customSpacing$mobile3 === void 0 ? void 0 : _customSpacing$mobile3.top, theme.grid.verticalMargin["default"]);
}, function (_ref45) {
  var _customSpacing$mobile4;

  var customSpacing = _ref45.customSpacing;
  return manageCustomSpacing(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$mobile4 = customSpacing.mobile) === null || _customSpacing$mobile4 === void 0 ? void 0 : _customSpacing$mobile4.bottom, theme.grid.verticalMargin["default"]);
}, theme.device.tablet, function (_ref46) {
  var _customSpacing$tablet;

  var customSpacing = _ref46.customSpacing;
  return manageCustomSpacing(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$tablet = customSpacing.tablet) === null || _customSpacing$tablet === void 0 ? void 0 : _customSpacing$tablet.left, theme.grid.horizontalMargin.tablet);
}, function (_ref47) {
  var _customSpacing$tablet2;

  var customSpacing = _ref47.customSpacing;
  return manageCustomSpacing(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$tablet2 = customSpacing.tablet) === null || _customSpacing$tablet2 === void 0 ? void 0 : _customSpacing$tablet2.right, theme.grid.horizontalMargin.tablet);
}, function (_ref48) {
  var _customSpacing$tablet3;

  var customSpacing = _ref48.customSpacing;
  return manageCustomSpacing(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$tablet3 = customSpacing.tablet) === null || _customSpacing$tablet3 === void 0 ? void 0 : _customSpacing$tablet3.top, theme.grid.verticalMargin.tablet);
}, function (_ref49) {
  var _customSpacing$tablet4;

  var customSpacing = _ref49.customSpacing;
  return manageCustomSpacing(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$tablet4 = customSpacing.tablet) === null || _customSpacing$tablet4 === void 0 ? void 0 : _customSpacing$tablet4.bottom, theme.grid.verticalMargin.tablet);
}, theme.device.laptop, function (_ref50) {
  var _customSpacing$laptop;

  var customSpacing = _ref50.customSpacing;
  return manageCustomSpacing(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$laptop = customSpacing.laptop) === null || _customSpacing$laptop === void 0 ? void 0 : _customSpacing$laptop.left, theme.grid.horizontalMargin.desktop);
}, function (_ref51) {
  var _customSpacing$laptop2;

  var customSpacing = _ref51.customSpacing;
  return manageCustomSpacing(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$laptop2 = customSpacing.laptop) === null || _customSpacing$laptop2 === void 0 ? void 0 : _customSpacing$laptop2.right, theme.grid.horizontalMargin.desktop);
}, function (_ref52) {
  var _customSpacing$laptop3;

  var customSpacing = _ref52.customSpacing;
  return manageCustomSpacing(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$laptop3 = customSpacing.laptop) === null || _customSpacing$laptop3 === void 0 ? void 0 : _customSpacing$laptop3.top, theme.grid.verticalMargin.laptop);
}, function (_ref53) {
  var _customSpacing$laptop4;

  var customSpacing = _ref53.customSpacing;
  return manageCustomSpacing(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$laptop4 = customSpacing.laptop) === null || _customSpacing$laptop4 === void 0 ? void 0 : _customSpacing$laptop4.bottom, theme.grid.verticalMargin.laptop);
}, theme.device.desktop, function (_ref54) {
  var fullWidth = _ref54.fullWidth;
  return fullWidth ? "\n      max-width: 100%;\n      " : "\n        max-width: " + rem(theme.grid.contentMaxWidth) + ";\n        \n      ";
}, function (_ref55) {
  var _customSpacing$deskto;

  var customSpacing = _ref55.customSpacing;
  return manageCustomSpacing(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$deskto = customSpacing.desktop) === null || _customSpacing$deskto === void 0 ? void 0 : _customSpacing$deskto.left, theme.grid.horizontalMargin.desktop);
}, function (_ref56) {
  var _customSpacing$deskto2;

  var customSpacing = _ref56.customSpacing;
  return manageCustomSpacing(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$deskto2 = customSpacing.desktop) === null || _customSpacing$deskto2 === void 0 ? void 0 : _customSpacing$deskto2.right, theme.grid.horizontalMargin.desktop);
}, function (_ref57) {
  var _customSpacing$deskto3;

  var customSpacing = _ref57.customSpacing;
  return manageCustomSpacing(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$deskto3 = customSpacing.desktop) === null || _customSpacing$deskto3 === void 0 ? void 0 : _customSpacing$deskto3.top, theme.grid.verticalMargin.desktop);
}, function (_ref58) {
  var _customSpacing$deskto4;

  var customSpacing = _ref58.customSpacing;
  return manageCustomSpacing(customSpacing === null || customSpacing === void 0 ? void 0 : (_customSpacing$deskto4 = customSpacing.desktop) === null || _customSpacing$deskto4 === void 0 ? void 0 : _customSpacing$deskto4.bottom, theme.grid.verticalMargin.desktop);
}, function (_ref59) {
  var containerized = _ref59.containerized;
  return containerized && "\n      margin: 0 auto;\n      width: 100%;\n      @media " + theme.device.desktop + " {\n        max-width: " + rem(theme.grid.contentMaxWidth) + ";\n      }\n    ";
}, function (_ref60) {
  var alignContent = _ref60.alignContent;
  return alignContent && "\n    @media " + theme.device.laptop + " {\n      align-content: " + (alignContent ? alignContent : 'unset') + ";\n    }\n    ";
}, function (_ref61) {
  var animation = _ref61.animation;
  return animation && animation !== 'none' && css(["animation:", " 0.3s ", ";animation-fill-mode:both;"], theme.animations[animation], theme.transitions.easeInOut);
});

var SectionComponent = function SectionComponent(_ref) {
  var _general$direction13, _general$direction13$, _general$direction14, _general$direction14$, _general$direction15, _general$direction15$, _general$direction16, _general$direction16$, _general$direction17, _general$direction17$, _general$direction18, _general$direction18$, _general$direction19, _general$direction19$, _general$direction20, _general$direction20$, _general$alignment9, _general$alignment9$d, _general$alignment10, _general$alignment10$, _general$alignment11, _general$alignment11$, _general$alignment12, _general$alignment12$, _general$alignment13, _general$alignment13$, _general$alignment14, _general$alignment14$, _general$alignment15, _general$alignment15$, _general$alignment16, _general$alignment16$, _general$addFlexWrap5, _general$addFlexWrap6, _general$addFlexWrap7, _general$addFlexWrap8;

  var children = _ref.children,
      background = _ref.background,
      customSpacing = _ref.customSpacing,
      general = _ref.general,
      borders = _ref.borders,
      link = _ref.link,
      hovers = _ref.hovers,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? 'fadeInUp' : _ref$animation;

  if (general !== null && general !== void 0 && general.containerized) {
    var _general$direction, _general$direction$di, _general$direction2, _general$direction2$d, _general$direction3, _general$direction3$d, _general$direction4, _general$direction4$d, _general$direction5, _general$direction5$d, _general$direction6, _general$direction6$d, _general$direction7, _general$direction7$d, _general$direction8, _general$direction8$d, _general$direction9, _general$direction9$d, _general$direction10, _general$direction10$, _general$direction11, _general$direction11$, _general$direction12, _general$direction12$, _general$alignment, _general$alignment$de, _general$alignment2, _general$alignment2$d, _general$alignment3, _general$alignment3$l, _general$alignment4, _general$alignment4$l, _general$alignment5, _general$alignment5$t, _general$alignment6, _general$alignment6$t, _general$alignment7, _general$alignment7$m, _general$alignment8, _general$alignment8$m, _general$addFlexWrap, _general$addFlexWrap2, _general$addFlexWrap3, _general$addFlexWrap4;

    return /*#__PURE__*/jsx(WithLink, {
      path: link === null || link === void 0 ? void 0 : link.url.path,
      containerized: general === null || general === void 0 ? void 0 : general.containerized,
      fullWidth: general !== null && general !== void 0 && general.fullWidth ? true : false,
      children: /*#__PURE__*/jsx(Section, {
        background: background,
        children: /*#__PURE__*/jsx(SectionComponentWrapper, {
          customSpacing: customSpacing,
          allowHorizontalScrolling: general !== null && general !== void 0 && general.allowHorizontalScrolling ? true : false,
          direction: {
            directionDesktop: {
              value: general !== null && general !== void 0 && (_general$direction = general.direction) !== null && _general$direction !== void 0 && (_general$direction$di = _general$direction.directionDesktop) !== null && _general$direction$di !== void 0 && _general$direction$di.value ? general === null || general === void 0 ? void 0 : (_general$direction2 = general.direction) === null || _general$direction2 === void 0 ? void 0 : (_general$direction2$d = _general$direction2.directionDesktop) === null || _general$direction2$d === void 0 ? void 0 : _general$direction2$d.value : 'vertical',
              elementsPerRow: general === null || general === void 0 ? void 0 : (_general$direction3 = general.direction) === null || _general$direction3 === void 0 ? void 0 : (_general$direction3$d = _general$direction3.directionDesktop) === null || _general$direction3$d === void 0 ? void 0 : _general$direction3$d.elementsPerRow
            },
            directionLaptop: {
              value: general !== null && general !== void 0 && (_general$direction4 = general.direction) !== null && _general$direction4 !== void 0 && (_general$direction4$d = _general$direction4.directionLaptop) !== null && _general$direction4$d !== void 0 && _general$direction4$d.value ? general === null || general === void 0 ? void 0 : (_general$direction5 = general.direction) === null || _general$direction5 === void 0 ? void 0 : (_general$direction5$d = _general$direction5.directionLaptop) === null || _general$direction5$d === void 0 ? void 0 : _general$direction5$d.value : 'vertical',
              elementsPerRow: general === null || general === void 0 ? void 0 : (_general$direction6 = general.direction) === null || _general$direction6 === void 0 ? void 0 : (_general$direction6$d = _general$direction6.directionLaptop) === null || _general$direction6$d === void 0 ? void 0 : _general$direction6$d.elementsPerRow
            },
            directionTablet: {
              value: general !== null && general !== void 0 && (_general$direction7 = general.direction) !== null && _general$direction7 !== void 0 && (_general$direction7$d = _general$direction7.directionTablet) !== null && _general$direction7$d !== void 0 && _general$direction7$d.value ? general === null || general === void 0 ? void 0 : (_general$direction8 = general.direction) === null || _general$direction8 === void 0 ? void 0 : (_general$direction8$d = _general$direction8.directionTablet) === null || _general$direction8$d === void 0 ? void 0 : _general$direction8$d.value : 'vertical',
              elementsPerRow: general === null || general === void 0 ? void 0 : (_general$direction9 = general.direction) === null || _general$direction9 === void 0 ? void 0 : (_general$direction9$d = _general$direction9.directionTablet) === null || _general$direction9$d === void 0 ? void 0 : _general$direction9$d.elementsPerRow
            },
            directionMobile: {
              value: general !== null && general !== void 0 && (_general$direction10 = general.direction) !== null && _general$direction10 !== void 0 && (_general$direction10$ = _general$direction10.directionMobile) !== null && _general$direction10$ !== void 0 && _general$direction10$.value ? general === null || general === void 0 ? void 0 : (_general$direction11 = general.direction) === null || _general$direction11 === void 0 ? void 0 : (_general$direction11$ = _general$direction11.directionMobile) === null || _general$direction11$ === void 0 ? void 0 : _general$direction11$.value : 'vertical',
              elementsPerRow: general === null || general === void 0 ? void 0 : (_general$direction12 = general.direction) === null || _general$direction12 === void 0 ? void 0 : (_general$direction12$ = _general$direction12.directionMobile) === null || _general$direction12$ === void 0 ? void 0 : _general$direction12$.elementsPerRow
            }
          },
          alignment: {
            desktop: {
              verticalAlign: general === null || general === void 0 ? void 0 : (_general$alignment = general.alignment) === null || _general$alignment === void 0 ? void 0 : (_general$alignment$de = _general$alignment.desktop) === null || _general$alignment$de === void 0 ? void 0 : _general$alignment$de.verticalAlign,
              horizontalAlign: general === null || general === void 0 ? void 0 : (_general$alignment2 = general.alignment) === null || _general$alignment2 === void 0 ? void 0 : (_general$alignment2$d = _general$alignment2.desktop) === null || _general$alignment2$d === void 0 ? void 0 : _general$alignment2$d.horizontalAlign
            },
            laptop: {
              verticalAlign: general === null || general === void 0 ? void 0 : (_general$alignment3 = general.alignment) === null || _general$alignment3 === void 0 ? void 0 : (_general$alignment3$l = _general$alignment3.laptop) === null || _general$alignment3$l === void 0 ? void 0 : _general$alignment3$l.verticalAlign,
              horizontalAlign: general === null || general === void 0 ? void 0 : (_general$alignment4 = general.alignment) === null || _general$alignment4 === void 0 ? void 0 : (_general$alignment4$l = _general$alignment4.laptop) === null || _general$alignment4$l === void 0 ? void 0 : _general$alignment4$l.horizontalAlign
            },
            tablet: {
              verticalAlign: general === null || general === void 0 ? void 0 : (_general$alignment5 = general.alignment) === null || _general$alignment5 === void 0 ? void 0 : (_general$alignment5$t = _general$alignment5.tablet) === null || _general$alignment5$t === void 0 ? void 0 : _general$alignment5$t.verticalAlign,
              horizontalAlign: general === null || general === void 0 ? void 0 : (_general$alignment6 = general.alignment) === null || _general$alignment6 === void 0 ? void 0 : (_general$alignment6$t = _general$alignment6.tablet) === null || _general$alignment6$t === void 0 ? void 0 : _general$alignment6$t.horizontalAlign
            },
            mobile: {
              verticalAlign: general === null || general === void 0 ? void 0 : (_general$alignment7 = general.alignment) === null || _general$alignment7 === void 0 ? void 0 : (_general$alignment7$m = _general$alignment7.mobile) === null || _general$alignment7$m === void 0 ? void 0 : _general$alignment7$m.verticalAlign,
              horizontalAlign: general === null || general === void 0 ? void 0 : (_general$alignment8 = general.alignment) === null || _general$alignment8 === void 0 ? void 0 : (_general$alignment8$m = _general$alignment8.mobile) === null || _general$alignment8$m === void 0 ? void 0 : _general$alignment8$m.horizontalAlign
            }
          },
          flexWrapProp: {
            desktop: general === null || general === void 0 ? void 0 : (_general$addFlexWrap = general.addFlexWrap) === null || _general$addFlexWrap === void 0 ? void 0 : _general$addFlexWrap.desktop,
            laptop: general === null || general === void 0 ? void 0 : (_general$addFlexWrap2 = general.addFlexWrap) === null || _general$addFlexWrap2 === void 0 ? void 0 : _general$addFlexWrap2.laptop,
            tablet: general === null || general === void 0 ? void 0 : (_general$addFlexWrap3 = general.addFlexWrap) === null || _general$addFlexWrap3 === void 0 ? void 0 : _general$addFlexWrap3.tablet,
            mobile: general === null || general === void 0 ? void 0 : (_general$addFlexWrap4 = general.addFlexWrap) === null || _general$addFlexWrap4 === void 0 ? void 0 : _general$addFlexWrap4.mobile
          },
          containerized: general === null || general === void 0 ? void 0 : general.containerized,
          fullWidth: (general === null || general === void 0 ? void 0 : general.fullWidth) === '1' ? true : false,
          alignContent: general === null || general === void 0 ? void 0 : general.alignContent,
          minHeight: general === null || general === void 0 ? void 0 : general.minHeight,
          borders: borders,
          gap: general === null || general === void 0 ? void 0 : general.gap,
          borderRad: {
            leftTop: borders === null || borders === void 0 ? void 0 : borders.borderRadiusTopLeft,
            rightTop: borders === null || borders === void 0 ? void 0 : borders.borderRadiusTopRight,
            leftBottom: borders === null || borders === void 0 ? void 0 : borders.borderRadiusBottomLeft,
            rightBottom: borders === null || borders === void 0 ? void 0 : borders.borderRadiusBottomRight
          },
          hovers: hovers,
          animation: animation,
          children: children
        })
      })
    });
  }

  return /*#__PURE__*/jsx(WithLink, {
    path: link === null || link === void 0 ? void 0 : link.url.path,
    containerized: general === null || general === void 0 ? void 0 : general.containerized,
    fullWidth: general !== null && general !== void 0 && general.fullWidth ? true : false,
    children: /*#__PURE__*/jsx(SectionComponentWrapper, {
      customSpacing: customSpacing,
      background: background,
      allowHorizontalScrolling: general !== null && general !== void 0 && general.allowHorizontalScrolling ? true : false,
      direction: {
        directionDesktop: {
          value: general === null || general === void 0 ? void 0 : (_general$direction13 = general.direction) === null || _general$direction13 === void 0 ? void 0 : (_general$direction13$ = _general$direction13.directionDesktop) === null || _general$direction13$ === void 0 ? void 0 : _general$direction13$.value,
          elementsPerRow: general === null || general === void 0 ? void 0 : (_general$direction14 = general.direction) === null || _general$direction14 === void 0 ? void 0 : (_general$direction14$ = _general$direction14.directionDesktop) === null || _general$direction14$ === void 0 ? void 0 : _general$direction14$.elementsPerRow
        },
        directionLaptop: {
          value: general === null || general === void 0 ? void 0 : (_general$direction15 = general.direction) === null || _general$direction15 === void 0 ? void 0 : (_general$direction15$ = _general$direction15.directionLaptop) === null || _general$direction15$ === void 0 ? void 0 : _general$direction15$.value,
          elementsPerRow: general === null || general === void 0 ? void 0 : (_general$direction16 = general.direction) === null || _general$direction16 === void 0 ? void 0 : (_general$direction16$ = _general$direction16.directionLaptop) === null || _general$direction16$ === void 0 ? void 0 : _general$direction16$.elementsPerRow
        },
        directionTablet: {
          value: general === null || general === void 0 ? void 0 : (_general$direction17 = general.direction) === null || _general$direction17 === void 0 ? void 0 : (_general$direction17$ = _general$direction17.directionTablet) === null || _general$direction17$ === void 0 ? void 0 : _general$direction17$.value,
          elementsPerRow: general === null || general === void 0 ? void 0 : (_general$direction18 = general.direction) === null || _general$direction18 === void 0 ? void 0 : (_general$direction18$ = _general$direction18.directionTablet) === null || _general$direction18$ === void 0 ? void 0 : _general$direction18$.elementsPerRow
        },
        directionMobile: {
          value: general === null || general === void 0 ? void 0 : (_general$direction19 = general.direction) === null || _general$direction19 === void 0 ? void 0 : (_general$direction19$ = _general$direction19.directionMobile) === null || _general$direction19$ === void 0 ? void 0 : _general$direction19$.value,
          elementsPerRow: general === null || general === void 0 ? void 0 : (_general$direction20 = general.direction) === null || _general$direction20 === void 0 ? void 0 : (_general$direction20$ = _general$direction20.directionMobile) === null || _general$direction20$ === void 0 ? void 0 : _general$direction20$.elementsPerRow
        }
      },
      alignment: {
        desktop: {
          verticalAlign: general === null || general === void 0 ? void 0 : (_general$alignment9 = general.alignment) === null || _general$alignment9 === void 0 ? void 0 : (_general$alignment9$d = _general$alignment9.desktop) === null || _general$alignment9$d === void 0 ? void 0 : _general$alignment9$d.verticalAlign,
          horizontalAlign: general === null || general === void 0 ? void 0 : (_general$alignment10 = general.alignment) === null || _general$alignment10 === void 0 ? void 0 : (_general$alignment10$ = _general$alignment10.desktop) === null || _general$alignment10$ === void 0 ? void 0 : _general$alignment10$.horizontalAlign
        },
        laptop: {
          verticalAlign: general === null || general === void 0 ? void 0 : (_general$alignment11 = general.alignment) === null || _general$alignment11 === void 0 ? void 0 : (_general$alignment11$ = _general$alignment11.laptop) === null || _general$alignment11$ === void 0 ? void 0 : _general$alignment11$.verticalAlign,
          horizontalAlign: general === null || general === void 0 ? void 0 : (_general$alignment12 = general.alignment) === null || _general$alignment12 === void 0 ? void 0 : (_general$alignment12$ = _general$alignment12.laptop) === null || _general$alignment12$ === void 0 ? void 0 : _general$alignment12$.horizontalAlign
        },
        tablet: {
          verticalAlign: general === null || general === void 0 ? void 0 : (_general$alignment13 = general.alignment) === null || _general$alignment13 === void 0 ? void 0 : (_general$alignment13$ = _general$alignment13.tablet) === null || _general$alignment13$ === void 0 ? void 0 : _general$alignment13$.verticalAlign,
          horizontalAlign: general === null || general === void 0 ? void 0 : (_general$alignment14 = general.alignment) === null || _general$alignment14 === void 0 ? void 0 : (_general$alignment14$ = _general$alignment14.tablet) === null || _general$alignment14$ === void 0 ? void 0 : _general$alignment14$.horizontalAlign
        },
        mobile: {
          verticalAlign: general === null || general === void 0 ? void 0 : (_general$alignment15 = general.alignment) === null || _general$alignment15 === void 0 ? void 0 : (_general$alignment15$ = _general$alignment15.mobile) === null || _general$alignment15$ === void 0 ? void 0 : _general$alignment15$.verticalAlign,
          horizontalAlign: general === null || general === void 0 ? void 0 : (_general$alignment16 = general.alignment) === null || _general$alignment16 === void 0 ? void 0 : (_general$alignment16$ = _general$alignment16.mobile) === null || _general$alignment16$ === void 0 ? void 0 : _general$alignment16$.horizontalAlign
        }
      },
      flexWrapProp: {
        desktop: general === null || general === void 0 ? void 0 : (_general$addFlexWrap5 = general.addFlexWrap) === null || _general$addFlexWrap5 === void 0 ? void 0 : _general$addFlexWrap5.desktop,
        laptop: general === null || general === void 0 ? void 0 : (_general$addFlexWrap6 = general.addFlexWrap) === null || _general$addFlexWrap6 === void 0 ? void 0 : _general$addFlexWrap6.laptop,
        tablet: general === null || general === void 0 ? void 0 : (_general$addFlexWrap7 = general.addFlexWrap) === null || _general$addFlexWrap7 === void 0 ? void 0 : _general$addFlexWrap7.tablet,
        mobile: general === null || general === void 0 ? void 0 : (_general$addFlexWrap8 = general.addFlexWrap) === null || _general$addFlexWrap8 === void 0 ? void 0 : _general$addFlexWrap8.mobile
      },
      containerized: general === null || general === void 0 ? void 0 : general.containerized,
      fullWidth: (general === null || general === void 0 ? void 0 : general.fullWidth) === '1' ? true : false,
      alignContent: general === null || general === void 0 ? void 0 : general.alignContent,
      minHeight: general === null || general === void 0 ? void 0 : general.minHeight,
      borders: borders,
      gap: general === null || general === void 0 ? void 0 : general.gap,
      borderRad: {
        leftTop: borders === null || borders === void 0 ? void 0 : borders.borderRadiusTopLeft,
        rightTop: borders === null || borders === void 0 ? void 0 : borders.borderRadiusTopRight,
        leftBottom: borders === null || borders === void 0 ? void 0 : borders.borderRadiusBottomLeft,
        rightBottom: borders === null || borders === void 0 ? void 0 : borders.borderRadiusBottomRight
      },
      hovers: hovers,
      animation: animation,
      children: children
    })
  });
};

var _StyledA = styled("a").withConfig({
  displayName: "SectionComponent___StyledA",
  componentId: "sc-10up3ko-0"
})(["max-width:", " display:", ";width:", ";text-decoration:none;&:hover{cursor:pointer;}"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var WithLink = function WithLink(_ref2) {
  var path = _ref2.path,
      children = _ref2.children,
      fullWidth = _ref2.fullWidth,
      containerized = _ref2.containerized;
  return path ? /*#__PURE__*/jsx(_StyledA, {
    href: path,
    _css: containerized ? '1500px' : 'unset',
    _css2: fullWidth ? 'block' : 'inline',
    _css3: fullWidth ? '100%' : 'auto',
    children: children
  }) : children;
};

var FormSinglePage = function FormSinglePage(_ref) {
  var backgroundColor = _ref.backgroundColor,
      children = _ref.children,
      withTopbar = _ref.withTopbar;
  return /*#__PURE__*/jsx(Animation, {
    type: "fadeInUp",
    children: /*#__PURE__*/jsx(SinglePageContainer, {
      backgroundColor: backgroundColor || 'white',
      children: /*#__PURE__*/jsx(FormSinglePageContainer, {
        withTopbar: withTopbar,
        children: children
      })
    })
  });
};
var FormSinglePageContainer = styled.div.withConfig({
  displayName: "FormSinglePage__FormSinglePageContainer",
  componentId: "sc-4k5k1r-0"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;margin:0 auto;@media ", "{max-width:calc((100% / 8) * 4);}@media ", "{max-width:calc((100% / 12) * 4);}"], theme.device.tablet, theme.device.laptop);

var TwoColumnsContainer = styled.div.withConfig({
  displayName: "TwoColumnsContainerstyles__TwoColumnsContainer",
  componentId: "u2kbrc-0"
})(["display:flex;flex-direction:column-reverse;align-items:center;justify-content:center;gap:", ";@media ", "{flex-direction:row;}"], rem(theme.sizes.medium), theme.device.laptop);
var TwoColumnsColumn = styled.div.withConfig({
  displayName: "TwoColumnsContainerstyles__TwoColumnsColumn",
  componentId: "u2kbrc-1"
})(["flex:0 0 50%;width:100%;"]);
var ContentContainer$1 = styled.div.withConfig({
  displayName: "TwoColumnsContainerstyles__ContentContainer",
  componentId: "u2kbrc-2"
})(["display:flex;flex-direction:column;align-items:center;text-align:center;@media ", "{align-items:flex-start;padding:0 ", ";text-align:left;}"], theme.device.laptop, rem(theme.sizes.xlarge));

var Categories = function Categories(_ref) {
  var links = _ref.links;
  return /*#__PURE__*/jsx(CategoryWrapper, {
    children: links && links.map(function (category, index) {
      var image = category.landing.icon ? category.landing.icon.entity.mediaImage : null;
      return /*#__PURE__*/jsx(CategoryCTAWrapper, {
        children: /*#__PURE__*/jsx(Link, {
          href: category.landing.url.path,
          "data-cy": category.landing.displayTitle3,
          children: /*#__PURE__*/jsxs(CategoryCTA, {
            children: [image && /*#__PURE__*/jsx(Image, {
              src: image.src,
              alt: image.alt,
              width: '36',
              height: '36',
              style: {
                marginRight: '4px'
              }
            }), /*#__PURE__*/jsx(Text, {
              variant: 'mediumButton',
              $color: 'rBlack',
              children: category.landing.displayTitle3
            })]
          })
        }, index)
      }, index);
    })
  });
};

var DescriptionContainer$1 = styled.div.withConfig({
  displayName: "Templatestyles__DescriptionContainer",
  componentId: "b9pnuu-0"
})(["@media ", "{max-width:", ";margin:auto;}"], theme.device.laptop, rem(768));
var ContentContainer = styled.div.withConfig({
  displayName: "Templatestyles__ContentContainer",
  componentId: "b9pnuu-1"
})(["padding:0;@media ", "{padding:0 ", ";}"], theme.device.laptop, rem(24));
var InfoList = styled.ul.withConfig({
  displayName: "Templatestyles__InfoList",
  componentId: "b9pnuu-2"
})(["display:flex;flex-direction:column;flex-wrap:wrap;"]);
var InfoListItem = styled.li.withConfig({
  displayName: "Templatestyles__InfoListItem",
  componentId: "b9pnuu-3"
})(["display:flex;gap:", ";align-items:center;margin-bottom:", ";flex:100%;"], rem(10), rem(6));
var TitleRegion = styled.div.withConfig({
  displayName: "Templatestyles__TitleRegion",
  componentId: "b9pnuu-4"
})(["flex:1;flex-direction:column;padding-top:40px;display:flex;align-items:center;justify-content:center;@media ", "{padding-top:0;width:calc((100% / 12) * 4);animation-fill-mode:both;aspect-ratio:16 / 9;}"], theme.device.laptop);
var LinkWrapper = styled.div.withConfig({
  displayName: "Templatestyles__LinkWrapper",
  componentId: "b9pnuu-5"
})(["width:100%;@media ", "{width:auto;}> a{width:100%;@media ", "{width:auto;}}"], theme.device.tablet, theme.device.tablet);
var IframeRegion = styled.div.withConfig({
  displayName: "Templatestyles__IframeRegion",
  componentId: "b9pnuu-6"
})(["align-items:flex-start;flex-direction:column;padding:0 20px;@media ", "{width:calc((100% / 12) * 8);height:600px;}position:relative;", ""], theme.device.laptop, function (_ref) {
  var preset = _ref.preset;
  return preset === 'vertical' && "    \n    display: flex;\n    align-items: center;\n    @media " + theme.device.laptop + " {\n    height: unset;\n  }\n  ";
});
styled.div.withConfig({
  displayName: "Templatestyles__CategoryTag",
  componentId: "b9pnuu-7"
})(["border:1px solid ", ";border-radius:4px;padding:", " ", ";color:", ";&:hover{background:", ";border:1px solid transparent;color:", ";}&:active{transform:scale(0.95);background:", ";}"], theme.colors.smoke, rem(3), rem(11), theme.colors.coal, theme.colors.snow, theme.colors.black, theme.colors.snow);
var VerticalIframeWrapper = styled(Flex).withConfig({
  displayName: "Templatestyles__VerticalIframeWrapper",
  componentId: "b9pnuu-8"
})(["position:relative;width:100%;height:60vh;@media ", "{width:", "px;height:60vh;display:flex;justify-self:center;}@media ", "{width:", "px;height:", "px;}@media ", "{width:", "px;height:", "px;}"], theme.device.tablet, IframeSizes.width.vertical.laptop, theme.device.laptop, IframeSizes.width.vertical.laptop, IframeSizes.height.vertical.laptop, theme.device.desktop, IframeSizes.width.vertical.desktop, IframeSizes.height.vertical.desktop);
var LiveSessionsBadgeContainer = styled(Flex).withConfig({
  displayName: "Templatestyles__LiveSessionsBadgeContainer",
  componentId: "b9pnuu-9"
})(["display:flex;position:relative;width:fit-content;left:", ";top:", ";z-index:1;border-radius:", ";background:", ";gap:", ";padding:", ";", ""], rem(8), rem(40), rem(4), theme.colors.rBlack50, rem(8), rem(8), function (_ref2) {
  var preset = _ref2.preset;
  return preset === 'vertical' && "\n      position: absolute;\n      top: " + rem(8) + ";\n      left: " + rem(8) + ";\n  ";
});
var TemplateIframe = styled.iframe.withConfig({
  displayName: "Templatestyles__TemplateIframe",
  componentId: "b9pnuu-10"
})(["", " ", " border-radius:", ";filter:drop-shadow(rgba(0,15,51,0.2) 0px 1px 4px);"], function (_ref3) {
  var preset = _ref3.preset;
  return preset === 'horizontal' && "\n      width: 100%;\n      height: 50vh;\n      @media " + theme.device.laptop + " {\n        height: 100%;\n      }\n\n    ";
}, function (_ref4) {
  var preset = _ref4.preset;
  return preset === 'square' && "\n        width: 100%;\n        height: 50vh;\n        @media " + theme.device.tablet + " {\n          height: 80vh;}\n        @media " + theme.device.laptop + " {\n            width:100%;\n            height:100%;\n        }\n        @media " + theme.device.desktop + " {\n            width:100%;\n            height:100%;\n        }\n    ";
}, rem(8));

var img$1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABmSURBVHgB3ZHhCYBQCISveAM0wlulDdqkURqpFRqhDWoDO+H1zwvsX31wKJ4iKCAws5lakMUayu/xkg8NFr8e46Qa6K9BeetoHEwG5Nh9sDKpgXlvGqONUPzoj+XBO5ty+LUp+aYLj6IxPFIJYfUAAAAASUVORK5CYII=";

var img = "data:image/png;base64,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";

var templateAlt = function templateAlt(title, lang) {
  var alt = title;
  lang = lang === null || lang === undefined ? 'en' : lang;
  var formattedLang = lang !== '/' ? lang.replace(/\//g, '') : lang;

  switch (formattedLang) {
    case '/' :
      {
        alt = 'Interactive ' + title + ' template';
        break;
      }

    case 'es':
      {
        alt = 'Plantilla interactiva ' + title;
        break;
      }

    case 'fr':
      {
        alt = 'Modèle interactif ' + title;
        break;
      }

    case 'it':
      {
        alt = 'Template interattivo ' + title;
        break;
      }

    case 'pt-br':
      {
        alt = 'Modelo interativo ' + title;
        break;
      }

    case 'de':
      {
        alt = 'Interaktive Vorlage „' + title + '“';
        break;
      }

    default:
      {
        alt = 'Interactive ' + title + ' template';
        break;
      }
  }

  return alt;
};

var carouselSpacing$1 = {
  mobile: {
    top: 0,
    bottom: 32
  },
  tablet: {
    top: 0,
    bottom: 32
  },
  desktop: {
    top: 0,
    bottom: 32
  },
  laptop: {
    top: 0,
    bottom: 32
  }
};
var RelatedTemplates = function RelatedTemplates(_ref) {
  var content = _ref.content;
      _ref.lang;
  var renderedTemplatesFirstRow = content ? content : null;
  var renderedTemplatesSecondRow = content ? content.slice(content.length / 2, content.length) : null;
  return /*#__PURE__*/jsx(Fragment$1, {
    children: content && /*#__PURE__*/jsx(Cards, {
      variant: "carousel",
      title: undefined,
      autoplay: 0,
      hideControls: false,
      customSpacing: carouselSpacing$1,
      firstSlider: parseCardsCarouselItems$1(renderedTemplatesFirstRow),
      secondSlider: parseCardsCarouselItems$1(renderedTemplatesSecondRow),
      templateCard: true
    })
  });
};
var parseCardsCarouselItems$1 = function parseCardsCarouselItems(items, lang) {
  if (!items || items.length == 0) return undefined;
  return items.map(function (item) {
    return {
      media: {
        src: {
          desktop: item.thumbnail !== undefined ? item.thumbnail : img
        },
        alt: templateAlt(item.title, lang),
        type: 'image',
        width: '600px',
        height: '337px'
      },
      price: item.price,
      title: {
        text: item.title
      },
      url: item.url ? item.url.path : undefined
    };
  });
};

var _StyledFlex = styled(Flex).withConfig({
  displayName: "TemplatePage___StyledFlex",
  componentId: "cvp352-0"
})(["gap:10px;width:100%;display:flex;animation-fill-mode:both;"]);

var _StyledText = styled(Text).withConfig({
  displayName: "TemplatePage___StyledText",
  componentId: "cvp352-1"
})(["word-break:break-word;"]);

var _StyledFlex2 = styled(Flex).withConfig({
  displayName: "TemplatePage___StyledFlex2",
  componentId: "cvp352-2"
})(["gap:13px;"]);

var _StyledText2 = styled(Text).withConfig({
  displayName: "TemplatePage___StyledText2",
  componentId: "cvp352-3"
})(["font-weight:500;"]);

var _StyledFlex3 = styled(Flex).withConfig({
  displayName: "TemplatePage___StyledFlex3",
  componentId: "cvp352-4"
})(["gap:10px;flex-flow:row wrap;"]);

var TemplatePage = function TemplatePage(_ref) {
  var breadcrumbItems = _ref.breadcrumbItems,
      title = _ref.title,
      description = _ref.description,
      idView = _ref.idView,
      relatedTemplates = _ref.relatedTemplates,
      relatedTemplatesTitle = _ref.relatedTemplatesTitle,
      categories = _ref.categories,
      categoriesTitle = _ref.categoriesTitle,
      idGenially = _ref.idGenially,
      useTemplate = _ref.useTemplate,
      banner = _ref.banner,
      relatedTemplatesCTA = _ref.relatedTemplatesCTA,
      lang = _ref.lang,
      info = _ref.info,
      changed = _ref.changed,
      price = _ref.price,
      liveSession = _ref.liveSession,
      liveSessionText = _ref.liveSessionText,
      aspectRatio = _ref.aspectRatio;
  var headerSpacing = {
    mobile: {
      top: 0,
      bottom: 20
    },
    tablet: {
      top: 0,
      bottom: 20
    },
    laptop: {
      top: 0,
      bottom: 20
    },
    desktop: {
      top: 0,
      bottom: 20
    }
  };
  var backSpacing = {
    desktop: {
      top: 36,
      bottom: 36
    },
    laptop: {
      top: 36,
      bottom: 36
    },
    tablet: {
      top: 36,
      bottom: 36
    },
    mobile: {
      top: 36,
      bottom: 28
    }
  };
  var ctaSpacing = {
    desktop: {
      top: 0,
      bottom: 36
    },
    laptop: {
      top: 0,
      bottom: 36
    },
    tablet: {
      top: 0,
      bottom: 36
    },
    mobile: {
      top: 0,
      bottom: 28
    }
  };
  var relatedSpacing = {
    desktop: {
      top: 0,
      bottom: 36
    },
    laptop: {
      top: 0,
      bottom: 36
    },
    tablet: {
      top: 0,
      bottom: 36
    },
    mobile: {
      top: 0,
      bottom: 40
    }
  };
  banner = banner ? banner.entity : null; // app CTA

  var finalUrl = idGenially ? 'https://auth.genially.com' + lang + 'signup?backTo=https%3A%2F%2Fapp.genially.com%2Fusetemplate%2F' + idGenially + '%2F' + '%3Ffrom%3Dtemplatecenter-web' : null; // Iframe

  var viewUrl = idView ? 'https://view.genially.com/' + idView + '?social=false&cache=true' : '';
  idGenially = idGenially + '?from=templatecenter-web';
  var preset = 'horizontal';

  switch (aspectRatio) {
    case '9:16':
      {
        preset = 'vertical';
        break;
      }

    case '1:1':
      {
        preset = 'square';
        break;
      }

    case '1:2':
      {
        preset = 'square';
        break;
      }
  }

  return /*#__PURE__*/jsxs("main", {
    changed: changed,
    "data-cy": title,
    children: [/*#__PURE__*/jsx(Section, {
      children: /*#__PURE__*/jsx(ComponentContainer, {
        customSpacing: backSpacing,
        children: /*#__PURE__*/jsx(Breadcrumb, {
          items: breadcrumbItems
        })
      })
    }), /*#__PURE__*/jsx(Section, {
      children: /*#__PURE__*/jsx(ComponentContainer, {
        customSpacing: ctaSpacing,
        children: /*#__PURE__*/jsxs(_StyledFlex, {
          flexDirection: {
            mobile: 'column',
            laptop: 'row'
          },
          children: [/*#__PURE__*/jsx(IframeRegion, {
            preset: preset,
            children: preset === 'vertical' ? /*#__PURE__*/jsxs(VerticalIframeWrapper, {
              children: [liveSession && /*#__PURE__*/jsxs(LiveSessionsBadgeContainer, {
                alignItems: 'center',
                preset: preset,
                children: [/*#__PURE__*/jsx(Icon, {
                  name: "LiveSessions",
                  color: theme.colors.rWhite
                }), /*#__PURE__*/jsx(Text, {
                  $color: 'rWhite',
                  variant: 'paragraphXS',
                  children: /*#__PURE__*/jsx(HtmlParser, {
                    children: liveSessionText
                  })
                })]
              }), viewUrl && /*#__PURE__*/jsx(TemplateIframe, {
                sandbox: "allow-scripts allow-popups allow-same-origin",
                allowFullScreen: true,
                loading: "lazy",
                frameBorder: "0",
                scrolling: "yes",
                src: viewUrl,
                "data-cy": 'iframeButton',
                preset: preset
              })]
            }) : /*#__PURE__*/jsxs(Fragment$1, {
              children: [liveSession && /*#__PURE__*/jsxs(LiveSessionsBadgeContainer, {
                alignItems: 'center',
                preset: preset,
                children: [/*#__PURE__*/jsx(Icon, {
                  name: "LiveSessions",
                  color: theme.colors.rWhite
                }), /*#__PURE__*/jsx(Text, {
                  $color: 'rWhite',
                  variant: 'paragraphXS',
                  children: /*#__PURE__*/jsx(HtmlParser, {
                    children: liveSessionText
                  })
                })]
              }), viewUrl && /*#__PURE__*/jsx(TemplateIframe, {
                sandbox: "allow-scripts allow-popups allow-same-origin",
                allowFullScreen: true,
                loading: "lazy",
                frameBorder: "0",
                src: viewUrl,
                "data-cy": 'iframeButton',
                preset: preset,
                style: {
                  border: 0,
                  overflow: 'auto'
                }
              })]
            })
          }), /*#__PURE__*/jsx(TitleRegion, {
            children: /*#__PURE__*/jsxs(ContentContainer, {
              children: [price === 'premium' && /*#__PURE__*/jsxs(PremiumWrapper, {
                children: [/*#__PURE__*/jsx(Icon, {
                  name: "Premium",
                  color: theme.colors.rPremium
                }), /*#__PURE__*/jsx(Text, {
                  variant: 'paragraphXSBold',
                  $color: 'rPremium',
                  uppercase: true,
                  style: {
                    margin: 0
                  },
                  children: "premium"
                })]
              }), /*#__PURE__*/jsx(_StyledText, {
                variant: 'title1XL',
                $color: 'rBlack',
                children: title
              }), /*#__PURE__*/jsx(Flex, {
                marginTop: 'small',
                children: description && /*#__PURE__*/jsx(DescriptionContainer$1, {
                  children: /*#__PURE__*/jsx(Text, {
                    variant: 'paragraphS',
                    $color: 'rBlack',
                    children: /*#__PURE__*/jsx(HtmlParser, {
                      children: description
                    })
                  })
                })
              }), finalUrl && /*#__PURE__*/jsx(Flex, {
                marginTop: 'medium',
                marginBottom: 'medium',
                children: /*#__PURE__*/jsx(LinkWrapper, {
                  children: /*#__PURE__*/jsx(ButtonLink, {
                    variant: "primary",
                    href: finalUrl,
                    size: "big",
                    target: "_blank",
                    rel: "noreferrer",
                    "data-cy": useTemplate,
                    children: /*#__PURE__*/jsxs(_StyledFlex2, {
                      justifyContent: "center",
                      alignItems: "center",
                      children: [/*#__PURE__*/jsx(Media, {
                        alt: 'Use this template',
                        src: img$1,
                        width: 14,
                        height: 14,
                        type: "image"
                      }), /*#__PURE__*/jsx(_StyledText2, {
                        variant: 'paragraphMBold',
                        $color: 'white',
                        children: useTemplate
                      })]
                    })
                  })
                })
              }), /*#__PURE__*/jsx(Flex, {
                marginTop: 'large',
                flexDirection: 'column',
                children: /*#__PURE__*/jsxs(InfoList, {
                  children: [/*#__PURE__*/jsxs(InfoListItem, {
                    children: [/*#__PURE__*/jsx(Icon, {
                      name: "Interactivity24",
                      color: theme.colors.rOnyx
                    }), /*#__PURE__*/jsx(Text, {
                      variant: 'paragraphS',
                      $color: 'rBlack',
                      children: info[0].text
                    })]
                  }), /*#__PURE__*/jsxs(InfoListItem, {
                    children: [/*#__PURE__*/jsx(Icon, {
                      name: "ColorPalette",
                      color: theme.colors.rOnyx
                    }), /*#__PURE__*/jsx(Text, {
                      variant: 'paragraphS',
                      $color: 'rBlack',
                      children: info[1].text
                    })]
                  }), /*#__PURE__*/jsxs(InfoListItem, {
                    children: [/*#__PURE__*/jsx(Icon, {
                      name: "Video",
                      color: theme.colors.rOnyx
                    }), /*#__PURE__*/jsx(Text, {
                      variant: 'paragraphS',
                      $color: 'rBlack',
                      children: info[2].text
                    })]
                  }), /*#__PURE__*/jsxs(InfoListItem, {
                    children: [/*#__PURE__*/jsx(Icon, {
                      name: "Share",
                      color: theme.colors.rOnyx
                    }), /*#__PURE__*/jsx(Text, {
                      variant: 'paragraphS',
                      $color: 'rBlack',
                      children: info[3].text
                    })]
                  }), /*#__PURE__*/jsxs(InfoListItem, {
                    children: [/*#__PURE__*/jsx(Icon, {
                      name: "Download",
                      color: theme.colors.rOnyx
                    }), /*#__PURE__*/jsx(Text, {
                      variant: 'paragraphS',
                      $color: 'rBlack',
                      children: info[4].text
                    })]
                  })]
                })
              }), categories && /*#__PURE__*/jsxs(Flex, {
                marginTop: 'large',
                flexDirection: 'column',
                children: [/*#__PURE__*/jsx(Text, {
                  variant: 'paragraphMBold',
                  $color: 'rBlack',
                  uppercase: true,
                  marginBottom: 'mini',
                  children: categoriesTitle
                }), categories.length > 0 && /*#__PURE__*/jsx(_StyledFlex3, {
                  children: categories === null || categories === void 0 ? void 0 : categories.map(function (category, index) {
                    if (category !== null) {
                      return /*#__PURE__*/jsx(Link, {
                        href: category.path,
                        "data-cy": category.title,
                        children: /*#__PURE__*/jsx(Button, {
                          variant: "stroke",
                          size: "small",
                          children: /*#__PURE__*/jsx(Text, {
                            variant: "paragraphS",
                            children: category.title
                          })
                        }, index)
                      }, index);
                    } else {
                      return /*#__PURE__*/jsx(Fragment$1, {});
                    }
                  })
                })]
              })]
            })
          })]
        })
      })
    }), relatedTemplates && /*#__PURE__*/jsxs(Fragment$1, {
      children: [/*#__PURE__*/jsx(Section, {
        style: {
          marginTop: rem(40)
        },
        children: /*#__PURE__*/jsx(ComponentContainer, {
          customSpacing: headerSpacing,
          children: /*#__PURE__*/jsx(Text, {
            variant: 'paragraphLBold',
            $color: 'rBlack',
            children: relatedTemplatesTitle
          })
        })
      }), /*#__PURE__*/jsx(RelatedTemplates, {
        content: relatedTemplates,
        lang: lang
      }), /*#__PURE__*/jsx(ComponentContainer, {
        customSpacing: relatedSpacing,
        children: categories && categories[0] && /*#__PURE__*/jsx("div", {
          style: {
            textAlign: 'center',
            marginBottom: '40px'
          },
          children: /*#__PURE__*/jsx(Link, {
            href: categories[0].path,
            "data-cy": relatedTemplatesCTA,
            children: /*#__PURE__*/jsx("div", {
              children: /*#__PURE__*/jsx(Button, {
                variant: "stroke",
                size: "big",
                type: "submit",
                children: relatedTemplatesCTA
              })
            })
          })
        })
      })]
    }), banner && banner.type === 'ParagraphBanner' ? /*#__PURE__*/jsx(Banner, {
      animation: 'none',
      background: parseBackground(banner.behaviorSettings.rowStyle.background),
      customSpacing: banner.behaviorSettings.rowStyle.spacing,
      title: banner.title ? {
        text: banner.title,
        type: banner.titleType,
        color: banner.titleColor
      } : undefined,
      subtitle: banner.subtitle ? {
        text: banner.subtitle,
        type: banner.subtitleType,
        color: banner.subtitleColor
      } : undefined,
      button: banner.button ? {
        variant: banner.buttonStyle.variant,
        size: banner.buttonStyle.size,
        children: banner.button.title,
        href: banner.button.url.path
      } : undefined
    }) : null]
  });
};
var PremiumWrapper = styled.div.withConfig({
  displayName: "TemplatePage__PremiumWrapper",
  componentId: "cvp352-5"
})(["display:flex;max-width:fit-content;gap:", ";padding:", " ", ";border-radius:", ";align-items:center;background:", ";margin-bottom:", ";"], rem(4), rem(4), rem(5), rem(6), theme.colors.rBlack80, rem(16));
var parseBackground = function parseBackground(backgroundDTO) {
  if (isNil_1(backgroundDTO)) return undefined;
  var background = {
    color: backgroundDTO === null || backgroundDTO === void 0 ? void 0 : backgroundDTO.baseColor.color
  };

  if (!isNil_1(backgroundDTO.image)) {
    background.image = backgroundDTO === null || backgroundDTO === void 0 ? void 0 : backgroundDTO.image;
  }

  return background;
};
var parseMedia = function parseMedia(media) {
  if (isNil_1(media) || !('entity' in media)) return undefined;
  var entity = media.entity;
  if (isNil_1(entity)) return undefined;

  if (entity.type === 'MediaIframe') {
    return {
      type: 'iframe',
      src: entity.html.value
    };
  }

  if (entity.type === 'MediaVideo') {
    var _entity$desktop, _entity$mobile, _entity$tablet, _entity$laptop;

    return {
      type: 'video',
      alt: 'Esto es un vídeo',
      src: {
        desktop: (_entity$desktop = entity.desktop) === null || _entity$desktop === void 0 ? void 0 : _entity$desktop.video.src,
        mobile: (_entity$mobile = entity.mobile) === null || _entity$mobile === void 0 ? void 0 : _entity$mobile.video.src,
        tablet: (_entity$tablet = entity.tablet) === null || _entity$tablet === void 0 ? void 0 : _entity$tablet.video.src,
        laptop: (_entity$laptop = entity.laptop) === null || _entity$laptop === void 0 ? void 0 : _entity$laptop.video.src
      }
    };
  }

  if ('mediaImage' in entity && entity.type === 'MediaImage') {
    var _entity$mediaImage, _entity$mediaImage2, _entity$mediaImageMob, _entity$mediaImageMob2, _entity$mediaImage3, _entity$mediaImageTab, _entity$mediaImageTab2, _entity$mediaImage4, _entity$mediaImageLap, _entity$mediaImageLap2, _entity$mediaImage5, _entity$mediaImage6, _entity$mediaImage7, _entity$mediaImage8;

    return {
      type: 'image',
      src: {
        desktop: (_entity$mediaImage = entity.mediaImage) !== null && _entity$mediaImage !== void 0 && _entity$mediaImage.src ? (_entity$mediaImage2 = entity.mediaImage) === null || _entity$mediaImage2 === void 0 ? void 0 : _entity$mediaImage2.src : null,
        mobile: (_entity$mediaImageMob = entity.mediaImageMobile) !== null && _entity$mediaImageMob !== void 0 && _entity$mediaImageMob.src ? (_entity$mediaImageMob2 = entity.mediaImageMobile) === null || _entity$mediaImageMob2 === void 0 ? void 0 : _entity$mediaImageMob2.src : (_entity$mediaImage3 = entity.mediaImage) === null || _entity$mediaImage3 === void 0 ? void 0 : _entity$mediaImage3.src,
        tablet: (_entity$mediaImageTab = entity.mediaImageTablet) !== null && _entity$mediaImageTab !== void 0 && _entity$mediaImageTab.src ? (_entity$mediaImageTab2 = entity.mediaImageTablet) === null || _entity$mediaImageTab2 === void 0 ? void 0 : _entity$mediaImageTab2.src : (_entity$mediaImage4 = entity.mediaImage) === null || _entity$mediaImage4 === void 0 ? void 0 : _entity$mediaImage4.src,
        laptop: (_entity$mediaImageLap = entity.mediaImageLaptop) !== null && _entity$mediaImageLap !== void 0 && _entity$mediaImageLap.src ? (_entity$mediaImageLap2 = entity.mediaImageLaptop) === null || _entity$mediaImageLap2 === void 0 ? void 0 : _entity$mediaImageLap2.src : (_entity$mediaImage5 = entity.mediaImage) === null || _entity$mediaImage5 === void 0 ? void 0 : _entity$mediaImage5.src
      },
      width: ((_entity$mediaImage6 = entity.mediaImage) === null || _entity$mediaImage6 === void 0 ? void 0 : _entity$mediaImage6.width) + 'px',
      height: ((_entity$mediaImage7 = entity.mediaImage) === null || _entity$mediaImage7 === void 0 ? void 0 : _entity$mediaImage7.height) + 'px',
      alt: (_entity$mediaImage8 = entity.mediaImage) === null || _entity$mediaImage8 === void 0 ? void 0 : _entity$mediaImage8.alt
    };
  }
};

var carouselSpacing = {
  mobile: {
    top: 0,
    bottom: 48
  },
  tablet: {
    top: 0,
    bottom: 48
  },
  desktop: {
    top: 0,
    bottom: 48
  },
  laptop: {
    top: 0,
    bottom: 48
  }
};
var CategoryTemplates = function CategoryTemplates(_ref) {
  var content = _ref.content,
      lang = _ref.lang,
      masonry = _ref.masonry;
  return /*#__PURE__*/jsx(Fragment$1, {
    children: content && /*#__PURE__*/jsx(Cards, {
      variant: "grid",
      title: undefined,
      customSpacing: carouselSpacing,
      elementsPerRow: 4,
      masonry: masonry,
      cards: parseCardsCarouselItems(content, lang),
      templateCard: true
    })
  });
};
var parseCardsCarouselItems = function parseCardsCarouselItems(items, lang) {
  if (!Array.isArray(items) || items === undefined || !items || items.length === 0) return undefined;
  var newTemplates = [];
  items.forEach(function (item) {
    if (item.contents) {
      var contents = item.contents.filter(function (itm) {
        return itm.lang === 'PT' ? 'pt-br' : itm.lang.toLowerCase() === lang && itm.hide === false;
      });
      newTemplates.push({
        title: {
          text: contents[0] ? contents[0].title : ''
        },
        media: {
          src: {
            desktop: contents[0] ? contents[0].thumbnail : ''
          },
          alt: contents[0] ? contents[0].title : '',
          type: 'image',
          width: '600px',
          height: '337px'
        },
        price: item.price ? 'premium' : 'free',
        url: contents[0] ? contents[0].lang === 'PT' ? '/pt-br' + contents[0].urlPath + '/' : contents[0].lang === 'EN' ? contents[0].urlPath + '/' : '/' + contents[0].lang.toLowerCase() + contents[0].urlPath + '/' : ''
      });
    }
  });
  return newTemplates;
};

var DescriptionContainer = styled.div.withConfig({
  displayName: "Categorystyles__DescriptionContainer",
  componentId: "sc-1flpfu7-0"
})(["max-width:", ";margin:auto;text-align:center;"], rem(768));

var ctaSpacing = {
  desktop: {
    top: 0,
    bottom: 36
  },
  laptop: {
    top: 0,
    bottom: 36
  },
  tablet: {
    top: 0,
    bottom: 36
  },
  mobile: {
    top: 0,
    bottom: 28
  }
};
var Subcategories = function Subcategories(_ref) {
  var subcategories = _ref.subcategories,
      pageId = _ref.pageId,
      parentId = _ref.parentId,
      extraCategories = _ref.extraCategories;
  var links = [];
  parentId === null ? links = subcategories && subcategories.filter(function (category) {
    return category.parent[0].targetId === pageId || category.tid === pageId;
  }) : null;
  parentId !== null ? links = subcategories && subcategories.filter(function (category) {
    return category.parent[0].targetId === parentId || category.tid === parentId;
  }) : null;

  if (links !== null) {
    links.unshift(links.splice(links.findIndex(function (link) {
      return link.parent[0].targetId === 0;
    }), 1)[0]);
  }

  links = links.concat(extraCategories);
  if (links.length < 2) return null;
  return /*#__PURE__*/jsx(Section, {
    flex: true,
    children: /*#__PURE__*/jsx(ComponentContainer, {
      customSpacing: ctaSpacing,
      children: /*#__PURE__*/jsx(CategoryWrapper, {
        children: links && links.map(function (category, index) {
          if (category.mainRelatedContents === undefined || category.mainRelatedContents === null) return null;
          var path = category.mainRelatedContents ? category.mainRelatedContents.entities[0].url.path : null;
          var title = '';

          if (category.extra) {
            title = category.mainRelatedContents ? category.mainRelatedContents.entities[0].fieldDisplayTitle3 : category.name;
          } else {
            title = category.mainRelatedContents ? category.mainRelatedContents.entities[0].fieldDisplayTitle2 : category.name;
          }

          return /*#__PURE__*/jsx(Fragment$1, {
            children: /*#__PURE__*/jsx(Link, {
              href: category.extra ? path : path + '/',
              "data-cy": title,
              children: /*#__PURE__*/jsx(SubCategoryCTA, {
                active: pageId === category.tid,
                parent: category.parent && category.parent[0].targetId === 0 ? true : false,
                children: /*#__PURE__*/jsx(Text, {
                  variant: 'mediumButton',
                  $color: 'rBlack',
                  children: title
                })
              }, index)
            }, index)
          });
        })
      })
    })
  });
};

var CategoryPage = function CategoryPage(_ref) {
  var _faqs$entity$headingC, _faqs$entity$titleCol, _faqs$entity$paragrap;

  var breadcrumbItems = _ref.breadcrumbItems,
      subcategories = _ref.subcategories,
      templates = _ref.templates,
      header = _ref.header,
      teaser = _ref.teaser,
      tid = _ref.tid,
      parentId = _ref.parentId,
      description = _ref.description,
      banner = _ref.banner,
      faqs = _ref.faqs,
      lang = _ref.lang,
      extraCategories = _ref.extraCategories;
  var ctaSpacing = {
    desktop: {
      top: 36,
      bottom: 36
    },
    laptop: {
      top: 36,
      bottom: 36
    },
    tablet: {
      top: 36,
      bottom: 36
    },
    mobile: {
      top: 28,
      bottom: 28
    }
  };
  teaser = teaser ? teaser.entity : null;
  header = header ? header.entity : null;
  banner = banner ? banner.entity : null;
  var btnPrimary = teaser && teaser.buttonPrimary ? teaser.buttonPrimary : null;
  var btnPrimaryStyle = teaser && teaser.buttonPrimaryStyle ? teaser.buttonPrimaryStyle : null;
  var btnSecondary = teaser && teaser.buttonSecondary ? teaser.buttonSecondary : null;
  var btnSecondaryStyle = teaser && teaser.buttonSecondaryStyle ? teaser.buttonSecondaryStyle : null;
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [header && header.type === 'ParagraphTeaser' ? /*#__PURE__*/jsx(Teaser, {
      animation: 'none',
      columns: header.variant === '1col' ? 1 : 2,
      flip: header.flip && header.flip,
      background: parseBackground(header.behaviorSettings.rowStyle.background),
      customSpacing: header.behaviorSettings.rowStyle.spacing,
      media: parseMedia(header.media),
      templatesHeader: true,
      heading: header.heading ? {
        text: header.heading,
        type: header.headingType,
        color: header.headingColor
      } : undefined,
      title: header.title ? {
        text: header.title,
        type: header.titleType,
        color: header.titleColor
      } : undefined,
      subtitle: header.subtitle ? {
        text: header.subtitle,
        type: header.subtitleType,
        color: header.subtitleColor
      } : undefined,
      paragraph: header.paragraph ? {
        text: header.paragraph.processed,
        color: header.paragraphColor
      } : undefined,
      buttons: undefined
    }) : null, /*#__PURE__*/jsx(Section, {
      children: /*#__PURE__*/jsx(ComponentContainer, {
        customSpacing: ctaSpacing,
        children: /*#__PURE__*/jsx(Breadcrumb, {
          items: breadcrumbItems
        })
      })
    }), subcategories && /*#__PURE__*/jsx(Subcategories, {
      subcategories: subcategories,
      pageId: tid,
      parentId: parentId,
      extraCategories: extraCategories
    }), /*#__PURE__*/jsx(CategoryTemplates, {
      content: templates,
      lang: lang,
      masonry: true
    }), faqs && faqs.entity && faqs.entity.items && faqs.entity.items[0].item.title && faqs.entity.items[0].item.paragraph.processed && /*#__PURE__*/jsx(Accordion, {
      animation: faqs.entity.animation,
      background: parseBackground(faqs.entity.behaviorSettings.rowStyle.background),
      customSpacing: faqs.entity.behaviorSettings.rowStyle.spacing,
      subtitle: faqs.entity.heading ? {
        text: faqs.entity.heading,
        color: (_faqs$entity$headingC = faqs.entity.headingColor) != null ? _faqs$entity$headingC : 'primary',
        type: faqs.entity.headingType
      } : undefined,
      title: faqs.entity.title ? {
        text: faqs.entity.title,
        color: (_faqs$entity$titleCol = faqs.entity.titleColor) != null ? _faqs$entity$titleCol : 'black',
        type: faqs.entity.titleType
      } : undefined,
      text: faqs.entity.paragraph ? {
        text: faqs.entity.paragraph.value,
        color: (_faqs$entity$paragrap = faqs.entity.paragraphColor) != null ? _faqs$entity$paragrap : 'black'
      } : undefined,
      button: faqs.entity.button && faqs.entity.buttonStyle ? {
        variant: faqs.entity.buttonStyle.variant,
        size: faqs.entity.buttonStyle.size,
        title: faqs.entity.button.title,
        href: faqs.entity.button.url.path
      } : undefined,
      accordionItems: parseAccordeonItems(faqs.entity.items)
    }), description && /*#__PURE__*/jsx(ComponentContainer, {
      customSpacing: ctaSpacing,
      children: /*#__PURE__*/jsx(DescriptionContainer, {
        children: /*#__PURE__*/jsx(Text, {
          variant: 'paragraphS',
          $color: 'black',
          center: true,
          children: /*#__PURE__*/jsx(HtmlParser, {
            children: description
          })
        })
      })
    }), banner && banner.type === 'ParagraphBanner' ? /*#__PURE__*/jsx("div", {
      style: {
        marginTop: '50px'
      },
      children: /*#__PURE__*/jsx(Banner, {
        animation: 'none',
        background: parseBackground(banner.behaviorSettings.rowStyle.background),
        customSpacing: banner.behaviorSettings.rowStyle.spacing,
        title: banner.title ? {
          text: banner.title,
          type: banner.titleType,
          color: banner.titleColor
        } : undefined,
        subtitle: banner.subtitle ? {
          text: banner.subtitle,
          type: banner.subtitleType,
          color: banner.subtitleColor
        } : undefined,
        button: banner.button ? {
          variant: banner.buttonStyle.variant,
          size: banner.buttonStyle.size,
          children: banner.button.title,
          href: banner.button.url.path
        } : undefined
      })
    }) : null, teaser && teaser.type === 'ParagraphTeaser' ? /*#__PURE__*/jsx(Teaser, {
      animation: 'none',
      columns: teaser.variant === '1col' ? 1 : 2,
      flip: teaser.flip && teaser.flip,
      background: parseBackground(teaser.behaviorSettings.rowStyle.background),
      customSpacing: teaser.behaviorSettings.rowStyle.spacing,
      media: parseMedia(teaser.media),
      heading: teaser.heading ? {
        text: teaser.heading,
        type: teaser.headingType,
        color: teaser.headingColor
      } : undefined,
      title: teaser.title ? {
        text: teaser.title,
        type: teaser.titleType,
        color: teaser.titleColor
      } : undefined,
      subtitle: teaser.subtitle ? {
        text: teaser.subtitle,
        type: teaser.subtitleType,
        color: teaser.subtitleColor
      } : undefined,
      paragraph: teaser.paragraph ? {
        text: teaser.paragraph.processed,
        color: teaser.paragraphColor
      } : undefined,
      buttons: getButtons(btnPrimary, btnPrimaryStyle, btnSecondary, btnSecondaryStyle)
    }) : null]
  });
};
var parseAccordeonItems = function parseAccordeonItems(itemsDTO) {
  if (itemsDTO === void 0) {
    itemsDTO = [];
  }

  if (!itemsDTO) return [];
  return itemsDTO.map(function (item, index) {
    return {
      id: index + 1,
      title: item.item.title ? {
        text: item.item.title,
        color: item.item.titleColor,
        type: item.item.titleType
      } : undefined,
      paragraph: item.item.paragraph ? {
        text: item.item.paragraph.processed,
        color: item.item.paragraphColor
      } : undefined
    };
  });
};
var getButtons = function getButtons(buttonPrimary, buttonPrimaryStyle, buttonSecondary, buttonSecondaryStyle) {
  var buttons = [];

  if (!isNil_1(buttonPrimary)) {
    buttons.push({
      variant: buttonPrimaryStyle.variant,
      size: buttonPrimaryStyle.size,
      children: buttonPrimary.title,
      href: buttonPrimary.url.path
    });
  }

  if (!isNil_1(buttonSecondary)) {
    buttons.push({
      variant: buttonSecondaryStyle.variant,
      size: buttonSecondaryStyle.size,
      children: buttonSecondary.title,
      href: buttonSecondary.url.path
    });
  }

  return buttons;
};

export { Accordion, Animation, AuthButton, AuthTopbar, Avatar, Banner, Brands, Breadcrumb, Button, ButtonContainer, ButtonLink, Cards, Categories, CategoryPage, CheckBox, Columns, ComponentContainer, Container, Content$1 as Content, ContentContainer$1 as ContentContainer, Divider, DividerWithText, Dot, DropDownHeader, Dropdown, DropdownContainer, DropdownList, ErrorBox, Flex, Footer, FormSinglePage, GlideCarousel, GlideCarouselItem, GlideSlide, HorizontalMenu, HorizontalMenuItem, HtmlParser, Icon, IconContainer, IconList, IconListItem, Iframe, Image, Input, IsLoggedInContext, IsLoggedInProvider, Isotype, Link, LinkContext, LinkProvider, Links, List, Loading, Logo, Media, MediaContainer, MediaQuery, ModalContainer, Paragraph, ParagraphWrapper, PasswordInput, Play, Pricing, PricingCard, PricingTab, RadioButton, Section, SectionColumn, SectionComponent, SimpleList, SimpleListItem, SimpleSection, SinglePageContainer, Spacing, StaticPage, Sticker, Switch, Tabs, Teaser, TemplatePage, TestimonialChat, TestimonialFlex, TestimonyFlex, Text, ThemeProvider, Tooltip, Topbar, TwoColumnsColumn, TwoColumnsContainer, VerticalMenu, VerticalMenuItem, VerticalMenuItemBasic, VerticalMenuItemNumeric, Video, VisuallyHidden, mediaTypes, showOptionValue, theme, useHomepage, useIsLoggedIn, useLink, useMedia, useOnClickOutside };
